// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.12_webpack@5.109.2_esbuild@0.25.12_postcss@8.5.25_uglify-js@3.19.3_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.12_webpack@5.109.2_esbuild@0.25.12_postcss@8.5.25_uglify-js@3.19.3_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Bootstrap Responsive v2.2.2
 *
 * Copyright 2012 Twitter, Inc
 * Licensed under the Apache License v2.0
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Designed and built with all the love in the world @twitter by @mdo and @fat.
 */.clearfix{*zoom:1}.clearfix:before,.clearfix:after{display:table;line-height:0;content:""}.clearfix:after{clear:both}.hide-text{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.input-block-level{display:block;width:100%;min-height:30px;box-sizing:border-box}.hidden{display:none;visibility:hidden}.visible-phone{display:none!important}.visible-tablet{display:none!important}.hidden-desktop{display:none!important}.visible-desktop{display:inherit!important}@media(min-width:768px) and (max-width:979px){.hidden-desktop{display:inherit!important}.visible-desktop{display:none!important}.visible-tablet{display:inherit!important}.hidden-tablet{display:none!important}}@media(max-width:767px){.hidden-desktop{display:inherit!important}.visible-desktop{display:none!important}.visible-phone{display:inherit!important}.hidden-phone{display:none!important}}@media(min-width:1200px){.row{margin-left:-30px;*zoom:1}.row:before,.row:after{display:table;line-height:0;content:""}.row:after{clear:both}[class*="span"]{float:left;min-height:1px;margin-left:30px}.container,.navbar-static-top .container,.navbar-fixed-top .container,.navbar-fixed-bottom .container{width:1170px}.span12{width:1170px}.span11{width:1070px}.span10{width:970px}.span9{width:870px}.span8{width:770px}.span7{width:670px}.span6{width:570px}.span5{width:470px}.span4{width:370px}.span3{width:270px}.span2{width:170px}.span1{width:70px}.offset12{margin-left:1230px}.offset11{margin-left:1130px}.offset10{margin-left:1030px}.offset9{margin-left:930px}.offset8{margin-left:830px}.offset7{margin-left:730px}.offset6{margin-left:630px}.offset5{margin-left:530px}.offset4{margin-left:430px}.offset3{margin-left:330px}.offset2{margin-left:230px}.offset1{margin-left:130px}.row-fluid{width:100%;*zoom:1}.row-fluid:before,.row-fluid:after{display:table;line-height:0;content:""}.row-fluid:after{clear:both}.row-fluid [class*="span"]{display:block;float:left;width:100%;min-height:30px;*margin-left:2.5109110747408616%;box-sizing:border-box}.row-fluid [class*="span"]:first-child{margin-left:0}.row-fluid .controls-row [class*="span"]+[class*="span"]{margin-left:2.564102564102564%}.row-fluid .span12{*width:99.94680851063829%}.row-fluid .span11{*width:91.39979996362975%}.row-fluid .span10{*width:82.8527914166212%}.row-fluid .span9{*width:74.30578286961266%}.row-fluid .span8{*width:65.75877432260411%}.row-fluid .span7{*width:57.21176577559556%}.row-fluid .span6{*width:48.664757228587014%}.row-fluid .span5{*width:40.11774868157847%}.row-fluid .span4{*width:31.570740134569924%}.row-fluid .span3{*width:23.023731587561375%}.row-fluid .span2{*width:14.476723040552828%}.row-fluid .span1{*width:5.929714493544281%}.row-fluid .offset12{*margin-left:105.02182214948171%}.row-fluid .offset12:first-child{*margin-left:102.45771958537915%}.row-fluid .offset11{*margin-left:96.47481360247316%}.row-fluid .offset11:first-child{*margin-left:93.91071103837061%}.row-fluid .offset10{*margin-left:87.92780505546462%}.row-fluid .offset10:first-child{*margin-left:85.36370249136206%}.row-fluid .offset9{*margin-left:79.38079650845607%}.row-fluid .offset9:first-child{*margin-left:76.81669394435352%}.row-fluid .offset8{*margin-left:70.83378796144753%}.row-fluid .offset8:first-child{*margin-left:68.26968539734497%}.row-fluid .offset7{*margin-left:62.28677941443899%}.row-fluid .offset7:first-child{*margin-left:59.72267685033642%}.row-fluid .offset6{*margin-left:53.739770867430444%}.row-fluid .offset6:first-child{*margin-left:51.175668303327875%}.row-fluid .offset5{*margin-left:45.1927623204219%}.row-fluid .offset5:first-child{*margin-left:42.62865975631933%}.row-fluid .offset4{*margin-left:36.645753773413354%}.row-fluid .offset4:first-child{*margin-left:34.081651209310785%}.row-fluid .offset3{*margin-left:28.0987452264048%}.row-fluid .offset3:first-child{*margin-left:25.53464266230224%}.row-fluid .offset2{*margin-left:19.551736679396257%}.row-fluid .offset2:first-child{*margin-left:16.98763411529369%}.row-fluid .offset1{*margin-left:11.004728132387708%}.row-fluid .offset1:first-child{*margin-left:8.440625568285142%}input,textarea,.uneditable-input{margin-left:0}.controls-row [class*="span"]+[class*="span"]{margin-left:30px}input.span12,textarea.span12,.uneditable-input.span12{width:1156px}input.span11,textarea.span11,.uneditable-input.span11{width:1056px}input.span10,textarea.span10,.uneditable-input.span10{width:956px}input.span9,textarea.span9,.uneditable-input.span9{width:856px}input.span8,textarea.span8,.uneditable-input.span8{width:756px}input.span7,textarea.span7,.uneditable-input.span7{width:656px}input.span6,textarea.span6,.uneditable-input.span6{width:556px}input.span5,textarea.span5,.uneditable-input.span5{width:456px}input.span4,textarea.span4,.uneditable-input.span4{width:356px}input.span3,textarea.span3,.uneditable-input.span3{width:256px}input.span2,textarea.span2,.uneditable-input.span2{width:156px}input.span1,textarea.span1,.uneditable-input.span1{width:56px}.thumbnails{margin-left:-30px}.thumbnails>li{margin-left:30px}.row-fluid .thumbnails{margin-left:0}}@media(min-width:768px) and (max-width:979px){.row{margin-left:-20px;*zoom:1}.row:before,.row:after{display:table;line-height:0;content:""}.row:after{clear:both}[class*="span"]{float:left;min-height:1px;margin-left:20px}.container,.navbar-static-top .container,.navbar-fixed-top .container,.navbar-fixed-bottom .container{width:724px}.span12{width:724px}.span11{width:662px}.span10{width:600px}.span9{width:538px}.span8{width:476px}.span7{width:414px}.span6{width:352px}.span5{width:290px}.span4{width:228px}.span3{width:166px}.span2{width:104px}.span1{width:42px}.offset12{margin-left:764px}.offset11{margin-left:702px}.offset10{margin-left:640px}.offset9{margin-left:578px}.offset8{margin-left:516px}.offset7{margin-left:454px}.offset6{margin-left:392px}.offset5{margin-left:330px}.offset4{margin-left:268px}.offset3{margin-left:206px}.offset2{margin-left:144px}.offset1{margin-left:82px}.row-fluid{width:100%;*zoom:1}.row-fluid:before,.row-fluid:after{display:table;line-height:0;content:""}.row-fluid:after{clear:both}.row-fluid [class*="span"]{display:block;float:left;width:100%;min-height:30px;*margin-left:2.709239449864817%;box-sizing:border-box}.row-fluid [class*="span"]:first-child{margin-left:0}.row-fluid .controls-row [class*="span"]+[class*="span"]{margin-left:2.7624309392265194%}.row-fluid .span12{*width:99.94680851063829%}.row-fluid .span11{*width:91.38327259903608%}.row-fluid .span10{*width:82.81973668743387%}.row-fluid .span9{*width:74.25620077583166%}.row-fluid .span8{*width:65.69266486422946%}.row-fluid .span7{*width:57.12912895262725%}.row-fluid .span6{*width:48.56559304102504%}.row-fluid .span5{*width:40.00205712942283%}.row-fluid .span4{*width:31.43852121782062%}.row-fluid .span3{*width:22.87498530621841%}.row-fluid .span2{*width:14.311449394616199%}.row-fluid .span1{*width:5.747913483013988%}.row-fluid .offset12{*margin-left:105.41847889972962%}.row-fluid .offset12:first-child{*margin-left:102.6560479605031%}.row-fluid .offset11{*margin-left:96.8549429881274%}.row-fluid .offset11:first-child{*margin-left:94.09251204890089%}.row-fluid .offset10{*margin-left:88.2914070765252%}.row-fluid .offset10:first-child{*margin-left:85.52897613729868%}.row-fluid .offset9{*margin-left:79.72787116492299%}.row-fluid .offset9:first-child{*margin-left:76.96544022569647%}.row-fluid .offset8{*margin-left:71.16433525332079%}.row-fluid .offset8:first-child{*margin-left:68.40190431409427%}.row-fluid .offset7{*margin-left:62.600799341718584%}.row-fluid .offset7:first-child{*margin-left:59.838368402492065%}.row-fluid .offset6{*margin-left:54.037263430116376%}.row-fluid .offset6:first-child{*margin-left:51.27483249088986%}.row-fluid .offset5{*margin-left:45.47372751851417%}.row-fluid .offset5:first-child{*margin-left:42.71129657928765%}.row-fluid .offset4{*margin-left:36.91019160691196%}.row-fluid .offset4:first-child{*margin-left:34.14776066768544%}.row-fluid .offset3{*margin-left:28.346655695309746%}.row-fluid .offset3:first-child{*margin-left:25.584224756083227%}.row-fluid .offset2{*margin-left:19.783119783707537%}.row-fluid .offset2:first-child{*margin-left:17.02068884448102%}.row-fluid .offset1{*margin-left:11.219583872105325%}.row-fluid .offset1:first-child{*margin-left:8.457152932878806%}input,textarea,.uneditable-input{margin-left:0}.controls-row [class*="span"]+[class*="span"]{margin-left:20px}input.span12,textarea.span12,.uneditable-input.span12{width:710px}input.span11,textarea.span11,.uneditable-input.span11{width:648px}input.span10,textarea.span10,.uneditable-input.span10{width:586px}input.span9,textarea.span9,.uneditable-input.span9{width:524px}input.span8,textarea.span8,.uneditable-input.span8{width:462px}input.span7,textarea.span7,.uneditable-input.span7{width:400px}input.span6,textarea.span6,.uneditable-input.span6{width:338px}input.span5,textarea.span5,.uneditable-input.span5{width:276px}input.span4,textarea.span4,.uneditable-input.span4{width:214px}input.span3,textarea.span3,.uneditable-input.span3{width:152px}input.span2,textarea.span2,.uneditable-input.span2{width:90px}input.span1,textarea.span1,.uneditable-input.span1{width:28px}}@media(max-width:767px){body{padding-right:20px;padding-left:20px}.navbar-fixed-top,.navbar-fixed-bottom,.navbar-static-top{margin-right:-20px;margin-left:-20px}.container-fluid{padding:0}.dl-horizontal dt{float:none;width:auto;clear:none;text-align:left}.dl-horizontal dd{margin-left:0}.container{width:auto}.row-fluid{width:100%}.row,.thumbnails{margin-left:0}.thumbnails>li{float:none;margin-left:0}[class*="span"],.uneditable-input[class*="span"],.row-fluid [class*="span"]{display:block;float:none;width:100%;margin-left:0;box-sizing:border-box}.span12,.row-fluid .span12{width:100%;box-sizing:border-box}.row-fluid [class*="offset"]:first-child{margin-left:0}.input-large,.input-xlarge,.input-xxlarge,input[class*="span"],select[class*="span"],textarea[class*="span"],.uneditable-input{display:block;width:100%;min-height:30px;box-sizing:border-box}.input-prepend input,.input-append input,.input-prepend input[class*="span"],.input-append input[class*="span"]{display:inline-block;width:auto}.controls-row [class*="span"]+[class*="span"]{margin-left:0}.modal{position:fixed;top:20px;right:20px;left:20px;width:auto;margin:0}.modal.fade{top:-100px}.modal.fade.in{top:20px}}@media(max-width:480px){.nav-collapse{-webkit-transform:translate3d(0,0,0)}.page-header h1 small{display:block;line-height:20px}input[type="checkbox"],input[type="radio"]{border:1px solid #ccc}.form-horizontal .control-label{float:none;width:auto;padding-top:0;text-align:left}.form-horizontal .controls{margin-left:0}.form-horizontal .control-list{padding-top:0}.form-horizontal .form-actions{padding-right:10px;padding-left:10px}.media .pull-left,.media .pull-right{display:block;float:none;margin-bottom:10px}.media-object{margin-right:0;margin-left:0}.modal{top:10px;right:10px;left:10px}.modal-header .close{padding:10px;margin:-10px}.carousel-caption{position:static}}@media(max-width:979px){body{padding-top:0}.navbar-fixed-top,.navbar-fixed-bottom{position:static}.navbar-fixed-top{margin-bottom:20px}.navbar-fixed-bottom{margin-top:20px}.navbar-fixed-top .navbar-inner,.navbar-fixed-bottom .navbar-inner{padding:5px}.navbar .container{width:auto;padding:0}.navbar .brand{padding-right:10px;padding-left:10px;margin:0 0 0 -5px}.nav-collapse{clear:both}.nav-collapse .nav{float:none;margin:0 0 10px}.nav-collapse .nav>li{float:none}.nav-collapse .nav>li>a{margin-bottom:2px}.nav-collapse .nav>.divider-vertical{display:none}.nav-collapse .nav .nav-header{color:#777;text-shadow:none}.nav-collapse .nav>li>a,.nav-collapse .dropdown-menu a{padding:9px 15px;font-weight:bold;color:#777;border-radius:3px}.nav-collapse .btn{padding:4px 10px 4px;font-weight:normal;border-radius:4px}.nav-collapse .dropdown-menu li+li a{margin-bottom:2px}.nav-collapse .nav>li>a:hover,.nav-collapse .dropdown-menu a:hover{background-color:#f2f2f2}.navbar-inverse .nav-collapse .nav>li>a,.navbar-inverse .nav-collapse .dropdown-menu a{color:#999}.navbar-inverse .nav-collapse .nav>li>a:hover,.navbar-inverse .nav-collapse .dropdown-menu a:hover{background-color:#111}.nav-collapse.in .btn-group{padding:0;margin-top:5px}.nav-collapse .dropdown-menu{position:static;top:auto;left:auto;display:none;float:none;max-width:none;padding:0;margin:0 15px;background-color:transparent;border:0;border-radius:0;box-shadow:none}.nav-collapse .open>.dropdown-menu{display:block}.nav-collapse .dropdown-menu:before,.nav-collapse .dropdown-menu:after{display:none}.nav-collapse .dropdown-menu .divider{display:none}.nav-collapse .nav>li>.dropdown-menu:before,.nav-collapse .nav>li>.dropdown-menu:after{display:none}.nav-collapse .navbar-form,.nav-collapse .navbar-search{float:none;padding:10px 15px;margin:10px 0;border-top:1px solid #f2f2f2;border-bottom:1px solid #f2f2f2;box-shadow:inset 0 1px 0 rgba(255,255,255,0.1),0 1px 0 rgba(255,255,255,0.1)}.navbar-inverse .nav-collapse .navbar-form,.navbar-inverse .nav-collapse .navbar-search{border-top-color:#111;border-bottom-color:#111}.navbar .nav-collapse .nav.pull-right{float:none;margin-left:0}.nav-collapse,.nav-collapse.collapse{height:0;overflow:hidden}.navbar .btn-navbar{display:block}.navbar-static .navbar-inner{padding-right:10px;padding-left:10px}}@media(min-width:980px){.nav-collapse.collapse{height:auto!important;overflow:visible!important}}
/*!
 * Bootstrap v2.2.2
 *
 * Copyright 2012 Twitter, Inc
 * Licensed under the Apache License v2.0
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Designed and built with all the love in the world @twitter by @mdo and @fat.
 */
.clearfix{*zoom:1;}.clearfix:before,.clearfix:after{display:table;content:"";line-height:0;}
.clearfix:after{clear:both;}
.hide-text{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0;}
.input-block-level{display:block;width:100%;min-height:30px;box-sizing:border-box;}
[class^="icon-"],[class*=" icon-"]{margin:5px;display:inline-block;width:14px;height:14px;*margin-right:.3em;line-height:14px;vertical-align:text-top;background-image:url("/images/bootstrap/glyphicons-halflings.png");background-position:14px 14px;background-repeat:no-repeat;margin-top:1px;}
.icon-white,.nav-pills>.active>a>[class^="icon-"],.nav-pills>.active>a>[class*=" icon-"],.nav-list>.active>a>[class^="icon-"],.nav-list>.active>a>[class*=" icon-"],.navbar-inverse .nav>.active>a>[class^="icon-"],.navbar-inverse .nav>.active>a>[class*=" icon-"],.dropdown-menu>li>a:hover>[class^="icon-"],.dropdown-menu>li>a:focus>[class^="icon-"],.dropdown-menu>li>a:hover>[class*=" icon-"],.dropdown-menu>li>a:focus>[class*=" icon-"],.dropdown-menu>.active>a>[class^="icon-"],.dropdown-menu>.active>a>[class*=" icon-"],.dropdown-submenu:hover>a>[class^="icon-"],.dropdown-submenu:focus>a>[class^="icon-"],.dropdown-submenu:hover>a>[class*=" icon-"],.dropdown-submenu:focus>a>[class*=" icon-"]{background-image:url("/images/bootstrap/glyphicons-halflings-white.png");}
.icon-glass{background-position:0 0;}
.icon-music{background-position:-24px 0;}
.icon-envelope{background-position:-72px 0;}
.icon-heart{background-position:-96px 0;}
.icon-star{background-position:-120px 0;}
.icon-star-empty{background-position:-144px 0;}
.icon-user{background-position:-168px 0;}
.icon-film{background-position:-192px 0;}
.icon-th-large{background-position:-216px 0;}
.icon-th{background-position:-240px 0;}
.icon-th-list{background-position:-264px 0;}
.icon-ok{background-position:-288px 0;}
.icon-remove{background-position:-312px 0;}
.icon-zoom-in{background-position:-336px 0;}
.icon-zoom-out{background-position:-360px 0;}
.icon-off{background-position:-384px 0;}
.icon-signal{background-position:-408px 0;}
.icon-cog{background-position:-432px 0;}
.icon-trash{background-position:-456px 0;}
.icon-home{background-position:0 -24px;}
.icon-file{background-position:-24px -24px;}
.icon-time{background-position:-48px -24px;}
.icon-road{background-position:-72px -24px;}
.icon-download-alt{background-position:-96px -24px;}
.icon-download{background-position:-120px -24px;}
.icon-upload{background-position:-144px -24px;}
.icon-inbox{background-position:-168px -24px;}
.icon-play-circle{background-position:-192px -24px;}
.icon-repeat{background-position:-216px -24px;}
.icon-refresh{background-position:-240px -24px;}
.icon-list-alt{background-position:-264px -24px;}
.icon-lock{background-position:-287px -24px;}
.icon-flag{background-position:-312px -24px;}
.icon-headphones{background-position:-336px -24px;}
.icon-volume-off{background-position:-360px -24px;}
.icon-volume-down{background-position:-384px -24px;}
.icon-volume-up{background-position:-408px -24px;}
.icon-qrcode{background-position:-432px -24px;}
.icon-barcode{background-position:-456px -24px;}
.icon-tag{background-position:0 -48px;}
.icon-tags{background-position:-25px -48px;}
.icon-book{background-position:-48px -48px;}
.icon-bookmark{background-position:-72px -48px;}
.icon-print{background-position:-96px -48px;}
.icon-camera{background-position:-120px -48px;}
.icon-font{background-position:-144px -48px;}
.icon-bold{background-position:-167px -48px;}
.icon-italic{background-position:-192px -48px;}
.icon-text-height{background-position:-216px -48px;}
.icon-text-width{background-position:-240px -48px;}
.icon-align-left{background-position:-264px -48px;}
.icon-align-center{background-position:-288px -48px;}
.icon-align-right{background-position:-312px -48px;}
.icon-align-justify{background-position:-336px -48px;}
.icon-list{background-position:-360px -48px;}
.icon-indent-left{background-position:-384px -48px;}
.icon-indent-right{background-position:-408px -48px;}
.icon-facetime-video{background-position:-432px -48px;}
.icon-picture{background-position:-456px -48px;}
.icon-pencil{background-position:0 -72px;}
.icon-map-marker{background-position:-24px -72px;}
.icon-adjust{background-position:-48px -72px;}
.icon-tint{background-position:-72px -72px;}
.icon-edit{background-position:-96px -72px;}
.icon-share{background-position:-120px -72px;}
.icon-check{background-position:-144px -72px;}
.icon-move{background-position:-168px -72px;}
.icon-step-backward{background-position:-192px -72px;}
.icon-fast-backward{background-position:-216px -72px;}
.icon-backward{background-position:-240px -72px;}
.icon-play{background-position:-264px -72px;}
.icon-pause{background-position:-288px -72px;}
.icon-stop{background-position:-312px -72px;}
.icon-forward{background-position:-336px -72px;}
.icon-fast-forward{background-position:-360px -72px;}
.icon-step-forward{background-position:-384px -72px;}
.icon-eject{background-position:-408px -72px;}
.icon-chevron-left{background-position:-432px -72px;}
.icon-chevron-right{background-position:-456px -72px;}
.icon-plus-sign{background-position:0 -96px;}
.icon-minus-sign{background-position:-24px -96px;}
.icon-remove-sign{background-position:-48px -96px;}
.icon-ok-sign{background-position:-72px -96px;}
.icon-question-sign{background-position:-96px -96px;}
.icon-info-sign{background-position:-120px -96px;}
.icon-screenshot{background-position:-144px -96px;}
.icon-remove-circle{background-position:-168px -96px;}
.icon-ok-circle{background-position:-192px -96px;}
.icon-ban-circle{background-position:-216px -96px;}
.icon-arrow-left{background-position:-240px -96px;}
.icon-arrow-right{background-position:-264px -96px;}
.icon-arrow-up{background-position:-289px -96px;}
.icon-arrow-down{background-position:-312px -96px;}
.icon-share-alt{background-position:-336px -96px;}
.icon-resize-full{background-position:-360px -96px;}
.icon-resize-small{background-position:-384px -96px;}
.icon-plus{background-position:-408px -96px;}
.icon-minus{background-position:-433px -96px;}
.icon-asterisk{background-position:-456px -96px;}
.icon-exclamation-sign{background-position:0 -120px;}
.icon-gift{background-position:-24px -120px;}
.icon-leaf{background-position:-48px -120px;}
.icon-fire{background-position:-72px -120px;}
.icon-eye-open{background-position:-96px -120px;}
.icon-eye-close{background-position:-120px -120px;}
.icon-warning-sign{background-position:-144px -120px;}
.icon-plane{background-position:-168px -120px;}
.icon-calendar{background-position:-192px -120px;}
.icon-random{background-position:-216px -120px;width:16px;}
.icon-comment{background-position:-240px -120px;}
.icon-magnet{background-position:-264px -120px;}
.icon-chevron-up{background-position:-288px -120px;}
.icon-chevron-down{background-position:-313px -119px;}
.icon-retweet{background-position:-336px -120px;}
.icon-shopping-cart{background-position:-360px -120px;}
.icon-folder-close{background-position:-384px -120px;width:16px;}
.icon-folder-open{background-position:-408px -120px;width:16px;}
.icon-resize-vertical{background-position:-432px -119px;}
.icon-resize-horizontal{background-position:-456px -118px;}
.icon-hdd{background-position:0 -144px;}
.icon-bullhorn{background-position:-24px -144px;}
.icon-bell{background-position:-48px -144px;}
.icon-certificate{background-position:-72px -144px;}
.icon-thumbs-up{background-position:-96px -144px;}
.icon-thumbs-down{background-position:-120px -144px;}
.icon-hand-right{background-position:-144px -144px;}
.icon-hand-left{background-position:-168px -144px;}
.icon-hand-up{background-position:-192px -144px;}
.icon-hand-down{background-position:-216px -144px;}
.icon-circle-arrow-right{background-position:-240px -144px;}
.icon-circle-arrow-left{background-position:-264px -144px;}
.icon-circle-arrow-up{background-position:-288px -144px;}
.icon-circle-arrow-down{background-position:-312px -144px;}
.icon-globe{background-position:-336px -144px;}
.icon-wrench{background-position:-360px -144px;}
.icon-tasks{background-position:-384px -144px;}
.icon-filter{background-position:-408px -144px;}
.icon-briefcase{background-position:-432px -144px;}
.icon-fullscreen{background-position:-456px -144px;}
article,aside,details,figcaption,figure,footer,header,hgroup,nav,section{display:block;}
audio,canvas,video{display:inline-block;*display:inline;*zoom:1;}
audio:not([controls]){display:none;}
html{font-size:100%;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;}
a:focus{outline:thin dotted #333;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px;}
a:hover,a:active{outline:0;}
sub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline;}
sup{top:-0.5em;}
sub{bottom:-0.25em;}
img{max-width:100%;width:auto\\9;height:auto;vertical-align:middle;border:0;-ms-interpolation-mode:bicubic;}
#map_canvas img,.google-maps img{max-width:none;}
button,input,select,textarea{margin:0;font-size:100%;vertical-align:middle;}
button,input{*overflow:visible;line-height:normal;}
button::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0;}
button,html input[type="button"],input[type="reset"],input[type="submit"]{-webkit-appearance:button;cursor:pointer;}
label,select,button,input[type="button"],input[type="reset"],input[type="submit"],input[type="radio"],input[type="checkbox"]{cursor:pointer;}
input[type="search"]{box-sizing:content-box;-webkit-appearance:textfield;}
input[type="search"]::-webkit-search-decoration,input[type="search"]::-webkit-search-cancel-button{-webkit-appearance:none;}
textarea{overflow:auto;vertical-align:top;}
@media print{*{text-shadow:none !important;color:#000 !important;background:transparent !important;box-shadow:none !important;} a,a:visited{text-decoration:underline;} a[href]:after{content:" (" attr(href) ")";} abbr[title]:after{content:" (" attr(title) ")";} .ir a:after,a[href^="javascript:"]:after,a[href^="#"]:after{content:"";} pre,blockquote{border:1px solid #999;page-break-inside:avoid;} thead{display:table-header-group;} tr,img{page-break-inside:avoid;} img{max-width:100% !important;} @page {margin:0.5cm;}p,h2,h3{orphans:3;widows:3;} h2,h3{page-break-after:avoid;}}body{margin:0;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;font-size:14px;line-height:20px;color:#333333;background-color:#ffffff;}
a{color:#0088cc;text-decoration:none;}
a:hover{color:#005580;text-decoration:underline;}
.img-rounded{border-radius:6px;}
.img-polaroid{padding:4px;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0, 0, 0, 0.2);box-shadow:0 1px 3px rgba(0, 0, 0, 0.1);}
.img-circle{border-radius:500px;}
.row{margin-left:-20px;*zoom:1;}.row:before,.row:after{display:table;content:"";line-height:0;}
.row:after{clear:both;}
[class*="span"]{float:left;min-height:1px;margin-left:20px;}
.container,.navbar-static-top .container,.navbar-fixed-top .container,.navbar-fixed-bottom .container{width:940px;}
.span12{width:940px;}
.span11{width:860px;}
.span10{width:780px;}
.span9{width:700px;}
.span8{width:620px;}
.span7{width:540px;}
.span6{width:460px;}
.span5{width:380px;}
.span4{width:300px;}
.span3{width:220px;}
.span2{width:140px;}
.span1{width:60px;}
.offset12{margin-left:980px;}
.offset11{margin-left:900px;}
.offset10{margin-left:820px;}
.offset9{margin-left:740px;}
.offset8{margin-left:660px;}
.offset7{margin-left:580px;}
.offset6{margin-left:500px;}
.offset5{margin-left:420px;}
.offset4{margin-left:340px;}
.offset3{margin-left:260px;}
.offset2{margin-left:180px;}
.offset1{margin-left:100px;}
.row-fluid{width:100%;*zoom:1;}.row-fluid:before,.row-fluid:after{display:table;content:"";line-height:0;}
.row-fluid:after{clear:both;}
.row-fluid [class*="span"]{display:block;width:100%;min-height:30px;box-sizing:border-box;float:left;*margin-left:2.074468085106383%;}
.row-fluid [class*="span"]:first-child{margin-left:0;}
.row-fluid .controls-row [class*="span"]+[class*="span"]{margin-left:2.127659574468085%;}
.row-fluid .span12{*width:99.94680851063829%;}
.row-fluid .span11{*width:91.43617021276594%;}
.row-fluid .span10{*width:82.92553191489361%;}
.row-fluid .span9{*width:74.41489361702126%;}
.row-fluid .span8{*width:65.90425531914893%;}
.row-fluid .span7{*width:57.39361702127659%;}
.row-fluid .span6{*width:48.88297872340425%;}
.row-fluid .span5{*width:40.37234042553192%;}
.row-fluid .span4{*width:31.861702127659576%;}
.row-fluid .span3{*width:23.351063829787233%;}
.row-fluid .span2{*width:14.840425531914894%;}
.row-fluid .span1{*width:6.329787234042553%;}
.row-fluid .offset12{*margin-left:104.14893617021275%;}
.row-fluid .offset12:first-child{*margin-left:102.02127659574467%;}
.row-fluid .offset11{*margin-left:95.6382978723404%;}
.row-fluid .offset11:first-child{*margin-left:93.51063829787232%;}
.row-fluid .offset10{*margin-left:87.12765957446807%;}
.row-fluid .offset10:first-child{*margin-left:84.99999999999999%;}
.row-fluid .offset9{*margin-left:78.61702127659572%;}
.row-fluid .offset9:first-child{*margin-left:76.48936170212764%;}
.row-fluid .offset8{*margin-left:70.10638297872339%;}
.row-fluid .offset8:first-child{*margin-left:67.9787234042553%;}
.row-fluid .offset7{*margin-left:61.59574468085106%;}
.row-fluid .offset7:first-child{*margin-left:59.46808510638297%;}
.row-fluid .offset6{*margin-left:53.085106382978715%;}
.row-fluid .offset6:first-child{*margin-left:50.95744680851063%;}
.row-fluid .offset5{*margin-left:44.57446808510638%;}
.row-fluid .offset5:first-child{*margin-left:42.4468085106383%;}
.row-fluid .offset4{*margin-left:36.06382978723405%;}
.row-fluid .offset4:first-child{*margin-left:33.93617021276596%;}
.row-fluid .offset3{*margin-left:27.5531914893617%;}
.row-fluid .offset3:first-child{*margin-left:25.425531914893618%;}
.row-fluid .offset2{*margin-left:19.04255319148936%;}
.row-fluid .offset2:first-child{*margin-left:16.914893617021278%;}
.row-fluid .offset1{*margin-left:10.53191489361702%;}
.row-fluid .offset1:first-child{*margin-left:8.404255319148938%;}
[class*="span"].hide,.row-fluid [class*="span"].hide{display:none;}
[class*="span"].pull-right,.row-fluid [class*="span"].pull-right{float:right;}
.container{margin-right:auto;margin-left:auto;*zoom:1;}.container:before,.container:after{display:table;content:"";line-height:0;}
.container:after{clear:both;}
.container-fluid{padding-right:20px;padding-left:20px;*zoom:1;}.container-fluid:before,.container-fluid:after{display:table;content:"";line-height:0;}
.container-fluid:after{clear:both;}
.btn-group{position:relative;display:inline-block;*display:inline;*zoom:1;font-size:0;vertical-align:middle;white-space:nowrap;*margin-left:.3em;}.btn-group:first-child{*margin-left:0;}
.btn-group+.btn-group{margin-left:5px;}
.btn-toolbar{font-size:0;margin-top:10px;margin-bottom:10px;}.btn-toolbar>.btn+.btn,.btn-toolbar>.btn-group+.btn,.btn-toolbar>.btn+.btn-group{margin-left:5px;}
.btn-group>.btn{position:relative;border-radius:0;}
.btn-group>.btn+.btn{margin-left:-1px;}
.btn-group>.btn,.btn-group>.dropdown-menu,.btn-group>.popover{font-size:14px;}
.btn-group>.btn-mini{font-size:10.5px;}
.btn-group>.btn-small{font-size:11.9px;}
.btn-group>.btn-large{font-size:17.5px;}
.btn-group>.btn:first-child{margin-left:0;border-top-left-radius:4px;border-bottom-left-radius:4px;}
.btn-group>.btn:last-child,.btn-group>.dropdown-toggle{border-top-right-radius:4px;border-bottom-right-radius:4px;}
.btn-group>.btn.large:first-child{margin-left:0;border-top-left-radius:6px;border-bottom-left-radius:6px;}
.btn-group>.btn.large:last-child,.btn-group>.large.dropdown-toggle{border-top-right-radius:6px;border-bottom-right-radius:6px;}
.btn-group>.btn:hover,.btn-group>.btn:focus,.btn-group>.btn:active,.btn-group>.btn.active{z-index:2;}
.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0;}
.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px;box-shadow:inset 1px 0 0 rgba(255,255,255,.125), inset 0 1px 0 rgba(255,255,255,.2), 0 1px 2px rgba(0,0,0,.05);*padding-top:5px;*padding-bottom:5px;}
.btn-group>.btn-mini+.dropdown-toggle{padding-left:5px;padding-right:5px;*padding-top:2px;*padding-bottom:2px;}
.btn-group>.btn-small+.dropdown-toggle{*padding-top:5px;*padding-bottom:4px;}
.btn-group>.btn-large+.dropdown-toggle{padding-left:12px;padding-right:12px;*padding-top:7px;*padding-bottom:7px;}
.btn-group.open .dropdown-toggle{background-image:none;box-shadow:inset 0 2px 4px rgba(0,0,0,.15), 0 1px 2px rgba(0,0,0,.05);}
.btn-group.open .btn.dropdown-toggle{background-color:#e6e6e6;}
.btn-group.open .btn-primary.dropdown-toggle{background-color:#0044cc;}
.btn-group.open .btn-warning.dropdown-toggle{background-color:#f89406;}
.btn-group.open .btn-danger.dropdown-toggle{background-color:#bd362f;}
.btn-group.open .btn-success.dropdown-toggle{background-color:#51a351;}
.btn-group.open .btn-info.dropdown-toggle{background-color:#2f96b4;}
.btn-group.open .btn-inverse.dropdown-toggle{background-color:#222222;}
.btn .caret{margin-top:8px;margin-left:0;}
.btn-mini .caret,.btn-small .caret,.btn-large .caret{margin-top:6px;}
.btn-large .caret{border-left-width:5px;border-right-width:5px;border-top-width:5px;}
.dropup .btn-large .caret{border-bottom-width:5px;}
.btn-primary .caret,.btn-warning .caret,.btn-danger .caret,.btn-info .caret,.btn-success .caret,.btn-inverse .caret{border-top-color:#ffffff;border-bottom-color:#ffffff;}
.btn-group-vertical{display:inline-block;*display:inline;*zoom:1;}
.btn-group-vertical>.btn{display:block;float:none;max-width:100%;border-radius:0;}
.btn-group-vertical>.btn+.btn{margin-left:0;margin-top:-1px;}
.btn-group-vertical>.btn:first-child{border-radius:4px 4px 0 0;}
.btn-group-vertical>.btn:last-child{border-radius:0 0 4px 4px;}
.btn-group-vertical>.btn-large:first-child{border-radius:6px 6px 0 0;}
.btn-group-vertical>.btn-large:last-child{border-radius:0 0 6px 6px;}
.nav{margin-left:0;margin-bottom:20px;list-style:none;}
.nav>li>a{display:block;}
.nav>li>a:hover{text-decoration:none;background-color:#eeeeee;}
.nav>li>a>img{max-width:none;}
.nav>.pull-right{float:right;}
.nav-header{display:block;padding:3px 15px;font-size:11px;font-weight:bold;line-height:20px;color:#999999;text-shadow:0 1px 0 rgba(255, 255, 255, 0.5);text-transform:uppercase;}
.nav li+.nav-header{margin-top:9px;}
.nav-list{padding-left:15px;padding-right:15px;margin-bottom:0;}
.nav-list>li>a,.nav-list .nav-header{margin-left:-15px;margin-right:-15px;text-shadow:0 1px 0 rgba(255, 255, 255, 0.5);}
.nav-list>li>a{padding:3px 15px;}
.nav-list>.active>a,.nav-list>.active>a:hover{color:#ffffff;text-shadow:0 -1px 0 rgba(0, 0, 0, 0.2);background-color:#0088cc;}
.nav-list [class^="icon-"],.nav-list [class*=" icon-"]{margin-right:2px;}
.nav-list .divider{*width:100%;height:1px;margin:9px 1px;*margin:-5px 0 5px;overflow:hidden;background-color:#e5e5e5;border-bottom:1px solid #ffffff;}
.nav-tabs,.nav-pills{*zoom:1;}.nav-tabs:before,.nav-pills:before,.nav-tabs:after,.nav-pills:after{display:table;content:"";line-height:0;}
.nav-tabs:after,.nav-pills:after{clear:both;}
.nav-tabs>li,.nav-pills>li{float:left;}
.nav-tabs>li>a,.nav-pills>li>a{padding-right:12px;padding-left:12px;margin-right:2px;line-height:14px;}
.nav-tabs{border-bottom:1px solid #ddd;}
.nav-tabs>li{margin-bottom:-1px;}
.nav-tabs>li>a{padding-top:8px;padding-bottom:8px;line-height:20px;border:1px solid transparent;border-radius:4px 4px 0 0;}.nav-tabs>li>a:hover{border-color:#eeeeee #eeeeee #dddddd;}
.nav-tabs>.active>a,.nav-tabs>.active>a:hover{color:#555555;background-color:#ffffff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default;}
.nav-pills>li>a{padding-top:8px;padding-bottom:8px;margin-top:2px;margin-bottom:2px;border-radius:5px;}
.nav-pills>.active>a,.nav-pills>.active>a:hover{color:#ffffff;background-color:#0088cc;}
.nav-stacked>li{float:none;}
.nav-stacked>li>a{margin-right:0;}
.nav-tabs.nav-stacked{border-bottom:0;}
.nav-tabs.nav-stacked>li>a{border:1px solid #ddd;border-radius:0;}
.nav-tabs.nav-stacked>li:first-child>a{border-top-right-radius:4px;border-top-left-radius:4px;}
.nav-tabs.nav-stacked>li:last-child>a{border-bottom-right-radius:4px;border-bottom-left-radius:4px;}
.nav-tabs.nav-stacked>li>a:hover{border-color:#ddd;z-index:2;}
.nav-pills.nav-stacked>li>a{margin-bottom:3px;}
.nav-pills.nav-stacked>li:last-child>a{margin-bottom:1px;}
.nav-tabs .dropdown-menu{border-radius:0 0 6px 6px;}
.nav-pills .dropdown-menu{border-radius:6px;}
.nav .dropdown-toggle .caret{border-top-color:#0088cc;border-bottom-color:#0088cc;margin-top:6px;}
.nav .dropdown-toggle:hover .caret{border-top-color:#005580;border-bottom-color:#005580;}
.nav-tabs .dropdown-toggle .caret{margin-top:8px;}
.nav .active .dropdown-toggle .caret{border-top-color:#fff;border-bottom-color:#fff;}
.nav-tabs .active .dropdown-toggle .caret{border-top-color:#555555;border-bottom-color:#555555;}
.nav>.dropdown.active>a:hover{cursor:pointer;}
.nav-tabs .open .dropdown-toggle,.nav-pills .open .dropdown-toggle,.nav>li.dropdown.open.active>a:hover{color:#ffffff;background-color:#999999;border-color:#999999;}
.nav li.dropdown.open .caret,.nav li.dropdown.open.active .caret,.nav li.dropdown.open a:hover .caret{border-top-color:#ffffff;border-bottom-color:#ffffff;opacity:1;filter:alpha(opacity=100);}
.tabs-stacked .open>a:hover{border-color:#999999;}
.tabbable{*zoom:1;}.tabbable:before,.tabbable:after{display:table;content:"";line-height:0;}
.tabbable:after{clear:both;}
.tab-content{overflow:auto;}
.tabs-below>.nav-tabs,.tabs-right>.nav-tabs,.tabs-left>.nav-tabs{border-bottom:0;}
.tab-content>.tab-pane,.pill-content>.pill-pane{display:none;}
.tab-content>.active,.pill-content>.active{display:block;}
.tabs-below>.nav-tabs{border-top:1px solid #ddd;}
.tabs-below>.nav-tabs>li{margin-top:-1px;margin-bottom:0;}
.tabs-below>.nav-tabs>li>a{border-radius:0 0 4px 4px;}.tabs-below>.nav-tabs>li>a:hover{border-bottom-color:transparent;border-top-color:#ddd;}
.tabs-below>.nav-tabs>.active>a,.tabs-below>.nav-tabs>.active>a:hover{border-color:transparent #ddd #ddd #ddd;}
.tabs-left>.nav-tabs>li,.tabs-right>.nav-tabs>li{float:none;}
.tabs-left>.nav-tabs>li>a,.tabs-right>.nav-tabs>li>a{min-width:74px;margin-right:0;margin-bottom:3px;}
.tabs-left>.nav-tabs{float:left;margin-right:19px;border-right:1px solid #ddd;}
.tabs-left>.nav-tabs>li>a{margin-right:-1px;border-radius:4px 0 0 4px;}
.tabs-left>.nav-tabs>li>a:hover{border-color:#eeeeee #dddddd #eeeeee #eeeeee;}
.tabs-left>.nav-tabs .active>a,.tabs-left>.nav-tabs .active>a:hover{border-color:#ddd transparent #ddd #ddd;*border-right-color:#ffffff;}
.tabs-right>.nav-tabs{float:right;margin-left:19px;border-left:1px solid #ddd;}
.tabs-right>.nav-tabs>li>a{margin-left:-1px;border-radius:0 4px 4px 0;}
.tabs-right>.nav-tabs>li>a:hover{border-color:#eeeeee #eeeeee #eeeeee #dddddd;}
.tabs-right>.nav-tabs .active>a,.tabs-right>.nav-tabs .active>a:hover{border-color:#ddd #ddd #ddd transparent;*border-left-color:#ffffff;}
.nav>.disabled>a{color:#999999;}
.nav>.disabled>a:hover{text-decoration:none;background-color:transparent;cursor:default;}
.navbar{overflow:visible;*position:relative;*z-index:2;}
.navbar-inner{min-height:40px;padding-left:20px;padding-right:20px;background-color:#fafafa;background-image:linear-gradient(to bottom, #ffffff, #f2f2f2);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff', endColorstr='#fff2f2f2', GradientType=0);border:1px solid #d4d4d4;border-radius:4px;box-shadow:0 1px 4px rgba(0, 0, 0, 0.065);*zoom:1;}.navbar-inner:before,.navbar-inner:after{display:table;content:"";line-height:0;}
.navbar-inner:after{clear:both;}
.navbar .container{width:auto;}
.nav-collapse.collapse{height:auto;overflow:visible;}
.navbar .brand{float:left;display:block;padding:10px 20px 10px;margin-left:-20px;font-size:20px;font-weight:200;color:#777777;text-shadow:0 1px 0 #ffffff;}.navbar .brand:hover{text-decoration:none;}
.navbar-text{margin-bottom:0;line-height:40px;color:#777777;}
.navbar-link{color:#777777;}.navbar-link:hover{color:#333333;}
.navbar .divider-vertical{height:40px;margin:0 9px;border-left:1px solid #f2f2f2;border-right:1px solid #ffffff;}
.navbar .btn,.navbar .btn-group{margin-top:5px;}
.navbar .btn-group .btn,.navbar .input-prepend .btn,.navbar .input-append .btn{margin-top:0;}
.navbar-form{margin-bottom:0;*zoom:1;}.navbar-form:before,.navbar-form:after{display:table;content:"";line-height:0;}
.navbar-form:after{clear:both;}
.navbar-form input,.navbar-form select,.navbar-form .radio,.navbar-form .checkbox{margin-top:5px;}
.navbar-form input,.navbar-form select,.navbar-form .btn{display:inline-block;margin-bottom:0;}
.navbar-form input[type="image"],.navbar-form input[type="checkbox"],.navbar-form input[type="radio"]{margin-top:3px;}
.navbar-form .input-append,.navbar-form .input-prepend{margin-top:5px;white-space:nowrap;}.navbar-form .input-append input,.navbar-form .input-prepend input{margin-top:0;}
.navbar-search{position:relative;float:left;margin-top:5px;margin-bottom:0;}.navbar-search .search-query{margin-bottom:0;padding:4px 14px;font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;font-size:13px;font-weight:normal;line-height:1;border-radius:15px;}
.navbar-static-top{position:static;margin-bottom:0;}.navbar-static-top .navbar-inner{border-radius:0;}
.navbar-fixed-top,.navbar-fixed-bottom{position:fixed;right:0;left:0;z-index:1030;margin-bottom:0;}
.navbar-fixed-top .navbar-inner,.navbar-static-top .navbar-inner{border-width:0 0 1px;}
.navbar-fixed-bottom .navbar-inner{border-width:1px 0 0;}
.navbar-fixed-top .navbar-inner,.navbar-fixed-bottom .navbar-inner{padding-left:0;padding-right:0;border-radius:0;}
.navbar-static-top .container,.navbar-fixed-top .container,.navbar-fixed-bottom .container{width:940px;}
.navbar-fixed-top{top:0;}
.navbar-fixed-top .navbar-inner,.navbar-static-top .navbar-inner{box-shadow:0 1px 10px rgba(0,0,0,.1);}
.navbar-fixed-bottom{bottom:0;}.navbar-fixed-bottom .navbar-inner{box-shadow:0 -1px 10px rgba(0,0,0,.1);}
.navbar .nav{position:relative;left:0;display:block;float:left;margin:0 10px 0 0;}
.navbar .nav.pull-right{float:right;margin-right:0;}
.navbar .nav>li{float:left;}
.navbar .nav>li>a{float:none;padding:10px 15px 10px;color:#777777;text-decoration:none;text-shadow:0 1px 0 #ffffff;}
.navbar .nav .dropdown-toggle .caret{margin-top:8px;}
.navbar .nav>li>a:focus,.navbar .nav>li>a:hover{background-color:transparent;color:#333333;text-decoration:none;}
.navbar .nav>.active>a,.navbar .nav>.active>a:hover,.navbar .nav>.active>a:focus{color:#555555;text-decoration:none;background-color:#e5e5e5;box-shadow:inset 0 3px 8px rgba(0, 0, 0, 0.125);}
.navbar .btn-navbar{display:none;float:right;padding:7px 10px;margin-left:5px;margin-right:5px;color:#ffffff;text-shadow:0 -1px 0 rgba(0, 0, 0, 0.25);background-color:#ededed;background-image:linear-gradient(to bottom, #f2f2f2, #e5e5e5);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff2f2f2', endColorstr='#ffe5e5e5', GradientType=0);border-color:#e5e5e5 #e5e5e5 #bfbfbf;border-color:rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);*background-color:#e5e5e5;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);box-shadow:inset 0 1px 0 rgba(255,255,255,.1), 0 1px 0 rgba(255,255,255,.075);}.navbar .btn-navbar:hover,.navbar .btn-navbar:active,.navbar .btn-navbar.active,.navbar .btn-navbar.disabled,.navbar .btn-navbar[disabled]{color:#ffffff;background-color:#e5e5e5;*background-color:#d9d9d9;}
.navbar .btn-navbar:active,.navbar .btn-navbar.active{background-color:#cccccc \\9;}
.navbar .btn-navbar .icon-bar{display:block;width:18px;height:2px;background-color:#f5f5f5;border-radius:1px;box-shadow:0 1px 0 rgba(0, 0, 0, 0.25);}
.btn-navbar .icon-bar+.icon-bar{margin-top:3px;}
.navbar .nav>li>.dropdown-menu:before{content:'';display:inline-block;border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid #ccc;border-bottom-color:rgba(0, 0, 0, 0.2);position:absolute;top:-7px;left:9px;}
.navbar .nav>li>.dropdown-menu:after{content:'';display:inline-block;border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #ffffff;position:absolute;top:-6px;left:10px;}
.navbar-fixed-bottom .nav>li>.dropdown-menu:before{border-top:7px solid #ccc;border-top-color:rgba(0, 0, 0, 0.2);border-bottom:0;bottom:-7px;top:auto;}
.navbar-fixed-bottom .nav>li>.dropdown-menu:after{border-top:6px solid #ffffff;border-bottom:0;bottom:-6px;top:auto;}
.navbar .nav li.dropdown>a:hover .caret{border-top-color:#555555;border-bottom-color:#555555;}
.navbar .nav li.dropdown.open>.dropdown-toggle,.navbar .nav li.dropdown.active>.dropdown-toggle,.navbar .nav li.dropdown.open.active>.dropdown-toggle{background-color:#e5e5e5;color:#555555;}
.navbar .nav li.dropdown>.dropdown-toggle .caret{border-top-color:#777777;border-bottom-color:#777777;}
.navbar .nav li.dropdown.open>.dropdown-toggle .caret,.navbar .nav li.dropdown.active>.dropdown-toggle .caret,.navbar .nav li.dropdown.open.active>.dropdown-toggle .caret{border-top-color:#555555;border-bottom-color:#555555;}
.navbar .pull-right>li>.dropdown-menu,.navbar .nav>li>.dropdown-menu.pull-right{left:auto;right:0;}.navbar .pull-right>li>.dropdown-menu:before,.navbar .nav>li>.dropdown-menu.pull-right:before{left:auto;right:12px;}
.navbar .pull-right>li>.dropdown-menu:after,.navbar .nav>li>.dropdown-menu.pull-right:after{left:auto;right:13px;}
.navbar .pull-right>li>.dropdown-menu .dropdown-menu,.navbar .nav>li>.dropdown-menu.pull-right .dropdown-menu{left:auto;right:100%;margin-left:0;margin-right:-1px;border-radius:6px 0 6px 6px;}
.navbar-inverse .navbar-inner{background-color:#1b1b1b;background-image:linear-gradient(to bottom, #222222, #111111);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff222222', endColorstr='#ff111111', GradientType=0);border-color:#252525;}
.navbar-inverse .brand,.navbar-inverse .nav>li>a{color:#999999;text-shadow:0 -1px 0 rgba(0, 0, 0, 0.25);}.navbar-inverse .brand:hover,.navbar-inverse .nav>li>a:hover{color:#ffffff;}
.navbar-inverse .brand{color:#999999;}
.navbar-inverse .navbar-text{color:#999999;}
.navbar-inverse .nav>li>a:focus,.navbar-inverse .nav>li>a:hover{background-color:transparent;color:#ffffff;}
.navbar-inverse .nav .active>a,.navbar-inverse .nav .active>a:hover,.navbar-inverse .nav .active>a:focus{color:#ffffff;background-color:#111111;}
.navbar-inverse .navbar-link{color:#999999;}.navbar-inverse .navbar-link:hover{color:#ffffff;}
.navbar-inverse .divider-vertical{border-left-color:#111111;border-right-color:#222222;}
.navbar-inverse .nav li.dropdown.open>.dropdown-toggle,.navbar-inverse .nav li.dropdown.active>.dropdown-toggle,.navbar-inverse .nav li.dropdown.open.active>.dropdown-toggle{background-color:#111111;color:#ffffff;}
.navbar-inverse .nav li.dropdown>a:hover .caret{border-top-color:#ffffff;border-bottom-color:#ffffff;}
.navbar-inverse .nav li.dropdown>.dropdown-toggle .caret{border-top-color:#999999;border-bottom-color:#999999;}
.navbar-inverse .nav li.dropdown.open>.dropdown-toggle .caret,.navbar-inverse .nav li.dropdown.active>.dropdown-toggle .caret,.navbar-inverse .nav li.dropdown.open.active>.dropdown-toggle .caret{border-top-color:#ffffff;border-bottom-color:#ffffff;}
.navbar-inverse .navbar-search .search-query{color:#ffffff;background-color:#515151;border-color:#111111;box-shadow:inset 0 1px 2px rgba(0,0,0,.1), 0 1px 0 rgba(255,255,255,.15);transition:none;}.navbar-inverse .navbar-search .search-query:-moz-placeholder{color:#cccccc;}
.navbar-inverse .navbar-search .search-query:-ms-input-placeholder{color:#cccccc;}
.navbar-inverse .navbar-search .search-query::-webkit-input-placeholder{color:#cccccc;}
.navbar-inverse .navbar-search .search-query:focus,.navbar-inverse .navbar-search .search-query.focused{padding:5px 15px;color:#333333;text-shadow:0 1px 0 #ffffff;background-color:#ffffff;border:0;box-shadow:0 0 3px rgba(0, 0, 0, 0.15);outline:0;}
.navbar-inverse .btn-navbar{color:#ffffff;text-shadow:0 -1px 0 rgba(0, 0, 0, 0.25);background-color:#0e0e0e;background-image:linear-gradient(to bottom, #151515, #040404);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff151515', endColorstr='#ff040404', GradientType=0);border-color:#040404 #040404 #000000;border-color:rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);*background-color:#040404;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);}.navbar-inverse .btn-navbar:hover,.navbar-inverse .btn-navbar:active,.navbar-inverse .btn-navbar.active,.navbar-inverse .btn-navbar.disabled,.navbar-inverse .btn-navbar[disabled]{color:#ffffff;*background-color:#000000;}
.navbar-inverse .btn-navbar:active,.navbar-inverse .btn-navbar.active{background-color:#000000 \\9;}
.breadcrumb{padding:8px 15px;margin:0 0 20px;list-style:none;background-color:#f5f5f5;border-radius:4px;}.breadcrumb>li{display:inline-block;*display:inline;*zoom:1;text-shadow:0 1px 0 #ffffff;}.breadcrumb>li>.divider{padding:0 5px;color:#ccc;}
.breadcrumb>.active{color:#999999;}
.pagination{margin:20px 0;}
.pagination ul{display:inline-block;*display:inline;*zoom:1;margin-left:0;margin-bottom:0;border-radius:4px;box-shadow:0 1px 2px rgba(0, 0, 0, 0.05);}
.pagination ul>li{display:inline;}
.pagination ul>li>a,.pagination ul>li>span{float:left;padding:4px 12px;line-height:20px;text-decoration:none;background-color:#ffffff;border:1px solid #dddddd;border-left-width:0;}
.pagination ul>li>a:hover,.pagination ul>.active>a,.pagination ul>.active>span{background-color:#f5f5f5;}
.pagination ul>.active>a,.pagination ul>.active>span{color:#999999;cursor:default;}
.pagination ul>.disabled>span,.pagination ul>.disabled>a,.pagination ul>.disabled>a:hover{color:#999999;background-color:transparent;cursor:default;}
.pagination ul>li:first-child>a,.pagination ul>li:first-child>span{border-left-width:1px;border-top-left-radius:4px;border-bottom-left-radius:4px;}
.pagination ul>li:last-child>a,.pagination ul>li:last-child>span{border-top-right-radius:4px;border-bottom-right-radius:4px;}
.pagination-centered{text-align:center;}
.pagination-right{text-align:right;}
.pagination-large ul>li>a,.pagination-large ul>li>span{padding:11px 19px;font-size:17.5px;}
.pagination-large ul>li:first-child>a,.pagination-large ul>li:first-child>span{border-top-left-radius:6px;border-bottom-left-radius:6px;}
.pagination-large ul>li:last-child>a,.pagination-large ul>li:last-child>span{border-top-right-radius:6px;border-bottom-right-radius:6px;}
.pagination-mini ul>li:first-child>a,.pagination-small ul>li:first-child>a,.pagination-mini ul>li:first-child>span,.pagination-small ul>li:first-child>span{border-top-left-radius:3px;border-bottom-left-radius:3px;}
.pagination-mini ul>li:last-child>a,.pagination-small ul>li:last-child>a,.pagination-mini ul>li:last-child>span,.pagination-small ul>li:last-child>span{border-top-right-radius:3px;border-bottom-right-radius:3px;}
.pagination-small ul>li>a,.pagination-small ul>li>span{padding:2px 10px;font-size:11.9px;}
.pagination-mini ul>li>a,.pagination-mini ul>li>span{padding:0 6px;font-size:10.5px;}
.pager{margin:20px 0;list-style:none;text-align:center;*zoom:1;}.pager:before,.pager:after{display:table;content:"";line-height:0;}
.pager:after{clear:both;}
.pager li{display:inline;}
.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px;}
.pager li>a:hover{text-decoration:none;background-color:#f5f5f5;}
.pager .next>a,.pager .next>span{float:right;}
.pager .previous>a,.pager .previous>span{float:left;}
.pager .disabled>a,.pager .disabled>a:hover,.pager .disabled>span{color:#999999;background-color:#fff;cursor:default;}
.thumbnails{margin-left:-20px;list-style:none;*zoom:1;}.thumbnails:before,.thumbnails:after{display:table;content:"";line-height:0;}
.thumbnails:after{clear:both;}
.row-fluid .thumbnails{margin-left:0;}
.thumbnails>li{float:left;margin-bottom:20px;margin-left:20px;}
.thumbnail{display:block;padding:4px;line-height:20px;border:1px solid #ddd;border-radius:4px;box-shadow:0 1px 3px rgba(0, 0, 0, 0.055);transition:all 0.2s ease-in-out;}
a.thumbnail:hover{border-color:#0088cc;box-shadow:0 1px 4px rgba(0, 105, 214, 0.25);}
.thumbnail>img{display:block;max-width:100%;margin-left:auto;margin-right:auto;}
.thumbnail .caption{padding:9px;color:#555555;}
.alert{padding:8px 35px 8px 14px;margin-bottom:20px;text-shadow:0 1px 0 rgba(255, 255, 255, 0.5);background-color:#fcf8e3;border:1px solid #fbeed5;border-radius:4px;}
.alert,.alert h4{color:#c09853;}
.alert h4{margin:0;}
.alert .close{position:relative;top:-2px;right:-21px;line-height:20px;}
.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#468847;}
.alert-success h4{color:#468847;}
.alert-danger,.alert-error{background-color:#f2dede;border-color:#eed3d7;color:#b94a48;}
.alert-danger h4,.alert-error h4{color:#b94a48;}
.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#3a87ad;}
.alert-info h4{color:#3a87ad;}
.alert-block{padding-top:14px;padding-bottom:14px;}
.alert-block>p,.alert-block>ul{margin-bottom:0;}
.alert-block p+p{margin-top:5px;}@keyframes progress-bar-stripes{from{background-position:40px 0;} to{background-position:0 0;}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f7f7f7;background-image:linear-gradient(to bottom, #f5f5f5, #f9f9f9);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff5f5f5', endColorstr='#fff9f9f9', GradientType=0);box-shadow:inset 0 1px 2px rgba(0, 0, 0, 0.1);border-radius:4px;}
.progress .bar{width:0%;height:100%;color:#ffffff;float:left;font-size:12px;text-align:center;text-shadow:0 -1px 0 rgba(0, 0, 0, 0.25);background-color:#0e90d2;background-image:linear-gradient(to bottom, #149bdf, #0480be);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff149bdf', endColorstr='#ff0480be', GradientType=0);box-shadow:inset 0 -1px 0 rgba(0, 0, 0, 0.15);box-sizing:border-box;transition:width 0.6s ease;}
.progress .bar+.bar{box-shadow:inset 1px 0 0 rgba(0,0,0,.15), inset 0 -1px 0 rgba(0,0,0,.15);}
.progress-striped .bar{background-color:#149bdf;background-image:linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-size:40px 40px;}
.progress.active .bar{animation:progress-bar-stripes 2s linear infinite;}
.progress-danger .bar,.progress .bar-danger{background-color:#dd514c;background-image:linear-gradient(to bottom, #ee5f5b, #c43c35);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffee5f5b', endColorstr='#ffc43c35', GradientType=0);}
.progress-danger.progress-striped .bar,.progress-striped .bar-danger{background-color:#ee5f5b;background-image:linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);}
.progress-success .bar,.progress .bar-success{background-color:#5eb95e;background-image:linear-gradient(to bottom, #62c462, #57a957);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff62c462', endColorstr='#ff57a957', GradientType=0);}
.progress-success.progress-striped .bar,.progress-striped .bar-success{background-color:#62c462;background-image:linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);}
.progress-info .bar,.progress .bar-info{background-color:#4bb1cf;background-image:linear-gradient(to bottom, #5bc0de, #339bb9);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff5bc0de', endColorstr='#ff339bb9', GradientType=0);}
.progress-info.progress-striped .bar,.progress-striped .bar-info{background-color:#5bc0de;background-image:linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);}
.progress-warning .bar,.progress .bar-warning{background-color:#faa732;background-image:linear-gradient(to bottom, #fbb450, #f89406);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffbb450', endColorstr='#fff89406', GradientType=0);}
.progress-warning.progress-striped .bar,.progress-striped .bar-warning{background-color:#fbb450;background-image:linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);}
.hero-unit{padding:60px;margin-bottom:30px;font-size:18px;font-weight:200;line-height:30px;color:inherit;background-color:#eeeeee;border-radius:6px;}.hero-unit h1{margin-bottom:0;font-size:60px;line-height:1;color:inherit;letter-spacing:-1px;}
.hero-unit li{line-height:30px;}
.media,.media-body{overflow:hidden;*overflow:visible;zoom:1;}
.media,.media .media{margin-top:15px;}
.media:first-child{margin-top:0;}
.media-object{display:block;}
.media-heading{margin:0 0 5px;}
.media .pull-left{margin-right:10px;}
.media .pull-right{margin-left:10px;}
.media-list{margin-left:0;list-style:none;}
.tooltip{position:absolute;z-index:1030;display:block;visibility:visible;padding:5px;font-size:11px;opacity:0;filter:alpha(opacity=0);}.tooltip.in{opacity:0.8;filter:alpha(opacity=80);}
.tooltip.top{margin-top:-3px;}
.tooltip.right{margin-left:3px;}
.tooltip.bottom{margin-top:3px;}
.tooltip.left{margin-left:-3px;}
.tooltip-inner{max-width:200px;padding:3px 8px;color:#ffffff;text-align:center;text-decoration:none;background-color:#000000;border-radius:4px;}
.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid;}
.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000000;}
.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000000;}
.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000000;}
.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000000;}
.popover{position:absolute;top:0;left:0;z-index:1010;display:none;width:236px;padding:1px;text-align:left;background-color:#ffffff;-webkit-background-clip:padding-box;-moz-background-clip:padding;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0, 0, 0, 0.2);border-radius:6px;box-shadow:0 5px 10px rgba(0, 0, 0, 0.2);white-space:normal;}.popover.top{margin-top:-10px;}
.popover.right{margin-left:10px;}
.popover.bottom{margin-top:10px;}
.popover.left{margin-left:-10px;}
.popover-title{margin:0;padding:8px 14px;font-size:14px;font-weight:normal;line-height:18px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0;}
.popover-content{padding:9px 14px;}
.popover .arrow,.popover .arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid;}
.popover .arrow{border-width:11px;}
.popover .arrow:after{border-width:10px;content:"";}
.popover.top .arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0, 0, 0, 0.25);bottom:-11px;}.popover.top .arrow:after{bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#ffffff;}
.popover.right .arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0, 0, 0, 0.25);}.popover.right .arrow:after{left:1px;bottom:-10px;border-left-width:0;border-right-color:#ffffff;}
.popover.bottom .arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0, 0, 0, 0.25);top:-11px;}.popover.bottom .arrow:after{top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#ffffff;}
.popover.left .arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0, 0, 0, 0.25);}.popover.left .arrow:after{right:1px;border-right-width:0;border-left-color:#ffffff;bottom:-10px;}
.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000000;}.modal-backdrop.fade{opacity:0;}
.modal-backdrop,.modal-backdrop.fade.in{opacity:0.8;filter:alpha(opacity=80);}
.modal{position:fixed;top:10%;left:50%;z-index:1050;width:560px;margin-left:-280px;background-color:#ffffff;border:1px solid #999;border:1px solid rgba(0, 0, 0, 0.3);*border:1px solid #999;border-radius:6px;box-shadow:0 3px 7px rgba(0, 0, 0, 0.3);-webkit-background-clip:padding-box;-moz-background-clip:padding-box;background-clip:padding-box;outline:none;}.modal.fade{transition:opacity .3s linear, top .3s ease-out;top:-25%;}
.modal.fade.in{top:10%;}
.modal-header{padding:9px 15px;border-bottom:1px solid #eee;}.modal-header .close{margin-top:2px;}
.modal-header h3{margin:0;line-height:30px;}
.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px;}
.modal-form{margin-bottom:0;}
.modal-footer{padding:14px 15px 15px;margin-bottom:0;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;box-shadow:inset 0 1px 0 #ffffff;*zoom:1;}.modal-footer:before,.modal-footer:after{display:table;content:"";line-height:0;}
.modal-footer:after{clear:both;}
.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0;}
.modal-footer .btn-group .btn+.btn{margin-left:-1px;}
.modal-footer .btn-block+.btn-block{margin-left:0;}
.dropup,.dropdown{position:relative;}
.dropdown-toggle{*margin-bottom:-3px;}
.dropdown-toggle:active,.open .dropdown-toggle{outline:0;}
.caret{display:inline-block;width:0;height:0;vertical-align:top;border-top:4px solid #000000;border-right:4px solid transparent;border-left:4px solid transparent;content:"";}
.dropdown .caret{margin-top:8px;margin-left:2px;}
.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;background-color:#ffffff;border:1px solid #ccc;border:1px solid rgba(0, 0, 0, 0.2);*border-right-width:2px;*border-bottom-width:2px;border-radius:6px;box-shadow:0 5px 10px rgba(0, 0, 0, 0.2);-webkit-background-clip:padding-box;-moz-background-clip:padding;background-clip:padding-box;}.dropdown-menu.pull-right{right:0;left:auto;}
.dropdown-menu .divider{*width:100%;height:1px;margin:9px 1px;*margin:-5px 0 5px;overflow:hidden;background-color:#e5e5e5;border-bottom:1px solid #ffffff;}
.dropdown-menu li>a{display:block;padding:3px 20px;clear:both;font-weight:normal;line-height:20px;color:#333333;white-space:nowrap;}
.dropdown-menu li>a:hover,.dropdown-menu li>a:focus,.dropdown-submenu:hover>a{text-decoration:none;color:#ffffff;background-color:#0081c2;background-image:linear-gradient(to bottom, #0088cc, #0077b3);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff0088cc', endColorstr='#ff0077b3', GradientType=0);}
.dropdown-menu .active>a,.dropdown-menu .active>a:hover{color:#ffffff;text-decoration:none;outline:0;background-color:#0081c2;background-image:linear-gradient(to bottom, #0088cc, #0077b3);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff0088cc', endColorstr='#ff0077b3', GradientType=0);}
.dropdown-menu .disabled>a,.dropdown-menu .disabled>a:hover{color:#999999;}
.dropdown-menu .disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:default;}
.open{*z-index:1000;}.open >.dropdown-menu{display:block;}
.pull-right>.dropdown-menu{right:0;left:auto;}
.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px solid #000000;content:"";}
.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:1px;}
.dropdown-submenu{position:relative;}
.dropdown-submenu>.dropdown-menu{top:0;left:100%;margin-top:-6px;margin-left:-1px;border-radius:0 6px 6px 6px;}
.dropdown-submenu:hover>.dropdown-menu{display:block;}
.dropup .dropdown-submenu>.dropdown-menu{top:auto;bottom:0;margin-top:0;margin-bottom:-2px;border-radius:5px 5px 5px 0;}
.dropdown-submenu>a:after{display:block;content:" ";float:right;width:0;height:0;border-color:transparent;border-style:solid;border-width:5px 0 5px 5px;border-left-color:#cccccc;margin-top:5px;margin-right:-10px;}
.dropdown-submenu:hover>a:after{border-left-color:#ffffff;}
.dropdown-submenu.pull-left{float:none;}.dropdown-submenu.pull-left>.dropdown-menu{left:-100%;margin-left:10px;border-radius:6px 0 6px 6px;}
.dropdown .dropdown-menu .nav-header{padding-left:20px;padding-right:20px;}
.typeahead{z-index:1051;margin-top:2px;border-radius:4px;}
.accordion{margin-bottom:20px;}
/*.accordion-group{margin:10px;border:1px solid #e5e5e5;border-radius:4px;-moz-border-radius:4px;border-radius:4px;background-color: #F8F8F8}*/
.accordion-group{margin:10px;border:1px solid #e5e5e5;background-color: #F8F8F8;border-radius: 4px;}
.accordion-heading{border-bottom:0;}
.accordion-heading .accordion-toggle{display:block;padding:8px 15px}
.accordion-heading .accordion-toggle::first-letter{text-transform:capitalize;}
.accordion-toggle{cursor:pointer;}
/*.accordion-inner{padding:9px 15px;border-top:1px solid #e5e5e5;}*/
.accordion-inner{padding:9px 15px;background-color: rgb(255, 255, 255);}
.carousel{position:relative;margin-bottom:20px;line-height:1;}
.carousel-inner{overflow:hidden;width:100%;position:relative;}
.carousel-inner>.item{display:none;position:relative;transition:0.6s ease-in-out left;}
.carousel-inner>.item>img{display:block;line-height:1;}
.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block;}
.carousel-inner>.active{left:0;}
.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%;}
.carousel-inner>.next{left:100%;}
.carousel-inner>.prev{left:-100%;}
.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0;}
.carousel-inner>.active.left{left:-100%;}
.carousel-inner>.active.right{left:100%;}
.carousel-control{position:absolute;top:40%;left:15px;width:40px;height:40px;margin-top:-20px;font-size:60px;font-weight:100;line-height:30px;color:#ffffff;text-align:center;background:#222222;border:3px solid #ffffff;border-radius:23px;opacity:0.5;filter:alpha(opacity=50);}.carousel-control.right{left:auto;right:15px;}
.carousel-control:hover{color:#ffffff;text-decoration:none;opacity:0.9;filter:alpha(opacity=90);}
.carousel-caption{position:absolute;left:0;right:0;bottom:0;padding:15px;background:#333333;background:rgba(0, 0, 0, 0.75);}
.carousel-caption h4,.carousel-caption p{color:#ffffff;line-height:20px;}
.carousel-caption h4{margin:0 0 5px;}
.carousel-caption p{margin-bottom:0;}
.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.05);}.well blockquote{border-color:#ddd;border-color:rgba(0, 0, 0, 0.15);}
.well-large{padding:24px;border-radius:6px;}
.well-small{padding:9px;border-radius:3px;}
.close{float:right;font-size:20px;font-weight:bold;line-height:20px;color:#000000;text-shadow:0 1px 0 #ffffff;opacity:0.2;filter:alpha(opacity=20);}.close:hover{color:#000000;text-decoration:none;cursor:pointer;opacity:0.4;filter:alpha(opacity=40);}
button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none;}
.pull-right{float:right;}
.pull-left{float:left;}
.hide{display:none;}
.show{display:block;}
.invisible{visibility:hidden;}
.affix{position:fixed;}
.fade{opacity:0;transition:opacity 0.15s linear;}.fade.in{opacity:1;}
.collapse{position:relative;height:0;overflow:hidden;transition:height 0.35s ease;}.collapse.in{height:auto;}
.hidden{display:none;visibility:hidden;}
.visible-phone{display:none !important;}
.visible-tablet{display:none !important;}
.hidden-desktop{display:none !important;}
.visible-desktop{display:inherit !important;}
@media (min-width:768px) and (max-width:979px){.hidden-desktop{display:inherit !important;} .visible-desktop{display:none !important ;} .visible-tablet{display:inherit !important;} .hidden-tablet{display:none !important;}}@media (max-width:767px){.hidden-desktop{display:inherit !important;} .visible-desktop{display:none !important;} .visible-phone{display:inherit !important;} .hidden-phone{display:none !important;}body{padding-left:20px;padding-right:20px;} .navbar-fixed-top,.navbar-fixed-bottom,.navbar-static-top{margin-left:-20px;margin-right:-20px;} .container-fluid{padding:0;} .dl-horizontal dt{float:none;clear:none;width:auto;text-align:left;} .dl-horizontal dd{margin-left:0;} .container{width:auto;} .row-fluid{width:100%;} .row,.thumbnails{margin-left:0;} .thumbnails>li{float:none;margin-left:0;} [class*="span"],.uneditable-input[class*="span"],.row-fluid [class*="span"]{float:none;display:block;width:100%;margin-left:0;box-sizing:border-box;} .span12,.row-fluid .span12{width:100%;box-sizing:border-box;} .row-fluid [class*="offset"]:first-child{margin-left:0;} .input-large,.input-xlarge,.input-xxlarge,input[class*="span"],select[class*="span"],textarea[class*="span"],.uneditable-input{display:block;width:100%;min-height:30px;box-sizing:border-box;} .input-prepend input,.input-append input,.input-prepend input[class*="span"],.input-append input[class*="span"]{display:inline-block;width:auto;} .controls-row [class*="span"]+[class*="span"]{margin-left:0;} .modal{position:fixed;top:20px;left:20px;right:20px;width:auto;margin:0;}.modal.fade{top:-100px;} .modal.fade.in{top:20px;}}@media (max-width:480px){.nav-collapse{-webkit-transform:translate3d(0, 0, 0);} .page-header h1 small{display:block;line-height:20px;} input[type="checkbox"],input[type="radio"]{border:1px solid #ccc;} .form-horizontal .control-label{float:none;width:auto;padding-top:0;text-align:left;} .form-horizontal .controls{margin-left:0;} .form-horizontal .control-list{padding-top:0;} .form-horizontal .form-actions{padding-left:10px;padding-right:10px;} .media .pull-left,.media .pull-right{float:none;display:block;margin-bottom:10px;} .media-object{margin-right:0;margin-left:0;} .modal{top:10px;left:10px;right:10px;} .modal-header .close{padding:10px;margin:-10px;} .carousel-caption{position:static;}}@media (min-width:768px) and (max-width:979px){.row{margin-left:-20px;*zoom:1;}.row:before,.row:after{display:table;content:"";line-height:0;} .row:after{clear:both;} [class*="span"]{float:left;min-height:1px;margin-left:20px;} .container,.navbar-static-top .container,.navbar-fixed-top .container,.navbar-fixed-bottom .container{width:724px;} .span12{width:724px;} .span11{width:662px;} .span10{width:600px;} .span9{width:538px;} .span8{width:476px;} .span7{width:414px;} .span6{width:352px;} .span5{width:290px;} .span4{width:228px;} .span3{width:166px;} .span2{width:104px;} .span1{width:42px;} .offset12{margin-left:764px;} .offset11{margin-left:702px;} .offset10{margin-left:640px;} .offset9{margin-left:578px;} .offset8{margin-left:516px;} .offset7{margin-left:454px;} .offset6{margin-left:392px;} .offset5{margin-left:330px;} .offset4{margin-left:268px;} .offset3{margin-left:206px;} .offset2{margin-left:144px;} .offset1{margin-left:82px;} .row-fluid{width:100%;*zoom:1;}.row-fluid:before,.row-fluid:after{display:table;content:"";line-height:0;} .row-fluid:after{clear:both;} .row-fluid [class*="span"]{display:block;width:100%;min-height:30px;box-sizing:border-box;float:left;*margin-left:2.709239449864817%;} .row-fluid [class*="span"]:first-child{margin-left:0;} .row-fluid .controls-row [class*="span"]+[class*="span"]{margin-left:2.7624309392265194%;} .row-fluid .span12{*width:99.94680851063829%;} .row-fluid .span11{*width:91.38327259903608%;} .row-fluid .span10{*width:82.81973668743387%;} .row-fluid .span9{*width:74.25620077583166%;} .row-fluid .span8{*width:65.69266486422946%;} .row-fluid .span7{*width:57.12912895262725%;} .row-fluid .span6{*width:48.56559304102504%;} .row-fluid .span5{*width:40.00205712942283%;} .row-fluid .span4{*width:31.43852121782062%;} .row-fluid .span3{*width:22.87498530621841%;} .row-fluid .span2{*width:14.311449394616199%;} .row-fluid .span1{*width:5.747913483013988%;} .row-fluid .offset12{*margin-left:105.41847889972962%;} .row-fluid .offset12:first-child{*margin-left:102.6560479605031%;} .row-fluid .offset11{*margin-left:96.8549429881274%;} .row-fluid .offset11:first-child{*margin-left:94.09251204890089%;} .row-fluid .offset10{*margin-left:88.2914070765252%;} .row-fluid .offset10:first-child{*margin-left:85.52897613729868%;} .row-fluid .offset9{*margin-left:79.72787116492299%;} .row-fluid .offset9:first-child{*margin-left:76.96544022569647%;} .row-fluid .offset8{*margin-left:71.16433525332079%;} .row-fluid .offset8:first-child{*margin-left:68.40190431409427%;} .row-fluid .offset7{*margin-left:62.600799341718584%;} .row-fluid .offset7:first-child{*margin-left:59.838368402492065%;} .row-fluid .offset6{*margin-left:54.037263430116376%;} .row-fluid .offset6:first-child{*margin-left:51.27483249088986%;} .row-fluid .offset5{*margin-left:45.47372751851417%;} .row-fluid .offset5:first-child{*margin-left:42.71129657928765%;} .row-fluid .offset4{*margin-left:36.91019160691196%;} .row-fluid .offset4:first-child{*margin-left:34.14776066768544%;} .row-fluid .offset3{*margin-left:28.346655695309746%;} .row-fluid .offset3:first-child{*margin-left:25.584224756083227%;} .row-fluid .offset2{*margin-left:19.783119783707537%;} .row-fluid .offset2:first-child{*margin-left:17.02068884448102%;} .row-fluid .offset1{*margin-left:11.219583872105325%;} .row-fluid .offset1:first-child{*margin-left:8.457152932878806%;} input,textarea,.uneditable-input{margin-left:0;} .controls-row [class*="span"]+[class*="span"]{margin-left:20px;} input.span12, textarea.span12, .uneditable-input.span12{width:710px;} input.span11, textarea.span11, .uneditable-input.span11{width:648px;} input.span10, textarea.span10, .uneditable-input.span10{width:586px;} input.span9, textarea.span9, .uneditable-input.span9{width:524px;} input.span8, textarea.span8, .uneditable-input.span8{width:462px;} input.span7, textarea.span7, .uneditable-input.span7{width:400px;} input.span6, textarea.span6, .uneditable-input.span6{width:338px;} input.span5, textarea.span5, .uneditable-input.span5{width:276px;} input.span4, textarea.span4, .uneditable-input.span4{width:214px;} input.span3, textarea.span3, .uneditable-input.span3{width:152px;} input.span2, textarea.span2, .uneditable-input.span2{width:90px;} input.span1, textarea.span1, .uneditable-input.span1{width:28px;}}@media (min-width:1200px){.row{margin-left:-30px;*zoom:1;}.row:before,.row:after{display:table;content:"";line-height:0;} .row:after{clear:both;} [class*="span"]{float:left;min-height:1px;margin-left:30px;} .container,.navbar-static-top .container,.navbar-fixed-top .container,.navbar-fixed-bottom .container{width:1170px;} .span12{width:1170px;} .span11{width:1070px;} .span10{width:970px;} .span9{width:870px;} .span8{width:770px;} .span7{width:670px;} .span6{width:570px;} .span5{width:470px;} .span4{width:370px;} .span3{width:270px;} .span2{width:170px;} .span1{width:70px;} .offset12{margin-left:1230px;} .offset11{margin-left:1130px;} .offset10{margin-left:1030px;} .offset9{margin-left:930px;} .offset8{margin-left:830px;} .offset7{margin-left:730px;} .offset6{margin-left:630px;} .offset5{margin-left:530px;} .offset4{margin-left:430px;} .offset3{margin-left:330px;} .offset2{margin-left:230px;} .offset1{margin-left:130px;} .row-fluid{width:100%;*zoom:1;}.row-fluid:before,.row-fluid:after{display:table;content:"";line-height:0;} .row-fluid:after{clear:both;} .row-fluid [class*="span"]{display:block;width:100%;min-height:30px;box-sizing:border-box;float:left;*margin-left:2.5109110747408616%;} .row-fluid [class*="span"]:first-child{margin-left:0;} .row-fluid .controls-row [class*="span"]+[class*="span"]{margin-left:2.564102564102564%;} .row-fluid .span12{*width:99.94680851063829%;} .row-fluid .span11{*width:91.39979996362975%;} .row-fluid .span10{*width:82.8527914166212%;} .row-fluid .span9{*width:74.30578286961266%;} .row-fluid .span8{*width:65.75877432260411%;} .row-fluid .span7{*width:57.21176577559556%;} .row-fluid .span6{*width:48.664757228587014%;} .row-fluid .span5{*width:40.11774868157847%;} .row-fluid .span4{*width:31.570740134569924%;} .row-fluid .span3{*width:23.023731587561375%;} .row-fluid .span2{*width:14.476723040552828%;} .row-fluid .span1{*width:5.929714493544281%;} .row-fluid .offset12{*margin-left:105.02182214948171%;} .row-fluid .offset12:first-child{*margin-left:102.45771958537915%;} .row-fluid .offset11{*margin-left:96.47481360247316%;} .row-fluid .offset11:first-child{*margin-left:93.91071103837061%;} .row-fluid .offset10{*margin-left:87.92780505546462%;} .row-fluid .offset10:first-child{*margin-left:85.36370249136206%;} .row-fluid .offset9{*margin-left:79.38079650845607%;} .row-fluid .offset9:first-child{*margin-left:76.81669394435352%;} .row-fluid .offset8{*margin-left:70.83378796144753%;} .row-fluid .offset8:first-child{*margin-left:68.26968539734497%;} .row-fluid .offset7{*margin-left:62.28677941443899%;} .row-fluid .offset7:first-child{*margin-left:59.72267685033642%;} .row-fluid .offset6{*margin-left:53.739770867430444%;} .row-fluid .offset6:first-child{*margin-left:51.175668303327875%;} .row-fluid .offset5{*margin-left:45.1927623204219%;} .row-fluid .offset5:first-child{*margin-left:42.62865975631933%;} .row-fluid .offset4{*margin-left:36.645753773413354%;} .row-fluid .offset4:first-child{*margin-left:34.081651209310785%;} .row-fluid .offset3{*margin-left:28.0987452264048%;} .row-fluid .offset3:first-child{*margin-left:25.53464266230224%;} .row-fluid .offset2{*margin-left:19.551736679396257%;} .row-fluid .offset2:first-child{*margin-left:16.98763411529369%;} .row-fluid .offset1{*margin-left:11.004728132387708%;} .row-fluid .offset1:first-child{*margin-left:8.440625568285142%;} input,textarea,.uneditable-input{margin-left:0;} .controls-row [class*="span"]+[class*="span"]{margin-left:30px;} input.span12, textarea.span12, .uneditable-input.span12{width:1156px;} input.span11, textarea.span11, .uneditable-input.span11{width:1056px;} input.span10, textarea.span10, .uneditable-input.span10{width:956px;} input.span9, textarea.span9, .uneditable-input.span9{width:856px;} input.span8, textarea.span8, .uneditable-input.span8{width:756px;} input.span7, textarea.span7, .uneditable-input.span7{width:656px;} input.span6, textarea.span6, .uneditable-input.span6{width:556px;} input.span5, textarea.span5, .uneditable-input.span5{width:456px;} input.span4, textarea.span4, .uneditable-input.span4{width:356px;} input.span3, textarea.span3, .uneditable-input.span3{width:256px;} input.span2, textarea.span2, .uneditable-input.span2{width:156px;} input.span1, textarea.span1, .uneditable-input.span1{width:56px;} .thumbnails{margin-left:-30px;} .thumbnails>li{margin-left:30px;} .row-fluid .thumbnails{margin-left:0;}}@media (max-width:979px){body{padding-top:0;} .navbar-fixed-top,.navbar-fixed-bottom{position:static;} .navbar-fixed-top{margin-bottom:20px;} .navbar-fixed-bottom{margin-top:20px;} .navbar-fixed-top .navbar-inner,.navbar-fixed-bottom .navbar-inner{padding:5px;} .navbar .container{width:auto;padding:0;} .navbar .brand{padding-left:10px;padding-right:10px;margin:0 0 0 -5px;} .nav-collapse{clear:both;} .nav-collapse .nav{float:none;margin:0 0 10px;} .nav-collapse .nav>li{float:none;} .nav-collapse .nav>li>a{margin-bottom:2px;} .nav-collapse .nav>.divider-vertical{display:none;} .nav-collapse .nav .nav-header{color:#777777;text-shadow:none;} .nav-collapse .nav>li>a,.nav-collapse .dropdown-menu a{padding:9px 15px;font-weight:bold;color:#777777;border-radius:3px;} .nav-collapse .btn{padding:4px 10px 4px;font-weight:normal;border-radius:4px;} .nav-collapse .dropdown-menu li+li a{margin-bottom:2px;} .nav-collapse .nav>li>a:hover,.nav-collapse .dropdown-menu a:hover{background-color:#f2f2f2;} .navbar-inverse .nav-collapse .nav>li>a,.navbar-inverse .nav-collapse .dropdown-menu a{color:#999999;} .navbar-inverse .nav-collapse .nav>li>a:hover,.navbar-inverse .nav-collapse .dropdown-menu a:hover{background-color:#111111;} .nav-collapse.in .btn-group{margin-top:5px;padding:0;} .nav-collapse .dropdown-menu{position:static;top:auto;left:auto;float:none;display:none;max-width:none;margin:0 15px;padding:0;background-color:transparent;border:none;border-radius:0;box-shadow:none;} .nav-collapse .open>.dropdown-menu{display:block;} .nav-collapse .dropdown-menu:before,.nav-collapse .dropdown-menu:after{display:none;} .nav-collapse .dropdown-menu .divider{display:none;} .nav-collapse .nav>li>.dropdown-menu:before,.nav-collapse .nav>li>.dropdown-menu:after{display:none;} .nav-collapse .navbar-form,.nav-collapse .navbar-search{float:none;padding:10px 15px;margin:10px 0;border-top:1px solid #f2f2f2;border-bottom:1px solid #f2f2f2;box-shadow:inset 0 1px 0 rgba(255,255,255,.1), 0 1px 0 rgba(255,255,255,.1);} .navbar-inverse .nav-collapse .navbar-form,.navbar-inverse .nav-collapse .navbar-search{border-top-color:#111111;border-bottom-color:#111111;} .navbar .nav-collapse .nav.pull-right{float:none;margin-left:0;} .nav-collapse,.nav-collapse.collapse{overflow:hidden;height:0;} .navbar .btn-navbar{display:block;} .navbar-static .navbar-inner{padding-left:10px;padding-right:10px;}}@media (min-width:980px){.nav-collapse.collapse{height:auto !important;overflow:visible !important;}}
/*!
 * Bootstrap v2.2.1
 *
 * Copyright 2012 Twitter, Inc
 * Licensed under the Apache License v2.0
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Designed and built with all the love in the world @twitter by @mdo and @fat.
 */
.clearfix {
    *zoom: 1;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
    line-height: 0;
}

.clearfix:after {
    clear: both;
}

.hide-text {
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0;
}

.input-block-level {
    display: block;
    width: 100%;
    min-height: 30px;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.navbar {
    overflow: visible;
    /*margin-bottom: 20px;*/
    color: #777777;
    *position: relative;
    *z-index: 2;
}

.navbar-inner {
    min-height: 40px;
    padding: 0 10px;
    background-color: #FAFAFA;
    background-image: linear-gradient(to bottom, #FFFFFF, #F2F2F2);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff', endColorstr='#fff2f2f2', GradientType=0);
    border: 1px solid #D4D4D4;
    border-radius: 3px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.065);
    *zoom: 1;
}

.navbar-inner:before,
.navbar-inner:after {
    display: table;
    content: "";
    line-height: 0;
}

.navbar-inner:after {
    clear: both;
}

.navbar .container {
    width: auto;
}

.nav-collapse.collapse {
    height: auto;
    overflow: visible;
}

.navbar .brand {
    float: left;
    display: block;
    padding: 4px 20px;
    margin-left: -20px;
    font-size: 20px;
    font-weight: 200;
    color: #777777;
    text-shadow: 0 1px 0 #FFFFFF;
}

.navbar .brand .svg_icon {
    line-height: 30px;
    margin-right: 20px;
}

.navbar .brand:hover {
    text-decoration: none;
}

.navbar-text {
    margin-bottom: 0;
    line-height: 40px;
}

.navbar-link {
    color: #777777;
}

.navbar-link:hover {
    color: #333333;
}

.navbar .divider-vertical {
    height: 40px;
    margin: 0 9px;
    border-left: 1px solid #F2F2F2;
    border-right: 1px solid #FFFFFF;
}

.navbar .btn,
.navbar .btn-group {
    margin-top: 5px;
}

.navbar .btn-group .btn,
.navbar .input-prepend .btn,
.navbar .input-append .btn {
    margin-top: 0;
}

.navbar-form {
    margin-bottom: 0;
    *zoom: 1;
}

.navbar-form:before,
.navbar-form:after {
    display: table;
    content: "";
    line-height: 0;
}

.navbar-form:after {
    clear: both;
}

.navbar-form input,
.navbar-form select,
.navbar-form .radio,
.navbar-form .checkbox {
    margin-top: 5px;
}

.navbar-form input,
.navbar-form select,
.navbar-form .btn {
    display: inline-block;
    margin-bottom: 0;
}

.navbar-form input[type="image"],
.navbar-form input[type="checkbox"],
.navbar-form input[type="radio"] {
    margin-top: 3px;
}

.navbar-form .input-append,
.navbar-form .input-prepend {
    margin-top: 6px;
    white-space: nowrap;
}

.navbar-form .input-append input,
.navbar-form .input-prepend input {
    margin-top: 0;
}

.navbar-search {
    position: relative;
    float: left;
    margin-top: 5px;
    margin-bottom: 0;
}

.navbar-search .search-query {
    margin-bottom: 0;
    padding: 4px 14px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 13px;
    font-weight: normal;
    line-height: 1;
    border-radius: 15px;
}

.navbar-static-top {
    position: static;
    margin-bottom: 0;
}

.navbar-static-top .navbar-inner {
    border-radius: 0;
}

.navbar-fixed-top,
.navbar-fixed-bottom {
    position: fixed;
    right: 0;
    left: 0;
    z-index: 1030;
    margin-bottom: 0;
}

.navbar-fixed-top .navbar-inner,
.navbar-static-top .navbar-inner {
    border-width: 0 0 1px;
}

.navbar-fixed-bottom .navbar-inner {
    border-width: 1px 0 0;
}

.navbar-fixed-top .navbar-inner,
.navbar-fixed-bottom .navbar-inner {
    padding-left: 0;
    padding-right: 0;
    border-radius: 0;
}

.navbar-static-top .container,
.navbar-fixed-top .container,
.navbar-fixed-bottom .container {
    width: 940px;
}

.navbar-fixed-top {
    top: 0;
}

.navbar-fixed-top .navbar-inner,
.navbar-static-top .navbar-inner {
    box-shadow: 0 1px 10px rgba(0, 0, 0, .1);
}

.navbar-fixed-bottom {
    bottom: 0;
}

.navbar-fixed-bottom .navbar-inner {
    box-shadow: 0 -1px 10px rgba(0, 0, 0, .1);
}

.navbar .nav {
    position: relative;
    left: 0;
    display: block;
    float: left;
    margin: 0 10px 0 0;
}

.navbar .nav.pull-right {
    float: right;
    margin-right: 0;
}

.navbar .nav > li {
    float: left;

    &::first-letter {
        text-transform: capitalize;
    }
}

.navbar .nav > li > a {
    float: none;
    padding: 10px 15px 10px;
    color: #777777;
    text-decoration: none;
    text-shadow: 0 1px 0 #FFFFFF;
}

.navbar .nav .dropdown-toggle .caret {
    margin-top: 8px;
}

.navbar .nav > li > a:focus,
.navbar .nav > li > a:hover {
    cursor: pointer;
    background-color: transparent;
    color: #333333;
    text-decoration: none;
}

.navbar .nav > .active > a,
.navbar .nav > .active > a:hover,
.navbar .nav > .active > a:focus {
    color: #555555;
    text-decoration: none;
    background-color: #E5E5E5;
    box-shadow: inset 0 3px 8px rgba(0, 0, 0, 0.125);
}

.navbar .btn-navbar {
    display: none;
    float: right;
    padding: 7px 10px;
    margin-left: 5px;
    margin-right: 5px;
    color: #FFFFFF;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
    background-color: #EDEDED;
    background-image: linear-gradient(to bottom, #F2F2F2, #E5E5E5);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff2f2f2', endColorstr='#ffe5e5e5', GradientType=0);
    border-color: #E5E5E5 #E5E5E5 #BFBFBF;
    border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
    *background-color: #E5E5E5;
    /* Darken IE7 buttons by default so they stand out more given they won't have borders */

    filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .075);
}

.navbar .btn-navbar:hover,
.navbar .btn-navbar:active,
.navbar .btn-navbar.active,
.navbar .btn-navbar.disabled,
.navbar .btn-navbar[disabled] {
    color: #FFFFFF;
    background-color: #E5E5E5;
    *background-color: #D9D9D9;
}

.navbar .btn-navbar:active,
.navbar .btn-navbar.active {
    background-color: #CCCCCC \\9;
}

.navbar .btn-navbar .icon-bar {
    display: block;
    width: 18px;
    height: 2px;
    background-color: #F5F5F5;
    border-radius: 1px;
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);
}

.btn-navbar .icon-bar + .icon-bar {
    margin-top: 3px;
}

.navbar .nav > li > .dropdown-menu:before {
    content: '';
    display: inline-block;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid #CCCCCC;
    border-bottom-color: rgba(0, 0, 0, 0.2);
    position: absolute;
    top: -7px;
    left: 9px;
}

.navbar .nav > li > .dropdown-menu:after {
    content: '';
    display: inline-block;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #FFFFFF;
    position: absolute;
    top: -6px;
    left: 10px;
}

.navbar-fixed-bottom .nav > li > .dropdown-menu:before {
    border-top: 7px solid #CCCCCC;
    border-top-color: rgba(0, 0, 0, 0.2);
    border-bottom: 0;
    bottom: -7px;
    top: auto;
}

.navbar-fixed-bottom .nav > li > .dropdown-menu:after {
    border-top: 6px solid #FFFFFF;
    border-bottom: 0;
    bottom: -6px;
    top: auto;
}

.navbar .nav li.dropdown.open > .dropdown-toggle,
.navbar .nav li.dropdown.active > .dropdown-toggle,
.navbar .nav li.dropdown.open.active > .dropdown-toggle {
    background-color: #E5E5E5;
    color: #555555;
}

.navbar .nav li.dropdown > .dropdown-toggle .caret {
    border-top-color: #777777;
    border-bottom-color: #777777;
}

.navbar .nav li.dropdown.open > .dropdown-toggle .caret,
.navbar .nav li.dropdown.active > .dropdown-toggle .caret,
.navbar .nav li.dropdown.open.active > .dropdown-toggle .caret {
    border-top-color: #555555;
    border-bottom-color: #555555;
}

.navbar .pull-right > li > .dropdown-menu,
.navbar .nav > li > .dropdown-menu.pull-right {
    left: auto;
    right: 0;
}

.navbar .pull-right > li > .dropdown-menu:before,
.navbar .nav > li > .dropdown-menu.pull-right:before {
    left: auto;
    right: 12px;
}

.navbar .pull-right > li > .dropdown-menu:after,
.navbar .nav > li > .dropdown-menu.pull-right:after {
    left: auto;
    right: 13px;
}

.navbar .pull-right > li > .dropdown-menu .dropdown-menu,
.navbar .nav > li > .dropdown-menu.pull-right .dropdown-menu {
    left: auto;
    right: 100%;
    margin-left: 0;
    margin-right: -1px;
    border-radius: 6px 0 6px 6px;
}

.navbar-inverse {
    color: #999999;
}

.navbar-inverse .navbar-inner {
    background-color: #1B1B1B;
    background-image: linear-gradient(to bottom, #222222, #111111);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff222222', endColorstr='#ff111111', GradientType=0);
    border-color: #252525;
}

.navbar-inverse .brand,
.navbar-inverse .nav > li > a {
    color: #999999;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
}

.navbar-inverse .brand:hover,
.navbar-inverse .nav > li > a:hover {
    color: #FFFFFF;
}

.navbar-inverse .nav > li > a:focus,
.navbar-inverse .nav > li > a:hover {
    background-color: transparent;
    color: #FFFFFF;
}

.navbar-inverse .nav .active > a,
.navbar-inverse .nav .active > a:hover,
.navbar-inverse .nav .active > a:focus {
    color: #FFFFFF;
    background-color: #111111;
}

.navbar-inverse .navbar-link {
    color: #999999;
}

.navbar-inverse .navbar-link:hover {
    color: #FFFFFF;
}

.navbar-inverse .divider-vertical {
    border-left-color: #111111;
    border-right-color: #222222;
}

.navbar-inverse .nav li.dropdown.open > .dropdown-toggle,
.navbar-inverse .nav li.dropdown.active > .dropdown-toggle,
.navbar-inverse .nav li.dropdown.open.active > .dropdown-toggle {
    background-color: #111111;
    color: #FFFFFF;
}

.navbar-inverse .nav li.dropdown > .dropdown-toggle .caret {
    border-top-color: #999999;
    border-bottom-color: #999999;
}

.navbar-inverse .nav li.dropdown.open > .dropdown-toggle .caret,
.navbar-inverse .nav li.dropdown.active > .dropdown-toggle .caret,
.navbar-inverse .nav li.dropdown.open.active > .dropdown-toggle .caret {
    border-top-color: #FFFFFF;
    border-bottom-color: #FFFFFF;
}

.navbar-inverse .navbar-search .search-query {
    color: #FFFFFF;
    background-color: #515151;
    border-color: #111111;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1), 0 1px 0 rgba(255, 255, 255, .15);
    transition: none;
}

.navbar-inverse .navbar-search .search-query:-moz-placeholder {
    color: #CCCCCC;
}

.navbar-inverse .navbar-search .search-query:-ms-input-placeholder {
    color: #CCCCCC;
}

.navbar-inverse .navbar-search .search-query::-webkit-input-placeholder {
    color: #CCCCCC;
}

.navbar-inverse .navbar-search .search-query:focus,
.navbar-inverse .navbar-search .search-query.focused {
    padding: 5px 15px;
    color: #333333;
    text-shadow: 0 1px 0 #FFFFFF;
    background-color: #FFFFFF;
    border: 0;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);
    outline: 0;
}

.navbar-inverse .btn-navbar {
    color: #FFFFFF;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);
    background-color: #0E0E0E;
    background-image: linear-gradient(to bottom, #151515, #040404);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff151515', endColorstr='#ff040404', GradientType=0);
    border-color: #040404 #040404 #000000;
    border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);
    *background-color: #040404;
    /* Darken IE7 buttons by default so they stand out more given they won't have borders */

    filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);
}

.navbar-inverse .btn-navbar:hover,
.navbar-inverse .btn-navbar:active,
.navbar-inverse .btn-navbar.active,
.navbar-inverse .btn-navbar.disabled,
.navbar-inverse .btn-navbar[disabled] {
    color: #FFFFFF;
    *background-color: #000000;
}

.navbar-inverse .btn-navbar:active,
.navbar-inverse .btn-navbar.active {
    background-color: #000000 \\9;
}
/*!
 * Bootstrap v2.2.1
 *
 * Copyright 2012 Twitter, Inc
 * Licensed under the Apache License v2.0
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Designed and built with all the love in the world @twitter by @mdo and @fat.
 */
.clearfix {
    *zoom: 1;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
    line-height: 0;
}

.clearfix:after {
    clear: both;
}

.hide-text {
    font: 0/0 a;
    color: transparent;
    text-shadow: none;
    background-color: transparent;
    border: 0;
}

.input-block-level {
    display: block;
    width: 100%;
    min-height: 30px;
    box-sizing: border-box;
}

.nav {
    margin-left: 0;
    margin-bottom: 20px;
    list-style: none;
}

.nav > li > a {
    display: block;
}

.nav > li > a:hover {
    text-decoration: none;
    background-color: #EEEEEE;
}

.nav > .pull-right {
    float: right;
}

.nav-header {
    display: block;
    padding: 3px 15px;
    font-size: 11px;
    font-weight: bold;
    line-height: 20px;
    color: #999999;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
    text-transform: uppercase;
}

.nav li + .nav-header {
    margin-top: 9px;
}

.nav-list {
    padding-left: 15px;
    padding-right: 15px;
    margin-bottom: 0;
}

.nav-list > li > a,
.nav-list .nav-header {
    margin-left: -15px;
    margin-right: -15px;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
}

.nav-list > li > a {
    padding: 3px 15px;
}

.nav-list > .active > a,
.nav-list > .active > a:hover {
    color: #FFFFFF;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.2);
    background-color: #0088CC;
}

.nav-list [class^="icon-"],
.nav-list [class*=" icon-"] {
    margin-right: 2px;
}

.nav-list .divider {
    *width: 100%;
    height: 1px;
    margin: 9px 1px;
    *margin: -5px 0 5px;
    overflow: hidden;
    background-color: #E5E5E5;
    border-bottom: 1px solid #FFFFFF;
}

.nav-tabs,
.nav-pills {
    *zoom: 1;
}

.nav-tabs:before,
.nav-pills:before,
.nav-tabs:after,
.nav-pills:after {
    display: table;
    content: "";
    line-height: 0;
}

.nav-tabs:after,
.nav-pills:after {
    clear: both;
}

.nav-tabs > li,
.nav-pills > li {
    float: left;
}

.nav-tabs > li > a,
.nav-pills > li > a {
    padding-right: 12px;
    padding-left: 12px;
    /*margin-right: 2px;*/
    line-height: 14px;
}

.nav-tabs {
    border-bottom: 1px solid #DDDDDD;
}

.nav-tabs > li {
    margin-bottom: -1px;
}

.nav-tabs > li > a {
    padding-top: 8px;
    padding-bottom: 8px;
    line-height: 20px;
    border: 1px solid transparent;
    border-radius: 4px 4px 0 0;
}

.nav-tabs > li > a:hover {
    border-color: #EEEEEE #EEEEEE #DDDDDD;
}

.nav-tabs > .active > a,
.nav-tabs > .active > a:hover {
    color: #555555;
    background-color: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-bottom-color: transparent;
    cursor: default;
}

.nav-pills > li > a {
    padding-top: 8px;
    padding-bottom: 8px;
    margin-top: 2px;
    margin-bottom: 2px;
    border-radius: 5px;
}

.nav-pills > .active > a,
.nav-pills > .active > a:hover {
    color: #FFFFFF;
    background-color: #0088CC;
}

.nav-stacked > li {
    float: none;
}

.nav-stacked > li > a {
    margin-right: 0;
}

.nav-tabs.nav-stacked {
    border-bottom: 0;
}

.nav-tabs.nav-stacked > li > a {
    border: 1px solid #DDDDDD;
    border-radius: 0;
}

.nav-tabs.nav-stacked > li:first-child > a {
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
}

.nav-tabs.nav-stacked > li:last-child > a {
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
}

.nav-tabs.nav-stacked > li > a:hover {
    border-color: #DDDDDD;
    z-index: 2;
}

.nav-pills.nav-stacked > li > a {
    margin-bottom: 3px;
}

.nav-pills.nav-stacked > li:last-child > a {
    margin-bottom: 1px;
}

.nav-tabs .dropdown-menu {
    border-radius: 0 0 6px 6px;
}

.nav-pills .dropdown-menu {
    border-radius: 6px;
}

.nav .dropdown-toggle .caret {
    border-top-color: #0088CC;
    border-bottom-color: #0088CC;
    margin-top: 6px;
}

.nav .dropdown-toggle:hover .caret {
    border-top-color: #005580;
    border-bottom-color: #005580;
}

/* move down carets for tabs */
.nav-tabs .dropdown-toggle .caret {
    margin-top: 8px;
}

.nav .active .dropdown-toggle .caret {
    border-top-color: #FFFFFF;
    border-bottom-color: #FFFFFF;
}

.nav-tabs .active .dropdown-toggle .caret {
    border-top-color: #555555;
    border-bottom-color: #555555;
}

.nav > .dropdown.active > a:hover {
    cursor: pointer;
}

.nav-tabs .open .dropdown-toggle,
.nav-pills .open .dropdown-toggle,
.nav > li.dropdown.open.active > a:hover {
    color: #FFFFFF;
    background-color: #999999;
    border-color: #999999;
}

.nav li.dropdown.open .caret,
.nav li.dropdown.open.active .caret,
.nav li.dropdown.open a:hover .caret {
    border-top-color: #FFFFFF;
    border-bottom-color: #FFFFFF;
    opacity: 1;
    filter: alpha(opacity=100);
}

.tabs-stacked .open > a:hover {
    border-color: #999999;
}

.tabbable {
    *zoom: 1;
}

.tabbable:before,
.tabbable:after {
    display: table;
    content: "";
    line-height: 0;
}

.tabbable:after {
    clear: both;
}

.tab-content {
    overflow: auto;
}

.tabs-below > .nav-tabs,
.tabs-right > .nav-tabs,
.tabs-left > .nav-tabs {
    border-bottom: 0;
}

.tab-content > .tab-pane,
.pill-content > .pill-pane {
    display: none;
}

.tab-content > .active,
.pill-content > .active {
    display: block;
}

.tabs-below > .nav-tabs {
    border-top: 1px solid #DDDDDD;
}

.tabs-below > .nav-tabs > li {
    margin-top: -1px;
    margin-bottom: 0;
}

.tabs-below > .nav-tabs > li > a {
    border-radius: 0 0 4px 4px;
}

.tabs-below > .nav-tabs > li > a:hover {
    border-bottom-color: transparent;
    border-top-color: #DDDDDD;
}

.tabs-below > .nav-tabs > .active > a,
.tabs-below > .nav-tabs > .active > a:hover {
    border-color: transparent #DDDDDD #DDDDDD #DDDDDD;
}

.tabs-left > .nav-tabs > li,
.tabs-right > .nav-tabs > li {
    float: none;
}

.tabs-left > .nav-tabs > li > a,
.tabs-right > .nav-tabs > li > a {
    min-width: 74px;
    margin-right: 0;
    margin-bottom: 3px;
}

.tabs-left > .nav-tabs {
    float: left;
    margin-right: 19px;
    border-right: 1px solid #DDDDDD;
}

.tabs-left > .nav-tabs > li > a {
    margin-right: -1px;
    border-radius: 4px 0 0 4px;
}

.tabs-left > .nav-tabs > li > a:hover {
    border-color: #EEEEEE #DDDDDD #EEEEEE #EEEEEE;
}

.tabs-left > .nav-tabs .active > a,
.tabs-left > .nav-tabs .active > a:hover {
    border-color: #DDDDDD transparent #DDDDDD #DDDDDD;
    *border-right-color: #FFFFFF;
}

.tabs-right > .nav-tabs {
    float: right;
    margin-left: 19px;
    border-left: 1px solid #DDDDDD;
}

.tabs-right > .nav-tabs > li > a {
    margin-left: -1px;
    border-radius: 0 4px 4px 0;
}

.tabs-right > .nav-tabs > li > a:hover {
    border-color: #EEEEEE #EEEEEE #EEEEEE #DDDDDD;
}

.tabs-right > .nav-tabs .active > a,
.tabs-right > .nav-tabs .active > a:hover {
    border-color: #DDDDDD #DDDDDD #DDDDDD transparent;
    *border-left-color: #FFFFFF;
}

.nav > .disabled > a {
    color: #999999;
}

.nav > .disabled > a:hover {
    text-decoration: none;
    background-color: transparent;
    cursor: default;
}
/*! jQuery UI - v1.10.1 - 2013-02-25
* http://jqueryui.com
* Includes: jquery.ui.core.css, jquery.ui.resizable.css, jquery.ui.selectable.css, jquery.ui.accordion.css, jquery.ui.autocomplete.css, jquery.ui.button.css, jquery.ui.datepicker.css, jquery.ui.dialog.css, jquery.ui.menu.css, jquery.ui.progressbar.css, jquery.ui.slider.css, jquery.ui.spinner.css, jquery.ui.tabs.css, jquery.ui.tooltip.css
* To view and modify this theme, visit http://jqueryui.com/themeroller/?ffDefault=Verdana%2CArial%2Csans-serif&fwDefault=normal&fsDefault=1.1em&cornerRadius=4px&bgColorHeader=cccccc&bgTextureHeader=highlight_soft&bgImgOpacityHeader=75&borderColorHeader=aaaaaa&fcHeader=222222&iconColorHeader=222222&bgColorContent=ffffff&bgTextureContent=flat&bgImgOpacityContent=75&borderColorContent=aaaaaa&fcContent=222222&iconColorContent=222222&bgColorDefault=e6e6e6&bgTextureDefault=glass&bgImgOpacityDefault=75&borderColorDefault=d3d3d3&fcDefault=555555&iconColorDefault=888888&bgColorHover=dadada&bgTextureHover=glass&bgImgOpacityHover=75&borderColorHover=999999&fcHover=212121&iconColorHover=454545&bgColorActive=ffffff&bgTextureActive=glass&bgImgOpacityActive=65&borderColorActive=aaaaaa&fcActive=212121&iconColorActive=454545&bgColorHighlight=fbf9ee&bgTextureHighlight=glass&bgImgOpacityHighlight=55&borderColorHighlight=fcefa1&fcHighlight=363636&iconColorHighlight=2e83ff&bgColorError=fef1ec&bgTextureError=glass&bgImgOpacityError=95&borderColorError=cd0a0a&fcError=cd0a0a&iconColorError=cd0a0a&bgColorOverlay=aaaaaa&bgTextureOverlay=flat&bgImgOpacityOverlay=0&opacityOverlay=30&bgColorShadow=aaaaaa&bgTextureShadow=flat&bgImgOpacityShadow=0&opacityShadow=30&thicknessShadow=8px&offsetTopShadow=-8px&offsetLeftShadow=-8px&cornerRadiusShadow=8px
* Copyright (c) 2013 jQuery Foundation and other contributors Licensed MIT */

/* Layout helpers
----------------------------------*/
.ui-helper-hidden {
    display: none;
}

.ui-helper-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}

.ui-helper-reset {
    margin: 0;
    padding: 0;
    border: 0;
    outline: 0;
    line-height: 1.3;
    text-decoration: none;
    font-size: 100%;
    list-style: none;
}

.ui-helper-clearfix:before,
.ui-helper-clearfix:after {
    content: "";
    display: table;
    border-collapse: collapse;
}

.ui-helper-clearfix:after {
    clear: both;
}

.ui-helper-clearfix {
    min-height: 0; /* support: IE7 */
}

.ui-helper-zfix {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    position: absolute;
    opacity: 0;
    filter: Alpha(Opacity=0);
}

.ui-front {
    z-index: 100;
}


/* Interaction Cues
----------------------------------*/
.ui-state-disabled {
    cursor: default !important;
}


/* Icons
----------------------------------*/

/* states and images */
.ui-icon {
    display: block;
    text-indent: -99999px;
    overflow: hidden;
    background-repeat: no-repeat;
}


/* Misc visuals
----------------------------------*/

/* Overlays */
.ui-widget-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.ui-resizable {
    position: relative;
}

.ui-resizable-handle {
    position: absolute;
    font-size: 0.1px;
    display: block;
}

.ui-resizable-disabled .ui-resizable-handle,
.ui-resizable-autohide .ui-resizable-handle {
    display: none;
}

.ui-resizable-n {
    cursor: n-resize;
    height: 7px;
    width: 100%;
    top: -5px;
    left: 0;
}

.ui-resizable-s {
    cursor: s-resize;
    height: 7px;
    width: 100%;
    bottom: -5px;
    left: 0;
}

.ui-resizable-e {
    cursor: e-resize;
    width: 7px;
    right: -5px;
    top: 0;
    height: 100%;
}

.ui-resizable-w {
    cursor: w-resize;
    width: 7px;
    left: -5px;
    top: 0;
    height: 100%;
}

.ui-resizable-se {
    cursor: se-resize;
    width: 12px;
    height: 12px;
    right: 1px;
    bottom: 1px;
}

.ui-resizable-sw {
    cursor: sw-resize;
    width: 9px;
    height: 9px;
    left: -5px;
    bottom: -5px;
}

.ui-resizable-nw {
    cursor: nw-resize;
    width: 9px;
    height: 9px;
    left: -5px;
    top: -5px;
}

.ui-resizable-ne {
    cursor: ne-resize;
    width: 9px;
    height: 9px;
    right: -5px;
    top: -5px;
}

.ui-selectable-helper {
    position: absolute;
    z-index: 100;
    border: 1px dotted black;
}

.ui-accordion .ui-accordion-header {
    display: block;
    cursor: pointer;
    position: relative;
    margin-top: 2px;
    padding: .5em .5em .5em .7em;
    min-height: 0; /* support: IE7 */
}

.ui-accordion .ui-accordion-icons {
    padding-left: 2.2em;
}

.ui-accordion .ui-accordion-noicons {
    padding-left: .7em;
}

.ui-accordion .ui-accordion-icons .ui-accordion-icons {
    padding-left: 2.2em;
}

.ui-accordion .ui-accordion-header .ui-accordion-header-icon {
    position: absolute;
    left: .5em;
    top: 50%;
    margin-top: -8px;
}

.ui-accordion .ui-accordion-content {
    padding: 1em 2.2em;
    border-top: 0;
    overflow: auto;
}

.ui-autocomplete {
    position: absolute;
    top: 0;
    left: 0;
    cursor: default;
}

.ui-button {
    display: inline-block;
    position: relative;
    padding: 0;
    line-height: normal;
    margin-right: .1em;
    cursor: pointer;
    vertical-align: middle;
    text-align: center;
    overflow: visible; /* removes extra width in IE */
}

.ui-button,
.ui-button:link,
.ui-button:visited,
.ui-button:hover,
.ui-button:active {
    text-decoration: none;
}

/* to make room for the icon, a width needs to be set here */
.ui-button-icon-only {
    width: 2.2em;
}

/* button elements seem to need a little more width */
button.ui-button-icon-only {
    width: 2.4em;
}

.ui-button-icons-only {
    width: 3.4em;
}

button.ui-button-icons-only {
    width: 3.7em;
}

/* button text element */
.ui-button .ui-button-text {
    display: block;
    line-height: normal;
}

.ui-button-text-only .ui-button-text {
    padding: .4em 1em;
}

.ui-button-icon-only .ui-button-text,
.ui-button-icons-only .ui-button-text {
    padding: .4em;
    text-indent: -9999999px;
}

.ui-button-text-icon-primary .ui-button-text,
.ui-button-text-icons .ui-button-text {
    padding: .4em 1em .4em 2.1em;
}

.ui-button-text-icon-secondary .ui-button-text,
.ui-button-text-icons .ui-button-text {
    padding: .4em 2.1em .4em 1em;
}

.ui-button-text-icons .ui-button-text {
    padding-left: 2.1em;
    padding-right: 2.1em;
}

/* no icon support for input elements, provide padding by default */
input.ui-button {
    padding: .4em 1em;
}

/* button icon element(s) */
.ui-button-icon-only .ui-icon,
.ui-button-text-icon-primary .ui-icon,
.ui-button-text-icon-secondary .ui-icon,
.ui-button-text-icons .ui-icon,
.ui-button-icons-only .ui-icon {
    position: absolute;
    top: 50%;
    margin-top: -8px;
}

.ui-button-icon-only .ui-icon {
    left: 50%;
    margin-left: -8px;
}

.ui-button-text-icon-primary .ui-button-icon-primary,
.ui-button-text-icons .ui-button-icon-primary,
.ui-button-icons-only .ui-button-icon-primary {
    left: .5em;
}

.ui-button-text-icon-secondary .ui-button-icon-secondary,
.ui-button-text-icons .ui-button-icon-secondary,
.ui-button-icons-only .ui-button-icon-secondary {
    right: .5em;
}

/* button sets */
.ui-buttonset {
    margin-right: 7px;
}

.ui-buttonset .ui-button {
    margin-left: 0;
    margin-right: -.3em;
}

/* workarounds */
/* reset extra padding in Firefox, see h5bp.com/l */
input.ui-button::-moz-focus-inner,
button.ui-button::-moz-focus-inner {
    border: 0;
    padding: 0;
}

.ui-datepicker {
    width: 17em;
    padding: .2em .2em 0;
    display: none;
}

.ui-datepicker .ui-datepicker-header {
    position: relative;
    padding: .2em 0;
}

.ui-datepicker .ui-datepicker-prev,
.ui-datepicker .ui-datepicker-next {
    position: absolute;
    top: 2px;
    width: 1.8em;
    height: 1.8em;
}

.ui-datepicker .ui-datepicker-prev-hover,
.ui-datepicker .ui-datepicker-next-hover {
    top: 1px;
}

.ui-datepicker .ui-datepicker-prev {
    left: 2px;
}

.ui-datepicker .ui-datepicker-next {
    right: 2px;
}

.ui-datepicker .ui-datepicker-prev-hover {
    left: 1px;
}

.ui-datepicker .ui-datepicker-next-hover {
    right: 1px;
}

.ui-datepicker .ui-datepicker-prev span,
.ui-datepicker .ui-datepicker-next span {
    display: block;
    position: absolute;
    left: 50%;
    margin-left: -8px;
    top: 50%;
    margin-top: -8px;
}

.ui-datepicker .ui-datepicker-title {
    margin: 0 2.3em;
    line-height: 1.8em;
    text-align: center;
}

.ui-datepicker .ui-datepicker-title select {
    font-size: 1em;
    margin: 1px 0;
}

.ui-datepicker select.ui-datepicker-month-year {
    width: 100%;
}

.ui-datepicker select.ui-datepicker-month,
.ui-datepicker select.ui-datepicker-year {
    width: 49%;
}

.ui-datepicker table {
    width: 100%;
    font-size: .9em;
    border-collapse: collapse;
    margin: 0 0 .4em;
}

.ui-datepicker th {
    padding: .7em .3em;
    text-align: center;
    font-weight: bold;
    border: 0;
}

.ui-datepicker td {
    border: 0;
    padding: 1px;
}

.ui-datepicker td span,
.ui-datepicker td a {
    display: block;
    padding: .2em;
    text-align: right;
    text-decoration: none;
}

.ui-datepicker .ui-datepicker-buttonpane {
    background-image: none;
    margin: .7em 0 0 0;
    padding: 0 .2em;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
}

.ui-datepicker .ui-datepicker-buttonpane button {
    float: right;
    margin: .5em .2em .4em;
    cursor: pointer;
    padding: .2em .6em .3em .6em;
    width: auto;
    overflow: visible;
}

.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current {
    float: left;
}

/* with multiple calendars */
.ui-datepicker.ui-datepicker-multi {
    width: auto;
}

.ui-datepicker-multi .ui-datepicker-group {
    float: left;
}

.ui-datepicker-multi .ui-datepicker-group table {
    width: 95%;
    margin: 0 auto .4em;
}

.ui-datepicker-multi-2 .ui-datepicker-group {
    width: 50%;
}

.ui-datepicker-multi-3 .ui-datepicker-group {
    width: 33.3%;
}

.ui-datepicker-multi-4 .ui-datepicker-group {
    width: 25%;
}

.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header,
.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header {
    border-left-width: 0;
}

.ui-datepicker-multi .ui-datepicker-buttonpane {
    clear: left;
}

.ui-datepicker-row-break {
    clear: both;
    width: 100%;
    font-size: 0;
}

/* RTL support */
.ui-datepicker-rtl {
    direction: rtl;
}

.ui-datepicker-rtl .ui-datepicker-prev {
    right: 2px;
    left: auto;
}

.ui-datepicker-rtl .ui-datepicker-next {
    left: 2px;
    right: auto;
}

.ui-datepicker-rtl .ui-datepicker-prev:hover {
    right: 1px;
    left: auto;
}

.ui-datepicker-rtl .ui-datepicker-next:hover {
    left: 1px;
    right: auto;
}

.ui-datepicker-rtl .ui-datepicker-buttonpane {
    clear: right;
}

.ui-datepicker-rtl .ui-datepicker-buttonpane button {
    float: left;
}

.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current,
.ui-datepicker-rtl .ui-datepicker-group {
    float: right;
}

.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header,
.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header {
    border-right-width: 0;
    border-left-width: 1px;
}

.ui-dialog {
    position: absolute;
    top: 0;
    left: 0;
    padding: .2em;
    outline: 0;
}

.ui-dialog .ui-dialog-titlebar {
    padding: .4em 1em;
    position: relative;
}

.ui-dialog .ui-dialog-title {
    float: left;
    margin: .1em 0;
    white-space: nowrap;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ui-dialog .ui-dialog-titlebar-close {
    position: absolute;
    right: .3em;
    top: 50%;
    width: 21px;
    margin: -10px 0 0 0;
    padding: 1px;
    height: 20px;
}

.ui-dialog .ui-dialog-content {
    position: relative;
    border: 0;
    padding: .5em 1em;
    background: none;
    overflow: auto;
}

.ui-dialog .ui-dialog-buttonpane {
    text-align: left;
    border-width: 1px 0 0 0;
    background-image: none;
    margin-top: .5em;
    padding: .3em 1em .5em .4em;
}

.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {
    float: right;
}

.ui-dialog .ui-dialog-buttonpane button {
    margin: .5em .4em .5em 0;
    cursor: pointer;
}

.ui-dialog .ui-resizable-se {
    width: 12px;
    height: 12px;
    right: -5px;
    bottom: -5px;
    background-position: 16px 16px;
}

.ui-draggable .ui-dialog-titlebar {
    cursor: move;
}

.ui-menu {
    list-style: none;
    padding: 2px;
    margin: 0;
    display: block;
    outline: none;
}

.ui-menu .ui-menu {
    margin-top: -3px;
    position: absolute;
}

.ui-menu .ui-menu-item {
    margin: 0;
    padding: 0;
    width: 100%;
}

.ui-menu .ui-menu-divider {
    margin: 5px -2px 5px -2px;
    height: 0;
    font-size: 0;
    line-height: 0;
    border-width: 1px 0 0 0;
}

.ui-menu .ui-menu-item a {
    text-decoration: none;
    display: block;
    padding: 2px .4em;
    line-height: 1.5;
    min-height: 0; /* support: IE7 */
    font-weight: normal;
}

.ui-menu .ui-menu-item a.ui-state-focus,
.ui-menu .ui-menu-item a.ui-state-active {
    font-weight: normal;
    margin: -1px;
}

.ui-menu .ui-state-disabled {
    font-weight: normal;
    margin: .4em 0 .2em;
    line-height: 1.5;
}

.ui-menu .ui-state-disabled a {
    cursor: default;
}

/* icon support */
.ui-menu-icons {
    position: relative;
}

.ui-menu-icons .ui-menu-item a {
    position: relative;
    padding-left: 2em;
}

/* left-aligned */
.ui-menu .ui-icon {
    position: absolute;
    top: .2em;
    left: .2em;
}

/* right-aligned */
.ui-menu .ui-menu-icon {
    position: static;
    float: right;
}

.ui-progressbar {
    height: 2em;
    text-align: left;
    overflow: hidden;
}

.ui-progressbar .ui-progressbar-value {
    margin: -1px;
    height: 100%;
}

.ui-progressbar .ui-progressbar-overlay {
    background: url(/images/jquery-ui/animated-overlay.gif);
    height: 100%;
    filter: alpha(opacity=25);
    opacity: 0.25;
}

.ui-progressbar-indeterminate .ui-progressbar-value {
    background-image: none;
}

.ui-slider {
    position: relative;
    text-align: left;
}

.ui-slider .ui-slider-handle {
    position: absolute;
    z-index: 2;
    width: 1.2em;
    height: 1.2em;
    cursor: default;
}

.ui-slider .ui-slider-range {
    position: absolute;
    z-index: 1;
    font-size: .7em;
    display: block;
    border: 0;
    background-position: 0 0;
}

/* For IE8 - See #6727 */
.ui-slider.ui-state-disabled .ui-slider-handle,
.ui-slider.ui-state-disabled .ui-slider-range {
    filter: inherit;
}

.ui-slider-horizontal {
    height: .8em;
}

.ui-slider-horizontal .ui-slider-handle {
    top: -.3em;
    margin-left: -.6em;
}

.ui-slider-horizontal .ui-slider-range {
    top: 0;
    height: 100%;
}

.ui-slider-horizontal .ui-slider-range-min {
    left: 0;
}

.ui-slider-horizontal .ui-slider-range-max {
    right: 0;
}

.ui-slider-vertical {
    width: .8em;
    height: 100px;
}

.ui-slider-vertical .ui-slider-handle {
    left: -.3em;
    margin-left: 0;
    margin-bottom: -.6em;
}

.ui-slider-vertical .ui-slider-range {
    left: 0;
    width: 100%;
}

.ui-slider-vertical .ui-slider-range-min {
    bottom: 0;
}

.ui-slider-vertical .ui-slider-range-max {
    top: 0;
}

.ui-spinner {
    position: relative;
    display: inline-block;
    overflow: hidden;
    padding: 0;
    vertical-align: middle;
}

.ui-spinner-input {
    border: none;
    background: none;
    color: inherit;
    padding: 0;
    margin: .2em 0;
    vertical-align: middle;
    margin-left: .4em;
    margin-right: 22px;
}

.ui-spinner-button {
    width: 16px;
    height: 50%;
    font-size: .5em;
    padding: 0;
    margin: 0;
    text-align: center;
    position: absolute;
    cursor: default;
    display: block;
    overflow: hidden;
    right: 0;
}

/* more specificity required here to overide default borders */
.ui-spinner a.ui-spinner-button {
    border-top: none;
    border-bottom: none;
    border-right: none;
}

/* vertical centre icon */
.ui-spinner .ui-icon {
    position: absolute;
    margin-top: -8px;
    top: 50%;
    left: 0;
}

.ui-spinner-up {
    top: 0;
}

.ui-spinner-down {
    bottom: 0;
}

/* TR overrides */
.ui-spinner .ui-icon-triangle-1-s {
    /* need to fix icons sprite */
    background-position: -65px -16px;
}

.ui-tabs {
    position: relative; /* position: relative prevents IE scroll bug (element with position: relative inside container with overflow: auto appear as "fixed") */
    padding: .2em;
}

.ui-tabs .ui-tabs-nav {
    margin: 0;
    padding: .2em .2em 0;
}

.ui-tabs .ui-tabs-nav li {
    list-style: none;
    float: left;
    position: relative;
    top: 0;
    margin: 1px .2em 0 0;
    border-bottom: 0;
    padding: 0;
    white-space: nowrap;
}

.ui-tabs .ui-tabs-nav li a {
    float: left;
    padding: .5em 1em;
    text-decoration: none;
}

.ui-tabs .ui-tabs-nav li.ui-tabs-active {
    margin-bottom: -1px;
    padding-bottom: 1px;
}

.ui-tabs .ui-tabs-nav li.ui-tabs-active a,
.ui-tabs .ui-tabs-nav li.ui-state-disabled a,
.ui-tabs .ui-tabs-nav li.ui-tabs-loading a {
    cursor: text;
}

.ui-tabs .ui-tabs-nav li a, /* first selector in group seems obsolete, but required to overcome bug in Opera applying cursor: text overall if defined elsewhere... */
.ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-active a {
    cursor: pointer;
}

.ui-tabs .ui-tabs-panel {
    display: block;
    border-width: 0;
    padding: 1em 1.4em;
    background: none;
}

.ui-tooltip {
    padding: 8px;
    position: absolute;
    z-index: 9999;
    max-width: 300px;
    box-shadow: 0 0 5px #AAAAAA;
}

body .ui-tooltip {
    border-width: 2px;
}

/* Component containers
----------------------------------*/
.ui-widget {
    font-family: Verdana, Arial, sans-serif;
    font-size: 1.1em;
}

.ui-widget .ui-widget {
    font-size: 1em;
}

.ui-widget input,
.ui-widget select,
.ui-widget textarea,
.ui-widget button {
    font-family: Verdana, Arial, sans-serif;
    font-size: 1em;
}

.ui-widget-content {
    border: 1px solid #AAAAAA;
    background: #FFFFFF url(/images/jquery-ui/ui-bg_flat_75_ffffff_40x100.png) 50% 50% repeat-x;
    color: #222222;
}

.ui-widget-content a {
    color: #222222;
}

.ui-widget-header {
    border: rgb(255, 255, 255);
    color: #222222;
    font-weight: bold;
}

.ui-widget-header a {
    color: #222222;
}

/* Interaction states
----------------------------------*/
.ui-state-default,
.ui-widget-content .ui-state-default,
.ui-widget-header .ui-state-default {
    /* border: 1px solid #FAFAFA; */
    /* background: #FAFAFA; */
    font-weight: normal;
    color: #555555;
}

.ui-state-default a,
.ui-state-default a:link,
.ui-state-default a:visited {
    color: #555555;
    text-decoration: none;
}

.ui-state-hover,
.ui-widget-content .ui-state-hover,
.ui-widget-header .ui-state-hover,
.ui-state-focus,
.ui-widget-content .ui-state-focus,
.ui-widget-header .ui-state-focus {
    border: 1px solid #999999;
    background: #DADADA url(/images/jquery-ui/ui-bg_glass_75_dadada_1x400.png) 50% 50% repeat-x;
    font-weight: normal;
    color: #212121;
}

.ui-state-hover a,
.ui-state-hover a:hover,
.ui-state-hover a:link,
.ui-state-hover a:visited {
    color: #212121;
    text-decoration: none;
}

.ui-state-active,
.ui-widget-content .ui-state-active,
.ui-widget-header .ui-state-active {
    border: 1px solid #AAAAAA;
    background: #FFFFFF url(/images/jquery-ui/ui-bg_glass_65_ffffff_1x400.png) 50% 50% repeat-x;
    font-weight: normal;
    color: #212121;
}

.ui-state-active a,
.ui-state-active a:link,
.ui-state-active a:visited {
    color: #212121;
    text-decoration: none;
}

/* Interaction Cues
----------------------------------*/
.ui-state-highlight,
.ui-widget-content .ui-state-highlight,
.ui-widget-header .ui-state-highlight {
    border: 1px solid #FCEFA1;
    background: #FBF9EE url(/images/jquery-ui/ui-bg_glass_55_fbf9ee_1x400.png) 50% 50% repeat-x;
    color: #363636;
}

.ui-state-highlight a,
.ui-widget-content .ui-state-highlight a,
.ui-widget-header .ui-state-highlight a {
    color: #363636;
}

.ui-state-error,
.ui-widget-content .ui-state-error,
.ui-widget-header .ui-state-error {
    border: 1px solid #CD0A0A;
    background: #FEF1EC url(/images/jquery-ui/ui-bg_glass_95_fef1ec_1x400.png) 50% 50% repeat-x;
    color: #CD0A0A;
}

.ui-state-error a,
.ui-widget-content .ui-state-error a,
.ui-widget-header .ui-state-error a {
    color: #CD0A0A;
}

.ui-state-error-text,
.ui-widget-content .ui-state-error-text,
.ui-widget-header .ui-state-error-text {
    color: #CD0A0A;
}

.ui-priority-primary,
.ui-widget-content .ui-priority-primary,
.ui-widget-header .ui-priority-primary {
    font-weight: bold;
}

.ui-priority-secondary,
.ui-widget-content .ui-priority-secondary,
.ui-widget-header .ui-priority-secondary {
    opacity: .7;
    filter: Alpha(Opacity=70);
    font-weight: normal;
}

.ui-state-disabled,
.ui-widget-content .ui-state-disabled,
.ui-widget-header .ui-state-disabled {
    opacity: .35;
    filter: Alpha(Opacity=35);
    background-image: none;
}

.ui-state-disabled .ui-icon {
    filter: Alpha(Opacity=35); /* For IE8 - See #6059 */
}

/* Icons
----------------------------------*/

/* states and images */
.ui-icon {
    width: 16px;
    height: 16px;
    background-position: 16px 16px;
}

.ui-icon,
.ui-widget-content .ui-icon {
    background-image: url(/images/jquery-ui/ui-icons_222222_256x240.png);
}

.ui-widget-header .ui-icon {
    background-image: url(/images/jquery-ui/ui-icons_222222_256x240.png);
}

.ui-state-default .ui-icon {
    background-image: url(/images/jquery-ui/ui-icons_888888_256x240.png);
}

.ui-state-hover .ui-icon,
.ui-state-focus .ui-icon {
    background-image: url(/images/jquery-ui/ui-icons_454545_256x240.png);
}

.ui-state-active .ui-icon {
    background-image: url(/images/jquery-ui/ui-icons_454545_256x240.png);
}

.ui-state-highlight .ui-icon {
    background-image: url(/images/jquery-ui/ui-icons_2e83ff_256x240.png);
}

.ui-state-error .ui-icon,
.ui-state-error-text .ui-icon {
    background-image: url(/images/jquery-ui/ui-icons_cd0a0a_256x240.png);
}

/* positioning */
.ui-icon-carat-1-n {
    background-position: 0 0;
}

.ui-icon-carat-1-ne {
    background-position: -16px 0;
}

.ui-icon-carat-1-e {
    background-position: -32px 0;
}

.ui-icon-carat-1-se {
    background-position: -48px 0;
}

.ui-icon-carat-1-s {
    background-position: -64px 0;
}

.ui-icon-carat-1-sw {
    background-position: -80px 0;
}

.ui-icon-carat-1-w {
    background-position: -96px 0;
}

.ui-icon-carat-1-nw {
    background-position: -112px 0;
}

.ui-icon-carat-2-n-s {
    background-position: -128px 0;
}

.ui-icon-carat-2-e-w {
    background-position: -144px 0;
}

.ui-icon-triangle-1-n {
    background-position: 0 -16px;
}

.ui-icon-triangle-1-ne {
    background-position: -16px -16px;
}

.ui-icon-triangle-1-e {
    background-position: -32px -16px;
}

.ui-icon-triangle-1-se {
    background-position: -48px -16px;
}

.ui-icon-triangle-1-s {
    background-position: -64px -16px;
}

.ui-icon-triangle-1-sw {
    background-position: -80px -16px;
}

.ui-icon-triangle-1-w {
    background-position: -96px -16px;
}

.ui-icon-triangle-1-nw {
    background-position: -112px -16px;
}

.ui-icon-triangle-2-n-s {
    background-position: -128px -16px;
}

.ui-icon-triangle-2-e-w {
    background-position: -144px -16px;
}

.ui-icon-arrow-1-n {
    background-position: 0 -32px;
}

.ui-icon-arrow-1-ne {
    background-position: -16px -32px;
}

.ui-icon-arrow-1-e {
    background-position: -32px -32px;
}

.ui-icon-arrow-1-se {
    background-position: -48px -32px;
}

.ui-icon-arrow-1-s {
    background-position: -64px -32px;
}

.ui-icon-arrow-1-sw {
    background-position: -80px -32px;
}

.ui-icon-arrow-1-w {
    background-position: -96px -32px;
}

.ui-icon-arrow-1-nw {
    background-position: -112px -32px;
}

.ui-icon-arrow-2-n-s {
    background-position: -128px -32px;
}

.ui-icon-arrow-2-ne-sw {
    background-position: -144px -32px;
}

.ui-icon-arrow-2-e-w {
    background-position: -160px -32px;
}

.ui-icon-arrow-2-se-nw {
    background-position: -176px -32px;
}

.ui-icon-arrowstop-1-n {
    background-position: -192px -32px;
}

.ui-icon-arrowstop-1-e {
    background-position: -208px -32px;
}

.ui-icon-arrowstop-1-s {
    background-position: -224px -32px;
}

.ui-icon-arrowstop-1-w {
    background-position: -240px -32px;
}

.ui-icon-arrowthick-1-n {
    background-position: 0 -48px;
}

.ui-icon-arrowthick-1-ne {
    background-position: -16px -48px;
}

.ui-icon-arrowthick-1-e {
    background-position: -32px -48px;
}

.ui-icon-arrowthick-1-se {
    background-position: -48px -48px;
}

.ui-icon-arrowthick-1-s {
    background-position: -64px -48px;
}

.ui-icon-arrowthick-1-sw {
    background-position: -80px -48px;
}

.ui-icon-arrowthick-1-w {
    background-position: -96px -48px;
}

.ui-icon-arrowthick-1-nw {
    background-position: -112px -48px;
}

.ui-icon-arrowthick-2-n-s {
    background-position: -128px -48px;
}

.ui-icon-arrowthick-2-ne-sw {
    background-position: -144px -48px;
}

.ui-icon-arrowthick-2-e-w {
    background-position: -160px -48px;
}

.ui-icon-arrowthick-2-se-nw {
    background-position: -176px -48px;
}

.ui-icon-arrowthickstop-1-n {
    background-position: -192px -48px;
}

.ui-icon-arrowthickstop-1-e {
    background-position: -208px -48px;
}

.ui-icon-arrowthickstop-1-s {
    background-position: -224px -48px;
}

.ui-icon-arrowthickstop-1-w {
    background-position: -240px -48px;
}

.ui-icon-arrowreturnthick-1-w {
    background-position: 0 -64px;
}

.ui-icon-arrowreturnthick-1-n {
    background-position: -16px -64px;
}

.ui-icon-arrowreturnthick-1-e {
    background-position: -32px -64px;
}

.ui-icon-arrowreturnthick-1-s {
    background-position: -48px -64px;
}

.ui-icon-arrowreturn-1-w {
    background-position: -64px -64px;
}

.ui-icon-arrowreturn-1-n {
    background-position: -80px -64px;
}

.ui-icon-arrowreturn-1-e {
    background-position: -96px -64px;
}

.ui-icon-arrowreturn-1-s {
    background-position: -112px -64px;
}

.ui-icon-arrowrefresh-1-w {
    background-position: -128px -64px;
}

.ui-icon-arrowrefresh-1-n {
    background-position: -144px -64px;
}

.ui-icon-arrowrefresh-1-e {
    background-position: -160px -64px;
}

.ui-icon-arrowrefresh-1-s {
    background-position: -176px -64px;
}

.ui-icon-arrow-4 {
    background-position: 0 -80px;
}

.ui-icon-arrow-4-diag {
    background-position: -16px -80px;
}

.ui-icon-extlink {
    background-position: -32px -80px;
}

.ui-icon-newwin {
    background-position: -48px -80px;
}

.ui-icon-refresh {
    background-position: -64px -80px;
}

.ui-icon-shuffle {
    background-position: -80px -80px;
}

.ui-icon-transfer-e-w {
    background-position: -96px -80px;
}

.ui-icon-transferthick-e-w {
    background-position: -112px -80px;
}

.ui-icon-folder-collapsed {
    background-position: 0 -96px;
}

.ui-icon-folder-open {
    background-position: -16px -96px;
}

.ui-icon-document {
    background-position: -32px -96px;
}

.ui-icon-document-b {
    background-position: -48px -96px;
}

.ui-icon-note {
    background-position: -64px -96px;
}

.ui-icon-mail-closed {
    background-position: -80px -96px;
}

.ui-icon-mail-open {
    background-position: -96px -96px;
}

.ui-icon-suitcase {
    background-position: -112px -96px;
}

.ui-icon-comment {
    background-position: -128px -96px;
}

.ui-icon-person {
    background-position: -144px -96px;
}

.ui-icon-print {
    background-position: -160px -96px;
}

.ui-icon-trash {
    background-position: -176px -96px;
}

.ui-icon-locked {
    background-position: -192px -96px;
}

.ui-icon-unlocked {
    background-position: -208px -96px;
}

.ui-icon-bookmark {
    background-position: -224px -96px;
}

.ui-icon-tag {
    background-position: -240px -96px;
}

.ui-icon-home {
    background-position: 0 -112px;
}

.ui-icon-flag {
    background-position: -16px -112px;
}

.ui-icon-calendar {
    background-position: -32px -112px;
}

.ui-icon-cart {
    background-position: -48px -112px;
}

.ui-icon-pencil {
    background-position: -64px -112px;
}

.ui-icon-clock {
    background-position: -80px -112px;
}

.ui-icon-disk {
    background-position: -96px -112px;
}

.ui-icon-calculator {
    background-position: -112px -112px;
}

.ui-icon-zoomin {
    background-position: -128px -112px;
}

.ui-icon-zoomout {
    background-position: -144px -112px;
}

.ui-icon-search {
    background-position: -160px -112px;
}

.ui-icon-wrench {
    background-position: -176px -112px;
}

.ui-icon-gear {
    background-position: -192px -112px;
}

.ui-icon-heart {
    background-position: -208px -112px;
}

.ui-icon-star {
    background-position: -224px -112px;
}

.ui-icon-link {
    background-position: -240px -112px;
}

.ui-icon-cancel {
    background-position: 0 -128px;
}

.ui-icon-plus {
    background-position: -16px -128px;
}

.ui-icon-plusthick {
    background-position: -32px -128px;
}

.ui-icon-minus {
    background-position: -48px -128px;
}

.ui-icon-minusthick {
    background-position: -64px -128px;
}

.ui-icon-close {
    background-position: -80px -128px;
}

.ui-icon-closethick {
    background-position: -96px -128px;
}

.ui-icon-key {
    background-position: -112px -128px;
}

.ui-icon-lightbulb {
    background-position: -128px -128px;
}

.ui-icon-scissors {
    background-position: -144px -128px;
}

.ui-icon-clipboard {
    background-position: -160px -128px;
}

.ui-icon-copy {
    background-position: -176px -128px;
}

.ui-icon-contact {
    background-position: -192px -128px;
}

.ui-icon-image {
    background-position: -208px -128px;
}

.ui-icon-video {
    background-position: -224px -128px;
}

.ui-icon-script {
    background-position: -240px -128px;
}

.ui-icon-alert {
    background-position: 0 -144px;
}

.ui-icon-info {
    background-position: -16px -144px;
}

.ui-icon-notice {
    background-position: -32px -144px;
}

.ui-icon-help {
    background-position: -48px -144px;
}

.ui-icon-check {
    background-position: -64px -144px;
}

.ui-icon-bullet {
    background-position: -80px -144px;
}

.ui-icon-radio-on {
    background-position: -96px -144px;
}

.ui-icon-radio-off {
    background-position: -112px -144px;
}

.ui-icon-pin-w {
    background-position: -128px -144px;
}

.ui-icon-pin-s {
    background-position: -144px -144px;
}

.ui-icon-play {
    background-position: 0 -160px;
}

.ui-icon-pause {
    background-position: -16px -160px;
}

.ui-icon-seek-next {
    background-position: -32px -160px;
}

.ui-icon-seek-prev {
    background-position: -48px -160px;
}

.ui-icon-seek-end {
    background-position: -64px -160px;
}

.ui-icon-seek-start {
    background-position: -80px -160px;
}

/* ui-icon-seek-first is deprecated, use ui-icon-seek-start instead */
.ui-icon-seek-first {
    background-position: -80px -160px;
}

.ui-icon-stop {
    background-position: -96px -160px;
}

.ui-icon-eject {
    background-position: -112px -160px;
}

.ui-icon-volume-off {
    background-position: -128px -160px;
}

.ui-icon-volume-on {
    background-position: -144px -160px;
}

.ui-icon-power {
    background-position: 0 -176px;
}

.ui-icon-signal-diag {
    background-position: -16px -176px;
}

.ui-icon-signal {
    background-position: -32px -176px;
}

.ui-icon-battery-0 {
    background-position: -48px -176px;
}

.ui-icon-battery-1 {
    background-position: -64px -176px;
}

.ui-icon-battery-2 {
    background-position: -80px -176px;
}

.ui-icon-battery-3 {
    background-position: -96px -176px;
}

.ui-icon-circle-plus {
    background-position: 0 -192px;
}

.ui-icon-circle-minus {
    background-position: -16px -192px;
}

.ui-icon-circle-close {
    background-position: -32px -192px;
}

.ui-icon-circle-triangle-e {
    background-position: -48px -192px;
}

.ui-icon-circle-triangle-s {
    background-position: -64px -192px;
}

.ui-icon-circle-triangle-w {
    background-position: -80px -192px;
}

.ui-icon-circle-triangle-n {
    background-position: -96px -192px;
}

.ui-icon-circle-arrow-e {
    background-position: -112px -192px;
}

.ui-icon-circle-arrow-s {
    background-position: -128px -192px;
}

.ui-icon-circle-arrow-w {
    background-position: -144px -192px;
}

.ui-icon-circle-arrow-n {
    background-position: -160px -192px;
}

.ui-icon-circle-zoomin {
    background-position: -176px -192px;
}

.ui-icon-circle-zoomout {
    background-position: -192px -192px;
}

.ui-icon-circle-check {
    background-position: -208px -192px;
}

.ui-icon-circlesmall-plus {
    background-position: 0 -208px;
}

.ui-icon-circlesmall-minus {
    background-position: -16px -208px;
}

.ui-icon-circlesmall-close {
    background-position: -32px -208px;
}

.ui-icon-squaresmall-plus {
    background-position: -48px -208px;
}

.ui-icon-squaresmall-minus {
    background-position: -64px -208px;
}

.ui-icon-squaresmall-close {
    background-position: -80px -208px;
}

.ui-icon-grip-dotted-vertical {
    background-position: 0 -224px;
}

.ui-icon-grip-dotted-horizontal {
    background-position: -16px -224px;
}

.ui-icon-grip-solid-vertical {
    background-position: -32px -224px;
}

.ui-icon-grip-solid-horizontal {
    background-position: -48px -224px;
}

.ui-icon-gripsmall-diagonal-se {
    background-position: -64px -224px;
}

.ui-icon-grip-diagonal-se {
    background-position: -80px -224px;
}


/* Misc visuals
----------------------------------*/

/* Corner radius */
.ui-corner-all,
.ui-corner-top,
.ui-corner-left,
.ui-corner-tl {
    border-top-left-radius: 4px;
}

.ui-corner-all,
.ui-corner-top,
.ui-corner-right,
.ui-corner-tr {
    border-top-right-radius: 4px;
}

.ui-corner-all,
.ui-corner-bottom,
.ui-corner-left,
.ui-corner-bl {
    border-bottom-left-radius: 4px;
}

.ui-corner-all,
.ui-corner-bottom,
.ui-corner-right,
.ui-corner-br {
    border-bottom-right-radius: 4px;
}

/* Overlays */
.ui-widget-overlay {
    background: #AAAAAA url(/images/jquery-ui/ui-bg_flat_0_aaaaaa_40x100.png) 50% 50% repeat-x;
    opacity: .3;
    filter: Alpha(Opacity=30);
}

.ui-widget-shadow {
    margin: -8px 0 0 -8px;
    padding: 8px;
    background: #AAAAAA url(/images/jquery-ui/ui-bg_flat_0_aaaaaa_40x100.png) 50% 50% repeat-x;
    opacity: .3;
    filter: Alpha(Opacity=30);
    border-radius: 8px;
}
.ui-timepicker-div .ui-widget-header {
    margin-bottom: 8px;
}

.ui-timepicker-div dl {
    text-align: left;
}

.ui-timepicker-div dl dt {
    float: left;
    clear: left;
    padding: 0 0 0 5px;
}

.ui-timepicker-div dl dd {
    margin: 0 10px 10px 40%;
}

.ui-timepicker-div td {
    font-size: 90%;
}

.ui-tpicker-grid-label {
    background: none;
    border: none;
    margin: 0;
    padding: 0;
}

.ui-timepicker-div .ui_tpicker_unit_hide {
    display: none;
}

.ui-timepicker-div .ui_tpicker_time .ui_tpicker_time_input {
    background: none;
    color: inherit;
    border: none;
    outline: none;
    border-bottom: solid 1px #555555;
    width: 95%;
}

.ui-timepicker-div .ui_tpicker_time .ui_tpicker_time_input:focus {
    border-bottom-color: #AAAAAA;
}

.ui-timepicker-rtl {
    direction: rtl;
}

.ui-timepicker-rtl dl {
    text-align: right;
    padding: 0 5px 0 0;
}

.ui-timepicker-rtl dl dt {
    float: right;
    clear: right;
}

.ui-timepicker-rtl dl dd {
    margin: 0 40% 10px 10px;
}

/* Shortened version style */
.ui-timepicker-div.ui-timepicker-oneLine {
    padding-right: 2px;
}

.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_time,
.ui-timepicker-div.ui-timepicker-oneLine dt {
    display: none;
}

.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_time_label {
    display: block;
    padding-top: 2px;
}

.ui-timepicker-div.ui-timepicker-oneLine dl {
    text-align: right;
}

.ui-timepicker-div.ui-timepicker-oneLine dl dd,
.ui-timepicker-div.ui-timepicker-oneLine dl dd > div {
    display: inline-block;
    margin: 0;
}

.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_minute:before,
.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_second:before {
    content: ':';
    display: inline-block;
}

.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_millisec:before,
.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_microsec:before {
    content: '.';
    display: inline-block;
}

.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_unit_hide,
.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_unit_hide:before {
    display: none;
}

.ui-slider-handle {
    background: #DADADA !important;
}
/*
 * Table
 */
table.dataTable {
    clear: both;
    width: 100%;
    border-collapse: collapse;
    margin: 15px auto 0;
}

table.dataTable thead th {
    cursor: pointer;
    *cursor: hand;
}


table.dataTable th.align-right {
    text-align: right;
}

table.dataTable th.align-center {
    text-align: center;
}

table.dataTable tfoot th {
    padding: 3px 10px;
}

table.dataTable td {
    padding: 10px;
    border: 0;
}

table.dataTable td.table-icon {
    color: #8BC53F;
    font-size: 12px;
}

table.dataTable td.align-right {
    text-align: right;
}

table.dataTable td.align-center {
    text-align: center;
}

table.dataTable td.control.center {
    width: 50px;
}

table.dataTable td.center,
table.dataTable td.dataTables_empty {
    text-align: -webkit-center;
}

table.dataTable tr.odd:hover {
    color: #5CBB35;
}

table.dataTable tr.odd:hover td.table-icon {
    color: #5CBB35;
}

table.dataTable tr.even:hover {
    color: #5CBB35;
}

table.dataTable tr.even:hover td.table-icon {
    color: #5CBB35;
}

table.dataTable tr.odd {
    background-color: #F2F2F2;
    border-bottom: #E5E5E5 solid 1px;
}

table.dataTable tr.odd.checked {
    background-color: #8BC53F;
    color: white;
}

table.dataTable tr.odd.checked td a {
    color: white;
}

table.dataTable tr.odd.checked td.table-icon {
    color: white;
}

table.dataTable tr.odd.checked td div.circle {
    background-color: white !important;
}

table.dataTable tr.even {
    background-color: white;
    border-bottom: #E5E5E5 solid 1px;
}

table.dataTable tr.even.checked td a {
    color: white;
}

table.dataTable tr.even.checked {
    background-color: #8BC53F;
    color: white;
}

table.dataTable tr.even.checked td.table-icon {
    color: white;
}

table.dataTable tr.even.checked td div.circle {
    background-color: white !important;
}

table.dataTable tr.odd td.sorting_1 {
    background-color: #F2F2F2;
}

table.dataTable tr.odd.checked td.sorting_1 {
    background-color: #8BC53F;
}

table.dataTable tr.odd td.sorting_2 {
    background-color: #EEF4FD;
}

table.dataTable tr.odd.checked td.sorting_2 {
    background-color: #8BC53F;
}

table.dataTable tr.odd td.sorting_3 {
    background-color: #EEF4FD;
}

table.dataTable tr.odd.checked td.sorting_3 {
    background-color: #8BC53F;
}

table.dataTable tr.even td.sorting_1 {
    background-color: white;
}

table.dataTable tr.even.checked td.sorting_1 {
    background-color: #8BC53F;
}

table.dataTable tr.even td.sorting_2 {
    background-color: white;
}

table.dataTable tr.even.checked td.sorting_2 {
    background-color: #8BC53F;
}

table.dataTable tr.even td.sorting_3 {
    background-color: white;
}

table.dataTable tr.even.checked td.sorting_3 {
    background-color: #8BC53F;
}

/*
 * Table wrapper
 */
.dataTables_wrapper {
    margin: 10px;
    position: relative;
    clear: both;
    *zoom: 1;
}

.dataTables_wrapper .ui-widget-header {
    font-weight: normal;
}

.dataTables_wrapper .ui-toolbar {
    padding: 5px;
}


/*
 * Page length menu
 */
.dataTables_length {
    height: 32px;
    margin-bottom: 15px;
    float: right;
    margin-left: 20px;
    margin-right: 10px;
}

.dataTables_length select {
    height: 24px;
    border: solid 1px #BBBBBB;
    border-radius: 4px;
    margin: 0;
}

/*
 * Filter
 */
.dataTables_filter {
    height: 32px;
    margin-bottom: 15px;
    float: right;
    text-align: right;
}

.dataTables_filter label input {
    margin-left: 5px;
    height: 20px;
    border: solid 1px #BBBBBB;
    border-radius: 4px;
    padding-left: 4px;
}

.dataTables_filter label, .dataTables_length label {
    font-size: 1em;
}

/*
 * Table information
 */
.dataTables_info {
    margin-top: 15px;
    padding-top: 3px;
    clear: both;
    float: left;
}

/*
 * Table inner details # to complete
 */
div.tableInnerDetails {
    display: block;
}

table.dataTable.details {
    padding-left: 50px;
    border-collapse: collapse;
    border-spacing: 0;
    font-size: 1.3em;
}

table.dataTable.details td {
    border: 0;
}

.dataTables_toolbar {
    float: left;
    padding: 2px 6px;
    margin: 0;
    cursor: pointer;
    *cursor: hand;
    color: #333333 !important;
}

.toolbar .ui-button {
    padding: 2px 6px;
    margin: 0;
    cursor: pointer;
    *cursor: hand;
    color: #333333 !important;
}

/*
 * END CUSTOM
 */

/*
 * Pagination
 */
.dataTables_paginate {
    margin-top: 15px;
    float: right;
    text-align: right;
    color: #224C4F;
}

.dataTables_paginate .paginate_button {
    margin-right: -0.1em !important;
}

.paging_two_button .ui-button {
    float: left;
    cursor: pointer;
    *cursor: hand;
}

.paging_full_numbers .paginate_button {
    padding: 2px 6px;
    margin: 0;
    cursor: pointer;
    *cursor: hand;
    color: #333333 !important;
}

/* Full number pagination */
.paging_full_numbers a:active {
    outline: none
}

.paging_full_numbers a:hover {
    text-decoration: none;
}

.paging_full_numbers a.paginate_button,
.paging_full_numbers a.paginate_active {
    padding: 2px 5px;
    margin: 0 3px;
    cursor: pointer;
    *cursor: hand;
    color: #333333 !important;
}

.paging_full_numbers a.paginate_button:hover {
    text-decoration: underline;
}

.paging_full_numbers a.paginate_button.disabled,
.paging_full_numbers a.paginate_button.current {
    color: #999999 !important;
    text-decoration: none !important;
    cursor: default !important;
}

/*
 * Processing indicator
 */
.dataTables_processing {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 250px;
    height: 30px;
    margin-left: -125px;
    margin-top: -15px;
    padding: 14px 0 2px 0;
    border: 1px solid #DDDDDD;
    text-align: center;
    color: #999999;
    font-size: 14px;
    background-color: white;
}

/*
 * Sorting
 */
table.dataTable thead th div.DataTables_sort_wrapper {
    position: relative;
    padding-top: 5px;
    padding-right: 20px;
    font-weight: bold;
    color: #224C4F;
    font-size: 11px;
    text-transform: capitalize;
    margin-bottom: 5px;
}

table.dataTable thead th div.DataTables_sort_wrapper span {
    position: absolute;
    top: 66%;
    margin-top: -8px;
    right: 0;
}

table.dataTable th:active {
    outline: none;
}

/*
 * Scrolling
 */
.dataTables_scroll {
    clear: both;
}

.dataTables_scrollBody {
    *margin-top: -1px;
    -webkit-overflow-scrolling: touch;
}

/*
 * dataTables custom buttons
 */

nav[role="navigation"] li {
    float: left;
    margin: 0 0 10px 0;
    font-size: 14px;
}

nav[role="navigation"] li a {
    position: relative;
    float: left;
    padding: 5px 8px;
    cursor: pointer;
    *cursor: hand;
}

.table-activate-button, .table-discard-button, .table-reset-button {
    border: none;
    border-radius: 4px;
    color: white;
    font-size: .9em;
    height: 24px;
    margin-right: 4px !important;
    width: 48px;
}

.table-activate-button {
    background-color: #2DC937;
}

.table-discard-button {
    background-color: #CC3232;
}

.table-reset-button {
    background-color: #6EB3E3;
}
/*
 * File:        TableTools.css
 * Description: Styles for TableTools 2
 * Author:      Allan Jardine (www.sprymedia.co.uk)
 * Language:    Javascript
 * License:     GPL v2 / 3 point BSD
 * Project:     DataTables
 *
 * Copyright 2009-2012 Allan Jardine, all rights reserved.
 *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *
 * CSS name space:
 *   DTTT                  DataTables TableTools
 *
 * Style sheet provides:
 *   CONTAINER             TableTools container element and styles applying to all components
 *   BUTTON_STYLES         Action specific button styles
 *   SELECTING             Row selection styles
 *   COLLECTIONS           Drop down list (collection) styles
 *   PRINTING              Print display styles
 */


/*
 * CONTAINER
 * TableTools container element and styles applying to all components
 */
div.DTTT_container {
    position: relative;
    float: right;
    margin-bottom: 1em;
}

button.DTTT_button,
div.DTTT_button,
a.DTTT_button {
    position: relative;
    float: left;
    margin-right: 3px;
    padding: 5px 8px;
    border: 1px solid #999999;
    cursor: pointer;
    *cursor: hand;
    font-size: 0.88em;
    color: black !important;
    border-radius: 2px;
    -ms-box-shadow: 1px 1px 3px #CCCCCC;
    -o-box-shadow: 1px 1px 3px #CCCCCC;
    box-shadow: 1px 1px 3px #CCCCCC;

    /* Generated by http://www.colorzilla.com/gradient-editor/ */
    background: #FFFFFF; /* Old browsers */ /* Chrome10+,Safari5.1+ */ /* FF3.6+ */ /* IE10+ */ /* Opera 11.10+ */
    background: linear-gradient(to bottom, #FFFFFF 0%, #F3F3F3 89%, #F9F9F9 100%); /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#f9f9f9', GradientType=0); /* IE6-9 */
}


/* Buttons are cunning border-box sizing - we can't just use that for A and DIV due to IE6/7 */
button.DTTT_button {
    height: 30px;
    padding: 3px 8px;
}

.DTTT_button embed {
    outline: none;
}

button.DTTT_button:hover,
div.DTTT_button:hover,
a.DTTT_button:hover {
    border: 1px solid #666666;
    text-decoration: none !important;
    -ms-box-shadow: 1px 1px 3px #999999;
    -o-box-shadow: 1px 1px 3px #999999;
    box-shadow: 1px 1px 3px #999999;

    background: #F3F3F3; /* Old browsers */ /* Chrome10+,Safari5.1+ */ /* FF3.6+ */ /* IE10+ */ /* Opera 11.10+ */
    background: linear-gradient(to bottom, #F3F3F3 0%, #E2E2E2 89%, #F4F4F4 100%); /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f3f3f3', endColorstr='#f4f4f4', GradientType=0); /* IE6-9 */
}

button.DTTT_disabled,
div.DTTT_disabled,
a.DTTT_disabled {
    color: #999999;
    border: 1px solid #D0D0D0;

    background: #FFFFFF; /* Old browsers */ /* Chrome10+,Safari5.1+ */ /* FF3.6+ */ /* IE10+ */ /* Opera 11.10+ */
    background: linear-gradient(to bottom, #FFFFFF 0%, #F9F9F9 89%, #FAFAFA 100%); /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#fafafa', GradientType=0); /* IE6-9 */
}


/*
 * BUTTON_STYLES
 * Action specific button styles
 * If you want images - comment this back in

button.DTTT_button_csv,
button.DTTT_button_xls,
button.DTTT_button_copy,
button.DTTT_button_pdf,
button.DTTT_button_print {
	padding-right: 0;
}

button.DTTT_button_csv span,
button.DTTT_button_xls span,
button.DTTT_button_copy span,
button.DTTT_button_pdf span,
button.DTTT_button_print span {
	display: inline-block;
	height: 24px;
	line-height: 24px;
	padding-right: 30px;
}


button.DTTT_button_csv span { background: url(../images/csv.png) no-repeat bottom right; }
button.DTTT_button_csv:hover span { background: url(../images/csv_hover.png) no-repeat center right; }

button.DTTT_button_xls span { background: url(../images/xls.png) no-repeat center right; }
button.DTTT_button_xls:hover span { background: #f0f0f0 url(../images/xls_hover.png) no-repeat center right; }

button.DTTT_button_copy span { background: url(../images/copy.png) no-repeat center right; }
button.DTTT_button_copy:hover span { background: #f0f0f0 url(../images/copy_hover.png) no-repeat center right; }

button.DTTT_button_pdf span { background: url(../images/pdf.png) no-repeat center right; }
button.DTTT_button_pdf:hover span { background: #f0f0f0 url(../images/pdf_hover.png) no-repeat center right; }

button.DTTT_button_print span { background: url(../images/print.png) no-repeat center right; }
button.DTTT_button_print:hover span { background: #f0f0f0 url(../images/print_hover.png) no-repeat center right; }

 */

button.DTTT_button_collection span {
    padding-right: 17px;
    /*background: url(../images/collection.png) no-repeat center right;*/
}

button.DTTT_button_collection:hover span {
    padding-right: 17px;
    /*background: #f0f0f0 url(../images/collection_hover.png) no-repeat center right;*/
}


/*
* SELECTING
* Row selection styles
*/
table.DTTT_selectable tbody tr {
    cursor: pointer;
    *cursor: hand;
}

table.dataTable tr.DTTT_selected.odd {
    background-color: #9FAFD1;
}

table.dataTable tr.DTTT_selected.odd td.sorting_1 {
    background-color: #9FAFD1;
}

table.dataTable tr.DTTT_selected.odd td.sorting_2 {
    background-color: #9FAFD1;
}

table.dataTable tr.DTTT_selected.odd td.sorting_3 {
    background-color: #9FAFD1;
}


table.dataTable tr.DTTT_selected.even {
    background-color: #B0BED9;
}

table.dataTable tr.DTTT_selected.even td.sorting_1 {
    background-color: #B0BED9;
}

table.dataTable tr.DTTT_selected.even td.sorting_2 {
    background-color: #B0BED9;
}

table.dataTable tr.DTTT_selected.even td.sorting_3 {
    background-color: #B0BED9;
}


/*
 * COLLECTIONS
 * Drop down list (collection) styles
 */

div.DTTT_collection {
    width: 150px;
    padding: 8px 8px 4px 8px;
    border: 1px solid #CCCCCC;
    border: 1px solid rgba(0, 0, 0, 0.4);
    background-color: #F3F3F3;
    background-color: rgba(255, 255, 255, 0.3);
    overflow: hidden;
    z-index: 2002;
    border-radius: 5px;
    -ms-box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);
    -o-box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);
}

div.DTTT_collection_background {
    /*background: transparent url(../images/background.png) repeat top left;*/
    z-index: 2001;
}

div.DTTT_collection button.DTTT_button,
div.DTTT_collection div.DTTT_button,
div.DTTT_collection a.DTTT_button {
    position: relative;
    left: 0;
    right: 0;

    display: block;
    float: none;
    margin-bottom: 4px;
    -ms-box-shadow: 1px 1px 3px #999999;
    -o-box-shadow: 1px 1px 3px #999999;
    box-shadow: 1px 1px 3px #999999;
}


/*
* PRINTING
* Print display styles
*/

.DTTT_print_info {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 400px;
    height: 150px;
    margin-left: -200px;
    margin-top: -75px;
    text-align: center;
    color: #333333;
    padding: 10px 30px;

    background: #FFFFFF; /* Old browsers */ /* Chrome10+,Safari5.1+ */ /* FF3.6+ */ /* IE10+ */ /* Opera 11.10+ */
    background: linear-gradient(to bottom, #FFFFFF 0%, #F3F3F3 89%, #F9F9F9 100%); /* W3C */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#f9f9f9', GradientType=0); /* IE6-9 */

    opacity: 0.95;

    border: 1px solid black;
    border: 1px solid rgba(0, 0, 0, 0.5);
    border-radius: 6px;
    -ms-box-shadow: 0 3px 7px rgba(0, 0, 0, 0.5);
    -o-box-shadow: 0 3px 7px rgba(0, 0, 0, 0.5);
    box-shadow: 0 3px 7px rgba(0, 0, 0, 0.5);
}

.DTTT_print_info h6 {
    font-weight: normal;
    font-size: 28px;
    line-height: 28px;
    margin: 1em;
}

.DTTT_print_info p {
    font-size: 14px;
    line-height: 20px;
}
/*
 * File:        TableTools.css
 * Description: Styles for TableTools 2 with JUI theming
 * Author:      Allan Jardine (www.sprymedia.co.uk)
 * Language:    Javascript
 * License:     LGPL / 3 point BSD
 * Project:     DataTables
 *
 * Copyright 2010 Allan Jardine, all rights reserved.
 *
 * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 *
 * Notes:
 *   Generally speaking, please refer to the TableTools.css file - this file contains basic
 *   modifications to that 'master' stylesheet for ThemeRoller.
 *
 * CSS name space:
 *   DTTT                  DataTables TableTools
 *
 * Colour dictionary:
 *   Button border         #d0d0d0
 *   Button border hover   #999999
 *   Hover background      #f0f0f0
 *   Action blue           #4b66d9
 *
 * Style sheet provides:
 *   CONTAINER             TableTools container element and styles applying to all components
 *   SELECTING             Row selection styles
 *   COLLECTIONS           Drop down list (collection) styles
 *   PRINTING              Print display styles
 *   MISC                  Minor misc styles
 */

/*
 * CONTAINER
 * TableTools container element and styles applying to all components
 */
div.DTTT_container {
    position: relative;
    float: left;
}

.DTTT_button {
    position: relative;
    float: left;
    margin-right: 3px;
    padding: 3px 10px;
    border: 1px solid #D0D0D0;
    background-color: #FFFFFF;
    color: #333333 !important;
    cursor: pointer;
    *cursor: hand;
}

.DTTT_button::-moz-focus-inner {
    border: none !important;
    padding: 0;
}

/*
 * SELECTING
 * Row selection styles
 */
table.DTTT_selectable tbody tr {
    cursor: pointer;
    *cursor: hand;
}

table.dataTable tr.DTTT_selected.odd {
    background-color: #9FAFD1;
}

table.dataTable tr.DTTT_selected.odd td.sorting_1 {
    background-color: #9FAFD1;
}

table.dataTable tr.DTTT_selected.odd td.sorting_2 {
    background-color: #9FAFD1;
}

table.dataTable tr.DTTT_selected.odd td.sorting_3 {
    background-color: #9FAFD1;
}

table.dataTable tr.DTTT_selected.even {
    background-color: #B0BED9;
}

table.dataTable tr.DTTT_selected.even td.sorting_1 {
    background-color: #B0BED9;
}

table.dataTable tr.DTTT_selected.even td.sorting_2 {
    background-color: #B0BED9;
}

table.dataTable tr.DTTT_selected.even td.sorting_3 {
    background-color: #B0BED9;
}

/*
 * COLLECTIONS
 * Drop down list (collection) styles
 */

div.DTTT_collection {
    width: 150px;
    background-color: #F3F3F3;
    overflow: hidden;
    z-index: 2002;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
}

div.DTTT_collection_background {
    /*background: url(../images/background.png) repeat top left;*/
    z-index: 2001;
}

div.DTTT_collection button.DTTT_button,
div.DTTT_collection div.DTTT_button,
div.DTTT_collection a.DTTT_button {
    float: none;
    width: 100%;
    margin-bottom: -0.1em;
}

/*
* PRINTING
* Print display styles
*/

.DTTT_print_info {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 400px;
    height: 150px;
    margin-left: -200px;
    margin-top: -75px;
    text-align: center;
    background-color: #3F3F3F;
    color: white;
    padding: 10px 30px;

    opacity: 0.9;
    border-radius: 5px;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
}

.DTTT_print_info h6 {
    font-weight: normal;
    font-size: 28px;
    line-height: 28px;
    margin: 1em;
}

.DTTT_print_info p {
    font-size: 14px;
    line-height: 20px;
}

/*
 * MISC
 * Minor misc styles
 */

.DTTT_disabled {
    color: #999999;
}
/* Assets in alarms */

.alarm-integration-assets {
    margin-top: 10px;
    width: 100%;
    background: none;
    width: calc(100% - 25px);
}

.alarm-integration-assets .content {
    width: 100%;
    background-color: #E8E8E8;
    border-radius: 0 0 3px 3px;
    padding: 0px 10px 10px 10px;
}

.alarm-integration-assets .content #integration-assets {
    padding-top: 5px;
}

.alarm-integration-assets .content li {
    margin: 5px 0;
    float: left;
}

.alarm-integration-assets .content ul {
    list-style: none;
}

.alarm-integration-assets .title {
    width: 100%;
    font-size: 12px;
    border-radius: 3px 3px 0 0;
    background: #224C4F;
    text-align: left;
    color: white;
    font-weight: bold;
    padding: 10px;
}

.partner-title {
    font-weight: bold;
    padding-top: 5px;
}

.question-mark {
    display: inline-block;
    vertical-align: top;
}

.question-mark .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: #224C4F;
    color: #FFFFFF;
    text-align: center;
    border-radius: 3px;
    padding: 5px 2px;
    position: absolute;
    z-index: 15;
}

.question-mark:hover .tooltiptext {
    visibility: visible;
}

.truncated-text {
    max-width: 150px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inline-block;
}

/* Asset show */

.asset-settings .slider {
    left: auto;
}

.asset-settings .switch {
    position: initial;
}
._select_view {
    width: 200px;
}
.wise-layout a {
    color: #8BC53F;
    text-decoration: none;
}

.wise-layout a:hover {
    color: #8BC53F;
    text-decoration: underline;
}

.wise-layout .breadcrumb {
    padding: 7px 14px;
    margin: 0 0 18px;
    height: 18px;
    background-color: #FBFBFB;
    background-image: linear-gradient(to bottom, #FFFFFF, #F5F5F5);
    background-repeat: repeat-x;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#f5f5f5', GradientType=0);
    border: 1px solid #DDDDDD;
    border-radius: 3px;
    box-shadow: inset 0 1px 0 #FFFFFF;
}

.wise-layout .breadcrumb li {
    display: inline-block;
    text-shadow: 0 1px 0 #FFFFFF;
}

.wise-layout .breadcrumb .divider {
    padding: 0 5px;
    color: #999999;
}

.wise-layout .breadcrumb .active a {
    color: #333333;
}

.wise-layout #content-banner {
    margin: 20px;
    padding: 20px 20px;
    border-radius: 3px;
    background-color: #8BC53F;
    color: #224C4F;
    font-size: 14px;
}
/* Cal-HeatMap CSS */

.cal-heatmap-container {
    display: block;
}

.graph {
    font-family: "Lucida Grande", Lucida, Verdana, sans-serif;
}

.graph-label {
    fill: #999999;
    font-size: 10px
}

.graph, .graph-legend rect {
    shape-rendering: crispedges
}

.graph-rect {
    fill: #EDEDED
}

.graph-subdomain-group rect:hover {
    stroke: #000000;
    stroke-width: 1px
}

.subdomain-text {
    font-size: 8px;
    fill: #999999;
    pointer-events: none
}

.hover_cursor:hover {
    cursor: pointer
}

.qi {
    background-color: #999999;
    fill: #999999
}

/*
Remove comment to apply this style to date with value equal to 0
.q0
{
	background-color: #fff;
	fill: #fff;
	stroke: #ededed
}
*/

.q1 {
    background-color: #DAE289;
    fill: #DAE289
}

.q2 {
    background-color: #CEDB9C;
    fill: #9CC069
}

.q3 {
    background-color: #B5CF6B;
    fill: #669D45
}

.q4 {
    background-color: #637939;
    fill: #637939
}

.q5 {
    background-color: #3B6427;
    fill: #3B6427
}

rect.highlight {
    stroke: #444444;
    stroke-width: 1
}

text.highlight {
    fill: #444444
}

rect.now {
    stroke: red
}

text.now {
    fill: red;
    font-weight: 800
}

.domain-background {
    fill: none;
    shape-rendering: crispedges
}

.ch-tooltip {
    padding: 10px;
    background: #222222;
    color: #BBBBBB;
    font-size: 12px;
    line-height: 1.4;
    width: 140px;
    position: absolute;
    z-index: 99999 !important;
    text-align: center;
    border-radius: 2px;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);
    display: none;
    box-sizing: border-box;
}

.ch-tooltip::after {
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    content: "";
    padding: 0;
    display: "block";
    bottom: -6px;
    left: 50%;
    margin-left: -6px;
    border-width: 6px 6px 0;
    border-top-color: #222222;
}
.subdomain-text {
    font-size: 7px;
    fill: black;
}

.q0 {
    background-color: #EDEDED;
    fill: #EDEDED;
}

.q1 {
    background-color: #AAAAAA;
    fill: #AAAAAA;
}

.q2 {
    background-color: #4D7D9E;
    fill: #4D7D9E;
}

.q3 {
    background-color: #6EB3E3;
    fill: #6EB3E3;
}

.q4 {
    background-color: #A8D1EE;
    fill: #A8D1EE;
}

.q5 {
    background-color: #EF7C7E;
    fill: #EF7C7E;
}

.q6 {
    background-color: #E94547;
    fill: #E94547;
}
/*
 * This product includes color specifications and designs developed by Cynthia
 * Brewer (http://colorbrewer.org/).
 */
.YlGn .q0-3 {
    fill: rgb(247, 252, 185)
}

.YlGn .q1-3 {
    fill: rgb(173, 221, 142)
}

.YlGn .q2-3 {
    fill: rgb(49, 163, 84)
}

.YlGn .q0-4 {
    fill: rgb(255, 255, 204)
}

.YlGn .q1-4 {
    fill: rgb(194, 230, 153)
}

.YlGn .q2-4 {
    fill: rgb(120, 198, 121)
}

.YlGn .q3-4 {
    fill: rgb(35, 132, 67)
}

.YlGn .q0-5 {
    fill: rgb(255, 255, 204)
}

.YlGn .q1-5 {
    fill: rgb(194, 230, 153)
}

.YlGn .q2-5 {
    fill: rgb(120, 198, 121)
}

.YlGn .q3-5 {
    fill: rgb(49, 163, 84)
}

.YlGn .q4-5 {
    fill: rgb(0, 104, 55)
}

.YlGn .q0-6 {
    fill: rgb(255, 255, 204)
}

.YlGn .q1-6 {
    fill: rgb(217, 240, 163)
}

.YlGn .q2-6 {
    fill: rgb(173, 221, 142)
}

.YlGn .q3-6 {
    fill: rgb(120, 198, 121)
}

.YlGn .q4-6 {
    fill: rgb(49, 163, 84)
}

.YlGn .q5-6 {
    fill: rgb(0, 104, 55)
}

.YlGn .q0-7 {
    fill: rgb(255, 255, 204)
}

.YlGn .q1-7 {
    fill: rgb(217, 240, 163)
}

.YlGn .q2-7 {
    fill: rgb(173, 221, 142)
}

.YlGn .q3-7 {
    fill: rgb(120, 198, 121)
}

.YlGn .q4-7 {
    fill: rgb(65, 171, 93)
}

.YlGn .q5-7 {
    fill: rgb(35, 132, 67)
}

.YlGn .q6-7 {
    fill: rgb(0, 90, 50)
}

.YlGn .q0-8 {
    fill: rgb(255, 255, 229)
}

.YlGn .q1-8 {
    fill: rgb(247, 252, 185)
}

.YlGn .q2-8 {
    fill: rgb(217, 240, 163)
}

.YlGn .q3-8 {
    fill: rgb(173, 221, 142)
}

.YlGn .q4-8 {
    fill: rgb(120, 198, 121)
}

.YlGn .q5-8 {
    fill: rgb(65, 171, 93)
}

.YlGn .q6-8 {
    fill: rgb(35, 132, 67)
}

.YlGn .q7-8 {
    fill: rgb(0, 90, 50)
}

.YlGn .q0-9 {
    fill: rgb(255, 255, 229)
}

.YlGn .q1-9 {
    fill: rgb(247, 252, 185)
}

.YlGn .q2-9 {
    fill: rgb(217, 240, 163)
}

.YlGn .q3-9 {
    fill: rgb(173, 221, 142)
}

.YlGn .q4-9 {
    fill: rgb(120, 198, 121)
}

.YlGn .q5-9 {
    fill: rgb(65, 171, 93)
}

.YlGn .q6-9 {
    fill: rgb(35, 132, 67)
}

.YlGn .q7-9 {
    fill: rgb(0, 104, 55)
}

.YlGn .q8-9 {
    fill: rgb(0, 69, 41)
}

.YlGnBu .q0-3 {
    fill: rgb(237, 248, 177)
}

.YlGnBu .q1-3 {
    fill: rgb(127, 205, 187)
}

.YlGnBu .q2-3 {
    fill: rgb(44, 127, 184)
}

.YlGnBu .q0-4 {
    fill: rgb(255, 255, 204)
}

.YlGnBu .q1-4 {
    fill: rgb(161, 218, 180)
}

.YlGnBu .q2-4 {
    fill: rgb(65, 182, 196)
}

.YlGnBu .q3-4 {
    fill: rgb(34, 94, 168)
}

.YlGnBu .q0-5 {
    fill: rgb(255, 255, 204)
}

.YlGnBu .q1-5 {
    fill: rgb(161, 218, 180)
}

.YlGnBu .q2-5 {
    fill: rgb(65, 182, 196)
}

.YlGnBu .q3-5 {
    fill: rgb(44, 127, 184)
}

.YlGnBu .q4-5 {
    fill: rgb(37, 52, 148)
}

.YlGnBu .q0-6 {
    fill: rgb(255, 255, 204)
}

.YlGnBu .q1-6 {
    fill: rgb(199, 233, 180)
}

.YlGnBu .q2-6 {
    fill: rgb(127, 205, 187)
}

.YlGnBu .q3-6 {
    fill: rgb(65, 182, 196)
}

.YlGnBu .q4-6 {
    fill: rgb(44, 127, 184)
}

.YlGnBu .q5-6 {
    fill: rgb(37, 52, 148)
}

.YlGnBu .q0-7 {
    fill: rgb(255, 255, 204)
}

.YlGnBu .q1-7 {
    fill: rgb(199, 233, 180)
}

.YlGnBu .q2-7 {
    fill: rgb(127, 205, 187)
}

.YlGnBu .q3-7 {
    fill: rgb(65, 182, 196)
}

.YlGnBu .q4-7 {
    fill: rgb(29, 145, 192)
}

.YlGnBu .q5-7 {
    fill: rgb(34, 94, 168)
}

.YlGnBu .q6-7 {
    fill: rgb(12, 44, 132)
}

.YlGnBu .q0-8 {
    fill: rgb(255, 255, 217)
}

.YlGnBu .q1-8 {
    fill: rgb(237, 248, 177)
}

.YlGnBu .q2-8 {
    fill: rgb(199, 233, 180)
}

.YlGnBu .q3-8 {
    fill: rgb(127, 205, 187)
}

.YlGnBu .q4-8 {
    fill: rgb(65, 182, 196)
}

.YlGnBu .q5-8 {
    fill: rgb(29, 145, 192)
}

.YlGnBu .q6-8 {
    fill: rgb(34, 94, 168)
}

.YlGnBu .q7-8 {
    fill: rgb(12, 44, 132)
}

.YlGnBu .q0-9 {
    fill: rgb(255, 255, 217)
}

.YlGnBu .q1-9 {
    fill: rgb(237, 248, 177)
}

.YlGnBu .q2-9 {
    fill: rgb(199, 233, 180)
}

.YlGnBu .q3-9 {
    fill: rgb(127, 205, 187)
}

.YlGnBu .q4-9 {
    fill: rgb(65, 182, 196)
}

.YlGnBu .q5-9 {
    fill: rgb(29, 145, 192)
}

.YlGnBu .q6-9 {
    fill: rgb(34, 94, 168)
}

.YlGnBu .q7-9 {
    fill: rgb(37, 52, 148)
}

.YlGnBu .q8-9 {
    fill: rgb(8, 29, 88)
}

.GnBu .q0-3 {
    fill: rgb(224, 243, 219)
}

.GnBu .q1-3 {
    fill: rgb(168, 221, 181)
}

.GnBu .q2-3 {
    fill: rgb(67, 162, 202)
}

.GnBu .q0-4 {
    fill: rgb(240, 249, 232)
}

.GnBu .q1-4 {
    fill: rgb(186, 228, 188)
}

.GnBu .q2-4 {
    fill: rgb(123, 204, 196)
}

.GnBu .q3-4 {
    fill: rgb(43, 140, 190)
}

.GnBu .q0-5 {
    fill: rgb(240, 249, 232)
}

.GnBu .q1-5 {
    fill: rgb(186, 228, 188)
}

.GnBu .q2-5 {
    fill: rgb(123, 204, 196)
}

.GnBu .q3-5 {
    fill: rgb(67, 162, 202)
}

.GnBu .q4-5 {
    fill: rgb(8, 104, 172)
}

.GnBu .q0-6 {
    fill: rgb(240, 249, 232)
}

.GnBu .q1-6 {
    fill: rgb(204, 235, 197)
}

.GnBu .q2-6 {
    fill: rgb(168, 221, 181)
}

.GnBu .q3-6 {
    fill: rgb(123, 204, 196)
}

.GnBu .q4-6 {
    fill: rgb(67, 162, 202)
}

.GnBu .q5-6 {
    fill: rgb(8, 104, 172)
}

.GnBu .q0-7 {
    fill: rgb(240, 249, 232)
}

.GnBu .q1-7 {
    fill: rgb(204, 235, 197)
}

.GnBu .q2-7 {
    fill: rgb(168, 221, 181)
}

.GnBu .q3-7 {
    fill: rgb(123, 204, 196)
}

.GnBu .q4-7 {
    fill: rgb(78, 179, 211)
}

.GnBu .q5-7 {
    fill: rgb(43, 140, 190)
}

.GnBu .q6-7 {
    fill: rgb(8, 88, 158)
}

.GnBu .q0-8 {
    fill: rgb(247, 252, 240)
}

.GnBu .q1-8 {
    fill: rgb(224, 243, 219)
}

.GnBu .q2-8 {
    fill: rgb(204, 235, 197)
}

.GnBu .q3-8 {
    fill: rgb(168, 221, 181)
}

.GnBu .q4-8 {
    fill: rgb(123, 204, 196)
}

.GnBu .q5-8 {
    fill: rgb(78, 179, 211)
}

.GnBu .q6-8 {
    fill: rgb(43, 140, 190)
}

.GnBu .q7-8 {
    fill: rgb(8, 88, 158)
}

.GnBu .q0-9 {
    fill: rgb(247, 252, 240)
}

.GnBu .q1-9 {
    fill: rgb(224, 243, 219)
}

.GnBu .q2-9 {
    fill: rgb(204, 235, 197)
}

.GnBu .q3-9 {
    fill: rgb(168, 221, 181)
}

.GnBu .q4-9 {
    fill: rgb(123, 204, 196)
}

.GnBu .q5-9 {
    fill: rgb(78, 179, 211)
}

.GnBu .q6-9 {
    fill: rgb(43, 140, 190)
}

.GnBu .q7-9 {
    fill: rgb(8, 104, 172)
}

.GnBu .q8-9 {
    fill: rgb(8, 64, 129)
}

.BuGn .q0-3 {
    fill: rgb(229, 245, 249)
}

.BuGn .q1-3 {
    fill: rgb(153, 216, 201)
}

.BuGn .q2-3 {
    fill: rgb(44, 162, 95)
}

.BuGn .q0-4 {
    fill: rgb(237, 248, 251)
}

.BuGn .q1-4 {
    fill: rgb(178, 226, 226)
}

.BuGn .q2-4 {
    fill: rgb(102, 194, 164)
}

.BuGn .q3-4 {
    fill: rgb(35, 139, 69)
}

.BuGn .q0-5 {
    fill: rgb(237, 248, 251)
}

.BuGn .q1-5 {
    fill: rgb(178, 226, 226)
}

.BuGn .q2-5 {
    fill: rgb(102, 194, 164)
}

.BuGn .q3-5 {
    fill: rgb(44, 162, 95)
}

.BuGn .q4-5 {
    fill: rgb(0, 109, 44)
}

.BuGn .q0-6 {
    fill: rgb(237, 248, 251)
}

.BuGn .q1-6 {
    fill: rgb(204, 236, 230)
}

.BuGn .q2-6 {
    fill: rgb(153, 216, 201)
}

.BuGn .q3-6 {
    fill: rgb(102, 194, 164)
}

.BuGn .q4-6 {
    fill: rgb(44, 162, 95)
}

.BuGn .q5-6 {
    fill: rgb(0, 109, 44)
}

.BuGn .q0-7 {
    fill: rgb(237, 248, 251)
}

.BuGn .q1-7 {
    fill: rgb(204, 236, 230)
}

.BuGn .q2-7 {
    fill: rgb(153, 216, 201)
}

.BuGn .q3-7 {
    fill: rgb(102, 194, 164)
}

.BuGn .q4-7 {
    fill: rgb(65, 174, 118)
}

.BuGn .q5-7 {
    fill: rgb(35, 139, 69)
}

.BuGn .q6-7 {
    fill: rgb(0, 88, 36)
}

.BuGn .q0-8 {
    fill: rgb(247, 252, 253)
}

.BuGn .q1-8 {
    fill: rgb(229, 245, 249)
}

.BuGn .q2-8 {
    fill: rgb(204, 236, 230)
}

.BuGn .q3-8 {
    fill: rgb(153, 216, 201)
}

.BuGn .q4-8 {
    fill: rgb(102, 194, 164)
}

.BuGn .q5-8 {
    fill: rgb(65, 174, 118)
}

.BuGn .q6-8 {
    fill: rgb(35, 139, 69)
}

.BuGn .q7-8 {
    fill: rgb(0, 88, 36)
}

.BuGn .q0-9 {
    fill: rgb(247, 252, 253)
}

.BuGn .q1-9 {
    fill: rgb(229, 245, 249)
}

.BuGn .q2-9 {
    fill: rgb(204, 236, 230)
}

.BuGn .q3-9 {
    fill: rgb(153, 216, 201)
}

.BuGn .q4-9 {
    fill: rgb(102, 194, 164)
}

.BuGn .q5-9 {
    fill: rgb(65, 174, 118)
}

.BuGn .q6-9 {
    fill: rgb(35, 139, 69)
}

.BuGn .q7-9 {
    fill: rgb(0, 109, 44)
}

.BuGn .q8-9 {
    fill: rgb(0, 68, 27)
}

.PuBuGn .q0-3 {
    fill: rgb(236, 226, 240)
}

.PuBuGn .q1-3 {
    fill: rgb(166, 189, 219)
}

.PuBuGn .q2-3 {
    fill: rgb(28, 144, 153)
}

.PuBuGn .q0-4 {
    fill: rgb(246, 239, 247)
}

.PuBuGn .q1-4 {
    fill: rgb(189, 201, 225)
}

.PuBuGn .q2-4 {
    fill: rgb(103, 169, 207)
}

.PuBuGn .q3-4 {
    fill: rgb(2, 129, 138)
}

.PuBuGn .q0-5 {
    fill: rgb(246, 239, 247)
}

.PuBuGn .q1-5 {
    fill: rgb(189, 201, 225)
}

.PuBuGn .q2-5 {
    fill: rgb(103, 169, 207)
}

.PuBuGn .q3-5 {
    fill: rgb(28, 144, 153)
}

.PuBuGn .q4-5 {
    fill: rgb(1, 108, 89)
}

.PuBuGn .q0-6 {
    fill: rgb(246, 239, 247)
}

.PuBuGn .q1-6 {
    fill: rgb(208, 209, 230)
}

.PuBuGn .q2-6 {
    fill: rgb(166, 189, 219)
}

.PuBuGn .q3-6 {
    fill: rgb(103, 169, 207)
}

.PuBuGn .q4-6 {
    fill: rgb(28, 144, 153)
}

.PuBuGn .q5-6 {
    fill: rgb(1, 108, 89)
}

.PuBuGn .q0-7 {
    fill: rgb(246, 239, 247)
}

.PuBuGn .q1-7 {
    fill: rgb(208, 209, 230)
}

.PuBuGn .q2-7 {
    fill: rgb(166, 189, 219)
}

.PuBuGn .q3-7 {
    fill: rgb(103, 169, 207)
}

.PuBuGn .q4-7 {
    fill: rgb(54, 144, 192)
}

.PuBuGn .q5-7 {
    fill: rgb(2, 129, 138)
}

.PuBuGn .q6-7 {
    fill: rgb(1, 100, 80)
}

.PuBuGn .q0-8 {
    fill: rgb(255, 247, 251)
}

.PuBuGn .q1-8 {
    fill: rgb(236, 226, 240)
}

.PuBuGn .q2-8 {
    fill: rgb(208, 209, 230)
}

.PuBuGn .q3-8 {
    fill: rgb(166, 189, 219)
}

.PuBuGn .q4-8 {
    fill: rgb(103, 169, 207)
}

.PuBuGn .q5-8 {
    fill: rgb(54, 144, 192)
}

.PuBuGn .q6-8 {
    fill: rgb(2, 129, 138)
}

.PuBuGn .q7-8 {
    fill: rgb(1, 100, 80)
}

.PuBuGn .q0-9 {
    fill: rgb(255, 247, 251)
}

.PuBuGn .q1-9 {
    fill: rgb(236, 226, 240)
}

.PuBuGn .q2-9 {
    fill: rgb(208, 209, 230)
}

.PuBuGn .q3-9 {
    fill: rgb(166, 189, 219)
}

.PuBuGn .q4-9 {
    fill: rgb(103, 169, 207)
}

.PuBuGn .q5-9 {
    fill: rgb(54, 144, 192)
}

.PuBuGn .q6-9 {
    fill: rgb(2, 129, 138)
}

.PuBuGn .q7-9 {
    fill: rgb(1, 108, 89)
}

.PuBuGn .q8-9 {
    fill: rgb(1, 70, 54)
}

.PuBu .q0-3 {
    fill: rgb(236, 231, 242)
}

.PuBu .q1-3 {
    fill: rgb(166, 189, 219)
}

.PuBu .q2-3 {
    fill: rgb(43, 140, 190)
}

.PuBu .q0-4 {
    fill: rgb(241, 238, 246)
}

.PuBu .q1-4 {
    fill: rgb(189, 201, 225)
}

.PuBu .q2-4 {
    fill: rgb(116, 169, 207)
}

.PuBu .q3-4 {
    fill: rgb(5, 112, 176)
}

.PuBu .q0-5 {
    fill: rgb(241, 238, 246)
}

.PuBu .q1-5 {
    fill: rgb(189, 201, 225)
}

.PuBu .q2-5 {
    fill: rgb(116, 169, 207)
}

.PuBu .q3-5 {
    fill: rgb(43, 140, 190)
}

.PuBu .q4-5 {
    fill: rgb(4, 90, 141)
}

.PuBu .q0-6 {
    fill: rgb(241, 238, 246)
}

.PuBu .q1-6 {
    fill: rgb(208, 209, 230)
}

.PuBu .q2-6 {
    fill: rgb(166, 189, 219)
}

.PuBu .q3-6 {
    fill: rgb(116, 169, 207)
}

.PuBu .q4-6 {
    fill: rgb(43, 140, 190)
}

.PuBu .q5-6 {
    fill: rgb(4, 90, 141)
}

.PuBu .q0-7 {
    fill: rgb(241, 238, 246)
}

.PuBu .q1-7 {
    fill: rgb(208, 209, 230)
}

.PuBu .q2-7 {
    fill: rgb(166, 189, 219)
}

.PuBu .q3-7 {
    fill: rgb(116, 169, 207)
}

.PuBu .q4-7 {
    fill: rgb(54, 144, 192)
}

.PuBu .q5-7 {
    fill: rgb(5, 112, 176)
}

.PuBu .q6-7 {
    fill: rgb(3, 78, 123)
}

.PuBu .q0-8 {
    fill: rgb(255, 247, 251)
}

.PuBu .q1-8 {
    fill: rgb(236, 231, 242)
}

.PuBu .q2-8 {
    fill: rgb(208, 209, 230)
}

.PuBu .q3-8 {
    fill: rgb(166, 189, 219)
}

.PuBu .q4-8 {
    fill: rgb(116, 169, 207)
}

.PuBu .q5-8 {
    fill: rgb(54, 144, 192)
}

.PuBu .q6-8 {
    fill: rgb(5, 112, 176)
}

.PuBu .q7-8 {
    fill: rgb(3, 78, 123)
}

.PuBu .q0-9 {
    fill: rgb(255, 247, 251)
}

.PuBu .q1-9 {
    fill: rgb(236, 231, 242)
}

.PuBu .q2-9 {
    fill: rgb(208, 209, 230)
}

.PuBu .q3-9 {
    fill: rgb(166, 189, 219)
}

.PuBu .q4-9 {
    fill: rgb(116, 169, 207)
}

.PuBu .q5-9 {
    fill: rgb(54, 144, 192)
}

.PuBu .q6-9 {
    fill: rgb(5, 112, 176)
}

.PuBu .q7-9 {
    fill: rgb(4, 90, 141)
}

.PuBu .q8-9 {
    fill: rgb(2, 56, 88)
}

.BuPu .q0-3 {
    fill: rgb(224, 236, 244)
}

.BuPu .q1-3 {
    fill: rgb(158, 188, 218)
}

.BuPu .q2-3 {
    fill: rgb(136, 86, 167)
}

.BuPu .q0-4 {
    fill: rgb(237, 248, 251)
}

.BuPu .q1-4 {
    fill: rgb(179, 205, 227)
}

.BuPu .q2-4 {
    fill: rgb(140, 150, 198)
}

.BuPu .q3-4 {
    fill: rgb(136, 65, 157)
}

.BuPu .q0-5 {
    fill: rgb(237, 248, 251)
}

.BuPu .q1-5 {
    fill: rgb(179, 205, 227)
}

.BuPu .q2-5 {
    fill: rgb(140, 150, 198)
}

.BuPu .q3-5 {
    fill: rgb(136, 86, 167)
}

.BuPu .q4-5 {
    fill: rgb(129, 15, 124)
}

.BuPu .q0-6 {
    fill: rgb(237, 248, 251)
}

.BuPu .q1-6 {
    fill: rgb(191, 211, 230)
}

.BuPu .q2-6 {
    fill: rgb(158, 188, 218)
}

.BuPu .q3-6 {
    fill: rgb(140, 150, 198)
}

.BuPu .q4-6 {
    fill: rgb(136, 86, 167)
}

.BuPu .q5-6 {
    fill: rgb(129, 15, 124)
}

.BuPu .q0-7 {
    fill: rgb(237, 248, 251)
}

.BuPu .q1-7 {
    fill: rgb(191, 211, 230)
}

.BuPu .q2-7 {
    fill: rgb(158, 188, 218)
}

.BuPu .q3-7 {
    fill: rgb(140, 150, 198)
}

.BuPu .q4-7 {
    fill: rgb(140, 107, 177)
}

.BuPu .q5-7 {
    fill: rgb(136, 65, 157)
}

.BuPu .q6-7 {
    fill: rgb(110, 1, 107)
}

.BuPu .q0-8 {
    fill: rgb(247, 252, 253)
}

.BuPu .q1-8 {
    fill: rgb(224, 236, 244)
}

.BuPu .q2-8 {
    fill: rgb(191, 211, 230)
}

.BuPu .q3-8 {
    fill: rgb(158, 188, 218)
}

.BuPu .q4-8 {
    fill: rgb(140, 150, 198)
}

.BuPu .q5-8 {
    fill: rgb(140, 107, 177)
}

.BuPu .q6-8 {
    fill: rgb(136, 65, 157)
}

.BuPu .q7-8 {
    fill: rgb(110, 1, 107)
}

.BuPu .q0-9 {
    fill: rgb(247, 252, 253)
}

.BuPu .q1-9 {
    fill: rgb(224, 236, 244)
}

.BuPu .q2-9 {
    fill: rgb(191, 211, 230)
}

.BuPu .q3-9 {
    fill: rgb(158, 188, 218)
}

.BuPu .q4-9 {
    fill: rgb(140, 150, 198)
}

.BuPu .q5-9 {
    fill: rgb(140, 107, 177)
}

.BuPu .q6-9 {
    fill: rgb(136, 65, 157)
}

.BuPu .q7-9 {
    fill: rgb(129, 15, 124)
}

.BuPu .q8-9 {
    fill: rgb(77, 0, 75)
}

.RdPu .q0-3 {
    fill: rgb(253, 224, 221)
}

.RdPu .q1-3 {
    fill: rgb(250, 159, 181)
}

.RdPu .q2-3 {
    fill: rgb(197, 27, 138)
}

.RdPu .q0-4 {
    fill: rgb(254, 235, 226)
}

.RdPu .q1-4 {
    fill: rgb(251, 180, 185)
}

.RdPu .q2-4 {
    fill: rgb(247, 104, 161)
}

.RdPu .q3-4 {
    fill: rgb(174, 1, 126)
}

.RdPu .q0-5 {
    fill: rgb(254, 235, 226)
}

.RdPu .q1-5 {
    fill: rgb(251, 180, 185)
}

.RdPu .q2-5 {
    fill: rgb(247, 104, 161)
}

.RdPu .q3-5 {
    fill: rgb(197, 27, 138)
}

.RdPu .q4-5 {
    fill: rgb(122, 1, 119)
}

.RdPu .q0-6 {
    fill: rgb(254, 235, 226)
}

.RdPu .q1-6 {
    fill: rgb(252, 197, 192)
}

.RdPu .q2-6 {
    fill: rgb(250, 159, 181)
}

.RdPu .q3-6 {
    fill: rgb(247, 104, 161)
}

.RdPu .q4-6 {
    fill: rgb(197, 27, 138)
}

.RdPu .q5-6 {
    fill: rgb(122, 1, 119)
}

.RdPu .q0-7 {
    fill: rgb(254, 235, 226)
}

.RdPu .q1-7 {
    fill: rgb(252, 197, 192)
}

.RdPu .q2-7 {
    fill: rgb(250, 159, 181)
}

.RdPu .q3-7 {
    fill: rgb(247, 104, 161)
}

.RdPu .q4-7 {
    fill: rgb(221, 52, 151)
}

.RdPu .q5-7 {
    fill: rgb(174, 1, 126)
}

.RdPu .q6-7 {
    fill: rgb(122, 1, 119)
}

.RdPu .q0-8 {
    fill: rgb(255, 247, 243)
}

.RdPu .q1-8 {
    fill: rgb(253, 224, 221)
}

.RdPu .q2-8 {
    fill: rgb(252, 197, 192)
}

.RdPu .q3-8 {
    fill: rgb(250, 159, 181)
}

.RdPu .q4-8 {
    fill: rgb(247, 104, 161)
}

.RdPu .q5-8 {
    fill: rgb(221, 52, 151)
}

.RdPu .q6-8 {
    fill: rgb(174, 1, 126)
}

.RdPu .q7-8 {
    fill: rgb(122, 1, 119)
}

.RdPu .q0-9 {
    fill: rgb(255, 247, 243)
}

.RdPu .q1-9 {
    fill: rgb(253, 224, 221)
}

.RdPu .q2-9 {
    fill: rgb(252, 197, 192)
}

.RdPu .q3-9 {
    fill: rgb(250, 159, 181)
}

.RdPu .q4-9 {
    fill: rgb(247, 104, 161)
}

.RdPu .q5-9 {
    fill: rgb(221, 52, 151)
}

.RdPu .q6-9 {
    fill: rgb(174, 1, 126)
}

.RdPu .q7-9 {
    fill: rgb(122, 1, 119)
}

.RdPu .q8-9 {
    fill: rgb(73, 0, 106)
}

.PuRd .q0-3 {
    fill: rgb(231, 225, 239)
}

.PuRd .q1-3 {
    fill: rgb(201, 148, 199)
}

.PuRd .q2-3 {
    fill: rgb(221, 28, 119)
}

.PuRd .q0-4 {
    fill: rgb(241, 238, 246)
}

.PuRd .q1-4 {
    fill: rgb(215, 181, 216)
}

.PuRd .q2-4 {
    fill: rgb(223, 101, 176)
}

.PuRd .q3-4 {
    fill: rgb(206, 18, 86)
}

.PuRd .q0-5 {
    fill: rgb(241, 238, 246)
}

.PuRd .q1-5 {
    fill: rgb(215, 181, 216)
}

.PuRd .q2-5 {
    fill: rgb(223, 101, 176)
}

.PuRd .q3-5 {
    fill: rgb(221, 28, 119)
}

.PuRd .q4-5 {
    fill: rgb(152, 0, 67)
}

.PuRd .q0-6 {
    fill: rgb(241, 238, 246)
}

.PuRd .q1-6 {
    fill: rgb(212, 185, 218)
}

.PuRd .q2-6 {
    fill: rgb(201, 148, 199)
}

.PuRd .q3-6 {
    fill: rgb(223, 101, 176)
}

.PuRd .q4-6 {
    fill: rgb(221, 28, 119)
}

.PuRd .q5-6 {
    fill: rgb(152, 0, 67)
}

.PuRd .q0-7 {
    fill: rgb(241, 238, 246)
}

.PuRd .q1-7 {
    fill: rgb(212, 185, 218)
}

.PuRd .q2-7 {
    fill: rgb(201, 148, 199)
}

.PuRd .q3-7 {
    fill: rgb(223, 101, 176)
}

.PuRd .q4-7 {
    fill: rgb(231, 41, 138)
}

.PuRd .q5-7 {
    fill: rgb(206, 18, 86)
}

.PuRd .q6-7 {
    fill: rgb(145, 0, 63)
}

.PuRd .q0-8 {
    fill: rgb(247, 244, 249)
}

.PuRd .q1-8 {
    fill: rgb(231, 225, 239)
}

.PuRd .q2-8 {
    fill: rgb(212, 185, 218)
}

.PuRd .q3-8 {
    fill: rgb(201, 148, 199)
}

.PuRd .q4-8 {
    fill: rgb(223, 101, 176)
}

.PuRd .q5-8 {
    fill: rgb(231, 41, 138)
}

.PuRd .q6-8 {
    fill: rgb(206, 18, 86)
}

.PuRd .q7-8 {
    fill: rgb(145, 0, 63)
}

.PuRd .q0-9 {
    fill: rgb(247, 244, 249)
}

.PuRd .q1-9 {
    fill: rgb(231, 225, 239)
}

.PuRd .q2-9 {
    fill: rgb(212, 185, 218)
}

.PuRd .q3-9 {
    fill: rgb(201, 148, 199)
}

.PuRd .q4-9 {
    fill: rgb(223, 101, 176)
}

.PuRd .q5-9 {
    fill: rgb(231, 41, 138)
}

.PuRd .q6-9 {
    fill: rgb(206, 18, 86)
}

.PuRd .q7-9 {
    fill: rgb(152, 0, 67)
}

.PuRd .q8-9 {
    fill: rgb(103, 0, 31)
}

.OrRd .q0-3 {
    fill: rgb(254, 232, 200)
}

.OrRd .q1-3 {
    fill: rgb(253, 187, 132)
}

.OrRd .q2-3 {
    fill: rgb(227, 74, 51)
}

.OrRd .q0-4 {
    fill: rgb(254, 240, 217)
}

.OrRd .q1-4 {
    fill: rgb(253, 204, 138)
}

.OrRd .q2-4 {
    fill: rgb(252, 141, 89)
}

.OrRd .q3-4 {
    fill: rgb(215, 48, 31)
}

.OrRd .q0-5 {
    fill: rgb(254, 240, 217)
}

.OrRd .q1-5 {
    fill: rgb(253, 204, 138)
}

.OrRd .q2-5 {
    fill: rgb(252, 141, 89)
}

.OrRd .q3-5 {
    fill: rgb(227, 74, 51)
}

.OrRd .q4-5 {
    fill: rgb(179, 0, 0)
}

.OrRd .q0-6 {
    fill: rgb(254, 240, 217)
}

.OrRd .q1-6 {
    fill: rgb(253, 212, 158)
}

.OrRd .q2-6 {
    fill: rgb(253, 187, 132)
}

.OrRd .q3-6 {
    fill: rgb(252, 141, 89)
}

.OrRd .q4-6 {
    fill: rgb(227, 74, 51)
}

.OrRd .q5-6 {
    fill: rgb(179, 0, 0)
}

.OrRd .q0-7 {
    fill: rgb(254, 240, 217)
}

.OrRd .q1-7 {
    fill: rgb(253, 212, 158)
}

.OrRd .q2-7 {
    fill: rgb(253, 187, 132)
}

.OrRd .q3-7 {
    fill: rgb(252, 141, 89)
}

.OrRd .q4-7 {
    fill: rgb(239, 101, 72)
}

.OrRd .q5-7 {
    fill: rgb(215, 48, 31)
}

.OrRd .q6-7 {
    fill: rgb(153, 0, 0)
}

.OrRd .q0-8 {
    fill: rgb(255, 247, 236)
}

.OrRd .q1-8 {
    fill: rgb(254, 232, 200)
}

.OrRd .q2-8 {
    fill: rgb(253, 212, 158)
}

.OrRd .q3-8 {
    fill: rgb(253, 187, 132)
}

.OrRd .q4-8 {
    fill: rgb(252, 141, 89)
}

.OrRd .q5-8 {
    fill: rgb(239, 101, 72)
}

.OrRd .q6-8 {
    fill: rgb(215, 48, 31)
}

.OrRd .q7-8 {
    fill: rgb(153, 0, 0)
}

.OrRd .q0-9 {
    fill: rgb(255, 247, 236)
}

.OrRd .q1-9 {
    fill: rgb(254, 232, 200)
}

.OrRd .q2-9 {
    fill: rgb(253, 212, 158)
}

.OrRd .q3-9 {
    fill: rgb(253, 187, 132)
}

.OrRd .q4-9 {
    fill: rgb(252, 141, 89)
}

.OrRd .q5-9 {
    fill: rgb(239, 101, 72)
}

.OrRd .q6-9 {
    fill: rgb(215, 48, 31)
}

.OrRd .q7-9 {
    fill: rgb(179, 0, 0)
}

.OrRd .q8-9 {
    fill: rgb(127, 0, 0)
}

.YlOrRd .q0-3 {
    fill: rgb(255, 237, 160)
}

.YlOrRd .q1-3 {
    fill: rgb(254, 178, 76)
}

.YlOrRd .q2-3 {
    fill: rgb(240, 59, 32)
}

.YlOrRd .q0-4 {
    fill: rgb(255, 255, 178)
}

.YlOrRd .q1-4 {
    fill: rgb(254, 204, 92)
}

.YlOrRd .q2-4 {
    fill: rgb(253, 141, 60)
}

.YlOrRd .q3-4 {
    fill: rgb(227, 26, 28)
}

.YlOrRd .q0-5 {
    fill: rgb(255, 255, 178)
}

.YlOrRd .q1-5 {
    fill: rgb(254, 204, 92)
}

.YlOrRd .q2-5 {
    fill: rgb(253, 141, 60)
}

.YlOrRd .q3-5 {
    fill: rgb(240, 59, 32)
}

.YlOrRd .q4-5 {
    fill: rgb(189, 0, 38)
}

.YlOrRd .q0-6 {
    fill: rgb(255, 255, 178)
}

.YlOrRd .q1-6 {
    fill: rgb(254, 217, 118)
}

.YlOrRd .q2-6 {
    fill: rgb(254, 178, 76)
}

.YlOrRd .q3-6 {
    fill: rgb(253, 141, 60)
}

.YlOrRd .q4-6 {
    fill: rgb(240, 59, 32)
}

.YlOrRd .q5-6 {
    fill: rgb(189, 0, 38)
}

.YlOrRd .q0-7 {
    fill: rgb(255, 255, 178)
}

.YlOrRd .q1-7 {
    fill: rgb(254, 217, 118)
}

.YlOrRd .q2-7 {
    fill: rgb(254, 178, 76)
}

.YlOrRd .q3-7 {
    fill: rgb(253, 141, 60)
}

.YlOrRd .q4-7 {
    fill: rgb(252, 78, 42)
}

.YlOrRd .q5-7 {
    fill: rgb(227, 26, 28)
}

.YlOrRd .q6-7 {
    fill: rgb(177, 0, 38)
}

.YlOrRd .q0-8 {
    fill: rgb(255, 255, 204)
}

.YlOrRd .q1-8 {
    fill: rgb(255, 237, 160)
}

.YlOrRd .q2-8 {
    fill: rgb(254, 217, 118)
}

.YlOrRd .q3-8 {
    fill: rgb(254, 178, 76)
}

.YlOrRd .q4-8 {
    fill: rgb(253, 141, 60)
}

.YlOrRd .q5-8 {
    fill: rgb(252, 78, 42)
}

.YlOrRd .q6-8 {
    fill: rgb(227, 26, 28)
}

.YlOrRd .q7-8 {
    fill: rgb(177, 0, 38)
}

.YlOrRd .q0-9 {
    fill: rgb(255, 255, 204)
}

.YlOrRd .q1-9 {
    fill: rgb(255, 237, 160)
}

.YlOrRd .q2-9 {
    fill: rgb(254, 217, 118)
}

.YlOrRd .q3-9 {
    fill: rgb(254, 178, 76)
}

.YlOrRd .q4-9 {
    fill: rgb(253, 141, 60)
}

.YlOrRd .q5-9 {
    fill: rgb(252, 78, 42)
}

.YlOrRd .q6-9 {
    fill: rgb(227, 26, 28)
}

.YlOrRd .q7-9 {
    fill: rgb(189, 0, 38)
}

.YlOrRd .q8-9 {
    fill: rgb(128, 0, 38)
}

.YlOrBr .q0-3 {
    fill: rgb(255, 247, 188)
}

.YlOrBr .q1-3 {
    fill: rgb(254, 196, 79)
}

.YlOrBr .q2-3 {
    fill: rgb(217, 95, 14)
}

.YlOrBr .q0-4 {
    fill: rgb(255, 255, 212)
}

.YlOrBr .q1-4 {
    fill: rgb(254, 217, 142)
}

.YlOrBr .q2-4 {
    fill: rgb(254, 153, 41)
}

.YlOrBr .q3-4 {
    fill: rgb(204, 76, 2)
}

.YlOrBr .q0-5 {
    fill: rgb(255, 255, 212)
}

.YlOrBr .q1-5 {
    fill: rgb(254, 217, 142)
}

.YlOrBr .q2-5 {
    fill: rgb(254, 153, 41)
}

.YlOrBr .q3-5 {
    fill: rgb(217, 95, 14)
}

.YlOrBr .q4-5 {
    fill: rgb(153, 52, 4)
}

.YlOrBr .q0-6 {
    fill: rgb(255, 255, 212)
}

.YlOrBr .q1-6 {
    fill: rgb(254, 227, 145)
}

.YlOrBr .q2-6 {
    fill: rgb(254, 196, 79)
}

.YlOrBr .q3-6 {
    fill: rgb(254, 153, 41)
}

.YlOrBr .q4-6 {
    fill: rgb(217, 95, 14)
}

.YlOrBr .q5-6 {
    fill: rgb(153, 52, 4)
}

.YlOrBr .q0-7 {
    fill: rgb(255, 255, 212)
}

.YlOrBr .q1-7 {
    fill: rgb(254, 227, 145)
}

.YlOrBr .q2-7 {
    fill: rgb(254, 196, 79)
}

.YlOrBr .q3-7 {
    fill: rgb(254, 153, 41)
}

.YlOrBr .q4-7 {
    fill: rgb(236, 112, 20)
}

.YlOrBr .q5-7 {
    fill: rgb(204, 76, 2)
}

.YlOrBr .q6-7 {
    fill: rgb(140, 45, 4)
}

.YlOrBr .q0-8 {
    fill: rgb(255, 255, 229)
}

.YlOrBr .q1-8 {
    fill: rgb(255, 247, 188)
}

.YlOrBr .q2-8 {
    fill: rgb(254, 227, 145)
}

.YlOrBr .q3-8 {
    fill: rgb(254, 196, 79)
}

.YlOrBr .q4-8 {
    fill: rgb(254, 153, 41)
}

.YlOrBr .q5-8 {
    fill: rgb(236, 112, 20)
}

.YlOrBr .q6-8 {
    fill: rgb(204, 76, 2)
}

.YlOrBr .q7-8 {
    fill: rgb(140, 45, 4)
}

.YlOrBr .q0-9 {
    fill: rgb(255, 255, 229)
}

.YlOrBr .q1-9 {
    fill: rgb(255, 247, 188)
}

.YlOrBr .q2-9 {
    fill: rgb(254, 227, 145)
}

.YlOrBr .q3-9 {
    fill: rgb(254, 196, 79)
}

.YlOrBr .q4-9 {
    fill: rgb(254, 153, 41)
}

.YlOrBr .q5-9 {
    fill: rgb(236, 112, 20)
}

.YlOrBr .q6-9 {
    fill: rgb(204, 76, 2)
}

.YlOrBr .q7-9 {
    fill: rgb(153, 52, 4)
}

.YlOrBr .q8-9 {
    fill: rgb(102, 37, 6)
}

.Purples .q0-3 {
    fill: rgb(239, 237, 245)
}

.Purples .q1-3 {
    fill: rgb(188, 189, 220)
}

.Purples .q2-3 {
    fill: rgb(117, 107, 177)
}

.Purples .q0-4 {
    fill: rgb(242, 240, 247)
}

.Purples .q1-4 {
    fill: rgb(203, 201, 226)
}

.Purples .q2-4 {
    fill: rgb(158, 154, 200)
}

.Purples .q3-4 {
    fill: rgb(106, 81, 163)
}

.Purples .q0-5 {
    fill: rgb(242, 240, 247)
}

.Purples .q1-5 {
    fill: rgb(203, 201, 226)
}

.Purples .q2-5 {
    fill: rgb(158, 154, 200)
}

.Purples .q3-5 {
    fill: rgb(117, 107, 177)
}

.Purples .q4-5 {
    fill: rgb(84, 39, 143)
}

.Purples .q0-6 {
    fill: rgb(242, 240, 247)
}

.Purples .q1-6 {
    fill: rgb(218, 218, 235)
}

.Purples .q2-6 {
    fill: rgb(188, 189, 220)
}

.Purples .q3-6 {
    fill: rgb(158, 154, 200)
}

.Purples .q4-6 {
    fill: rgb(117, 107, 177)
}

.Purples .q5-6 {
    fill: rgb(84, 39, 143)
}

.Purples .q0-7 {
    fill: rgb(242, 240, 247)
}

.Purples .q1-7 {
    fill: rgb(218, 218, 235)
}

.Purples .q2-7 {
    fill: rgb(188, 189, 220)
}

.Purples .q3-7 {
    fill: rgb(158, 154, 200)
}

.Purples .q4-7 {
    fill: rgb(128, 125, 186)
}

.Purples .q5-7 {
    fill: rgb(106, 81, 163)
}

.Purples .q6-7 {
    fill: rgb(74, 20, 134)
}

.Purples .q0-8 {
    fill: rgb(252, 251, 253)
}

.Purples .q1-8 {
    fill: rgb(239, 237, 245)
}

.Purples .q2-8 {
    fill: rgb(218, 218, 235)
}

.Purples .q3-8 {
    fill: rgb(188, 189, 220)
}

.Purples .q4-8 {
    fill: rgb(158, 154, 200)
}

.Purples .q5-8 {
    fill: rgb(128, 125, 186)
}

.Purples .q6-8 {
    fill: rgb(106, 81, 163)
}

.Purples .q7-8 {
    fill: rgb(74, 20, 134)
}

.Purples .q0-9 {
    fill: rgb(252, 251, 253)
}

.Purples .q1-9 {
    fill: rgb(239, 237, 245)
}

.Purples .q2-9 {
    fill: rgb(218, 218, 235)
}

.Purples .q3-9 {
    fill: rgb(188, 189, 220)
}

.Purples .q4-9 {
    fill: rgb(158, 154, 200)
}

.Purples .q5-9 {
    fill: rgb(128, 125, 186)
}

.Purples .q6-9 {
    fill: rgb(106, 81, 163)
}

.Purples .q7-9 {
    fill: rgb(84, 39, 143)
}

.Purples .q8-9 {
    fill: rgb(63, 0, 125)
}

.Blues .q0-3 {
    fill: rgb(222, 235, 247)
}

.Blues .q1-3 {
    fill: rgb(158, 202, 225)
}

.Blues .q2-3 {
    fill: rgb(49, 130, 189)
}

.Blues .q0-4 {
    fill: rgb(239, 243, 255)
}

.Blues .q1-4 {
    fill: rgb(189, 215, 231)
}

.Blues .q2-4 {
    fill: rgb(107, 174, 214)
}

.Blues .q3-4 {
    fill: rgb(33, 113, 181)
}

.Blues .q0-5 {
    fill: rgb(239, 243, 255)
}

.Blues .q1-5 {
    fill: rgb(189, 215, 231)
}

.Blues .q2-5 {
    fill: rgb(107, 174, 214)
}

.Blues .q3-5 {
    fill: rgb(49, 130, 189)
}

.Blues .q4-5 {
    fill: rgb(8, 81, 156)
}

.Blues .q0-6 {
    fill: rgb(239, 243, 255)
}

.Blues .q1-6 {
    fill: rgb(198, 219, 239)
}

.Blues .q2-6 {
    fill: rgb(158, 202, 225)
}

.Blues .q3-6 {
    fill: rgb(107, 174, 214)
}

.Blues .q4-6 {
    fill: rgb(49, 130, 189)
}

.Blues .q5-6 {
    fill: rgb(8, 81, 156)
}

.Blues .q0-7 {
    fill: rgb(239, 243, 255)
}

.Blues .q1-7 {
    fill: rgb(198, 219, 239)
}

.Blues .q2-7 {
    fill: rgb(158, 202, 225)
}

.Blues .q3-7 {
    fill: rgb(107, 174, 214)
}

.Blues .q4-7 {
    fill: rgb(66, 146, 198)
}

.Blues .q5-7 {
    fill: rgb(33, 113, 181)
}

.Blues .q6-7 {
    fill: rgb(8, 69, 148)
}

.Blues .q0-8 {
    fill: rgb(247, 251, 255)
}

.Blues .q1-8 {
    fill: rgb(222, 235, 247)
}

.Blues .q2-8 {
    fill: rgb(198, 219, 239)
}

.Blues .q3-8 {
    fill: rgb(158, 202, 225)
}

.Blues .q4-8 {
    fill: rgb(107, 174, 214)
}

.Blues .q5-8 {
    fill: rgb(66, 146, 198)
}

.Blues .q6-8 {
    fill: rgb(33, 113, 181)
}

.Blues .q7-8 {
    fill: rgb(8, 69, 148)
}

.Blues .q0-9 {
    fill: rgb(247, 251, 255)
}

.Blues .q1-9 {
    fill: rgb(222, 235, 247)
}

.Blues .q2-9 {
    fill: rgb(198, 219, 239)
}

.Blues .q3-9 {
    fill: rgb(158, 202, 225)
}

.Blues .q4-9 {
    fill: rgb(107, 174, 214)
}

.Blues .q5-9 {
    fill: rgb(66, 146, 198)
}

.Blues .q6-9 {
    fill: rgb(33, 113, 181)
}

.Blues .q7-9 {
    fill: rgb(8, 81, 156)
}

.Blues .q8-9 {
    fill: rgb(8, 48, 107)
}

.Greens .q0-3 {
    fill: rgb(229, 245, 224)
}

.Greens .q1-3 {
    fill: rgb(161, 217, 155)
}

.Greens .q2-3 {
    fill: rgb(49, 163, 84)
}

.Greens .q0-4 {
    fill: rgb(237, 248, 233)
}

.Greens .q1-4 {
    fill: rgb(186, 228, 179)
}

.Greens .q2-4 {
    fill: rgb(116, 196, 118)
}

.Greens .q3-4 {
    fill: rgb(35, 139, 69)
}

.Greens .q0-5 {
    fill: rgb(237, 248, 233)
}

.Greens .q1-5 {
    fill: rgb(186, 228, 179)
}

.Greens .q2-5 {
    fill: rgb(116, 196, 118)
}

.Greens .q3-5 {
    fill: rgb(49, 163, 84)
}

.Greens .q4-5 {
    fill: rgb(0, 109, 44)
}

.Greens .q0-6 {
    fill: rgb(237, 248, 233)
}

.Greens .q1-6 {
    fill: rgb(199, 233, 192)
}

.Greens .q2-6 {
    fill: rgb(161, 217, 155)
}

.Greens .q3-6 {
    fill: rgb(116, 196, 118)
}

.Greens .q4-6 {
    fill: rgb(49, 163, 84)
}

.Greens .q5-6 {
    fill: rgb(0, 109, 44)
}

.Greens .q0-7 {
    fill: rgb(237, 248, 233)
}

.Greens .q1-7 {
    fill: rgb(199, 233, 192)
}

.Greens .q2-7 {
    fill: rgb(161, 217, 155)
}

.Greens .q3-7 {
    fill: rgb(116, 196, 118)
}

.Greens .q4-7 {
    fill: rgb(65, 171, 93)
}

.Greens .q5-7 {
    fill: rgb(35, 139, 69)
}

.Greens .q6-7 {
    fill: rgb(0, 90, 50)
}

.Greens .q0-8 {
    fill: rgb(247, 252, 245)
}

.Greens .q1-8 {
    fill: rgb(229, 245, 224)
}

.Greens .q2-8 {
    fill: rgb(199, 233, 192)
}

.Greens .q3-8 {
    fill: rgb(161, 217, 155)
}

.Greens .q4-8 {
    fill: rgb(116, 196, 118)
}

.Greens .q5-8 {
    fill: rgb(65, 171, 93)
}

.Greens .q6-8 {
    fill: rgb(35, 139, 69)
}

.Greens .q7-8 {
    fill: rgb(0, 90, 50)
}

.Greens .q0-9 {
    fill: rgb(247, 252, 245)
}

.Greens .q1-9 {
    fill: rgb(229, 245, 224)
}

.Greens .q2-9 {
    fill: rgb(199, 233, 192)
}

.Greens .q3-9 {
    fill: rgb(161, 217, 155)
}

.Greens .q4-9 {
    fill: rgb(116, 196, 118)
}

.Greens .q5-9 {
    fill: rgb(65, 171, 93)
}

.Greens .q6-9 {
    fill: rgb(35, 139, 69)
}

.Greens .q7-9 {
    fill: rgb(0, 109, 44)
}

.Greens .q8-9 {
    fill: rgb(0, 68, 27)
}

.Oranges .q0-3 {
    fill: rgb(254, 230, 206)
}

.Oranges .q1-3 {
    fill: rgb(253, 174, 107)
}

.Oranges .q2-3 {
    fill: rgb(230, 85, 13)
}

.Oranges .q0-4 {
    fill: rgb(254, 237, 222)
}

.Oranges .q1-4 {
    fill: rgb(253, 190, 133)
}

.Oranges .q2-4 {
    fill: rgb(253, 141, 60)
}

.Oranges .q3-4 {
    fill: rgb(217, 71, 1)
}

.Oranges .q0-5 {
    fill: rgb(254, 237, 222)
}

.Oranges .q1-5 {
    fill: rgb(253, 190, 133)
}

.Oranges .q2-5 {
    fill: rgb(253, 141, 60)
}

.Oranges .q3-5 {
    fill: rgb(230, 85, 13)
}

.Oranges .q4-5 {
    fill: rgb(166, 54, 3)
}

.Oranges .q0-6 {
    fill: rgb(254, 237, 222)
}

.Oranges .q1-6 {
    fill: rgb(253, 208, 162)
}

.Oranges .q2-6 {
    fill: rgb(253, 174, 107)
}

.Oranges .q3-6 {
    fill: rgb(253, 141, 60)
}

.Oranges .q4-6 {
    fill: rgb(230, 85, 13)
}

.Oranges .q5-6 {
    fill: rgb(166, 54, 3)
}

.Oranges .q0-7 {
    fill: rgb(254, 237, 222)
}

.Oranges .q1-7 {
    fill: rgb(253, 208, 162)
}

.Oranges .q2-7 {
    fill: rgb(253, 174, 107)
}

.Oranges .q3-7 {
    fill: rgb(253, 141, 60)
}

.Oranges .q4-7 {
    fill: rgb(241, 105, 19)
}

.Oranges .q5-7 {
    fill: rgb(217, 72, 1)
}

.Oranges .q6-7 {
    fill: rgb(140, 45, 4)
}

.Oranges .q0-8 {
    fill: rgb(255, 245, 235)
}

.Oranges .q1-8 {
    fill: rgb(254, 230, 206)
}

.Oranges .q2-8 {
    fill: rgb(253, 208, 162)
}

.Oranges .q3-8 {
    fill: rgb(253, 174, 107)
}

.Oranges .q4-8 {
    fill: rgb(253, 141, 60)
}

.Oranges .q5-8 {
    fill: rgb(241, 105, 19)
}

.Oranges .q6-8 {
    fill: rgb(217, 72, 1)
}

.Oranges .q7-8 {
    fill: rgb(140, 45, 4)
}

.Oranges .q0-9 {
    fill: rgb(255, 245, 235)
}

.Oranges .q1-9 {
    fill: rgb(254, 230, 206)
}

.Oranges .q2-9 {
    fill: rgb(253, 208, 162)
}

.Oranges .q3-9 {
    fill: rgb(253, 174, 107)
}

.Oranges .q4-9 {
    fill: rgb(253, 141, 60)
}

.Oranges .q5-9 {
    fill: rgb(241, 105, 19)
}

.Oranges .q6-9 {
    fill: rgb(217, 72, 1)
}

.Oranges .q7-9 {
    fill: rgb(166, 54, 3)
}

.Oranges .q8-9 {
    fill: rgb(127, 39, 4)
}

.Reds .q0-3 {
    fill: rgb(254, 224, 210)
}

.Reds .q1-3 {
    fill: rgb(252, 146, 114)
}

.Reds .q2-3 {
    fill: rgb(222, 45, 38)
}

.Reds .q0-4 {
    fill: rgb(254, 229, 217)
}

.Reds .q1-4 {
    fill: rgb(252, 174, 145)
}

.Reds .q2-4 {
    fill: rgb(251, 106, 74)
}

.Reds .q3-4 {
    fill: rgb(203, 24, 29)
}

.Reds .q0-5 {
    fill: rgb(254, 229, 217)
}

.Reds .q1-5 {
    fill: rgb(252, 174, 145)
}

.Reds .q2-5 {
    fill: rgb(251, 106, 74)
}

.Reds .q3-5 {
    fill: rgb(222, 45, 38)
}

.Reds .q4-5 {
    fill: rgb(165, 15, 21)
}

.Reds .q0-6 {
    fill: rgb(254, 229, 217)
}

.Reds .q1-6 {
    fill: rgb(252, 187, 161)
}

.Reds .q2-6 {
    fill: rgb(252, 146, 114)
}

.Reds .q3-6 {
    fill: rgb(251, 106, 74)
}

.Reds .q4-6 {
    fill: rgb(222, 45, 38)
}

.Reds .q5-6 {
    fill: rgb(165, 15, 21)
}

.Reds .q0-7 {
    fill: rgb(254, 229, 217)
}

.Reds .q1-7 {
    fill: rgb(252, 187, 161)
}

.Reds .q2-7 {
    fill: rgb(252, 146, 114)
}

.Reds .q3-7 {
    fill: rgb(251, 106, 74)
}

.Reds .q4-7 {
    fill: rgb(239, 59, 44)
}

.Reds .q5-7 {
    fill: rgb(203, 24, 29)
}

.Reds .q6-7 {
    fill: rgb(153, 0, 13)
}

.Reds .q0-8 {
    fill: rgb(255, 245, 240)
}

.Reds .q1-8 {
    fill: rgb(254, 224, 210)
}

.Reds .q2-8 {
    fill: rgb(252, 187, 161)
}

.Reds .q3-8 {
    fill: rgb(252, 146, 114)
}

.Reds .q4-8 {
    fill: rgb(251, 106, 74)
}

.Reds .q5-8 {
    fill: rgb(239, 59, 44)
}

.Reds .q6-8 {
    fill: rgb(203, 24, 29)
}

.Reds .q7-8 {
    fill: rgb(153, 0, 13)
}

.Reds .q0-9 {
    fill: rgb(255, 245, 240)
}

.Reds .q1-9 {
    fill: rgb(254, 224, 210)
}

.Reds .q2-9 {
    fill: rgb(252, 187, 161)
}

.Reds .q3-9 {
    fill: rgb(252, 146, 114)
}

.Reds .q4-9 {
    fill: rgb(251, 106, 74)
}

.Reds .q5-9 {
    fill: rgb(239, 59, 44)
}

.Reds .q6-9 {
    fill: rgb(203, 24, 29)
}

.Reds .q7-9 {
    fill: rgb(165, 15, 21)
}

.Reds .q8-9 {
    fill: rgb(103, 0, 13)
}

.Greys .q0-3 {
    fill: rgb(240, 240, 240)
}

.Greys .q1-3 {
    fill: rgb(189, 189, 189)
}

.Greys .q2-3 {
    fill: rgb(99, 99, 99)
}

.Greys .q0-4 {
    fill: rgb(247, 247, 247)
}

.Greys .q1-4 {
    fill: rgb(204, 204, 204)
}

.Greys .q2-4 {
    fill: rgb(150, 150, 150)
}

.Greys .q3-4 {
    fill: rgb(82, 82, 82)
}

.Greys .q0-5 {
    fill: rgb(247, 247, 247)
}

.Greys .q1-5 {
    fill: rgb(204, 204, 204)
}

.Greys .q2-5 {
    fill: rgb(150, 150, 150)
}

.Greys .q3-5 {
    fill: rgb(99, 99, 99)
}

.Greys .q4-5 {
    fill: rgb(37, 37, 37)
}

.Greys .q0-6 {
    fill: rgb(247, 247, 247)
}

.Greys .q1-6 {
    fill: rgb(217, 217, 217)
}

.Greys .q2-6 {
    fill: rgb(189, 189, 189)
}

.Greys .q3-6 {
    fill: rgb(150, 150, 150)
}

.Greys .q4-6 {
    fill: rgb(99, 99, 99)
}

.Greys .q5-6 {
    fill: rgb(37, 37, 37)
}

.Greys .q0-7 {
    fill: rgb(247, 247, 247)
}

.Greys .q1-7 {
    fill: rgb(217, 217, 217)
}

.Greys .q2-7 {
    fill: rgb(189, 189, 189)
}

.Greys .q3-7 {
    fill: rgb(150, 150, 150)
}

.Greys .q4-7 {
    fill: rgb(115, 115, 115)
}

.Greys .q5-7 {
    fill: rgb(82, 82, 82)
}

.Greys .q6-7 {
    fill: rgb(37, 37, 37)
}

.Greys .q0-8 {
    fill: rgb(255, 255, 255)
}

.Greys .q1-8 {
    fill: rgb(240, 240, 240)
}

.Greys .q2-8 {
    fill: rgb(217, 217, 217)
}

.Greys .q3-8 {
    fill: rgb(189, 189, 189)
}

.Greys .q4-8 {
    fill: rgb(150, 150, 150)
}

.Greys .q5-8 {
    fill: rgb(115, 115, 115)
}

.Greys .q6-8 {
    fill: rgb(82, 82, 82)
}

.Greys .q7-8 {
    fill: rgb(37, 37, 37)
}

.Greys .q0-9 {
    fill: rgb(255, 255, 255)
}

.Greys .q1-9 {
    fill: rgb(240, 240, 240)
}

.Greys .q2-9 {
    fill: rgb(217, 217, 217)
}

.Greys .q3-9 {
    fill: rgb(189, 189, 189)
}

.Greys .q4-9 {
    fill: rgb(150, 150, 150)
}

.Greys .q5-9 {
    fill: rgb(115, 115, 115)
}

.Greys .q6-9 {
    fill: rgb(82, 82, 82)
}

.Greys .q7-9 {
    fill: rgb(37, 37, 37)
}

.Greys .q8-9 {
    fill: rgb(0, 0, 0)
}

.PuOr .q0-3 {
    fill: rgb(241, 163, 64)
}

.PuOr .q1-3 {
    fill: rgb(247, 247, 247)
}

.PuOr .q2-3 {
    fill: rgb(153, 142, 195)
}

.PuOr .q0-4 {
    fill: rgb(230, 97, 1)
}

.PuOr .q1-4 {
    fill: rgb(253, 184, 99)
}

.PuOr .q2-4 {
    fill: rgb(178, 171, 210)
}

.PuOr .q3-4 {
    fill: rgb(94, 60, 153)
}

.PuOr .q0-5 {
    fill: rgb(230, 97, 1)
}

.PuOr .q1-5 {
    fill: rgb(253, 184, 99)
}

.PuOr .q2-5 {
    fill: rgb(247, 247, 247)
}

.PuOr .q3-5 {
    fill: rgb(178, 171, 210)
}

.PuOr .q4-5 {
    fill: rgb(94, 60, 153)
}

.PuOr .q0-6 {
    fill: rgb(179, 88, 6)
}

.PuOr .q1-6 {
    fill: rgb(241, 163, 64)
}

.PuOr .q2-6 {
    fill: rgb(254, 224, 182)
}

.PuOr .q3-6 {
    fill: rgb(216, 218, 235)
}

.PuOr .q4-6 {
    fill: rgb(153, 142, 195)
}

.PuOr .q5-6 {
    fill: rgb(84, 39, 136)
}

.PuOr .q0-7 {
    fill: rgb(179, 88, 6)
}

.PuOr .q1-7 {
    fill: rgb(241, 163, 64)
}

.PuOr .q2-7 {
    fill: rgb(254, 224, 182)
}

.PuOr .q3-7 {
    fill: rgb(247, 247, 247)
}

.PuOr .q4-7 {
    fill: rgb(216, 218, 235)
}

.PuOr .q5-7 {
    fill: rgb(153, 142, 195)
}

.PuOr .q6-7 {
    fill: rgb(84, 39, 136)
}

.PuOr .q0-8 {
    fill: rgb(179, 88, 6)
}

.PuOr .q1-8 {
    fill: rgb(224, 130, 20)
}

.PuOr .q2-8 {
    fill: rgb(253, 184, 99)
}

.PuOr .q3-8 {
    fill: rgb(254, 224, 182)
}

.PuOr .q4-8 {
    fill: rgb(216, 218, 235)
}

.PuOr .q5-8 {
    fill: rgb(178, 171, 210)
}

.PuOr .q6-8 {
    fill: rgb(128, 115, 172)
}

.PuOr .q7-8 {
    fill: rgb(84, 39, 136)
}

.PuOr .q0-9 {
    fill: rgb(179, 88, 6)
}

.PuOr .q1-9 {
    fill: rgb(224, 130, 20)
}

.PuOr .q2-9 {
    fill: rgb(253, 184, 99)
}

.PuOr .q3-9 {
    fill: rgb(254, 224, 182)
}

.PuOr .q4-9 {
    fill: rgb(247, 247, 247)
}

.PuOr .q5-9 {
    fill: rgb(216, 218, 235)
}

.PuOr .q6-9 {
    fill: rgb(178, 171, 210)
}

.PuOr .q7-9 {
    fill: rgb(128, 115, 172)
}

.PuOr .q8-9 {
    fill: rgb(84, 39, 136)
}

.PuOr .q0-10 {
    fill: rgb(127, 59, 8)
}

.PuOr .q1-10 {
    fill: rgb(179, 88, 6)
}

.PuOr .q2-10 {
    fill: rgb(224, 130, 20)
}

.PuOr .q3-10 {
    fill: rgb(253, 184, 99)
}

.PuOr .q4-10 {
    fill: rgb(254, 224, 182)
}

.PuOr .q5-10 {
    fill: rgb(216, 218, 235)
}

.PuOr .q6-10 {
    fill: rgb(178, 171, 210)
}

.PuOr .q7-10 {
    fill: rgb(128, 115, 172)
}

.PuOr .q8-10 {
    fill: rgb(84, 39, 136)
}

.PuOr .q9-10 {
    fill: rgb(45, 0, 75)
}

.PuOr .q0-11 {
    fill: rgb(127, 59, 8)
}

.PuOr .q1-11 {
    fill: rgb(179, 88, 6)
}

.PuOr .q2-11 {
    fill: rgb(224, 130, 20)
}

.PuOr .q3-11 {
    fill: rgb(253, 184, 99)
}

.PuOr .q4-11 {
    fill: rgb(254, 224, 182)
}

.PuOr .q5-11 {
    fill: rgb(247, 247, 247)
}

.PuOr .q6-11 {
    fill: rgb(216, 218, 235)
}

.PuOr .q7-11 {
    fill: rgb(178, 171, 210)
}

.PuOr .q8-11 {
    fill: rgb(128, 115, 172)
}

.PuOr .q9-11 {
    fill: rgb(84, 39, 136)
}

.PuOr .q10-11 {
    fill: rgb(45, 0, 75)
}

.BrBG .q0-3 {
    fill: rgb(216, 179, 101)
}

.BrBG .q1-3 {
    fill: rgb(245, 245, 245)
}

.BrBG .q2-3 {
    fill: rgb(90, 180, 172)
}

.BrBG .q0-4 {
    fill: rgb(166, 97, 26)
}

.BrBG .q1-4 {
    fill: rgb(223, 194, 125)
}

.BrBG .q2-4 {
    fill: rgb(128, 205, 193)
}

.BrBG .q3-4 {
    fill: rgb(1, 133, 113)
}

.BrBG .q0-5 {
    fill: rgb(166, 97, 26)
}

.BrBG .q1-5 {
    fill: rgb(223, 194, 125)
}

.BrBG .q2-5 {
    fill: rgb(245, 245, 245)
}

.BrBG .q3-5 {
    fill: rgb(128, 205, 193)
}

.BrBG .q4-5 {
    fill: rgb(1, 133, 113)
}

.BrBG .q0-6 {
    fill: rgb(140, 81, 10)
}

.BrBG .q1-6 {
    fill: rgb(216, 179, 101)
}

.BrBG .q2-6 {
    fill: rgb(246, 232, 195)
}

.BrBG .q3-6 {
    fill: rgb(199, 234, 229)
}

.BrBG .q4-6 {
    fill: rgb(90, 180, 172)
}

.BrBG .q5-6 {
    fill: rgb(1, 102, 94)
}

.BrBG .q0-7 {
    fill: rgb(140, 81, 10)
}

.BrBG .q1-7 {
    fill: rgb(216, 179, 101)
}

.BrBG .q2-7 {
    fill: rgb(246, 232, 195)
}

.BrBG .q3-7 {
    fill: rgb(245, 245, 245)
}

.BrBG .q4-7 {
    fill: rgb(199, 234, 229)
}

.BrBG .q5-7 {
    fill: rgb(90, 180, 172)
}

.BrBG .q6-7 {
    fill: rgb(1, 102, 94)
}

.BrBG .q0-8 {
    fill: rgb(140, 81, 10)
}

.BrBG .q1-8 {
    fill: rgb(191, 129, 45)
}

.BrBG .q2-8 {
    fill: rgb(223, 194, 125)
}

.BrBG .q3-8 {
    fill: rgb(246, 232, 195)
}

.BrBG .q4-8 {
    fill: rgb(199, 234, 229)
}

.BrBG .q5-8 {
    fill: rgb(128, 205, 193)
}

.BrBG .q6-8 {
    fill: rgb(53, 151, 143)
}

.BrBG .q7-8 {
    fill: rgb(1, 102, 94)
}

.BrBG .q0-9 {
    fill: rgb(140, 81, 10)
}

.BrBG .q1-9 {
    fill: rgb(191, 129, 45)
}

.BrBG .q2-9 {
    fill: rgb(223, 194, 125)
}

.BrBG .q3-9 {
    fill: rgb(246, 232, 195)
}

.BrBG .q4-9 {
    fill: rgb(245, 245, 245)
}

.BrBG .q5-9 {
    fill: rgb(199, 234, 229)
}

.BrBG .q6-9 {
    fill: rgb(128, 205, 193)
}

.BrBG .q7-9 {
    fill: rgb(53, 151, 143)
}

.BrBG .q8-9 {
    fill: rgb(1, 102, 94)
}

.BrBG .q0-10 {
    fill: rgb(84, 48, 5)
}

.BrBG .q1-10 {
    fill: rgb(140, 81, 10)
}

.BrBG .q2-10 {
    fill: rgb(191, 129, 45)
}

.BrBG .q3-10 {
    fill: rgb(223, 194, 125)
}

.BrBG .q4-10 {
    fill: rgb(246, 232, 195)
}

.BrBG .q5-10 {
    fill: rgb(199, 234, 229)
}

.BrBG .q6-10 {
    fill: rgb(128, 205, 193)
}

.BrBG .q7-10 {
    fill: rgb(53, 151, 143)
}

.BrBG .q8-10 {
    fill: rgb(1, 102, 94)
}

.BrBG .q9-10 {
    fill: rgb(0, 60, 48)
}

.BrBG .q0-11 {
    fill: rgb(84, 48, 5)
}

.BrBG .q1-11 {
    fill: rgb(140, 81, 10)
}

.BrBG .q2-11 {
    fill: rgb(191, 129, 45)
}

.BrBG .q3-11 {
    fill: rgb(223, 194, 125)
}

.BrBG .q4-11 {
    fill: rgb(246, 232, 195)
}

.BrBG .q5-11 {
    fill: rgb(245, 245, 245)
}

.BrBG .q6-11 {
    fill: rgb(199, 234, 229)
}

.BrBG .q7-11 {
    fill: rgb(128, 205, 193)
}

.BrBG .q8-11 {
    fill: rgb(53, 151, 143)
}

.BrBG .q9-11 {
    fill: rgb(1, 102, 94)
}

.BrBG .q10-11 {
    fill: rgb(0, 60, 48)
}

.PRGn .q0-3 {
    fill: rgb(175, 141, 195)
}

.PRGn .q1-3 {
    fill: rgb(247, 247, 247)
}

.PRGn .q2-3 {
    fill: rgb(127, 191, 123)
}

.PRGn .q0-4 {
    fill: rgb(123, 50, 148)
}

.PRGn .q1-4 {
    fill: rgb(194, 165, 207)
}

.PRGn .q2-4 {
    fill: rgb(166, 219, 160)
}

.PRGn .q3-4 {
    fill: rgb(0, 136, 55)
}

.PRGn .q0-5 {
    fill: rgb(123, 50, 148)
}

.PRGn .q1-5 {
    fill: rgb(194, 165, 207)
}

.PRGn .q2-5 {
    fill: rgb(247, 247, 247)
}

.PRGn .q3-5 {
    fill: rgb(166, 219, 160)
}

.PRGn .q4-5 {
    fill: rgb(0, 136, 55)
}

.PRGn .q0-6 {
    fill: rgb(118, 42, 131)
}

.PRGn .q1-6 {
    fill: rgb(175, 141, 195)
}

.PRGn .q2-6 {
    fill: rgb(231, 212, 232)
}

.PRGn .q3-6 {
    fill: rgb(217, 240, 211)
}

.PRGn .q4-6 {
    fill: rgb(127, 191, 123)
}

.PRGn .q5-6 {
    fill: rgb(27, 120, 55)
}

.PRGn .q0-7 {
    fill: rgb(118, 42, 131)
}

.PRGn .q1-7 {
    fill: rgb(175, 141, 195)
}

.PRGn .q2-7 {
    fill: rgb(231, 212, 232)
}

.PRGn .q3-7 {
    fill: rgb(247, 247, 247)
}

.PRGn .q4-7 {
    fill: rgb(217, 240, 211)
}

.PRGn .q5-7 {
    fill: rgb(127, 191, 123)
}

.PRGn .q6-7 {
    fill: rgb(27, 120, 55)
}

.PRGn .q0-8 {
    fill: rgb(118, 42, 131)
}

.PRGn .q1-8 {
    fill: rgb(153, 112, 171)
}

.PRGn .q2-8 {
    fill: rgb(194, 165, 207)
}

.PRGn .q3-8 {
    fill: rgb(231, 212, 232)
}

.PRGn .q4-8 {
    fill: rgb(217, 240, 211)
}

.PRGn .q5-8 {
    fill: rgb(166, 219, 160)
}

.PRGn .q6-8 {
    fill: rgb(90, 174, 97)
}

.PRGn .q7-8 {
    fill: rgb(27, 120, 55)
}

.PRGn .q0-9 {
    fill: rgb(118, 42, 131)
}

.PRGn .q1-9 {
    fill: rgb(153, 112, 171)
}

.PRGn .q2-9 {
    fill: rgb(194, 165, 207)
}

.PRGn .q3-9 {
    fill: rgb(231, 212, 232)
}

.PRGn .q4-9 {
    fill: rgb(247, 247, 247)
}

.PRGn .q5-9 {
    fill: rgb(217, 240, 211)
}

.PRGn .q6-9 {
    fill: rgb(166, 219, 160)
}

.PRGn .q7-9 {
    fill: rgb(90, 174, 97)
}

.PRGn .q8-9 {
    fill: rgb(27, 120, 55)
}

.PRGn .q0-10 {
    fill: rgb(64, 0, 75)
}

.PRGn .q1-10 {
    fill: rgb(118, 42, 131)
}

.PRGn .q2-10 {
    fill: rgb(153, 112, 171)
}

.PRGn .q3-10 {
    fill: rgb(194, 165, 207)
}

.PRGn .q4-10 {
    fill: rgb(231, 212, 232)
}

.PRGn .q5-10 {
    fill: rgb(217, 240, 211)
}

.PRGn .q6-10 {
    fill: rgb(166, 219, 160)
}

.PRGn .q7-10 {
    fill: rgb(90, 174, 97)
}

.PRGn .q8-10 {
    fill: rgb(27, 120, 55)
}

.PRGn .q9-10 {
    fill: rgb(0, 68, 27)
}

.PRGn .q0-11 {
    fill: rgb(64, 0, 75)
}

.PRGn .q1-11 {
    fill: rgb(118, 42, 131)
}

.PRGn .q2-11 {
    fill: rgb(153, 112, 171)
}

.PRGn .q3-11 {
    fill: rgb(194, 165, 207)
}

.PRGn .q4-11 {
    fill: rgb(231, 212, 232)
}

.PRGn .q5-11 {
    fill: rgb(247, 247, 247)
}

.PRGn .q6-11 {
    fill: rgb(217, 240, 211)
}

.PRGn .q7-11 {
    fill: rgb(166, 219, 160)
}

.PRGn .q8-11 {
    fill: rgb(90, 174, 97)
}

.PRGn .q9-11 {
    fill: rgb(27, 120, 55)
}

.PRGn .q10-11 {
    fill: rgb(0, 68, 27)
}

.PiYG .q0-3 {
    fill: rgb(233, 163, 201)
}

.PiYG .q1-3 {
    fill: rgb(247, 247, 247)
}

.PiYG .q2-3 {
    fill: rgb(161, 215, 106)
}

.PiYG .q0-4 {
    fill: rgb(208, 28, 139)
}

.PiYG .q1-4 {
    fill: rgb(241, 182, 218)
}

.PiYG .q2-4 {
    fill: rgb(184, 225, 134)
}

.PiYG .q3-4 {
    fill: rgb(77, 172, 38)
}

.PiYG .q0-5 {
    fill: rgb(208, 28, 139)
}

.PiYG .q1-5 {
    fill: rgb(241, 182, 218)
}

.PiYG .q2-5 {
    fill: rgb(247, 247, 247)
}

.PiYG .q3-5 {
    fill: rgb(184, 225, 134)
}

.PiYG .q4-5 {
    fill: rgb(77, 172, 38)
}

.PiYG .q0-6 {
    fill: rgb(197, 27, 125)
}

.PiYG .q1-6 {
    fill: rgb(233, 163, 201)
}

.PiYG .q2-6 {
    fill: rgb(253, 224, 239)
}

.PiYG .q3-6 {
    fill: rgb(230, 245, 208)
}

.PiYG .q4-6 {
    fill: rgb(161, 215, 106)
}

.PiYG .q5-6 {
    fill: rgb(77, 146, 33)
}

.PiYG .q0-7 {
    fill: rgb(197, 27, 125)
}

.PiYG .q1-7 {
    fill: rgb(233, 163, 201)
}

.PiYG .q2-7 {
    fill: rgb(253, 224, 239)
}

.PiYG .q3-7 {
    fill: rgb(247, 247, 247)
}

.PiYG .q4-7 {
    fill: rgb(230, 245, 208)
}

.PiYG .q5-7 {
    fill: rgb(161, 215, 106)
}

.PiYG .q6-7 {
    fill: rgb(77, 146, 33)
}

.PiYG .q0-8 {
    fill: rgb(197, 27, 125)
}

.PiYG .q1-8 {
    fill: rgb(222, 119, 174)
}

.PiYG .q2-8 {
    fill: rgb(241, 182, 218)
}

.PiYG .q3-8 {
    fill: rgb(253, 224, 239)
}

.PiYG .q4-8 {
    fill: rgb(230, 245, 208)
}

.PiYG .q5-8 {
    fill: rgb(184, 225, 134)
}

.PiYG .q6-8 {
    fill: rgb(127, 188, 65)
}

.PiYG .q7-8 {
    fill: rgb(77, 146, 33)
}

.PiYG .q0-9 {
    fill: rgb(197, 27, 125)
}

.PiYG .q1-9 {
    fill: rgb(222, 119, 174)
}

.PiYG .q2-9 {
    fill: rgb(241, 182, 218)
}

.PiYG .q3-9 {
    fill: rgb(253, 224, 239)
}

.PiYG .q4-9 {
    fill: rgb(247, 247, 247)
}

.PiYG .q5-9 {
    fill: rgb(230, 245, 208)
}

.PiYG .q6-9 {
    fill: rgb(184, 225, 134)
}

.PiYG .q7-9 {
    fill: rgb(127, 188, 65)
}

.PiYG .q8-9 {
    fill: rgb(77, 146, 33)
}

.PiYG .q0-10 {
    fill: rgb(142, 1, 82)
}

.PiYG .q1-10 {
    fill: rgb(197, 27, 125)
}

.PiYG .q2-10 {
    fill: rgb(222, 119, 174)
}

.PiYG .q3-10 {
    fill: rgb(241, 182, 218)
}

.PiYG .q4-10 {
    fill: rgb(253, 224, 239)
}

.PiYG .q5-10 {
    fill: rgb(230, 245, 208)
}

.PiYG .q6-10 {
    fill: rgb(184, 225, 134)
}

.PiYG .q7-10 {
    fill: rgb(127, 188, 65)
}

.PiYG .q8-10 {
    fill: rgb(77, 146, 33)
}

.PiYG .q9-10 {
    fill: rgb(39, 100, 25)
}

.PiYG .q0-11 {
    fill: rgb(142, 1, 82)
}

.PiYG .q1-11 {
    fill: rgb(197, 27, 125)
}

.PiYG .q2-11 {
    fill: rgb(222, 119, 174)
}

.PiYG .q3-11 {
    fill: rgb(241, 182, 218)
}

.PiYG .q4-11 {
    fill: rgb(253, 224, 239)
}

.PiYG .q5-11 {
    fill: rgb(247, 247, 247)
}

.PiYG .q6-11 {
    fill: rgb(230, 245, 208)
}

.PiYG .q7-11 {
    fill: rgb(184, 225, 134)
}

.PiYG .q8-11 {
    fill: rgb(127, 188, 65)
}

.PiYG .q9-11 {
    fill: rgb(77, 146, 33)
}

.PiYG .q10-11 {
    fill: rgb(39, 100, 25)
}

.RdBu .q0-3 {
    fill: rgb(239, 138, 98)
}

.RdBu .q1-3 {
    fill: rgb(247, 247, 247)
}

.RdBu .q2-3 {
    fill: rgb(103, 169, 207)
}

.RdBu .q0-4 {
    fill: rgb(202, 0, 32)
}

.RdBu .q1-4 {
    fill: rgb(244, 165, 130)
}

.RdBu .q2-4 {
    fill: rgb(146, 197, 222)
}

.RdBu .q3-4 {
    fill: rgb(5, 113, 176)
}

.RdBu .q0-5 {
    fill: rgb(202, 0, 32)
}

.RdBu .q1-5 {
    fill: rgb(244, 165, 130)
}

.RdBu .q2-5 {
    fill: rgb(247, 247, 247)
}

.RdBu .q3-5 {
    fill: rgb(146, 197, 222)
}

.RdBu .q4-5 {
    fill: rgb(5, 113, 176)
}

.RdBu .q0-6 {
    fill: rgb(178, 24, 43)
}

.RdBu .q1-6 {
    fill: rgb(239, 138, 98)
}

.RdBu .q2-6 {
    fill: rgb(253, 219, 199)
}

.RdBu .q3-6 {
    fill: rgb(209, 229, 240)
}

.RdBu .q4-6 {
    fill: rgb(103, 169, 207)
}

.RdBu .q5-6 {
    fill: rgb(33, 102, 172)
}

.RdBu .q0-7 {
    fill: rgb(178, 24, 43)
}

.RdBu .q1-7 {
    fill: rgb(239, 138, 98)
}

.RdBu .q2-7 {
    fill: rgb(253, 219, 199)
}

.RdBu .q3-7 {
    fill: rgb(247, 247, 247)
}

.RdBu .q4-7 {
    fill: rgb(209, 229, 240)
}

.RdBu .q5-7 {
    fill: rgb(103, 169, 207)
}

.RdBu .q6-7 {
    fill: rgb(33, 102, 172)
}

.RdBu .q0-8 {
    fill: rgb(178, 24, 43)
}

.RdBu .q1-8 {
    fill: rgb(214, 96, 77)
}

.RdBu .q2-8 {
    fill: rgb(244, 165, 130)
}

.RdBu .q3-8 {
    fill: rgb(253, 219, 199)
}

.RdBu .q4-8 {
    fill: rgb(209, 229, 240)
}

.RdBu .q5-8 {
    fill: rgb(146, 197, 222)
}

.RdBu .q6-8 {
    fill: rgb(67, 147, 195)
}

.RdBu .q7-8 {
    fill: rgb(33, 102, 172)
}

.RdBu .q0-9 {
    fill: rgb(178, 24, 43)
}

.RdBu .q1-9 {
    fill: rgb(214, 96, 77)
}

.RdBu .q2-9 {
    fill: rgb(244, 165, 130)
}

.RdBu .q3-9 {
    fill: rgb(253, 219, 199)
}

.RdBu .q4-9 {
    fill: rgb(247, 247, 247)
}

.RdBu .q5-9 {
    fill: rgb(209, 229, 240)
}

.RdBu .q6-9 {
    fill: rgb(146, 197, 222)
}

.RdBu .q7-9 {
    fill: rgb(67, 147, 195)
}

.RdBu .q8-9 {
    fill: rgb(33, 102, 172)
}

.RdBu .q0-10 {
    fill: rgb(103, 0, 31)
}

.RdBu .q1-10 {
    fill: rgb(178, 24, 43)
}

.RdBu .q2-10 {
    fill: rgb(214, 96, 77)
}

.RdBu .q3-10 {
    fill: rgb(244, 165, 130)
}

.RdBu .q4-10 {
    fill: rgb(253, 219, 199)
}

.RdBu .q5-10 {
    fill: rgb(209, 229, 240)
}

.RdBu .q6-10 {
    fill: rgb(146, 197, 222)
}

.RdBu .q7-10 {
    fill: rgb(67, 147, 195)
}

.RdBu .q8-10 {
    fill: rgb(33, 102, 172)
}

.RdBu .q9-10 {
    fill: rgb(5, 48, 97)
}

.RdBu .q0-11 {
    fill: rgb(103, 0, 31)
}

.RdBu .q1-11 {
    fill: rgb(178, 24, 43)
}

.RdBu .q2-11 {
    fill: rgb(214, 96, 77)
}

.RdBu .q3-11 {
    fill: rgb(244, 165, 130)
}

.RdBu .q4-11 {
    fill: rgb(253, 219, 199)
}

.RdBu .q5-11 {
    fill: rgb(247, 247, 247)
}

.RdBu .q6-11 {
    fill: rgb(209, 229, 240)
}

.RdBu .q7-11 {
    fill: rgb(146, 197, 222)
}

.RdBu .q8-11 {
    fill: rgb(67, 147, 195)
}

.RdBu .q9-11 {
    fill: rgb(33, 102, 172)
}

.RdBu .q10-11 {
    fill: rgb(5, 48, 97)
}

.RdGy .q0-3 {
    fill: rgb(239, 138, 98)
}

.RdGy .q1-3 {
    fill: rgb(255, 255, 255)
}

.RdGy .q2-3 {
    fill: rgb(153, 153, 153)
}

.RdGy .q0-4 {
    fill: rgb(202, 0, 32)
}

.RdGy .q1-4 {
    fill: rgb(244, 165, 130)
}

.RdGy .q2-4 {
    fill: rgb(186, 186, 186)
}

.RdGy .q3-4 {
    fill: rgb(64, 64, 64)
}

.RdGy .q0-5 {
    fill: rgb(202, 0, 32)
}

.RdGy .q1-5 {
    fill: rgb(244, 165, 130)
}

.RdGy .q2-5 {
    fill: rgb(255, 255, 255)
}

.RdGy .q3-5 {
    fill: rgb(186, 186, 186)
}

.RdGy .q4-5 {
    fill: rgb(64, 64, 64)
}

.RdGy .q0-6 {
    fill: rgb(178, 24, 43)
}

.RdGy .q1-6 {
    fill: rgb(239, 138, 98)
}

.RdGy .q2-6 {
    fill: rgb(253, 219, 199)
}

.RdGy .q3-6 {
    fill: rgb(224, 224, 224)
}

.RdGy .q4-6 {
    fill: rgb(153, 153, 153)
}

.RdGy .q5-6 {
    fill: rgb(77, 77, 77)
}

.RdGy .q0-7 {
    fill: rgb(178, 24, 43)
}

.RdGy .q1-7 {
    fill: rgb(239, 138, 98)
}

.RdGy .q2-7 {
    fill: rgb(253, 219, 199)
}

.RdGy .q3-7 {
    fill: rgb(255, 255, 255)
}

.RdGy .q4-7 {
    fill: rgb(224, 224, 224)
}

.RdGy .q5-7 {
    fill: rgb(153, 153, 153)
}

.RdGy .q6-7 {
    fill: rgb(77, 77, 77)
}

.RdGy .q0-8 {
    fill: rgb(178, 24, 43)
}

.RdGy .q1-8 {
    fill: rgb(214, 96, 77)
}

.RdGy .q2-8 {
    fill: rgb(244, 165, 130)
}

.RdGy .q3-8 {
    fill: rgb(253, 219, 199)
}

.RdGy .q4-8 {
    fill: rgb(224, 224, 224)
}

.RdGy .q5-8 {
    fill: rgb(186, 186, 186)
}

.RdGy .q6-8 {
    fill: rgb(135, 135, 135)
}

.RdGy .q7-8 {
    fill: rgb(77, 77, 77)
}

.RdGy .q0-9 {
    fill: rgb(178, 24, 43)
}

.RdGy .q1-9 {
    fill: rgb(214, 96, 77)
}

.RdGy .q2-9 {
    fill: rgb(244, 165, 130)
}

.RdGy .q3-9 {
    fill: rgb(253, 219, 199)
}

.RdGy .q4-9 {
    fill: rgb(255, 255, 255)
}

.RdGy .q5-9 {
    fill: rgb(224, 224, 224)
}

.RdGy .q6-9 {
    fill: rgb(186, 186, 186)
}

.RdGy .q7-9 {
    fill: rgb(135, 135, 135)
}

.RdGy .q8-9 {
    fill: rgb(77, 77, 77)
}

.RdGy .q0-10 {
    fill: rgb(103, 0, 31)
}

.RdGy .q1-10 {
    fill: rgb(178, 24, 43)
}

.RdGy .q2-10 {
    fill: rgb(214, 96, 77)
}

.RdGy .q3-10 {
    fill: rgb(244, 165, 130)
}

.RdGy .q4-10 {
    fill: rgb(253, 219, 199)
}

.RdGy .q5-10 {
    fill: rgb(224, 224, 224)
}

.RdGy .q6-10 {
    fill: rgb(186, 186, 186)
}

.RdGy .q7-10 {
    fill: rgb(135, 135, 135)
}

.RdGy .q8-10 {
    fill: rgb(77, 77, 77)
}

.RdGy .q9-10 {
    fill: rgb(26, 26, 26)
}

.RdGy .q0-11 {
    fill: rgb(103, 0, 31)
}

.RdGy .q1-11 {
    fill: rgb(178, 24, 43)
}

.RdGy .q2-11 {
    fill: rgb(214, 96, 77)
}

.RdGy .q3-11 {
    fill: rgb(244, 165, 130)
}

.RdGy .q4-11 {
    fill: rgb(253, 219, 199)
}

.RdGy .q5-11 {
    fill: rgb(255, 255, 255)
}

.RdGy .q6-11 {
    fill: rgb(224, 224, 224)
}

.RdGy .q7-11 {
    fill: rgb(186, 186, 186)
}

.RdGy .q8-11 {
    fill: rgb(135, 135, 135)
}

.RdGy .q9-11 {
    fill: rgb(77, 77, 77)
}

.RdGy .q10-11 {
    fill: rgb(26, 26, 26)
}

.RdYlBu .q0-3 {
    fill: rgb(252, 141, 89)
}

.RdYlBu .q1-3 {
    fill: rgb(255, 255, 191)
}

.RdYlBu .q2-3 {
    fill: rgb(145, 191, 219)
}

.RdYlBu .q0-4 {
    fill: rgb(215, 25, 28)
}

.RdYlBu .q1-4 {
    fill: rgb(253, 174, 97)
}

.RdYlBu .q2-4 {
    fill: rgb(171, 217, 233)
}

.RdYlBu .q3-4 {
    fill: rgb(44, 123, 182)
}

.RdYlBu .q0-5 {
    fill: rgb(215, 25, 28)
}

.RdYlBu .q1-5 {
    fill: rgb(253, 174, 97)
}

.RdYlBu .q2-5 {
    fill: rgb(255, 255, 191)
}

.RdYlBu .q3-5 {
    fill: rgb(171, 217, 233)
}

.RdYlBu .q4-5 {
    fill: rgb(44, 123, 182)
}

.RdYlBu .q0-6 {
    fill: rgb(215, 48, 39)
}

.RdYlBu .q1-6 {
    fill: rgb(252, 141, 89)
}

.RdYlBu .q2-6 {
    fill: rgb(254, 224, 144)
}

.RdYlBu .q3-6 {
    fill: rgb(224, 243, 248)
}

.RdYlBu .q4-6 {
    fill: rgb(145, 191, 219)
}

.RdYlBu .q5-6 {
    fill: rgb(69, 117, 180)
}

.RdYlBu .q0-7 {
    fill: rgb(215, 48, 39)
}

.RdYlBu .q1-7 {
    fill: rgb(252, 141, 89)
}

.RdYlBu .q2-7 {
    fill: rgb(254, 224, 144)
}

.RdYlBu .q3-7 {
    fill: rgb(255, 255, 191)
}

.RdYlBu .q4-7 {
    fill: rgb(224, 243, 248)
}

.RdYlBu .q5-7 {
    fill: rgb(145, 191, 219)
}

.RdYlBu .q6-7 {
    fill: rgb(69, 117, 180)
}

.RdYlBu .q0-8 {
    fill: rgb(215, 48, 39)
}

.RdYlBu .q1-8 {
    fill: rgb(244, 109, 67)
}

.RdYlBu .q2-8 {
    fill: rgb(253, 174, 97)
}

.RdYlBu .q3-8 {
    fill: rgb(254, 224, 144)
}

.RdYlBu .q4-8 {
    fill: rgb(224, 243, 248)
}

.RdYlBu .q5-8 {
    fill: rgb(171, 217, 233)
}

.RdYlBu .q6-8 {
    fill: rgb(116, 173, 209)
}

.RdYlBu .q7-8 {
    fill: rgb(69, 117, 180)
}

.RdYlBu .q0-9 {
    fill: rgb(215, 48, 39)
}

.RdYlBu .q1-9 {
    fill: rgb(244, 109, 67)
}

.RdYlBu .q2-9 {
    fill: rgb(253, 174, 97)
}

.RdYlBu .q3-9 {
    fill: rgb(254, 224, 144)
}

.RdYlBu .q4-9 {
    fill: rgb(255, 255, 191)
}

.RdYlBu .q5-9 {
    fill: rgb(224, 243, 248)
}

.RdYlBu .q6-9 {
    fill: rgb(171, 217, 233)
}

.RdYlBu .q7-9 {
    fill: rgb(116, 173, 209)
}

.RdYlBu .q8-9 {
    fill: rgb(69, 117, 180)
}

.RdYlBu .q0-10 {
    fill: rgb(165, 0, 38)
}

.RdYlBu .q1-10 {
    fill: rgb(215, 48, 39)
}

.RdYlBu .q2-10 {
    fill: rgb(244, 109, 67)
}

.RdYlBu .q3-10 {
    fill: rgb(253, 174, 97)
}

.RdYlBu .q4-10 {
    fill: rgb(254, 224, 144)
}

.RdYlBu .q5-10 {
    fill: rgb(224, 243, 248)
}

.RdYlBu .q6-10 {
    fill: rgb(171, 217, 233)
}

.RdYlBu .q7-10 {
    fill: rgb(116, 173, 209)
}

.RdYlBu .q8-10 {
    fill: rgb(69, 117, 180)
}

.RdYlBu .q9-10 {
    fill: rgb(49, 54, 149)
}

.RdYlBu .q0-11 {
    fill: rgb(165, 0, 38)
}

.RdYlBu .q1-11 {
    fill: rgb(215, 48, 39)
}

.RdYlBu .q2-11 {
    fill: rgb(244, 109, 67)
}

.RdYlBu .q3-11 {
    fill: rgb(253, 174, 97)
}

.RdYlBu .q4-11 {
    fill: rgb(254, 224, 144)
}

.RdYlBu .q5-11 {
    fill: rgb(255, 255, 191)
}

.RdYlBu .q6-11 {
    fill: rgb(224, 243, 248)
}

.RdYlBu .q7-11 {
    fill: rgb(171, 217, 233)
}

.RdYlBu .q8-11 {
    fill: rgb(116, 173, 209)
}

.RdYlBu .q9-11 {
    fill: rgb(69, 117, 180)
}

.RdYlBu .q10-11 {
    fill: rgb(49, 54, 149)
}

.Spectral .q0-3 {
    fill: rgb(252, 141, 89)
}

.Spectral .q1-3 {
    fill: rgb(255, 255, 191)
}

.Spectral .q2-3 {
    fill: rgb(153, 213, 148)
}

.Spectral .q0-4 {
    fill: rgb(215, 25, 28)
}

.Spectral .q1-4 {
    fill: rgb(253, 174, 97)
}

.Spectral .q2-4 {
    fill: rgb(171, 221, 164)
}

.Spectral .q3-4 {
    fill: rgb(43, 131, 186)
}

.Spectral .q0-5 {
    fill: rgb(215, 25, 28)
}

.Spectral .q1-5 {
    fill: rgb(253, 174, 97)
}

.Spectral .q2-5 {
    fill: rgb(255, 255, 191)
}

.Spectral .q3-5 {
    fill: rgb(171, 221, 164)
}

.Spectral .q4-5 {
    fill: rgb(43, 131, 186)
}

.Spectral .q0-6 {
    fill: rgb(213, 62, 79)
}

.Spectral .q1-6 {
    fill: rgb(252, 141, 89)
}

.Spectral .q2-6 {
    fill: rgb(254, 224, 139)
}

.Spectral .q3-6 {
    fill: rgb(230, 245, 152)
}

.Spectral .q4-6 {
    fill: rgb(153, 213, 148)
}

.Spectral .q5-6 {
    fill: rgb(50, 136, 189)
}

.Spectral .q0-7 {
    fill: rgb(213, 62, 79)
}

.Spectral .q1-7 {
    fill: rgb(252, 141, 89)
}

.Spectral .q2-7 {
    fill: rgb(254, 224, 139)
}

.Spectral .q3-7 {
    fill: rgb(255, 255, 191)
}

.Spectral .q4-7 {
    fill: rgb(230, 245, 152)
}

.Spectral .q5-7 {
    fill: rgb(153, 213, 148)
}

.Spectral .q6-7 {
    fill: rgb(50, 136, 189)
}

.Spectral .q0-8 {
    fill: rgb(213, 62, 79)
}

.Spectral .q1-8 {
    fill: rgb(244, 109, 67)
}

.Spectral .q2-8 {
    fill: rgb(253, 174, 97)
}

.Spectral .q3-8 {
    fill: rgb(254, 224, 139)
}

.Spectral .q4-8 {
    fill: rgb(230, 245, 152)
}

.Spectral .q5-8 {
    fill: rgb(171, 221, 164)
}

.Spectral .q6-8 {
    fill: rgb(102, 194, 165)
}

.Spectral .q7-8 {
    fill: rgb(50, 136, 189)
}

.Spectral .q0-9 {
    fill: rgb(213, 62, 79)
}

.Spectral .q1-9 {
    fill: rgb(244, 109, 67)
}

.Spectral .q2-9 {
    fill: rgb(253, 174, 97)
}

.Spectral .q3-9 {
    fill: rgb(254, 224, 139)
}

.Spectral .q4-9 {
    fill: rgb(255, 255, 191)
}

.Spectral .q5-9 {
    fill: rgb(230, 245, 152)
}

.Spectral .q6-9 {
    fill: rgb(171, 221, 164)
}

.Spectral .q7-9 {
    fill: rgb(102, 194, 165)
}

.Spectral .q8-9 {
    fill: rgb(50, 136, 189)
}

.Spectral .q0-10 {
    fill: rgb(158, 1, 66)
}

.Spectral .q1-10 {
    fill: rgb(213, 62, 79)
}

.Spectral .q2-10 {
    fill: rgb(244, 109, 67)
}

.Spectral .q3-10 {
    fill: rgb(253, 174, 97)
}

.Spectral .q4-10 {
    fill: rgb(254, 224, 139)
}

.Spectral .q5-10 {
    fill: rgb(230, 245, 152)
}

.Spectral .q6-10 {
    fill: rgb(171, 221, 164)
}

.Spectral .q7-10 {
    fill: rgb(102, 194, 165)
}

.Spectral .q8-10 {
    fill: rgb(50, 136, 189)
}

.Spectral .q9-10 {
    fill: rgb(94, 79, 162)
}

.Spectral .q0-11 {
    fill: rgb(158, 1, 66)
}

.Spectral .q1-11 {
    fill: rgb(213, 62, 79)
}

.Spectral .q2-11 {
    fill: rgb(244, 109, 67)
}

.Spectral .q3-11 {
    fill: rgb(253, 174, 97)
}

.Spectral .q4-11 {
    fill: rgb(254, 224, 139)
}

.Spectral .q5-11 {
    fill: rgb(255, 255, 191)
}

.Spectral .q6-11 {
    fill: rgb(230, 245, 152)
}

.Spectral .q7-11 {
    fill: rgb(171, 221, 164)
}

.Spectral .q8-11 {
    fill: rgb(102, 194, 165)
}

.Spectral .q9-11 {
    fill: rgb(50, 136, 189)
}

.Spectral .q10-11 {
    fill: rgb(94, 79, 162)
}

.RdYlGn .q0-3 {
    fill: rgb(252, 141, 89)
}

.RdYlGn .q1-3 {
    fill: rgb(255, 255, 191)
}

.RdYlGn .q2-3 {
    fill: rgb(145, 207, 96)
}

.RdYlGn .q0-4 {
    fill: rgb(215, 25, 28)
}

.RdYlGn .q1-4 {
    fill: rgb(253, 174, 97)
}

.RdYlGn .q2-4 {
    fill: rgb(166, 217, 106)
}

.RdYlGn .q3-4 {
    fill: rgb(26, 150, 65)
}

.RdYlGn .q0-5 {
    fill: rgb(215, 25, 28)
}

.RdYlGn .q1-5 {
    fill: rgb(253, 174, 97)
}

.RdYlGn .q2-5 {
    fill: rgb(255, 255, 191)
}

.RdYlGn .q3-5 {
    fill: rgb(166, 217, 106)
}

.RdYlGn .q4-5 {
    fill: rgb(26, 150, 65)
}

.RdYlGn .q0-6 {
    fill: rgb(215, 48, 39)
}

.RdYlGn .q1-6 {
    fill: rgb(252, 141, 89)
}

.RdYlGn .q2-6 {
    fill: rgb(254, 224, 139)
}

.RdYlGn .q3-6 {
    fill: rgb(217, 239, 139)
}

.RdYlGn .q4-6 {
    fill: rgb(145, 207, 96)
}

.RdYlGn .q5-6 {
    fill: rgb(26, 152, 80)
}

.RdYlGn .q0-7 {
    fill: rgb(215, 48, 39)
}

.RdYlGn .q1-7 {
    fill: rgb(252, 141, 89)
}

.RdYlGn .q2-7 {
    fill: rgb(254, 224, 139)
}

.RdYlGn .q3-7 {
    fill: rgb(255, 255, 191)
}

.RdYlGn .q4-7 {
    fill: rgb(217, 239, 139)
}

.RdYlGn .q5-7 {
    fill: rgb(145, 207, 96)
}

.RdYlGn .q6-7 {
    fill: rgb(26, 152, 80)
}

.RdYlGn .q0-8 {
    fill: rgb(215, 48, 39)
}

.RdYlGn .q1-8 {
    fill: rgb(244, 109, 67)
}

.RdYlGn .q2-8 {
    fill: rgb(253, 174, 97)
}

.RdYlGn .q3-8 {
    fill: rgb(254, 224, 139)
}

.RdYlGn .q4-8 {
    fill: rgb(217, 239, 139)
}

.RdYlGn .q5-8 {
    fill: rgb(166, 217, 106)
}

.RdYlGn .q6-8 {
    fill: rgb(102, 189, 99)
}

.RdYlGn .q7-8 {
    fill: rgb(26, 152, 80)
}

.RdYlGn .q0-9 {
    fill: rgb(215, 48, 39)
}

.RdYlGn .q1-9 {
    fill: rgb(244, 109, 67)
}

.RdYlGn .q2-9 {
    fill: rgb(253, 174, 97)
}

.RdYlGn .q3-9 {
    fill: rgb(254, 224, 139)
}

.RdYlGn .q4-9 {
    fill: rgb(255, 255, 191)
}

.RdYlGn .q5-9 {
    fill: rgb(217, 239, 139)
}

.RdYlGn .q6-9 {
    fill: rgb(166, 217, 106)
}

.RdYlGn .q7-9 {
    fill: rgb(102, 189, 99)
}

.RdYlGn .q8-9 {
    fill: rgb(26, 152, 80)
}

.RdYlGn .q0-10 {
    fill: rgb(165, 0, 38)
}

.RdYlGn .q1-10 {
    fill: rgb(215, 48, 39)
}

.RdYlGn .q2-10 {
    fill: rgb(244, 109, 67)
}

.RdYlGn .q3-10 {
    fill: rgb(253, 174, 97)
}

.RdYlGn .q4-10 {
    fill: rgb(254, 224, 139)
}

.RdYlGn .q5-10 {
    fill: rgb(217, 239, 139)
}

.RdYlGn .q6-10 {
    fill: rgb(166, 217, 106)
}

.RdYlGn .q7-10 {
    fill: rgb(102, 189, 99)
}

.RdYlGn .q8-10 {
    fill: rgb(26, 152, 80)
}

.RdYlGn .q9-10 {
    fill: rgb(0, 104, 55)
}

.RdYlGn .q0-11 {
    fill: rgb(165, 0, 38)
}

.RdYlGn .q1-11 {
    fill: rgb(215, 48, 39)
}

.RdYlGn .q2-11 {
    fill: rgb(244, 109, 67)
}

.RdYlGn .q3-11 {
    fill: rgb(253, 174, 97)
}

.RdYlGn .q4-11 {
    fill: rgb(254, 224, 139)
}

.RdYlGn .q5-11 {
    fill: rgb(255, 255, 191)
}

.RdYlGn .q6-11 {
    fill: rgb(217, 239, 139)
}

.RdYlGn .q7-11 {
    fill: rgb(166, 217, 106)
}

.RdYlGn .q8-11 {
    fill: rgb(102, 189, 99)
}

.RdYlGn .q9-11 {
    fill: rgb(26, 152, 80)
}

.RdYlGn .q10-11 {
    fill: rgb(0, 104, 55)
}
.full-height {
    float: left;
    height: 100%;
    width: 100%;
}

.dashboard * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.dashboard .wmui-header {
    margin: 0;
    padding: 10px;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    height: 74px;
}

.dashboard .wmui-toolbox {
    position: absolute;
    top: 15px;
    right: 0;
}

.dashboard .wmui-header h2, .dashboard .wmui-header h5 {
    margin: 0;
}

.dashboard .content {
    position: absolute;
    border: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    /* min-width: 1000px; */
    min-height: 783px;
}

#widgets-wrapper.edit-mode {
    border: dashed 1px #8A8A8A;
    box-shadow: none;
    border-radius: 2px;
    padding: 1% 0 0 1%;
    margin: 1%;
}

.dashboard .content .automation {
    position: relative;
    padding: 0;
    float: left;
    width: 100%;
    min-width: 1000px;
    height: 40%;
    min-height: 400px;
}

.dashboard .content .info {
    position: relative;
    padding: 0;
    float: left;
    width: 12%;
    min-width: 120px;
    height: 32%;
    min-height: 250px;
}

.dashboard .content .info .section {
    padding: 20px 0 0 0;
    margin: 0;
}

.dashboard .content .info .section .head .title {
    font-size: 11px;
    padding-left: 10px;
    text-transform: none;
}

.dashboard .content .info .section .body li {
    padding-left: 10px;
}

.dashboard .content .half {
    position: relative;
    float: left;
    width: 50%;
    min-width: 500px;
    height: 25%;
    min-height: 250px;
}

.dashboard .content .third {
    position: relative;
    float: left;
    width: 33%;
    min-width: 333px;
    height: 33%;
    min-height: 250px;
}

.dashboard table#automation {
    margin: 0 0 25px 25px;
    width: auto;
    border-collapse: separate;
}

.dashboard table#automation th, .dashboard table#automation td {
    width: auto;
    padding: 0 10px;
    font-weight: bold;
}

.dashboard table#automation td {
    border: 1px solid #FFFFFF;
    border-left-width: 0;
    border-right-width: 0;
}

.dashboard table#automation td.values {
    font-weight: normal;
    text-align: center;
}

.objectives, .trends, .costs {
    background: none repeat scroll 0 0 #F9F9F9;
    background: -moz-linear-gradient(to bottom, #EEEEEE, #DDDDDD);
    background: -webkit-gradient(linear, left top, left bottom, from(#EEEEEE), to(#DDDDDD));
    filter: progid:DXImageTransform.Microsoft.Gradient(StartColorStr='#EEEEEE', EndColorStr='#DDDDDD', GradientType=0);
    border: 1px solid #DDDDDD;
    border-radius: 3px 3px 3px 3px;
    box-shadow: 3px 3px 5px #F8F8F8;
    margin: 10px;
    width: 500px !important;
    min-width: 500px !important;
}

.costs, .trends {
    width: 400px !important;
    min-width: 400px !important;
}

.rebuild-button, .sort-button {
    float: right !important;
    width: 30px !important;
    line-height: 40px !important;
    margin-right: 0 !important;
    cursor: pointer;
}

/* New dashboard */

.dashboard-inner {
    padding-left: 20px;
    height: 55px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.global-dashboard-title {
    display: flex;
    font-size: 20px;
    text-align: left;
    line-height: 20px;
    vertical-align: middle;
    color: #777777;
    text-shadow: 0 1px 0 #FFFFFF;
    margin-right: auto;
}

.global-dashboard-title svg {
    margin-right: 10px;
}

.dashboard-inner-edit {
    margin-top: 10px;
    padding-left: 20px;
    height: 30px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.dashboard-inner-edit.hidden-transition {
    margin-top: 0px;
}

.global-dashboard-edit-title {
    display: flex;
    font-size: 12px;
    text-align: left;
    line-height: 12px;
    vertical-align: middle;
    color: #777777;
    text-shadow: 0 1px 0 #FFFFFF;
    margin-right: auto;
}

.global-dashboard-edit-title svg {
    margin-right: 10px;
}

.navbar .nav.dashboard-options {
    display: flex;
    margin-left: auto;
}

.navbar.dashboard-navbar {
    margin: 1% 1% 0 1%;
}

.dashboard.edit-mode .dashboard-inner {
    display: none;
}
.per-box dl {
    margin: 1em;
    font-size: 1em;
    line-height: 1.5em;
    overflow: hidden;
}

.per-box dl dt {
    font-weight: bold;
    float: left;
    width: auto;
    text-align: left;
    padding-right: 5px;
    font-size: 0.9167em;
    line-height: 1.6364em;
    clear: both;
}

.per-box dl dt::first-letter {
    text-transform: capitalize;
}

.per-box dl dt.wise-box-name {
    width: auto;
}

.per-box dd {
    font-size: 1em;
    line-height: 1.5em;
    float: left;
    width: auto;
}

.per-box dd select {
    margin: .5em 0;
}

dd.link {
    text-decoration: underline;
    cursor: pointer;
}

.intervals.no-border table.interval {
    border: none;
}

span.wise-box-schedule {
    text-decoration: underline;
    cursor: pointer;
}
#toolbar {
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    height: 50px;
    border: 0;
    display: -webkit-box;
    background-color: #224C4F;
}

#toolbar .main-logo {
    left: 10px;
    max-width: 180px;
    position: absolute;
    top: 10px;
}

#toolbar .menu {
    font-size: 11px;
    color: white;
    height: 35px;
    position: absolute;
    left: 215px;
    right: 0;
    top: 8px;
    z-index: 100;
    line-height: 35px;
}

#toolbar .menu .item {
    float: left;
    margin-right: 15px;
}

#toolbar .menu .item.organization {
    float: right;
    margin-top: 7px;
}

#toolbar .menu .item.username {
    float: right;
}

#toolbar .menu .item.notifications,
#toolbar .menu .item.wise-store {
    cursor: pointer;
    float: right;
    margin-right: 20px;
    height: inherit;
    margin-top: 5px;
    &:hover {
        color: #8BC53F;

        .dropdown-main-icon {
            color: #8BC53F;
        }
    };
}

#toolbar .menu .item .dropdown .dropdown-main:not(.current_user) {
    &:hover {
        color: #8BC53F;

        .dropdown-main-icon {
            color: #8BC53F;
        }
    }
}

#toolbar .menu .item.notifications .badge {
    background-color: #E94547;
    border-radius: 10px;
    color: white;
    cursor: pointer;
    font-size: 9px;
    font-weight: bold;
    height: 10px;
    line-height: 9px;
    padding: 2px 4px 2px 3px;
    position: relative;
    right: -10px;
    text-align: center;
    top: -40px;
    white-space: nowrap;
    width: auto;
}

#toolbar .menu .item.change-organization {
    cursor: pointer;
    float: right;
    margin-right: 15px;
    height: inherit;
}

#toolbar .menu .item.change-organization #organizations {
    background-color: transparent;
    padding-right: 2px;
    border: none;
    color: #8BC53F;
    font-weight: bold;
    font-size: 12px;
    height: 32px;
    text-align: right;
    margin-top: -4px;
}

#toolbar .menu .logo * {
    height: 20px;
    margin: 8px 0 0 0;
}

.dropdown {
    cursor: pointer;
}

.dropdown a {
    color: white;
}

.dropdown a:hover {
    text-decoration: none;
}

.dropdown-main::first-letter {
    text-transform: capitalize;
}

.dropdown-main.current_user {
    border-radius: 50%;
    background-color: #8BC53F;
    font-weight: bold;
    font-size: 11px;
    color: #224C4F;
    height: 34px;
    text-align: center;
    width: 34px;
}

.dropdown-main.content {
    border-radius: 50%;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    height: 34px;
    text-align: center;
    width: 34px;
    display: flex;
    flex-flow: column;
    justify-content: space-around;

    &:hover {
        background-color: #EEEEEE;
        color: #224C4F !important;
        font-weight: bold;
        font-size: 16px;
    }
}

.dropdown:hover .dropdown-main:not(.content) {
    color: white;
}

.dropdown:hover .dropdown-main.content {
    background-color: #EEEEEE;
    color: #224C4F !important;
    font-weight: bold;
    font-size: 16px;
}

.dropdown-main img {
    margin-top: 7px;
}

.dropdown-section:hover::after {
    border-bottom-color: #7A9395;
}

.dropdown-section::after {
    border: 5px solid rgba(48, 48, 48, 0);
    border-bottom-color: #224C4F;
    bottom: 100%;
    content: " ";
    height: 0;
    left: 50%;
    margin-left: -5px;
    pointer-events: none;
    position: absolute;
    right: auto;
    text-align: center;
    transform: translate(-50%, 0);
}

.dropdown-section {
    background-clip: padding-box;
    background-color: #224C4F;
    border-radius: 0;
    border-top: 15px solid transparent;
    display: none;
    left: 50%;
    position: absolute;
    /* https://stackoverflow.com/a/28078054/1787187 */
    right: auto;
    text-align: center;
    transform: translate(-50%, 0);
    width: 200px;
}

.dropdown-section::first-letter {
    text-transform: capitalize;
}

.dropdown-section.menu-right::after {
    border: 5px solid rgba(48, 48, 48, 0);
    border-bottom-color: #224C4F;
    bottom: 100%;
    content: " ";
    height: 0;
    left: 95%;
    pointer-events: none;
    position: absolute;
    right: auto;
    text-align: center;
    transform: translate(-50%, 0);
}

.dropdown-section.menu-right {
    background-clip: padding-box;
    background-color: #224C4F;
    border-radius: 0;
    border-top: 17px solid transparent;
    display: none;
    left: -230%;
    position: absolute;
    /* https://stackoverflow.com/a/28078054/1787187 */
    right: auto;
    text-align: center;
    transform: translate(-50%, 0);
    width: 220px;
}

.dropdown-section.content::after {
    border: 5px solid rgba(48, 48, 48, 0);
    border-bottom-color: #224C4F;
    bottom: 100%;
    content: " ";
    height: 0;
    pointer-events: none;
    position: absolute;
    right: auto;
    text-align: center;
    transform: translate(-50%, 0);
    left: 95%;
}

.dropdown-section.content {
    z-index: 1000;
    left: -230%;
    position: absolute;
    /* https://stackoverflow.com/a/28078054/1787187 */
    right: auto;
    transform: translate(-50%, 0);
    width: 220px;
}

.dropdown-section.content > a > .dropdown-section-item {
    padding: 10px;
}

.dropdown-toggle::after {
    float: right;
}

.dropdown-section-icon, .dropdown-main-icon {
    color: white;
    float: left;
    font-size: 14px;
    margin: 0 14px;
    min-width: 22px;
    text-align: center;
}

.dropdown-main-icon {
    margin: 0 5px 0 0;
}

.dropdown-section-item {
    border-bottom: 1px solid #7A9395;
    text-align: left;

    &::first-letter {
        text-transform: capitalize;
    }
}

.dropdown-section-item:hover {
    background-color: #8BC53F;
    color: white;
}

.dropdown-section-item:hover .dropdown-section-icon {
    color: white;
}

.dropdown-section-item .dropdown-item {
    display: flex;
    justify-content: space-between;

    :first-letter {
        text-transform: capitalize;
    }
}

.dropdown-section-item .dropdown-item .lock {
    padding-right: 15px;
    color: #7A9395;
}
.panels_container.regular:has(> .drop-zone-overlay.active) #content-menu {
    position: relative;
    z-index: 201;
}

.drop-zone-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: none;
    align-items: center;
    justify-content: center;
    z-index: 300;
    pointer-events: none;
}

.drop-zone-overlay.active {
    display: flex;
    pointer-events: auto;
    background-color: rgba(34, 76, 79, 0.48);
}

.drop-zone-overlay.success {
    background-color: rgba(34, 76, 79, 0.36);
}

.drop-zone-overlay span {
    display: inline-flex;
    align-items: center;
    gap: 14px;
    font-size: 18px;
    color: white;
    font-weight: bold;
    padding: 20px 40px;
    background-color: #224C4F;
    border-radius: 8px;
    opacity: 1;
    transition: opacity 160ms ease, transform 180ms ease, background-color 180ms ease;
}

.drop-zone-overlay span.changing {
    opacity: 0;
    transform: translateY(6px) scale(0.98);
}

.drop-zone-overlay span.entering {
    opacity: 0;
    transform: translateY(-6px) scale(1.01);
}

.drop-zone-overlay.success span {
    transform: scale(1.03);
    background-color: #2F7D5C;
}

.drop-zone-overlay.success span.changing {
    transform: translateY(6px) scale(0.98);
}

.drop-zone-overlay.success span.entering {
    transform: translateY(-6px) scale(1.01);
}

.drop-zone-icon {
    font-size: 22px;
}

.drop-zone-field {
    margin: 10px;
    padding: 28px 20px;
    border: 2px dashed #c7d3d4;
    border-radius: 8px;
    background-color: #f7fafa;
    color: #224C4F;
    cursor: pointer;
    text-align: center;
    transition: border-color 160ms ease, background-color 160ms ease;
}

.drop-zone-field:hover,
.drop-zone-field.active {
    border-color: #224C4F;
    background-color: #eef4f4;
}

.drop-zone-field-icon {
    display: block;
    margin-bottom: 10px;
    font-size: 26px;
}

.drop-zone-field-hint {
    display: block;
    margin-top: 6px;
    color: #6b7f80;
    font-size: 12px;
}

.drop-zone-file-list {
    margin: 0 10px 10px;
    padding: 0;
    max-height: 180px;
    overflow-y: auto;
    list-style: none;
}

.drop-zone-file-list li {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 4px;
    border-bottom: 1px solid #eceff0;
    font-size: 13px;
}

.drop-zone-file-name {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.drop-zone-file-size {
    color: #6b7f80;
    font-size: 12px;
}

.drop-zone-file-remove {
    color: #e94547;
    cursor: pointer;
}

.drop-zone-overlay.success .drop-zone-icon {
    animation: drop-zone-check 240ms ease-out;
}

@keyframes drop-zone-check {
    0% {
        transform: scale(0.4);
        opacity: 0;
    }

    70% {
        transform: scale(1.18);
        opacity: 1;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}
#modal-backdrop {
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.15);
    z-index: 1000;
}

#modal-errors.active {
    background-color: rgba(200, 0, 0, 0.25);
    border: 2px solid #CC0000;
    color: #CC0000;
    margin: 10px 10px 0;
    padding: 10px;
}

.modal_blocker {
    z-index: 1001;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    opacity: 0.7;
    background: none no-repeat scroll center center white;
    text-align: center;
}

.modal_blocker_container {
    position: relative;
    top: 50%;
}

.modal_loading {
    color: #666666;
    border: 1px solid #CCCCCC;
    font-size: 16px;
    margin: 10px;
    padding: 20px;
    text-align: center;
}

.modal-description-warning {
    color: #CC0000;
}

.modal-description-container {
    padding: 10px;
    margin: 10px 0;
    border-radius: 4px;
    background-color: #F2F2F2;
}

.modal-description-title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.modal-description-title p {
    margin: 0;
}

#etl_extra_description {
    margin-bottom: 0px;
}
.card.plan.selected {
    border: #8BC53F solid 2px;
    position: relative;
}

.plan {
    border: 2px solid #224C4F;
    border-radius: 4px;
    padding: 20px 20px;
}

.plan > .plan-title {
    text-transform: capitalize;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    color: #224C4F;
}

.plan > .plan-description {
    text-align: left;
    color: #224C4F;
    margin: 40px 0 40px 0;
    min-height: 270px;
}

.plan > .plan-description > .item {
    display: flex;

    div:first-child {
        margin-right: 10px;
    }
}

.plan > .plan-changer > .plan-changer-button {
    width: 100%;
    padding: 10px;
    background: #224C4F;
    color: #FFFFFF;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    text-align: center;

    &:hover {
        background-color: #8BC53F;
    }

    &:disabled {
        background-color: #F8F8F8;
        color: #224C4F;
        cursor: not-allowed;
    }
}

.features {
    font-weight: bold;
    text-transform: capitalize;
}

.plans-accordion {
    background-color: #F8F8F8;
}

.btn-group-organization {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    padding: 2% 0%;
    width: 100%;
}

.btn-group-organization > .btn {
    border-color: #224C4F;
    font-weight: bold;
    height: auto;
    margin: 0;
    padding: 10px;
    position: relative;
    text-transform: capitalize;
    width: auto;
}

.btn-group-organization > .btn:hover {
    background-color: #8BC53F;
    color: white;
    text-shadow: none;
}

.btn-group-organization > .btn-essentials {
    background-color: white;
    color: #224C4F;
}

.btn-group-organization > .btn-standard {
    background-color: #E6E7E8;
    color: #224C4F;
}

.btn-group-organization > .btn-advanced {
    background-color: #BBBDBF;
    color: #224C4F;
}

.btn-group-organization > .btn-premium {
    background-color: #224C4F;
    color: #8BC53F;
}

.btn-group-organization > .selected {
    background-color: #8BC53F;
    color: white;
    text-shadow: none;
}

.organization-details, .site-details {
    display: flex;
    justify-content: space-between;
}

.organization-details > .per-box > dl > dd > img {
    max-height: 90px;
}

.site-details > .per-box > img {
    max-height: 180px;
}
body {
    height: 100%;
}

.wmui-btn-n {
    display: inline-block;
    padding: 0 4px !important;
    margin: 0 2px 0 0 !important;
    border: 1px solid transparent;
    font-size: 8px !important;
    border: 1px solid #E3E3E3;
    background: #F3F3F3;
    color: gray;
    cursor: pointer;
    border-radius: 9px !important;
    -moz-border-radius: 9px !important;
}

.wmui-btn-n.edt:hover {
    background-color: #8BC53F;
    color: white !important;
    border-color: #8BC53F !important;
}

.wmui-btn-n.dlt:hover {
    background-color: red;
    color: white !important;
    border-color: red !important;
}

.wmui-btn-n:hover {
    background: #C3C3C3;
    border: 1px solid gray;
    color: black !important;
}

.pad {
    color: black;
    position: absolute;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
}

ul li.label {
    cursor: normal;
    font-size: 10px;
    margin: 0 !important;
    padding: 2px 3px 0 0 !important;
    font-weight: bold;
    color: black;
}

ul li.label::first-letter {
    text-transform: capitalize;
}

ul li.label.comparison {
    margin-top: 3px !important;
    padding-top: 3px !important;
}

ul.grp_btn {
    border: 1px solid #E3E3E3;
    border-radius: 3px !important;
    -moz-border-radius: 3px !important;
    overflow: auto;
}

ul.grp_btn li {
    padding: 1px 3px !important;
    font-size: 10px;
    cursor: pointer;
    margin: 0 2px 0 0 !important;
    border-right: 1px solid #E3E3E3;
    width: 16px;
    text-align: center;
}

ul.grp_btn li.on {
    background: #E3E3E3;
    color: white;
}

ul.grp_btn li.last {
    border: none;
}

ul.btns li.btn, ul.ctrl li.btn {
    border: 1px solid gray !important;
    background-color: #E3E3E3 !important;
    border-radius: 3px !important;
    cursor: pointer;
    font-size: 10px !important;
    margin: 5px 2px 0 0 !important;
    color: #8BC53F !important;
    padding: 1px 3px !important;
    width: auto;
}

ul.btns li.btn:hover, ul.ctrl li.btn:hover {
    color: white !important;
    background-color: gray !important;
}

div.wmui-split_view {
    /*position: absolute;*/
    overflow: auto;
    right: 0;
    top: 0;
    left: 0;
    bottom: 0;
    background-color: white;
}

div.wmui-split_view.collapsed_inspector_panel .ph_left {
    margin-right: 0 !important;
}

div.wmui-split_view.collapsed_inspector_panel .ph_right {
    display: none;
}

div.wmui-split_view .ph_left {
    background-color: white;
}

div.wmui-split_view .ph_left .wmui-view {
    /* padding: 15px; */
}

div.wmui-split_view .ph_left.grayed {
    background-color: #F3F3F3;
}

div.wmui-split_view .ph_left .ph_handler {
    left: 0 !important;
    height: 100%;
    overflow: hidden;
    float: right;
    cursor: col-resize;
    border-right: 1px solid #E8E8E8;
    border-left: 1px solid #E8E8E8;
    width: 4px;
    background-color: white;
    background-image: url("/images/ui/dot.png");
    background-repeat: no-repeat;
    background-position: 0 0;
    background-position: 50% 50% !important;
}

div.wmui-split_view .ph_right {
    position: absolute;
    right: 0;
    overflow: hidden;
    padding-top: 0;
}

div.wmui-split_view .ph_right.grayed {
    background-color: #F3F3F3;
}

div.wmui-split_view .ph_right div.body, div.wmui-split_view .ph_right div.wmui-detail-list {
    background-color: #F3F3F3;
    border-bottom: 1px dotted #E3E3E3;
}

div.wmui-split_view .ph_right .section {
    margin-top: 0;
}

.clr {
    clear: both;
    height: 1px;
    width: 100%;
    overflow: hidden;
}

.wmui-help-box {
    border: 1px solid #E7E7E7;
    background-color: #F7F7F7;
    margin: 5px !important;
    font-size: 10px;
    font-style: italic;
    padding: 10px;
    color: gray;
}

.wmui-msg-box {
    font-size: 10px !important;
    text-align: center !important;
    text-shadow: white 1px 1px 0;
    color: rgba(0, 0, 0, 0.6);
    border: 1px solid #E7E7E7;
    background-color: #F7F7F7;
    margin: 5px 5px 10px !important;
    padding: 5px;
}

.wmui-section {
    margin: 0;
    padding: 0;
}

.wmui-section .head {
    border-bottom: 1px solid white;
    font-size: 9px !important;
    background-color: #333333;
}

.wmui-section .head:hover {
    background-color: black;
}

.wmui-section .head .title {
    color: white;
    padding: 5px;
    font-size: 9px;
}

.wmui-section .head .toolbar {
    margin: 0 !important;
    color: white;
}

.wmui-section .head .wmui-toolbar {
    margin: 10px 10px !important;
}

.wmui-section .body ul.items {
    margin-right: 0 !important;
}

.wmui-section .body > div {
    margin-bottom: 18px;
}

.wmui-section .body dl {
    /* margin: 0 15px 0 5px; */
}

.wmui-section .body hr {
    background-color: #E4E4E4;
    border: 0;
    height: 1px;
    display: inline-block;
    margin: 0;
    padding: 0;
}

.wmui-section .body dt {
    clear: both;
}

.wmui-section .body dd {
    cursor: text;
}

.wmui-section .body dd span {
    padding: 0;
}

.wmui-section .body hr {
    margin: 0 0 10px !important;
    display: inline-block;
}

.wmui-hc {
    overflow: hidden;
}

.wmui-chart {
    position: relative;
    background-color: white !important;
    border-bottom: 0 solid #E3E3E3;
    border-left: 0 solid #E3E3E3;
    border-right: 0 solid #E3E3E3;
    height: auto;
}

div.grp_ctrl {
    border-top: 0 solid #F3F3F3;
    border-bottom: 0 solid #F3F3F3;
    padding: 0;
}

div.grp_ctrl.wmui-chart-toolbar {
    width: 100%;
    overflow: hidden;
    background: white;
    min-height: 36px;
}

div.grp_ctrl div {
    display: inline-block;
    padding: 5px;
    float: left;
}

div.grp_ctrl div.title {
    font-size: 120%;
    color: rgb(119, 119, 119);
    line-height: 28px;
    padding-right: 10px;
}

div.grp_ctrl div.wmui-chart-control-resolution {
    background: white;
}

div.grp_ctrl div.wmui-chart-control-operation {
    background: white;
    border: none !important;
}

div.grp_ctrl div.wmui-chart-control-activity {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    top: 300px;
    left: 50%;
    z-index: 900000;
    margin-left: -110px;
    width: 200px;
    height: 80px;
    padding: 4px 8px;
    background: rgba(233, 233, 233, 0.2);
    border: 1px solid #E3E3E3;
    border-radius: 3px !important;
    box-shadow: rgba(0, 0, 0, 0.08) 0 5px 5px;
}

div.grp_ctrl div.wmui-chart-control-activity.loading {
    border: none;
    background: none;
    box-shadow: none;
}

div.grp_ctrl div.wmui-chart-control-activity img {
    float: left;
    margin-right: 5px;
    display: none;
}

div.grp_ctrl div.wmui-chart-control-activity h4 {
    width: 100%;
    display: inline-block;
    padding-top: 22px;
    color: rgba(0, 0, 0, 0.5);
    text-align: center;
    font-size: 24px !important;
    font-weight: bold;
}

ul.ctrl {
    overflow: auto;
    padding: 5px;
}

ul.ctrl li {
    display: block-inline;
    height: auto;
    color: #224C4F !important;
}

ul.ctrl li.mode {
    border-radius: 3px !important;
    -moz-border-radius: 3px !important;
    border: 1px solid transparent !important;
    padding: 1px 3px !important;
    font-size: 10px;
    cursor: pointer;
    margin: 0 2px 0 0 !important;
    text-align: center;
}

ul.ctrl li.not-selectable {
    border-radius: 3px !important;
    -moz-border-radius: 3px !important;
    border: 1px solid transparent !important;
    padding: 1px 3px !important;
    font-size: 10px;
    margin: 0 5px 0 0 !important;
    color: #888888;
    text-align: center;
}

ul.ctrl li.mode:hover:not(.locked) {
    background: rgb(34, 76, 79);
    color: #FFFFFF !important;
}

ul.ctrl li.mode.disabled:hover {
    text-decoration: none;
    cursor: default;
}

ul.ctrl li.mode.current {
    border: 1px solid #8BC53F !important;
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#8E93D5', endColorstr='#2731AE', GradientType=0);
    color: white !important;
    background-color: #8BC53F !important;
}

ul.ctrl li.locked {
    color: #E3E3E3 !important;
    cursor: default !important;
}

ul.ctrl li.locked:hover {
    text-decoration: none !important;
}

.wmui-chart-control-operation {
    margin-right: 0 !important;
    margin-left: 0 !important;
}

.wmui-chart-control-operation ul.ctrl {
    padding-right: 0 !important;
    padding-left: 0 !important;
}

.wmui-chart-control-date_time, .wmui-chart-control-text {
    padding: 4px !important;
}

.wmui-chart-control-text {
    float: none !important;
    background-color: white;
    z-index: 999999;
    left: 20px;
    margin-top: 0;
    border: none !important;
    padding: 0 !important;
    height: 20px;
}

.wmui-hc-analyze {
    margin-top: 18px;
}

.wmui-chart-control-period ul li label {
    margin-right: 5px;
}

.wmui-chart-control-date_time, .wmui-chart-control-text, .wmui-chart-compare {
    padding: 0;
}

.wmui-chart-control-date_time ul.ctrl, .wmui-chart-control-text ul.ctrl, .wmui-chart-compare ul.ctrl {
    border: none !important;
}

.wmui-chart-control-date_time ul.ctrl li, .wmui-chart-control-text ul.ctrl li, .wmui-chart-compare ul.ctrl li {
    float: left;
    margin: 0 0;
}

.wmui-chart-control-date_time ul.ctrl li.invalid input, .wmui-chart-control-text ul.ctrl li.invalid input, .wmui-chart-compare ul.ctrl li.invalid input {
    color: red !important;
}

.wmui-chart-control-date_time ul.ctrl li.field:hover, .wmui-chart-control-text ul.ctrl li.field:hover, .wmui-chart-compare ul.ctrl li.field:hover {
    border: 1px solid #8BC53F !important;
    background-color: #EDF5FF !important;
}

.wmui-chart-control-date_time ul.ctrl li.field:focus, .wmui-chart-control-text ul.ctrl li.field:focus, .wmui-chart-compare ul.ctrl li.field:focus {
    border: 1px solid #8BC53F !important;
    background-color: #EDF5FF !important;
}

.wmui-chart-control-date_time ul.ctrl li input, .wmui-chart-control-text ul.ctrl li input, .wmui-chart-compare ul.ctrl li input {
    display: inline-block;
    float: left;
    color: #224C4F !important;
    font-size: 10px;
    padding: 3px 5px !important;
    margin-right: 0 !important;
    border: none;
    width: 52px;
    background: transparent !important;
}

.wmui-chart-control-date_time ul.ctrl li.legend, .wmui-chart-control-text ul.ctrl li.legend, .wmui-chart-compare ul.ctrl li.legend {
    font-size: 10px;
}

.wmui-chart-control-date_time ul.ctrl li.legend span, .wmui-chart-control-text ul.ctrl li.legend span, .wmui-chart-compare ul.ctrl li.legend span {
    font-weight: bold;
}

.wmui-chart-control-date_time ul.ctrl li.label, .wmui-chart-control-text ul.ctrl li.label, .wmui-chart-compare ul.ctrl li.label {
    margin: 0 5px !important;
}

.wmui-chart-compare ul.ctrl li.label {
    color: white !important;
}

.wmui-chart-compare ul.ctrl li.label.comparison {
    margin-top: 3px !important;
}

.wmui-chart-control-date_time ul.ctrl li.border, .wmui-chart-control-text ul.ctrl li.border, .wmui-chart-compare ul.ctrl li.border {
    border: 1px solid #E3E3E3;
}

.wmui-chart-control-date_time ul.ctrl li.box, .wmui-chart-control-text ul.ctrl li.box, .wmui-chart-compare ul.ctrl li.box {
    border-left-width: none !important;
    height: 18px !important;
    padding: 0 3px;
    margin: 0 10px 0 0 !important;
    cursor: pointer;
    color: black !important;
}

.wmui-chart-control-date_time ul.ctrl li.box:hover, .wmui-chart-control-text ul.ctrl li.box:hover, .wmui-chart-compare ul.ctrl li.box:hover {
    color: #A1A1A1 !important;
    background-color: #E2E6EB !important;
    border: 1px solid #E3E3E3 !important;
    border-left-width: 0 !important;
}

.wmui-chart-control-date_time ul.ctrl li.ui_date_picker, .wmui-chart-control-text ul.ctrl li.ui_date_picker, .wmui-chart-compare ul.ctrl li.ui_date_picker {
    color: #E3E3E3 !important;
    border-left-width: 0;
}

.wmui-chart-compare {
    width: 100%;
    height: auto;
    background-color: #8BC53F;
    color: white;
    position: relative;
}

.wmui-chart-compare ul li.black {
    color: black !important;
}

.wmui-chart-compare ul li.btn {
    margin: 2px 10px 0 1px !important;
}

.wmui-chart-compare ul li {
    margin: 0 3px 0 0 !important;
}

.wmui-chart-compare ul li .wmui-icon {
    margin: 4px 0 0 2px;
}

.wmui-chart-compare ul li.regular {
    background-color: white;
    margin: 0px !important;
}

.wmui-chart-compare ul li.regular input {
    width: 250px !important;
    padding: 10px;
    font-weight: bold;
}

.wmui-chart-compare ul li.regular input::-moz-placeholder {
    color: #797979;
    font-weight: normal;
}

.wmui-chart-compare ul li.regular input::placeholder {
    color: #797979;
    font-weight: normal;
}

.wmui-chart-compare ul li.regular:hover {
    border: 1px solid #8BC53F !important;
    background-color: white !important;
}

.wmui-chart-compare ul li ul.items {
    overflow: hidden;
    margin: 0 !important;
    padding: 0 !important;
}

.wmui-chart-compare ul li ul.items li {
    float: left;
    padding: 0 8px;
    margin: 2px !important;
    background: #224C4F;
    border-radius: 3px !important;
    -moz-border-radius: 3px !important;
}


.wmui-chart-compare ul li ul.items li a, .wmui-chart-compare ul li ul.items li label {
    cursor: pointer;
    color: white !important;
}

.wmui-chart-compare ul li ul.items li .rm {
    cursor: pointer;
    float: left;
    color: white;
}

.wmui-chart-compare ul li ul.items li .rm:hover {
    color: red !important;
}

.wmui-chart-compare ul li ul.items li label {
    font-size: 10px;
    color: black;
    float: left;
    padding: 6px 3px;
}

.wmui-chart-compare ul li ul.items li label:hover {
    color: #8BC53F !important;
}

.wmui-chart-compare ul li ul.items li input[type=checkbox] {
    margin: 7px 3px 0 0 !important;
    width: auto !important;
    float: left;
}

.wmui-search-result-list {
    box-shadow: rgba(0, 0, 0, 0.08) 0 5px 5px;
    position: absolute;
    z-index: 900001;
    height: auto;
    width: 415px;
    top: 38px;
    left: 80px;
    border-top: none;
    border-right: 1px solid #E3E3E3;
    border-left: 1px solid #E3E3E3;
    border-bottom: 1px solid #E3E3E3;
    background: white;
    max-height: 450px;
    overflow: auto;
}

.wmui-search-result-list ul.wmui-search-items {
    padding: 5px 5px !important;
    margin: 0 !important;
    background-color: #224C4F;
    border: none;
    overflow: hidden;
}

.wmui-search-result-list ul.wmui-search-items li {
    color: white;
    margin: 0 !important;
    padding: 2px 5px !important;
    width: 385px;
    font-size: 10px;
    clear: both;
    font-weight: bold;
    border-bottom: 1px solid #F3F3F3;
}

.wmui-search-result-list ul.wmui-search-items li div.item-info {
    display: flex;
    justify-content: space-between;
    align-items: center
}

.wmui-search-result-list ul.wmui-search-items li div.item-info div.wmui-btn {
    height: -moz-fit-content;
    height: fit-content;
}

.wmui-search-result-list ul.wmui-search-items li.inactive {
    background-color: rgba(0, 0, 0, 0.02) !important;
}

.wmui-search-result-list ul.wmui-search-items li.inactive label {
    color: #E3E3E3 !important;
}

.wmui-search-result-list ul.wmui-search-items li.inactive:hover {
    background-color: rgba(0, 0, 0, 0.02) !important;
}

.wmui-search-result-list ul.wmui-search-items li.inactive .icon {
    opacity: 0.3;
}

.wmui-search-result-list ul.wmui-search-items li.bottom_bar {
    padding: 5px 5px 2px 0 !important;
}

.wmui-search-result-list ul.wmui-search-items li.bottom_bar:hover {
    background-color: transparent !important;
}

.wmui-search-result-list ul.wmui-search-items li.bottom_bar:hover label {
    color: black !important;
    font-size: 9px !important;
}

.wmui-search-result-list ul.wmui-search-items li.bottom_bar label {
    color: white;
}

.wmui-search-result-list ul.wmui-search-items li:last-child {
    border: none;
}

.wmui-search-result-list ul.wmui-search-items li div.wmui-icon {
    float: left;
}

.wmui-search-result-list ul.wmui-search-items li.last {
    border-bottom: none !important;
}

.wmui-search-result-list ul.wmui-search-items li label {
    font-size: 9px !important;
    cursor: pointer !important;
    color: white !important;
}

.wmui-search-result-list ul.wmui-search-items li:hover {
    background-color: #404040 !important;
    color: white !important;
}

.wmui-search-result-list ul.wmui-search-items li:hover .wmui-btn {
    background-color: #8BC53F !important;
    color: white !important;
}

.wmui-search-result-list ul.wmui-search-items li ul.toolbar {
    padding: 0 !important;
    margin: 0 !important;
    width: auto;
}

.wmui-search-result-list ul.wmui-search-items li ul.toolbar .rgt {
    float: right;
}

.wmui-search-result-list ul.wmui-search-items li ul.toolbar li {
    margin: 0;
    padding: 0;
}

.wmui-search-result-list ul.wmui-search-items li ul.toolbar li .wmui-btn {
    display: inline-block;
    float: right;
    width: auto;
    margin: 0;
    padding: 0;
}

div.wmui-icn {
    width: 16px;
    height: 16px;
    float: left;
    margin-right: 8px;
}

div.wmui-btn,
div.pagination a,
ul.toolbar.form li.wmui-btn a,
ul.toolbar.regular li.wmui-btn a {
    text-decoration: none;
    border-radius: 3px !important;
    -moz-border-radius: 3px !important;
    text-shadow: none;
    display: inline-block;
    padding: 2px 6px 2px 6px !important;
    margin: 0;
    font-size: 9px;
    cursor: pointer;
    text-align: center;
    text-transform: capitalize;
    background-color: #D3D3D3;
    border: 1px solid #C3C3C3;
    color: #444444;
}

div.wmui-btn:hover,
div.pagination a:hover,
ul.toolbar.regular li.wmui-btn a:hover,
ul.toolbar.form li.wmui-btn a:hover {
    border-color: #D8D8D8;
    background-color: #797979;
    color: white !important;
}

div.wmui-btn.disabled {
    cursor: default;
    color: #777777 !important;
}

div.wmui-btn.disabled:hover {
    background-color: #D3D3D3;
    border: 1px solid #C3C3C3;
    color: #777777 !important;
}

div.wmui-btn.deactivate {
    margin-left: 5px;
    background-color: #8BC53F !important;
    border: solid 1px #8BC53F;
    color: white;
}

div.wmui-btn.deactivate:hover {
    background-color: #224C4F !important;
    border-color: #224C4F !important;
}

div.wmui-btn.activate {
    margin-left: 5px;
    background-color: #E94547 !important;
    border: solid 1px #E94547;
    color: white;
}

div.wmui-btn.red:hover, div.wmui-btn.activate:hover {
    background-color: #C0392B !important;
    border-color: #C0392B !important;
}

div.wmui-btn.active, div.pagination span.current, div.pagination span.disabled, div.pagination span.gap {
    border-radius: 3px !important;
    padding: 2px 6px 2px 6px !important;
    background-color: gray;
    color: white;
    text-shadow: #646464 1px 1px 0;
    border: 1px solid rgba(0, 0, 0, 0.5);
}

div.pagination span.current, div.pagination span.disabled, div.pagination span.gap {
    opacity: 0.5;
    cursor: default;
    background-color: white;
    color: gray;
    text-shadow: none;
    font-weight: bold;
}

div.wmui-btn.active.edit {
    background-color: #8BC53F !important;
}

div.wmui-symbol {
    border-radius: 9px !important;
    display: inline-block;
    margin: 0 2px !important;
    height: -moz-fit-content;
    height: fit-content;
}

div.wmui-symbol.strong {
    font-weight: bold !important;
    height: -moz-fit-content;
    height: fit-content;
}

span.num {
    background: gray;
    color: white;
    font-weight: bold !important;
    font-size: 10px;
    border-radius: 9px !important;
    padding: 2px 5px !important;
    margin-right: 8px;
}

.bottom-offset {
    margin-bottom: 10px;
}

.top-offset {
    margin-top: 5px;
}

dl.stepped {
    display: inline-block !important;
    padding: 0 !important;
    margin: 10px !important;
}

ul.date_time-selector button {
    color: #444444;
    text-decoration: none;
    border-radius: 3px !important;
    display: inline-block;
    padding: 3px 6px 3px 6px !important;
    margin: 0 5px 0;
    font-size: 9px;
    cursor: pointer;
    background-color: #D3D3D3;
    border: 1px solid #C3C3C3;
    text-transform: uppercase;
    text-align: center;
}

ul.date_time-selector li.separator {
    margin: 0 3px;
}

ul.toolbar {
    overflow: hidden;
}

ul.toolbar.rgt {
    float: right;
    padding: 5px;
}

ul.toolbar.regular {
    float: none !important;
    clear: right;
    background-color: #E6E6E6;
    padding: 10px;
    border-bottom: 1px solid #E3E3E3;
    margin: 0;
}

ul.toolbar.regular li {
    border: none !important;
}

ul.toolbar.regular li.wmui-label {
    margin: 0;
}

/* ul.toolbar.form li.wmui-btn a,
ul.toolbar.regular li.wmui-btn a {
    border-radius: 3px !important;
    -moz-border-radius: 3px !important;
    border-radius: 3px !important;
    display: inline-block;
    padding: 2px 6px 2px 6px !important;
    margin: 0;
    font-size: 9px;
    cursor: pointer;
    text-align: center;
    background-color: #D3D3D3;
    border: 1px solid #C3C3C3;
    color: #444444;
    text-transform: uppercase;
    text-align: center;
} */

/* ul.toolbar.regular li.wmui-btn a:hover,
ul.toolbar.form li.wmui-btn a:hover {
    text-decoration: none;
    text-shadow: #444444 1px 1px 0;
    border-color: #444444;
    background-color: #A3A3A3;
    color: white !important;
} */

ul.toolbar.regular li.wmui-btn a.red:hover,
ul.toolbar.form li.wmui-btn a.red:hover {
    background-color: red !important;
    border-color: red;
    color: white !important;
    text-shadow: #646464 1px 1px 0;
}

ul.toolbar.regular li.wmui-btn a.active,
ul.toolbar.form li.wmui-btn a.active {
    background-color: gray;
    color: white;
    text-shadow: #646464 1px 1px 0;
    border: 1px solid rgba(0, 0, 0, 0.5);
}

ul.toolbar.regular li.wmui-btn a.active.edit,
ul.toolbar.form li.wmui-btn a.active.edit {
    background-color: #8BC53F !important;
}

ul.toolbar.regular li.wmui-btn a.active:hover,
ul.toolbar.form li.wmui-btn a.active:hover {
    color: white !important;
}

ul.toolbar.regular li.rgt {
    float: right;
}

ul.toolbar.form {
    width: 234px;
    padding: 5px 10px 10px 10px !important;
    margin: 0;
}

/* ul.toolbar.form li.wmui-btn a {
    border-radius: 3px !important;
    -moz-border-radius: 3px !important;
    border-radius: 3px !important;
    text-shadow: white 1px 1px 0;
    display: inline-block;
    padding: 2px 6px 2px 6px !important;
    margin: 0;
    font-size: 9px;
    cursor: pointer;
    text-align: center;
    background-color: #D3D3D3;
    border: 1px solid #C3C3C3;
    color: #444444;
    background-color: #E7E7E7;
    text-transform: uppercase;
    margin: 2px 2px !important;
} */
/*
ul.toolbar.form li.wmui-btn a:hover {
    text-shadow: #444444 1px 1px 0;
    border-color: #444444;
    background-color: #A3A3A3;
    color: white !important;
} */

/* ul.toolbar.form li.wmui-btn a.red:hover {
    background-color: red !important;
    border-color: red;
    color: white !important;
    text-shadow: #646464 1px 1px 0;
} */

/* ul.toolbar.form li.wmui-btn a.active {
    background-color: gray;
    color: white;
    text-shadow: #646464 1px 1px 0;
    border: 1px solid rgba(0, 0, 0, 0.5);
} */

/* ul.toolbar.form li.wmui-btn a.active.edit {
    background-color: #8bc53f !important;
} */
/*
ul.toolbar.form li.wmui-btn a.active:hover {
    color: white !important;
} */

ul.toolbar.form li.rgt {
    float: right !important;
}

li.wmui-chart-analyze {
    margin-right: 0 !important;
}

li.wmui-chart-analyze ul.toolbar li.wmui-select-box select {
    width: 140px;
}

select.analyze-opt {
    width: 100px;
    margin-right: 10px;
}

.wmui-chart-control-resume {
    border-top: 2px solid #F7F7F7;
    position: relative;
    padding: 0 !important;
    margin: 0 !important;
    width: 100%;
}

.wmui-chart-control-resume .btn-ctrl {
    cursor: pointer;
    margin-right: 5px;
    width: 40px;
    text-align: center;
    background-color: #E7E7E7;
    position: relative;
    float: right;
    border: 1px solid #F2F2F2;
    border-radius: 0 0 8px 8px/0 0 8px 8px;
    -moz-border-bottom-radius: 8px 8px;
    border-bottom-radius: 8px 8px;
    text-shadow: white 1px 1px 0;
    padding: 1px 6px !important;
    font-size: 8px;
    corner-radius: 4px;
}

.wmui-chart-control-resume .btn-ctrl:hover {
    background-color: #E3E3E3;
}

.wmui-chart-control-resume .wmui-resume-box {
    border-bottom: 1px solid #F2F2F2;
}

.wmui-chart-control-resume .wmui-resume-box:hover .wmui-btn-hdl {
    display: block;
}

.wmui-chart-control-resume .wmui-resume-box .wmui-btn-hdl {
    border: none !important;
    display: none;
    cursor: pointer;
    position: absolute;
    top: 8px;
}

.wmui-chart-control-resume .wmui-resume-box .wmui-btn-hdl:hover svg path {
    fill: #444444;
}

.wmui-chart-control-resume .wmui-resume-box .wmui-btn-hdl.in_ctrl {
    top: 10px;
    right: px;
}

.wmui-chart-control-resume .wmui-resume-box .wmui-btn-hdl.in_arrow_west {
    left: 10px;
}

.wmui-chart-control-resume .wmui-resume-box .wmui-btn-hdl.in_arrow_east {
    right: 10px;
}

.wmui-chart-control-resume .wmui-resume-box ul.board {
    overflow: hidden;
    width: 5000px;
    padding: 0 0 !important;
    height: 40px;
}

.wmui-chart-control-resume .wmui-resume-box ul.board > li {
    margin-right: 5px !important;
    padding: 5px !important;
    border-right: 1px dotted #E3E3E3;
}

.wmui-chart-control-resume .wmui-resume-box ul.board > li.wmui-board-active {
    background-color: #F7F7F7;
}

.wmui-chart-control-resume .wmui-resume-box ul.board > li.wmui-control-handler {
    margin: 0 !important;
    padding: 0 !important;
    width: 10px;
    height: 10px;
    border: none !important;
    cursor: pointer;
}

.wmui-chart-control-resume .wmui-resume-box ul.board > li.wmui-control-handler.wmui-button {
    border: none !important;
    margin: 0 !important;
    padding: 0 !important;
}

.wmui-chart-control-resume .wmui-resume-box ul.board > li:last-child {
    border-right: none;
}

.wmui-chart-control-resume .wmui-resume-box ul.board > li .value {
    font-size: 12px;
    float: right !important;
    margin: 0 5px 0 0 !important;
    padding: 0 0 0 0 !important;
    font-weight: bold;
    border: none !important;
}

.wmui-chart-control-resume .wmui-resume-box ul.board > li .value span.unit {
    font-size: 8px;
}

.wmui-chart-control-resume .wmui-resume-box ul.board > li ul {
    margin: 0;
}

.wmui-chart-control-resume .wmui-resume-box ul.board > li ul li {
    padding: 0 !important;
    text-align: left;
    clear: both;
    margin-left: 5px;
    font-size: px;
}

.wmui-chart-control-resume .wmui-resume-box ul.board > li ul li:first-child span:last-child {
    font-size: 14px !important;
    padding-left: 3px;
}

.wmui-chart-control-resume .wmui-resume-box ul.board > li ul li span:first-child {
    width: 40px;
    display: inline-block;
    padding: 0 2px 0 0;
    font-size: 9px;
}

.wmui-chart-control-resume .wmui-resume-box ul.board > li ul li span:first-child.max {
    font-size: 8px;
}

.wmui-chart-control-resume .wmui-resume-box ul.board > li ul li span:first-child.min {
    font-size: 8px;
}

.wmui-chart-control-resume .wmui-resume-box ul.board > li ul li span:first-child.avg {
    font-size: 8px;
}

div.wmui-list {
    padding: 10px 15px !important;
}

div.wmui-list dl dt span {
    display: inline-block;
    padding-bottom: 2px !important;
    font-weight: 700;
}

div.wmui-list dl dd {
    clear: both;
}

div.wmui-list dl dd.active {
    background-color: #F7F7F7 !important;
    padding: 0 5px;
    font-weight: bold !important;
}

div.wmui-list dl dd div.wmui-icon {
    float: left;
    cursor: pointer;
    margin-right: 3px;
}

div.wmui-list dl dd div.wmui-icon + span {
    margin-top: 2px;
    display: inline-block;
}

div.wmui-list div.wmui-list-title {
    padding: 0;
    margin: 10px 0 0;
}

div.wmui-list div.wmui-list-title h3 {
    margin: 0;
    padding: 0 0 9px;
    color: black;
    text-shadow: white 1px 1px 0;
}

div.wmui-form {
    padding: 10px !important;
}

dl.stepped {
    overflow: hidden;
    width: 100%;
    margin: 10px 0 !important;
    padding: 0 !important;

    dt:not(:first-child) {
        margin-top: 10px;
    }
}

dl.stepped .two-column {
    display: flex;
    justify-content: space-between;
}

dl.stepped .right-side .check {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    border-radius: 50%;
    width: 30px;
    height: 30px
}

dl.stepped .right-side .check.green {
    background-color: #8BC53F
}

dl.stepped .right-side .check.red {
    background-color: #E94547
}

dl.stepped .right-side .check.orange {
    background-color: #F59D24
}

dl.stepped .right-side .check.blue {
    background-color: #6EB3E3;
}

dl.stepped .right-side .check.lightGrey {
    background-color: #C5C5C5;
}

dl.stepped .right-side .check span {
    color: white;
    font-size: 14px;
}

dl.stepped .right-side .status {
    margin-top: 10px;
}


dl.stepped dd {
    position: relative;
}

dl.stepped dd.inherited {
    color: #A1A1A1;
}

dl.stepped dt {
    position: relative;
}

dl.stepped dt:not(:first-child) {
    margin-top: 10px;
}

dl.stepped div dt:first-child {
    margin-top: 10px;
}

dl.stepped dt::first-letter {
    text-transform: capitalize;
}

dl.stepped dt.inherited {
    color: #A1A1A1;
}

dl.stepped dt._error_ label, dl.stepped dt._error_ span {
    color: red !important;
}

.wmui-form dd {
    display: block;
}

.wmui-form dd input, .wmui-form dd textarea {
    padding: 5px 5px !important;
    border: 1px solid #E3E3E3;
    background: white;
}

.wmui-form dd input.wmui-field-number, .wmui-form dd input.wmui-field-float {
    width: 100px !important;
}

.wmui-form dd input.wmui-field-text {
    -webkit-appearance: textarea;
    width: 100% !important;
}

.wmui-form dd textarea.wmui-field-textarea {
    width: 100% !important;
    height: 72px !important;
}

.wmui-form dd select.wmui-field-enumerator {
    width: 100px !important;
}

.icon {
    cursor: pointer;
}

.wmui-header {
    width: 100%;
}

.wmui-header .icn {
    height: 20px;
    width: auto;
    float: left;
    background: url(/images/ui/dummy_icon.png) no-repeat;
    margin-right: 10px;
}

.wmui-header h1, .wmui-header h2, .wmui-header h3, .wmui-header p {
    color: #232323 !important;
}

.wmui-toolbox-abs {
    border-top: 1px solid #E3E3E3;
    margin: 0 10px !important;
    padding: 5px !important;
    float: left !important;
}

.wmui-toolbox-abs ul {
    width: 270px !important;
}

.wmui-toolbox {
    float: right;
}

.wmui-toolbox ul.wmui-toolbox-menu li.wmui-toolbox-btn {
    overflow: auto;
    margin: 5px;
}

.wmui-toolbox ul.wmui-toolbox-menu li.wmui-toolbox-btn .wmui-icon {
    float: left;
}

.wmui-toolbox ul.wmui-toolbox-menu li.wmui-toolbox-btn label {
    color: #A1A1A1;
    margin: 2px 5px 0 5px !important;
    font-size: 10px !important;
}

.wmui-toolbox ul.wmui-toolbox-menu li.wmui-toolbox-btn .wmui-icon:hover {
    cursor: pointer !important;
}

.wmui-toolbox ul.wmui-toolbox-menu li.wmui-toolbox-btn .wmui-icon:hover path {
    fill: black !important;
    stroke: black !important;
}

.wmui-board-grid div.wtb-gt {
    overflow: hidden;
    margin-top: 10px;
}

.wmui-board-grid div.wtb-gt:first-child {
    border-top: 1px solid #D3D3D3;
}

.wmui-board-grid div.wtb-gt div.wtb-u {
    display: inline-block;
    border-left: 1px solid #E3E3E3 !important;
    float: left;
    margin: 0 0 0 0%;
    height: 100%;
}

.wmui-board-grid div.wtb-gt div.wtb-u:first-child {
    border-left: none !important;
}

.wmui-board-grid div.wtb-gt div.wtb-u div.id {
    color: #A1A1A1;
    padding: 10px;
}

.wmui-board-grid div.wtb-gt div.first {
    margin-left: 0;
}

.wmui-wgt-head h4 {
    padding: 5px 5px !important;
    color: #ABABAB;
    margin: 0;
}

.wmui-wgt {
    overflow: hidden;
    padding: 10px;
    border: none;
}

.wmui-wgt.active {
    background-color: red;
}

.wmui-wgt .handle {
    cursor: move;
}

.wmui-wgt-msg {
    padding: 50px 20px;
    margin: 0 !important;
}

.wmui-wgt-msg h3 {
    color: #E3E3E3;
    text-align: center;
    line-height: 36px !important;
}

.wmui-chart-res {
    background: #F9F9F9;
    padding: 15px;
    border-radius: 3px;
    border: 1px solid #DDDDDD;
    box-shadow: 3px 3px 5px #F8F8F8;
    margin: 5px 5px 0 0 !important;
    position: relative;
}

.wmui-chart-res h5 {
    margin: 0 !important;
    font-weight: normal;
}

.wmui-chart-res .head h4, .wmui-chart-res .head h5, .wmui-chart-res .head h6 {
    text-transform: uppercase;
    margin: 0;
    padding: 5px;
}

.wmui-chart-res .head h4 a, .wmui-chart-res .head h5 a, .wmui-chart-res .head h6 a {
    color: #333333;
    text-shadow: white 1px 1px 0;
    text-decoration: none;
}

.wmui-chart-res .head h4 a:hover, .wmui-chart-res .head h5 a:hover, .wmui-chart-res .head h6 a:hover {
    color: #8BC53F;
}

.wmui-chart-res .body {
    overflow: hidden;
}

.wmui-chart-res .body .wmui-res-diff {
    position: absolute;
    right: 10px;
    top: 10px;
    color: white;
    width: auto;
    float: right;
}

.wmui-chart-res .body .wmui-res-diff .wmui-icon {
    float: left;
    margin: 0;
}

.wmui-chart-res .body .wmui-res-diff h5 {
    font-size: 12px;
    float: right;
    font-weight: bold;
    margin: 0 0;
}

.wmui-chart-res .msg {
    position: absolute;
    top: 40%;
    left: 0;
    right: 0;
}

.wmui-chart-res .msg p {
    text-align: center;
    text-transform: uppercase;
    color: #E3E3E3;
    font-size: 10px;
    font-weight: bold;
    padding: 5px;
    margin: 0;
}

.wmui-chart-res .footer {
    text-align: center;
    margin: 0 !important;
    padding: 0 !important;
}

.wmui-chart-res .footer .wmui-chart-ctrl {
    vertical-align: top;
    display: inline-block;
    padding: 0 5px !important;
    margin: 0 !important;
}

.wmui-chart-res .footer .wmui-chart-ctrl.wmui-chart-ctrl-btn {
    margin-top: 3px !important;
    padding-top: 5px;
    color: gray;
    cursor: pointer;
}

.wmui-chart-res .footer .wmui-chart-ctrl.wmui-chart-ctrl-btn:hover path {
    fill: #8BC53F;
}

.wmui-chart-res .footer label {
    color: black;
    text-transform: capitalize;
    font-weight: bold;
    display: inline-block;
    padding: 0 !important;
    margin: 0 !important;
}

.wmui-wgt-slider {
    position: relative;
    padding: 10px;
    border: 1px solid #E3E3E3;
    margin: 10px;
}

.wmui-wgt-slider .frame {
    width: 100%;
}

.wmui-wgt-slider .frame .scroller {
    margin: 5px 35px;
    overflow: hidden;
}

.wmui-wgt-slider .frame .scroller .container {
    padding: 0;
    width: 3500px;
    background: transparent;
}

.wmui-wgt-slider .frame .scroller .container .section {
    border-right: 1px solid #E3E3E3;
    float: left;
    margin: 0 0 0 0;
}

.wmui-wgt-slider .frame .scroller .container .section:last-child {
    border-right: none;
}

.wmui-wgt-slider .frame .scroller .container .section > div {
    margin: 0 1px 0 0;
}

.wmui-wgt-slider .frame .wmui-wgt-slider-btn {
    top: 0;
    bottom: 0;
    width: 30px;
    position: absolute;
    z-index: 5;
    padding-top: 140px;
}

.wmui-wgt-slider .frame .wmui-wgt-slider-btn.wmui-wgt-slider-btn-nxt {
    border-left: 1px solid transparent;
    right: 0;
}

.wmui-wgt-slider .frame .wmui-wgt-slider-btn.wmui-wgt-slider-btn-prv {
    border-right: 1px solid transparent;
    left: 0;
}

.wmui-wgt-slider .frame .wmui-wgt-slider-btn div {
    cursor: pointer;
    margin-left: 10px !important;
}

.wmui-view > div.wmui-table-view {
    margin: 10px;
}

.wmui-view > div.wmui-detail-list {
    margin: 0;
}

.wmui-msg h4 {
    text-shadow: white 1px 1px 0;
    color: #A1A1A1;
    text-align: center;
    margin: 20px auto;
}

.wmui-chart-analyze dl {
    margin: 0 !important;
}

.wmui-chart-analyze select {
    color: black;
    text-transform: capitalize;
    font-weight: normal;
}

.wmui-chart-analyze select option {
    text-transform: capitalize;
    font-weight: normal;
}

.wmui-chart-analyze select:disabled {
    background: transparent;
    color: gray;
}

.wmui-chart-analyze .analyze-mode {
    margin-right: 5px;
}

.wmui-chart-ph {
    position: relative;
    overflow: auto;
}

.wmui-chart-control-handler {
    position: relative;
    color: white;
    height: 100px;
}

.wmui-costs ul {
    padding: 5px;
}

.wmui-costs ul li {
    clear: both;
    padding: 0 5px;
    border-bottom: 1px solid #E3E3E3;
    margin: 0px;
}

.wmui-costs ul li.active {
    background-color: #F7F7F7;
}

.wmui-costs ul li:last-child {
    border: none;
}

.wmui-costs ul li div.wmui-icon {
    float: left;
}

.wmui-costs ul li label {
    padding: 0 0 !important;
    display: inline-block;
    vertical-align: top;
    margin: 3px 0 6px 6px;
    color: gray;
}

.wmui-costs ul li.current label {
    color: black;
}

table.jCalendar {
    border: 1px solid transparent;
    background: transparent;
    border-collapse: separate;
    border-spacing: 1px;
}

table.jCalendar thead {
    background-color: #E6F0FD;
}

table.jCalendar thead th {
    background: transparent;
    color: #8BC53F;
    font-weight: bold;
    padding: 3px 0;
    text-align: center;
    border: none !important;
}

table.jCalendar td {
    background: #F3F3F3;
    color: black;
    border: 1px solid transparent;
    padding: 3px 5px;
    text-align: center;
}

table.jCalendar td.other-month {
    background: #DDDDDD;
    color: #AAAAAA;
}

table.jCalendar td.today {
    background: #666666;
    color: white;
}

table.jCalendar td.selected {
    background: #FF6666;
    color: white;
}

table.jCalendar td.selected.dp-hover {
    background: #FF3333;
    color: white;
}

table.jCalendar td.dp-hover {
    background: white;
    color: black;
    border: 1px solid #E3E3E3;
}

table.jCalendar tr.activeWeekHover td {
    background: white;
    color: black;
}

table.jCalendar tr.selectedWeek td {
    background: #FF6666;
    color: white;
}

table.jCalendar td.disabled {
    background: #BBBBBB;
    color: #888888;
}

table.jCalendar td.disabled.dp-hover {
    background: #BBBBBB;
    color: #888888;
}

table.jCalendar td.unselectable {
    background: #BBBBBB;
    color: #888888;
}

table.jCalendar td.unselectable:hover, table.jCalendar td.unselectable.dp-hover {
    background: #BBBBBB;
    color: #888888;
}

/* For the popup */
/* NOTE - you will probably want to style a.dp-choose-date - see how I did it in demo.css */
div.dp-popup {
    box-shadow: rgba(0, 0, 0, 0.08) 0 5px 5px;
    border: 1px solid #E3E3E3;
    position: relative;
    background: #F8FAFE;
    font-size: 10px;
    padding: 4px;
    width: 171px;
    line-height: 1.2em;
}

div#dp-popup {
    position: absolute;
    z-index: 199;
}

div.dp-popup h2 {
    font-size: 11px;
    text-shadow: white 1px 1px 0;
    text-align: center;
    margin: 2px 0;
    padding: 0;
    color: #8BC53F;
    font-weight: bold;
}

a#dp-close {
    font-size: 11px;
    padding: 4px 0;
    text-align: center;
    display: block;
}

a#dp-close:hover {
    text-decoration: underline;
}

div.dp-popup a {
    color: #8BC53F;
    text-decoration: none;
    padding: 3px 2px 0;
}

div.dp-popup div.dp-nav-prev {
    position: absolute;
    top: 2px;
    left: 4px;
    width: 100px;
}

div.dp-popup div.dp-nav-prev a {
    font-size: 9px;
    font-weight: bold;
    float: left;
    cursor: pointer;
}

div.dp-popup div.dp-nav-next a {
    cursor: pointer;
}

div.dp-popup div.dp-nav-prev a.disabled {
    cursor: default;
}

div.dp-popup div.dp-nav-next {
    position: absolute;
    top: 2px;
    right: 4px;
    width: 100px;
}

div.dp-popup div.dp-nav-next a {
    font-size: 9px;
    font-weight: bold;
    float: right;
}

div.dp-popup div.dp-nav-next a.disabled {
    cursor: default;
}

div.dp-popup a.disabled {
    cursor: default;
    color: #AAAAAA;
}

div.dp-popup td {
    cursor: pointer;
}

div.dp-popup td.disabled {
    cursor: default;
}

.dp li {
    width: 100%;
    margin-right: 0;
}

.wmui-table-mono {
    padding: 9px 10px;
    background: none !important;
    margin-right: 20px !important;
}

.wmui-table-mono table {
    background: none !important;
}

.wmui-table-mono table thead tr {
    background: none !important;
}

.wmui-table-mono table thead tr th {
    border: none !important;
}

.wmui-table-mono table tbody {
    background-color: none !important;
}

.wmui-table-mono table tbody tr {
    background-color: none !important;
    cursor: pointer;
}

.wmui-table-mono table tbody tr:nth-child(odd) {
    background: none !important;
}

.wmui-table-mono table tbody tr:hover td {
    background-color: rgba(255, 255, 255, 0.7);
    color: black !important;
    text-shadow: none !important;
    border-top: 1px solid #D1D1D1;
}

.wmui-table-mono table tbody tr:hover td a {
    color: black !important;
}

.wmui-table-mono table tbody tr:hover td a.wmui-btn {
    color: black !important;
}

.wmui-table-mono table tbody tr:hover td.unit {
    color: white !important;
}

.wmui-table-mono table tbody tr td {
    border-right: none !important;
    border-top: 1px solid #D1D1D1;
    overflow: hidden;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    color: black !important;
    font-size: 10px !important;
    padding: 2px 5px;
}

.wmui-table-mono table tbody tr td:last-child {
    border-right: none;
}

.wmui-table-mono table tbody tr td a {
    color: black;
    -webkit-text-decoration: underscore;
            text-decoration: underscore;
}

.wmui-table-mono table tbody tr td a.wmui-btn {
    border-radius: 3px !important;
    text-shadow: white 1px 1px 0;
    display: inline-block;
    padding: 2px 6px 2px 6px !important;
    margin: 0;
    cursor: pointer;
    text-align: center;
    background-color: #D3D3D3;
    border: 1px solid #C3C3C3;
    color: #444444;
    text-transform: uppercase;
    font-size: 7px;
    line-height: 14px;
    padding: 0 6px !important;
}

.wmui-table-mono table tbody tr td a.wmui-btn:hover {
    text-shadow: #444444 1px 1px 0;
    border-color: #444444;
    background-color: #A3A3A3;
    color: white !important;
}

.wmui-table-mono table tbody tr td a.wmui-btn.red:hover {
    background-color: red !important;
    border-color: red;
    color: white !important;
    text-shadow: #646464 1px 1px 0;
}

.wmui-table-mono table tbody tr td a.wmui-btn.active {
    background-color: gray;
    color: white;
    text-shadow: #646464 1px 1px 0;
    border: 1px solid rgba(0, 0, 0, 0.5);
}

.wmui-table-mono table tbody tr td a.wmui-btn.active.edit {
    background-color: #8BC53F !important;
}

.wmui-table-mono table tbody tr td a.wmui-btn.active:hover {
    color: white !important;
}

.wmui-table-mono table tbody tr td a.wmui-btn:hover {
    border: 1px solid gray;
    color: blue !important;
}

.wmui-table-mono table tbody tr td.unit {
    color: white;
    text-shadow: black 1px 1px 0;
    text-align: right !important;
    font-size: 7px !important;
    font-weight: bold;
    background-image: url("/images/ui/_tags_18.png");
    background-repeat: no-repeat;
    background-position: 0 0;
    text-shadow: "black" 1px 1px 0;
    background-position: 0 2px;
}

.exported {
    text-shadow: "black" 1px 1px 0;
    width: 100%;
}

.exported .icon {
    text-align: center;
    cursor: pointer;
    width: 100px;
    height: 131px;
    margin: 20px auto 0;
    float: none;
    clear: both;
}

.exported .icon.error {
    cursor: auto;
    background-image: url("/images/ui/export_error.png");
    background-repeat: no-repeat;
    background-position: 0 0;
}

.exported .icon.csv {
    background-image: url("/images/ui/export_csv.png");
    background-repeat: no-repeat;
    background-position: 0 0;
}

.exported .icon.pdf {
    background-image: url("/images/ui/export_pdf.png");
    background-repeat: no-repeat;
    background-position: 0 0;
}

.exported .icon.html {
    background-image: url("/images/ui/export_html.png");
    background-repeat: no-repeat;
    background-position: 0 0;
}

.exported .icon.xlsx {
    background-image: url("/images/ui/export_xlsx.png");
    background-repeat: no-repeat;
    background-position: 0 0;
}

.exported .wmui-btn-download {
    cursor: pointer;
    text-align: center;
}

.exported .wmui-btn-download .wmui-btn {
    font-size: 12px;
    margin: 6px auto;
}

.exported p {
    text-align: center;
    font-size: 10px;
}

.exported p.error {
    background: none !important;
    color: red;
    padding: 10px 20px;
}

div.form_content {
    padding: 0 10px;
}

div.ldr_il {
    margin: 20px;
}

.wmui-chart-components,
.wmui-chart-legend,
.wmui-export,
.wmui-chart-triggers,
.wmui-costs {
    margin: 0;
}

.wmui-chart-triggers div {
    padding: 10px;
}

.wmui-chart-legend {
    width: 100%;
}

.wmui-chart-legend ul {
    padding: 5px;
}

.wmui-chart-legend ul li {
    border-top: 1px solid #E3E3E3;
    padding: 0 5px !important;
    clear: both;
}

.wmui-chart-legend ul li.active {
    background-color: #2372D5;
}


.wmui-chart-legend ul li.item.component {
    display: flex;
    margin: 0;
}

.wmui-chart-legend ul li.item.current.component {
    background-color: transparent !important;
}

.wmui-chart-legend ul li.item .wmui-icon {
    float: left;
    margin: 3px 6px !important;
}

.wmui-chart-legend ul li.item .wmui-icon:hover path {
    stroke: #A1A1A1;
    fill: white;
}

.wmui-chart-legend ul li div.color-box {
    display: block;
    float: left;
    width: 10px;
    height: 10px;
    margin: 6px 0;
}

.wmui-chart-legend ul li label {
    float: none;
}

.wmui-chart-legend ul li .label {
    float: none;
    font-size: 9px;
    width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

th.d-head {
    background-image: none !important;
    background-color: white;
    border: none !important;
    width: 12px;
    padding: 2px 0 !important;
}

td.d-handler {
    border-right: 1px solid #F7F7F7;
    margin: 0;
    padding: 0 !important;
    cursor: move;
}

td.d-handler div {
    color: black;
    border-radius: 3px !important;
    width: 10px !important;
    height: 20px;
    font-weight: bold;
    padding: 0 0 0 5px;
    font-size: 12px;
}

tr.tDnD_whileDrag {
    background-color: #FAF9B6 !important;
}

tr.tDnD_whileDrag td.d-handler {
    background-color: #FAF9B6;
}

tr.tDnD_whileDrag td {
    border-top: 1px solid #E3E3E3 !important;
    border-bottom: 1px solid #E3E3E3 !important;
    font-weight: bold;
    color: black;
}

.wmui-tipper {
    z-index: 99999;
    top: 0;
    opacity: 0;
    position: absolute;
    background-color: "none";
}

.wmui-tipper .wmui-tipper-arrow {
    width: 0;
    height: 0;
    position: absolute;
    z-index: 10;
}

.wmui-tipper .wmui-tipper-arrow.n, .wmui-tipper .wmui-tipper-arrow.ne, .wmui-tipper .wmui-tipper-arrow.nw {
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #333333;
}

.wmui-tipper .wmui-tipper-arrow.s, .wmui-tipper .wmui-tipper-arrow.se, .wmui-tipper .wmui-tipper-arrow.sw {
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #333333;
}

.wmui-tipper .wmui-tipper-body {
    z-index: 11;
    margin-top: 10px;
    box-shadow: 0 0 5px #BCBCBC;
    background: #333333;
    padding: 0 5px;
    border-radius: 3px !important;
    padding: 10px 10px;
    text-align: center;
    color: #F3F3F3;
}

.wmui-tipper .wmui-tipper-body .wmui-tipper-msg {
    font-size: 9px;
    border: 1px solid #333333;
    width: 100%;
    text-transform: uppercase;
    text-align: left;
}

.wmui-tipper .wmui-tipper-body label {
    display: block;
    width: 100%;
    margin-bottom: 9px;
    padding-left: 2px;
    text-align: left !important;
    font-size: 9px !important;
    text-transform: uppercase;
    color: #E3E3E3;
}

.wmui-tipper .wmui-tipper-body input {
    clear: left;
    border: 1px solid #444444;
    padding: 6px !important;
    margin-bottom: 9px;
    font-size: 12px;
    background: #F3F3F3;
    min-width: 200px;
    color: #444444 !important;
    font-weight: 700;
}

.wmui-tipper .wmui-tipper-body p {
    padding: 0 !important;
    font-size: 12px;
    margin: 0 0 9px;
}

.wmui-tipper .wmui-tipper-body.wmui-tipper-publish div.tiper-form {
    text-align: left;
    margin: 4px 0 9px !important;
    overflow: hidden;
}

.wmui-tipper .wmui-tipper-body.wmui-tipper-publish div.tiper-form select {
    min-width: 100px;
}

.wmui-tipper .wmui-tipper-body.wmui-tipper-signal {
    padding: 4px 6px 3px !important;
    background-color: #F8E891;
}

.wmui-tipper .wmui-tipper-body.wmui-tipper-signal p {
    margin: 0 !important;
    padding: 0 9px !important;
    color: #444444;
    font-weight: 700;
    font-size: 10px;
}

.wmui-tipper .wmui-tipper-body.wmui-tipper-signal p.imperative {
    text-transform: uppercase;
}

.wmui-tipper .wmui-tipper-body.wmui-tipper-signal p.declarative {
    text-transform: normal;
}

.wmui-tipper .wmui-tipper-body .wmui-tipper-btns .wmui-btn {
    margin-right: 5px !important;
    text-transform: uppercase;
}

.wmui-tipper.an-n, .wmui-tipper.an-ne, .wmui-tipper.an-nw {
    margin-top: 10px;
    opacity: 1;
}

.wmui-tipper.an-s, .wmui-tipper.an-se, .wmui-tipper.an-sw {
    margin-top: -15px;
    opacity: 1;
}

.an {
    transition: all 0.3s;
}

.wmui-visualizations ul {
    padding: 10px 10px 10px 10px;
}

.wmui-visualizations ul li {
    clear: both;
    margin: 1px 0 0;
    padding: 2px 5px;
    border-bottom: 1px solid #E3E3E3;
}

.wmui-visualizations ul li.active {
    background-color: #F7F7F7;
}

.wmui-visualizations ul li:last-child {
    border: none;
}

.wmui-visualizations ul li div.wmui-icon {
    float: left;
}

.wmui-visualizations ul li label {
    padding: 0 0 !important;
    display: inline-block;
    vertical-align: top;
    margin: 3px 0 6px 6px;
    color: gray;
}

.wmui-visualizations ul li.current label {
    color: black;
}

.left-18 {
    margin-left: 18px;
}

.wmui-btn-right {
    min-width: 60px;
    display: inline-block;
    padding: 4px 6px;
    margin-left: auto;
    border: none;
    background-color: #8BC53F;
    font-size: 10px !important;
    color: white;
    cursor: pointer;
    border-radius: 3px !important;
    -moz-border-radius: 3px !important;
}

.wmui-btn-right:hover {
    background-color: #224C4F;
}

.wmui-btn-right:disabled {
    background-color: #D3D3D3;
    color: #333333;
    opacity: 0.7;
    cursor: not-allowed;
}

.wmui-btn-right:disabled:hover {
    background-color: #D3D3D3;
    opacity: 0.7;
    cursor: not-allowed;
}
.ribbon {
    width: 30px;
    height: 40px;
    background-color: #8BC53F;
    position: absolute;
    right: 5%;
    top: -350px;
    animation: drop forwards 1s 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);

    &:before {
        content: '';
        position: absolute;
        z-index: 2;
        left: 0;
        bottom: -14px;
        border-left: 15px solid #8BC53F;
        border-right: 15px solid #8BC53F;
        border-bottom: 15px solid transparent;
    }
}

@keyframes drop {
    0% { top: -350px; }
    100% { top: 0; }
}
.progress {
    margin: 5px 0;
    display: flex;
    height: 1rem;
    overflow: hidden;
    font-size: 0.75rem;
    background-color: #E9ECEF;
    border-radius: 0.25rem;
}

.progress-bar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    color: #FFFFFF;
    text-align: center;
    white-space: nowrap;
    background-color: #8BC53F;
    transition: width 0.6s ease;
}

.progress-bar.yellow {
    background-color: #F5D124;
}

.missing-configurations {
    margin: 20px 0;

    :first-child {
        font-weight: bold;
    }
}
.ui-schedule {
    overflow: auto;
    clear: left;
    float: left;
    padding-right: 10px;
}

table.ui-schedule-table {
    border: 1px solid #222222 !important;
    border-collapse: collapse;
    margin-top: 0;
}

table.ui-schedule-table th {
    border: 1px solid #222222;
    padding: 0;
    text-align: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}

table.ui-schedule-table tbody tr td:first-child {
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}

table.ui-schedule-table th.day {
    width: 40px;
}

table.ui-schedule-table td {
    border: 0;
    border-right: 1px solid #888888;
    border-bottom: 1px solid #888888;
    height: 15px;
    padding: 0;
    text-align: center;
    width: 15px;
}

table.ui-schedule-table td.day {
    width: 40px;
}

.pointer-show {
    cursor: default;
}

table.ui-schedule-table td.day-change {
    border-right: 1px solid #222222;
}

.schedule-legend {
    float: left;
}

.schedule-legend .schedule-legend-label {
    font-weight: bold;
    margin: 0;
    max-width: 215px;
    text-transform: capitalize;
}

.schedule-legend .on-off {
    clear: both;
    padding-top: 10px;
}

.schedule-legend .color-legend {
    border: 1px solid transparent;
    border-radius: 3px;
    height: 16px;
    margin-bottom: 0;
    padding: 3px;
}

.schedule-legend .color-legend:hover {
    border-color: #DDDDDD !important;
    cursor: pointer;
    background-color: #FAFAFA;
}

.schedule-legend .period-values {
    float: left;
    margin-right: 2px;
    width: 50px;
}

.schedule-legend span.color-box {
    margin-right: 5px;
    width: 14px;
    height: 14px;
    float: left;
    border: 1px solid transparent;
    border-radius: 2px;
}

.schedule-legend .color-box:hover {
    border-color: #DDDDDD !important;
    cursor: pointer;
    background-color: #FAFAFA;
}

.schedule-legend span.color-text {
    float: left;
    font-size: 12px;
    font-weight: normal;
    height: 16px;
    line-height: 16px;
}

.schedule-legend #current_position {
    background: #F8F8F8;
    border: 1px solid #CCCCCC;
    border-radius: 2px;
    display: none;
    margin-top: 10px;
    padding: 5px;
}

.schedule-left {
    float: left;
    max-width: 200px;
    min-width: 200px;
    padding-right: 15px;
}

.schedule-left select {
    max-width: 200px;
}

.schedule-left input.circuit-search {
    width: 190px;
    padding: 3px;
}

.schedule-left .circuit-search-results {
    margin-top: 10px;
    max-height: 385px;
    overflow: scroll;
}

.schedule-right {
    border-left: 1px solid #CCCCCC;
    float: left;
    padding-left: 15px;
}
#tipper {
    position: fixed;
    top: 8px;
    left: 200px;
    right: 200px;
    z-index: 1000;
    text-align: center;
}

#tipper .tipper {
    -moz-border-radius: 4px;
    border: 2px solid transparent;
    border-radius: 3px;
    font-weight: bold;
    left: 50%;
    margin: 4px auto;
    padding: 2px 12px 2px 2px;
    position: absolute;
    transform: translate(-50%, 0);
    top: 0;
}

#tipper .alert, #tipper .alert path {
    background-color: #F59D24;
    color: white;
    text-shadow: none;
}

#tipper .success, #tipper .success path {
    background-color: #8BC53F;
    color: white;
}

#tipper .error, #tipper .error path {
    background-color: #E94547;
    color: white;
}

#tipper .info, #tipper .info path {
    background-color: #6EB3E3;
    color: white;
}

#tipper .tipper-icon {
    float: left;
    margin: 0 10px 0 5px;
}
.capitalize::first-letter {
    text-transform: capitalize;
}

.decapitalize {
    text-transform: none !important;
}

.pointer:hover {
    cursor: pointer;
}

div.svg_icon.disabled_icon {
    cursor: default;
    opacity: 0.2;
}

div.svg_icon.red > svg > path {
    fill: red
}

div#wmwmui-datepicker-div {
    z-index: 100;
}

#wmui-timepicker-div dl {
    text-align: left;
}

#wmui-timepicker-div dl dt {
    height: 25px;
}

#wmui-timepicker-div dl dd {
    margin: -25px 0 10px 65px;
}

body {
    height: 100%;
    margin: 0;
    overflow: hidden;
    width: 100%;
    -webkit-text-size-adjust: none;
    -webkit-user-select: text;
    -moz-user-select: text;
}


/*  this still allows the indicator to appear when focused by keyboard, but hides when mouse activated. It’s the best of both worlds… */

a:active {
    outline: none;
}

.data_period {
    position: absolute;
    top: 37px;
    right: 36px;
    z-index: 999;
}

.data_period input {
    border: none;
    font-family: "Lucida Grande", "Lucida Sans Unicode", Helvetica, Arial, Verdana, sans-serif;
    text-align: center;
    font-size: 11px;
    display: inline;
    color: #333333;
    text-decoration: underline;
    cursor: pointer;
    cursor: hand;
    padding: 0 5px;
    top: 3px;
}

.data_period input.to {
    padding: 0 0 0 5px;
}

.data_period .select a.current {
    padding-right: 3px;
    color: #000000;
    padding-bottom: 2px;
}

.data_period .select .dropdown {
    z-index: 2;
    background-color: #FFFFFF;
    display: inline;
    border: 1px solid transparent;
    border-top-left-radius: 5px;
    -moz-border-radius-topleft: 5px;
    border-top-right-radius: 5px;
    -moz-border-radius-topright: 5px;
    padding-bottom: 2px;
}

.data_period .select .dropdown img {
    position: relative;
    top: 3px;
    cursor: pointer;
    cursor: hand;
}

.data_period .select .dropdown .options {
    z-index: -1;
    position: absolute;
    right: 0;
    margin-top: 2px;
    padding: 5px 10px;
    text-align: right;
    background-color: #FFFFFF;
    border-top-left-radius: 5px;
    -moz-border-radius-topleft: 5px;
    border-bottom-left-radius: 5px;
    -moz-border-radius-bottomleft: 5px;
    border-bottom-right-radius: 5px;
    -moz-border-radius-bottomright: 5px;
    border: 1px solid #C2C2C2;
}

.data_period .select a,
.data_period .select .dropdown .options a {
    color: #999999;
}

.data_period .select a:hover,
.data_period .select .dropdown .options a:hover {
    color: #000000;
}


/*login*/

.login #main {
    background-color: #224C4F;
    border-width: 0 !important;
    overflow-y: auto;
    top: 0;
}

.login .central {
    position: absolute;
    left: 50%;
    top: 30%;
    margin-left: -267px;
}

.login .log {
    float: left;
    width: 200px;
    padding: 6em 4em 0 0;
}

.login .form_log {
    float: left;
    width: 310px;
}

.login .form_log p .title.corn {
    width: -webkit-fill-available;
    margin-top: 0.5em;
}

.login .form_log form div {
    margin: 0.5em 0;
    border: none !important;
}

.login .form_log .footer {
    display: flex;
    justify-content: space-between;
}

.login .msg {
    padding: .5em .5em 0.25em;
    color: white;
}

.login .msg .icon {
    margin-right: 8px;
}

.login .msg .svg_icon {
    margin-right: 8px;
}

.login .msg_text {
    font-size: .8em;
    line-height: 2em;
}

.login .central label {
    color: white;
    font-size: .8em;
    line-height: 1.5em;
    display: block;
    margin-top: .5em;
}

.login .central form {
    margin-top: .5em;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    padding: 1em 0.5em;
    overflow: auto;
}

.login .loader {
    background-image: url(/images/ui/search_loader.gif) !important;
    width: 16px;
    height: 16px;
    float: left;
    margin-right: 10px;
    border: 0 solid gray !important;
}

.login .msg_text {
    text-transform: uppercase;
}

.login .active {
    background-color: #3B73BA;
}

.login input[type=submit] {
    height: 24px;
    width: 100px;
    border: 1px;
    font-weight: bold;
    cursor: pointer;
    border-radius: 3px;
    background-color: #FDFDFD;
    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#DCDCDC), to(#FDFDFD));
}

.login input[type=submit]:hover {
    background-color: #DCDCDC;
    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#FDFDFD), to(#DCDCDC));
}

.login a.small {
    font-size: .9em;
    text-decoration: none;
    color: white;
}

.login a.small:hover {
    font-size: .9em;
    text-decoration: none;
    color: rgba(255, 255, 255, 1);
}


/*inline buttons*/

a.lnk {
    font-size: 8px;
    background: #E3E3E3;
    color: #2E3D1B;
    text-transform: uppercase;
    padding: .3em 1em;
    text-decoration: none;
    border-radius: 3px;
    margin-right: 3px;
}

a.lnk.operation {
    font-size: 10px;
    line-height: 2;
}

a.lnk:hover {
    background: #63764B;
    color: white
}


/*colors*/

a.lnk_right {
    float: right !important;
}

a.lnk_red {
    background: #FFD3D3;
    color: #C41E12;
}

a.lnk_red:hover {
    background: red;
    color: white;
}

a.lnk_blue {
    background: #1C9EE8;
    color: white;
}

a.lnk_blue:hover {
    background: #007AC0;
    color: white;
}

a.lnk_petro {
    background: #E3E3E3;
    color: #2E3D1B;
}

a.lnk_petro:hover {
    background: #0366B7;
    color: white;
}

a.lnk_green {
    background: #DAFFEA;
    color: #147307;
}

a.lnk_green:hover {
    background: #3FA76B;
    color: white;
}

a.lnk_yellow {
    background: #FFFADB;
    color: black;
}

a.lnk_yellow:hover {
    background: #FFEA5F;
    color: black;
}

a.lnk_gray {
    background: #94979A;
    color: white;
}

a.lnk_gray:hover {
    background: #3579EB;
    color: white;
}

.lnk_tlb {
    margin: 1em .5em;
    border-bottom: 1px solid #E3E3E3;
    height: 26px;
}

a.lnk_big {
    color: black;
    padding: .5em 1em;
    font-size: 1.1em;
    background: #F1F1F1;
    border: 1px solid gray;
    font-weight: bold;
    text-decoration: none;
    float: left;
}

a.lnk_big:hover {
    background: gray;
    color: white;
}


.bar {
    height: 4px;
    width: 100%;
    position: absolute;
    background-color: #F3F3F3;
    background: -moz-linear-gradient(to bottom, #DCDCDC, #FDFDFD);
}

#search {
    margin: 0 5px 0 0;
    padding: 3px 5px;
    height: 36px;
}

#search .btn {
    margin-top: 8px;
}

#search input {
    padding: 2px;
    margin: 7px 10px 5px 3px;
    width: 212px;
    -moz-border-radius: 2px;
    float: left;
}

#main {
    background-color: white;
    bottom: 0;
    left: 0;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 41px;
    z-index: 1;
}

#main_panels {
    bottom: 4px;
    left: 0;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;
}

#main_status_bar {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
}

#navbar-inner {
    margin-right: 0;
    min-height: 38px;
    height: 38px;
    border-radius: 0;
    border-width: 1px 0;
    display: flex;
    justify-content: space-between;

    ul {
        width: 100%;
        overflow-y: scroll;
    }

    button {
        border: none;
        background: none;
    }
}

#wrapper {
    display: flex;
    flex-direction: row;
    position: fixed !important;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: 50px 0 0;
    overflow: hidden;
    width: 100%;
}

#elm_content {
    flex: 1;
    display: block;
    padding: 0;
    position: relative !important;
    overflow: auto;
}

#elm_sidebar {
    background-color: #FAFAFA;
    cursor: default;
    overflow: hidden;
    position: relative !important;
    width: 225px;
    min-width: 225px;
    max-width: 50%;
    border-right: #E5E5E5 solid 1px;
}

#elm_sidebar > .ui-resizable-handle.ui-resizable-e {
    right: 0;
    top: 0;
    width: 8px;
    height: 100%;
    background-position: -26px center;
    cursor: col-resize;
    background-color: #FAFAFA;
    position: absolute;
    background-image: url(/images/ui/resizable.png);
    background-repeat: no-repeat;
    margin-top: 0;
}

#elm_sidebar > .panels_container {
    right: 7px;
}

#elm_sidebar .tab_sections {
    padding-right: 10px;
}

#content-body .wmui-split_view .ph_left {
    min-height: calc(100vh - 75px);
}

.elm_resize_vertical_handler {
    bottom: 0;
    cursor: col-resize;
    position: absolute;
    top: 35px;
    width: 5px;
    z-index: 500;
    left: 220px;
    border-right: 1px solid #797979;
}

.panels_container {
    overflow: auto;
}

.status_bar {
    height: 4px;
    overflow: hidden;
    white-space: nowrap;
    z-index: 12;
    border-top: 1px solid #A2A2A2;
    background-color: #F3F3F3;
    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#DCDCDC), to(#FDFDFD));
}

div.panels_container {
    position: absolute;
    background-color: transparent;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
}

#elm_sidebar div.panels_container {
    padding: 0 !important;
    background-color: #FAFAFA;
}

.default_background,
.default_loader {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    text-align: center;
    background: url(/images/ui/logo_inverted.png) no-repeat center center;
    background-position-x: 50%;
    background-position-y: 50%;
    background-color: #F3F3F3 !important;
    display: block;
}

.default_loader {
    background: url(/images/ui/loader.svg) no-repeat center center;
}

ol.silver > li.tab.current {
    background: -moz-linear-gradient(to bottom, #FFFFFF, #FAFAFA);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#FEFEFE', endColorstr='#FAFAFA', GradientType=0);
}

ul {
    list-style: none;
}

ul li {
    float: left;
    margin-right: 5px;
}

ul li a {
    text-decoration: none;
}

.icon {
    float: left;
    margin-right: 2px;
    margin-top: 0;
    width: 16px;
    height: 16px;
}

.svg_icon {
    float: left;
    margin-right: 5px;
    margin-top: 0;
    width: 16px;
    height: 16px;
}

.accordion-toggle .svg_icon {
    line-height: 18px;
    margin-right: 10px;
}

.accordion-toggle .wmui-btn {
    float: right;
    margin-top: -1px;
    width: 60px;
}

.svg_icon > svg > path {
    fill: #606060
}

li.current > .svg_icon > svg > path {
    fill: #E0E0E0
}

.wmui-icon > svg > path {
    fill: #AAAAAA
}

.wmui-icon > svg:hover > path {
    fill: #DDDDDD
}

.btn {
    float: left;
    margin-right: 3px;
    margin-top: 0;
    width: 16px;
    height: 16px;
    cursor: pointer !important;
}

.first {
    margin-left: 10px;
}

.last {
    margin-right: 10px;
}

.section {
    background: transparent;
    overflow: auto;
    margin-top: 5px;
}

.section .head {
    cursor: pointer;
    padding: 5px 0;
}

.section .title {
    color: #39508A;
    text-transform: uppercase;
    font-size: 10px;
    font-weight: bold;
    padding-left: 10px;
}

.section ul.toolbar li {
    position: relative;
    float: left;
    margin-left: 5px;
    padding: 0 !important
}

.section ul.toolbar li.top {
    top: -3px;
}

.section ul li {
    cursor: pointer;
    float: none;
}

.section li.search {
    display: none;
}

.section .toolbar {
    float: right;
    margin-right: 5px;
}

.section .body {
    width: 100%;
    overflow: hidden;
}

ul.items {
    margin-right: -5px;
    padding: 0;
}

li.item {
    height: 24px;
    line-height: 24px;
    margin-top: 1px;
    padding-left: 8px;
    white-space: nowrap;
}

li.item.activate, li.item.deactivated {
    height: 40px;
}


li.item div.title {
    text-transform: none;
    padding-left: 0;
    padding-right: 10px;
    font-size: .9em;
    font-weight: normal;
    color: #000000;
    margin-left: 1em;
    text-overflow: ellipsis;
    overflow: hidden;
}

li.item div.title .tree {
    display: flex;
    justify-content: space-between;
    padding-right: 10px;
}

li.item div.title .tree .lock {
    color: #BCC9CA;
}

li.item div.title .tree {
    display: flex;
    justify-content: space-between;
    padding-right: 10px;
}

li.item div.title.activate {
    color: #E94547;
}

li.item div.title.deactivated {
    color: grey;
}

li.item div.svg_icon {
    text-align: center;
}

li.item div.accessor {
    float: right;
    margin-right: 7px;
}

li.item.current {
    background-color: #224C4F;
    background-position-x: 100%;
    background-position-y: 50%;
    background-repeat: no-repeat;
}

li.item.current.activate {
    background-color: #E94547;
}

.subtitle {
    font-size: 8px;
    line-height: 0;
}

li.item.current.deactivated {
    background-color: grey;
}

li.item.current .title,
li.item.current .title.activate,
li.item.current .title.deactivated {
    color: white;
}

li.item.high .icon {
    margin-right: 5px;
    margin-top: 4px;
    width: 32px !important;
    height: 32px !important;
}

li.item.high .svg_icon {
    float: left;
    margin-right: 5px;
    margin-top: 4px;
    width: 32px !important;
    height: 32px !important;
}

li.item.high .title {
    height: 40px;
}

li.item.high {
    height: 40px;
    line-height: 40px;
    margin-top: 1px;
    white-space: nowrap;
    padding-left: 20px;
}

.spacer {
    float: left;
    margin-right: 2px;
    margin-top: 0;
    width: 16px;
    height: 16px;
}

.hidden {
    display: none;
}

.hidden-transition {
    opacity: 0;
    max-height: 0;
    min-height: 0;
    overflow: hidden;
}

.visible-transition {
    opacity: 1;
    max-height: 1000px; /* Arbitrary large value */
    transition: opacity 1s ease, max-height 1s ease;
}

.search_panel {
    position: absolute;
    z-index: 1001;
    left: 111px;
    top: 0;
    height: auto;
    max-height: 90%;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: white;
    border-right: 1px solid #A1A1A1;
    border-bottom: 1px solid #A1A1A1;
    width: 254px;
    box-shadow: rgba(0, 0, 0, 0.2) 0 5px 25px;
    background: #FFFFFF;
}

.search_panel ul {
    background-image: url(/images/ui/lst_bck_src.png);
    list-style: none;
    border-bottom: 1px solid #E3E3E3;
}

.search_panel ul li {
    white-space: nowrap;
    float: none;
    cursor: pointer;
    padding: 0;
    margin: 0;
    height: 48px;
    line-height: 1.5em;
}

.search_panel ul li:hover {
    color: white;
    background-color: #758193;
}

.search_panel ul li .icon {
    margin-top: .5em;
    margin-right: 5px;
}

.search_panel ul li .svg_icon {
    margin-top: .5em;
    margin-right: 5px;
}

.search_panel ul li .title {
    padding-top: .5em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 0;
    font-size: 1em;
    font-weight: bold;
}

.search_loader {
    background-image: url(/images/ui/search_loader.gif) !important;
}

.search_panel ul li.no_result {
    background-color: #F3F3F3;
    padding: 10px 10px 0;
    border-bottom: 4px solid white;
}

.search_panel ul li.no_result p {
    color: gray;
    text-align: center;
    margin-bottom: 3px;
}

.search_panel ul li.no_result p.small {
    font-style: italic;
    font-size: 9px;
    text-transform: normal;
    text-align: center;
    margin-bottom: 3px;
}

.center {
    text-align: center;
}

.active {
    background-color: #386BC0;
}

.error {
    background-color: #EB4F35;
}

.success {
    background-color: #50C029;
}

.box {
    padding: 1em 2em;
}

.box .toolbar {
    padding: 0;
    margin: 0;
    overflow: hidden;
    border: 1px solid #C2C2C2;
    height: 24px;
    background: -moz-linear-gradient(to bottom, #FCFCFC, #E9E9E9);
    background-color: #BBBBBB;
}

.toolbar_button {
    background-color: transparent;
    border: 0 none transparent;
    display: block;
    float: left;
    vertical-align: top;
    padding: 0;
    height: 24px;
    font-size: .9em;
    cursor: pointer;
    border-right: 1px solid #C2C2C2;
    text-shadow: white 0 1px 1px;
}

.toolbar_button:hover,
.toolbar > div > div.dropdown > .toolbar_button:hover {
    background-color: rgba(255, 255, 255, .8)
}

.toolbar_button.active {
    background-color: #C4C4C4;
    color: white;
    border: 1px solid #E3E3E3;
}

.toolbar_button.disabled {
    background-color: rgba(255, 255, 255, .8);
    color: #CBCBCB;
}

.toolbar_button_item {
    width: 24px;
    height: 24px;
}

.right {
    border: 0 none transparent !important;
    border-left: 1px solid #C2C2C2 !important;
}

.item_24 {
    width: 24px !important;
}

.item_48 {
    width: 48px !important;
}

.item_72 {
    width: 72px !important;
}

.item_96 {
    width: 96px !important;
}

.item_120 {
    width: 120px !important;
}

.item_144 {
    width: 144px !important;
}

.item_168 {
    width: 168px !important;
}

.item_192 {
    width: 192px !important;
}

.item_216 {
    width: 216px !important;
}

.item_float {
    padding: 0 1em;
}

select.toolbar_select {
    border: 1px solid #C2C2C2 !important;
    width: 200px;
    margin: 2px;
}

.toolbar label {
    padding: 0 0 0 1em;
    font-size: 10px !important;
    font-weight: normal;
}

.toolbar_icon.item_float {
    padding-left: 2.5em !important;
}

.toolbar > div > div.dropdown {
    border-top: 1px solid #C2C2C2;
}

.toolbar > div > div.dropdown > .toolbar_button {
    background-color: transparent;
    display: block;
    margin: 0;
    vertical-align: top;
    padding: 0;
    height: 24px;
    font-size: .9em;
    cursor: pointer;
    text-shadow: white 0 1px 1px;
    float: none;
    border-width: 1px 1px 1px 1px;
    border-color: #C2C2C2;
    width: 25px;
    border-style: none solid solid solid;
}

.toolbar > div > div.dropdown > .toolbar_button + .last {
    border-style: solid;
}

.toolbar .from,
.toolbar .to {
    position: relative;
    height: 24px;
}

.toolbar .from {
    width: 140px;
}

.toolbar .to {
    width: 130px;
}

.toolbar .from > label,
.toolbar .to > label {
    float: left;
    top: 8px;
    position: relative;
    width: 0;
    z-index: 1;
}

.toolbar .from > input,
.toolbar .to > input {
    width: 115px;
    vertical-align: top;
    height: 24px;
    text-shadow: 0 1px 1px white;
    display: block;
    cursor: pointer;
    background-color: transparent;
    border-color: transparent;
    border-style: none;
    font-size: 10px;
    margin: 0;
    padding: 1px 10px 0 5px;
    position: absolute;
    text-align: right;
    z-index: 2;
}

.toolbar .from > input {
    width: 125px;
}

.toolbar .to > input {
    width: 115px;
}

dl.stepped {
    -webkit-user-select: text;
    font-size: 10px;
}

dl.stepped dt {
    font-size: 11px;
    color: #000000;
    font-weight: bold;
    overflow: hidden;
}

dl.stepped dd {
    font-size: 11px;
    color: #535353;
    margin-bottom: 5px;
    text-align: justify;
}

dl.stepped.colored {
    background-color: #F3F3F3;
    padding: 1em 2em !important
}

.colored {
    background-color: #F3F3F3;
}

.uppercase {
    text-transform: uppercase;
}

table {
    width: 100%;
    -webkit-user-select: text;
    margin-top: 1em;
}

table thead {
    line-height: 2em;
    font-size: 0.75em;
    text-transform: uppercase;
    font-weight: bold;
    text-shadow: none;
}

table thead th {
    border-bottom: 1px solid #CBCBCD !important;
    padding-left: 1em;
}

table tbody tr {
    line-height: 1.8em;
    font-size: 0.8333em;
    cursor: pointer;
}

table.hv tbody tr:hover {
    background-color: #336FD4 !important;
    color: white;
}

table.hv tbody tr:hover td > a {
    color: white;
}

table.hv tbody tr:hover td {
    border-right: 1px solid transparent;
}

table tbody td.sym {
    width: 25px;
    text-align: center;
    padding-left: 0;
}

table tbody td {
    padding-left: 1em;
    border-right: 1px solid #F3F3F3;
    text-overflow: ellipsis;
    overflow: hidden;
}

table tbody td a {
    text-decoration: none;
    color: black;
}

table tbody td.last {
    border-width: 0 !important;
}

table tbody td.red {
    color: #E94547;
}

table tbody td.blue {
    color: #6EB3E3;
}

table tbody td.green {
    color: white;
}

table tbody td.yellow {
    color: #F5D124;
}

table tbody td.gray {
    color: #94979A;
}

table.interval {
    width: 452px;
    border-style: solid;
    border-width: 1px 0 0 0;
    border-color: #444444;
    padding-bottom: 5px;
    color: black
}

table.interval tr.spacer {
    height: 5px;
}

table.interval tr.spacer.shaded {
    height: 5px;
    background-color: #F0F0F0;
    width: 100%
}

table.interval th {
    background-color: #F0F0F0;
    border: 0;
    font-size: 11px;
    line-height: 17px;
    padding: 0;
    text-align: center;
    width: 125px;
}

table.interval th.head {
    font-weight: bold;
    background-color: #FAFAFA;
}

table.interval th.top {
    vertical-align: top;
}

table.interval td {
    text-align: left;
    font-weight: bold;
    border: 0;
    padding: 0;
    font-size: 11px;
    line-height: 17px;
}

table.interval td.unit {
    text-align: left;
    font-weight: normal;
    border: 0;
    padding: 0;
}

table.interval input {
    text-align: center;
    width: 221px;
    padding: 0;
    margin: 0;
}

table.interval input[type=radio] {
    width: initial;
    margin: 0 5px;
}

table.interval input[type=radio]:focus {
    margin: 0 5px
}

table tbody tr.built_in,
table tbody tr.built_in a,
.built_in {
    color: gray;
}

table.expanded {
    border-top: 1px solid #E3E3E3;
    border-bottom: 1px solid #E3E3E3;
}

table.underline tbody tr:hover td {
    background-color: #2372D5;
    color: white;
    border-right: 1px solid #A3B9D7;
}

table.underline tbody td a {
    color: white;
}

table.base tbody tr td a {
    color: blue;
    text-decoration: underline;
}

table.base tbody tr:hover td a {
    color: white;
    text-decoration: underline;
}

table.ind {
    margin: .5em 0 1em;
    overflow: auto;
    border-bottom: 1px solid #E3E3E3;
}

table.ind tbody tr td {
    border-top: 2px solid #FFFFFF;
    border-bottom: 2px solid #FFFFFF;
}

table.ind td p.title {
    font-weight: bold;
    font-size: 1.2em;
    padding-top: .5em;
}

table.ind td.sym {
    padding: .5em;
}

table.ind td p.lead {
    font-weight: normal;
    font-size: 1em;
    padding-top: .5em;
}

table.ind td {
    background: -webkit-gradient(linear, 0% 20%, 0% 100%, from(#F1FFF6), to(#F1FFF6));
}

table.ind td p.max {
    font-weight: bold;
    color: red;
    padding: 0 .5em;
}

table.ind td p.min {
    font-weight: bold;
    color: green;
    padding: 0 .5em;
}

table.ind td p.value {
    font-size: 1.5em;
    font-weight: bold;
    color: blue;
}

table td.top {
    vertical-align: top;
}

table td.center {
    text-align: center;
}


/* table properties for showing metadata history in inspector panel */

table.metadata_history {
    font-size: 12px;
}

table.metadata_history tbody tr {
    width: auto;
}

table.metadata_history tbody tr td {
    width: auto;
}

.strong {
    font-weight: bold;
}

.explain {
    padding: .5em;
    border-bottom: 1px solid #E3E3E3;
}

.explain .error {
    text-align: left;
    font-size: .9em;
    margin-bottom: 5px;
}

.explain > div {
    padding: .5em 1em;
}

.explainError {
    color: #CC0000;
    font-size: 1em;
    padding: 0;
    border: none;
}

.explain .error.adhoc {
    background-image: url(/images/ui/accessor_down.png);
    background-position-x: 100%;
    background-position-y: 50%;
    background-repeat: no-repeat;
}

.explain .info {
    border: 1px solid #F3F3F3;
    background: #F7F7F7;
    color: black;
    font-size: .8em;
    margin-bottom: 5px;
    line-height: 1.8333;
}

.explain .notice {
    background-color: #D8E0E1 !important;
}

.err {
    color: #CC0000;
}

.err_dot {
    color: #AE0000;
    margin-left: 1em;
    float: left;
    font-size: 1em;
    line-height: 1.5em;
    cursor: pointer;
}

.err-help {
    margin-left: 3px;
    font-size: 1.2em;
}

.help {

}

/* .help:ho */

/*tooltip*/

div.stt {
    padding: .3em .8em;
    border-width: 2px !important;
    position: absolute;
    border: 2px solid #CC0000;
    background: rgba(204, 0, 0, .75);
    color: white;
    font-size: .9em;
    z-index: 10000;
    box-shadow: rgba(0, 0, 0, 0.5) 0 5px 5px;
}

div.stt_err {
    border: 2px solid red;
    background: rgba(179, 0, 3, .9);
    color: white;
    font-size: .9em;
}

div.stt_arr_down,
div.stt_arr_down_inner {
    position: absolute;
    width: 0;
    height: 0;
    border-bottom-width: 0;
    background: none;
}

div.stt_arr_down {
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top-width: 14px;
    bottom: -7px;
    right: auto;
    left: 50%;
    margin-left: -7px;
}

div.stt_arr_down_inner {
    border-right: 7px solid transparent;
    border-left: 7px solid transparent;
    border-top: 7px solid #CC0000;
    bottom: auto;
    top: -7px;
    left: -7px;
}

div.stt_err div.stt_arr_down_inner {
    border-top: 7px solid red;
}

div.sep {
    color: gray;
    overflow: auto;
    padding: 3px 5px 0 5px !important;
    margin-top: 1em;
}

div.sep h6 {
    font-weight: bold;
}

div.sep_brd {
    border-bottom: 1px solid rgb(227, 227, 227) !important;
}

.resource_error {
    background-color: #DEDEDE;
    color: white;
}

ul.dashed {
    padding: .5em;
}

ul.dashed > li {
    width: 100%;
    min-width: 500px;
    border: 2px solid transparent;
}

ul.dashed > li.selected .spark_ind {
    background: -webkit-gradient(linear, 0% 50%, 0% 100%, from(#F3F3F3), to(#F3F3F3));
}

.spark_ind {
    text-shadow: rgba(255, 255, 255, 0.496094) 0 1px 1px;
    border: 1px solid #E3E3E3;
    background: -webkit-gradient(linear, 0% 50%, 0% 100%, from(#FBFBFB), to(#F9F9F9));
    float: left;
    margin: 0 5px 5px 0;
}

.spark_ind .title {
    font-size: .9em;
    font-weight: bold;
    padding: .5em .5em;
    margin-left: 5px;
}

.spark_ind .right {
    border: none;
}

.spark_ind .pod {
    width: 480px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 5px;
}

.spark_ind .folder {
    width: 480px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 5px;
}

.spark_ind .value {
    width: 80px;
    text-align: center;
    padding: .5em;
    float: left;
    margin-right: 10px;
    color: #144A77;
}

.spark_ind .value .number {
    font-size: 1.8em;
    font-weight: normal;
    padding: 0;
    margin: 0;
    color: #144A77;
}

.spark_ind .value .unit {
    font-size: 1em;
    padding: 0;
    margin: 0;
}

.spark_ind .canvas {
    width: 300px;
    height: 60px;
    float: left;
    margin: 0 5px;
    border: 0 solid #E3E3E3;
    border-bottom: 1px;
}

.spark_ind .time_elapse {
    font-size: .8em;
    padding: .5em 0;
    margin: 0;
    font-weight: bold;
    text-align: center;
    clear: both;
    color: #949494;
    padding-right: 10px;
}

.spark_ind .extras {
    float: left;
}

.spark_ind .extras ul {
    padding: 1em 0;
    width: 60px;
    overflow: auto;
}

.spark_ind .extras ul li {
    text-align: center;
    clear: both;
    width: 100%;
}

.spark_ind .handler {
    cursor: pointer;
}

.spark_ind .max {
    font-size: .8em;
    color: red;
}

.spark_ind .min {
    font-size: .8em;
    color: green;
}

._handler_ {
    width: 16px;
    height: 16px;
    float: left;
    margin-right: 2px;
    cursor: pointer;
    border: none !important
}

._handler_target_ {
    padding: 0 1em;
}

._dash_handler_ {
    width: 16px;
    height: 16px;
    float: left;
    margin: -1px 3px;
    cursor: pointer;
    border: none !important;
}

.settings {
    border: 1px solid transparent !important;
}

td div.settings {
    margin-top: 4px;
}

.on.settings {
    z-index: 3;
    border: 1px solid #949494 !important;
    border-bottom: 3px solid #FAFAFA !important;
    background-color: #FAFAFA;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    -moz-border-radius-top-left: 3px;
    -moz-border-radius-top-right: 3px;
}

.context_menu {
    position: absolute;
    z-index: 20;
    font-size: .9em;
    margin-top: 3px;
}

.context_menu .btn {
    position: absolute;
    z-index: 4;
    right: 0;
    margin: 0 0 !important;
    border-bottom: 0 solid #FAFAFA !important;
    height: 17px;
}

.context_menu ul {
    position: absolute;
    z-index: 3;
    left: 0;
    top: 17px;
    right: 0;
    box-shadow: rgba(0, 0, 0, 0.1) 0 5px 5px;
    -moz-box-shadow: rgba(0, 0, 0, 0.1) 0 5px 5px;
    background: -moz-linear-gradient(to bottom, #FAFAFA, #FFFFFF);
    background-color: #FFFFFF;
    border: 1px solid #BFBFBF;
    padding: .5em
}

.context_menu ul li {
    list-style: none;
    line-height: 1.8em;
    border-bottom: 1px solid #E3E3E3;
    margin: 0;
    padding: 0 .5em;
    clear: both;
}

.context_menu ul li:last-child {
    border: none;
}

.context_menu ul li:hover {
    background: #949494;
    color: white;
}

.context_menu ul li:hover,
.context_menu ul li:hover a {
    color: white;
    text-shadow: none;
}

.context_menu ul li a {
    color: black;
    text-shadow: rgb(255, 255, 255) 0 1px 1px;
    width: 100%;
}

.btn.settings {
    cursor: pointer;
}

a.ctl {
    text-decoration: none;
    color: #C8C8C8;
    text-transform: uppercase;
    font-size: .78em;
    margin-top: 2px;
}

a.ctl:hover {
    text-decoration: none;
    color: #393939
}

div.chart_container {
    border-top: 1px solid #E3E3E3;
    padding: 0.5em 0;
    margin-bottom: 2em;
    overflow: hidden;
}

div.chart_container div.chart {
    padding: .5em;
    margin-bottom: .5em;
    position: relative;
    border: 1px solid #F3F3F3;
}

div.chart_container div.chart input {
    float: left;
    margin: .2em .5em 0 .25em;
}

div.chart_container div.chart div.canvas {
    margin-left: 25px;
    margin-top: .5em;
}

div.chart_container div.chart a.title {
    cursor: pointer;
}

div.chart_container div.chart div.handler {
    cursor: pointer;
}

div.chart_container div.chart div.context_menu {
    position: absolute;
    right: 4px;
    top: 5px;
    z-index: 20;
}

div.chart_container div.chart div.context_menu ul {
    top: 17px;
    margin-left: -120px;
}

div#cf-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999999;
    overflow: hidden;
}

iframe.chromeFrameInstallDefaultStyle {
    z-index: 9999;
}

input.number {
    width: 60px !important;
    float: left;
    padding: .2em
}

select.in {
    width: 120px;
    display: block;
    float: left;
    margin: .5em 1.5em .5em 0;
}

div.value_cont {
    margin: 0 0;
}

div.placeholder div.chart {
    clear: both;
}

div.placeholder div.legend {
    float: left;
    margin-left: 80px;
    z-index: 10;
}

div.placeholder div.legend > ul > li {
    width: 160px;
    float: left;
}

div.placeholder div.legend > ul > li > div {
    display: inline-block;
    width: 15px;
    height: 9px;
    border-bottom: 2px solid;
    margin-right: 5px;
}

div.placeholder div.legend > ul > li > a.legend_item {
    text-decoration: none;
    outline: none;
    color: #333333;
}

div.placeholder div.legend > ul > li > a.unselected {
    color: #CCCCCC !important;
}

div.pagination {
    font-size: 10px !important;
    line-height: 13px !important;
    padding: 10px 0 0 2px;
}


/* calendar view (3d.js) */

.ui_hc_calendar .day {
    fill: #FFFFFF;
    stroke: #CCCCCC;
    shape-rendering: crispEdges;
}

.ui_hc_calendar .month {
    fill: none;
    stroke: #000000;
    stroke-width: 2px;
    shape-rendering: crispEdges;
}

img.wise-loader {
    display: block !important;
    margin-left: auto;
    margin-right: auto;
}

span.red {
    color: red;
}

.no-margin {
    margin: 0 !important;
}

.no-padding {
    padding: 0 !important;
}

.no-border {
    border: none !important;
}

table.buckets {
    border-collapse: collapse;
}

table.buckets tr:last-child {
    border-bottom: 1px solid #3F3F3F;
}

table.buckets td,
table.buckets th {
    cursor: pointer !important;
    font-size: 1.1em;
    padding: 0 5px 0 0;
    border: none;
}

#elm_sidebar .search {
    border: 1px solid #CCCCCC;
    box-sizing: border-box;
    margin-left: 8px;
    padding: 5px;
    width: calc(100% - 18px)
}
.wmui-card-view {
    display: grid;
    grid-template-columns: [first] 24.25% [line2] 24.25% [line3] 24.25% [line4] 24.25% [end];
    margin: 20px;
    grid-gap: 1%;
    justify-content: flex-start;
}

.card {
    background-color: #FFFFFF;
    border-radius: 4px;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1);
    border: 1px solid #E4E4E7;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.card-cta {
    background-color: #224C4F;
    border: none;
    border-radius: 2px;
    color: white;
    text-align: center;
    width: -webkit-fill-available;

    &.discard {
        background-color: #CC3232;
    }

    &.activate {
        background-color: #8BC53F;

        &:hover {
            background-color: #688715;
        }
    }

    &:hover {
        background-color: #8BC53F;
    }

    &:disabled {
        background-color: #F8F8F8;
        color: #224C4F;
        cursor: not-allowed;
    }

    &::first-letter {
        text-transform: capitalize;
    }
}

.card-coming-soon {
    color: #224C4F;
    font-size: 12px;
}

.card-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100%;
}

.card-description {
    padding: 10px;
    text-align: justify;
}

.card-description p {
    margin: 0;
}

.card-emphasis {
    color: #333333;
    font-weight: bold;
    font-size: 1.5rem;
    padding: 10px;
}

.card-header {
    text-align: center;
}

.card-footer {
    min-height: 60px;

    div, button {
        font-size: 12px;
        font-weight: bold;
        margin: 10px;
        display: inline-block;
    }

    button {
        padding: 10px 20px;
    }

    div {
        padding: 10px 0px;
    }
}

.card-image img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
}

.card-links {
    display: flex;
    padding: 0px;
}

.card-list {
    padding: 10px;
    text-align: justify;
    height: 250px;
}

.card-title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
}

.card-title {
    height: 30px;
    font-size: 14px;
    margin: 0;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    width: 100%;
    padding-top: 5px;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 400;
    line-height: 1.5;
}

.card-website, .card-linkedin {
    font-size: medium;
    text-align: right;
    margin-right: 5px;
}

@media screen and (min-width: 600px) {
    .card-grid {
        grid-template-columns: repeat(auto-fit, minmax(0, 16%));
    }
}

.wmui-small-card-view {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    grid-gap: 10px;
    margin: 10px;
}

.small-card {
    background-color: #FFFFFF;
    border-radius: 4px;
    border: solid 1px #E0E0E0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 10px 20px;
}

.small-card.green {
    background: #8BC53F;
}

.small-card > .label {
    font-weight: bold;

    &::first-letter {
        text-transform: capitalize;
    }
}

.small-card > .label.green {
    color: #8BC53F;
}

.small-card > .sub-label {
    margin-bottom: 5px;
    min-height: 18px;

    &::first-letter {
        text-transform: capitalize;
    }
}

.small-card > .sub-label.green {
    color: #8BC53F;
}

.small-card > .value {
    font-weight: bold;
    font-size: 20px;

    &::first-letter {
        text-transform: capitalize;
    }
}

.small-card > .value.green {
    color: #8BC53F;
}

.small-card > .bottom-label {
    color: #999999;

    &::first-letter {
        text-transform: capitalize;
    }
}

.small-card > .bottom-label.green {
    color: #8BC53F;
}

/* Add these styles to ensure all cards have the same height */
.impact-analysis-box {
    height: 80px;
}

.impact-analysis-box .results {
    display: flex;
    justify-content: space-between;
}

.workflow {
    display: flex;
    justify-content: space-between;
    margin: 5px 0 15px 0 !important;
}

.workflow-caret {
    margin: 0 5px;
}

.workflow-buttons {
    background-color: #D3D3D3;
    border: 1px solid #C3C3C3;
    border-radius: 2px;
    color: #444444;
    cursor: pointer;
    display: inline-block;
    font-size: 12px;
    height: 25px;
    margin: 0;
    padding: 2px 6px 2px 6px !important;
    text-align: center;
    text-transform: capitalize;
    width: 75px;
}

.workflow-buttons:disabled {
    opacity: 0.7;
}

.workflow-buttons:enabled:hover {
    border-color: #8BC53F !important;
    background-color: #8BC53F !important;
    color: #224C4F !important;
}

.workflow-buttons:disabled:hover {
    cursor: not-allowed;
}

.workflow-buttons#pending {
    background-color: #6EB3E3;
    border: solid 1px #6EB3E3;
    color: white;
}

.workflow-buttons#ongoing {
    background-color: #DB7B2B;
    border: solid 1px #DB7B2B;
    color: white;
}

.workflow-buttons#active, .workflow-buttons#completed {
    background-color: #2DC937;
    border: solid 1px #2DC937;
    color: white;
}

.workflow-buttons#discarded {
    background-color: #CC3232;
    border: solid 1px #CC3232;
    color: white;
}

.indicator-container {
    padding: 5px 10px;
    border: 1px solid #BBBBBB;
    margin: 15px 0;
}

/* Side by side costs tables */

.tables-wrapper {
    display: flex;
    justify-content: space-between;
    margin-left: 10px;
}

.half-size-table {
    padding: 15px;
    flex: 1;
    margin: 10px 10px 10px 0;
    border-radius: 3px;
}

.half-size-table.cost {
    background-color: #E8EDED;
}

.half-size-table.simulate {
    background-color: #D2DBDB;
}

.half-size-table table {
    width: 100%;
    table-layout: fixed;
}

tr.half-totals {
    background-color: #8BC53F;
    color: white;
    font-weight: bold;
    font-size: 12px;
}

tr.half-variance {
    border-top: 5px solid #D2DBDB;
    background-color: #99C9EB;
    color: white;
    font-weight: bold;
    font-size: 12px;
}

.half-table-title {
    color: #224C4F;
    font-size: 18px;
}

.half-table-legend {
    font-size: 14px;
}

.half-table-title-wrapper {
    min-height: 40px;
}
/* reset.css */
html, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, code, del, dfn, em, img, q, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td {
    margin: 0;
    padding: 0;
    border: 0;
    font-weight: inherit;
    font-style: inherit;
    font-size: 100%;
    font-family: inherit;
    vertical-align: baseline;
}

body {
    line-height: 1.5;
}

table {
    border-collapse: separate;
    border-spacing: 0;
}

caption, th, td {
    text-align: left;
    font-weight: normal;
}

table, td, th {
    vertical-align: middle;
}

blockquote:before, blockquote:after, q:before, q:after {
    content: "";
}

blockquote, q {
    quotes: "" "";
}

a img {
    border: none;
}

/*some bpp defaults*/
body {
    cursor: default;
    font-size: 75%;
    color: #333333;
    font-family: "Lucida Grande", "Lucida Sans Unicode", Helvetica, Arial, Verdana, sans-serif;
    display: block;
}

h1, h2, h3, h4, h5, h6 {
    font-weight: normal;
    color: #000000;
}

ul, ol {
    margin: 0
}

ul {
    list-style-type: none;
}

.container {
}

.lft {
    float: left;
}

.rgt {
    float: right;
}

div.border {
    padding-right: 4px;
    margin-right: 5px;
    border-right: 1px solid #EEEEEE;
}

hr {
    background: #FFFFFF;
    color: #000000;
    clear: both;
    float: none;
    width: 100%;
    height: .1em;
    margin: 0 0 1.45em;
    border: none;
}

hr.space {
    background: #FFFFFF;
    color: #FFFFFF;
}

.clearfix:after, .container:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}

.clearfix, .container {
    display: block;
}

.clear {
    clear: both;
}

.state-label {
    color: white;
    padding: 5px;
    border-radius: 3px;
}
#wm-crud {
    border: solid 1px #CCCCCC;
    border-radius: 4px;
    margin: 10px;
    padding: 10px;
}

#wm-crud > #crud-header > #crud-title {
    color: #8BC53F;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
}

#wm-crud > #crud-container > #crud-body {
    max-height: none !important;
}

#wm-crud > #crud-container > #crud-body > .crud-info > form > dl > dd > .btn-group-organization {
    padding: 0;
}

#wm-crud > #crud-container > #crud-body > .crud-info > form > dl > dt {
    margin-top: 20px;
}

#wm-crud > #crud-container > #crud-body > .crud-info > form > dl > dt > label,
#wm-crud > #crud-container > #crud-body > .crud-info > form > dl > div > dt > label {
    font-size: 12px;
    color: #224C4F;

    .err-help {
        color: red
    }
}

#wm-crud > #crud-container > #crud-body > .crud-info > form > dl > dd > select {
    font-size: 12px;
    height: 28px;
    width: -webkit-fill-available;
    border-radius: 4px;
}

#wm-crud > #crud-container > #crud-body > .crud-info > form > dl > dd > input {
    border-width: 1px;
    font-size: 12px;
    height: 14px;
    width: -webkit-fill-available;
    border-radius: 4px;

    &.input-file {
        height: 19px;
    }

    &:focus {
        border-color: #8BC53F;
        padding: 5px;
    }
}

#wm-crud > #crud-container > #crud-footer {
    margin-top: 20px;
}

#wm-crud > #crud-container > #crud-footer > .crud-btns {
    display: flex;
    justify-content: space-between;
}

#wm-crud > #crud-container > #crud-footer > .crud-btns > div > input {
    background-color: #224C4F;
    border: none;
    border-radius: 4px;
    color: #FFFFFF;
    padding: 10px;
    min-width: 80px;
}
#lmit_mbx {
    border: 1px solid #AAAAAA;
    background: #FFFFFF;
    border-radius: 6px;
}

.mbx_mask {
    z-index: 5000;
    position: absolute;
    top: 0;
    left: 0;
    -moz-opacity: 0.5;
    opacity: .50;
    filter: alpha(opacity=50);
    background-color: black;
    width: 100%;
    height: 100%;
}

.mbx {
    padding: 0;
    text-align: left;
    font-size: 1em;
    -moz-border-radius: 0;
    box-shadow: rgba(0, 0, 0, 0.2) 0 5px 25px;
    -moz-box-shadow: rgba(0, 0, 0, 0.2) 0 5px 25px
}

.mbx .mbx_head {
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    padding: 10px;
    color: black !important;
    text-decoration: none;
    text-shadow: rgb(238, 238, 238) 1px 1px 0;
    cursor: move;
    background: -moz-linear-gradient(to bottom, #FCFCFC, #E9E9E9);
    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#FCFCFC), to(#E9E9E9));
    text-align: center;
    font-size: 12px;
    background-color: #BBBBBB;
    border-bottom: 1px solid #AAAAAA;
}

.mbx .mbx_body {
    background: white;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    margin: 0;
    padding: 0;
}

.mbx .mbx_cont {
    overflow: auto;
    padding: 5px;
}

.mbx .mbx_cont ul li {
    float: none;
}

.mbx .mbx_body .mbx_msg {
    font-size: 1.5em;
    line-height: 1.5em;
    text-align: center;
    margin: 1em;
}

.mbx .mbx_body .mbx_msg h4 {
    text-align: center;
}

.mbx_btns_pod {
    padding: 5px;
    margin: .8em;
}

.mbx .mbx_body .mbx_btns_pod {
    background: -moz-linear-gradient(to bottom, #FFFFFF, #E8E8E8);
    height: 24px;
}

.mbx .mbx_body .mbx_btns {
    overflow: hidden;
    background-color: #FAFAFA;
    border-top: 1px solid #C2C2C2;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
}

.mbx .mbx_body .mbx_btns_pod input {
    margin-top: 0;
    font-weight: bold !important;
}

.mbx .mbx_body .mbx_btns input {
    border: 1px solid #BBBBBB;
    border-radius: 4px;
    font-size: .9em;
    height: 24px;
    margin-right: 4px !important;
}

.mbx_btns {
    display: flex;
    justify-content: space-between;
    min-height: 36px;
}

a.mbx_btn_close {
    float: right;
    margin: 2px;
    background: url(/images/ui/spt.png) no-repeat;
    background-position: -1px -1px;
    width: 14px;
    height: 14px;
    display: block;
}

a.mbx_btn_close:hover {
    background-position: -18px -1px;
}

.mbx label {
    font-size: 10px;
    line-height: 14px;

    &::first-letter {
        text-transform: capitalize;
    }
}

.mbx input.title {
    font-size: 1.5em;
    width: 260px;
}

.mbx .mbx_body input:focus, .mbx input.title:focus, .mbx textarea:focus, .mbx select:focus {
    border: 2px solid #8BC53F;
    margin: 0;
}

.mbx textarea:focus {
    margin: 1px;
}

.mbx input.mbx_text, input.title {
    width: 280px;
    padding: 5px
}

.mbx select {
    padding: 2px;
}

.mbx textarea.mbx_text {
    width: 280px;
    height: 120px;
    padding: 5px;
}

.mbx legend {
    font-weight: normal;
    font-size: .9em;
    font-style: italic;
}

.mbx .mbx_wait {
    background: url(/images/ui/mbx/wait_icn.gif) no-repeat 0 0;
}

.mbx .btn:hover {
    text-shadow: gray 1px 1px 1px
}

.mbx-info, .mbx_calendar {
    padding: 10px;
    text-align: center;
}

.mbx-info.green {
    background-color: #8BC53F;
    color: white;
    padding: 15px;
}

.text-left {
    text-align: left;
}

.mbx_calendar {
    text-align: justify;
}

.mbx input.text, .mbx textarea.text, .mbx select.text, .mbx div.text {
    font-size: 12px;
    padding: 5px;
    margin: 0;
    border: 1px solid #BBBBBB;
    box-sizing: border-box;
    width: 100% !important;
    border-radius: 4px;
}

.mbx select.text {
    text-transform: capitalize;
}

.mbx textarea.text, .mbx div.text {
    height: 50px;
}

.mbx div.text {
    overflow: auto;
}

.mbx textarea.text.big, .mbx div.text.big {
    height: 100px;
}

.mbx select.text {
    width: 414px;
    padding: 5px;
    height: 27px;

    &::first-letter {
        text-transform: capitalize;
    }
}

.mbx select.text[multiple] {
    height: auto;
}

.mbx input.text:focus, .mbx textarea.text:focus, .mbx select.text:focus, .mbx div.text:focus {
    border: 1px solid #372086;
    margin: 0;
    padding: 5px;
}

.mbx select.text:focus {
    padding: 5px;
}

.stepped.zero {
    margin: 0 !important;
}

input.vertical-middle {
    position: relative;
    top: -1px;
}

.mbx dd.last {
    margin-bottom: 0;
}

.mbx-input-group {
    display: flex;
    align-items: center;
    width: 100%;
}

.mbx-input-group-text {
    flex: 1;
}

.mbx-input-group-button {
    background-color: transparent;
    border: 1px solid #BBBBBB;
    border-radius: 4px;
    cursor: pointer;
    flex: 0 0 100px;
    font-size: 1em;
    font-weight: bold !important;
    height: 26px;
    margin: 0px 0px 5px 5px;
    max-width: 30%;
    padding: 0 10px;
}

.mbx .mbx_body .mbx-input-group-button:focus {
    margin: 0px 0px 5px 5px;
}
.no-access {
    margin: 20px 10px;
    padding: 10px;
    background-color: #F8F8F8;
    border-left: solid 4px #F5D124;
}
.spt, .icon {
    /* background: url(/images/ui/spt.png) no-repeat; */
}

.underline {
    background: url(/images/ui/tbl_bck.png);
}

.underline30 {
    background: url(/images/ui/lst_bck_src.png);
}


#search .close {
    background-position: -102px -1px
}

#search .close:hover {
    background-position: -120px -1px
}

.arrow {
    background-position: -86px -51px
}

li:hover .arrow {
    background-position: -102px -51px
}


#search .display {
    background-position: -102px -17px
}

#search .display:hover {
    background-position: -120px -17px
}

/*system icons*/
.close {
    background-position: -34px -1px
}

li.active > .close {
    background-position: -1px -1px
}

.close:hover {
    background-position: -17px -1px
}

li.active > .close:hover {
    background-position: -17px -1px
}

._dash_handler_, .handler {
    background-position: -51px -1px;
}

.expanded .handler {
    background-position: -68px -1px
}

.settings {
    background-position: 0 -52px;
}

.on_settings {
    background-position: 0 -52px;
}

li .tree_handler {
    background-position: -35px -53px;
    padding-right: 5px;
    color: grey;
    width: auto;
}

li.expanded .tree_handler {
    background-position: -18px -53px;
}

li.current .tree_handler {
    background-position: -18px -53px;
    color: white !important;
}

/*extended icons*/
.explorer {
    background-position: -18px -18px
}

li.current > .explorer {
    background-position: -1px -18px
}

.management {
    background-position: -52px -18px
}

li.current > .management {
    background-position: -35px -18px
}

/* .wise_logo {background-position: -86px -18px} */
.dashboard {
    background-position: -86px -18px
}

.dashboard:hover {
    background-position: -69px -18px
}

.current.dashboard {
    background-position: -69px -18px
}

.mark {
    background-position: 0 -315px;
    width: 107px !important;
    height: 28px !important;
    margin-top: 3px;
    margin-left: 4px;
}

/*theme*/
.notification {
    background-position: -1px -35px
}

.exit {
    background-position: -18px -35px
}

.help {
    background-position: -35px -35px
}

.exclamation {
    background-position: -51px -35px
}

.success {
    background-position: -69px -35px
}

/*section icons*/
.site {
    background-position: -1px -86px
}

.zone {
    background-position: -136px -1px
}

.circuit {
    background-position: -34px -121px
}

.equipment {
    background-position: -19px -121px
}

.folder {
    background-position: -35px -87px
}

.plot {
    background-position: -69px -120px
}

.device {
    background-position: -18px -120px
}

.indicator, .raw {
    background-position: -69px -120px
}

.complex {
    background-position: -52px -120px
}

.cost {
    background-position: -68px -103px
}

.reading {
    background-position: -86px -103px
}

.time_1 {
    background-position: -19px -102px
}

.current .time_1 {
    background-position: -19px -102px
}

/*defaults*/
.default_16 {
    background-position: -103px -86px
}

.tools {
    background-position: -103px -103px
}

.profile {
    background-position: -137px -103px
}

.operations {
    background-position: -137px -70px
}

.tariffs {
    background-position: -137px -41px
}

.tags {
    background-position: -137px -15px
}

.member {
    background-position: -103px -135px
}

.groups {
    background-position: -137px -162px
}

.gears {
    background-position: -103px -162px
}

.params {
    background-position: -72px -160px
}

/*toolbar*/
.inline_icon, .toolbar_icon {
    background: url(/images/ui/tbr2.png) no-repeat;
    width: 24px;
}


.curve {
    background-position: -1px -1px
}

.chart {
    background-position: -1px -252px
}

.implode {
    background-position: -1px -200px
}

.table {
    background-position: -1px -276px
}

.print {
    background-position: -1px -175px
}

.share {
    background-position: -1px -1px
}

.edit {
    background-position: -1px -25px
}

.plus {
    background-position: -1px -51px
}

.minus {
    background-position: -1px -76px
}

.remove {
    background-position: -1px -351px
}

.pw {
    background-position: -1px -377px
}

.new_zone, .new_folder, .new_pod {
    background-position: -1px -403px
}

.xls {
    background-position: -1px -477px
}

.pdf {
    background-position: -1px -427px
}

.csv {
    background-position: -1px -452px
}

.join {
    background-position: -1px -503px
}

.new_filtered_chart {
    background-position: -1px -528px
}

.sum {
    background-position: -1px -553px
}

.event {
    background-position: -1px -577px
}

.trigger {
    background-position: -1px -603px
}

.explode {
    background-position: -1px -628px
}

.select_all {
    background-position: -52px -69px
}

.select_none {
    background-position: -35px -69px
}

.more {
    background-position: -52px -51px
}

.less {
    background-position: -68px -51px
}

a.sel_all span {
    background-position: -52px -69px;
}

a.ctl {
    display: inline-block;
}

a.icn, a.ctl span {
    display: block;
    width: 16px;
    height: 16px;
    float: left;
    margin-right: 3px;
}

a.icn {
    margin-right: .5em;
}

a.icn.off {
    opacity: .2;
}

a.unsel_all span {
    background-position: -35px -69px;
}

a.exp_all span {
    background-position: -86px -69px;
}

a.clp_all span {
    background-position: -103px -69px;
}

a.watch {
    background-position: -69px -68px;
}

a.overlay {
    background-position: -120px -68px;
}

a.spacer {
    background-position: -152px -134px;
}


/*inspector*/
.info {
    background-position: -47px -137px
}

li.current > .info {
    background-position: -47px -137px
}

.list {
    background-position: -1px -136px
}

li.list > .list {
    background-position: -1px -136px
}

.preview-logo {
    border: none;
}

.preview-image {
    max-height: 200px;
}
/*typo*/
body {
    font-size: 75%;
    color: #333333;
    font-family: "Lucida Grande", "Lucida Sans Unicode", Helvetica, Arial, Verdana, sans-serif
}

h1, h2, h3, h4, h5, h6 {
    font-weight: normal;
    color: #111111;
}

h1 {
    font-size: 3em;
    line-height: 1;
    margin-bottom: 0.5em;
}

h2 {
    font-size: 2em;
    margin-bottom: 0.75em;
}

h3 {
    font-size: 1.5em;
    line-height: 1;
    margin-bottom: 1em;
}

h4 {
    font-size: 1.2em;
    line-height: 1.25;
    margin-bottom: 1.25em;
}

h5 {
    font-size: 1em;
    font-weight: bold;
    margin-bottom: 1.5em;
}

h6 {
    font-size: .8em;
    font-weight: normal;
    line-height: 2em;
}

p {
    margin: 0 0 1.5em;
}

img {
    border-width: 0 !important;
}

.bottom {
    margin-bottom: 0 !important;
}

p img.left {
    float: left;
    margin: 1.5em 1.5em 1.5em 0;
    padding: 0;
}

p img.right {
    float: right;
    margin: 1.5em 0 1.5em 1.5em;
}

strong {
    font-weight: bold;
}

.strong {
    font-weight: bold;
}

em, dfn {
    font-style: italic;
}

dfn {
    font-weight: bold;
}

sup, sub {
    line-height: 0;
}

.small {
    font-size: .8em;
}

abbr, acronym {
    border-bottom: 1px dotted #666666;
}

address {
    margin: 0 0 1.5em;
    font-style: italic;
}

del {
    color: #666666;
}

pre {
    margin: 1.5em 0;
    white-space: pre;
    text-align: left;
}

pre, code, tt {
    font: 1em 'andale mono', 'lucida console', monospace;
    line-height: 1.5;
}

hr {
    background: #DDDDDD;
    color: #DDDDDD;
    clear: both;
    float: none;
    width: 100%;
    height: .1em;
    margin: 0 0 1.45em;
    border: none;
}

hr.space {
    background: #FFFFFF;
    color: #FFFFFF;
}

.clearfix, .container {
    display: block;
}

.clear {
    clear: both;
}

.right {
    float: right;
}

.left {
    float: left;
}

/* forms.css */
label {
    font-size: .8em;
    line-height: 1.2em;
}

fieldset {
    padding: 1.4em;
    margin: 0 0 1.5em 0;
    border: 1px solid #CCCCCC;
}

legend {
    font-weight: bold;
    font-size: 1.2em;
}

input.text, input.title, textarea, select {
    border: 1px solid #BBBBBB;
    margin: 1px;
}

input[type=file] {
    border: 2px solid #BBBBBB;
}

input.text:focus, input.title:focus, textarea:focus {
    border: 2px solid #68B0EE;
    padding: 4px;
}

input.text, input.title {
    padding: 5px;
}

input.title {
    font-size: 1.3em;
}

.crn_all {
    border-radius: 3px;
}

textarea {
    font-family: "Lucida Grande";
    height: 60px;
    padding: 5px;
}

/*colors*/
.white {
    color: white;
}

.green {
    color: green;
}

.underlined-text {
    text-decoration: underline;
}
#widgets {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
}

#widgets.list {
    flex-flow: column wrap !important;
    align-items: center;
}

#widgets.below-table {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
}

.widget {
    flex: 1;
    padding: 0 5px;
    margin: 5px 0;
    min-width: 50%;
    max-width: 100%;
    width: 100%;
    border: 0;
    background: none;
    height: 310px;
    font-size: 10px;
    line-height: 18px;
    vertical-align: middle;
}

.widget.tall {
    height: 425px;
}

.widget.full {
    min-width: 100%;
}

.widget .title {
    width: 100%;
    position: relative;
    float: left;
    height: 30px;
    margin: 0;
    padding-top: 5px;
    font-size: 12px;
    border-radius: 3px 3px 0 0;
    background: #224C4F;
    text-align: center;
    color: white;
    font-weight: bold;
}

.widget .content {
    position: relative;
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 280px;
    min-height: 280px;
    max-height: 280px;
    background-color: #E8E8E8;
    float: left;
    border-radius: 0 0 3px 3px;
}

.widget.tall .content {
    height: 400px;
    min-height: 400px;
    max-height: 400px;
}

.widget .chart {
    position: relative;
    height: 280px;
    width: 0;
    flex: 1;
    display: inline-block;
}

.widget.tall .chart {
    height: 380px;
}

.widget .legend {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex: 0;
    position: relative;
    text-align: center;
    width: 100px;
    padding: 0 5px;
}

.widget .middle {
    top: 80px;
}

.widget .legend .title {
    position: relative;
    float: left;
    background: none;
    width: 90px;
    height: 20px;
    min-height: 20px;
    max-height: 20px;
    line-height: 20px;
    color: white;
    font-weight: bold;
    text-overflow: ellipsis;
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
}

.widget .legend .tall {
    height: 32px;
    min-height: 32px;
    max-height: 32px;
    line-height: 16px;
}

.widget .legend .value {
    position: relative;
    float: left;
    width: 90px;
    height: 20px;
    min-height: 20px;
    max-height: 20px;
    background-color: white;
    /* border-radius: 0 0 5px 5px; */
    margin-bottom: 10px;
    font-weight: bold;
}

.widget .legend .last {
    margin-bottom: 0;
}

.widget .legend .comparison {
    /* border-radius: 0; */
    margin-bottom: 0;
}

.widget .legend .positive {
    color: white;
    background-color: green;
    margin-bottom: 0;
}

.widget .legend .negative {
    color: white;
    background-color: #E94547;
    margin-bottom: 0;
}

.widget .loader {
    line-height: 280px;
    text-align: center;
    color: #CCCCCC;
    font-weight: bold;
    font-size: 24px;
}

.widget .highcharts-data-labels.highcharts-pie-series {
    z-index: -1;
}

.widget .highcharts-legend-item span {
    z-index: -1;
    height: 240px;
}

.widget .value-displayer {
    flex-direction: column;
    justify-content: center;
}

.widget .value-displayer .value svg {
    color: #224C4F;
    transform: rotate(-45deg);
    font-size: 0.8em;
}

.widget .value-displayer .value {
    font-size: 40px;
    font-weight: bold;
    height: 60px;
    color: #8BC53F;
}

.widget .value-displayer .name {
    font-size: 15px;
    color: #224C4F;
}

.nav.widget-options select {
    display: inline-block;
    padding: 4px 6px;
    margin-top: 4px;
    margin-left: -5px;
    font-size: 14px;
    color: #555555;
    vertical-align: middle;
    /* -webkit-border-radius: 4px; */
    /* -moz-border-radius: 4px; */
    /* border-radius: 4px; */
    height: 30px;
    line-height: 30px;
    background-color: #FFFFFF;
    border: 1px solid #CCCCCC;
}

.sortable {
    height: calc(39 * 34px);
}

.sortable .member {
    background: #EEEEEE;
    border: 1px solid #CCCCCC;
    cursor: move;
    margin: 4px;
    padding: 5px 10px;
    width: calc(100% - 30px);
}

.sortable .member input[type=checkbox] {
    float: right;
    height: 18px;
    vertical-align: middle;
}

.legend {
    position: relative;
    font-size: 10px;
    text-align: center;
    height: 100%;
}

.legend .title {
    padding-top: 0;
    font-size: 10px;
    color: white;
    border-radius: 3px 3px 0 0;
    line-height: 21px;
    height: 20px;
    min-height: 20px;
    max-height: 20px;
}

.legend .value {
    line-height: 21px;
}

.legend .past-value.value,
.legend .currentGoal.value,
.legend .no-comparison.value {
    margin-bottom: 10px;
    border-radius: 0 0 3px 3px;
}

.legend .percentage.value {
    color: white;
    margin-bottom: 10px;
    border-radius: 0 0 3px 3px;
}

/* New dashboard Widgets */

.basic-widget {
    background-color: #FFFFFF;
    overflow: hidden;
    min-height: 382px;
    position: relative;
    font-size: 10px;
    line-height: 18px;
    vertical-align: middle;
    border: 1px solid #DDDDDD;
    border-radius: 4px;
    margin-right: 1%;
    margin-bottom: 1%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
}

.basic-widget.hidden-true {
    display: none;
}

.dashboard.edit-mode .basic-widget.hidden-true {
    display: block;
}

.dashboard.edit-mode .basic-widget {
    border: dashed 1px #8A8A8A;
    box-shadow: none;
    border-radius: 0px;
    cursor: grab;
}

.basic-widget .chart {
    width: 100%;
}

.basic-widget .content-map {
    display: flex;
    flex-direction: row;
    width: 100%;
    float: left;
    max-height: inherit;
    height: 100%;
}

.basic-widget .empty-content {
    padding: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 279px;
    float: left;
    font-size: 15px;
    font-weight: 300;
    line-height: 20px;
    text-shadow: 0 1px 0 #FFFFFF;
    color: #CC3232;
}

.basic-widget .highcharts-data-labels.highcharts-pie-series {
    z-index: -1;
}

.basic-widget .highcharts-legend-item span {
    z-index: -1;
    height: 240px;
}

.basic-widget .loader {
    line-height: 280px;
    text-align: center;
    color: #CCCCCC;
    font-weight: bold;
    font-size: 24px;
}

.basic-widget .title {
    width: 98%;
    position: relative;
    float: left;
    height: 50px;
    font-size: 1.5em;
    text-align: left;
    padding: 0 2% 0 2%;
    align-items: center;
    display: flex;
}

.basic-widget .widget-content {
    position: relative;
    padding: 15px;
    display: flex;
    flex-direction: row;
    width: 100%;
    float: left;
}

.basic-widget .widget-content .highlight-value {
    opacity: 0.9;
    height: 60px;
    width: 100px;
    font-size: 1.5em;
    align-content: center;
    position: absolute;
    top: 0px;
    right: 15px;
    border-radius: 4px;
    z-index: 1;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .3);
}

.basic-widget-normalization {
    position: absolute;
    right: 0;
    z-index: 100;
    font-size: 10px;
    font-weight: thin;
    align-items: center;
}

.basic-widget-normalization span {
    cursor: pointer;
    border-radius: 3px;
    border: 1px solid transparent;
    padding: 3px 5px;
    margin: 0 2px 0 0;
    text-align: center;
}

.basic-widget-normalization span:hover {
    cursor: pointer;
    color: white;
    background-color: #224C4F;
}

.dashboard.edit-mode .basic-widget .basic-widget-normalization {
    display: none;
}

.basic-widget-underline {
    color: #333333;
    text-decoration: underline;
}

.basic-widget-options {
    display: none;
}

.edit-mode .basic-widget-options {
    display: block;
    position: absolute;
    right: 0;
    z-index: 100;
    color: #333333;
    font-size: 15px;
    font-weight: bold;
    cursor: pointer;
    align-items: center;
}

.empty-notification {
    color: #777777;
    font-weight: 300;
}

.empty-symbol {
    flex: 0 0 25%;
    display: flex;
    height: 50%;
}

.empty-symbol svg {
    opacity: 0.8;
    width: 100%;
    height: auto;
    max-width: 100%;
    padding-bottom: 20px;
    color: #777777;
}

.grid-half {
    min-width: 49%;
    max-width: 49%;
    width: 49%;
}

#widgets-wrapper {
    padding: 1% 0 0 1%;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
}

#widgets-wrapper.below-table {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
}

#widgets-wrapper.list {
    flex-flow: column wrap !important;
    align-items: center;
}

.widget-options-wrapper {
    padding: 5px;
    position: absolute;
    z-index: 999;
    top: 0;
    right: -50%;
    transition: 1s;
    background-color: white;
    box-shadow: 0 0 3px rgba(0, 0, 0, .5);
    opacity: 0;
    width: 50%;
    height: 100%;
}

.widget-options-wrapper.active {
    right: 0;
    opacity: 0.96;
    transition: 1s;
}

.widget-options-buttons {
    padding: 3px;
    text-align: left;
    width: 100%;
    border-top: 1px solid #D4D4D4;
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #FAFAFA;
    background-image: linear-gradient(to bottom, #FFFFFF, #F2F2F2);
}

.widget-options-button {
    border-radius: 3px !important;
    -moz-border-radius: 3px !important;
    background: none;
    border: 1px solid transparent !important;
    padding: 1px 3px !important;
    font-size: 10px;
    font-weight: bold;
    cursor: pointer;
    margin: 0 2px 0 0 !important;
    text-align: center;
    line-height: 25px;
    color: #224C4F;
}

.widget-options-button:hover {
    background-color: #224C4F;
    color: white;
}

.widget-hidden {
    position: absolute;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    opacity: 0.8;
}

.widget-hidden-icon {
    font-size: 5em;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

/* Carousel Widget */

.basic-widget .grid-carousel .title .title-text {
    margin: auto;
}

.basic-widget .grid-carousel .widget-content {
    max-height: calc(100% - 100px);
}

.basic-widget .grid-carousel .title {
    width: 98%;
    height: 25px;
    font-size: 1.25em;
    text-align: center;
    padding: 0 2% 0 2%;
    align-items: center;
    display: flex;
}

.carousel-button {
    position: absolute;
    top: 0;
    font-size: 30px;
    cursor: pointer;
    color: #E8E8E8;
    width: 40px;
    height: 100%;
    border: none;
    background: none;
    z-index: 10000;
}

.carousel-container {
    width: 100%;
    height: 100%;
    margin: auto;
    overflow: hidden;
    position: relative;
}

.carousel-item {
    width: 100%;
    min-width: 100%;
    height: calc(100% - 50px);
    box-sizing: border-box;
}

.carousel-item .content div {
    min-width: 50%;
    box-sizing: border-box;
}

.carousel-item .sub-title {
    font-size: 1.25em;
    margin: 10px;
}

.carousel-item .widget-content .chart {
    width: 100%;
}


.carousel-wrapper {
    display: flex;
    transition: transform 0.5s ease-in-out;
    height: 100%;
}

.carousel-wrapper.basic-widget {
    display: flex;
    transition: transform 0.5s ease-in-out;
    height: 100%;
    font-size: 10px;
    line-height: 14px;
    vertical-align: left;
    border: none;
    margin: 0;
    box-shadow: none;
}

.grid-carousel {
    min-width: 100%;
    max-width: 100%;
    width: 100%;
    font-size: 10px;
    line-height: 14px;
    vertical-align: middle;
    border: none;
    margin: 0;
    box-shadow: none;
}

.next {
    right: 0px;
    transition: border-left 1s, color 1s, background-color 0.5s;
}

.next:hover {
    border-left: 1px solid #DDDDDD;
    color: #333333;
    background-color: white;
}

.prev {
    left: 0px;
    transition: border-right 1s, color 1s, background-color 0.5s;
}

.prev:hover {
    border-right: 1px solid #DDDDDD;
    color: #333333;
    background-color: white;
}

/* Totalizers */

.percentage-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
}

.totalizer-progress-bar {
    flex: 1;
    height: 10px;
    background-color: #D7DEDF;
    border-radius: 5px;
    overflow: hidden;
}

.totalizer-progress-fill {
    height: 100%;
    border-radius: 5px;
    background-color: #224C4F;
}

.progress-info {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
}

.text-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

#total-displayers {
    display: flex;
    flex-flow: row wrap;
    margin: 1% 0 -1% 1%;
}

.total-displayer {
    border-radius: 3px;
    padding: 1vw 1vw;
    width: 15.66%;
    margin-bottom: 1%;
    margin-right: 1%;
}

.total-displayer-header {
    display: flex;
    text-align: left;
    justify-content: space-between;
    height: 50px;
    margin-bottom: -15px;
}

.total-displayer-icon {
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    height: 3vw;
    width: 3vw;
    min-width: 50px;
    min-height: 50px;
    border-radius: 50%;
    margin-right: 10px;
}

.total-displayer-icon svg {
    width: 50%;
    height: auto;
}

.total-displayer-main-wrapper {
    margin-top: 15px;
    text-align: right;
}

.total-displayer-small-icon svg {
    height: 1.25em;
    padding-top: 5px;
}

.total-displayer-title {
    max-width: 95%;
}

.total-displayer-title p {
    font-size: 0.7vw;
    margin-bottom: 0px;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
}

.total-displayer-title .title-text {
    font-size: 1.25em;
}

.total-value {
    font-size: 1.3vw;
    font-weight: 500;
}

.total-subtitle {
    font-size: 0.65vw;
    margin-top: -5px;
}

/* Widget Table */

.basic-widget.table-widget .widget-table-displayer {
    position: relative;
    padding: 15px;
    border-radius: 4px;
    height: 100%;
}

.no-data {
    text-align: center;
    color: #777777;
}

.table-main {
    font-size: 1.25em;
    margin: 0;
    font-weight: 500;
    margin-bottom: 5px;
    color: #224C4F;
    overflow: hidden;
    text-overflow: ellipsis;
}

.table-sub {
    font-size: 1em;
    margin: 0;
    color: #8BC53F;
    overflow: hidden;
    text-overflow: ellipsis;
}

.widget-table {
    max-height: 332px;
    display: flex;
    flex-direction: column;
    min-width: 100%;
    max-width: 100%;
    justify-content: space-between;
    overflow-x: hidden;
}

.widget-table-cell {
    white-space: nowrap;
    padding: 8px;
    margin: auto;
    margin-right: 5px;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
}

.widget-table-icon {
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    align-items: center;
    min-width: 36px;
    min-height: 36px;
    max-width: 55px;
    max-height: 55px;
    height: 2.5vw;
    width: 2.5vw;
    border-radius: 50%;
    margin-right: 0px;
}

.widget-table-icon svg {
    width: 45%;
    height: auto;
}

.widget-table-row {
    min-height: 60px;
    display: flex;
    flex-direction: row;
}

@media (max-width: 600px) {
    .total-displayer-icon {
        min-width: 150px;
        min-height: 150px;
    }
}

@media (max-width: 900px) {
    .grid-half {
        min-width: 99%;
        max-width: 99%;
        width: 99%;
    }

    .total-displayer {
        min-width: 32.33%;
        max-width: 32.33%;
        width: 32.33%;
    }

    .total-displayer-icon {
        min-width: 75px;
        min-height: 75px;
    }
}
table.dataTable td.col50, table.dataTable th.col50 {
    width: 50%;
}

table.dataTable td.col25, table.dataTable th.col25 {
    width: 25%;
}

.dataTables_toolbar {
    cursor: default;
    line-height: 16px;
    margin-bottom: 10px;
    height: 32px;
}

.dataTables_toolbar * {
    box-sizing: border-box;
}

.dataTables_toolbar .svg_icon {
    cursor: pointer;
    padding: 8px;
    background-color: #8BC53F;
    border-radius: 4px;
    width: 32px;
    height: 32px;
}

.dataTables_toolbar .svg_icon svg {
    width: 16px;
    height: 16px;
}

.dataTables_toolbar .svg_icon svg path {
    fill: white;
}

ul.highcharts-menu li.highcharts-menu-item {
    float: none;
}

ul.highcharts-menu hr {
    margin: 2px 0;
}

input#select_all_checkbox {
    margin-bottom: 2px;
}

div.accordion-body-fix {
    background: white;
    padding-bottom: 25px;
}
#sites-map {
    height: 100%;
    position: absolute;
    overflow: hidden;
    width: 100%;
}

#sites-map #map-placeholder {
    height: 100%;
}

#sites-map #map-search {
    left: 10px;
    position: absolute;
    right: 10px;
    top: 10px;
}

#sites-map #map-search input[type=search] {
    border: none;
    border-bottom: 1px solid #EEEEEE;
    box-sizing: border-box;
    height: 40px;
    padding: 5px 15px;
    width: 100%;
}

#sites-map #map-search .sites-table {
    margin-right: 0;
    padding-top: 5px;
    position: absolute;
    right: 0;
    top: 0;
}

#sites-map #map-search input[type=search]:focus {
    outline: 0;
}

#sites-map .search-box {
    box-shadow: 0 2px 6px rgba(0, 0, 0, .3);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}

.search-box .icon-searching {
    color: #888888;
    display: none;
    font-size: 20px;
    line-height: 40px;
    position: absolute;
    right: 10px;
    top: 0;
}

.search-box .search-summary {
    color: #888888;
    font-size: 11px;
    line-height: 40px;
    position: absolute;
    right: 10px;
    top: 0;
}

#sites-map #map-search input[type=search]:focus + .results {
    display: block;
}

#sites-map .search-box:hover .results {
    display: block;
}

#sites-map .result {
    background: white;
    border: none;
    border-bottom: 1px solid #EEEEEE;
    box-sizing: border-box;
    cursor: pointer;
    padding: 7px 15px;
}

#sites-map .results {
    display: none;
    max-height: 170px;
    overflow: scroll;
    width: 100%;
}

#sites-map .result:hover {
    background-color: #EEEEEE;
}

#sites-map .result .site-name {
    font-weight: bold;
}

#sites-map .result .site-address {
    color: #888888;
    font-size: 11px;
}

#sites-map .result .site-tags {
    color: #666666;
    font-size: 11px;
}

.site-info-window {
    cursor: pointer;
    max-width: 100%;
    width: 480px;
}

.site-info-window .image {
    max-width: 40%;
    padding-right: 10px;
}

.site-info-window .image img {
    max-width: 100%;
}

.site-info-window .content-container {
    display: flex;
    width: 100%;
}

.site-info-window .popup-content {
    flex: 1;
    max-width: 100%;
    min-height: auto;
    overflow-y: scroll;
    padding-right: 10px;
    position: relative;
}

.site-info-window .popup-content::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
}

.site-info-window .popup-content::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #8BC53F;
    box-shadow: 0 0 1px rgba(255, 255, 255, .5);
}

.site-info-window .popup-title {
    font-weight: bold;
    margin-bottom: 10px;
    text-align: left;
    width: 100%;
}

.site-info-window .popup-title .street {
    color: gray;
    font-size: 9px;
    max-height: 12px;
    font-weight: normal;
}

.site-info-window .popup-content .summary {
    font-size: 11px;
}

.site-info-window .popup-content .summary .line {
    border-bottom: 2px solid #EEEEEE;
    display: flex;
    justify-content: space-between;
    margin-bottom: 4px;
    padding-bottom: 4px;
    width: auto;
}

.site-info-window .popup-content .summary .last-year {
    margin-bottom: 15px;
}

.site-info-window .no-content {
    color: #CCCCCC;
    font-size: 18px;
    margin: 50px 0;
    text-align: center;
}

div.map-control-button {
    background-color: white;
    border-radius: 2px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, .3);
    cursor: pointer;
    margin-right: 10px;
    font-size: 20px;
    height: 40px;
    padding: 8px;
    width: 40px;
    box-sizing: border-box;
    text-align: -webkit-center;
    vertical-align: middle;
    color: #666666;
    margin-top: 10px;
}

div.map-control-button:hover {
    color: black;
}

img.edit-panorama:hover {
    cursor: pointer;
    opacity: 0.75;
}

/* dashboard map */

#dashboard-placeholder {
    background-color: #EEEEEE;
    border-radius: 2px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, .3);
    height: inherit;
    width: 100%;
}
#notifications-container *, *:before, *:after {
    box-sizing: border-box;
}

#notifications-container {
    background: #EEEEEE;
    bottom: 0;
    font-size: 12px;
    left: 0;
    line-height: 150%;
    position: absolute;
    right: 0;
    top: 0;
}

#notifications-container .truncate {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
}

#notifications-container .disclaimer {
    margin: 0 auto 50px;
    text-align: center;
    width: 400px;
}

#notifications-container .btn {
    border: none;
    cursor: pointer;
    display: block;
    font-size: 16px;
    outline: none;
    padding: 15px;
    transition: all .1s linear;
}

#notifications-container #sidebar {
    background: #34393D;
    bottom: 0;
    left: 0;
    position: absolute;
    top: 0;
    width: 250px;
}

#notifications-container #sidebar .sidebar-inboxes li {
    margin-right: 0;
    width: 100%;
}

#notifications-container #sidebar .sidebar-inboxes .item-count {
    background: #34393D;
    border-radius: 5px;
    float: right;
    padding: 2px 8px;
    margin: -2px -8px;
}

#notifications-container #sidebar .sidebar-inboxes li a {
    color: #FFFFFF;
    cursor: pointer;
    display: block;
    padding: 15px 15px 15px 0;
    text-decoration: none;
    transition: background .1s linear;
    width: 100%;
}

#notifications-container #sidebar .item-icon {
    width: 40px;
}

#notifications-container #sidebar .sidebar-inboxes li a.active {
    background: #404549;
}

#notifications-container #sidebar .sidebar-inboxes li a:hover {
    background: #54595D;
}

#notifications-container #sidebar .sidebar-inboxes .fa {
    margin-right: 10px;
}

#notifications-container #sidebar .btn.compose {
    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4gPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJncmFkIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgeDE9IjEuMCIgeTE9IjEuMCIgeDI9IjAuMCIgeTI9IjAuMCI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzAwOWZjNCIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzBjN2VhZCIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JhZCkiIC8+PC9zdmc+IA==');
    background-image: linear-gradient(to top left, #009FC4, #0C7EAD);
    background-size: 100%;
    color: #FFFFFF;
    padding: 30px 15px;
    text-align: center;
    text-decoration: none;
    transition: all .1s linear;
    width: 100%;
}

#notifications-container #sidebar .btn.compose:hover {
    background-size: 150%;
}

#notifications-container #sidebar .btn.compose:hover .fa {
    transform: rotate(90deg);
}

#notifications-container #sidebar .btn.compose .fa {
    margin-left: 10px;
    transition: all .1s linear;
}

#notifications-container .notification-list {
    background: #F5F5F5;
    bottom: 0;
    left: 0;
    overflow-y: auto;
    position: absolute;
    top: 0;
    width: 350px;
}

#notifications-container .notification-list.empty {
    color: #AAAAAA;
    padding-top: calc(50vh - 50px);
    text-align: center;
}

#notifications-container .notification-list .notification-item {
    background: #FFFFFF;
    border-bottom: 1px solid #EEEEEE;
    cursor: pointer;
    padding: 10px 15px;
    position: relative;
}

#notifications-container .notification-list .notification-item.selected {
    color: #009FC4;
}

#notifications-container .notification-list .notification-item.deleted.selected {
    color: #B94A48;
}

#notifications-container .notification-list .notification-item__subject {
    margin-bottom: 8px;
}

#notifications-container .notification-list .notification-item__details {
    font-size: 10px;
    opacity: 0.9;
}

#notifications-container .notification-list .notification-item-dot {
    height: 100%;
    position: absolute;
    right: 10px;
    top: 10px;
}

#notifications-container .notification-list .notification-item-dot[data-status="unread"]:before, .notification-item-dot[data-status="deleted"]:before {
    background: #009FC4;
    border-radius: 50%;
    content: '';
    display: block;
    height: 6px;
    width: 6px;
}

#notifications-container .notification-list .notification-item-dot[data-status="deleted"]:before {
    background: #B94A48;
}

#notifications-container .notification-list .notification-item__time {
    text-align: right;
}

#notifications-container .notification-list .notification-item:hover:not(.selected) {
    background: #FAFAFA;
}

#notifications-container .notification-wrapper {
    background: #F5F5F5;
    border-left: 1px solid #DDDDDD;
    bottom: 0;
    left: 350px;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;
}

#notifications-container .notification-content {
    max-width: 1024px;
    width: 80%;
    margin: 5% auto 0 auto;
    background-color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    position: relative;
}

#notifications-container .notification-content.empty {
    color: #AAAAAA;
    padding-top: calc(50vh - 50px);
    text-align: center;
    box-shadow: none;
}

#notifications-container .notification-banner {
    background-color: #8BC53F;
    text-align: center;
}

#notifications-container .notification-banner img {
    width: 50%;
    padding: 5% 10%;
    height: auto;
}

#notifications-container .notification-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2% 2% 0px 2%;
}

#notifications-container .notification-title {
    font-size: 18px;
    color: #224C4F;
    margin: 10px 0;
}

#notifications-container .notification-header .notification-delete-btn {
    cursor: pointer;
    color: #797979;
    transition: color .1s linear;
}

#notifications-container .notification-header .notification-delete-btn:hover {
    color: #CC3232;
}

#notifications-container .notification-area {
    padding: 2%;
    margin: 10px 0px 10px 0px;
    font-size: 14px;
    min-height: 200px;
}

#notifications-container .notification-date {
    width: 96%;
    margin: 0px 2%;
    text-align: right;
    color: #797979;
    font-style: italic;
    font-size: 10px;
    border-bottom: 1px solid #EEEEEE;
}

#notifications-container .notification-footer {
    border-top: 1px solid #EEEEEE;
    width: 96%;
    margin: 0px 2%;
    text-align: center;
    padding: 10px 0;
}

#notifications-container .notification-footer p {
    margin: 0px;
}
/* The switch - the box around the slider */
.switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #CCCCCC;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: .4s;
}

input:checked + .slider {
    background-color: #8BC53F;
}

input:disabled + .slider {
    opacity: 0.5;
    cursor: not-allowed;
}

input:focus + .slider {
    box-shadow: 0 0 1px #8BC53F;
}

input:checked + .slider:before {
    transform: translateX(26px);
    left: -5px;
}

input:checked + .slider:after {
    content: '';
    color: white;
    display: block;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 33%;
    font-size: 9px;
    font-family: Verdana, sans-serif;
}

/* Rounded sliders */
.slider.round {
    width: 35px;
    height: 16px;
    border-radius: 34px;
}

.slider.round:before {
    height: 9px;
    width: 9px;
    border-radius: 50%;

}
*, ::before, ::after{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }
::backdrop{--tw-border-spacing-x:0;--tw-border-spacing-y:0;--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*:where(.tailwind-container,.tailwind-container *),
:where(.tailwind-container,.tailwind-container *)::before,
:where(.tailwind-container,.tailwind-container *)::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

:where(.tailwind-container,.tailwind-container *)::before,
:where(.tailwind-container,.tailwind-container *)::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

.tailwind-container {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

.tailwind-container {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr:where(.tailwind-container,.tailwind-container *) {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]):where(.tailwind-container,.tailwind-container *) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1:where(.tailwind-container,.tailwind-container *),
h2:where(.tailwind-container,.tailwind-container *),
h3:where(.tailwind-container,.tailwind-container *),
h4:where(.tailwind-container,.tailwind-container *),
h5:where(.tailwind-container,.tailwind-container *),
h6:where(.tailwind-container,.tailwind-container *) {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a:where(.tailwind-container,.tailwind-container *) {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b:where(.tailwind-container,.tailwind-container *),
strong:where(.tailwind-container,.tailwind-container *) {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code:where(.tailwind-container,.tailwind-container *),
kbd:where(.tailwind-container,.tailwind-container *),
samp:where(.tailwind-container,.tailwind-container *),
pre:where(.tailwind-container,.tailwind-container *) {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small:where(.tailwind-container,.tailwind-container *) {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub:where(.tailwind-container,.tailwind-container *),
sup:where(.tailwind-container,.tailwind-container *) {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub:where(.tailwind-container,.tailwind-container *) {
  bottom: -0.25em;
}

sup:where(.tailwind-container,.tailwind-container *) {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table:where(.tailwind-container,.tailwind-container *) {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button:where(.tailwind-container,.tailwind-container *),
input:where(.tailwind-container,.tailwind-container *),
optgroup:where(.tailwind-container,.tailwind-container *),
select:where(.tailwind-container,.tailwind-container *),
textarea:where(.tailwind-container,.tailwind-container *) {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button:where(.tailwind-container,.tailwind-container *),
select:where(.tailwind-container,.tailwind-container *) {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button:where(.tailwind-container,.tailwind-container *),
input:where([type='button']):where(.tailwind-container,.tailwind-container *),
input:where([type='reset']):where(.tailwind-container,.tailwind-container *),
input:where([type='submit']):where(.tailwind-container,.tailwind-container *) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring:where(.tailwind-container,.tailwind-container *) {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid:where(.tailwind-container,.tailwind-container *) {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress:where(.tailwind-container,.tailwind-container *) {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

:where(.tailwind-container,.tailwind-container *) ::-webkit-inner-spin-button,
:where(.tailwind-container,.tailwind-container *) ::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search']:where(.tailwind-container,.tailwind-container *) {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

:where(.tailwind-container,.tailwind-container *) ::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

:where(.tailwind-container,.tailwind-container *) ::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary:where(.tailwind-container,.tailwind-container *) {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote:where(.tailwind-container,.tailwind-container *),
dl:where(.tailwind-container,.tailwind-container *),
dd:where(.tailwind-container,.tailwind-container *),
h1:where(.tailwind-container,.tailwind-container *),
h2:where(.tailwind-container,.tailwind-container *),
h3:where(.tailwind-container,.tailwind-container *),
h4:where(.tailwind-container,.tailwind-container *),
h5:where(.tailwind-container,.tailwind-container *),
h6:where(.tailwind-container,.tailwind-container *),
hr:where(.tailwind-container,.tailwind-container *),
figure:where(.tailwind-container,.tailwind-container *),
p:where(.tailwind-container,.tailwind-container *),
pre:where(.tailwind-container,.tailwind-container *) {
  margin: 0;
}

fieldset:where(.tailwind-container,.tailwind-container *) {
  margin: 0;
  padding: 0;
}

legend:where(.tailwind-container,.tailwind-container *) {
  padding: 0;
}

ol:where(.tailwind-container,.tailwind-container *),
ul:where(.tailwind-container,.tailwind-container *),
menu:where(.tailwind-container,.tailwind-container *) {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog:where(.tailwind-container,.tailwind-container *) {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea:where(.tailwind-container,.tailwind-container *) {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

:where(.tailwind-container,.tailwind-container *) input::-moz-placeholder, :where(.tailwind-container,.tailwind-container *) textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

:where(.tailwind-container,.tailwind-container *) input::placeholder,
:where(.tailwind-container,.tailwind-container *) textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button:where(.tailwind-container,.tailwind-container *),
[role="button"]:where(.tailwind-container,.tailwind-container *) {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled:where(.tailwind-container,.tailwind-container *) {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img:where(.tailwind-container,.tailwind-container *),
svg:where(.tailwind-container,.tailwind-container *),
video:where(.tailwind-container,.tailwind-container *),
canvas:where(.tailwind-container,.tailwind-container *),
audio:where(.tailwind-container,.tailwind-container *),
iframe:where(.tailwind-container,.tailwind-container *),
embed:where(.tailwind-container,.tailwind-container *),
object:where(.tailwind-container,.tailwind-container *) {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img:where(.tailwind-container,.tailwind-container *),
video:where(.tailwind-container,.tailwind-container *) {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])):where(.tailwind-container,.tailwind-container *) {
  display: none;
}
    :root {
        --background: 0 0% 100%;
        --backgroundGrey: 108 2% 95%;
        --foreground: 222.2 47.4% 11.2%;

        --muted: 210 40% 96.1%;
        --muted-foreground: 215.4 16.3% 46.9%;

        --popover: 0 0% 100%;
        --popover-foreground: 222.2 47.4% 11.2%;

        --border: 214.3 31.8% 91.4%;
        --input: 214.3 31.8% 91.4%;

        --card: 0 0% 100%;
        --card-foreground: 222.2 47.4% 11.2%;

        --primary: 139 197 63;
        --primary-foreground: 210 40% 98%;

        --secondary: 34 76 79;
        --secondary-foreground: 210 40% 98%;

        --accent: 108 2% 95%;
        --accent-foreground: 222.2 47.4% 11.2%;

        --destructive: 359.27 78.85 59.22;
        --destructive-foreground: 0 0% 100%;

        --info: 200.41 98.01 39.41;
        --info-foreground: 200.95 90 27.45;

        --ring: 215 20.2% 65.1%;

        --radius: 0.5rem;

        --grey: 0 0 47%;
        --grey-light: 0 0 85%;
        --grey-dark: 0 0 20%;
        --grey-bg: 0 0 95%;
    }

    .dark {
        --background: 224 71% 4%;
        --foreground: 213 31% 91%;

        --muted: 223 47% 11%;
        --muted-foreground: 215.4 16.3% 56.9%;

        --accent: 216 34% 17%;
        --accent-foreground: 210 40% 98%;

        --popover: 224 71% 4%;
        --popover-foreground: 215 20.2% 65.1%;

        --border: 216 34% 17%;
        --input: 216 34% 17%;

        --card: 224 71% 4%;
        --card-foreground: 213 31% 91%;

        --primary: 210 40% 98%;
        --primary-foreground: 222.2 47.4% 1.2%;

        --secondary: 222.2 47.4% 11.2%;
        --secondary-foreground: 210 40% 98%;

        --destructive: 0 63% 31%;
        --destructive-foreground: 210 40% 98%;

        --ring: 216 34% 17%;

        --radius: 0.5rem;

        --grey: 0 0 47%;
        --grey-light: 0 0 85%;
        --grey-dark: 0 0 20%;
        --grey-bg: 0 0 95%;
    }
    *{border-color:hsl(var(--border))}

    body{background-color:hsl(var(--background));color:hsl(var(--foreground))}

    .tailwind-container {
        h1{margin-top:1rem}
        h1{margin-bottom:0.5rem}
        h1{font-size:1.5rem;line-height:2rem}
        h1{font-weight:700}
        h1 {
            /* 1.5rem */
        }

        h2{margin-top:0.75rem}

        h2{margin-bottom:0.5rem}

        h2{font-size:1.25rem;line-height:1.75rem}

        h2{font-weight:700}

        h2 {
            /* 1.25rem */
        }

        h3{margin-top:0.75rem}

        h3{margin-bottom:0.5rem}

        h3{font-size:1.125rem;line-height:1.75rem}

        h3{font-weight:700}

        h3 {
            /* 1.125rem */
        }

        h4{margin-top:0.75rem}

        h4{margin-bottom:0.5rem}

        h4{font-size:1rem;line-height:1.5rem}

        h4{font-weight:700}

        h4 {
            /* 1rem */
        }

        h5{margin-top:0.5rem}

        h5{margin-bottom:0.25rem}

        h5{font-size:0.875rem;line-height:1.25rem}

        h5{font-weight:700}

        h5 {
            /* 0.875rem */
        }

        h6{margin-top:0.5rem}

        h6{margin-bottom:0.25rem}

        h6{font-size:0.75rem;line-height:1rem}

        h6{font-weight:700}

        h6 {
            /* 0.75rem */
        }
    }
    .tw-clear-float-list li {
      float: none !important;
      display: list-item !important;
    }
.tw-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border-width:0}
.tw-pointer-events-none{pointer-events:none}
.tw-pointer-events-auto{pointer-events:auto}
.tw-invisible{visibility:hidden}
.tw-fixed{position:fixed}
.tw-absolute{position:absolute}
.tw-relative{position:relative}
.tw-sticky{position:sticky}
.tw-inset-0{inset:0px}
.tw-inset-x-0{left:0px;right:0px}
.tw-inset-y-0{top:0px;bottom:0px}
.tw--bottom-12{bottom:-3rem}
.tw--left-12{left:-3rem}
.tw--right-12{right:-3rem}
.tw--top-12{top:-3rem}
.tw-bottom-0{bottom:0px}
.tw-bottom-2{bottom:0.5rem}
.tw-left-0{left:0px}
.tw-left-1{left:0.25rem}
.tw-left-1\\/2{left:50%}
.tw-left-2{left:0.5rem}
.tw-left-\\[-5px\\]{left:-5px}
.tw-left-\\[50\\%\\]{left:50%}
.tw-left-full{left:100%}
.tw-right-0{right:0px}
.tw-right-1{right:0.25rem}
.tw-right-2{right:0.5rem}
.tw-right-2\\.5{right:0.625rem}
.tw-right-3{right:0.75rem}
.tw-right-4{right:1rem}
.tw-top-0{top:0px}
.tw-top-1\\.5{top:0.375rem}
.tw-top-1\\/2{top:50%}
.tw-top-2{top:0.5rem}
.tw-top-3{top:0.75rem}
.tw-top-3\\.5{top:0.875rem}
.tw-top-4{top:1rem}
.tw-top-7{top:1.75rem}
.tw-top-\\[1px\\]{top:1px}
.tw-top-\\[50\\%\\]{top:50%}
.tw-top-\\[60\\%\\]{top:60%}
.tw-top-\\[calc\\(15\\%-6rem\\)\\]{top:calc(15% - 6rem)}
.tw-top-\\[calc\\(85\\%\\+1rem\\)\\]{top:calc(85% + 1rem)}
.tw-top-full{top:100%}
.tw-z-0{z-index:0}
.tw-z-10{z-index:10}
.tw-z-20{z-index:20}
.tw-z-40{z-index:40}
.tw-z-50{z-index:50}
.tw-z-\\[100\\]{z-index:100}
.tw-z-\\[1\\]{z-index:1}
.tw-z-\\[50\\]{z-index:50}
.\\!tw-m-0{margin:0px !important}
.tw-m-0{margin:0px}
.tw--mx-1{margin-left:-0.25rem;margin-right:-0.25rem}
.tw-mx-1{margin-left:0.25rem;margin-right:0.25rem}
.tw-mx-2{margin-left:0.5rem;margin-right:0.5rem}
.tw-mx-3\\.5{margin-left:0.875rem;margin-right:0.875rem}
.tw-mx-auto{margin-left:auto;margin-right:auto}
.tw-my-1{margin-top:0.25rem;margin-bottom:0.25rem}
.tw-my-12{margin-top:3rem;margin-bottom:3rem}
.tw-my-2{margin-top:0.5rem;margin-bottom:0.5rem}
.tw-my-3{margin-top:0.75rem;margin-bottom:0.75rem}
.\\!tw-mb-0{margin-bottom:0px !important}
.\\!tw-mb-6{margin-bottom:1.5rem !important}
.\\!tw-mt-0{margin-top:0px !important}
.\\!tw-mt-4{margin-top:1rem !important}
.-tw-mr-1{margin-right:-0.25rem}
.tw--ml-4{margin-left:-1rem}
.tw--mt-4{margin-top:-1rem}
.tw-mb-0{margin-bottom:0px}
.tw-mb-0\\.5{margin-bottom:0.125rem}
.tw-mb-1{margin-bottom:0.25rem}
.tw-mb-2{margin-bottom:0.5rem}
.tw-mb-4{margin-bottom:1rem}
.tw-mb-5{margin-bottom:1.25rem}
.tw-mb-6{margin-bottom:1.5rem}
.tw-mb-8{margin-bottom:2rem}
.tw-ml-0{margin-left:0px}
.tw-ml-0\\.5{margin-left:0.125rem}
.tw-ml-1{margin-left:0.25rem}
.tw-ml-2{margin-left:0.5rem}
.tw-ml-4{margin-left:1rem}
.tw-ml-6{margin-left:1.5rem}
.tw-ml-auto{margin-left:auto}
.tw-mr-1{margin-right:0.25rem}
.tw-mr-2{margin-right:0.5rem}
.tw-mr-auto{margin-right:auto}
.tw-mt-0{margin-top:0px}
.tw-mt-0\\.5{margin-top:0.125rem}
.tw-mt-1{margin-top:0.25rem}
.tw-mt-1\\.5{margin-top:0.375rem}
.tw-mt-2{margin-top:0.5rem}
.tw-mt-24{margin-top:6rem}
.tw-mt-3{margin-top:0.75rem}
.tw-mt-4{margin-top:1rem}
.tw-mt-6{margin-top:1.5rem}
.tw-mt-\\[-4px\\]{margin-top:-4px}
.tw-mt-\\[-6px\\]{margin-top:-6px}
.tw-mt-\\[-8px\\]{margin-top:-8px}
.tw-mt-auto{margin-top:auto}
.tw-block{display:block}
.tw-inline-block{display:inline-block}
.tw-flex{display:flex}
.tw-inline-flex{display:inline-flex}
.tw-grid{display:grid}
.tw-hidden{display:none}
.tw-aspect-square{aspect-ratio:1 / 1}
.tw-aspect-video{aspect-ratio:16 / 9}
.tw-size-4{width:1rem;height:1rem}
.tw-h-0{height:0px}
.tw-h-1\\.5{height:0.375rem}
.tw-h-1\\/2{height:50%}
.tw-h-10{height:2.5rem}
.tw-h-11{height:2.75rem}
.tw-h-12{height:3rem}
.tw-h-2{height:0.5rem}
.tw-h-2\\.5{height:0.625rem}
.tw-h-20{height:5rem}
.tw-h-3{height:0.75rem}
.tw-h-3\\.5{height:0.875rem}
.tw-h-4{height:1rem}
.tw-h-5{height:1.25rem}
.tw-h-6{height:1.5rem}
.tw-h-64{height:16rem}
.tw-h-7{height:1.75rem}
.tw-h-8{height:2rem}
.tw-h-9{height:2.25rem}
.tw-h-\\[1px\\]{height:1px}
.tw-h-\\[200px\\]{height:200px}
.tw-h-\\[255px\\]{height:255px}
.tw-h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{height:var(--radix-navigation-menu-viewport-height)}
.tw-h-\\[var\\(--radix-select-trigger-height\\)\\]{height:var(--radix-select-trigger-height)}
.tw-h-auto{height:auto}
.tw-h-full{height:100%}
.tw-h-px{height:1px}
.tw-h-screen{height:100vh}
.tw-h-svh{height:100svh}
.\\!tw-max-h-28{max-height:7rem !important}
.tw-max-h-10{max-height:2.5rem}
.tw-max-h-96{max-height:24rem}
.tw-max-h-\\[120px\\]{max-height:120px}
.tw-max-h-\\[200px\\]{max-height:200px}
.tw-max-h-\\[300px\\]{max-height:300px}
.tw-max-h-\\[70vh\\]{max-height:70vh}
.tw-max-h-full{max-height:100%}
.tw-max-h-screen{max-height:100vh}
.\\!tw-min-h-0{min-height:0px !important}
.tw-min-h-0{min-height:0px}
.tw-min-h-11{min-height:2.75rem}
.tw-min-h-9{min-height:2.25rem}
.tw-min-h-\\[100dvh\\]{min-height:100dvh}
.tw-min-h-\\[600px\\]{min-height:600px}
.tw-min-h-\\[70vh\\]{min-height:70vh}
.tw-min-h-\\[80px\\]{min-height:80px}
.tw-min-h-full{min-height:100%}
.tw-min-h-svh{min-height:100svh}
.tw-w-1\\.5{width:0.375rem}
.tw-w-1\\/2{width:50%}
.tw-w-10{width:2.5rem}
.tw-w-11{width:2.75rem}
.tw-w-12{width:3rem}
.tw-w-2{width:0.5rem}
.tw-w-2\\.5{width:0.625rem}
.tw-w-3{width:0.75rem}
.tw-w-3\\.5{width:0.875rem}
.tw-w-3\\/4{width:75%}
.tw-w-4{width:1rem}
.tw-w-5{width:1.25rem}
.tw-w-6{width:1.5rem}
.tw-w-64{width:16rem}
.tw-w-7{width:1.75rem}
.tw-w-72{width:18rem}
.tw-w-8{width:2rem}
.tw-w-9{width:2.25rem}
.tw-w-\\[--sidebar-width\\]{width:var(--sidebar-width)}
.tw-w-\\[100px\\]{width:100px}
.tw-w-\\[1px\\]{width:1px}
.tw-w-\\[280px\\]{width:280px}
.tw-w-\\[320px\\]{width:320px}
.tw-w-\\[35\\%\\]{width:35%}
.tw-w-\\[65\\%\\]{width:65%}
.tw-w-\\[90\\%\\]{width:90%}
.tw-w-auto{width:auto}
.tw-w-fit{width:-moz-fit-content;width:fit-content}
.tw-w-full{width:100%}
.tw-w-max{width:-moz-max-content;width:max-content}
.tw-w-px{width:1px}
.tw-w-screen{width:100vw}
.tw-min-w-0{min-width:0px}
.tw-min-w-20{min-width:5rem}
.tw-min-w-5{min-width:1.25rem}
.tw-min-w-\\[12rem\\]{min-width:12rem}
.tw-min-w-\\[250px\\]{min-width:250px}
.tw-min-w-\\[8rem\\]{min-width:8rem}
.tw-min-w-\\[var\\(--radix-select-trigger-width\\)\\]{min-width:var(--radix-select-trigger-width)}
.tw-min-w-full{min-width:100%}
.\\!tw-max-w-full{max-width:100% !important}
.tw-max-w-\\[--skeleton-width\\]{max-width:var(--skeleton-width)}
.tw-max-w-\\[520px\\]{max-width:520px}
.tw-max-w-\\[560px\\]{max-width:560px}
.tw-max-w-\\[75\\%\\]{max-width:75%}
.tw-max-w-\\[80vw\\]{max-width:80vw}
.tw-max-w-\\[90\\%\\]{max-width:90%}
.tw-max-w-full{max-width:100%}
.tw-max-w-lg{max-width:32rem}
.tw-max-w-max{max-width:-moz-max-content;max-width:max-content}
.tw-max-w-md{max-width:28rem}
.tw-max-w-screen-2xl{max-width:1536px}
.tw-max-w-sm{max-width:24rem}
.tw-max-w-xs{max-width:20rem}
.\\!tw-flex-none{flex:none !important}
.tw-flex-1{flex:1 1 0%}
.tw-flex-auto{flex:1 1 auto}
.tw-flex-none{flex:none}
.tw-flex-shrink-0{flex-shrink:0}
.tw-shrink-0{flex-shrink:0}
.tw-flex-grow{flex-grow:1}
.tw-grow{flex-grow:1}
.tw-grow-0{flex-grow:0}
.tw-basis-1\\/4{flex-basis:25%}
.tw-basis-3\\/4{flex-basis:75%}
.tw-basis-full{flex-basis:100%}
.tw-caption-bottom{caption-side:bottom}
.tw-border-collapse{border-collapse:collapse}
.-tw-translate-y-1\\/2{--tw-translate-y:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}
.tw--translate-x-1\\/2{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}
.tw--translate-x-px{--tw-translate-x:-1px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}
.tw--translate-y-1\\/2{--tw-translate-y:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}
.tw-translate-x-\\[-50\\%\\]{--tw-translate-x:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}
.tw-translate-x-px{--tw-translate-x:1px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}
.tw-translate-y-\\[-50\\%\\]{--tw-translate-y:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}
.tw-rotate-45{--tw-rotate:45deg;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}
.tw-rotate-90{--tw-rotate:90deg;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}
.tw-rotate-\\[-90deg\\]{--tw-rotate:-90deg;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}
.tw-transform{transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}
@keyframes tw-caret-blink{0%,70%,100%{opacity:1}20%,50%{opacity:0}}
.tw-animate-caret-blink{animation:tw-caret-blink 1.25s ease-out infinite}
@keyframes tw-pulse{50%{opacity:.5}}
.tw-animate-pulse{animation:tw-pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite}
@keyframes tw-spin{to{transform:rotate(360deg)}}
.tw-animate-spin{animation:tw-spin 1s linear infinite}
.tw-cursor-default{cursor:default}
.tw-cursor-not-allowed{cursor:not-allowed}
.tw-cursor-pointer{cursor:pointer}
.tw-touch-none{touch-action:none}
.tw-select-none{-webkit-user-select:none;-moz-user-select:none;user-select:none}
.tw-resize-none{resize:none}
.tw-list-decimal{list-style-type:decimal}
.tw-list-disc{list-style-type:disc}
.tw-list-none{list-style-type:none}
.tw-appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}
.tw-grid-cols-1{grid-template-columns:repeat(1, minmax(0, 1fr))}
.tw-grid-cols-2{grid-template-columns:repeat(2, minmax(0, 1fr))}
.tw-grid-cols-3{grid-template-columns:repeat(3, minmax(0, 1fr))}
.tw-grid-cols-4{grid-template-columns:repeat(4, minmax(0, 1fr))}
.tw-grid-rows-2{grid-template-rows:repeat(2, minmax(0, 1fr))}
.tw-flex-row{flex-direction:row}
.tw-flex-col{flex-direction:column}
.tw-flex-col-reverse{flex-direction:column-reverse}
.tw-flex-wrap{flex-wrap:wrap}
.tw-items-start{align-items:flex-start}
.tw-items-end{align-items:flex-end}
.tw-items-center{align-items:center}
.tw-items-stretch{align-items:stretch}
.tw-justify-start{justify-content:flex-start}
.tw-justify-end{justify-content:flex-end}
.tw-justify-center{justify-content:center}
.tw-justify-between{justify-content:space-between}
.tw-gap-1{gap:0.25rem}
.tw-gap-1\\.5{gap:0.375rem}
.tw-gap-2{gap:0.5rem}
.tw-gap-3{gap:0.75rem}
.tw-gap-4{gap:1rem}
.tw-gap-6{gap:1.5rem}
.tw-space-x-1 > :not([hidden]) ~ :not([hidden]){--tw-space-x-reverse:0;margin-right:calc(0.25rem * var(--tw-space-x-reverse));margin-left:calc(0.25rem * calc(1 - var(--tw-space-x-reverse)))}
.tw-space-x-2 > :not([hidden]) ~ :not([hidden]){--tw-space-x-reverse:0;margin-right:calc(0.5rem * var(--tw-space-x-reverse));margin-left:calc(0.5rem * calc(1 - var(--tw-space-x-reverse)))}
.tw-space-x-3 > :not([hidden]) ~ :not([hidden]){--tw-space-x-reverse:0;margin-right:calc(0.75rem * var(--tw-space-x-reverse));margin-left:calc(0.75rem * calc(1 - var(--tw-space-x-reverse)))}
.tw-space-x-4 > :not([hidden]) ~ :not([hidden]){--tw-space-x-reverse:0;margin-right:calc(1rem * var(--tw-space-x-reverse));margin-left:calc(1rem * calc(1 - var(--tw-space-x-reverse)))}
.tw-space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){--tw-space-y-reverse:0;margin-top:calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(0.125rem * var(--tw-space-y-reverse))}
.tw-space-y-1 > :not([hidden]) ~ :not([hidden]){--tw-space-y-reverse:0;margin-top:calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(0.25rem * var(--tw-space-y-reverse))}
.tw-space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){--tw-space-y-reverse:0;margin-top:calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(0.375rem * var(--tw-space-y-reverse))}
.tw-space-y-2 > :not([hidden]) ~ :not([hidden]){--tw-space-y-reverse:0;margin-top:calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(0.5rem * var(--tw-space-y-reverse))}
.tw-space-y-3 > :not([hidden]) ~ :not([hidden]){--tw-space-y-reverse:0;margin-top:calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(0.75rem * var(--tw-space-y-reverse))}
.tw-space-y-4 > :not([hidden]) ~ :not([hidden]){--tw-space-y-reverse:0;margin-top:calc(1rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1rem * var(--tw-space-y-reverse))}
.tw-space-y-6 > :not([hidden]) ~ :not([hidden]){--tw-space-y-reverse:0;margin-top:calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(1.5rem * var(--tw-space-y-reverse))}
.tw-divide-y > :not([hidden]) ~ :not([hidden]){--tw-divide-y-reverse:0;border-top-width:calc(1px * calc(1 - var(--tw-divide-y-reverse)));border-bottom-width:calc(1px * var(--tw-divide-y-reverse))}
.tw-overflow-auto{overflow:auto}
.tw-overflow-hidden{overflow:hidden}
.tw-overflow-x-auto{overflow-x:auto}
.tw-overflow-y-auto{overflow-y:auto}
.tw-overflow-x-hidden{overflow-x:hidden}
.tw-overflow-y-scroll{overflow-y:scroll}
.tw-text-ellipsis{text-overflow:ellipsis}
.tw-whitespace-nowrap{white-space:nowrap}
.tw-whitespace-pre-wrap{white-space:pre-wrap}
.tw-break-words{overflow-wrap:break-word}
.tw-rounded{border-radius:0.25rem}
.tw-rounded-\\[2px\\]{border-radius:2px}
.tw-rounded-\\[inherit\\]{border-radius:inherit}
.tw-rounded-full{border-radius:9999px}
.tw-rounded-lg{border-radius:var(--radius)}
.tw-rounded-md{border-radius:calc(var(--radius) - 2px)}
.tw-rounded-sm{border-radius:calc(var(--radius) - 4px)}
.tw-rounded-xl{border-radius:0.75rem}
.tw-rounded-r-lg{border-top-right-radius:var(--radius);border-bottom-right-radius:var(--radius)}
.tw-rounded-r-md{border-top-right-radius:calc(var(--radius) - 2px);border-bottom-right-radius:calc(var(--radius) - 2px)}
.tw-rounded-t-\\[10px\\]{border-top-left-radius:10px;border-top-right-radius:10px}
.tw-rounded-t-lg{border-top-left-radius:var(--radius);border-top-right-radius:var(--radius)}
.tw-rounded-t-xl{border-top-left-radius:0.75rem;border-top-right-radius:0.75rem}
.tw-rounded-tl-sm{border-top-left-radius:calc(var(--radius) - 4px)}
.\\!tw-border-0{border-width:0px !important}
.\\!tw-border-2{border-width:2px !important}
.tw-border{border-width:1px}
.tw-border-2{border-width:2px}
.tw-border-4{border-width:4px}
.tw-border-y{border-top-width:1px;border-bottom-width:1px}
.tw-border-b{border-bottom-width:1px}
.tw-border-l{border-left-width:1px}
.tw-border-l-2{border-left-width:2px}
.tw-border-l-4{border-left-width:4px}
.tw-border-r{border-right-width:1px}
.tw-border-t{border-top-width:1px}
.\\!tw-border-solid{border-style:solid !important}
.tw-border-solid{border-style:solid}
.tw-border-dashed{border-style:dashed}
.tw-border-none{border-style:none}
.tw-border-\\[--color-border\\]{border-color:var(--color-border)}
.tw-border-accent{border-color:hsl(var(--accent))}
.tw-border-amber-800{--tw-border-opacity:1;border-color:rgb(146 64 14 / var(--tw-border-opacity, 1))}
.tw-border-black\\/10{border-color:rgb(0 0 0 / 0.1)}
.tw-border-border{border-color:hsl(var(--border))}
.tw-border-border\\/20{border-color:hsl(var(--border) / 0.2)}
.tw-border-border\\/30{border-color:hsl(var(--border) / 0.3)}
.tw-border-border\\/50{border-color:hsl(var(--border) / 0.5)}
.tw-border-destructive{border-color:hsl(var(--destructive))}
.tw-border-destructive\\/20{border-color:hsl(var(--destructive) / 0.2)}
.tw-border-gray-100{--tw-border-opacity:1;border-color:rgb(243 244 246 / var(--tw-border-opacity, 1))}
.tw-border-gray-200{--tw-border-opacity:1;border-color:rgb(229 231 235 / var(--tw-border-opacity, 1))}
.tw-border-gray-300{--tw-border-opacity:1;border-color:rgb(209 213 219 / var(--tw-border-opacity, 1))}
.tw-border-gray-400{--tw-border-opacity:1;border-color:rgb(156 163 175 / var(--tw-border-opacity, 1))}
.tw-border-green-600{--tw-border-opacity:1;border-color:rgb(22 163 74 / var(--tw-border-opacity, 1))}
.tw-border-info-foreground{border-color:hsl(var(--info-foreground))}
.tw-border-input{border-color:hsl(var(--input))}
.tw-border-muted{border-color:hsl(var(--muted))}
.tw-border-primary{border-color:rgb(var(--primary))}
.tw-border-primary\\/20{border-color:rgb(var(--primary) / 0.2)}
.tw-border-secondary{border-color:rgb(var(--secondary))}
.tw-border-sidebar-border{border-color:hsl(var(--sidebar-border))}
.tw-border-sky-800{--tw-border-opacity:1;border-color:rgb(7 89 133 / var(--tw-border-opacity, 1))}
.tw-border-transparent{border-color:transparent}
.tw-border-white{--tw-border-opacity:1;border-color:rgb(255 255 255 / var(--tw-border-opacity, 1))}
.tw-border-l-transparent{border-left-color:transparent}
.tw-border-t-transparent{border-top-color:transparent}
.\\!tw-bg-\\[\\#ffffff\\]{--tw-bg-opacity:1 !important;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important}
.tw-bg-\\[--color-bg\\]{background-color:var(--color-bg)}
.tw-bg-accent{background-color:hsl(var(--accent))}
.tw-bg-accent\\/40{background-color:hsl(var(--accent) / 0.4)}
.tw-bg-amber-400\\/20{background-color:rgb(251 191 36 / 0.2)}
.tw-bg-background{background-color:hsl(var(--background))}
.tw-bg-background-grey{background-color:hsl(var(--backgroundGrey))}
.tw-bg-background\\/90{background-color:hsl(var(--background) / 0.9)}
.tw-bg-backgroundGrey{background-color:hsl(var(--backgroundGrey))}
.tw-bg-black\\/40{background-color:rgb(0 0 0 / 0.4)}
.tw-bg-black\\/80{background-color:rgb(0 0 0 / 0.8)}
.tw-bg-border{background-color:hsl(var(--border))}
.tw-bg-card{background-color:hsl(var(--card))}
.tw-bg-destructive{background-color:hsl(var(--destructive))}
.tw-bg-destructive\\/10{background-color:hsl(var(--destructive) / 0.1)}
.tw-bg-destructive\\/30{background-color:hsl(var(--destructive) / 0.3)}
.tw-bg-destructive\\/5{background-color:hsl(var(--destructive) / 0.05)}
.tw-bg-foreground{background-color:hsl(var(--foreground))}
.tw-bg-gray-100{--tw-bg-opacity:1;background-color:rgb(243 244 246 / var(--tw-bg-opacity, 1))}
.tw-bg-gray-200{--tw-bg-opacity:1;background-color:rgb(229 231 235 / var(--tw-bg-opacity, 1))}
.tw-bg-gray-400{--tw-bg-opacity:1;background-color:rgb(156 163 175 / var(--tw-bg-opacity, 1))}
.tw-bg-gray-50{--tw-bg-opacity:1;background-color:rgb(249 250 251 / var(--tw-bg-opacity, 1))}
.tw-bg-green-600\\/20{background-color:rgb(22 163 74 / 0.2)}
.tw-bg-grey-bg{background-color:hsl(var(--grey-bg))}
.tw-bg-info\\/20{background-color:hsl(var(--info) / 0.2)}
.tw-bg-muted{background-color:hsl(var(--muted))}
.tw-bg-muted\\/50{background-color:hsl(var(--muted) / 0.5)}
.tw-bg-popover{background-color:hsl(var(--popover))}
.tw-bg-primary{background-color:rgb(var(--primary))}
.tw-bg-primary\\/5{background-color:rgb(var(--primary) / 0.05)}
.tw-bg-red-50{--tw-bg-opacity:1;background-color:rgb(254 242 242 / var(--tw-bg-opacity, 1))}
.tw-bg-secondary{background-color:rgb(var(--secondary))}
.tw-bg-sidebar{background-color:hsl(var(--sidebar-background))}
.tw-bg-sidebar-border{background-color:hsl(var(--sidebar-border))}
.tw-bg-transparent{background-color:transparent}
.tw-bg-white{--tw-bg-opacity:1;background-color:rgb(255 255 255 / var(--tw-bg-opacity, 1))}
.tw-bg-white\\/40{background-color:rgb(255 255 255 / 0.4)}
.tw-bg-white\\/70{background-color:rgb(255 255 255 / 0.7)}
.tw-bg-white\\/80{background-color:rgb(255 255 255 / 0.8)}
.tw-bg-\\[linear-gradient\\(\\#ddd_1px\\,transparent_1px\\)\\,linear-gradient\\(90deg\\,\\#ddd_1px\\,transparent_1px\\)\\]{background-image:linear-gradient(#ddd 1px,transparent 1px),linear-gradient(90deg,#ddd 1px,transparent 1px)}
.tw-bg-\\[url\\(\\'\\/images\\/placeholder\\.webp\\'\\)\\]{background-image:url('/images/placeholder.webp')}
.tw-bg-\\[url\\(\\'\\/images\\/placeholder_wide\\.webp\\'\\)\\]{background-image:url('/images/placeholder_wide.webp')}
.tw-bg-\\[size\\:calc\\(100\\%\\/12\\)_100px\\]{background-size:calc(100% / 12) 100px}
.tw-bg-cover{background-size:cover}
.tw-bg-center{background-position:center}
.tw-bg-no-repeat{background-repeat:no-repeat}
.tw-fill-current{fill:currentColor}
.\\!tw-p-0{padding:0px !important}
.\\!tw-p-2{padding:0.5rem !important}
.tw-p-0{padding:0px}
.tw-p-0\\.5{padding:0.125rem}
.tw-p-1{padding:0.25rem}
.tw-p-2{padding:0.5rem}
.tw-p-20{padding:5rem}
.tw-p-3{padding:0.75rem}
.tw-p-4{padding:1rem}
.tw-p-6{padding:1.5rem}
.tw-p-8{padding:2rem}
.tw-p-\\[1px\\]{padding:1px}
.\\!tw-py-0{padding-top:0px !important;padding-bottom:0px !important}
.\\!tw-py-4{padding-top:1rem !important;padding-bottom:1rem !important}
.tw-px-1{padding-left:0.25rem;padding-right:0.25rem}
.tw-px-1\\.5{padding-left:0.375rem;padding-right:0.375rem}
.tw-px-10{padding-left:2.5rem;padding-right:2.5rem}
.tw-px-2{padding-left:0.5rem;padding-right:0.5rem}
.tw-px-2\\.5{padding-left:0.625rem;padding-right:0.625rem}
.tw-px-3{padding-left:0.75rem;padding-right:0.75rem}
.tw-px-4{padding-left:1rem;padding-right:1rem}
.tw-px-5{padding-left:1.25rem;padding-right:1.25rem}
.tw-px-6{padding-left:1.5rem;padding-right:1.5rem}
.tw-px-8{padding-left:2rem;padding-right:2rem}
.tw-py-0{padding-top:0px;padding-bottom:0px}
.tw-py-0\\.5{padding-top:0.125rem;padding-bottom:0.125rem}
.tw-py-1{padding-top:0.25rem;padding-bottom:0.25rem}
.tw-py-1\\.5{padding-top:0.375rem;padding-bottom:0.375rem}
.tw-py-10{padding-top:2.5rem;padding-bottom:2.5rem}
.tw-py-2{padding-top:0.5rem;padding-bottom:0.5rem}
.tw-py-3{padding-top:0.75rem;padding-bottom:0.75rem}
.tw-py-4{padding-top:1rem;padding-bottom:1rem}
.tw-py-6{padding-top:1.5rem;padding-bottom:1.5rem}
.tw-py-8{padding-top:2rem;padding-bottom:2rem}
.tw-pb-2{padding-bottom:0.5rem}
.tw-pb-2\\.5{padding-bottom:0.625rem}
.tw-pb-3{padding-bottom:0.75rem}
.tw-pb-4{padding-bottom:1rem}
.tw-pb-6{padding-bottom:1.5rem}
.tw-pl-2{padding-left:0.5rem}
.tw-pl-2\\.5{padding-left:0.625rem}
.tw-pl-4{padding-left:1rem}
.tw-pl-5{padding-left:1.25rem}
.tw-pl-6{padding-left:1.5rem}
.tw-pl-8{padding-left:2rem}
.tw-pr-10{padding-right:2.5rem}
.tw-pr-14{padding-right:3.5rem}
.tw-pr-2{padding-right:0.5rem}
.tw-pr-2\\.5{padding-right:0.625rem}
.tw-pr-4{padding-right:1rem}
.tw-pr-6{padding-right:1.5rem}
.tw-pr-8{padding-right:2rem}
.tw-pt-0{padding-top:0px}
.tw-pt-1{padding-top:0.25rem}
.tw-pt-3{padding-top:0.75rem}
.tw-pt-4{padding-top:1rem}
.tw-pt-6{padding-top:1.5rem}
.tw-text-left{text-align:left}
.tw-text-center{text-align:center}
.tw-text-right{text-align:right}
.tw-text-justify{text-align:justify}
.tw-align-middle{vertical-align:middle}
.tw-font-mono{font-family:ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace}
.tw-text-2xl{font-size:1.5rem;line-height:2rem}
.tw-text-3xl{font-size:1.875rem;line-height:2.25rem}
.tw-text-4xl{font-size:2.25rem;line-height:2.5rem}
.tw-text-6xl{font-size:3.75rem;line-height:1}
.tw-text-\\[0\\.8rem\\]{font-size:0.8rem}
.tw-text-\\[10px\\]{font-size:10px}
.tw-text-\\[11px\\]{font-size:11px}
.tw-text-\\[12px\\]{font-size:12px}
.tw-text-\\[13px\\]{font-size:13px}
.tw-text-\\[14px\\]{font-size:14px}
.tw-text-\\[15px\\]{font-size:15px}
.tw-text-\\[8px\\]{font-size:8px}
.tw-text-base{font-size:1rem;line-height:1.5rem}
.tw-text-lg{font-size:1.125rem;line-height:1.75rem}
.tw-text-sm{font-size:0.875rem;line-height:1.25rem}
.tw-text-xl{font-size:1.25rem;line-height:1.75rem}
.tw-text-xs{font-size:0.75rem;line-height:1rem}
.tw-font-bold{font-weight:700}
.tw-font-light{font-weight:300}
.tw-font-medium{font-weight:500}
.tw-font-normal{font-weight:400}
.tw-font-semibold{font-weight:600}
.tw-uppercase{text-transform:uppercase}
.tw-italic{font-style:italic}
.tw-tabular-nums{--tw-numeric-spacing:tabular-nums;font-variant-numeric:var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction)}
.tw-leading-5{line-height:1.25rem}
.tw-leading-none{line-height:1}
.tw-leading-relaxed{line-height:1.625}
.tw-tracking-tight{letter-spacing:-0.025em}
.tw-tracking-wider{letter-spacing:0.05em}
.tw-tracking-widest{letter-spacing:0.1em}
.tw-text-accent-foreground{color:hsl(var(--accent-foreground))}
.tw-text-amber-800{--tw-text-opacity:1;color:rgb(146 64 14 / var(--tw-text-opacity, 1))}
.tw-text-card-foreground{color:hsl(var(--card-foreground))}
.tw-text-current{color:currentColor}
.tw-text-destructive{color:hsl(var(--destructive))}
.tw-text-destructive-foreground{color:hsl(var(--destructive-foreground))}
.tw-text-destructive\\/80{color:hsl(var(--destructive) / 0.8)}
.tw-text-foreground{color:hsl(var(--foreground))}
.tw-text-foreground\\/50{color:hsl(var(--foreground) / 0.5)}
.tw-text-gray-400{--tw-text-opacity:1;color:rgb(156 163 175 / var(--tw-text-opacity, 1))}
.tw-text-gray-500{--tw-text-opacity:1;color:rgb(107 114 128 / var(--tw-text-opacity, 1))}
.tw-text-gray-600{--tw-text-opacity:1;color:rgb(75 85 99 / var(--tw-text-opacity, 1))}
.tw-text-gray-700{--tw-text-opacity:1;color:rgb(55 65 81 / var(--tw-text-opacity, 1))}
.tw-text-gray-800{--tw-text-opacity:1;color:rgb(31 41 55 / var(--tw-text-opacity, 1))}
.tw-text-gray-900{--tw-text-opacity:1;color:rgb(17 24 39 / var(--tw-text-opacity, 1))}
.tw-text-green-600{--tw-text-opacity:1;color:rgb(22 163 74 / var(--tw-text-opacity, 1))}
.tw-text-green-800{--tw-text-opacity:1;color:rgb(22 101 52 / var(--tw-text-opacity, 1))}
.tw-text-grey{color:hsl(var(--grey))}
.tw-text-grey-dark{color:hsl(var(--grey-dark))}
.tw-text-info-foreground{color:hsl(var(--info-foreground))}
.tw-text-muted-foreground{color:hsl(var(--muted-foreground))}
.tw-text-popover-foreground{color:hsl(var(--popover-foreground))}
.tw-text-primary{color:rgb(var(--primary))}
.tw-text-primary-foreground{color:hsl(var(--primary-foreground))}
.tw-text-red-500{--tw-text-opacity:1;color:rgb(239 68 68 / var(--tw-text-opacity, 1))}
.tw-text-red-700{--tw-text-opacity:1;color:rgb(185 28 28 / var(--tw-text-opacity, 1))}
.tw-text-secondary{color:rgb(var(--secondary))}
.tw-text-secondary-foreground{color:hsl(var(--secondary-foreground))}
.tw-text-sidebar-foreground{color:hsl(var(--sidebar-foreground))}
.tw-text-sidebar-foreground\\/70{color:hsl(var(--sidebar-foreground) / 0.7)}
.tw-text-sky-800{--tw-text-opacity:1;color:rgb(7 89 133 / var(--tw-text-opacity, 1))}
.tw-text-slate-500{--tw-text-opacity:1;color:rgb(100 116 139 / var(--tw-text-opacity, 1))}
.tw-text-transparent{color:transparent}
.tw-text-white{--tw-text-opacity:1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}
.tw-text-yellow-800{--tw-text-opacity:1;color:rgb(133 77 14 / var(--tw-text-opacity, 1))}
.tw-underline{text-decoration-line:underline}
.tw-underline-offset-4{text-underline-offset:4px}
.tw-opacity-0{opacity:0}
.tw-opacity-100{opacity:1}
.tw-opacity-50{opacity:0.5}
.tw-opacity-60{opacity:0.6}
.tw-opacity-65{opacity:0.65}
.tw-opacity-70{opacity:0.7}
.tw-opacity-75{opacity:0.75}
.tw-opacity-90{opacity:0.9}
.tw-shadow-2xl{--tw-shadow:0 25px 50px -12px rgb(0 0 0 / 0.25);--tw-shadow-colored:0 25px 50px -12px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}
.tw-shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-border\\)\\)\\]{--tw-shadow:0 0 0 1px hsl(var(--sidebar-border));--tw-shadow-colored:0 0 0 1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}
.tw-shadow-lg{--tw-shadow:0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);--tw-shadow-colored:0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}
.tw-shadow-md{--tw-shadow:0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);--tw-shadow-colored:0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}
.tw-shadow-none{--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}
.tw-shadow-sm{--tw-shadow:0 1px 2px 0 rgb(0 0 0 / 0.05);--tw-shadow-colored:0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}
.tw-shadow-xl{--tw-shadow:0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);--tw-shadow-colored:0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}
.\\!tw-outline-none{outline:2px solid transparent !important;outline-offset:2px !important}
.tw-outline-none{outline:2px solid transparent;outline-offset:2px}
.tw-ring-0{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)}
.tw-ring-2{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)}
.tw-ring-ring{--tw-ring-color:hsl(var(--ring))}
.tw-ring-sidebar-ring{--tw-ring-color:hsl(var(--sidebar-ring))}
.tw-ring-offset-background{--tw-ring-offset-color:hsl(var(--background))}
.tw-backdrop-blur-\\[1px\\]{--tw-backdrop-blur:blur(1px);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}
.tw-backdrop-blur-sm{--tw-backdrop-blur:blur(4px);backdrop-filter:var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)}
.tw-transition{transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transition-duration:150ms}
.tw-transition-\\[left\\,right\\,width\\]{transition-property:left,right,width;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transition-duration:150ms}
.tw-transition-\\[margin\\,opa\\]{transition-property:margin,opa;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transition-duration:150ms}
.tw-transition-\\[width\\,height\\,padding\\]{transition-property:width,height,padding;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transition-duration:150ms}
.tw-transition-\\[width\\]{transition-property:width;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transition-duration:150ms}
.tw-transition-all{transition-property:all;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transition-duration:150ms}
.tw-transition-colors{transition-property:color, background-color, border-color, text-decoration-color, fill, stroke;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transition-duration:150ms}
.tw-transition-opacity{transition-property:opacity;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transition-duration:150ms}
.tw-transition-transform{transition-property:transform;transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);transition-duration:150ms}
.tw-duration-1000{transition-duration:1000ms}
.tw-duration-200{transition-duration:200ms}
.tw-ease-in-out{transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1)}
.tw-ease-linear{transition-timing-function:linear}
@keyframes enter{from{opacity:var(--tw-enter-opacity, 1);transform:translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0))}}
@keyframes exit{to{opacity:var(--tw-exit-opacity, 1);transform:translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0))}}
.tw-animate-in{animation-name:enter;animation-duration:150ms;--tw-enter-opacity:initial;--tw-enter-scale:initial;--tw-enter-rotate:initial;--tw-enter-translate-x:initial;--tw-enter-translate-y:initial}
.tw-fade-in-0{--tw-enter-opacity:0}
.tw-fade-in-80{--tw-enter-opacity:0.8}
.tw-zoom-in-95{--tw-enter-scale:.95}
.tw-duration-1000{animation-duration:1000ms}
.tw-duration-200{animation-duration:200ms}
.tw-ease-in-out{animation-timing-function:cubic-bezier(0.4, 0, 0.2, 1)}
.tw-ease-linear{animation-timing-function:linear}

.disable-pointer {
    pointer-events: none;
    opacity: 0.7;
}

:focus {
    outline: none;
}

a, a.link {
    color: #8BC53F;
}

a.link {
    text-decoration: underline;
}

a:hover, a.link:hover {
    color: #688715;
}

.file\\:tw-border-0::file-selector-button{border-width:0px}

.file\\:tw-bg-transparent::file-selector-button{background-color:transparent}

.file\\:tw-text-sm::file-selector-button{font-size:0.875rem;line-height:1.25rem}

.file\\:tw-font-medium::file-selector-button{font-weight:500}

.file\\:tw-text-foreground::file-selector-button{color:hsl(var(--foreground))}

.placeholder\\:tw-text-muted-foreground::-moz-placeholder{color:hsl(var(--muted-foreground))}

.placeholder\\:tw-text-muted-foreground::placeholder{color:hsl(var(--muted-foreground))}

.after\\:tw-absolute::after{content:var(--tw-content);position:absolute}

.after\\:tw--inset-2::after{content:var(--tw-content);inset:-0.5rem}

.after\\:tw-inset-y-0::after{content:var(--tw-content);top:0px;bottom:0px}

.after\\:tw-left-1\\/2::after{content:var(--tw-content);left:50%}

.after\\:tw-w-1::after{content:var(--tw-content);width:0.25rem}

.after\\:tw-w-\\[2px\\]::after{content:var(--tw-content);width:2px}

.after\\:tw--translate-x-1\\/2::after{content:var(--tw-content);--tw-translate-x:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.first\\:tw-mt-0:first-child{margin-top:0px}

.first\\:tw-rounded-l-md:first-child{border-top-left-radius:calc(var(--radius) - 2px);border-bottom-left-radius:calc(var(--radius) - 2px)}

.first\\:tw-border-l:first-child{border-left-width:1px}

.last\\:tw-mb-0:last-child{margin-bottom:0px}

.last\\:tw-rounded-r-md:last-child{border-top-right-radius:calc(var(--radius) - 2px);border-bottom-right-radius:calc(var(--radius) - 2px)}

.last\\:tw-border-r-0:last-child{border-right-width:0px}

.even\\:tw-bg-grey-bg:nth-child(even){background-color:hsl(var(--grey-bg))}

.focus-within\\:tw-relative:focus-within{position:relative}

.focus-within\\:tw-z-20:focus-within{z-index:20}

.hover\\:tw-border-gray-300:hover{--tw-border-opacity:1;border-color:rgb(209 213 219 / var(--tw-border-opacity, 1))}

.hover\\:tw-border-primary:hover{border-color:rgb(var(--primary))}

.hover\\:tw-bg-accent:hover{background-color:hsl(var(--accent))}

.hover\\:tw-bg-accent\\/80:hover{background-color:hsl(var(--accent) / 0.8)}

.hover\\:tw-bg-destructive:hover{background-color:hsl(var(--destructive))}

.hover\\:tw-bg-destructive\\/10:hover{background-color:hsl(var(--destructive) / 0.1)}

.hover\\:tw-bg-destructive\\/80:hover{background-color:hsl(var(--destructive) / 0.8)}

.hover\\:tw-bg-destructive\\/90:hover{background-color:hsl(var(--destructive) / 0.9)}

.hover\\:tw-bg-gray-200:hover{--tw-bg-opacity:1;background-color:rgb(229 231 235 / var(--tw-bg-opacity, 1))}

.hover\\:tw-bg-grey-bg:hover{background-color:hsl(var(--grey-bg))}

.hover\\:tw-bg-info-foreground:hover{background-color:hsl(var(--info-foreground))}

.hover\\:tw-bg-muted:hover{background-color:hsl(var(--muted))}

.hover\\:tw-bg-muted\\/50:hover{background-color:hsl(var(--muted) / 0.5)}

.hover\\:tw-bg-primary:hover{background-color:rgb(var(--primary))}

.hover\\:tw-bg-primary\\/80:hover{background-color:rgb(var(--primary) / 0.8)}

.hover\\:tw-bg-primary\\/90:hover{background-color:rgb(var(--primary) / 0.9)}

.hover\\:tw-bg-secondary:hover{background-color:rgb(var(--secondary))}

.hover\\:tw-bg-secondary\\/80:hover{background-color:rgb(var(--secondary) / 0.8)}

.hover\\:tw-bg-sidebar-accent:hover{background-color:hsl(var(--sidebar-accent))}

.hover\\:tw-bg-transparent:hover{background-color:transparent}

.hover\\:tw-bg-white\\/90:hover{background-color:rgb(255 255 255 / 0.9)}

.hover\\:tw-text-accent-foreground:hover{color:hsl(var(--accent-foreground))}

.hover\\:tw-text-destructive:hover{color:hsl(var(--destructive))}

.hover\\:tw-text-destructive-foreground:hover{color:hsl(var(--destructive-foreground))}

.hover\\:tw-text-foreground:hover{color:hsl(var(--foreground))}

.hover\\:tw-text-gray-500:hover{--tw-text-opacity:1;color:rgb(107 114 128 / var(--tw-text-opacity, 1))}

.hover\\:tw-text-gray-700:hover{--tw-text-opacity:1;color:rgb(55 65 81 / var(--tw-text-opacity, 1))}

.hover\\:tw-text-gray-900:hover{--tw-text-opacity:1;color:rgb(17 24 39 / var(--tw-text-opacity, 1))}

.hover\\:tw-text-grey-dark:hover{color:hsl(var(--grey-dark))}

.hover\\:tw-text-muted-foreground:hover{color:hsl(var(--muted-foreground))}

.hover\\:tw-text-primary:hover{color:rgb(var(--primary))}

.hover\\:tw-text-primary-foreground:hover{color:hsl(var(--primary-foreground))}

.hover\\:tw-text-secondary:hover{color:rgb(var(--secondary))}

.hover\\:tw-text-sidebar-accent-foreground:hover{color:hsl(var(--sidebar-accent-foreground))}

.hover\\:tw-text-white:hover{--tw-text-opacity:1;color:rgb(255 255 255 / var(--tw-text-opacity, 1))}

.hover\\:tw-underline:hover{text-decoration-line:underline}

.hover\\:tw-no-underline:hover{text-decoration-line:none}

.hover\\:tw-opacity-100:hover{opacity:1}

.hover\\:tw-opacity-90:hover{opacity:0.9}

.hover\\:tw-shadow-\\[0_0_0_1px_hsl\\(var\\(--sidebar-accent\\)\\)\\]:hover{--tw-shadow:0 0 0 1px hsl(var(--sidebar-accent));--tw-shadow-colored:0 0 0 1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}

.hover\\:after\\:tw-bg-sidebar-border:hover::after{content:var(--tw-content);background-color:hsl(var(--sidebar-border))}

.focus\\:\\!tw-border:focus{border-width:1px !important}

.focus\\:tw-border:focus{border-width:1px}

.focus\\:\\!tw-border-slate-400:focus{--tw-border-opacity:1 !important;border-color:rgb(148 163 184 / var(--tw-border-opacity, 1)) !important}

.focus\\:tw-border-input:focus{border-color:hsl(var(--input))}

.focus\\:tw-border-primary:focus{border-color:rgb(var(--primary))}

.focus\\:tw-border-slate-400:focus{--tw-border-opacity:1;border-color:rgb(148 163 184 / var(--tw-border-opacity, 1))}

.focus\\:tw-bg-accent:focus{background-color:hsl(var(--accent))}

.focus\\:tw-bg-primary:focus{background-color:rgb(var(--primary))}

.focus\\:\\!tw-py-2:focus{padding-top:0.5rem !important;padding-bottom:0.5rem !important}

.focus\\:\\!tw-pl-3:focus{padding-left:0.75rem !important}

.focus\\:\\!tw-pr-10:focus{padding-right:2.5rem !important}

.focus\\:tw-text-accent-foreground:focus{color:hsl(var(--accent-foreground))}

.focus\\:tw-text-primary-foreground:focus{color:hsl(var(--primary-foreground))}

.focus\\:tw-opacity-100:focus{opacity:1}

.focus\\:tw-outline-none:focus{outline:2px solid transparent;outline-offset:2px}

.focus\\:\\!tw-ring-0:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important}

.focus\\:tw-ring-2:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)}

.focus\\:tw-ring-ring:focus{--tw-ring-color:hsl(var(--ring))}

.focus\\:\\!tw-ring-offset-0:focus{--tw-ring-offset-width:0px !important}

.focus\\:tw-ring-offset-2:focus{--tw-ring-offset-width:2px}

.focus-visible\\:tw-border-slate-400:focus-visible{--tw-border-opacity:1;border-color:rgb(148 163 184 / var(--tw-border-opacity, 1))}

.focus-visible\\:tw-outline-none:focus-visible{outline:2px solid transparent;outline-offset:2px}

.focus-visible\\:\\!tw-ring-0:focus-visible{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important}

.focus-visible\\:tw-ring-0:focus-visible{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)}

.focus-visible\\:tw-ring-1:focus-visible{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)}

.focus-visible\\:tw-ring-2:focus-visible{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)}

.focus-visible\\:tw-ring-ring:focus-visible{--tw-ring-color:hsl(var(--ring))}

.focus-visible\\:tw-ring-sidebar-ring:focus-visible{--tw-ring-color:hsl(var(--sidebar-ring))}

.focus-visible\\:\\!tw-ring-offset-0:focus-visible{--tw-ring-offset-width:0px !important}

.focus-visible\\:tw-ring-offset-0:focus-visible{--tw-ring-offset-width:0px}

.focus-visible\\:tw-ring-offset-1:focus-visible{--tw-ring-offset-width:1px}

.focus-visible\\:tw-ring-offset-2:focus-visible{--tw-ring-offset-width:2px}

.focus-visible\\:tw-ring-offset-background:focus-visible{--tw-ring-offset-color:hsl(var(--background))}

.active\\:tw-bg-sidebar-accent:active{background-color:hsl(var(--sidebar-accent))}

.active\\:tw-text-sidebar-accent-foreground:active{color:hsl(var(--sidebar-accent-foreground))}

.disabled\\:tw-pointer-events-none:disabled{pointer-events:none}

.disabled\\:tw-cursor-not-allowed:disabled{cursor:not-allowed}

.disabled\\:tw-opacity-40:disabled{opacity:0.4}

.disabled\\:tw-opacity-50:disabled{opacity:0.5}

.tw-group:hover .group-hover\\:tw-opacity-100{opacity:1}

.tw-group.destructive .group-\\[\\.destructive\\]\\:tw-border-muted\\/40{border-color:hsl(var(--muted) / 0.4)}

.tw-group.destructive .group-\\[\\.destructive\\]\\:tw-text-red-300{--tw-text-opacity:1;color:rgb(252 165 165 / var(--tw-text-opacity, 1))}

.tw-group.destructive .group-\\[\\.destructive\\]\\:hover\\:tw-border-destructive\\/30:hover{border-color:hsl(var(--destructive) / 0.3)}

.tw-group.destructive .group-\\[\\.destructive\\]\\:hover\\:tw-bg-destructive:hover{background-color:hsl(var(--destructive))}

.tw-group.destructive .group-\\[\\.destructive\\]\\:hover\\:tw-text-destructive-foreground:hover{color:hsl(var(--destructive-foreground))}

.tw-group.destructive .group-\\[\\.destructive\\]\\:hover\\:tw-text-red-50:hover{--tw-text-opacity:1;color:rgb(254 242 242 / var(--tw-text-opacity, 1))}

.tw-group.destructive .group-\\[\\.destructive\\]\\:focus\\:tw-ring-destructive:focus{--tw-ring-color:hsl(var(--destructive))}

.tw-group.destructive .group-\\[\\.destructive\\]\\:focus\\:tw-ring-red-400:focus{--tw-ring-opacity:1;--tw-ring-color:rgb(248 113 113 / var(--tw-ring-opacity, 1))}

.tw-group.destructive .group-\\[\\.destructive\\]\\:focus\\:tw-ring-offset-red-600:focus{--tw-ring-offset-color:#dc2626}

.tw-peer:disabled ~ .peer-disabled\\:tw-cursor-not-allowed{cursor:not-allowed}

.tw-peer:disabled ~ .peer-disabled\\:tw-opacity-70{opacity:0.7}

.has-\\[\\[data-variant\\=inset\\]\\]\\:tw-bg-sidebar:has([data-variant=inset]){background-color:hsl(var(--sidebar-background))}

.aria-disabled\\:tw-pointer-events-none[aria-disabled="true"]{pointer-events:none}

.aria-disabled\\:tw-opacity-50[aria-disabled="true"]{opacity:0.5}

.aria-selected\\:tw-bg-accent[aria-selected="true"]{background-color:hsl(var(--accent))}

.aria-selected\\:tw-bg-accent\\/50[aria-selected="true"]{background-color:hsl(var(--accent) / 0.5)}

.aria-selected\\:tw-text-accent-foreground[aria-selected="true"]{color:hsl(var(--accent-foreground))}

.aria-selected\\:tw-text-muted-foreground[aria-selected="true"]{color:hsl(var(--muted-foreground))}

.aria-selected\\:tw-opacity-100[aria-selected="true"]{opacity:1}

.aria-selected\\:tw-opacity-30[aria-selected="true"]{opacity:0.3}

.data-\\[disabled\\=true\\]\\:tw-pointer-events-none[data-disabled="true"]{pointer-events:none}

.data-\\[disabled\\]\\:tw-pointer-events-none[data-disabled]{pointer-events:none}

.data-\\[panel-group-direction\\=vertical\\]\\:tw-h-px[data-panel-group-direction="vertical"]{height:1px}

.data-\\[panel-group-direction\\=vertical\\]\\:tw-w-full[data-panel-group-direction="vertical"]{width:100%}

.data-\\[side\\=bottom\\]\\:tw-translate-y-1[data-side="bottom"]{--tw-translate-y:0.25rem;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.data-\\[side\\=left\\]\\:tw--translate-x-1[data-side="left"]{--tw-translate-x:-0.25rem;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.data-\\[side\\=right\\]\\:tw-translate-x-1[data-side="right"]{--tw-translate-x:0.25rem;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.data-\\[side\\=top\\]\\:tw--translate-y-1[data-side="top"]{--tw-translate-y:-0.25rem;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.data-\\[state\\=checked\\]\\:tw-translate-x-5[data-state="checked"]{--tw-translate-x:1.25rem;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.data-\\[state\\=unchecked\\]\\:tw-translate-x-0[data-state="unchecked"]{--tw-translate-x:0px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.data-\\[swipe\\=cancel\\]\\:tw-translate-x-0[data-swipe="cancel"]{--tw-translate-x:0px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.data-\\[swipe\\=end\\]\\:tw-translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{--tw-translate-x:var(--radix-toast-swipe-end-x);transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.data-\\[swipe\\=move\\]\\:tw-translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{--tw-translate-x:var(--radix-toast-swipe-move-x);transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

@keyframes tw-accordion-up{from{height:var(--radix-accordion-content-height)}to{height:0}}

.data-\\[state\\=closed\\]\\:tw-animate-accordion-up[data-state="closed"]{animation:tw-accordion-up 0.2s ease-out}

@keyframes tw-accordion-down{from{height:0}to{height:var(--radix-accordion-content-height)}}

.data-\\[state\\=open\\]\\:tw-animate-accordion-down[data-state="open"]{animation:tw-accordion-down 0.2s ease-out}

.data-\\[panel-group-direction\\=vertical\\]\\:tw-flex-col[data-panel-group-direction="vertical"]{flex-direction:column}

.data-\\[state\\=open\\]\\:tw-border-slate-400[data-state="open"]{--tw-border-opacity:1;border-color:rgb(148 163 184 / var(--tw-border-opacity, 1))}

.data-\\[active\\=true\\]\\:tw-bg-sidebar-accent[data-active="true"]{background-color:hsl(var(--sidebar-accent))}

.data-\\[active\\]\\:tw-bg-accent\\/50[data-active]{background-color:hsl(var(--accent) / 0.5)}

.data-\\[selected\\=true\\]\\:tw-bg-accent[data-selected="true"]{background-color:hsl(var(--accent))}

.data-\\[state\\=active\\]\\:tw-bg-background[data-state="active"]{background-color:hsl(var(--background))}

.data-\\[state\\=checked\\]\\:tw-bg-destructive[data-state="checked"]{background-color:hsl(var(--destructive))}

.data-\\[state\\=checked\\]\\:tw-bg-green-600[data-state="checked"]{--tw-bg-opacity:1;background-color:rgb(22 163 74 / var(--tw-bg-opacity, 1))}

.data-\\[state\\=checked\\]\\:tw-bg-primary[data-state="checked"]{background-color:rgb(var(--primary))}

.data-\\[state\\=checked\\]\\:tw-bg-secondary[data-state="checked"]{background-color:rgb(var(--secondary))}

.data-\\[state\\=on\\]\\:tw-bg-accent[data-state="on"]{background-color:hsl(var(--accent))}

.data-\\[state\\=open\\]\\:tw-bg-accent[data-state="open"]{background-color:hsl(var(--accent))}

.data-\\[state\\=open\\]\\:tw-bg-accent\\/50[data-state="open"]{background-color:hsl(var(--accent) / 0.5)}

.data-\\[state\\=open\\]\\:tw-bg-secondary[data-state="open"]{background-color:rgb(var(--secondary))}

.data-\\[state\\=selected\\]\\:tw-bg-muted[data-state="selected"]{background-color:hsl(var(--muted))}

.data-\\[state\\=unchecked\\]\\:tw-bg-input[data-state="unchecked"]{background-color:hsl(var(--input))}

.data-\\[active\\=true\\]\\:tw-font-medium[data-active="true"]{font-weight:500}

.data-\\[active\\=true\\]\\:tw-text-sidebar-accent-foreground[data-active="true"]{color:hsl(var(--sidebar-accent-foreground))}

.data-\\[selected\\=true\\]\\:tw-text-accent-foreground[data-selected="true"]{color:hsl(var(--accent-foreground))}

.data-\\[state\\=active\\]\\:tw-text-foreground[data-state="active"]{color:hsl(var(--foreground))}

.data-\\[state\\=checked\\]\\:tw-text-primary-foreground[data-state="checked"]{color:hsl(var(--primary-foreground))}

.data-\\[state\\=on\\]\\:tw-text-accent-foreground[data-state="on"]{color:hsl(var(--accent-foreground))}

.data-\\[state\\=open\\]\\:tw-text-accent-foreground[data-state="open"]{color:hsl(var(--accent-foreground))}

.data-\\[state\\=open\\]\\:tw-text-muted-foreground[data-state="open"]{color:hsl(var(--muted-foreground))}

.data-\\[disabled\\=true\\]\\:tw-opacity-50[data-disabled="true"]{opacity:0.5}

.data-\\[disabled\\]\\:tw-opacity-50[data-disabled]{opacity:0.5}

.data-\\[state\\=open\\]\\:tw-opacity-100[data-state="open"]{opacity:1}

.data-\\[state\\=active\\]\\:tw-shadow-sm[data-state="active"]{--tw-shadow:0 1px 2px 0 rgb(0 0 0 / 0.05);--tw-shadow-colored:0 1px 2px 0 var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}

.data-\\[state\\=open\\]\\:\\!tw-ring-0[data-state="open"]{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;box-shadow:var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important}

.data-\\[state\\=open\\]\\:\\!tw-ring-offset-0[data-state="open"]{--tw-ring-offset-width:0px !important}

.data-\\[swipe\\=move\\]\\:tw-transition-none[data-swipe="move"]{transition-property:none}

.data-\\[state\\=closed\\]\\:tw-duration-300[data-state="closed"]{transition-duration:300ms}

.data-\\[state\\=open\\]\\:tw-duration-500[data-state="open"]{transition-duration:500ms}

.data-\\[motion\\^\\=from-\\]\\:tw-animate-in[data-motion^="from-"]{animation-name:enter;animation-duration:150ms;--tw-enter-opacity:initial;--tw-enter-scale:initial;--tw-enter-rotate:initial;--tw-enter-translate-x:initial;--tw-enter-translate-y:initial}

.data-\\[state\\=open\\]\\:tw-animate-in[data-state="open"]{animation-name:enter;animation-duration:150ms;--tw-enter-opacity:initial;--tw-enter-scale:initial;--tw-enter-rotate:initial;--tw-enter-translate-x:initial;--tw-enter-translate-y:initial}

.data-\\[state\\=visible\\]\\:tw-animate-in[data-state="visible"]{animation-name:enter;animation-duration:150ms;--tw-enter-opacity:initial;--tw-enter-scale:initial;--tw-enter-rotate:initial;--tw-enter-translate-x:initial;--tw-enter-translate-y:initial}

.data-\\[motion\\^\\=to-\\]\\:tw-animate-out[data-motion^="to-"]{animation-name:exit;animation-duration:150ms;--tw-exit-opacity:initial;--tw-exit-scale:initial;--tw-exit-rotate:initial;--tw-exit-translate-x:initial;--tw-exit-translate-y:initial}

.data-\\[state\\=closed\\]\\:tw-animate-out[data-state="closed"]{animation-name:exit;animation-duration:150ms;--tw-exit-opacity:initial;--tw-exit-scale:initial;--tw-exit-rotate:initial;--tw-exit-translate-x:initial;--tw-exit-translate-y:initial}

.data-\\[state\\=hidden\\]\\:tw-animate-out[data-state="hidden"]{animation-name:exit;animation-duration:150ms;--tw-exit-opacity:initial;--tw-exit-scale:initial;--tw-exit-rotate:initial;--tw-exit-translate-x:initial;--tw-exit-translate-y:initial}

.data-\\[swipe\\=end\\]\\:tw-animate-out[data-swipe="end"]{animation-name:exit;animation-duration:150ms;--tw-exit-opacity:initial;--tw-exit-scale:initial;--tw-exit-rotate:initial;--tw-exit-translate-x:initial;--tw-exit-translate-y:initial}

.data-\\[motion\\^\\=from-\\]\\:tw-fade-in[data-motion^="from-"]{--tw-enter-opacity:0}

.data-\\[motion\\^\\=to-\\]\\:tw-fade-out[data-motion^="to-"]{--tw-exit-opacity:0}

.data-\\[state\\=closed\\]\\:tw-fade-out-0[data-state="closed"]{--tw-exit-opacity:0}

.data-\\[state\\=closed\\]\\:tw-fade-out-80[data-state="closed"]{--tw-exit-opacity:0.8}

.data-\\[state\\=hidden\\]\\:tw-fade-out[data-state="hidden"]{--tw-exit-opacity:0}

.data-\\[state\\=open\\]\\:tw-fade-in-0[data-state="open"]{--tw-enter-opacity:0}

.data-\\[state\\=visible\\]\\:tw-fade-in[data-state="visible"]{--tw-enter-opacity:0}

.data-\\[state\\=closed\\]\\:tw-zoom-out-95[data-state="closed"]{--tw-exit-scale:.95}

.data-\\[state\\=open\\]\\:tw-zoom-in-90[data-state="open"]{--tw-enter-scale:.9}

.data-\\[state\\=open\\]\\:tw-zoom-in-95[data-state="open"]{--tw-enter-scale:.95}

.data-\\[motion\\=from-end\\]\\:tw-slide-in-from-right-52[data-motion="from-end"]{--tw-enter-translate-x:13rem}

.data-\\[motion\\=from-start\\]\\:tw-slide-in-from-left-52[data-motion="from-start"]{--tw-enter-translate-x:-13rem}

.data-\\[motion\\=to-end\\]\\:tw-slide-out-to-right-52[data-motion="to-end"]{--tw-exit-translate-x:13rem}

.data-\\[motion\\=to-start\\]\\:tw-slide-out-to-left-52[data-motion="to-start"]{--tw-exit-translate-x:-13rem}

.data-\\[side\\=bottom\\]\\:tw-slide-in-from-top-2[data-side="bottom"]{--tw-enter-translate-y:-0.5rem}

.data-\\[side\\=left\\]\\:tw-slide-in-from-right-2[data-side="left"]{--tw-enter-translate-x:0.5rem}

.data-\\[side\\=right\\]\\:tw-slide-in-from-left-2[data-side="right"]{--tw-enter-translate-x:-0.5rem}

.data-\\[side\\=top\\]\\:tw-slide-in-from-bottom-2[data-side="top"]{--tw-enter-translate-y:0.5rem}

.data-\\[state\\=closed\\]\\:tw-slide-out-to-bottom[data-state="closed"]{--tw-exit-translate-y:100%}

.data-\\[state\\=closed\\]\\:tw-slide-out-to-left[data-state="closed"]{--tw-exit-translate-x:-100%}

.data-\\[state\\=closed\\]\\:tw-slide-out-to-left-1\\/2[data-state="closed"]{--tw-exit-translate-x:-50%}

.data-\\[state\\=closed\\]\\:tw-slide-out-to-right[data-state="closed"]{--tw-exit-translate-x:100%}

.data-\\[state\\=closed\\]\\:tw-slide-out-to-right-full[data-state="closed"]{--tw-exit-translate-x:100%}

.data-\\[state\\=closed\\]\\:tw-slide-out-to-top[data-state="closed"]{--tw-exit-translate-y:-100%}

.data-\\[state\\=closed\\]\\:tw-slide-out-to-top-\\[48\\%\\][data-state="closed"]{--tw-exit-translate-y:-48%}

.data-\\[state\\=open\\]\\:tw-slide-in-from-bottom[data-state="open"]{--tw-enter-translate-y:100%}

.data-\\[state\\=open\\]\\:tw-slide-in-from-left[data-state="open"]{--tw-enter-translate-x:-100%}

.data-\\[state\\=open\\]\\:tw-slide-in-from-left-1\\/2[data-state="open"]{--tw-enter-translate-x:-50%}

.data-\\[state\\=open\\]\\:tw-slide-in-from-right[data-state="open"]{--tw-enter-translate-x:100%}

.data-\\[state\\=open\\]\\:tw-slide-in-from-top[data-state="open"]{--tw-enter-translate-y:-100%}

.data-\\[state\\=open\\]\\:tw-slide-in-from-top-\\[48\\%\\][data-state="open"]{--tw-enter-translate-y:-48%}

.data-\\[state\\=open\\]\\:tw-slide-in-from-top-full[data-state="open"]{--tw-enter-translate-y:-100%}

.data-\\[state\\=closed\\]\\:tw-duration-300[data-state="closed"]{animation-duration:300ms}

.data-\\[state\\=open\\]\\:tw-duration-500[data-state="open"]{animation-duration:500ms}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:tw-left-0[data-panel-group-direction="vertical"]::after{content:var(--tw-content);left:0px}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:tw-h-1[data-panel-group-direction="vertical"]::after{content:var(--tw-content);height:0.25rem}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:tw-w-full[data-panel-group-direction="vertical"]::after{content:var(--tw-content);width:100%}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:tw--translate-y-1\\/2[data-panel-group-direction="vertical"]::after{content:var(--tw-content);--tw-translate-y:-50%;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.data-\\[panel-group-direction\\=vertical\\]\\:after\\:tw-translate-x-0[data-panel-group-direction="vertical"]::after{content:var(--tw-content);--tw-translate-x:0px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.data-\\[state\\=open\\]\\:hover\\:tw-bg-sidebar-accent:hover[data-state="open"]{background-color:hsl(var(--sidebar-accent))}

.data-\\[state\\=open\\]\\:hover\\:tw-text-sidebar-accent-foreground:hover[data-state="open"]{color:hsl(var(--sidebar-accent-foreground))}

.tw-group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:tw-left-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\]{left:calc(var(--sidebar-width) * -1)}

.tw-group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:tw-right-\\[calc\\(var\\(--sidebar-width\\)\\*-1\\)\\]{right:calc(var(--sidebar-width) * -1)}

.tw-group[data-side="left"] .group-data-\\[side\\=left\\]\\:tw--right-4{right:-1rem}

.tw-group[data-side="right"] .group-data-\\[side\\=right\\]\\:tw-left-0{left:0px}

.tw-group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:tw--mt-8{margin-top:-2rem}

.tw-group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:tw-hidden{display:none}

.tw-group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:tw-w-\\[--sidebar-width-icon\\]{width:var(--sidebar-width-icon)}

.tw-group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:tw-w-\\[calc\\(var\\(--sidebar-width-icon\\)_\\+_theme\\(spacing\\.4\\)\\)\\]{width:calc(var(--sidebar-width-icon) + 1rem)}

.tw-group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:tw-w-\\[calc\\(var\\(--sidebar-width-icon\\)_\\+_theme\\(spacing\\.4\\)_\\+2px\\)\\]{width:calc(var(--sidebar-width-icon) + 1rem + 2px)}

.tw-group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:tw-w-0{width:0px}

.tw-group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:tw-translate-x-0{--tw-translate-x:0px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.tw-group[data-side="right"] .group-data-\\[side\\=right\\]\\:tw-rotate-180{--tw-rotate:180deg;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.tw-group[data-state="open"] .group-data-\\[state\\=open\\]\\:tw-rotate-180{--tw-rotate:180deg;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.tw-group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:tw-overflow-hidden{overflow:hidden}

.tw-group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:tw-rounded-lg{border-radius:var(--radius)}

.tw-group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:tw-border{border-width:1px}

.tw-group[data-side="left"] .group-data-\\[side\\=left\\]\\:tw-border-r{border-right-width:1px}

.tw-group[data-side="right"] .group-data-\\[side\\=right\\]\\:tw-border-l{border-left-width:1px}

.tw-group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:tw-border-sidebar-border{border-color:hsl(var(--sidebar-border))}

.tw-group[data-collapsible="icon"] .group-data-\\[collapsible\\=icon\\]\\:tw-opacity-0{opacity:0}

.tw-group[data-variant="floating"] .group-data-\\[variant\\=floating\\]\\:tw-shadow{--tw-shadow:0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);--tw-shadow-colored:0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}

.tw-group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:after\\:tw-left-full::after{content:var(--tw-content);left:100%}

.tw-group[data-collapsible="offcanvas"] .group-data-\\[collapsible\\=offcanvas\\]\\:hover\\:tw-bg-sidebar:hover{background-color:hsl(var(--sidebar-background))}

.tw-peer[data-variant="inset"] ~ .peer-data-\\[variant\\=inset\\]\\:tw-min-h-\\[calc\\(100svh-theme\\(spacing\\.4\\)\\)\\]{min-height:calc(100svh - 1rem)}

.dark\\:tw-border-amber-400:is(.tw-dark *){--tw-border-opacity:1;border-color:rgb(251 191 36 / var(--tw-border-opacity, 1))}

.dark\\:tw-border-destructive:is(.tw-dark *){border-color:hsl(var(--destructive))}

.dark\\:tw-border-info-foreground:is(.tw-dark *){border-color:hsl(var(--info-foreground))}

.dark\\:tw-border-secondary:is(.tw-dark *){border-color:rgb(var(--secondary))}

.dark\\:tw-bg-gray-800:is(.tw-dark *){--tw-bg-opacity:1;background-color:rgb(31 41 55 / var(--tw-bg-opacity, 1))}

@media (min-width: 640px){.sm\\:tw-bottom-0{bottom:0px}.sm\\:tw-right-0{right:0px}.sm\\:tw-top-auto{top:auto}.sm\\:tw-mt-0{margin-top:0px}.sm\\:tw-flex{display:flex}.sm\\:tw-max-w-sm{max-width:24rem}.sm\\:tw-flex-row{flex-direction:row}.sm\\:tw-flex-col{flex-direction:column}.sm\\:tw-justify-end{justify-content:flex-end}.sm\\:tw-gap-2\\.5{gap:0.625rem}.sm\\:tw-space-x-2 > :not([hidden]) ~ :not([hidden]){--tw-space-x-reverse:0;margin-right:calc(0.5rem * var(--tw-space-x-reverse));margin-left:calc(0.5rem * calc(1 - var(--tw-space-x-reverse)))}.sm\\:tw-space-x-4 > :not([hidden]) ~ :not([hidden]){--tw-space-x-reverse:0;margin-right:calc(1rem * var(--tw-space-x-reverse));margin-left:calc(1rem * calc(1 - var(--tw-space-x-reverse)))}.sm\\:tw-space-y-0 > :not([hidden]) ~ :not([hidden]){--tw-space-y-reverse:0;margin-top:calc(0px * calc(1 - var(--tw-space-y-reverse)));margin-bottom:calc(0px * var(--tw-space-y-reverse))}.sm\\:tw-rounded-lg{border-radius:var(--radius)}.sm\\:tw-pr-0{padding-right:0px}.sm\\:tw-text-left{text-align:left}.data-\\[state\\=open\\]\\:sm\\:tw-slide-in-from-bottom-full[data-state="open"]{--tw-enter-translate-y:100%}}

@media (min-width: 768px){.md\\:tw-absolute{position:absolute}.md\\:tw-block{display:block}.md\\:tw-flex{display:flex}.md\\:tw-w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{width:var(--radix-navigation-menu-viewport-width)}.md\\:tw-w-auto{width:auto}.md\\:tw-max-w-\\[420px\\]{max-width:420px}.md\\:\\!tw-basis-1\\/2{flex-basis:50% !important}.md\\:tw-grid-cols-2{grid-template-columns:repeat(2, minmax(0, 1fr))}.md\\:tw-flex-row{flex-direction:row}.md\\:tw-opacity-0{opacity:0}.after\\:md\\:tw-hidden::after{content:var(--tw-content);display:none}.tw-peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:tw-m-2{margin:0.5rem}.tw-peer[data-state="collapsed"][data-variant="inset"] ~ .md\\:peer-data-\\[state\\=collapsed\\]\\:peer-data-\\[variant\\=inset\\]\\:tw-ml-2{margin-left:0.5rem}.tw-peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:tw-ml-0{margin-left:0px}.tw-peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:tw-rounded-xl{border-radius:0.75rem}.tw-peer[data-variant="inset"] ~ .md\\:peer-data-\\[variant\\=inset\\]\\:tw-shadow{--tw-shadow:0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);--tw-shadow-colored:0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)}}

@media (min-width: 1024px){.lg\\:tw-block{display:block}.lg\\:tw-hidden{display:none}.lg\\:\\!tw-basis-1\\/3{flex-basis:33.333333% !important}.lg\\:tw-grid-cols-2{grid-template-columns:repeat(2, minmax(0, 1fr))}.lg\\:tw-grid-cols-3{grid-template-columns:repeat(3, minmax(0, 1fr))}.lg\\:tw-grid-cols-4{grid-template-columns:repeat(4, minmax(0, 1fr))}.lg\\:tw-flex-row{flex-direction:row}.lg\\:tw-p-10{padding:2.5rem}.lg\\:tw-text-5xl{font-size:3rem;line-height:1}}

@media (min-width: 1280px){.xl\\:tw-w-80{width:20rem}.xl\\:tw-grid-cols-4{grid-template-columns:repeat(4, minmax(0, 1fr))}.xl\\:tw-text-6xl{font-size:3.75rem;line-height:1}}

@media (min-width: 1536px){.\\32xl\\:tw-w-\\[28rem\\]{width:28rem}.\\32xl\\:tw-max-w-md{max-width:28rem}.\\32xl\\:tw-px-20{padding-left:5rem;padding-right:5rem}.\\32xl\\:tw-text-7xl{font-size:4.5rem;line-height:1}}

.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:tw-bg-accent:has([aria-selected]){background-color:hsl(var(--accent))}

.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:tw-rounded-l-md:has([aria-selected]):first-child{border-top-left-radius:calc(var(--radius) - 2px);border-bottom-left-radius:calc(var(--radius) - 2px)}

.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:tw-rounded-r-md:has([aria-selected]):last-child{border-top-right-radius:calc(var(--radius) - 2px);border-bottom-right-radius:calc(var(--radius) - 2px)}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:tw-bg-accent\\/50:has([aria-selected].day-outside){background-color:hsl(var(--accent) / 0.5)}

.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:tw-rounded-r-md:has([aria-selected].day-range-end){border-top-right-radius:calc(var(--radius) - 2px);border-bottom-right-radius:calc(var(--radius) - 2px)}

.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:tw-pr-0:has([role=checkbox]){padding-right:0px}

.\\[\\&\\>button\\]\\:tw-hidden>button{display:none}

.\\[\\&\\>h5\\]\\:tw-text-amber-800>h5{--tw-text-opacity:1;color:rgb(146 64 14 / var(--tw-text-opacity, 1))}

.\\[\\&\\>h5\\]\\:tw-text-destructive>h5{color:hsl(var(--destructive))}

.\\[\\&\\>h5\\]\\:tw-text-info-foreground>h5{color:hsl(var(--info-foreground))}

.\\[\\&\\>h5\\]\\:tw-text-secondary>h5{color:rgb(var(--secondary))}

.\\[\\&\\>span\\:last-child\\]\\:tw-truncate>span:last-child{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}

.\\[\\&\\>span\\]\\:tw-line-clamp-1>span{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1}

.\\[\\&\\>svg\\+div\\]\\:tw-translate-y-\\[-3px\\]>svg+div{--tw-translate-y:-3px;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.\\[\\&\\>svg\\]\\:tw-absolute>svg{position:absolute}

.\\[\\&\\>svg\\]\\:tw-left-4>svg{left:1rem}

.\\[\\&\\>svg\\]\\:tw-top-4>svg{top:1rem}

.\\[\\&\\>svg\\]\\:tw-size-4>svg{width:1rem;height:1rem}

.\\[\\&\\>svg\\]\\:tw-h-2\\.5>svg{height:0.625rem}

.\\[\\&\\>svg\\]\\:tw-h-3>svg{height:0.75rem}

.\\[\\&\\>svg\\]\\:tw-h-3\\.5>svg{height:0.875rem}

.\\[\\&\\>svg\\]\\:tw-w-2\\.5>svg{width:0.625rem}

.\\[\\&\\>svg\\]\\:tw-w-3>svg{width:0.75rem}

.\\[\\&\\>svg\\]\\:tw-w-3\\.5>svg{width:0.875rem}

.\\[\\&\\>svg\\]\\:tw-shrink-0>svg{flex-shrink:0}

.\\[\\&\\>svg\\]\\:tw-text-amber-800>svg{--tw-text-opacity:1;color:rgb(146 64 14 / var(--tw-text-opacity, 1))}

.\\[\\&\\>svg\\]\\:tw-text-destructive>svg{color:hsl(var(--destructive))}

.\\[\\&\\>svg\\]\\:tw-text-foreground>svg{color:hsl(var(--foreground))}

.\\[\\&\\>svg\\]\\:tw-text-grey-dark>svg{color:hsl(var(--grey-dark))}

.\\[\\&\\>svg\\]\\:tw-text-info-foreground>svg{color:hsl(var(--info-foreground))}

.\\[\\&\\>svg\\]\\:tw-text-muted-foreground>svg{color:hsl(var(--muted-foreground))}

.\\[\\&\\>svg\\]\\:tw-text-secondary>svg{color:rgb(var(--secondary))}

.\\[\\&\\>svg\\]\\:tw-text-sidebar-accent-foreground>svg{color:hsl(var(--sidebar-accent-foreground))}

.\\[\\&\\>svg\\]\\:hover\\:tw-text-grey-dark:hover>svg{color:hsl(var(--grey-dark))}

.\\[\\&\\>svg\\~\\*\\]\\:tw-pl-7>svg~*{padding-left:1.75rem}

.\\[\\&\\>tr\\]\\:last\\:tw-border-b-0:last-child>tr{border-bottom-width:0px}

.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:tw-rotate-90[data-panel-group-direction=vertical]>div{--tw-rotate:90deg;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:tw-rotate-180[data-state=open]>svg{--tw-rotate:180deg;transform:translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}

.\\[\\&_\\*\\]\\:tw-pointer-events-auto *{pointer-events:auto}

.\\[\\&_\\.recharts-cartesian-axis-tick_text\\]\\:tw-fill-muted-foreground .recharts-cartesian-axis-tick text{fill:hsl(var(--muted-foreground))}

.\\[\\&_\\.recharts-cartesian-grid_line\\[stroke\\=\\#ccc\\]\\]\\:tw-stroke-border\\/50 .recharts-cartesian-grid line[stroke=#ccc]{stroke:hsl(var(--border) / 0.5)}

.\\[\\&_\\.recharts-curve\\.recharts-tooltip-cursor\\]\\:tw-stroke-border .recharts-curve.recharts-tooltip-cursor{stroke:hsl(var(--border))}

.\\[\\&_\\.recharts-dot\\[stroke\\=\\#fff\\]\\]\\:tw-stroke-transparent .recharts-dot[stroke=#fff]{stroke:transparent}

.\\[\\&_\\.recharts-layer\\]\\:tw-outline-none .recharts-layer{outline:2px solid transparent;outline-offset:2px}

.\\[\\&_\\.recharts-polar-grid_\\[stroke\\=\\#ccc\\]\\]\\:tw-stroke-border .recharts-polar-grid [stroke=#ccc]{stroke:hsl(var(--border))}

.\\[\\&_\\.recharts-radial-bar-background-sector\\]\\:tw-fill-muted .recharts-radial-bar-background-sector{fill:hsl(var(--muted))}

.\\[\\&_\\.recharts-rectangle\\.recharts-tooltip-cursor\\]\\:tw-fill-muted .recharts-rectangle.recharts-tooltip-cursor{fill:hsl(var(--muted))}

.\\[\\&_\\.recharts-reference-line_\\[stroke\\=\\#ccc\\]\\]\\:tw-stroke-border .recharts-reference-line [stroke=#ccc]{stroke:hsl(var(--border))}

.\\[\\&_\\.recharts-sector\\[stroke\\=\\#fff\\]\\]\\:tw-stroke-transparent .recharts-sector[stroke=#fff]{stroke:transparent}

.\\[\\&_\\.recharts-sector\\]\\:tw-outline-none .recharts-sector{outline:2px solid transparent;outline-offset:2px}

.\\[\\&_\\.recharts-surface\\]\\:tw-outline-none .recharts-surface{outline:2px solid transparent;outline-offset:2px}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:tw-px-2 [cmdk-group-heading]{padding-left:0.5rem;padding-right:0.5rem}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:tw-py-1\\.5 [cmdk-group-heading]{padding-top:0.375rem;padding-bottom:0.375rem}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:tw-text-xs [cmdk-group-heading]{font-size:0.75rem;line-height:1rem}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:tw-font-medium [cmdk-group-heading]{font-weight:500}

.\\[\\&_\\[cmdk-group-heading\\]\\]\\:tw-text-muted-foreground [cmdk-group-heading]{color:hsl(var(--muted-foreground))}

.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:tw-pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{padding-top:0px}

.\\[\\&_\\[cmdk-group\\]\\]\\:tw-px-2 [cmdk-group]{padding-left:0.5rem;padding-right:0.5rem}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:tw-h-5 [cmdk-input-wrapper] svg{height:1.25rem}

.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:tw-w-5 [cmdk-input-wrapper] svg{width:1.25rem}

.\\[\\&_\\[cmdk-input\\]\\]\\:tw-h-12 [cmdk-input]{height:3rem}

.\\[\\&_\\[cmdk-item\\]\\]\\:tw-px-2 [cmdk-item]{padding-left:0.5rem;padding-right:0.5rem}

.\\[\\&_\\[cmdk-item\\]\\]\\:tw-py-3 [cmdk-item]{padding-top:0.75rem;padding-bottom:0.75rem}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:tw-h-5 [cmdk-item] svg{height:1.25rem}

.\\[\\&_\\[cmdk-item\\]_svg\\]\\:tw-w-5 [cmdk-item] svg{width:1.25rem}

.\\[\\&_p\\]\\:tw-leading-relaxed p{line-height:1.625}

.\\[\\&_svg\\]\\:tw-pointer-events-none svg{pointer-events:none}

.\\[\\&_svg\\]\\:tw-size-4 svg{width:1rem;height:1rem}

.\\[\\&_svg\\]\\:tw-shrink-0 svg{flex-shrink:0}

.\\[\\&_tr\\:last-child\\]\\:tw-border-b tr:last-child{border-bottom-width:1px}

.\\[\\&_tr\\:last-child\\]\\:tw-border-solid tr:last-child{border-style:solid}

.\\[\\&_tr\\:last-child\\]\\:tw-border-border tr:last-child{border-color:hsl(var(--border))}

.\\[\\&_tr\\]\\:tw-border-b-0 tr{border-bottom-width:0px}

[data-side=left][data-collapsible=offcanvas] .\\[\\[data-side\\=left\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:tw--right-2{right:-0.5rem}

[data-side=left][data-state=collapsed] .\\[\\[data-side\\=left\\]\\[data-state\\=collapsed\\]_\\&\\]\\:tw-cursor-e-resize{cursor:e-resize}

[data-side=left] .\\[\\[data-side\\=left\\]_\\&\\]\\:tw-cursor-w-resize{cursor:w-resize}

[data-side=right][data-collapsible=offcanvas] .\\[\\[data-side\\=right\\]\\[data-collapsible\\=offcanvas\\]_\\&\\]\\:tw--left-2{left:-0.5rem}

[data-side=right][data-state=collapsed] .\\[\\[data-side\\=right\\]\\[data-state\\=collapsed\\]_\\&\\]\\:tw-cursor-w-resize{cursor:w-resize}

[data-side=right] .\\[\\[data-side\\=right\\]_\\&\\]\\:tw-cursor-e-resize{cursor:e-resize}
`, "",{"version":3,"sources":["webpack://./src/css/bootstrap/bootstrap-responsive.min.css","webpack://./src/css/bootstrap/bootstrap.min.css","webpack://./src/css/bootstrap/navbar.css","webpack://./src/css/bootstrap/tabs.css","webpack://./src/css/jquery-ui/1.10.1-darkness.css","webpack://./src/css/jquery-ui/time-picker-addon.css","webpack://./src/css/vendor/datatables/jquery.dataTables_themeroller.css","webpack://./src/css/vendor/datatables/TableTools.css","webpack://./src/css/vendor/datatables/TableTools_JUI.css","webpack://./src/css/integrations.css","webpack://./src/css/benchmark.css","webpack://./src/css/breadcrumb.css","webpack://./src/css/cal-heatmap.css","webpack://./src/css/cal-heatmap-wisemetering.css","webpack://./src/css/colorbrewer.css","webpack://./src/css/dashboard.css","webpack://./src/css/details.css","webpack://./src/css/dropdown.css","webpack://./src/css/drop_zone.css","webpack://./src/css/modal.css","webpack://./src/css/organization.css","webpack://./src/css/reviewed.css","webpack://./src/css/ribbon.css","webpack://./src/css/progressbar.css","webpack://./src/css/schedules.css","webpack://./src/css/tipper.css","webpack://./src/css/ui_app.css","webpack://./src/css/ui_card.css","webpack://./src/css/ui_custom.css","webpack://./src/css/ui_defaults.css","webpack://./src/css/ui_crud.css","webpack://./src/css/ui_mbx.css","webpack://./src/css/ui_no_access.css","webpack://./src/css/ui_sprite.css","webpack://./src/css/ui_text.css","webpack://./src/css/widget.css","webpack://./src/css/overrides.css","webpack://./src/css/map.css","webpack://./src/css/notifications.css","webpack://./src/css/switch-toggle.css","webpack://./src/css/shadcn.css","webpack://./src/css/wisemetering.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE,CAAkC,WAAU,MAAO,CAAC,iCAAiC,aAAa,CAAC,aAAa,CAAC,UAAU,CAAC,gBAAgB,UAAU,CAAC,WAAW,UAAU,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,4BAA4B,CAAC,QAAQ,CAAC,mBAAmB,aAAa,CAAC,UAAU,CAAC,eAAe,CAAkD,qBAAqB,CAAC,QAAQ,YAAY,CAAC,iBAAiB,CAAC,eAAe,sBAAsB,CAAC,gBAAgB,sBAAsB,CAAC,gBAAgB,sBAAsB,CAAC,iBAAiB,yBAAyB,CAAC,8CAA8C,gBAAgB,yBAAyB,CAAC,iBAAiB,sBAAsB,CAAC,gBAAgB,yBAAyB,CAAC,eAAe,sBAAsB,CAAC,CAAC,wBAAwB,gBAAgB,yBAAyB,CAAC,iBAAiB,sBAAsB,CAAC,eAAe,yBAAyB,CAAC,cAAc,sBAAsB,CAAC,CAAC,yBAAyB,KAAK,iBAAiB,EAAC,MAAO,CAAC,uBAAuB,aAAa,CAAC,aAAa,CAAC,UAAU,CAAC,WAAW,UAAU,CAAC,gBAAgB,UAAU,CAAC,cAAc,CAAC,gBAAgB,CAAC,sGAAsG,YAAY,CAAC,QAAQ,YAAY,CAAC,QAAQ,YAAY,CAAC,QAAQ,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,UAAU,CAAC,UAAU,kBAAkB,CAAC,UAAU,kBAAkB,CAAC,UAAU,kBAAkB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,WAAW,UAAU,EAAC,MAAO,CAAC,mCAAmC,aAAa,CAAC,aAAa,CAAC,UAAU,CAAC,iBAAiB,UAAU,CAAC,2BAA2B,aAAa,CAAC,UAAU,CAAC,UAAU,CAAC,eAAe,EAAgC,+BAAgC,CAAkD,qBAAqB,CAAC,uCAAuC,aAAa,CAAC,yDAAyD,8BAA8B,CAAC,oBAA8B,wBAAyB,CAAC,oBAA4C,wBAAyB,CAAC,oBAA4C,uBAAwB,CAAC,mBAA2C,wBAAyB,CAAC,mBAA2C,wBAAyB,CAAC,mBAA2C,wBAAyB,CAAC,mBAA4C,yBAA0B,CAAC,mBAA2C,wBAAyB,CAAC,mBAA4C,yBAA0B,CAAC,mBAA4C,yBAA0B,CAAC,mBAA2C,yBAA0B,CAAC,mBAA2C,wBAAyB,CAAC,sBAAqD,+BAAgC,CAAC,kCAAiE,+BAAgC,CAAC,sBAAoD,8BAA+B,CAAC,kCAAgE,8BAA+B,CAAC,sBAAoD,8BAA+B,CAAC,kCAAgE,8BAA+B,CAAC,qBAAmD,8BAA+B,CAAC,iCAA+D,8BAA+B,CAAC,qBAAmD,8BAA+B,CAAC,iCAA+D,8BAA+B,CAAC,qBAAoD,8BAA+B,CAAC,iCAA+D,8BAA+B,CAAC,qBAAmD,+BAAgC,CAAC,iCAA+D,+BAAgC,CAAC,qBAAoD,6BAA8B,CAAC,iCAA+D,8BAA+B,CAAC,qBAAmD,+BAAgC,CAAC,iCAA+D,+BAAgC,CAAC,qBAAoD,6BAA8B,CAAC,iCAAgE,8BAA+B,CAAC,qBAAmD,+BAAgC,CAAC,iCAAgE,8BAA+B,CAAC,qBAAmD,+BAAgC,CAAC,iCAA+D,8BAA+B,CAAC,iCAAiC,aAAa,CAAC,8CAA8C,gBAAgB,CAAC,sDAAsD,YAAY,CAAC,sDAAsD,YAAY,CAAC,sDAAsD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,UAAU,CAAC,YAAY,iBAAiB,CAAC,eAAe,gBAAgB,CAAC,uBAAuB,aAAa,CAAC,CAAC,8CAA8C,KAAK,iBAAiB,EAAC,MAAO,CAAC,uBAAuB,aAAa,CAAC,aAAa,CAAC,UAAU,CAAC,WAAW,UAAU,CAAC,gBAAgB,UAAU,CAAC,cAAc,CAAC,gBAAgB,CAAC,sGAAsG,WAAW,CAAC,QAAQ,WAAW,CAAC,QAAQ,WAAW,CAAC,QAAQ,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,WAAW,CAAC,OAAO,UAAU,CAAC,UAAU,iBAAiB,CAAC,UAAU,iBAAiB,CAAC,UAAU,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,iBAAiB,CAAC,SAAS,gBAAgB,CAAC,WAAW,UAAU,EAAC,MAAO,CAAC,mCAAmC,aAAa,CAAC,aAAa,CAAC,UAAU,CAAC,iBAAiB,UAAU,CAAC,2BAA2B,aAAa,CAAC,UAAU,CAAC,UAAU,CAAC,eAAe,EAAiC,8BAA+B,CAAkD,qBAAqB,CAAC,uCAAuC,aAAa,CAAC,yDAAyD,+BAA+B,CAAC,oBAA8B,wBAAyB,CAAC,oBAA4C,wBAAyB,CAAC,oBAA4C,wBAAyB,CAAC,mBAA2C,wBAAyB,CAAC,mBAA2C,wBAAyB,CAAC,mBAA2C,wBAAyB,CAAC,mBAA2C,wBAAyB,CAAC,mBAA2C,wBAAyB,CAAC,mBAA4C,wBAAyB,CAAC,mBAA2C,wBAAyB,CAAC,mBAA0C,yBAA0B,CAAC,mBAA2C,wBAAyB,CAAC,sBAAqD,+BAAgC,CAAC,kCAAiE,8BAA+B,CAAC,sBAAoD,6BAA8B,CAAC,kCAA+D,8BAA+B,CAAC,sBAAoD,6BAA8B,CAAC,kCAA+D,8BAA+B,CAAC,qBAAkD,8BAA+B,CAAC,iCAA+D,8BAA+B,CAAC,qBAAkD,8BAA+B,CAAC,iCAA+D,8BAA+B,CAAC,qBAAmD,+BAAgC,CAAC,iCAA+D,+BAAgC,CAAC,qBAAmD,+BAAgC,CAAC,iCAA+D,8BAA+B,CAAC,qBAAmD,8BAA+B,CAAC,iCAA+D,8BAA+B,CAAC,qBAAmD,8BAA+B,CAAC,iCAA+D,8BAA+B,CAAC,qBAAmD,+BAAgC,CAAC,iCAA+D,+BAAgC,CAAC,qBAAmD,+BAAgC,CAAC,iCAA+D,8BAA+B,CAAC,qBAAmD,+BAAgC,CAAC,iCAA8D,8BAA+B,CAAC,iCAAiC,aAAa,CAAC,8CAA8C,gBAAgB,CAAC,sDAAsD,WAAW,CAAC,sDAAsD,WAAW,CAAC,sDAAsD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,WAAW,CAAC,mDAAmD,UAAU,CAAC,mDAAmD,UAAU,CAAC,CAAC,wBAAwB,KAAK,kBAAkB,CAAC,iBAAiB,CAAC,0DAA0D,kBAAkB,CAAC,iBAAiB,CAAC,iBAAiB,SAAS,CAAC,kBAAkB,UAAU,CAAC,UAAU,CAAC,UAAU,CAAC,eAAe,CAAC,kBAAkB,aAAa,CAAC,WAAW,UAAU,CAAC,WAAW,UAAU,CAAC,iBAAiB,aAAa,CAAC,eAAe,UAAU,CAAC,aAAa,CAAC,4EAA4E,aAAa,CAAC,UAAU,CAAC,UAAU,CAAC,aAAa,CAAkD,qBAAqB,CAAC,2BAA2B,UAAU,CAAkD,qBAAqB,CAAC,yCAAyC,aAAa,CAAC,+HAA+H,aAAa,CAAC,UAAU,CAAC,eAAe,CAAkD,qBAAqB,CAAC,gHAAgH,oBAAoB,CAAC,UAAU,CAAC,8CAA8C,aAAa,CAAC,OAAO,cAAc,CAAC,QAAQ,CAAC,UAAU,CAAC,SAAS,CAAC,UAAU,CAAC,QAAQ,CAAC,YAAY,UAAU,CAAC,eAAe,QAAQ,CAAC,CAAC,wBAAwB,cAAc,oCAAoC,CAAC,sBAAsB,aAAa,CAAC,gBAAgB,CAAC,2CAA2C,qBAAqB,CAAC,gCAAgC,UAAU,CAAC,UAAU,CAAC,aAAa,CAAC,eAAe,CAAC,2BAA2B,aAAa,CAAC,+BAA+B,aAAa,CAAC,+BAA+B,kBAAkB,CAAC,iBAAiB,CAAC,qCAAqC,aAAa,CAAC,UAAU,CAAC,kBAAkB,CAAC,cAAc,cAAc,CAAC,aAAa,CAAC,OAAO,QAAQ,CAAC,UAAU,CAAC,SAAS,CAAC,qBAAqB,YAAY,CAAC,YAAY,CAAC,kBAAkB,eAAe,CAAC,CAAC,wBAAwB,KAAK,aAAa,CAAC,uCAAuC,eAAe,CAAC,kBAAkB,kBAAkB,CAAC,qBAAqB,eAAe,CAAC,mEAAmE,WAAW,CAAC,mBAAmB,UAAU,CAAC,SAAS,CAAC,eAAe,kBAAkB,CAAC,iBAAiB,CAAC,iBAAiB,CAAC,cAAc,UAAU,CAAC,mBAAmB,UAAU,CAAC,eAAe,CAAC,sBAAsB,UAAU,CAAC,wBAAwB,iBAAiB,CAAC,qCAAqC,YAAY,CAAC,+BAA+B,UAAU,CAAC,gBAAgB,CAAC,uDAAuD,gBAAgB,CAAC,gBAAgB,CAAC,UAAU,CAA0C,iBAAiB,CAAC,mBAAmB,oBAAoB,CAAC,kBAAkB,CAA0C,iBAAiB,CAAC,qCAAqC,iBAAiB,CAAC,mEAAmE,wBAAwB,CAAC,uFAAuF,UAAU,CAAC,mGAAmG,qBAAqB,CAAC,4BAA4B,SAAS,CAAC,cAAc,CAAC,6BAA6B,eAAe,CAAC,QAAQ,CAAC,SAAS,CAAC,YAAY,CAAC,UAAU,CAAC,cAAc,CAAC,SAAS,CAAC,aAAa,CAAC,4BAA4B,CAAC,QAAQ,CAAsC,eAAe,CAAsC,eAAe,CAAC,mCAAmC,aAAa,CAAC,uEAAuE,YAAY,CAAC,sCAAsC,YAAY,CAAC,uFAAuF,YAAY,CAAC,wDAAwD,UAAU,CAAC,iBAAiB,CAAC,aAAa,CAAC,4BAA4B,CAAC,+BAA+B,CAAgK,4EAA4E,CAAC,wFAAwF,qBAAqB,CAAC,wBAAwB,CAAC,sCAAsC,UAAU,CAAC,aAAa,CAAC,qCAAqC,QAAQ,CAAC,eAAe,CAAC,oBAAoB,aAAa,CAAC,6BAA6B,kBAAkB,CAAC,iBAAiB,CAAC,CAAC,wBAAwB,uBAAuB,qBAAqB,CAAC,0BAA0B,CAAC;ACR/1f;;;;;;;;EAQE;AACF,WAAU,MAAO,CAAC,CAAC,iCAAiC,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC;AAC3F,gBAAgB,UAAU,CAAC;AAC3B,WAAW,UAAU,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,4BAA4B,CAAC,QAAQ,CAAC;AAC/F,mBAAmB,aAAa,CAAC,UAAU,CAAC,eAAe,CAAkD,qBAAqB,CAAC;AACnI,mCAAmC,UAAU,CAAC,oBAAoB,CAAC,UAAU,CAAC,WAAW,EAAC,iBAAkB,CAAC,gBAAgB,CAAC,uBAAuB,CAAC,kEAAkE,CAAC,6BAA6B,CAAC,2BAA2B,CAAC,cAAc,CAAC;AAClS,srBAAsrB,wEAAwE,CAAC;AAC/vB,YAAY,uBAAuB,CAAC;AACpC,YAAY,2BAA2B,CAAC;AACxC,eAAe,2BAA2B,CAAC;AAC3C,YAAY,2BAA2B,CAAC;AACxC,WAAW,4BAA4B,CAAC;AACxC,iBAAiB,4BAA4B,CAAC;AAC9C,WAAW,4BAA4B,CAAC;AACxC,WAAW,4BAA4B,CAAC;AACxC,eAAe,4BAA4B,CAAC;AAC5C,SAAS,4BAA4B,CAAC;AACtC,cAAc,4BAA4B,CAAC;AAC3C,SAAS,4BAA4B,CAAC;AACtC,aAAa,4BAA4B,CAAC;AAC1C,cAAc,4BAA4B,CAAC;AAC3C,eAAe,4BAA4B,CAAC;AAC5C,UAAU,4BAA4B,CAAC;AACvC,aAAa,4BAA4B,CAAC;AAC1C,UAAU,4BAA4B,CAAC;AACvC,YAAY,4BAA4B,CAAC;AACzC,WAAW,2BAA2B,CAAC;AACvC,WAAW,+BAA+B,CAAC;AAC3C,WAAW,+BAA+B,CAAC;AAC3C,WAAW,+BAA+B,CAAC;AAC3C,mBAAmB,+BAA+B,CAAC;AACnD,eAAe,gCAAgC,CAAC;AAChD,aAAa,gCAAgC,CAAC;AAC9C,YAAY,gCAAgC,CAAC;AAC7C,kBAAkB,gCAAgC,CAAC;AACnD,aAAa,gCAAgC,CAAC;AAC9C,cAAc,gCAAgC,CAAC;AAC/C,eAAe,gCAAgC,CAAC;AAChD,WAAW,gCAAgC,CAAC;AAC5C,WAAW,gCAAgC,CAAC;AAC5C,iBAAiB,gCAAgC,CAAC;AAClD,iBAAiB,gCAAgC,CAAC;AAClD,kBAAkB,gCAAgC,CAAC;AACnD,gBAAgB,gCAAgC,CAAC;AACjD,aAAa,gCAAgC,CAAC;AAC9C,cAAc,gCAAgC,CAAC;AAC/C,UAAU,2BAA2B,CAAC;AACtC,WAAW,+BAA+B,CAAC;AAC3C,WAAW,+BAA+B,CAAC;AAC3C,eAAe,+BAA+B,CAAC;AAC/C,YAAY,+BAA+B,CAAC;AAC5C,aAAa,gCAAgC,CAAC;AAC9C,WAAW,gCAAgC,CAAC;AAC5C,WAAW,gCAAgC,CAAC;AAC5C,aAAa,gCAAgC,CAAC;AAC9C,kBAAkB,gCAAgC,CAAC;AACnD,iBAAiB,gCAAgC,CAAC;AAClD,iBAAiB,gCAAgC,CAAC;AAClD,mBAAmB,gCAAgC,CAAC;AACpD,kBAAkB,gCAAgC,CAAC;AACnD,oBAAoB,gCAAgC,CAAC;AACrD,WAAW,gCAAgC,CAAC;AAC5C,kBAAkB,gCAAgC,CAAC;AACnD,mBAAmB,gCAAgC,CAAC;AACpD,qBAAqB,gCAAgC,CAAC;AACtD,cAAc,gCAAgC,CAAC;AAC/C,aAAa,2BAA2B,CAAC;AACzC,iBAAiB,+BAA+B,CAAC;AACjD,aAAa,+BAA+B,CAAC;AAC7C,WAAW,+BAA+B,CAAC;AAC3C,WAAW,+BAA+B,CAAC;AAC3C,YAAY,gCAAgC,CAAC;AAC7C,YAAY,gCAAgC,CAAC;AAC7C,WAAW,gCAAgC,CAAC;AAC5C,oBAAoB,gCAAgC,CAAC;AACrD,oBAAoB,gCAAgC,CAAC;AACrD,eAAe,gCAAgC,CAAC;AAChD,WAAW,gCAAgC,CAAC;AAC5C,YAAY,gCAAgC,CAAC;AAC7C,WAAW,gCAAgC,CAAC;AAC5C,cAAc,gCAAgC,CAAC;AAC/C,mBAAmB,gCAAgC,CAAC;AACpD,mBAAmB,gCAAgC,CAAC;AACpD,YAAY,gCAAgC,CAAC;AAC7C,mBAAmB,gCAAgC,CAAC;AACpD,oBAAoB,gCAAgC,CAAC;AACrD,gBAAgB,2BAA2B,CAAC;AAC5C,iBAAiB,+BAA+B,CAAC;AACjD,kBAAkB,+BAA+B,CAAC;AAClD,cAAc,+BAA+B,CAAC;AAC9C,oBAAoB,+BAA+B,CAAC;AACpD,gBAAgB,gCAAgC,CAAC;AACjD,iBAAiB,gCAAgC,CAAC;AAClD,oBAAoB,gCAAgC,CAAC;AACrD,gBAAgB,gCAAgC,CAAC;AACjD,iBAAiB,gCAAgC,CAAC;AAClD,iBAAiB,gCAAgC,CAAC;AAClD,kBAAkB,gCAAgC,CAAC;AACnD,eAAe,gCAAgC,CAAC;AAChD,iBAAiB,gCAAgC,CAAC;AAClD,gBAAgB,gCAAgC,CAAC;AACjD,kBAAkB,gCAAgC,CAAC;AACnD,mBAAmB,gCAAgC,CAAC;AACpD,WAAW,gCAAgC,CAAC;AAC5C,YAAY,gCAAgC,CAAC;AAC7C,eAAe,gCAAgC,CAAC;AAChD,uBAAuB,4BAA4B,CAAC;AACpD,WAAW,gCAAgC,CAAC;AAC5C,WAAW,gCAAgC,CAAC;AAC5C,WAAW,gCAAgC,CAAC;AAC5C,eAAe,gCAAgC,CAAC;AAChD,gBAAgB,iCAAiC,CAAC;AAClD,mBAAmB,iCAAiC,CAAC;AACrD,YAAY,iCAAiC,CAAC;AAC9C,eAAe,iCAAiC,CAAC;AACjD,aAAa,iCAAiC,CAAC,UAAU,CAAC;AAC1D,cAAc,iCAAiC,CAAC;AAChD,aAAa,iCAAiC,CAAC;AAC/C,iBAAiB,iCAAiC,CAAC;AACnD,mBAAmB,iCAAiC,CAAC;AACrD,cAAc,iCAAiC,CAAC;AAChD,oBAAoB,iCAAiC,CAAC;AACtD,mBAAmB,iCAAiC,CAAC,UAAU,CAAC;AAChE,kBAAkB,iCAAiC,CAAC,UAAU,CAAC;AAC/D,sBAAsB,iCAAiC,CAAC;AACxD,wBAAwB,iCAAiC,CAAC;AAC1D,UAAU,4BAA4B,CAAC;AACvC,eAAe,gCAAgC,CAAC;AAChD,WAAW,gCAAgC,CAAC;AAC5C,kBAAkB,gCAAgC,CAAC;AACnD,gBAAgB,gCAAgC,CAAC;AACjD,kBAAkB,iCAAiC,CAAC;AACpD,iBAAiB,iCAAiC,CAAC;AACnD,gBAAgB,iCAAiC,CAAC;AAClD,cAAc,iCAAiC,CAAC;AAChD,gBAAgB,iCAAiC,CAAC;AAClD,yBAAyB,iCAAiC,CAAC;AAC3D,wBAAwB,iCAAiC,CAAC;AAC1D,sBAAsB,iCAAiC,CAAC;AACxD,wBAAwB,iCAAiC,CAAC;AAC1D,YAAY,iCAAiC,CAAC;AAC9C,aAAa,iCAAiC,CAAC;AAC/C,YAAY,iCAAiC,CAAC;AAC9C,aAAa,iCAAiC,CAAC;AAC/C,gBAAgB,iCAAiC,CAAC;AAClD,iBAAiB,iCAAiC,CAAC;AACnD,yEAAyE,aAAa,CAAC;AACvF,mBAAmB,oBAAoB,EAAC,cAAe,EAAC,MAAO,CAAC;AAChE,sBAAsB,YAAY,CAAC;AACnC,KAAK,cAAc,CAAC,6BAA6B,CAAC,yBAAyB,CAAC;AAC5E,QAAQ,wBAAwB,CAAC,yCAAyC,CAAC,mBAAmB,CAAC;AAC/F,iBAAiB,SAAS,CAAC;AAC3B,QAAQ,iBAAiB,CAAC,aAAa,CAAC,aAAa,CAAC,uBAAuB,CAAC;AAC9E,IAAI,UAAU,CAAC;AACf,IAAI,cAAc,CAAC;AACnB,IAAI,cAAc,CAAC,YAAY,CAAC,WAAW,CAAC,qBAAqB,CAAC,QAAQ,CAAC,8BAA8B,CAAC;AAC1G,iCAAiC,cAAc,CAAC;AAChD,6BAA6B,QAAQ,CAAC,cAAc,CAAC,qBAAqB,CAAC;AAC3E,cAAa,gBAAiB,CAAC,kBAAkB,CAAC;AAClD,iDAAiD,SAAS,CAAC,QAAQ,CAAC;AACpE,0EAA0E,yBAAyB,CAAC,cAAc,CAAC;AACnH,6HAA6H,cAAc,CAAC;AAC5I,qBAAwE,sBAAsB,CAAC,4BAA4B,CAAC;AAC5H,mGAAmG,uBAAuB,CAAC;AAC3H,SAAS,aAAa,CAAC,kBAAkB,CAAC;AAC1C,aAAa,EAAE,2BAA2B,CAAC,qBAAqB,CAAC,iCAAiC,CAAC,0BAA0B,CAAC,EAAE,YAAY,yBAAyB,CAAC,EAAE,cAAc,2BAA2B,CAAC,EAAE,kBAAkB,4BAA4B,CAAC,EAAE,4DAA4D,UAAU,CAAC,EAAE,eAAe,qBAAqB,CAAC,uBAAuB,CAAC,EAAE,MAAM,0BAA0B,CAAC,EAAE,OAAO,uBAAuB,CAAC,EAAE,IAAI,yBAAyB,CAAC,EAAE,OAAO,YAAY,CAAC,CAAC,QAAQ,SAAS,CAAC,QAAQ,CAAC,EAAE,MAAM,sBAAsB,CAAC,CAAC,CAAC,KAAK,QAAQ,CAAC,uDAAuD,CAAC,cAAc,CAAC,gBAAgB,CAAC,aAAa,CAAC,wBAAwB,CAAC;AAC/sB,EAAE,aAAa,CAAC,oBAAoB,CAAC;AACrC,QAAQ,aAAa,CAAC,yBAAyB,CAAC;AAChD,aAAsD,iBAAiB,CAAC;AACxE,cAAc,WAAW,CAAC,qBAAqB,CAAC,qBAAqB,CAAC,mCAAmC,CAAsF,uCAAuC,CAAC;AACvO,YAAyD,mBAAmB,CAAC;AAC7E,KAAK,iBAAiB,EAAC,MAAO,CAAC,CAAC,uBAAuB,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC;AAC9F,WAAW,UAAU,CAAC;AACtB,gBAAgB,UAAU,CAAC,cAAc,CAAC,gBAAgB,CAAC;AAC3D,sGAAsG,WAAW,CAAC;AAClH,QAAQ,WAAW,CAAC;AACpB,QAAQ,WAAW,CAAC;AACpB,QAAQ,WAAW,CAAC;AACpB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,WAAW,CAAC;AACnB,OAAO,UAAU,CAAC;AAClB,UAAU,iBAAiB,CAAC;AAC5B,UAAU,iBAAiB,CAAC;AAC5B,UAAU,iBAAiB,CAAC;AAC5B,SAAS,iBAAiB,CAAC;AAC3B,SAAS,iBAAiB,CAAC;AAC3B,SAAS,iBAAiB,CAAC;AAC3B,SAAS,iBAAiB,CAAC;AAC3B,SAAS,iBAAiB,CAAC;AAC3B,SAAS,iBAAiB,CAAC;AAC3B,SAAS,iBAAiB,CAAC;AAC3B,SAAS,iBAAiB,CAAC;AAC3B,SAAS,iBAAiB,CAAC;AAC3B,WAAW,UAAU,EAAC,MAAO,CAAC,CAAC,mCAAmC,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC;AACzG,iBAAiB,UAAU,CAAC;AAC5B,2BAA2B,aAAa,CAAC,UAAU,CAAC,eAAe,CAAkD,qBAAqB,CAAC,UAAU,EAAgC,8BAA+B,CAAC;AACrN,uCAAuC,aAAa,CAAC;AACrD,yDAAyD,8BAA8B,CAAC;AACxF,oBAA8B,wBAAyB,CAAC;AACxD,oBAA4C,wBAAyB,CAAC;AACtE,oBAA4C,wBAAyB,CAAC;AACtE,mBAA2C,wBAAyB,CAAC;AACrE,mBAA2C,wBAAyB,CAAC;AACrE,mBAA2C,wBAAyB,CAAC;AACrE,mBAA2C,wBAAyB,CAAC;AACrE,mBAA2C,wBAAyB,CAAC;AACrE,mBAA4C,yBAA0B,CAAC;AACvE,mBAA4C,yBAA0B,CAAC;AACvE,mBAA4C,yBAA0B,CAAC;AACvE,mBAA2C,wBAAyB,CAAC;AACrE,sBAAqD,+BAAgC,CAAC;AACtF,kCAAiE,+BAAgC,CAAC;AAClG,sBAAoD,6BAA8B,CAAC;AACnF,kCAAgE,8BAA+B,CAAC;AAChG,sBAAoD,8BAA+B,CAAC;AACpF,kCAA+D,8BAA+B,CAAC;AAC/F,qBAAmD,8BAA+B,CAAC;AACnF,iCAA+D,8BAA+B,CAAC;AAC/F,qBAAkD,8BAA+B,CAAC;AAClF,iCAA+D,6BAA8B,CAAC;AAC9F,qBAAmD,8BAA+B,CAAC;AACnF,iCAAgE,8BAA+B,CAAC;AAChG,qBAAoD,+BAAgC,CAAC;AACrF,iCAAgE,8BAA+B,CAAC;AAChG,qBAAmD,8BAA+B,CAAC;AACnF,iCAA8D,6BAA8B,CAAC;AAC7F,qBAAoD,8BAA+B,CAAC;AACpF,iCAA+D,8BAA+B,CAAC;AAC/F,qBAAoD,6BAA8B,CAAC;AACnF,iCAA+D,+BAAgC,CAAC;AAChG,qBAAoD,8BAA+B,CAAC;AACpF,iCAA+D,+BAAgC,CAAC;AAChG,qBAAoD,8BAA+B,CAAC;AACpF,iCAA8D,8BAA+B,CAAC;AAC9F,qDAAqD,YAAY,CAAC;AAClE,iEAAiE,WAAW,CAAC;AAC7E,WAAW,iBAAiB,CAAC,gBAAgB,EAAC,MAAO,CAAC,CAAC,mCAAmC,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC;AACjI,iBAAiB,UAAU,CAAC;AAC5B,iBAAiB,kBAAkB,CAAC,iBAAiB,EAAC,MAAO,CAAC,CAAC,+CAA+C,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC;AACrJ,uBAAuB,UAAU,CAAC;AAClC,WAAW,iBAAiB,CAAC,oBAAoB,EAAC,cAAe,EAAC,MAAO,CAAC,WAAW,CAAC,qBAAqB,CAAC,kBAAkB,EAAC,gBAAiB,CAAC,CAAC,wBAAuB,aAAc,CAAC;AACxL,sBAAsB,eAAe,CAAC;AACtC,aAAa,WAAW,CAAC,eAAe,CAAC,kBAAkB,CAAC,CAAC,iFAAiF,eAAe,CAAC;AAC9J,gBAAgB,iBAAiB,CAAsC,eAAe,CAAC;AACvF,qBAAqB,gBAAgB,CAAC;AACtC,8DAA8D,cAAc,CAAC;AAC7E,qBAAqB,gBAAgB,CAAC;AACtC,sBAAsB,gBAAgB,CAAC;AACvC,sBAAsB,gBAAgB,CAAC;AACvC,4BAA4B,aAAa,CAA2D,0BAA0B,CAAiE,6BAA6B,CAAC;AAC7N,uDAAmH,2BAA2B,CAAmE,8BAA8B,CAAC;AAChP,kCAAkC,aAAa,CAA2D,0BAA0B,CAAiE,6BAA6B,CAAC;AACnO,mEAA+H,2BAA2B,CAAmE,8BAA8B,CAAC;AAC5P,0FAA0F,SAAS,CAAC;AACpG,oEAAoE,SAAS,CAAC;AAC9E,iCAAiC,gBAAgB,CAAC,iBAAiB,CAAoO,8GAA8G,EAAC,eAAgB,EAAC,kBAAmB,CAAC;AAC3b,sCAAsC,gBAAgB,CAAC,iBAAiB,EAAC,eAAgB,EAAC,kBAAmB,CAAC;AAC9G,wCAAuC,eAAgB,EAAC,kBAAmB,CAAC;AAC5E,uCAAuC,iBAAiB,CAAC,kBAAkB,EAAC,eAAgB,EAAC,kBAAmB,CAAC;AACjH,iCAAiC,qBAAqB,CAAkJ,qEAAqE,CAAC;AAC9Q,qCAAqC,wBAAwB,CAAC;AAC9D,6CAA6C,wBAAwB,CAAC;AACtE,6CAA6C,wBAAwB,CAAC;AACtE,4CAA4C,wBAAwB,CAAC;AACrE,6CAA6C,wBAAwB,CAAC;AACtE,0CAA0C,wBAAwB,CAAC;AACnE,6CAA6C,wBAAwB,CAAC;AACtE,YAAY,cAAc,CAAC,aAAa,CAAC;AACzC,qDAAqD,cAAc,CAAC;AACpE,kBAAkB,qBAAqB,CAAC,sBAAsB,CAAC,oBAAoB,CAAC;AACpF,0BAA0B,uBAAuB,CAAC;AAClD,oHAAoH,wBAAwB,CAAC,2BAA2B,CAAC;AACzK,oBAAoB,oBAAoB,EAAC,cAAe,EAAC,MAAO,CAAC;AACjE,yBAAyB,aAAa,CAAC,UAAU,CAAC,cAAc,CAAsC,eAAe,CAAC;AACtH,8BAA8B,aAAa,CAAC,eAAe,CAAC;AAC5D,qCAA8F,yBAAyB,CAAC;AACxH,oCAA6F,yBAAyB,CAAC;AACvH,2CAAoG,yBAAyB,CAAC;AAC9H,0CAAmG,yBAAyB,CAAC;AAC7H,KAAK,aAAa,CAAC,kBAAkB,CAAC,eAAe,CAAC;AACtD,UAAU,aAAa,CAAC;AACxB,gBAAgB,oBAAoB,CAAC,wBAAwB,CAAC;AAC9D,cAAc,cAAc,CAAC;AAC7B,iBAAiB,WAAW,CAAC;AAC7B,YAAY,aAAa,CAAC,gBAAgB,CAAC,cAAc,CAAC,gBAAgB,CAAC,gBAAgB,CAAC,aAAa,CAAC,4CAA4C,CAAC,wBAAwB,CAAC;AAChL,oBAAoB,cAAc,CAAC;AACnC,UAAU,iBAAiB,CAAC,kBAAkB,CAAC,eAAe,CAAC;AAC/D,qCAAqC,iBAAiB,CAAC,kBAAkB,CAAC,4CAA4C,CAAC;AACvH,eAAe,gBAAgB,CAAC;AAChC,8CAA8C,aAAa,CAAC,uCAAuC,CAAC,wBAAwB,CAAC;AAC7H,uDAAuD,gBAAgB,CAAC;AACxE,oBAAmB,UAAW,CAAC,UAAU,CAAC,cAAc,EAAC,iBAAkB,CAAC,eAAe,CAAC,wBAAwB,CAAC,+BAA+B,CAAC;AACrJ,sBAAqB,MAAO,CAAC,CAAC,oEAAoE,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC;AACzI,iCAAiC,UAAU,CAAC;AAC5C,2BAA2B,UAAU,CAAC;AACtC,+BAA+B,kBAAkB,CAAC,iBAAiB,CAAC,gBAAgB,CAAC,gBAAgB,CAAC;AACtG,UAAU,4BAA4B,CAAC;AACvC,aAAa,kBAAkB,CAAC;AAChC,eAAe,eAAe,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,4BAA4B,CAA0D,yBAAyB,CAAC,CAAC,qBAAqB,oCAAoC,CAAC;AAC9O,8CAA8C,aAAa,CAAC,wBAAwB,CAAC,qBAAqB,CAAC,+BAA+B,CAAC,cAAc,CAAC;AAC1J,gBAAgB,eAAe,CAAC,kBAAkB,CAAC,cAAc,CAAC,iBAAiB,CAA0C,iBAAiB,CAAC;AAC/I,gDAAgD,aAAa,CAAC,wBAAwB,CAAC;AACvF,gBAAgB,UAAU,CAAC;AAC3B,kBAAkB,cAAc,CAAC;AACjC,sBAAsB,eAAe,CAAC;AACtC,2BAA2B,qBAAqB,CAAsC,eAAe,CAAC;AACtG,uCAAmG,2BAA2B,CAA2D,0BAA0B,CAAC;AACpN,sCAAwG,8BAA8B,CAAiE,6BAA6B,CAAC;AACrO,iCAAiC,iBAAiB,CAAC,SAAS,CAAC;AAC7D,4BAA4B,iBAAiB,CAAC;AAC9C,uCAAuC,iBAAiB,CAAC;AACzD,yBAAkF,yBAAyB,CAAC;AAC5G,0BAAmE,iBAAiB,CAAC;AACrF,6BAA6B,wBAAwB,CAAC,2BAA2B,CAAC,cAAc,CAAC;AACjG,mCAAmC,wBAAwB,CAAC,2BAA2B,CAAC;AACxF,kCAAkC,cAAc,CAAC;AACjD,qCAAqC,qBAAqB,CAAC,wBAAwB,CAAC;AACpF,0CAA0C,wBAAwB,CAAC,2BAA2B,CAAC;AAC/F,8BAA8B,cAAc,CAAC;AAC7C,wGAAwG,aAAa,CAAC,wBAAwB,CAAC,oBAAoB,CAAC;AACpK,sGAAsG,wBAAwB,CAAC,2BAA2B,CAAC,SAAS,CAAC,yBAAyB,CAAC;AAC/L,4BAA4B,oBAAoB,CAAC;AACjD,WAAU,MAAO,CAAC,CAAC,iCAAiC,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC;AAC3F,gBAAgB,UAAU,CAAC;AAC3B,aAAa,aAAa,CAAC;AAC3B,iEAAiE,eAAe,CAAC;AACjF,gDAAgD,YAAY,CAAC;AAC7D,2CAA2C,aAAa,CAAC;AACzD,sBAAsB,yBAAyB,CAAC;AAChD,yBAAyB,eAAe,CAAC,eAAe,CAAC;AACzD,2BAAoF,yBAAyB,CAAC,CAAC,iCAAiC,+BAA+B,CAAC,qBAAqB,CAAC;AACtM,sEAAsE,uCAAuC,CAAC;AAC9G,iDAAiD,UAAU,CAAC;AAC5D,qDAAqD,cAAc,CAAC,cAAc,CAAC,iBAAiB,CAAC;AACrG,qBAAqB,UAAU,CAAC,iBAAiB,CAAC,2BAA2B,CAAC;AAC9E,0BAA0B,iBAAiB,CAA0D,yBAAyB,CAAC;AAC/H,gCAAgC,4CAA4C,CAAC;AAC7E,oEAAoE,uCAAuC,EAAC,0BAA2B,CAAC;AACxI,sBAAsB,WAAW,CAAC,gBAAgB,CAAC,0BAA0B,CAAC;AAC9E,2BAA2B,gBAAgB,CAA0D,yBAAyB,CAAC;AAC/H,iCAAiC,4CAA4C,CAAC;AAC9E,sEAAsE,uCAAuC,EAAC,yBAA0B,CAAC;AACzI,iBAAiB,aAAa,CAAC;AAC/B,uBAAuB,oBAAoB,CAAC,4BAA4B,CAAC,cAAc,CAAC;AACxF,QAAQ,gBAAgB,EAAC,iBAAkB,EAAC,SAAU,CAAC;AACvD,cAAc,eAAe,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,wBAAwB,CAA8R,6DAA6D,CAAC,0BAA0B,CAAC,qHAAqH,CAAC,wBAAwB,CAA0C,iBAAiB,CAA0F,yCAAyC,EAAC,MAAO,CAAC,CAAC,yCAAyC,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC;AACx3B,oBAAoB,UAAU,CAAC;AAC/B,mBAAmB,UAAU,CAAC;AAC9B,uBAAuB,WAAW,CAAC,gBAAgB,CAAC;AACpD,eAAe,UAAU,CAAC,aAAa,CAAC,sBAAsB,CAAC,iBAAiB,CAAC,cAAc,CAAC,eAAe,CAAC,aAAa,CAAC,2BAA2B,CAAC,CAAC,qBAAqB,oBAAoB,CAAC;AACrM,aAAa,eAAe,CAAC,gBAAgB,CAAC,aAAa,CAAC;AAC5D,aAAa,aAAa,CAAC,CAAC,mBAAmB,aAAa,CAAC;AAC7D,0BAA0B,WAAW,CAAC,YAAY,CAAC,6BAA6B,CAAC,8BAA8B,CAAC;AAChH,gCAAgC,cAAc,CAAC;AAC/C,+EAA+E,YAAY,CAAC;AAC5F,aAAa,eAAe,EAAC,MAAO,CAAC,CAAC,uCAAuC,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC;AACpH,mBAAmB,UAAU,CAAC;AAC9B,kFAAkF,cAAc,CAAC;AACjG,yDAAyD,oBAAoB,CAAC,eAAe,CAAC;AAC9F,sGAAsG,cAAc,CAAC;AACrH,uDAAuD,cAAc,CAAC,kBAAkB,CAAC,CAAC,mEAAmE,YAAY,CAAC;AAC1K,eAAe,iBAAiB,CAAC,UAAU,CAAC,cAAc,CAAC,eAAe,CAAC,CAAC,6BAA6B,eAAe,CAAC,gBAAgB,CAAC,uDAAuD,CAAC,cAAc,CAAC,kBAAkB,CAAC,aAAa,CAA4C,kBAAkB,CAAC;AAChT,mBAAmB,eAAe,CAAC,eAAe,CAAC,CAAC,iCAAsE,eAAe,CAAC;AAC1I,uCAAuC,cAAc,CAAC,OAAO,CAAC,MAAM,CAAC,YAAY,CAAC,eAAe,CAAC;AAClG,iEAAiE,oBAAoB,CAAC;AACtF,mCAAmC,oBAAoB,CAAC;AACxD,mEAAmE,cAAc,CAAC,eAAe,CAAsC,eAAe,CAAC;AACvJ,2FAA2F,WAAW,CAAC;AACvG,kBAAkB,KAAK,CAAC;AACxB,iEAAgJ,oCAAoC,CAAC;AACrL,qBAAqB,QAAQ,CAAC,CAAC,mCAAoH,qCAAqC,CAAC;AACzL,aAAa,iBAAiB,CAAC,MAAM,CAAC,aAAa,CAAC,UAAU,CAAC,iBAAiB,CAAC;AACjF,wBAAwB,WAAW,CAAC,cAAc,CAAC;AACnD,gBAAgB,UAAU,CAAC;AAC3B,kBAAkB,UAAU,CAAC,sBAAsB,CAAC,aAAa,CAAC,oBAAoB,CAAC,2BAA2B,CAAC;AACnH,qCAAqC,cAAc,CAAC;AACpD,gDAAgD,4BAA4B,CAAC,aAAa,CAAC,oBAAoB,CAAC;AAChH,iFAAiF,aAAa,CAAC,oBAAoB,CAAC,wBAAwB,CAAsG,+CAA+C,CAAC;AAClS,oBAAoB,YAAY,CAAC,WAAW,CAAC,gBAAgB,CAAC,eAAe,CAAC,gBAAgB,CAAC,aAAa,CAAC,wCAAwC,CAAC,wBAAwB,CAA8R,6DAA6D,CAAC,0BAA0B,CAAC,qHAAqH,CAAC,oCAAoC,CAAC,sEAAsE,EAAC,wBAAyB,CAAC,kEAAkE,CAAkK,6EAA6E,CAAC,CAAC,2IAA2I,aAAa,CAAC,wBAAwB,EAAC,wBAAyB,CAAC;AAChyC,sDAAsD,2BAA2B,CAAC;AAClF,8BAA8B,aAAa,CAAC,UAAU,CAAC,UAAU,CAAC,wBAAwB,CAA0C,iBAAiB,CAAoF,sCAAsC,CAAC;AAChR,gCAAgC,cAAc,CAAC;AAC/C,sCAAsC,UAAU,CAAC,oBAAoB,CAAC,iCAAiC,CAAC,kCAAkC,CAAC,4BAA4B,CAAC,sCAAsC,CAAC,iBAAiB,CAAC,QAAQ,CAAC,QAAQ,CAAC;AACnP,qCAAqC,UAAU,CAAC,oBAAoB,CAAC,iCAAiC,CAAC,kCAAkC,CAAC,+BAA+B,CAAC,iBAAiB,CAAC,QAAQ,CAAC,SAAS,CAAC;AAC/M,mDAAmD,yBAAyB,CAAC,mCAAmC,CAAC,eAAe,CAAC,WAAW,CAAC,QAAQ,CAAC;AACtJ,kDAAkD,4BAA4B,CAAC,eAAe,CAAC,WAAW,CAAC,QAAQ,CAAC;AACpH,wCAAwC,wBAAwB,CAAC,2BAA2B,CAAC;AAC7F,sJAAsJ,wBAAwB,CAAC,aAAa,CAAC;AAC7L,iDAAiD,wBAAwB,CAAC,2BAA2B,CAAC;AACtG,2KAA2K,wBAAwB,CAAC,2BAA2B,CAAC;AAChO,gFAAgF,SAAS,CAAC,OAAO,CAAC,CAAC,8FAA8F,SAAS,CAAC,UAAU,CAAC;AACtN,4FAA4F,SAAS,CAAC,UAAU,CAAC;AACjH,8GAA8G,SAAS,CAAC,UAAU,CAAC,aAAa,CAAC,iBAAiB,CAA8D,2BAA2B,CAAC;AAC5P,8BAA8B,wBAAwB,CAA8R,6DAA6D,CAAC,0BAA0B,CAAC,qHAAqH,CAAC,oBAAoB,CAAC;AACxjB,iDAAiD,aAAa,CAAC,wCAAwC,CAAC,CAAC,6DAA6D,aAAa,CAAC;AACpL,uBAAuB,aAAa,CAAC;AACrC,6BAA6B,aAAa,CAAC;AAC3C,gEAAgE,4BAA4B,CAAC,aAAa,CAAC;AAC3G,yGAAyG,aAAa,CAAC,wBAAwB,CAAC;AAChJ,6BAA6B,aAAa,CAAC,CAAC,mCAAmC,aAAa,CAAC;AAC7F,kCAAkC,yBAAyB,CAAC,0BAA0B,CAAC;AACvF,8KAA8K,wBAAwB,CAAC,aAAa,CAAC;AACrN,gDAAgD,wBAAwB,CAAC,2BAA2B,CAAC;AACrG,yDAAyD,wBAAwB,CAAC,2BAA2B,CAAC;AAC9G,mMAAmM,wBAAwB,CAAC,2BAA2B,CAAC;AACxP,6CAA6C,aAAa,CAAC,wBAAwB,CAAC,oBAAoB,CAAwJ,wEAAwE,CAAiE,eAAe,CAAC,CAAC,8DAA8D,aAAa,CAAC;AACte,mEAAmE,aAAa,CAAC;AACjF,wEAAwE,aAAa,CAAC;AACtF,wGAAwG,gBAAgB,CAAC,aAAa,CAAC,2BAA2B,CAAC,wBAAwB,CAAC,QAAQ,CAAoF,sCAAsC,CAAC,SAAS,CAAC;AACzU,4BAA4B,aAAa,CAAC,wCAAwC,CAAC,wBAAwB,CAA8R,6DAA6D,CAAC,0BAA0B,CAAC,qHAAqH,CAAC,oCAAoC,CAAC,sEAAsE,EAAC,wBAAyB,CAAC,kEAAkE,CAAC,CAAC,mLAAmL,aAAa,EAA0B,wBAAyB,CAAC;AACthC,sEAAsE,2BAA2B,CAAC;AAClG,YAAY,gBAAgB,CAAC,eAAe,CAAC,eAAe,CAAC,wBAAwB,CAA0C,iBAAiB,CAAC,CAAC,eAAe,oBAAoB,EAAC,cAAe,EAAC,MAAO,CAAC,2BAA2B,CAAC,CAAC,wBAAwB,aAAa,CAAC,UAAU,CAAC;AAC5R,oBAAoB,aAAa,CAAC;AAClC,YAAY,aAAa,CAAC;AAC1B,eAAe,oBAAoB,EAAC,cAAe,EAAC,MAAO,CAAC,aAAa,CAAC,eAAe,CAA0C,iBAAiB,CAAwF,wCAAwC,CAAC;AACrR,kBAAkB,cAAc,CAAC;AACjC,2CAA2C,UAAU,CAAC,gBAAgB,CAAC,gBAAgB,CAAC,oBAAoB,CAAC,wBAAwB,CAAC,wBAAwB,CAAC,mBAAmB,CAAC;AACnL,+EAA+E,wBAAwB,CAAC;AACxG,qDAAqD,aAAa,CAAC,cAAc,CAAC;AAClF,0FAA0F,aAAa,CAAC,4BAA4B,CAAC,cAAc,CAAC;AACpJ,mEAAmE,qBAAqB,CAA2D,0BAA0B,CAAiE,6BAA6B,CAAC;AAC5Q,iEAA6H,2BAA2B,CAAmE,8BAA8B,CAAC;AAC1P,qBAAqB,iBAAiB,CAAC;AACvC,kBAAkB,gBAAgB,CAAC;AACnC,uDAAuD,iBAAiB,CAAC,gBAAgB,CAAC;AAC1F,+EAAyI,0BAA0B,CAAiE,6BAA6B,CAAC;AAClQ,6EAAyI,2BAA2B,CAAmE,8BAA8B,CAAC;AACtQ,4JAAsN,0BAA0B,CAAiE,6BAA6B,CAAC;AAC/U,wJAAoN,2BAA2B,CAAmE,8BAA8B,CAAC;AACjV,uDAAuD,gBAAgB,CAAC,gBAAgB,CAAC;AACzF,qDAAqD,aAAa,CAAC,gBAAgB,CAAC;AACpF,OAAO,aAAa,CAAC,eAAe,CAAC,iBAAiB,EAAC,MAAO,CAAC,CAAC,2BAA2B,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC;AAClI,aAAa,UAAU,CAAC;AACxB,UAAU,cAAc,CAAC;AACzB,2BAA2B,oBAAoB,CAAC,gBAAgB,CAAC,qBAAqB,CAAC,qBAAqB,CAA4C,kBAAkB,CAAC;AAC3K,kBAAkB,oBAAoB,CAAC,wBAAwB,CAAC;AAChE,iCAAiC,WAAW,CAAC;AAC7C,yCAAyC,UAAU,CAAC;AACpD,kEAAkE,aAAa,CAAC,qBAAqB,CAAC,cAAc,CAAC;AACrH,YAAY,iBAAiB,CAAC,eAAe,EAAC,MAAO,CAAC,CAAC,qCAAqC,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC;AACnI,kBAAkB,UAAU,CAAC;AAC7B,uBAAuB,aAAa,CAAC;AACrC,eAAe,UAAU,CAAC,kBAAkB,CAAC,gBAAgB,CAAC;AAC9D,WAAW,aAAa,CAAC,WAAW,CAAC,gBAAgB,CAAC,qBAAqB,CAA0C,iBAAiB,CAA0F,yCAAyC,CAAiH,+BAA+B,CAAC;AAC1Z,kBAAkB,oBAAoB,CAAgG,4CAA4C,CAAC;AACnL,eAAe,aAAa,CAAC,cAAc,CAAC,gBAAgB,CAAC,iBAAiB,CAAC;AAC/E,oBAAoB,WAAW,CAAC,aAAa,CAAC;AAC9C,OAAO,yBAAyB,CAAC,kBAAkB,CAAC,4CAA4C,CAAC,wBAAwB,CAAC,wBAAwB,CAA0C,iBAAiB,CAAC;AAC9M,iBAAiB,aAAa,CAAC;AAC/B,UAAU,QAAQ,CAAC;AACnB,cAAc,iBAAiB,CAAC,QAAQ,CAAC,WAAW,CAAC,gBAAgB,CAAC;AACtE,eAAe,wBAAwB,CAAC,oBAAoB,CAAC,aAAa,CAAC;AAC3E,kBAAkB,aAAa,CAAC;AAChC,2BAA2B,wBAAwB,CAAC,oBAAoB,CAAC,aAAa,CAAC;AACvF,iCAAiC,aAAa,CAAC;AAC/C,YAAY,wBAAwB,CAAC,oBAAoB,CAAC,aAAa,CAAC;AACxE,eAAe,aAAa,CAAC;AAC7B,aAAa,gBAAgB,CAAC,mBAAmB,CAAC;AAClD,+BAA+B,eAAe,CAAC;AAC/C,iBAAiB,cAAc,CAAC,CACgX,gCAAgC,KAAK,0BAA0B,CAAC,EAAE,GAAG,uBAAuB,CAAC,CAAC,CAAC,UAAU,eAAe,CAAC,WAAW,CAAC,kBAAkB,CAAC,wBAAwB,CAA8R,6DAA6D,CAAC,0BAA0B,CAAC,qHAAqH,CAAkG,6CAA6C,CAA0C,iBAAiB,CAAC;AACvvC,eAAe,QAAQ,CAAC,WAAW,CAAC,aAAa,CAAC,UAAU,CAAC,cAAc,CAAC,iBAAiB,CAAC,wCAAwC,CAAC,wBAAwB,CAA8R,6DAA6D,CAAC,0BAA0B,CAAC,qHAAqH,CAAkG,6CAA6C,CAAkD,qBAAqB,CAAkG,0BAA0B,CAAC;AAC99B,oBAA2K,wEAAwE,CAAC;AACpP,uBAAuB,wBAAwB,CAA64B,oMAAoM,CAA+F,yBAAyB,CAAC;AACzvC,sBAAkP,iDAAiD,CAAC;AACpS,4CAA4C,wBAAwB,CAA8R,6DAA6D,CAAC,0BAA0B,CAAC,qHAAqH,CAAC;AACjjB,qEAAqE,wBAAwB,CAA64B,oMAAoM,CAAC;AAC/qC,8CAA8C,wBAAwB,CAA8R,6DAA6D,CAAC,0BAA0B,CAAC,qHAAqH,CAAC;AACnjB,uEAAuE,wBAAwB,CAA64B,oMAAoM,CAAC;AACjrC,wCAAwC,wBAAwB,CAA8R,6DAA6D,CAAC,0BAA0B,CAAC,qHAAqH,CAAC;AAC7iB,iEAAiE,wBAAwB,CAA64B,oMAAoM,CAAC;AAC3qC,8CAA8C,wBAAwB,CAA8R,6DAA6D,CAAC,0BAA0B,CAAC,qHAAqH,CAAC;AACnjB,uEAAuE,wBAAwB,CAA64B,oMAAoM,CAAC;AACjrC,WAAW,YAAY,CAAC,kBAAkB,CAAC,cAAc,CAAC,eAAe,CAAC,gBAAgB,CAAC,aAAa,CAAC,wBAAwB,CAA0C,iBAAiB,CAAC,CAAC,cAAc,eAAe,CAAC,cAAc,CAAC,aAAa,CAAC,aAAa,CAAC,mBAAmB,CAAC;AAC3R,cAAc,gBAAgB,CAAC;AAC/B,mBAAmB,eAAe,EAAC,gBAAiB,CAAC,MAAM,CAAC;AAC5D,qBAAqB,eAAe,CAAC;AACrC,mBAAmB,YAAY,CAAC;AAChC,cAAc,aAAa,CAAC;AAC5B,eAAe,cAAc,CAAC;AAC9B,kBAAkB,iBAAiB,CAAC;AACpC,mBAAmB,gBAAgB,CAAC;AACpC,YAAY,aAAa,CAAC,eAAe,CAAC;AAC1C,SAAS,iBAAiB,CAAC,YAAY,CAAC,aAAa,CAAC,kBAAkB,CAAC,WAAW,CAAC,cAAc,CAAC,SAAS,CAAC,uBAAuB,CAAC,CAAC,YAAY,WAAW,CAAC,wBAAwB,CAAC;AACxL,aAAa,eAAe,CAAC;AAC7B,eAAe,eAAe,CAAC;AAC/B,gBAAgB,cAAc,CAAC;AAC/B,cAAc,gBAAgB,CAAC;AAC/B,eAAe,eAAe,CAAC,eAAe,CAAC,aAAa,CAAC,iBAAiB,CAAC,oBAAoB,CAAC,wBAAwB,CAA0C,iBAAiB,CAAC;AACxL,eAAe,iBAAiB,CAAC,OAAO,CAAC,QAAQ,CAAC,wBAAwB,CAAC,kBAAkB,CAAC;AAC9F,4BAA4B,QAAQ,CAAC,QAAQ,CAAC,gBAAgB,CAAC,sBAAsB,CAAC,wBAAwB,CAAC;AAC/G,8BAA8B,OAAO,CAAC,MAAM,CAAC,eAAe,CAAC,0BAA0B,CAAC,0BAA0B,CAAC;AACnH,6BAA6B,OAAO,CAAC,OAAO,CAAC,eAAe,CAAC,0BAA0B,CAAC,yBAAyB,CAAC;AAClH,+BAA+B,KAAK,CAAC,QAAQ,CAAC,gBAAgB,CAAC,sBAAsB,CAAC,2BAA2B,CAAC;AAClH,SAAS,iBAAiB,CAAC,KAAK,CAAC,MAAM,CAAC,YAAY,CAAC,YAAY,CAAC,WAAW,CAAC,WAAW,CAAC,eAAe,CAAC,wBAAwB,CAAC,mCAAmC,CAAC,4BAA4B,CAAC,2BAA2B,CAAC,qBAAqB,CAAC,mCAAmC,CAA0C,iBAAiB,CAAwF,wCAAwC,CAAC,kBAAkB,CAAC,CAAC,aAAa,gBAAgB,CAAC;AACvgB,eAAe,gBAAgB,CAAC;AAChC,gBAAgB,eAAe,CAAC;AAChC,cAAc,iBAAiB,CAAC;AAChC,eAAe,QAAQ,CAAC,gBAAgB,CAAC,cAAc,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,wBAAwB,CAAC,+BAA+B,CAA0D,yBAAyB,CAAC;AACxO,iBAAiB,gBAAgB,CAAC;AAClC,sCAAsC,iBAAiB,CAAC,aAAa,CAAC,OAAO,CAAC,QAAQ,CAAC,wBAAwB,CAAC,kBAAkB,CAAC;AACnI,gBAAgB,iBAAiB,CAAC;AAClC,sBAAsB,iBAAiB,CAAC,UAAU,CAAC;AACnD,oBAAoB,QAAQ,CAAC,iBAAiB,CAAC,qBAAqB,CAAC,qBAAqB,CAAC,oCAAoC,CAAC,YAAY,CAAC,CAAC,0BAA0B,UAAU,CAAC,iBAAiB,CAAC,qBAAqB,CAAC,wBAAwB,CAAC;AACpP,sBAAsB,OAAO,CAAC,UAAU,CAAC,gBAAgB,CAAC,mBAAmB,CAAC,uBAAuB,CAAC,sCAAsC,CAAC,CAAC,4BAA4B,QAAQ,CAAC,YAAY,CAAC,mBAAmB,CAAC,0BAA0B,CAAC;AAC/O,uBAAuB,QAAQ,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,wBAAwB,CAAC,uCAAuC,CAAC,SAAS,CAAC,CAAC,6BAA6B,OAAO,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,2BAA2B,CAAC;AACvP,qBAAqB,OAAO,CAAC,WAAW,CAAC,gBAAgB,CAAC,oBAAoB,CAAC,sBAAsB,CAAC,qCAAqC,CAAC,CAAC,2BAA2B,SAAS,CAAC,oBAAoB,CAAC,yBAAyB,CAAC,YAAY,CAAC;AAC9O,gBAAgB,cAAc,CAAC,KAAK,CAAC,OAAO,CAAC,QAAQ,CAAC,MAAM,CAAC,YAAY,CAAC,wBAAwB,CAAC,CAAC,qBAAqB,SAAS,CAAC;AACnI,wCAAwC,WAAW,CAAC,wBAAwB,CAAC;AAC7E,OAAO,cAAc,CAAC,OAAO,CAAC,QAAQ,CAAC,YAAY,CAAC,WAAW,CAAC,kBAAkB,CAAC,wBAAwB,CAAC,qBAAqB,CAAC,mCAAmC,EAAC,qBAAsB,CAA0C,iBAAiB,CAAsF,uCAAuC,CAAC,mCAAmC,CAAC,gCAAgC,CAAC,2BAA2B,CAAC,YAAY,CAAC,CAAC,YAA4K,+CAA+C,CAAC,QAAQ,CAAC;AACzsB,eAAe,OAAO,CAAC;AACvB,cAAc,gBAAgB,CAAC,4BAA4B,CAAC,CAAC,qBAAqB,cAAc,CAAC;AACjG,iBAAiB,QAAQ,CAAC,gBAAgB,CAAC;AAC3C,YAAY,iBAAiB,CAAC,eAAe,CAAC,gBAAgB,CAAC,YAAY,CAAC;AAC5E,YAAY,eAAe,CAAC;AAC5B,cAAc,sBAAsB,CAAC,eAAe,CAAC,gBAAgB,CAAC,wBAAwB,CAAC,yBAAyB,CAA0D,yBAAyB,CAAwE,gCAAgC,EAAC,MAAO,CAAC,CAAC,yCAAyC,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC;AAC7Y,oBAAoB,UAAU,CAAC;AAC/B,wBAAwB,eAAe,CAAC,eAAe,CAAC;AACxD,mCAAmC,gBAAgB,CAAC;AACpD,oCAAoC,aAAa,CAAC;AAClD,kBAAkB,iBAAiB,CAAC;AACpC,kBAAiB,kBAAmB,CAAC;AACrC,+CAA+C,SAAS,CAAC;AACzD,OAAO,oBAAoB,CAAC,OAAO,CAAC,QAAQ,CAAC,kBAAkB,CAAC,4BAA4B,CAAC,kCAAkC,CAAC,iCAAiC,CAAC,UAAU,CAAC;AAC7K,iBAAiB,cAAc,CAAC,eAAe,CAAC;AAChD,eAAe,iBAAiB,CAAC,QAAQ,CAAC,MAAM,CAAC,YAAY,CAAC,YAAY,CAAC,UAAU,CAAC,eAAe,CAAC,aAAa,CAAC,cAAc,CAAC,eAAe,CAAC,wBAAwB,CAAC,qBAAqB,CAAC,mCAAmC,EAAC,sBAAuB,EAAC,uBAAwB,CAA0C,iBAAiB,CAAwF,wCAAwC,CAAC,mCAAmC,CAAC,4BAA4B,CAAC,2BAA2B,CAAC,CAAC,0BAA0B,OAAO,CAAC,SAAS,CAAC;AAC5lB,yBAAwB,UAAW,CAAC,UAAU,CAAC,cAAc,EAAC,iBAAkB,CAAC,eAAe,CAAC,wBAAwB,CAAC,+BAA+B,CAAC;AAC1J,oBAAoB,aAAa,CAAC,gBAAgB,CAAC,UAAU,CAAC,kBAAkB,CAAC,gBAAgB,CAAC,aAAa,CAAC,kBAAkB,CAAC;AACnI,8EAA8E,oBAAoB,CAAC,aAAa,CAAC,wBAAwB,CAA8R,6DAA6D,CAAC,0BAA0B,CAAC,qHAAqH,CAAC;AACtnB,wDAAwD,aAAa,CAAC,oBAAoB,CAAC,SAAS,CAAC,wBAAwB,CAA8R,6DAA6D,CAAC,0BAA0B,CAAC,qHAAqH,CAAC;AAC1mB,4DAA4D,aAAa,CAAC;AAC1E,iCAAiC,oBAAoB,CAAC,4BAA4B,CAAC,qBAAqB,CAAC,kEAAkE,CAAC,cAAc,CAAC;AAC3L,OAAM,YAAa,CAAC,CAAC,sBAAsB,aAAa,CAAC;AACzD,2BAA2B,OAAO,CAAC,SAAS,CAAC;AAC7C,qDAAqD,YAAY,CAAC,+BAA+B,CAAC,UAAU,CAAC;AAC7G,qEAAqE,QAAQ,CAAC,WAAW,CAAC,iBAAiB,CAAC;AAC5G,kBAAkB,iBAAiB,CAAC;AACpC,iCAAiC,KAAK,CAAC,SAAS,CAAC,eAAe,CAAC,gBAAgB,CAA8D,2BAA2B,CAAC;AAC3K,uCAAuC,aAAa,CAAC;AACrD,yCAAyC,QAAQ,CAAC,QAAQ,CAAC,YAAY,CAAC,kBAAkB,CAA8D,2BAA2B,CAAC;AACpL,0BAA0B,aAAa,CAAC,WAAW,CAAC,WAAW,CAAC,OAAO,CAAC,QAAQ,CAAC,wBAAwB,CAAC,kBAAkB,CAAC,0BAA0B,CAAC,yBAAyB,CAAC,cAAc,CAAC,kBAAkB,CAAC;AACpN,gCAAgC,yBAAyB,CAAC;AAC1D,4BAA4B,UAAU,CAAC,CAAC,2CAA2C,UAAU,CAAC,gBAAgB,CAA8D,2BAA2B,CAAC;AACxM,qCAAqC,iBAAiB,CAAC,kBAAkB,CAAC;AAC1E,WAAW,YAAY,CAAC,cAAc,CAA0C,iBAAiB,CAAC;AAClG,WAAW,kBAAkB,CAAC;AAC9B,8IAA8I;AAC9I,iBAAiB,WAAW,CAAC,wBAAwB,CAAC,yBAAyB,CAAC,kBAAkB,CAAC;AACnG,mBAAmB,eAAe,CAAC;AACnC,qCAAqC,aAAa,CAAC,gBAAgB;AACnE,mDAAmD,yBAAyB,CAAC;AAC7E,kBAAkB,cAAc,CAAC;AACjC,mEAAmE;AACnE,iBAAiB,gBAAgB,CAAC,oCAAoC,CAAC;AACvE,UAAU,iBAAiB,CAAC,kBAAkB,CAAC,aAAa,CAAC;AAC7D,gBAAgB,eAAe,CAAC,UAAU,CAAC,iBAAiB,CAAC;AAC7D,sBAAsB,YAAY,CAAC,iBAAiB,CAAoH,gCAAgC,CAAC;AACzM,0BAA0B,aAAa,CAAC,aAAa,CAAC;AACtD,oEAAoE,aAAa,CAAC;AAClF,wBAAwB,MAAM,CAAC;AAC/B,4CAA4C,iBAAiB,CAAC,KAAK,CAAC,UAAU,CAAC;AAC/E,sBAAsB,SAAS,CAAC;AAChC,sBAAsB,UAAU,CAAC;AACjC,uDAAuD,MAAM,CAAC;AAC9D,6BAA6B,UAAU,CAAC;AACxC,8BAA8B,SAAS,CAAC;AACxC,kBAAkB,iBAAiB,CAAC,OAAO,CAAC,SAAS,CAAC,UAAU,CAAC,WAAW,CAAC,gBAAgB,CAAC,cAAc,CAAC,eAAe,CAAC,gBAAgB,CAAC,aAAa,CAAC,iBAAiB,CAAC,kBAAkB,CAAC,wBAAwB,CAA4C,kBAAkB,CAAC,WAAW,CAAC,wBAAwB,CAAC,CAAC,wBAAwB,SAAS,CAAC,UAAU,CAAC;AAC3W,wBAAwB,aAAa,CAAC,oBAAoB,CAAC,WAAW,CAAC,wBAAwB,CAAC;AAChG,kBAAkB,iBAAiB,CAAC,MAAM,CAAC,OAAO,CAAC,QAAQ,CAAC,YAAY,CAAC,kBAAkB,CAAC,8BAA8B,CAAC;AAC3H,yCAAyC,aAAa,CAAC,gBAAgB,CAAC;AACxE,qBAAqB,cAAc,CAAC;AACpC,oBAAoB,eAAe,CAAC;AACpC,MAAM,eAAe,CAAC,YAAY,CAAC,kBAAkB,CAAC,wBAAwB,CAAC,wBAAwB,CAA0C,iBAAiB,CAAoG,8CAA8C,CAAC,CAAC,iBAAiB,iBAAiB,CAAC,gCAAgC,CAAC;AAC1X,YAAY,YAAY,CAA0C,iBAAiB,CAAC;AACpF,YAAY,WAAW,CAA0C,iBAAiB,CAAC;AACnF,OAAO,WAAW,CAAC,cAAc,CAAC,gBAAgB,CAAC,gBAAgB,CAAC,aAAa,CAAC,2BAA2B,CAAC,WAAW,CAAC,wBAAwB,CAAC,CAAC,aAAa,aAAa,CAAC,oBAAoB,CAAC,cAAc,CAAC,WAAW,CAAC,wBAAwB,CAAC;AACxP,aAAa,SAAS,CAAC,cAAc,CAAC,sBAAsB,CAAC,QAAQ,CAAC,uBAAuB,CAAC;AAC9F,YAAY,WAAW,CAAC;AACxB,WAAW,UAAU,CAAC;AACtB,MAAM,YAAY,CAAC;AACnB,MAAM,aAAa,CAAC;AACpB,WAAW,iBAAiB,CAAC;AAC7B,OAAO,cAAc,CAAC;AACtB,MAAM,SAAS,CAAiH,+BAA+B,CAAC,CAAC,SAAS,SAAS,CAAC;AACpL,UAAU,iBAAiB,CAAC,QAAQ,CAAC,eAAe,CAAwG,4BAA4B,CAAC,CAAC,aAAa,WAAW,CAAC;AACnN,QAAQ,YAAY,CAAC,iBAAiB,CAAC;AACvC,eAAe,uBAAuB,CAAC;AACvC,gBAAgB,uBAAuB,CAAC;AACxC,gBAAgB,uBAAuB,CAAC;AACxC,iBAAiB,0BAA0B,CAAC;AAC5C,+CAA+C,gBAAgB,0BAA0B,CAAC,EAAE,iBAAiB,wBAAwB,CAAC,EAAE,gBAAgB,0BAA0B,CAAC,EAAE,eAAe,uBAAuB,CAAC,CAAC,CAAC,yBAAyB,gBAAgB,0BAA0B,CAAC,EAAE,iBAAiB,uBAAuB,CAAC,EAAE,eAAe,0BAA0B,CAAC,EAAE,cAAc,uBAAuB,CAAC,CAA2B,KAAK,iBAAiB,CAAC,kBAAkB,CAAC,EAAE,0DAA0D,iBAAiB,CAAC,kBAAkB,CAAC,EAAE,iBAAiB,SAAS,CAAC,EAAE,kBAAkB,UAAU,CAAC,UAAU,CAAC,UAAU,CAAC,eAAe,CAAC,EAAE,kBAAkB,aAAa,CAAC,EAAE,WAAW,UAAU,CAAC,EAAE,WAAW,UAAU,CAAC,EAAE,iBAAiB,aAAa,CAAC,EAAE,eAAe,UAAU,CAAC,aAAa,CAAC,EAAE,4EAA4E,UAAU,CAAC,aAAa,CAAC,UAAU,CAAC,aAAa,CAAkD,qBAAqB,CAAC,EAAE,2BAA2B,UAAU,CAAkD,qBAAqB,CAAC,EAAE,yCAAyC,aAAa,CAAC,EAAE,+HAA+H,aAAa,CAAC,UAAU,CAAC,eAAe,CAAkD,qBAAqB,CAAC,EAAE,gHAAgH,oBAAoB,CAAC,UAAU,CAAC,EAAE,8CAA8C,aAAa,CAAC,EAAE,OAAO,cAAc,CAAC,QAAQ,CAAC,SAAS,CAAC,UAAU,CAAC,UAAU,CAAC,QAAQ,CAAC,CAAC,YAAY,UAAU,CAAC,EAAE,eAAe,QAAQ,CAAC,CAAh1C,CAAk1C,yBAAyB,cAAc,sCAAsC,CAAC,EAAE,sBAAsB,aAAa,CAAC,gBAAgB,CAAC,EAAE,2CAA2C,qBAAqB,CAAC,EAAE,gCAAgC,UAAU,CAAC,UAAU,CAAC,aAAa,CAAC,eAAe,CAAC,EAAE,2BAA2B,aAAa,CAAC,EAAE,+BAA+B,aAAa,CAAC,EAAE,+BAA+B,iBAAiB,CAAC,kBAAkB,CAAC,EAAE,qCAAqC,UAAU,CAAC,aAAa,CAAC,kBAAkB,CAAC,EAAE,cAAc,cAAc,CAAC,aAAa,CAAC,EAAE,OAAO,QAAQ,CAAC,SAAS,CAAC,UAAU,CAAC,EAAE,qBAAqB,YAAY,CAAC,YAAY,CAAC,EAAE,kBAAkB,eAAe,CAAC,CAAC,CAAC,+CAA+C,KAAK,iBAAiB,EAAC,MAAO,CAAC,CAAC,uBAAuB,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC,EAAE,WAAW,UAAU,CAAC,EAAE,gBAAgB,UAAU,CAAC,cAAc,CAAC,gBAAgB,CAAC,EAAE,sGAAsG,WAAW,CAAC,EAAE,QAAQ,WAAW,CAAC,EAAE,QAAQ,WAAW,CAAC,EAAE,QAAQ,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,UAAU,CAAC,EAAE,UAAU,iBAAiB,CAAC,EAAE,UAAU,iBAAiB,CAAC,EAAE,UAAU,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,gBAAgB,CAAC,EAAE,WAAW,UAAU,EAAC,MAAO,CAAC,CAAC,mCAAmC,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC,EAAE,iBAAiB,UAAU,CAAC,EAAE,2BAA2B,aAAa,CAAC,UAAU,CAAC,eAAe,CAAkD,qBAAqB,CAAC,UAAU,EAAiC,8BAA+B,CAAC,EAAE,uCAAuC,aAAa,CAAC,EAAE,yDAAyD,+BAA+B,CAAC,EAAE,oBAA8B,wBAAyB,CAAC,EAAE,oBAA4C,wBAAyB,CAAC,EAAE,oBAA4C,wBAAyB,CAAC,EAAE,mBAA2C,wBAAyB,CAAC,EAAE,mBAA2C,wBAAyB,CAAC,EAAE,mBAA2C,wBAAyB,CAAC,EAAE,mBAA2C,wBAAyB,CAAC,EAAE,mBAA2C,wBAAyB,CAAC,EAAE,mBAA4C,wBAAyB,CAAC,EAAE,mBAA2C,wBAAyB,CAAC,EAAE,mBAA0C,yBAA0B,CAAC,EAAE,mBAA2C,wBAAyB,CAAC,EAAE,sBAAqD,+BAAgC,CAAC,EAAE,kCAAiE,8BAA+B,CAAC,EAAE,sBAAoD,6BAA8B,CAAC,EAAE,kCAA+D,8BAA+B,CAAC,EAAE,sBAAoD,6BAA8B,CAAC,EAAE,kCAA+D,8BAA+B,CAAC,EAAE,qBAAkD,8BAA+B,CAAC,EAAE,iCAA+D,8BAA+B,CAAC,EAAE,qBAAkD,8BAA+B,CAAC,EAAE,iCAA+D,8BAA+B,CAAC,EAAE,qBAAmD,+BAAgC,CAAC,EAAE,iCAA+D,+BAAgC,CAAC,EAAE,qBAAmD,+BAAgC,CAAC,EAAE,iCAA+D,8BAA+B,CAAC,EAAE,qBAAmD,8BAA+B,CAAC,EAAE,iCAA+D,8BAA+B,CAAC,EAAE,qBAAmD,8BAA+B,CAAC,EAAE,iCAA+D,8BAA+B,CAAC,EAAE,qBAAmD,+BAAgC,CAAC,EAAE,iCAA+D,+BAAgC,CAAC,EAAE,qBAAmD,+BAAgC,CAAC,EAAE,iCAA+D,8BAA+B,CAAC,EAAE,qBAAmD,+BAAgC,CAAC,EAAE,iCAA8D,8BAA+B,CAAC,EAAE,iCAAiC,aAAa,CAAC,EAAE,8CAA8C,gBAAgB,CAAC,EAAE,wDAAwD,WAAW,CAAC,EAAE,wDAAwD,WAAW,CAAC,EAAE,wDAAwD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,UAAU,CAAC,EAAE,qDAAqD,UAAU,CAAC,CAAC,CAAC,0BAA0B,KAAK,iBAAiB,EAAC,MAAO,CAAC,CAAC,uBAAuB,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC,EAAE,WAAW,UAAU,CAAC,EAAE,gBAAgB,UAAU,CAAC,cAAc,CAAC,gBAAgB,CAAC,EAAE,sGAAsG,YAAY,CAAC,EAAE,QAAQ,YAAY,CAAC,EAAE,QAAQ,YAAY,CAAC,EAAE,QAAQ,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,WAAW,CAAC,EAAE,OAAO,UAAU,CAAC,EAAE,UAAU,kBAAkB,CAAC,EAAE,UAAU,kBAAkB,CAAC,EAAE,UAAU,kBAAkB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,SAAS,iBAAiB,CAAC,EAAE,WAAW,UAAU,EAAC,MAAO,CAAC,CAAC,mCAAmC,aAAa,CAAC,UAAU,CAAC,aAAa,CAAC,EAAE,iBAAiB,UAAU,CAAC,EAAE,2BAA2B,aAAa,CAAC,UAAU,CAAC,eAAe,CAAkD,qBAAqB,CAAC,UAAU,EAAgC,+BAAgC,CAAC,EAAE,uCAAuC,aAAa,CAAC,EAAE,yDAAyD,8BAA8B,CAAC,EAAE,oBAA8B,wBAAyB,CAAC,EAAE,oBAA4C,wBAAyB,CAAC,EAAE,oBAA4C,uBAAwB,CAAC,EAAE,mBAA2C,wBAAyB,CAAC,EAAE,mBAA2C,wBAAyB,CAAC,EAAE,mBAA2C,wBAAyB,CAAC,EAAE,mBAA4C,yBAA0B,CAAC,EAAE,mBAA2C,wBAAyB,CAAC,EAAE,mBAA4C,yBAA0B,CAAC,EAAE,mBAA4C,yBAA0B,CAAC,EAAE,mBAA2C,yBAA0B,CAAC,EAAE,mBAA2C,wBAAyB,CAAC,EAAE,sBAAqD,+BAAgC,CAAC,EAAE,kCAAiE,+BAAgC,CAAC,EAAE,sBAAoD,8BAA+B,CAAC,EAAE,kCAAgE,8BAA+B,CAAC,EAAE,sBAAoD,8BAA+B,CAAC,EAAE,kCAAgE,8BAA+B,CAAC,EAAE,qBAAmD,8BAA+B,CAAC,EAAE,iCAA+D,8BAA+B,CAAC,EAAE,qBAAmD,8BAA+B,CAAC,EAAE,iCAA+D,8BAA+B,CAAC,EAAE,qBAAoD,8BAA+B,CAAC,EAAE,iCAA+D,8BAA+B,CAAC,EAAE,qBAAmD,+BAAgC,CAAC,EAAE,iCAA+D,+BAAgC,CAAC,EAAE,qBAAoD,6BAA8B,CAAC,EAAE,iCAA+D,8BAA+B,CAAC,EAAE,qBAAmD,+BAAgC,CAAC,EAAE,iCAA+D,+BAAgC,CAAC,EAAE,qBAAoD,6BAA8B,CAAC,EAAE,iCAAgE,8BAA+B,CAAC,EAAE,qBAAmD,+BAAgC,CAAC,EAAE,iCAAgE,8BAA+B,CAAC,EAAE,qBAAmD,+BAAgC,CAAC,EAAE,iCAA+D,8BAA+B,CAAC,EAAE,iCAAiC,aAAa,CAAC,EAAE,8CAA8C,gBAAgB,CAAC,EAAE,wDAAwD,YAAY,CAAC,EAAE,wDAAwD,YAAY,CAAC,EAAE,wDAAwD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,WAAW,CAAC,EAAE,qDAAqD,UAAU,CAAC,EAAE,YAAY,iBAAiB,CAAC,EAAE,eAAe,gBAAgB,CAAC,EAAE,uBAAuB,aAAa,CAAC,CAAC,CAAC,yBAAyB,KAAK,aAAa,CAAC,EAAE,uCAAuC,eAAe,CAAC,EAAE,kBAAkB,kBAAkB,CAAC,EAAE,qBAAqB,eAAe,CAAC,EAAE,mEAAmE,WAAW,CAAC,EAAE,mBAAmB,UAAU,CAAC,SAAS,CAAC,EAAE,eAAe,iBAAiB,CAAC,kBAAkB,CAAC,iBAAiB,CAAC,EAAE,cAAc,UAAU,CAAC,EAAE,mBAAmB,UAAU,CAAC,eAAe,CAAC,EAAE,sBAAsB,UAAU,CAAC,EAAE,wBAAwB,iBAAiB,CAAC,EAAE,qCAAqC,YAAY,CAAC,EAAE,+BAA+B,aAAa,CAAC,gBAAgB,CAAC,EAAE,uDAAuD,gBAAgB,CAAC,gBAAgB,CAAC,aAAa,CAA0C,iBAAiB,CAAC,EAAE,mBAAmB,oBAAoB,CAAC,kBAAkB,CAA0C,iBAAiB,CAAC,EAAE,qCAAqC,iBAAiB,CAAC,EAAE,mEAAmE,wBAAwB,CAAC,EAAE,uFAAuF,aAAa,CAAC,EAAE,mGAAmG,wBAAwB,CAAC,EAAE,4BAA4B,cAAc,CAAC,SAAS,CAAC,EAAE,6BAA6B,eAAe,CAAC,QAAQ,CAAC,SAAS,CAAC,UAAU,CAAC,YAAY,CAAC,cAAc,CAAC,aAAa,CAAC,SAAS,CAAC,4BAA4B,CAAC,WAAW,CAAsC,eAAe,CAAsC,eAAe,CAAC,EAAE,mCAAmC,aAAa,CAAC,EAAE,uEAAuE,YAAY,CAAC,EAAE,sCAAsC,YAAY,CAAC,EAAE,uFAAuF,YAAY,CAAC,EAAE,wDAAwD,UAAU,CAAC,iBAAiB,CAAC,aAAa,CAAC,4BAA4B,CAAC,+BAA+B,CAA8J,2EAA2E,CAAC,EAAE,wFAAwF,wBAAwB,CAAC,2BAA2B,CAAC,EAAE,sCAAsC,UAAU,CAAC,aAAa,CAAC,EAAE,qCAAqC,eAAe,CAAC,QAAQ,CAAC,EAAE,oBAAoB,aAAa,CAAC,EAAE,6BAA6B,iBAAiB,CAAC,kBAAkB,CAAC,CAAC,CAAC,yBAAyB,uBAAuB,sBAAsB,CAAC,2BAA2B,CAAC,CAAC;AC5lB90f;;;;;;;;EAQE;AACF;KACI,OAAQ;AACZ;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;KACd,kBAAmB;KACnB,UAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IAKzB,8DAA8D;IAC9D,2BAA2B;IAC3B,sHAAsH;IACtH,yBAAyB;IAEzB,kBAAkB;IAGlB,0CAA0C;KAC1C,OAAQ;AACZ;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,gBAAgB;KAChB,OAAQ;AACZ;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;;;IAGI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;;;IAGI,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,2DAA2D;IAC3D,eAAe;IACf,mBAAmB;IACnB,cAAc;IAGd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IAGI,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,QAAQ;IACR,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAGhB,gBAAgB;AACpB;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;IACI,MAAM;AACV;;AAEA;;IAII,wCAAwC;AAC5C;;AAEA;IACI,SAAS;AACb;;AAEA;IAGI,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,cAAc;IACd,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;;IAEX;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,cAAc;IACd,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,eAAe;IACf,6BAA6B;IAC7B,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;IAGI,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IAGzB,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,yCAAyC;IACzC,yBAAyB;IAKzB,8DAA8D;IAC9D,2BAA2B;IAC3B,sHAAsH;IACtH,qCAAqC;IACrC,uEAAuE;KACvE,yBAA0B;IAC1B,uFAAuF;;IAEvF,iEAAiE;IAGjE,oFAAoF;AACxF;;AAEA;;;;;IAKI,cAAc;IACd,yBAAyB;KACzB,yBAA0B;AAC9B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,yBAAyB;IAGzB,kBAAkB;IAGlB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kCAAkC;IAClC,mCAAmC;IACnC,gCAAgC;IAChC,uCAAuC;IACvC,kBAAkB;IAClB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kCAAkC;IAClC,mCAAmC;IACnC,gCAAgC;IAChC,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;IACpC,gBAAgB;IAChB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY;IACZ,SAAS;AACb;;AAEA;;;IAGI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;;;IAGI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;;IAEI,UAAU;IACV,QAAQ;AACZ;;AAEA;;IAEI,UAAU;IACV,WAAW;AACf;;AAEA;;IAEI,UAAU;IACV,WAAW;AACf;;AAEA;;IAEI,UAAU;IACV,WAAW;IACX,cAAc;IACd,kBAAkB;IAGlB,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IAKzB,8DAA8D;IAC9D,2BAA2B;IAC3B,sHAAsH;IACtH,qBAAqB;AACzB;;AAEA;;IAEI,cAAc;IACd,yCAAyC;AAC7C;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;;;IAGI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;;;IAGI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;;;IAGI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IAGrB,+EAA+E;IAI/E,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,cAAc;IACd,4BAA4B;IAC5B,yBAAyB;IACzB,SAAS;IAGT,uCAAuC;IACvC,UAAU;AACd;;AAEA;IACI,cAAc;IACd,yCAAyC;IACzC,yBAAyB;IAKzB,8DAA8D;IAC9D,2BAA2B;IAC3B,sHAAsH;IACtH,qCAAqC;IACrC,uEAAuE;KACvE,yBAA0B;IAC1B,uFAAuF;;IAEvF,iEAAiE;AACrE;;AAEA;;;;;IAKI,cAAc;KAEd,yBAA0B;AAC9B;;AAEA;;IAEI,4BAA4B;AAChC;ACjmBA;;;;;;;;EAQE;AACF;KACI,OAAQ;AACZ;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAGhB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,6CAA6C;IAC7C,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,cAAc;IACd,wCAAwC;IACxC,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;KACI,WAAY;IACZ,WAAW;IACX,eAAe;KACf,kBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;;KAEI,OAAQ;AACZ;;AAEA;;;;IAII,cAAc;IACd,WAAW;IACX,cAAc;AAClB;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,6BAA6B;IAG7B,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;;IAEI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAGlB,kBAAkB;AACtB;;AAEA;;IAEI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IAGzB,gBAAgB;AACpB;;AAEA;IAGI,4BAA4B;IAG5B,2BAA2B;AAC/B;;AAEA;IAGI,+BAA+B;IAG/B,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IAGI,0BAA0B;AAC9B;;AAEA;IAGI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA,8BAA8B;AAC9B;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,eAAe;AACnB;;AAEA;;;IAGI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;;IAGI,yBAAyB;IACzB,4BAA4B;IAC5B,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;KACI,OAAQ;AACZ;;AAEA;;IAEI,cAAc;IACd,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IAGI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;;IAEI,iDAAiD;AACrD;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAGlB,0BAA0B;AAC9B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;;IAEI,iDAAiD;KACjD,2BAA4B;AAChC;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IAGjB,0BAA0B;AAC9B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;;IAEI,iDAAiD;KACjD,0BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,6BAA6B;IAC7B,eAAe;AACnB;AChbA;;;;4EAI4E;;AAE5E;mCACmC;AACnC;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,SAAS;IACT,UAAU;IACV,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa,EAAE,iBAAiB;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,kBAAkB;IAClB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;;AAGA;mCACmC;AACnC;IACI,0BAA0B;AAC9B;;;AAGA;mCACmC;;AAEnC,sBAAsB;AACtB;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,4BAA4B;AAChC;;;AAGA;mCACmC;;AAEnC,aAAa;AACb;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,SAAS;IACT,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,UAAU;IACV,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,UAAU;IACV,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,WAAW;IACX,WAAW;IACX,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,aAAa,EAAE,iBAAiB;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB,EAAE,8BAA8B;AACrD;;AAEA;;;;;IAKI,qBAAqB;AACzB;;AAEA,4DAA4D;AAC5D;IACI,YAAY;AAChB;;AAEA,qDAAqD;AACrD;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA,wBAAwB;AACxB;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA,mEAAmE;AACnE;IACI,iBAAiB;AACrB;;AAEA,2BAA2B;AAC3B;;;;;IAKI,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;;;IAGI,UAAU;AACd;;AAEA;;;IAGI,WAAW;AACf;;AAEA,gBAAgB;AAChB;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB,mDAAmD;AACnD;;IAEI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,oBAAoB;IACpB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,aAAa;AACjB;;AAEA;;IAEI,QAAQ;AACZ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,SAAS;IACT,YAAY;AAChB;;AAEA;;IAEI,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,eAAe;IACf,4BAA4B;IAC5B,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA,4BAA4B;AAC5B;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,WAAW;IACX,YAAY;AAChB;;AAEA,gBAAgB;AAChB;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,YAAY;AAChB;;AAEA;;IAEI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;IACtB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,YAAY;IACZ,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,aAAa,EAAE,iBAAiB;IAChC,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,uDAAuD;IACvD,YAAY;IACZ,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,cAAc;IACd,SAAS;IACT,wBAAwB;AAC5B;;AAEA,wBAAwB;AACxB;;IAEI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,OAAO;IACP,WAAW;AACf;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,UAAU;IACV,cAAc;IACd,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,eAAe;IACf,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,QAAQ;AACZ;;AAEA,8DAA8D;AAC9D;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,gBAAgB;IAChB,QAAQ;IACR,OAAO;AACX;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,kBAAkB,EAAE,uIAAuI;IAC3J,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,oBAAoB;IACpB,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAEhB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;mCACmC;AACnC;IACI,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;;;;IAII,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,2FAA2F;IAC3F,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;mCACmC;AACnC;;;IAGI,+BAA+B;IAC/B,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;;IAGI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;;;;IAMI,yBAAyB;IACzB,2FAA2F;IAC3F,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;;;IAII,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;IAGI,yBAAyB;IACzB,2FAA2F;IAC3F,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;;IAGI,cAAc;IACd,qBAAqB;AACzB;;AAEA;mCACmC;AACnC;;;IAGI,yBAAyB;IACzB,2FAA2F;IAC3F,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;;IAGI,yBAAyB;IACzB,2FAA2F;IAC3F,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;;IAGI,iBAAiB;AACrB;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;;IAGI,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB,EAAE,wBAAwB;AACvD;;AAEA;mCACmC;;AAEnC,sBAAsB;AACtB;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;AAClC;;AAEA;;IAEI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;;IAEI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;IACI,oEAAoE;AACxE;;AAEA;;IAEI,oEAAoE;AACxE;;AAEA,gBAAgB;AAChB;IACI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA,qEAAqE;AACrE;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;;AAGA;mCACmC;;AAEnC,kBAAkB;AAClB;;;;IAII,2BAA2B;AAC/B;;AAEA;;;;IAII,4BAA4B;AAChC;;AAEA;;;;IAII,8BAA8B;AAClC;;AAEA;;;;IAII,+BAA+B;AACnC;;AAEA,aAAa;AACb;IACI,0FAA0F;IAC1F,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,0FAA0F;IAC1F,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;AC3zDA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,UAAU;AACd;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,4BAA4B;AAC5B;IACI,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;IAEI,qBAAqB;IACrB,SAAS;AACb;;AAEA;;IAEI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;;IAEI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;AC5GA;;EAEE;AACF;IACI,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;KACf,YAAa;AACjB;;;AAGA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;EAEE;AACF;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;KACX,OAAQ;AACZ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;;AAGA;;EAEE;AACF;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;AACb;;AAEA;;EAEE;AACF;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;;EAEE;AACF;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,WAAW;AACf;;AAEA;;EAEE;AACF;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,SAAS;IACT,eAAe;KACf,YAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,eAAe;KACf,YAAa;IACb,yBAAyB;AAC7B;;AAEA;;EAEE;;AAEF;;EAEE;AACF;IACI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,eAAe;KACf,YAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,eAAe;KACf,YAAa;IACb,yBAAyB;AAC7B;;AAEA,2BAA2B;AAC3B;IACI;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,gBAAgB;IAChB,aAAa;IACb,eAAe;KACf,YAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,yBAAyB;IACzB,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;;EAEE;AACF;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,uBAAuB;AAC3B;;AAEA;;EAEE;AACF;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;;EAEE;AACF;IACI,WAAW;AACf;;AAEA;KACI,gBAAiB;IACjB,iCAAiC;AACrC;;AAEA;;EAEE;;AAEF;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;KACf,YAAa;AACjB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;ACtaA;;;;;;;;;;;;;;;;;;;;;EAqBE;;;AAGF;;;EAGE;AACF;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;;IAGI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;KACf,YAAa;IACb,iBAAiB;IACjB,uBAAuB;IAMvB,kBAAkB;IAIlB,mCAAmC;IACnC,kCAAkC;IAClC,+BAA+B;;IAE/B,4DAA4D;IAC5D,mBAAmB,EAAE,iBAAiB,EACiD,yBAAyB,EAC5B,WAAW,EACZ,UAAU,EACX,iBAAiB;IACnG,6EAA6E,EAAE,QAAQ;IACvF,kHAAkH,EAAE,UAAU;AAClI;;;AAGA,8FAA8F;AAC9F;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;IAGI,yBAAyB;IACzB,gCAAgC;IAIhC,mCAAmC;IACnC,kCAAkC;IAClC,+BAA+B;;IAE/B,mBAAmB,EAAE,iBAAiB,EACiD,yBAAyB,EAC5B,WAAW,EACZ,UAAU,EACX,iBAAiB;IACnG,6EAA6E,EAAE,QAAQ;IACvF,kHAAkH,EAAE,UAAU;AAClI;;AAEA;;;IAGI,cAAc;IACd,yBAAyB;;IAEzB,mBAAmB,EAAE,iBAAiB,EACiD,yBAAyB,EAC5B,WAAW,EACZ,UAAU,EACX,iBAAiB;IACnG,6EAA6E,EAAE,QAAQ;IACvF,kHAAkH,EAAE,UAAU;AAClI;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwCE;;AAEF;IACI,mBAAmB;IACnB,oEAAoE;AACxE;;AAEA;IACI,mBAAmB;IACnB,kFAAkF;AACtF;;;AAGA;;;CAGC;AACD;IACI,eAAe;KACf,YAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;;;EAGE;;AAEF;IACI,YAAY;IACZ,wBAAwB;IACxB,yBAAyB;IACzB,oCAAoC;IACpC,yBAAyB;IACzB,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;IAMb,kBAAkB;IAIlB,8CAA8C;IAC9C,6CAA6C;IAC7C,0CAA0C;AAC9C;;AAEA;IACI,yEAAyE;IACzE,aAAa;AACjB;;AAEA;;;IAGI,kBAAkB;IAClB,OAAO;IACP,QAAQ;;IAER,cAAc;IACd,WAAW;IACX,kBAAkB;IAIlB,mCAAmC;IACnC,kCAAkC;IAClC,+BAA+B;AACnC;;;AAGA;;;CAGC;;AAED;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;;IAElB,mBAAmB,EAAE,iBAAiB,EACiD,yBAAyB,EAC5B,WAAW,EACZ,UAAU,EACX,iBAAiB;IACnG,6EAA6E,EAAE,QAAQ;IACvF,kHAAkH,EAAE,UAAU;;IAE9H,aAAa;;IAEb,uBAAuB;IACvB,oCAAoC;IAMpC,kBAAkB;IAIlB,4CAA4C;IAC5C,2CAA2C;IAC3C,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;AC9TA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA+BE;;AAEF;;;EAGE;AACF;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;KACf,YAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,UAAU;AACd;;AAEA;;;EAGE;AACF;IACI,eAAe;KACf,YAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;EAGE;;AAEF;IACI,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IAIb,0CAA0C;AAC9C;;AAEA;IACI,6DAA6D;IAC7D,aAAa;AACjB;;AAEA;;;IAGI,WAAW;IACX,WAAW;IACX,qBAAqB;AACzB;;AAEA;;;CAGC;;AAED;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;;IAElB,YAAY;IAIZ,kBAAkB;IAIlB,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;;EAGE;;AAEF;IACI,cAAc;AAClB;ACjLA,qBAAqB;;AAErB;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA,eAAe;;AAEf;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;AClFA;IACI,YAAY;AAChB;ACFA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IAMzB,8DAA8D;IAC9D,2BAA2B;IAC3B,kHAAkH;IAClH,yBAAyB;IAGzB,kBAAkB;IAGlB,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;AACnB;ACrDA,oBAAoB;;AAEpB;IACI,cAAc;AAClB;;AAEA;IACI,yDAAyD;AAC7D;;AAEA;IACI,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;;;;;;;;CAQC;;AAED;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,uBAAuB;IACvB,yBAAyB;AAC7B;ACnIA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;ACtCA;;;EAGE;AACF;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;AC9qKA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,0CAA0C;IAC1C,6DAA6D;IAC7D,uFAAuF;IACvF,kHAAkH;IAClH,yBAAyB;IACzB,8BAA8B;IAC9B,+BAA+B;IAC/B,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,4BAA4B;IAC5B,0BAA0B;IAC1B,eAAe;AACnB;;AAEA,kBAAkB;;AAElB;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;AC5NA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;ACjDA;IACI,OAAO;IACP,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,SAAS;IACT,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,QAAQ;IACR,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IAKf;QACI,cAAc;;QAEd;YACI,cAAc;QAClB;IACJ;AAVJ;;AAaA;IACI;QACI,cAAc;;QAEd;YACI,cAAc;QAClB;IACJ;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,6BAA6B;;IAE7B;QACI,yBAAyB;QACzB,yBAAyB;QACzB,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qCAAqC;IACrC,4BAA4B;IAC5B,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;IAChB,kCAAkC;IAClC,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,iDAAiD;IACjD,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;IACrC,4BAA4B;IAC5B,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,gBAAgB;IAChB,kCAAkC;IAClC,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,iDAAiD;IACjD,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,4BAA4B;IAC5B,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,iDAAiD;IACjD,WAAW;IACX,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;;IAEhB;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;;IAE9B;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;AChUA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,iFAAiF;AACrF;;AAEA;IACI,UAAU;IACV,sCAAsC;AAC1C;;AAEA;IACI,UAAU;IACV,uCAAuC;AAC3C;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gEAAgE;AACpE;;AAEA;;IAEI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI;QACI,qBAAqB;QACrB,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;ACzJA;IACI,aAAa;IACb,eAAe;IACf,OAAO;IACP,MAAM;IACN,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;AACjB;;AAEA;IACI,uCAAuC;IACvC,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;ACpEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,aAAa;;IAEb;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;;IAElB;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,mBAAmB;IACvB;AACJ;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAc;IACd,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;AC7HA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,4BAA4B;IAC5B,6BAA6B;IAC7B,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,6BAA6B;IAC7B,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,MAAM;IACN,OAAO;AACX;;AAEA;IACI,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,+BAA+B;IAC/B,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;IAC/B,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;IAGpC,6BAA6B;IAC7B,eAAe;IACf,0BAA0B;IAC1B,8BAA8B;IAC9B,yBAAyB;IACzB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,QAAQ;IACR,MAAM;IACN,OAAO;IACP,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,8BAA8B;IAC9B,UAAU;IACV,uBAAuB;IACvB,2CAA2C;IAC3C,4BAA4B;IAC5B,wBAAwB;IACxB,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IAER,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IAEzB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IAEzB,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,WAAW;IACX,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,8BAA8B;IAC9B,4BAA4B;IAC5B,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,oCAAoC;IACpC,yBAAyB;IAGzB,6BAA6B;IAC7B,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,wCAAwC;IACxC,2BAA2B;IAC3B,eAAe;IACf,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,wCAAwC;IACxC,2BAA2B;IAC3B,eAAe;IACf,4BAA4B;IAC5B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,kHAAkH;IAClH,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,2BAA2B;IAC3B,0BAA0B;IAC1B,YAAY;IACZ,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAHA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;IAC7B,kCAAkC;AACtC;;;AAGA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,yCAAyC;IACzC,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,+BAA+B;IAC/B,8BAA8B;IAC9B,gCAAgC;IAChC,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B;AACJ;;AAEA;IACI,wBAAmB;IAAnB,mBAAmB;AACvB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;;;;IAII,qBAAqB;IACrB,6BAA6B;IAC7B,kCAAkC;IAClC,iBAAiB;IACjB,qBAAqB;IACrB,mCAAmC;IACnC,SAAS;IACT,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,0BAA0B;IAC1B,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;;;IAII,qBAAqB;IACrB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IAEI,6BAA6B;IAC7B,mCAAmC;IACnC,sBAAsB;IACtB,YAAY;IACZ,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IAEI,6BAA6B;IAC7B,qBAAqB;IACrB,wBAAwB;IACxB,wBAAmB;IAAnB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,wBAAmB;IAAnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IAEf,6BAA6B;IAC7B,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,6BAA6B;IAC7B,qBAAqB;IACrB,mCAAmC;IACnC,eAAe;IACf,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,yBAAyB;IACzB,aAAa;IACb,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;;;;;;;;;;;;;;;;GAgBG;;AAEH;;;;;;;GAOG;;AAEH;;IAEI,gCAAgC;IAChC,iBAAiB;IACjB,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;;IAEI,sBAAsB;IACtB,YAAY;IACZ,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,sCAAsC;IACtC,SAAS;AACb;;AAEA;;;;;;;;;;;;;;;;;GAiBG;AACH;;;;;;GAMG;;AAEH;;;;;GAKG;;AAEH;;;;;GAKG;;AAEH;;GAEG;AACH;;;GAGG;;AAEH;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,sCAAsC;IACtC,kCAAkC;IAClC,6BAA6B;IAC7B,4BAA4B;IAC5B,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IAEI,4BAA4B;IAC5B,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,4BAA4B;IAC5B,2BAA2B;IAC3B,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;;IAErB;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,WAAW;IACX,oDAAoD;IACpD,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,yCAAyC;IACzC,WAAW;IACX,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,+BAA+B;IAC/B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,MAAM;IACN,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,QAAQ;AACZ;;AAEA;IACI,mCAAmC;IACnC,OAAO;AACX;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,4BAA4B;IAC5B,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,kBAAkB;AAClB,2FAA2F;AAC3F;IACI,yCAAyC;IACzC,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0CAA0C;IAC1C,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,gBAAgB;IAChB,kCAAkC;IAClC,8BAA8B;IAC9B,uBAAuB;IACvB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mCAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IAGI,6BAA6B;IAC7B,4BAA4B;IAC5B,qBAAqB;IACrB,mCAAmC;IACnC,SAAS;IAET,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,qBAAqB;IACrB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,4BAA4B;IAC5B,yBAAyB;IACzB,iBAAiB;IACjB,gDAAgD;IAChD,4BAA4B;IAC5B,wBAAwB;IACxB,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,oDAAoD;IACpD,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,kDAAkD;IAClD,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,kDAAkD;IAClD,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,mDAAmD;IACnD,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,mDAAmD;IACnD,4BAA4B;IAC5B,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;;IAKI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,SAAS;IACT,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,YAAY;IAGZ,6BAA6B;IAC7B,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,2CAA2C;IAI3C,iBAAiB;IACjB,YAAY;AAJhB;;AAOA;IACI,cAAc;IACd,MAAM;IACN,UAAU;IACV,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;IACI,mCAAmC;IACnC,oCAAoC;IACpC,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAEhB,2BAA2B;IAE3B,mBAAmB;IACnB,cAAc;IAGd,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,UAAU;AACd;;AAEA;IAII,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,0BAA0B;IAC1B,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;AACvB;ACj6EA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mEAAmE;;IAEnE;QACI,WAAW;QACX,kBAAkB;QAClB,UAAU;QACV,OAAO;QACP,aAAa;QACb,+BAA+B;QAC/B,gCAAgC;QAChC,qCAAqC;IACzC;AACJ;;AAEA;IACI,KAAK,WAAW,EAAE;IAClB,OAAO,MAAM,EAAE;AACnB;ACxBA;IACI,aAAa;IAEb,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IAEI,aAAa;IAEb,sBAAsB;IAEtB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;;IAEd;QACI,iBAAiB;IACrB;AACJ;ACpCA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IAEtB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IAEtB,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;IACT,+BAA+B;IAC/B,gCAAgC;IAChC,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,kBAAkB;AACtB;ACtJA;IACI,eAAe;IACf,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,MAAM;AACV;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;AC9CA;IACI,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,WAAW;IAIX,8BAA8B;IAC9B,yBAAyB;IACzB,sBAAsB;AAL1B;;;AASA,uIAAuI;;AAEvI;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,0FAA0F;IAC1F,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,0BAA0B;IAC1B,eAAe;IACf,YAAY;IACZ,cAAc;IACd,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,yBAAyB;IACzB,eAAe;IACf,6BAA6B;IAC7B,2BAA2B;IAC3B,+BAA+B;IAC/B,4BAA4B;IAC5B,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,2BAA2B;IAC3B,+BAA+B;IAC/B,8BAA8B;IAC9B,kCAAkC;IAClC,+BAA+B;IAC/B,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;;AAGA,QAAQ;;AAER;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,8DAA8D;IAC9D,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,eAAe;IAEf,kBAAkB;IAIlB,yBAAyB;IACzB,gFAAgF;AAJpF;;AAOA;IACI,yBAAyB;IACzB,gFAAgF;AACpF;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,6BAA6B;AACjC;;;AAGA,iBAAiB;;AAEjB;IACI,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,qBAAqB;IAErB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB;AACJ;;;AAGA,SAAS;;AAET;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;;AAGA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IAQzB,6DAA6D;AAPjE;;AAUA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,YAAY;IACZ,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;;IAE9B;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,OAAO;IACP,cAAc;IACd,UAAU;IACV,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,QAAQ;IACR,MAAM;IACN,UAAU;IACV,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,+CAA+C;IAC/C,4BAA4B;IAC5B,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IAIzB,gFAAgF;AAHpF;;AAMA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,QAAQ;IACR,OAAO;IACP,MAAM;IACN,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,kBAAkB;IAClB,qEAAqE;IACrE,0BAA0B;IAC1B,0BAA0B;IAC1B,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IAKI,6DAA6D;IAI7D,kHAAkH;AAPtH;;AAUA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB;AACJ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,kBAAkB,EAAE,0BAA0B;IAC9C,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,MAAM;IACN,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,+BAA+B;IAC/B,gCAAgC;IAChC,YAAY;IACZ,yCAAyC;IAIzC,mBAAmB;AAHvB;;AAMA;IACI,iDAAiD;IAIjD,gBAAgB;IAChB,gCAAgC;AAJpC;;AAOA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,UAAU;IACV,SAAS;IACT,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,8DAA8D;AAClE;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IAKZ,6DAA6D;IAC7D,yBAAyB;AAL7B;;AAQA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,cAAc;IACd,WAAW;IAEX,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,eAAe;IACf,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;;IAEI;AACJ;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,qCAAqC;IACrC,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,SAAS;IAET,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,eAAe;IACf,eAAe;IACf,4BAA4B;IAC5B,WAAW;IACX,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,QAAQ;IACR,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;;IAEI,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,4BAA4B;IAC5B,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;IAC3C,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB;AACJ;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,SAAS;AACb;;AAEA;IACI,cAAc;IACd,aAAa;AACjB;;AAEA;IACI;AACJ;;AAEA;;;IAGI,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iFAAiF;AACrF;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA,qEAAqE;;AAErE;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,mDAAmD;IACnD,2BAA2B;IAC3B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;;AAEA;;AAEA,aAAa;;AAEb,UAAU;;AAEV;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,yBAAyB;IACzB,gCAAgC;IAChC,YAAY;IACZ,eAAe;IACf,cAAc;IAId,wCAAuC;AAH3C;;AAMA;IACI,qBAAqB;IACrB,+BAA+B;IAC/B,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,6BAA6B;IAC7B,YAAY;IACZ,SAAS;IACT,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,iFAAiF;AACrF;;AAEA;IACI,oDAAoD;IACpD,yBAAyB;IACzB,iFAAiF;IACjF,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,oCAAoC;IACpC,2CAA2C;IAC3C,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;IAC5B,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,sBAAsB;IACtB,yCAAyC;IACzC,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,OAAO;IACP,SAAS;IACT,QAAQ;IACR,wCAAwC;IACxC,6CAA4C;IAK5C,6DAA6D;IAC7D,yBAAyB;IAIzB,yBAAyB;IACzB;AAVJ;;AAaA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX;AACJ;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,qBAAqB;AACzB;;;AAGA,0BAA0B;;AAE1B;IACI,aAAa;IACb,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ;AACJ;ACx8DA;IACI,aAAa;IACb,wFAAwF;IACxF,YAAY;IACZ,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;IAC1C,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;;IAE7B;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;;QAEzB;YACI,yBAAyB;QAC7B;IACJ;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;QACzB,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;;IAEhB;QACI,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAiB;OAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,SAAS;IACT,uDAAuD;IACvD,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI;QACI,uDAAuD;IAC3D;AACJ;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;;IAEjB;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;;IAEhB;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;;IAEf;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;;IAEd;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA,8DAA8D;AChO9D;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,mCAAmC;IACnC,kBAAkB;IAClB,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;AAClB;;AAEA,8BAA8B;;AAE9B;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,OAAO;IACP,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;ACrIA,cAAc;AACd;IACI,SAAS;IACT,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,cAAc;IACd,cAAc;IACd,0FAA0F;IAC1F,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;AACA;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,SAAS;IACT,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;ACrHA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,eAAe;IACf,cAAc;;IAEd;QACI;IACJ;AACJ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;;IAElB;QACI,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,YAAY;IAChB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,eAAe;AACnB;AC5EA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,yCAAyC;IACzC;AACJ;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,yCAAyC;IACzC,YAAY;IACZ,6DAA6D;IAC7D,gFAAgF;IAChF,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,8BAA8B;IAC9B,SAAS;IACT,UAAU;AACd;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,6BAA6B;IAC7B,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,6CAA6C;IAC7C,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,iBAAiB;;IAEjB;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,SAAS;IACT,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;;IAEZ;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,4BAA4B;IAC5B,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,uBAAuB;AAC3B;AC3RA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,8BAA8B;AAClC;ACLA;IACI,mDAAmD;AACvD;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2CAA2C;AAC/C;;;AAGA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;;AAGA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,eAAe;AACf;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI;AACJ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA,iBAAiB;AACjB;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,kDAAkD;AAClD;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA,QAAQ;AACR;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,gBAAgB;AAChB;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,WAAW;AACX;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,UAAU;AACV;IACI,8CAA8C;IAC9C,WAAW;AACf;;;AAGA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kCAAkC;AACtC;;;AAGA,YAAY;AACZ;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;ACnaA,OAAO;AACP;IACI,cAAc;IACd,cAAc;IACd;AACJ;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oDAAoD;IACpD,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,WAAW;IACX,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA,cAAc;AACd;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;IACZ,YAAY;AAChB;;AAEA,SAAS;AACT;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;AClNA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,OAAO;IACP,cAAc;IACd,aAAa;IACb,cAAc;IACd,eAAe;IACf,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;IACzB,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,OAAO;IACP,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,OAAO;IACP,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;IACvB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,gCAAgC;IAChC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,gCAAgC;IAChC,6BAA6B;IAC7B,wBAAwB;IACxB,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;IAGI,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA,0BAA0B;;AAE1B;IACI,yBAAyB;IACzB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,qCAAqC;IACrC,UAAU;IACV,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,6BAA6B;IAC7B,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,yBAAyB;IACzB,8DAA8D;AAClE;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,wCAAwC;IACxC,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA,oBAAoB;;AAEpB;IACI,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,eAAe;IACf,eAAe;IACf,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;IACZ,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,2DAA2D;AAC/D;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,4DAA4D;AAChE;;AAEA;IACI,+BAA+B;IAC/B,cAAc;IACd,uBAAuB;AAC3B;;AAEA,eAAe;;AAEf;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IAKI,iBAAiB;AAHrB;;AAMA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA,iBAAiB;;AAEjB;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,OAAO;IACP,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,cAAc;QACd,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;ACl3BA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAIlB,WAAW;IACX,YAAY;AAJhB;;AAOA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;ACvDA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,MAAM;AACV;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,MAAM;AACV;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;IAChC,sBAAsB;IACtB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,OAAO;IACP,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,uCAAuC;IACvC,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,0BAA0B;IAC1B,sBAAsB;IACtB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA,kBAAkB;;AAElB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;IACvC,eAAe;IACf,WAAW;AACf;AC5NA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,OAAO;IACP,iBAAiB;IACjB,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,aAAa;IACb,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,OAAO;IACP,kBAAkB;IAClB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uiBAAuiB;IAIviB,gEAAgE;IAChE,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IAGI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,WAAW;IACX,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,iBAAiB;IACjB,UAAU;IACV,sBAAsB;IACtB,uBAAuB;IACvB,uCAAuC;IACvC,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;IAC7B,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;ACnRA,2CAA2C;AAC3C;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;AAChB;;AAEA,+BAA+B;AAC/B;IACI,UAAU;IACV,QAAQ;IACR,SAAS;AACb;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yBAAyB;IAEzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IAEvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IAGI,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,gCAAgC;IAChC,QAAQ;IACR,SAAS;IACT,cAAc;IACd,gCAAgC;AACpC;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;;AAEtB;ACpFA,qBAAA,uBAAc,CAAd,uBAAc,CAAd,kBAAc,CAAd,kBAAc,CAAd,aAAc,CAAd,aAAc,CAAd,aAAc,CAAd,cAAc,CAAd,cAAc,CAAd,YAAc,CAAd,YAAc,CAAd,iBAAc,CAAd,qCAAc,CAAd,6BAAc,CAAd,4BAAc,CAAd,2BAAc,CAAd,cAAc,CAAd,mBAAc,CAAd,qBAAc,CAAd,sBAAc,CAAd,uBAAc,CAAd,iBAAc,CAAd,0BAAc,CAAd,2BAAc,CAAd,qCAAc,CAAd,iCAAc,CAAd,0BAAc,CAAd,qBAAc,CAAd,6BAAc,CAAd,WAAc,CAAd,iBAAc,CAAd,eAAc,CAAd,gBAAc,CAAd,iBAAc,CAAd,aAAc,CAAd,eAAc,CAAd,YAAc,CAAd,kBAAc,CAAd,oBAAc,CAAd,0BAAc,CAAd,wBAAc,CAAd,yBAAc,CAAd,0BAAc,CAAd,sBAAc,CAAd,uBAAc,CAAd,wBAAc,CAAd,qBAAc,CAAd,mBAAc,CAAd,qBAAc,CAAd,oBAAc,CAAd,oBAAc;AAAd,WAAA,uBAAc,CAAd,uBAAc,CAAd,kBAAc,CAAd,kBAAc,CAAd,aAAc,CAAd,aAAc,CAAd,aAAc,CAAd,cAAc,CAAd,cAAc,CAAd,YAAc,CAAd,YAAc,CAAd,iBAAc,CAAd,qCAAc,CAAd,6BAAc,CAAd,4BAAc,CAAd,2BAAc,CAAd,cAAc,CAAd,mBAAc,CAAd,qBAAc,CAAd,sBAAc,CAAd,uBAAc,CAAd,iBAAc,CAAd,0BAAc,CAAd,2BAAc,CAAd,qCAAc,CAAd,iCAAc,CAAd,0BAAc,CAAd,qBAAc,CAAd,6BAAc,CAAd,WAAc,CAAd,iBAAc,CAAd,eAAc,CAAd,gBAAc,CAAd,iBAAc,CAAd,aAAc,CAAd,eAAc,CAAd,YAAc,CAAd,kBAAc,CAAd,oBAAc,CAAd,0BAAc,CAAd,wBAAc,CAAd,yBAAc,CAAd,0BAAc,CAAd,sBAAc,CAAd,uBAAc,CAAd,wBAAc,CAAd,qBAAc,CAAd,mBAAc,CAAd,qBAAc,CAAd,oBAAc,CAAd,oBAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;IAAd;QAAA,uBAAc;QAAd,4BAAc;QAAd,+BAAc;;QAAd,sBAAc;QAAd,qCAAc;;QAAd,oBAAc;QAAd,uCAAc;;QAAd,2BAAc;QAAd,0BAAc;;QAAd,iBAAc;QAAd,oCAAc;;QAAd,qBAAc;QAAd,iCAAc;;QAAd,qBAAc;QAAd,mCAAc;;QAAd,oBAAc;QAAd,sCAAc;;QAAd,iCAAc;QAAd,mCAAc;;QAAd,0BAAc;QAAd,kCAAc;;QAAd,uBAAc;;QAAd,gBAAc;;QAAd,eAAc;QAAd,qBAAc;QAAd,oBAAc;QAAd,kBAAc;IAAA;;IAAd;QAAA,wBAAc;QAAd,yBAAc;;QAAd,oBAAc;QAAd,qCAAc;;QAAd,qBAAc;QAAd,gCAAc;;QAAd,qBAAc;QAAd,qCAAc;;QAAd,qBAAc;QAAd,oBAAc;;QAAd,kBAAc;QAAd,8BAAc;;QAAd,sBAAc;QAAd,sCAAc;;QAAd,8BAAc;QAAd,mCAAc;;QAAd,wBAAc;QAAd,qCAAc;;QAAd,mBAAc;;QAAd,gBAAc;;QAAd,eAAc;QAAd,qBAAc;QAAd,oBAAc;QAAd,kBAAc;IAAA;IAAd,EAAA,+BAAc;;IAAd,KAAA,uCAAc,CAAd,4BAAc;;IAAd;QAAA,GAAA,eAAc;QAAd,GAAA,oBAAc;QAAd,GAAA,gBAAc,CAAd,gBAAc;QAAd,GAAA,eAAc;QAAd;YAAA,WAAc;QAAA;;QAAd,GAAA,kBAAc;;QAAd,GAAA,oBAAc;;QAAd,GAAA,iBAAc,CAAd,mBAAc;;QAAd,GAAA,eAAc;;QAAd;YAAA,YAAc;QAAA;;QAAd,GAAA,kBAAc;;QAAd,GAAA,oBAAc;;QAAd,GAAA,kBAAc,CAAd,mBAAc;;QAAd,GAAA,eAAc;;QAAd;YAAA,aAAc;QAAA;;QAAd,GAAA,kBAAc;;QAAd,GAAA,oBAAc;;QAAd,GAAA,cAAc,CAAd,kBAAc;;QAAd,GAAA,eAAc;;QAAd;YAAA,SAAc;QAAA;;QAAd,GAAA,iBAAc;;QAAd,GAAA,qBAAc;;QAAd,GAAA,kBAAc,CAAd,mBAAc;;QAAd,GAAA,eAAc;;QAAd;YAAA,aAAc;QAAA;;QAAd,GAAA,iBAAc;;QAAd,GAAA,qBAAc;;QAAd,GAAA,iBAAc,CAAd,gBAAc;;QAAd,GAAA,eAAc;;QAAd;YAAA,YAAc;QAAA;IAAA;IAAd;MAAA,sBAAc;MAAd,6BAAc;IAAA;AAEd,YAAA,iBAAmB,CAAnB,SAAmB,CAAnB,UAAmB,CAAnB,SAAmB,CAAnB,WAAmB,CAAnB,eAAmB,CAAnB,qBAAmB,CAAnB,kBAAmB,CAAnB,cAAmB;AAAnB,wBAAA,mBAAmB;AAAnB,wBAAA,mBAAmB;AAAnB,cAAA,iBAAmB;AAAnB,UAAA,cAAmB;AAAnB,aAAA,iBAAmB;AAAnB,aAAA,iBAAmB;AAAnB,WAAA,eAAmB;AAAnB,YAAA,SAAmB;AAAnB,cAAA,QAAmB,CAAnB,SAAmB;AAAnB,cAAA,OAAmB,CAAnB,UAAmB;AAAnB,eAAA,YAAmB;AAAnB,aAAA,UAAmB;AAAnB,cAAA,WAAmB;AAAnB,YAAA,SAAmB;AAAnB,aAAA,UAAmB;AAAnB,aAAA,aAAmB;AAAnB,WAAA,QAAmB;AAAnB,WAAA,YAAmB;AAAnB,cAAA,QAAmB;AAAnB,WAAA,WAAmB;AAAnB,kBAAA,SAAmB;AAAnB,kBAAA,QAAmB;AAAnB,cAAA,SAAmB;AAAnB,YAAA,SAAmB;AAAnB,YAAA,aAAmB;AAAnB,YAAA,YAAmB;AAAnB,eAAA,cAAmB;AAAnB,YAAA,aAAmB;AAAnB,YAAA,UAAmB;AAAnB,UAAA,OAAmB;AAAnB,aAAA,YAAmB;AAAnB,aAAA,OAAmB;AAAnB,UAAA,UAAmB;AAAnB,UAAA,WAAmB;AAAnB,aAAA,YAAmB;AAAnB,UAAA,QAAmB;AAAnB,UAAA,WAAmB;AAAnB,gBAAA,OAAmB;AAAnB,iBAAA,OAAmB;AAAnB,iBAAA,OAAmB;AAAnB,8BAAA,oBAAmB;AAAnB,+BAAA,oBAAmB;AAAnB,aAAA,QAAmB;AAAnB,QAAA,SAAmB;AAAnB,SAAA,UAAmB;AAAnB,SAAA,UAAmB;AAAnB,SAAA,UAAmB;AAAnB,SAAA,UAAmB;AAAnB,cAAA,WAAmB;AAAnB,YAAA,SAAmB;AAAnB,aAAA,UAAmB;AAAnB,UAAA,qBAAmB;AAAnB,QAAA,UAAmB;AAAnB,UAAA,oBAAmB,CAAnB,qBAAmB;AAAnB,SAAA,mBAAmB,CAAnB,oBAAmB;AAAnB,SAAA,kBAAmB,CAAnB,mBAAmB;AAAnB,YAAA,oBAAmB,CAAnB,qBAAmB;AAAnB,YAAA,gBAAmB,CAAnB,iBAAmB;AAAnB,SAAA,kBAAmB,CAAnB,qBAAmB;AAAnB,UAAA,eAAmB,CAAnB,kBAAmB;AAAnB,SAAA,iBAAmB,CAAnB,oBAAmB;AAAnB,SAAA,kBAAmB,CAAnB,qBAAmB;AAAnB,WAAA,4BAAmB;AAAnB,WAAA,+BAAmB;AAAnB,WAAA,yBAAmB;AAAnB,WAAA,0BAAmB;AAAnB,UAAA,qBAAmB;AAAnB,UAAA,iBAAmB;AAAnB,UAAA,gBAAmB;AAAnB,SAAA,iBAAmB;AAAnB,YAAA,sBAAmB;AAAnB,SAAA,qBAAmB;AAAnB,SAAA,oBAAmB;AAAnB,SAAA,kBAAmB;AAAnB,SAAA,qBAAmB;AAAnB,SAAA,oBAAmB;AAAnB,SAAA,kBAAmB;AAAnB,SAAA,eAAmB;AAAnB,YAAA,oBAAmB;AAAnB,SAAA,mBAAmB;AAAnB,SAAA,kBAAmB;AAAnB,SAAA,gBAAmB;AAAnB,SAAA,kBAAmB;AAAnB,YAAA,gBAAmB;AAAnB,SAAA,oBAAmB;AAAnB,SAAA,mBAAmB;AAAnB,YAAA,iBAAmB;AAAnB,SAAA,cAAmB;AAAnB,YAAA,mBAAmB;AAAnB,SAAA,kBAAmB;AAAnB,YAAA,mBAAmB;AAAnB,SAAA,iBAAmB;AAAnB,UAAA,eAAmB;AAAnB,SAAA,kBAAmB;AAAnB,SAAA,eAAmB;AAAnB,SAAA,iBAAmB;AAAnB,gBAAA,eAAmB;AAAnB,gBAAA,eAAmB;AAAnB,gBAAA,eAAmB;AAAnB,YAAA,eAAmB;AAAnB,UAAA,aAAmB;AAAnB,iBAAA,oBAAmB;AAAnB,SAAA,YAAmB;AAAnB,gBAAA,mBAAmB;AAAnB,SAAA,YAAmB;AAAnB,WAAA,YAAmB;AAAnB,kBAAA,kBAAmB;AAAnB,iBAAA,mBAAmB;AAAnB,WAAA,UAAmB,CAAnB,WAAmB;AAAnB,QAAA,UAAmB;AAAnB,WAAA,eAAmB;AAAnB,WAAA,UAAmB;AAAnB,SAAA,aAAmB;AAAnB,SAAA,cAAmB;AAAnB,SAAA,WAAmB;AAAnB,QAAA,aAAmB;AAAnB,WAAA,eAAmB;AAAnB,SAAA,WAAmB;AAAnB,QAAA,cAAmB;AAAnB,WAAA,eAAmB;AAAnB,QAAA,WAAmB;AAAnB,QAAA,cAAmB;AAAnB,QAAA,aAAmB;AAAnB,SAAA,YAAmB;AAAnB,QAAA,cAAmB;AAAnB,QAAA,WAAmB;AAAnB,QAAA,cAAmB;AAAnB,cAAA,UAAmB;AAAnB,gBAAA,YAAmB;AAAnB,gBAAA,YAAmB;AAAnB,yDAAA,mDAAmB;AAAnB,+CAAA,yCAAmB;AAAnB,WAAA,WAAmB;AAAnB,WAAA,WAAmB;AAAnB,SAAA,UAAmB;AAAnB,aAAA,YAAmB;AAAnB,UAAA,aAAmB;AAAnB,eAAA,0BAAmB;AAAnB,aAAA,iBAAmB;AAAnB,aAAA,gBAAmB;AAAnB,oBAAA,gBAAmB;AAAnB,oBAAA,gBAAmB;AAAnB,oBAAA,gBAAmB;AAAnB,mBAAA,eAAmB;AAAnB,eAAA,eAAmB;AAAnB,iBAAA,gBAAmB;AAAnB,cAAA,yBAAmB;AAAnB,YAAA,cAAmB;AAAnB,aAAA,kBAAmB;AAAnB,YAAA,kBAAmB;AAAnB,qBAAA,iBAAmB;AAAnB,oBAAA,gBAAmB;AAAnB,mBAAA,eAAmB;AAAnB,mBAAA,eAAmB;AAAnB,eAAA,eAAmB;AAAnB,cAAA,iBAAmB;AAAnB,WAAA,cAAmB;AAAnB,WAAA,SAAmB;AAAnB,SAAA,YAAmB;AAAnB,SAAA,aAAmB;AAAnB,SAAA,UAAmB;AAAnB,QAAA,YAAmB;AAAnB,WAAA,cAAmB;AAAnB,QAAA,aAAmB;AAAnB,WAAA,cAAmB;AAAnB,WAAA,SAAmB;AAAnB,QAAA,UAAmB;AAAnB,QAAA,aAAmB;AAAnB,QAAA,YAAmB;AAAnB,SAAA,WAAmB;AAAnB,QAAA,aAAmB;AAAnB,SAAA,WAAmB;AAAnB,QAAA,UAAmB;AAAnB,QAAA,aAAmB;AAAnB,0BAAA,0BAAmB;AAAnB,gBAAA,WAAmB;AAAnB,cAAA,SAAmB;AAAnB,gBAAA,WAAmB;AAAnB,gBAAA,WAAmB;AAAnB,eAAA,SAAmB;AAAnB,eAAA,SAAmB;AAAnB,eAAA,SAAmB;AAAnB,WAAA,UAAmB;AAAnB,UAAA,sBAAmB,CAAnB,iBAAmB;AAAnB,WAAA,UAAmB;AAAnB,UAAA,sBAAmB,CAAnB,iBAAmB;AAAnB,SAAA,SAAmB;AAAnB,aAAA,WAAmB;AAAnB,YAAA,aAAmB;AAAnB,aAAA,cAAmB;AAAnB,YAAA,iBAAmB;AAAnB,oBAAA,eAAmB;AAAnB,oBAAA,eAAmB;AAAnB,mBAAA,cAAmB;AAAnB,kDAAA,2CAAmB;AAAnB,eAAA,cAAmB;AAAnB,iBAAA,yBAAmB;AAAnB,+BAAA,+BAAmB;AAAnB,oBAAA,eAAmB;AAAnB,oBAAA,eAAmB;AAAnB,mBAAA,aAAmB;AAAnB,mBAAA,cAAmB;AAAnB,mBAAA,aAAmB;AAAnB,eAAA,cAAmB;AAAnB,aAAA,eAAmB;AAAnB,cAAA,0BAAmB,CAAnB,qBAAmB;AAAnB,aAAA,eAAmB;AAAnB,qBAAA,gBAAmB;AAAnB,aAAA,eAAmB;AAAnB,aAAA,eAAmB;AAAnB,gBAAA,oBAAmB;AAAnB,WAAA,WAAmB;AAAnB,cAAA,aAAmB;AAAnB,cAAA,SAAmB;AAAnB,kBAAA,aAAmB;AAAnB,aAAA,aAAmB;AAAnB,cAAA,WAAmB;AAAnB,SAAA,WAAmB;AAAnB,WAAA,WAAmB;AAAnB,eAAA,cAAmB;AAAnB,eAAA,cAAmB;AAAnB,eAAA,eAAmB;AAAnB,mBAAA,mBAAmB;AAAnB,oBAAA,wBAAmB;AAAnB,sBAAA,qBAAmB,CAAnB,8LAAmB;AAAnB,sBAAA,qBAAmB,CAAnB,8LAAmB;AAAnB,oBAAA,qBAAmB,CAAnB,8LAAmB;AAAnB,sBAAA,qBAAmB,CAAnB,8LAAmB;AAAnB,0BAAA,qBAAmB,CAAnB,8LAAmB;AAAnB,mBAAA,oBAAmB,CAAnB,8LAAmB;AAAnB,0BAAA,qBAAmB,CAAnB,8LAAmB;AAAnB,cAAA,iBAAmB,CAAnB,8LAAmB;AAAnB,cAAA,iBAAmB,CAAnB,8LAAmB;AAAnB,sBAAA,kBAAmB,CAAnB,8LAAmB;AAAnB,cAAA,8LAAmB;AAAnB,0BAAA,YAAA,SAAmB,CAAnB,QAAA,SAAmB,CAAA;AAAnB,wBAAA,gDAAmB;AAAnB,oBAAA,IAAA,UAAmB,CAAA;AAAnB,kBAAA,2DAAmB;AAAnB,mBAAA,GAAA,wBAAmB,CAAA;AAAnB,iBAAA,oCAAmB;AAAnB,mBAAA,cAAmB;AAAnB,uBAAA,kBAAmB;AAAnB,mBAAA,cAAmB;AAAnB,eAAA,iBAAmB;AAAnB,gBAAA,wBAAmB,CAAnB,qBAAmB,CAAnB,gBAAmB;AAAnB,gBAAA,WAAmB;AAAnB,iBAAA,uBAAmB;AAAnB,cAAA,oBAAmB;AAAnB,cAAA,oBAAmB;AAAnB,oBAAA,uBAAmB,CAAnB,oBAAmB,CAAnB,eAAmB;AAAnB,gBAAA,+CAAmB;AAAnB,gBAAA,+CAAmB;AAAnB,gBAAA,+CAAmB;AAAnB,gBAAA,+CAAmB;AAAnB,gBAAA,4CAAmB;AAAnB,aAAA,kBAAmB;AAAnB,aAAA,qBAAmB;AAAnB,qBAAA,6BAAmB;AAAnB,cAAA,cAAmB;AAAnB,gBAAA,sBAAmB;AAAnB,cAAA,oBAAmB;AAAnB,iBAAA,kBAAmB;AAAnB,kBAAA,mBAAmB;AAAnB,kBAAA,0BAAmB;AAAnB,gBAAA,wBAAmB;AAAnB,mBAAA,sBAAmB;AAAnB,oBAAA,6BAAmB;AAAnB,UAAA,WAAmB;AAAnB,aAAA,YAAmB;AAAnB,UAAA,UAAmB;AAAnB,UAAA,WAAmB;AAAnB,UAAA,QAAmB;AAAnB,UAAA,UAAmB;AAAnB,gDAAA,sBAAmB,CAAnB,sDAAmB,CAAnB,+DAAmB;AAAnB,gDAAA,sBAAmB,CAAnB,qDAAmB,CAAnB,8DAAmB;AAAnB,gDAAA,sBAAmB,CAAnB,sDAAmB,CAAnB,+DAAmB;AAAnB,gDAAA,sBAAmB,CAAnB,mDAAmB,CAAnB,4DAAmB;AAAnB,mDAAA,sBAAmB,CAAnB,+DAAmB,CAAnB,wDAAmB;AAAnB,gDAAA,sBAAmB,CAAnB,8DAAmB,CAAnB,uDAAmB;AAAnB,mDAAA,sBAAmB,CAAnB,+DAAmB,CAAnB,wDAAmB;AAAnB,gDAAA,sBAAmB,CAAnB,6DAAmB,CAAnB,sDAAmB;AAAnB,gDAAA,sBAAmB,CAAnB,8DAAmB,CAAnB,uDAAmB;AAAnB,gDAAA,sBAAmB,CAAnB,2DAAmB,CAAnB,oDAAmB;AAAnB,gDAAA,sBAAmB,CAAnB,6DAAmB,CAAnB,sDAAmB;AAAnB,+CAAA,uBAAmB,CAAnB,iEAAmB,CAAnB,0DAAmB;AAAnB,kBAAA,aAAmB;AAAnB,oBAAA,eAAmB;AAAnB,oBAAA,eAAmB;AAAnB,oBAAA,eAAmB;AAAnB,sBAAA,iBAAmB;AAAnB,sBAAA,iBAAmB;AAAnB,kBAAA,sBAAmB;AAAnB,sBAAA,kBAAmB;AAAnB,wBAAA,oBAAmB;AAAnB,gBAAA,wBAAmB;AAAnB,YAAA,qBAAmB;AAAnB,oBAAA,iBAAmB;AAAnB,wBAAA,qBAAmB;AAAnB,iBAAA,oBAAmB;AAAnB,eAAA,2BAAmB;AAAnB,eAAA,uCAAmB;AAAnB,eAAA,uCAAmB;AAAnB,eAAA,qBAAmB;AAAnB,iBAAA,qCAAmB,CAAnB,wCAAmB;AAAnB,iBAAA,iDAAmB,CAAnB,oDAAmB;AAAnB,uBAAA,2BAAmB,CAAnB,4BAAmB;AAAnB,iBAAA,oCAAmB,CAAnB,qCAAmB;AAAnB,iBAAA,8BAAmB,CAAnB,+BAAmB;AAAnB,kBAAA,gDAAmB;AAAnB,eAAA,2BAAmB;AAAnB,eAAA,2BAAmB;AAAnB,WAAA,gBAAmB;AAAnB,aAAA,gBAAmB;AAAnB,aAAA,gBAAmB;AAAnB,aAAA,oBAAmB,CAAnB,uBAAmB;AAAnB,aAAA,uBAAmB;AAAnB,aAAA,qBAAmB;AAAnB,eAAA,qBAAmB;AAAnB,eAAA,qBAAmB;AAAnB,aAAA,sBAAmB;AAAnB,aAAA,oBAAmB;AAAnB,mBAAA,6BAAmB;AAAnB,iBAAA,kBAAmB;AAAnB,kBAAA,mBAAmB;AAAnB,gBAAA,iBAAmB;AAAnB,8BAAA,gCAAmB;AAAnB,kBAAA,+BAAmB;AAAnB,qBAAA,qBAAmB,CAAnB,yDAAmB;AAAnB,qBAAA,6BAAmB;AAAnB,kBAAA,+BAAmB;AAAnB,sBAAA,qCAAmB;AAAnB,sBAAA,qCAAmB;AAAnB,sBAAA,qCAAmB;AAAnB,uBAAA,oCAAmB;AAAnB,2BAAA,0CAAmB;AAAnB,oBAAA,qBAAmB,CAAnB,2DAAmB;AAAnB,oBAAA,qBAAmB,CAAnB,2DAAmB;AAAnB,oBAAA,qBAAmB,CAAnB,2DAAmB;AAAnB,oBAAA,qBAAmB,CAAnB,2DAAmB;AAAnB,qBAAA,qBAAmB,CAAnB,yDAAmB;AAAnB,2BAAA,wCAAmB;AAAnB,iBAAA,8BAAmB;AAAnB,iBAAA,8BAAmB;AAAnB,mBAAA,gCAAmB;AAAnB,uBAAA,sCAAmB;AAAnB,qBAAA,kCAAmB;AAAnB,0BAAA,uCAAmB;AAAnB,mBAAA,qBAAmB,CAAnB,wDAAmB;AAAnB,uBAAA,wBAAmB;AAAnB,iBAAA,qBAAmB,CAAnB,2DAAmB;AAAnB,yBAAA,6BAAmB;AAAnB,yBAAA,4BAAmB;AAAnB,sBAAA,4BAAmB,CAAnB,sEAAmB;AAAnB,sBAAA,gCAAmB;AAAnB,cAAA,mCAAmB;AAAnB,kBAAA,yCAAmB;AAAnB,qBAAA,sCAAmB;AAAnB,kBAAA,uCAAmB;AAAnB,uBAAA,2CAAmB;AAAnB,sBAAA,6CAAmB;AAAnB,sBAAA,2CAAmB;AAAnB,iBAAA,iCAAmB;AAAnB,iBAAA,iCAAmB;AAAnB,cAAA,mCAAmB;AAAnB,YAAA,iCAAmB;AAAnB,mBAAA,wCAAmB;AAAnB,uBAAA,8CAAmB;AAAnB,uBAAA,8CAAmB;AAAnB,sBAAA,+CAAmB;AAAnB,kBAAA,uCAAmB;AAAnB,gBAAA,iBAAmB,CAAnB,2DAAmB;AAAnB,gBAAA,iBAAmB,CAAnB,2DAAmB;AAAnB,gBAAA,iBAAmB,CAAnB,2DAAmB;AAAnB,eAAA,iBAAmB,CAAnB,2DAAmB;AAAnB,qBAAA,qCAAmB;AAAnB,eAAA,oCAAmB;AAAnB,gBAAA,uCAAmB;AAAnB,aAAA,kCAAmB;AAAnB,iBAAA,wCAAmB;AAAnB,eAAA,oCAAmB;AAAnB,eAAA,oCAAmB;AAAnB,kBAAA,2CAAmB;AAAnB,cAAA,iBAAmB,CAAnB,2DAAmB;AAAnB,iBAAA,sCAAmB;AAAnB,eAAA,+CAAmB;AAAnB,sBAAA,2CAAmB;AAAnB,mBAAA,4BAAmB;AAAnB,aAAA,iBAAmB,CAAnB,2DAAmB;AAAnB,iBAAA,uCAAmB;AAAnB,iBAAA,uCAAmB;AAAnB,iBAAA,uCAAmB;AAAnB,+GAAA,0GAAmB;AAAnB,kDAAA,gDAAmB;AAAnB,uDAAA,qDAAmB;AAAnB,yCAAA,qCAAmB;AAAnB,aAAA,qBAAmB;AAAnB,cAAA,0BAAmB;AAAnB,iBAAA,2BAAmB;AAAnB,iBAAA,iBAAmB;AAAnB,UAAA,sBAAmB;AAAnB,UAAA,yBAAmB;AAAnB,QAAA,WAAmB;AAAnB,WAAA,gBAAmB;AAAnB,QAAA,eAAmB;AAAnB,QAAA,cAAmB;AAAnB,SAAA,YAAmB;AAAnB,QAAA,eAAmB;AAAnB,QAAA,YAAmB;AAAnB,QAAA,cAAmB;AAAnB,QAAA,YAAmB;AAAnB,cAAA,WAAmB;AAAnB,WAAA,0BAAmB,CAAnB,6BAAmB;AAAnB,WAAA,2BAAmB,CAAnB,8BAAmB;AAAnB,SAAA,oBAAmB,CAAnB,qBAAmB;AAAnB,YAAA,qBAAmB,CAAnB,sBAAmB;AAAnB,UAAA,mBAAmB,CAAnB,oBAAmB;AAAnB,SAAA,mBAAmB,CAAnB,oBAAmB;AAAnB,YAAA,qBAAmB,CAAnB,sBAAmB;AAAnB,SAAA,oBAAmB,CAAnB,qBAAmB;AAAnB,SAAA,iBAAmB,CAAnB,kBAAmB;AAAnB,SAAA,oBAAmB,CAAnB,qBAAmB;AAAnB,SAAA,mBAAmB,CAAnB,oBAAmB;AAAnB,SAAA,iBAAmB,CAAnB,kBAAmB;AAAnB,SAAA,eAAmB,CAAnB,kBAAmB;AAAnB,YAAA,oBAAmB,CAAnB,uBAAmB;AAAnB,SAAA,mBAAmB,CAAnB,sBAAmB;AAAnB,YAAA,oBAAmB,CAAnB,uBAAmB;AAAnB,UAAA,kBAAmB,CAAnB,qBAAmB;AAAnB,SAAA,kBAAmB,CAAnB,qBAAmB;AAAnB,SAAA,mBAAmB,CAAnB,sBAAmB;AAAnB,SAAA,gBAAmB,CAAnB,mBAAmB;AAAnB,SAAA,kBAAmB,CAAnB,qBAAmB;AAAnB,SAAA,gBAAmB,CAAnB,mBAAmB;AAAnB,SAAA,qBAAmB;AAAnB,YAAA,uBAAmB;AAAnB,SAAA,sBAAmB;AAAnB,SAAA,mBAAmB;AAAnB,SAAA,qBAAmB;AAAnB,SAAA,mBAAmB;AAAnB,YAAA,qBAAmB;AAAnB,SAAA,iBAAmB;AAAnB,SAAA,oBAAmB;AAAnB,SAAA,mBAAmB;AAAnB,SAAA,iBAAmB;AAAnB,UAAA,oBAAmB;AAAnB,UAAA,oBAAmB;AAAnB,SAAA,oBAAmB;AAAnB,YAAA,sBAAmB;AAAnB,SAAA,kBAAmB;AAAnB,SAAA,oBAAmB;AAAnB,SAAA,kBAAmB;AAAnB,SAAA,eAAmB;AAAnB,SAAA,mBAAmB;AAAnB,SAAA,mBAAmB;AAAnB,SAAA,gBAAmB;AAAnB,SAAA,kBAAmB;AAAnB,cAAA,eAAmB;AAAnB,gBAAA,iBAAmB;AAAnB,eAAA,gBAAmB;AAAnB,iBAAA,kBAAmB;AAAnB,iBAAA,qBAAmB;AAAnB,cAAA,8GAAmB;AAAnB,aAAA,gBAAmB,CAAnB,gBAAmB;AAAnB,aAAA,kBAAmB,CAAnB,mBAAmB;AAAnB,aAAA,iBAAmB,CAAnB,kBAAmB;AAAnB,aAAA,iBAAmB,CAAnB,aAAmB;AAAnB,qBAAA,gBAAmB;AAAnB,kBAAA,cAAmB;AAAnB,kBAAA,cAAmB;AAAnB,kBAAA,cAAmB;AAAnB,kBAAA,cAAmB;AAAnB,kBAAA,cAAmB;AAAnB,kBAAA,cAAmB;AAAnB,iBAAA,aAAmB;AAAnB,cAAA,cAAmB,CAAnB,kBAAmB;AAAnB,YAAA,kBAAmB,CAAnB,mBAAmB;AAAnB,YAAA,kBAAmB,CAAnB,mBAAmB;AAAnB,YAAA,iBAAmB,CAAnB,mBAAmB;AAAnB,YAAA,iBAAmB,CAAnB,gBAAmB;AAAnB,cAAA,eAAmB;AAAnB,eAAA,eAAmB;AAAnB,gBAAA,eAAmB;AAAnB,gBAAA,eAAmB;AAAnB,kBAAA,eAAmB;AAAnB,cAAA,wBAAmB;AAAnB,WAAA,iBAAmB;AAAnB,iBAAA,iCAAmB,CAAnB,2IAAmB;AAAnB,cAAA,mBAAmB;AAAnB,iBAAA,aAAmB;AAAnB,oBAAA,iBAAmB;AAAnB,mBAAA,uBAAmB;AAAnB,mBAAA,qBAAmB;AAAnB,oBAAA,oBAAmB;AAAnB,2BAAA,mCAAmB;AAAnB,mBAAA,mBAAmB,CAAnB,gDAAmB;AAAnB,yBAAA,iCAAmB;AAAnB,iBAAA,kBAAmB;AAAnB,qBAAA,6BAAmB;AAAnB,gCAAA,wCAAmB;AAAnB,yBAAA,mCAAmB;AAAnB,oBAAA,4BAAmB;AAAnB,wBAAA,kCAAmB;AAAnB,kBAAA,mBAAmB,CAAnB,kDAAmB;AAAnB,kBAAA,mBAAmB,CAAnB,kDAAmB;AAAnB,kBAAA,mBAAmB,CAAnB,+CAAmB;AAAnB,kBAAA,mBAAmB,CAAnB,+CAAmB;AAAnB,kBAAA,mBAAmB,CAAnB,+CAAmB;AAAnB,kBAAA,mBAAmB,CAAnB,+CAAmB;AAAnB,mBAAA,mBAAmB,CAAnB,gDAAmB;AAAnB,mBAAA,mBAAmB,CAAnB,gDAAmB;AAAnB,cAAA,sBAAmB;AAAnB,mBAAA,2BAAmB;AAAnB,yBAAA,iCAAmB;AAAnB,0BAAA,kCAAmB;AAAnB,4BAAA,oCAAmB;AAAnB,iBAAA,yBAAmB;AAAnB,4BAAA,oCAAmB;AAAnB,iBAAA,mBAAmB,CAAnB,gDAAmB;AAAnB,iBAAA,mBAAmB,CAAnB,gDAAmB;AAAnB,mBAAA,2BAAmB;AAAnB,8BAAA,sCAAmB;AAAnB,4BAAA,oCAAmB;AAAnB,gCAAA,0CAAmB;AAAnB,iBAAA,mBAAmB,CAAnB,+CAAmB;AAAnB,mBAAA,mBAAmB,CAAnB,kDAAmB;AAAnB,qBAAA,iBAAmB;AAAnB,eAAA,mBAAmB,CAAnB,kDAAmB;AAAnB,oBAAA,mBAAmB,CAAnB,gDAAmB;AAAnB,cAAA,8BAAmB;AAAnB,uBAAA,yBAAmB;AAAnB,cAAA,SAAmB;AAAnB,gBAAA,SAAmB;AAAnB,eAAA,WAAmB;AAAnB,eAAA,WAAmB;AAAnB,eAAA,YAAmB;AAAnB,eAAA,WAAmB;AAAnB,eAAA,YAAmB;AAAnB,eAAA,WAAmB;AAAnB,eAAA,+CAAmB,CAAnB,4DAAmB,CAAnB,sGAAmB;AAAnB,wDAAA,gDAAmB,CAAnB,oDAAmB,CAAnB,sGAAmB;AAAnB,cAAA,8EAAmB,CAAnB,kGAAmB,CAAnB,sGAAmB;AAAnB,cAAA,4EAAmB,CAAnB,gGAAmB,CAAnB,sGAAmB;AAAnB,gBAAA,qBAAmB,CAAnB,6BAAmB,CAAnB,sGAAmB;AAAnB,cAAA,yCAAmB,CAAnB,sDAAmB,CAAnB,sGAAmB;AAAnB,cAAA,+EAAmB,CAAnB,mGAAmB,CAAnB,sGAAmB;AAAnB,mBAAA,wCAAmB,CAAnB,6BAAmB;AAAnB,iBAAA,6BAAmB,CAAnB,kBAAmB;AAAnB,WAAA,0GAAmB,CAAnB,wGAAmB,CAAnB,2FAAmB;AAAnB,WAAA,0GAAmB,CAAnB,wGAAmB,CAAnB,2FAAmB;AAAnB,cAAA,gCAAmB;AAAnB,sBAAA,wCAAmB;AAAnB,2BAAA,6CAAmB;AAAnB,0BAAA,4BAAmB,CAAnB,sQAAmB;AAAnB,qBAAA,4BAAmB,CAAnB,sQAAmB;AAAnB,eAAA,uJAAmB,CAAnB,uDAAmB,CAAnB,yBAAmB;AAAnB,sCAAA,oCAAmB,CAAnB,uDAAmB,CAAnB,yBAAmB;AAAnB,+BAAA,8BAAmB,CAAnB,uDAAmB,CAAnB,yBAAmB;AAAnB,0CAAA,wCAAmB,CAAnB,uDAAmB,CAAnB,yBAAmB;AAAnB,yBAAA,yBAAmB,CAAnB,uDAAmB,CAAnB,yBAAmB;AAAnB,mBAAA,uBAAmB,CAAnB,uDAAmB,CAAnB,yBAAmB;AAAnB,sBAAA,8FAAmB,CAAnB,uDAAmB,CAAnB,yBAAmB;AAAnB,uBAAA,2BAAmB,CAAnB,uDAAmB,CAAnB,yBAAmB;AAAnB,yBAAA,6BAAmB,CAAnB,uDAAmB,CAAnB,yBAAmB;AAAnB,kBAAA,0BAAmB;AAAnB,iBAAA,yBAAmB;AAAnB,gBAAA,uDAAmB;AAAnB,gBAAA,iCAAmB;AAAnB,iBAAA,KAAA,kCAAmB,CAAnB,gNAAmB,CAAA;AAAnB,gBAAA,GAAA,iCAAmB,CAAnB,0MAAmB,CAAA;AAAnB,eAAA,oBAAmB,CAAnB,wBAAmB,CAAnB,0BAAmB,CAAnB,wBAAmB,CAAnB,yBAAmB,CAAnB,8BAAmB,CAAnB,8BAAmB;AAAnB,cAAA,oBAAmB;AAAnB,eAAA,sBAAmB;AAAnB,eAAA,oBAAmB;AAAnB,kBAAA,yBAAmB;AAAnB,iBAAA,wBAAmB;AAAnB,gBAAA,sDAAmB;AAAnB,gBAAA,gCAAmB;;ACwCnB;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AA7DA,yCAAA,gBA8DA;;AA9DA,+CAAA,4BA8DA;;AA9DA,wCAAA,kBA8DA,CA9DA,mBA8DA;;AA9DA,4CAAA,eA8DA;;AA9DA,gDAAA,4BA8DA;;AA9DA,yDAAA,kCA8DA;;AA9DA,oDAAA,kCA8DA;;AA9DA,2BAAA,yBA8DA,CA9DA,iBA8DA;;AA9DA,2BAAA,yBA8DA,CA9DA,aA8DA;;AA9DA,4BAAA,yBA8DA,CA9DA,OA8DA,CA9DA,UA8DA;;AA9DA,4BAAA,yBA8DA,CA9DA,QA8DA;;AA9DA,sBAAA,yBA8DA,CA9DA,aA8DA;;AA9DA,4BAAA,yBA8DA,CA9DA,SA8DA;;AA9DA,oCAAA,yBA8DA,CA9DA,qBA8DA,CA9DA,8LA8DA;;AA9DA,4BAAA,cA8DA;;AA9DA,oCAAA,gDA8DA,CA9DA,mDA8DA;;AA9DA,gCAAA,qBA8DA;;AA9DA,0BAAA,iBA8DA;;AA9DA,kCAAA,iDA8DA,CA9DA,oDA8DA;;AA9DA,gCAAA,sBA8DA;;AA9DA,qCAAA,oCA8DA;;AA9DA,wCAAA,iBA8DA;;AA9DA,oCAAA,UA8DA;;AA9DA,iCAAA,qBA8DA,CA9DA,2DA8DA;;AA9DA,gCAAA,gCA8DA;;AA9DA,2BAAA,mCA8DA;;AA9DA,+BAAA,yCA8DA;;AA9DA,gCAAA,wCA8DA;;AA9DA,oCAAA,8CA8DA;;AA9DA,oCAAA,8CA8DA;;AA9DA,oCAAA,8CA8DA;;AA9DA,6BAAA,iBA8DA,CA9DA,2DA8DA;;AA9DA,4BAAA,oCA8DA;;AA9DA,oCAAA,4CA8DA;;AA9DA,0BAAA,kCA8DA;;AA9DA,8BAAA,wCA8DA;;AA9DA,4BAAA,oCA8DA;;AA9DA,gCAAA,0CA8DA;;AA9DA,gCAAA,0CA8DA;;AA9DA,8BAAA,sCA8DA;;AA9DA,kCAAA,4CA8DA;;AA9DA,mCAAA,2CA8DA;;AA9DA,gCAAA,4BA8DA;;AA9DA,8BAAA,uCA8DA;;AA9DA,wCAAA,mCA8DA;;AA9DA,kCAAA,6BA8DA;;AA9DA,6CAAA,wCA8DA;;AA9DA,iCAAA,4BA8DA;;AA9DA,+BAAA,mBA8DA,CA9DA,kDA8DA;;AA9DA,+BAAA,mBA8DA,CA9DA,+CA8DA;;AA9DA,+BAAA,mBA8DA,CA9DA,+CA8DA;;AA9DA,gCAAA,2BA8DA;;AA9DA,uCAAA,kCA8DA;;AA9DA,8BAAA,yBA8DA;;AA9DA,yCAAA,oCA8DA;;AA9DA,gCAAA,2BA8DA;;AA9DA,gDAAA,2CA8DA;;AA9DA,4BAAA,mBA8DA,CA9DA,kDA8DA;;AA9DA,2BAAA,8BA8DA;;AA9DA,8BAAA,yBA8DA;;AA9DA,6BAAA,SA8DA;;AA9DA,4BAAA,WA8DA;;AA9DA,qEAAA,gDA8DA,CA9DA,oDA8DA,CA9DA,sGA8DA;;AA9DA,iDAAA,yBA8DA,CA9DA,2CA8DA;;AA9DA,0BAAA,2BA8DA;;AA9DA,wBAAA,gBA8DA;;AA9DA,oCAAA,gCA8DA,CA9DA,sEA8DA;;AA9DA,8BAAA,8BA8DA;;AA9DA,gCAAA,gCA8DA;;AA9DA,kCAAA,qBA8DA,CA9DA,2DA8DA;;AA9DA,2BAAA,mCA8DA;;AA9DA,4BAAA,oCA8DA;;AA9DA,wBAAA,6BA8DA,CA9DA,gCA8DA;;AA9DA,wBAAA,+BA8DA;;AA9DA,yBAAA,+BA8DA;;AA9DA,wCAAA,mCA8DA;;AA9DA,yCAAA,oCA8DA;;AA9DA,6BAAA,SA8DA;;AA9DA,8BAAA,6BA8DA,CA9DA,kBA8DA;;AA9DA,0BAAA,qHA8DA,CA9DA,mHA8DA,CA9DA,sGA8DA;;AA9DA,wBAAA,0GA8DA,CA9DA,wGA8DA,CA9DA,2FA8DA;;AA9DA,2BAAA,gCA8DA;;AA9DA,iCAAA,qCA8DA;;AA9DA,+BAAA,0BA8DA;;AA9DA,kDAAA,qBA8DA,CA9DA,2DA8DA;;AA9DA,8CAAA,6BA8DA,CA9DA,kBA8DA;;AA9DA,0CAAA,qHA8DA,CA9DA,mHA8DA,CA9DA,sGA8DA;;AA9DA,wCAAA,0GA8DA,CA9DA,wGA8DA,CA9DA,2FA8DA;;AA9DA,wCAAA,0GA8DA,CA9DA,wGA8DA,CA9DA,2FA8DA;;AA9DA,wCAAA,0GA8DA,CA9DA,wGA8DA,CA9DA,2FA8DA;;AA9DA,2CAAA,gCA8DA;;AA9DA,mDAAA,wCA8DA;;AA9DA,iDAAA,qCA8DA;;AA9DA,+CAAA,0BA8DA;;AA9DA,+CAAA,0BA8DA;;AA9DA,+CAAA,0BA8DA;;AA9DA,wDAAA,6CA8DA;;AA9DA,qCAAA,2CA8DA;;AA9DA,kDAAA,2CA8DA;;AA9DA,2CAAA,mBA8DA;;AA9DA,0CAAA,kBA8DA;;AA9DA,kCAAA,WA8DA;;AA9DA,kCAAA,WA8DA;;AA9DA,6CAAA,SA8DA;;AA9DA,oEAAA,oCA8DA;;AA9DA,gEAAA,mBA8DA,CA9DA,kDA8DA;;AA9DA,uFAAA,0CA8DA;;AA9DA,+EAAA,wCA8DA;;AA9DA,4FAAA,wCA8DA;;AA9DA,4EAAA,mBA8DA,CA9DA,kDA8DA;;AA9DA,iFAAA,uCA8DA;;AA9DA,6EAAA,mBA8DA,CA9DA,4DA8DA;;AA9DA,oFAAA,8BA8DA;;AA9DA,0DAAA,kBA8DA;;AA9DA,kDAAA,WA8DA;;AA9DA,0EAAA,+CA8DA;;AA9DA,6DAAA,mBA8DA;;AA9DA,oDAAA,WA8DA;;AA9DA,mDAAA,mCA8DA;;AA9DA,uDAAA,yCA8DA;;AA9DA,gEAAA,mCA8DA;;AA9DA,+DAAA,kCA8DA;;AA9DA,qDAAA,SA8DA;;AA9DA,oDAAA,WA8DA;;AA9DA,uEAAA,mBA8DA;;AA9DA,0DAAA,mBA8DA;;AA9DA,0FAAA,UA8DA;;AA9DA,4FAAA,UA8DA;;AA9DA,6DAAA,wBA8DA,CA9DA,8LA8DA;;AA9DA,0DAAA,yBA8DA,CA9DA,8LA8DA;;AA9DA,2DAAA,wBA8DA,CA9DA,8LA8DA;;AA9DA,wDAAA,yBA8DA,CA9DA,8LA8DA;;AA9DA,iEAAA,wBA8DA,CA9DA,8LA8DA;;AA9DA,qEAAA,oBA8DA,CA9DA,8LA8DA;;AA9DA,+DAAA,oBA8DA,CA9DA,8LA8DA;;AA9DA,4FAAA,+CA8DA,CA9DA,8LA8DA;;AA9DA,+FAAA,gDA8DA,CA9DA,8LA8DA;;AA9DA,2BAAA,KAAA,4CA8DA,CA9DA,GAAA,QA8DA,CAAA;;AA9DA,sEAAA,uCA8DA;;AA9DA,6BAAA,KAAA,QA8DA,CA9DA,GAAA,4CA8DA,CAAA;;AA9DA,oEAAA,yCA8DA;;AA9DA,8FAAA,qBA8DA;;AA9DA,8DAAA,qBA8DA,CA9DA,2DA8DA;;AA9DA,iEAAA,2CA8DA;;AA9DA,gDAAA,yCA8DA;;AA9DA,6DAAA,mCA8DA;;AA9DA,+DAAA,uCA8DA;;AA9DA,kEAAA,wCA8DA;;AA9DA,gEAAA,iBA8DA,CA9DA,yDA8DA;;AA9DA,8DAAA,oCA8DA;;AA9DA,gEAAA,sCA8DA;;AA9DA,mDAAA,mCA8DA;;AA9DA,uDAAA,mCA8DA;;AA9DA,2DAAA,yCA8DA;;AA9DA,0DAAA,sCA8DA;;AA9DA,8DAAA,kCA8DA;;AA9DA,gEAAA,kCA8DA;;AA9DA,2DAAA,eA8DA;;AA9DA,8EAAA,2CA8DA;;AA9DA,0EAAA,mCA8DA;;AA9DA,iEAAA,4BA8DA;;AA9DA,2EAAA,oCA8DA;;AA9DA,gEAAA,mCA8DA;;AA9DA,oEAAA,mCA8DA;;AA9DA,mEAAA,kCA8DA;;AA9DA,8DAAA,WA8DA;;AA9DA,iDAAA,WA8DA;;AA9DA,yDAAA,SA8DA;;AA9DA,2DAAA,yCA8DA,CA9DA,sDA8DA,CA9DA,sGA8DA;;AA9DA,sDAAA,qHA8DA,CA9DA,mHA8DA,CA9DA,sGA8DA;;AA9DA,6DAAA,qCA8DA;;AA9DA,6DAAA,wBA8DA;;AA9DA,8DAAA,yBA8DA;;AA9DA,0DAAA,yBA8DA;;AA9DA,+DAAA,oBA8DA,CA9DA,wBA8DA,CA9DA,0BA8DA,CA9DA,wBA8DA,CA9DA,yBA8DA,CA9DA,8BA8DA,CA9DA,8BA8DA;;AA9DA,wDAAA,oBA8DA,CA9DA,wBA8DA,CA9DA,0BA8DA,CA9DA,wBA8DA,CA9DA,yBA8DA,CA9DA,8BA8DA,CA9DA,8BA8DA;;AA9DA,8DAAA,oBA8DA,CA9DA,wBA8DA,CA9DA,0BA8DA,CA9DA,wBA8DA,CA9DA,yBA8DA,CA9DA,8BA8DA,CA9DA,8BA8DA;;AA9DA,4DAAA,mBA8DA,CA9DA,wBA8DA,CA9DA,yBA8DA,CA9DA,uBA8DA,CA9DA,wBA8DA,CA9DA,6BA8DA,CA9DA,6BA8DA;;AA9DA,6DAAA,mBA8DA,CA9DA,wBA8DA,CA9DA,yBA8DA,CA9DA,uBA8DA,CA9DA,wBA8DA,CA9DA,6BA8DA,CA9DA,6BA8DA;;AA9DA,6DAAA,mBA8DA,CA9DA,wBA8DA,CA9DA,yBA8DA,CA9DA,uBA8DA,CA9DA,wBA8DA,CA9DA,6BA8DA,CA9DA,6BA8DA;;AA9DA,uDAAA,mBA8DA,CA9DA,wBA8DA,CA9DA,yBA8DA,CA9DA,uBA8DA,CA9DA,wBA8DA,CA9DA,6BA8DA,CA9DA,6BA8DA;;AA9DA,4DAAA,oBA8DA;;AA9DA,yDAAA,mBA8DA;;AA9DA,4DAAA,mBA8DA;;AA9DA,6DAAA,qBA8DA;;AA9DA,0DAAA,mBA8DA;;AA9DA,uDAAA,oBA8DA;;AA9DA,2DAAA,oBA8DA;;AA9DA,6DAAA,mBA8DA;;AA9DA,wDAAA,mBA8DA;;AA9DA,wDAAA,oBA8DA;;AA9DA,8EAAA,4BA8DA;;AA9DA,iFAAA,6BA8DA;;AA9DA,yEAAA,2BA8DA;;AA9DA,4EAAA,4BA8DA;;AA9DA,mEAAA,8BA8DA;;AA9DA,iEAAA,6BA8DA;;AA9DA,kEAAA,8BA8DA;;AA9DA,gEAAA,6BA8DA;;AA9DA,qEAAA,0BA8DA;;AA9DA,mEAAA,2BA8DA;;AA9DA,wEAAA,0BA8DA;;AA9DA,oEAAA,0BA8DA;;AA9DA,yEAAA,0BA8DA;;AA9DA,kEAAA,2BA8DA;;AA9DA,2EAAA,0BA8DA;;AA9DA,kEAAA,2BA8DA;;AA9DA,gEAAA,4BA8DA;;AA9DA,qEAAA,2BA8DA;;AA9DA,iEAAA,2BA8DA;;AA9DA,+DAAA,4BA8DA;;AA9DA,wEAAA,2BA8DA;;AA9DA,oEAAA,4BA8DA;;AA9DA,8DAAA,wBA8DA;;AA9DA,0DAAA,wBA8DA;;AA9DA,0GAAA,yBA8DA,CA9DA,QA8DA;;AA9DA,uGAAA,yBA8DA,CA9DA,cA8DA;;AA9DA,0GAAA,yBA8DA,CA9DA,UA8DA;;AA9DA,qHAAA,yBA8DA,CA9DA,qBA8DA,CA9DA,8LA8DA;;AA9DA,iHAAA,yBA8DA,CA9DA,oBA8DA,CA9DA,8LA8DA;;AA9DA,4EAAA,2CA8DA;;AA9DA,yFAAA,2CA8DA;;AA9DA,+HAAA,oCA8DA;;AA9DA,gIAAA,qCA8DA;;AA9DA,oEAAA,WA8DA;;AA9DA,oEAAA,QA8DA;;AA9DA,+EAAA,gBA8DA;;AA9DA,gFAAA,YA8DA;;AA9DA,oGAAA,+BA8DA;;AA9DA,0IAAA,4CA8DA;;AA9DA,gJAAA,kDA8DA;;AA9DA,uFAAA,SA8DA;;AA9DA,iGAAA,oBA8DA,CA9DA,8LA8DA;;AA9DA,wEAAA,kBA8DA,CA9DA,8LA8DA;;AA9DA,wEAAA,kBA8DA,CA9DA,8LA8DA;;AA9DA,yFAAA,eA8DA;;AA9DA,oFAAA,2BA8DA;;AA9DA,gFAAA,gBA8DA;;AA9DA,oEAAA,sBA8DA;;AA9DA,sEAAA,qBA8DA;;AA9DA,+FAAA,uCA8DA;;AA9DA,mFAAA,SA8DA;;AA9DA,gFAAA,yEA8DA,CA9DA,6FA8DA,CA9DA,sGA8DA;;AA9DA,2GAAA,yBA8DA,CA9DA,SA8DA;;AA9DA,2GAAA,+CA8DA;;AA9DA,gHAAA,8BA8DA;;AA9DA,0CAAA,qBA8DA,CA9DA,0DA8DA;;AA9DA,4CAAA,oCA8DA;;AA9DA,gDAAA,wCA8DA;;AA9DA,0CAAA,kCA8DA;;AA9DA,qCAAA,iBA8DA,CA9DA,wDA8DA;;AA9DA,0BAAA,iBAAA,UA8DA,CA9DA,gBAAA,SA8DA,CA9DA,iBAAA,QA8DA,CA9DA,aAAA,cA8DA,CA9DA,aAAA,YA8DA,CA9DA,iBAAA,eA8DA,CA9DA,iBAAA,kBA8DA,CA9DA,iBAAA,qBA8DA,CA9DA,oBAAA,wBA8DA,CA9DA,iBAAA,YA8DA,CA9DA,oDAAA,sBA8DA,CA9DA,qDA8DA,CA9DA,8DA8DA,CA9DA,oDAAA,sBA8DA,CA9DA,mDA8DA,CA9DA,4DA8DA,CA9DA,oDAAA,sBA8DA,CA9DA,0DA8DA,CA9DA,mDA8DA,CA9DA,mBAAA,2BA8DA,CA9DA,aAAA,iBA8DA,CA9DA,kBAAA,eA8DA,CA9DA,2EAAA,2BA8DA,CAAA;;AA9DA,0BAAA,iBAAA,iBA8DA,CA9DA,cAAA,aA8DA,CA9DA,aAAA,YA8DA,CA9DA,4DAAA,iDA8DA,CA9DA,eAAA,UA8DA,CA9DA,wBAAA,eA8DA,CA9DA,qBAAA,yBA8DA,CA9DA,oBAAA,+CA8DA,CA9DA,iBAAA,kBA8DA,CA9DA,kBAAA,SA8DA,CA9DA,6BAAA,yBA8DA,CA9DA,YA8DA,CA9DA,2EAAA,aA8DA,CA9DA,oIAAA,kBA8DA,CA9DA,4EAAA,eA8DA,CA9DA,kFAAA,qBA8DA,CA9DA,8EAAA,yEA8DA,CA9DA,6FA8DA,CA9DA,sGA8DA,CAAA;;AA9DA,2BAAA,cAAA,aA8DA,CA9DA,eAAA,YA8DA,CA9DA,qBAAA,gCA8DA,CA9DA,oBAAA,+CA8DA,CA9DA,oBAAA,+CA8DA,CA9DA,oBAAA,+CA8DA,CA9DA,iBAAA,kBA8DA,CA9DA,aAAA,cA8DA,CA9DA,iBAAA,cA8DA,CA9DA,aA8DA,CAAA;;AA9DA,2BAAA,aAAA,WA8DA,CA9DA,oBAAA,+CA8DA,CA9DA,iBAAA,iBA8DA,CA9DA,aA8DA,CAAA;;AA9DA,2BAAA,uBAAA,WA8DA,CA9DA,oBAAA,eA8DA,CA9DA,iBAAA,iBA8DA,CA9DA,kBA8DA,CA9DA,oBAAA,gBA8DA,CA9DA,aA8DA,CAAA;;AA9DA,qEAAA,mCA8DA;;AA9DA,2FAAA,gDA8DA,CA9DA,mDA8DA;;AA9DA,yFAAA,iDA8DA,CA9DA,oDA8DA;;AA9DA,kGAAA,yCA8DA;;AA9DA,qGAAA,iDA8DA,CA9DA,oDA8DA;;AA9DA,iEAAA,iBA8DA;;AA9DA,kCAAA,YA8DA;;AA9DA,kCAAA,mBA8DA,CA9DA,gDA8DA;;AA9DA,oCAAA,6BA8DA;;AA9DA,wCAAA,iCA8DA;;AA9DA,kCAAA,2BA8DA;;AA9DA,uDAAA,eA8DA,CA9DA,sBA8DA,CA9DA,kBA8DA;;AA9DA,oCAAA,eA8DA,CA9DA,mBA8DA,CA9DA,2BA8DA,CA9DA,oBA8DA;;AA9DA,mDAAA,qBA8DA,CA9DA,8LA8DA;;AA9DA,8BAAA,iBA8DA;;AA9DA,4BAAA,SA8DA;;AA9DA,2BAAA,QA8DA;;AA9DA,4BAAA,UA8DA,CA9DA,WA8DA;;AA9DA,4BAAA,eA8DA;;AA9DA,yBAAA,cA8DA;;AA9DA,4BAAA,eA8DA;;AA9DA,4BAAA,cA8DA;;AA9DA,yBAAA,aA8DA;;AA9DA,4BAAA,cA8DA;;AA9DA,8BAAA,aA8DA;;AA9DA,oCAAA,mBA8DA,CA9DA,gDA8DA;;AA9DA,sCAAA,6BA8DA;;AA9DA,qCAAA,4BA8DA;;AA9DA,oCAAA,2BA8DA;;AA9DA,0CAAA,iCA8DA;;AA9DA,2CAAA,kCA8DA;;AA9DA,oCAAA,2BA8DA;;AA9DA,oDAAA,2CA8DA;;AA9DA,iDAAA,2BA8DA;;AA9DA,gCAAA,oBA8DA;;AA9DA,+CAAA,uBA8DA;;AA9DA,4GAAA,iBA8DA,CA9DA,8LA8DA;;AA9DA,qEAAA,kBA8DA,CA9DA,8LA8DA;;AA9DA,qCAAA,mBA8DA;;AA9DA,yGAAA,iCA8DA;;AA9DA,yHAAA,+BA8DA;;AA9DA,4GAAA,yBA8DA;;AA9DA,0FAAA,kBA8DA;;AA9DA,0DAAA,6BA8DA,CA9DA,kBA8DA;;AA9DA,qGAAA,yBA8DA;;AA9DA,sGAAA,sBA8DA;;AA9DA,iHAAA,sBA8DA;;AA9DA,6GAAA,yBA8DA;;AA9DA,gGAAA,kBA8DA;;AA9DA,4DAAA,6BA8DA,CA9DA,kBA8DA;;AA9DA,8DAAA,6BA8DA,CA9DA,kBA8DA;;AA9DA,6DAAA,mBA8DA,CA9DA,oBA8DA;;AA9DA,gEAAA,oBA8DA,CA9DA,uBA8DA;;AA9DA,gEAAA,iBA8DA,CA9DA,gBA8DA;;AA9DA,oEAAA,eA8DA;;AA9DA,8EAAA,kCA8DA;;AA9DA,6GAAA,eA8DA;;AA9DA,6CAAA,mBA8DA,CA9DA,oBA8DA;;AA9DA,oEAAA,cA8DA;;AA9DA,oEAAA,aA8DA;;AA9DA,6CAAA,WA8DA;;AA9DA,2CAAA,mBA8DA,CA9DA,oBA8DA;;AA9DA,2CAAA,mBA8DA,CA9DA,sBA8DA;;AA9DA,kDAAA,cA8DA;;AA9DA,kDAAA,aA8DA;;AA9DA,gCAAA,iBA8DA;;AA9DA,wCAAA,mBA8DA;;AA9DA,2BAAA,UA8DA,CA9DA,WA8DA;;AA9DA,6BAAA,aA8DA;;AA9DA,kDAAA,uBA8DA;;AA9DA,sDAAA,kBA8DA;;AA9DA,uDAAA,+BA8DA;;AA9DA,6BAAA,uBA8DA;;AA9DA,qHAAA,aA8DA;;AA9DA,gHAAA,eA8DA;;AA9DA,iEAAA,eA8DA;;AA9DA,sHAAA,YA8DA;;AA9DA,kHAAA,eA8DA;;AA9DA,mEAAA,eA8DA","sourcesContent":["/*!\n * Bootstrap Responsive v2.2.2\n *\n * Copyright 2012 Twitter, Inc\n * Licensed under the Apache License v2.0\n * http://www.apache.org/licenses/LICENSE-2.0\n *\n * Designed and built with all the love in the world @twitter by @mdo and @fat.\n */@-ms-viewport{width:device-width}.clearfix{*zoom:1}.clearfix:before,.clearfix:after{display:table;line-height:0;content:\"\"}.clearfix:after{clear:both}.hide-text{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.input-block-level{display:block;width:100%;min-height:30px;box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.hidden{display:none;visibility:hidden}.visible-phone{display:none!important}.visible-tablet{display:none!important}.hidden-desktop{display:none!important}.visible-desktop{display:inherit!important}@media(min-width:768px) and (max-width:979px){.hidden-desktop{display:inherit!important}.visible-desktop{display:none!important}.visible-tablet{display:inherit!important}.hidden-tablet{display:none!important}}@media(max-width:767px){.hidden-desktop{display:inherit!important}.visible-desktop{display:none!important}.visible-phone{display:inherit!important}.hidden-phone{display:none!important}}@media(min-width:1200px){.row{margin-left:-30px;*zoom:1}.row:before,.row:after{display:table;line-height:0;content:\"\"}.row:after{clear:both}[class*=\"span\"]{float:left;min-height:1px;margin-left:30px}.container,.navbar-static-top .container,.navbar-fixed-top .container,.navbar-fixed-bottom .container{width:1170px}.span12{width:1170px}.span11{width:1070px}.span10{width:970px}.span9{width:870px}.span8{width:770px}.span7{width:670px}.span6{width:570px}.span5{width:470px}.span4{width:370px}.span3{width:270px}.span2{width:170px}.span1{width:70px}.offset12{margin-left:1230px}.offset11{margin-left:1130px}.offset10{margin-left:1030px}.offset9{margin-left:930px}.offset8{margin-left:830px}.offset7{margin-left:730px}.offset6{margin-left:630px}.offset5{margin-left:530px}.offset4{margin-left:430px}.offset3{margin-left:330px}.offset2{margin-left:230px}.offset1{margin-left:130px}.row-fluid{width:100%;*zoom:1}.row-fluid:before,.row-fluid:after{display:table;line-height:0;content:\"\"}.row-fluid:after{clear:both}.row-fluid [class*=\"span\"]{display:block;float:left;width:100%;min-height:30px;margin-left:2.564102564102564%;*margin-left:2.5109110747408616%;box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.row-fluid [class*=\"span\"]:first-child{margin-left:0}.row-fluid .controls-row [class*=\"span\"]+[class*=\"span\"]{margin-left:2.564102564102564%}.row-fluid .span12{width:100%;*width:99.94680851063829%}.row-fluid .span11{width:91.45299145299145%;*width:91.39979996362975%}.row-fluid .span10{width:82.90598290598291%;*width:82.8527914166212%}.row-fluid .span9{width:74.35897435897436%;*width:74.30578286961266%}.row-fluid .span8{width:65.81196581196582%;*width:65.75877432260411%}.row-fluid .span7{width:57.26495726495726%;*width:57.21176577559556%}.row-fluid .span6{width:48.717948717948715%;*width:48.664757228587014%}.row-fluid .span5{width:40.17094017094017%;*width:40.11774868157847%}.row-fluid .span4{width:31.623931623931625%;*width:31.570740134569924%}.row-fluid .span3{width:23.076923076923077%;*width:23.023731587561375%}.row-fluid .span2{width:14.52991452991453%;*width:14.476723040552828%}.row-fluid .span1{width:5.982905982905983%;*width:5.929714493544281%}.row-fluid .offset12{margin-left:105.12820512820512%;*margin-left:105.02182214948171%}.row-fluid .offset12:first-child{margin-left:102.56410256410257%;*margin-left:102.45771958537915%}.row-fluid .offset11{margin-left:96.58119658119658%;*margin-left:96.47481360247316%}.row-fluid .offset11:first-child{margin-left:94.01709401709402%;*margin-left:93.91071103837061%}.row-fluid .offset10{margin-left:88.03418803418803%;*margin-left:87.92780505546462%}.row-fluid .offset10:first-child{margin-left:85.47008547008548%;*margin-left:85.36370249136206%}.row-fluid .offset9{margin-left:79.48717948717949%;*margin-left:79.38079650845607%}.row-fluid .offset9:first-child{margin-left:76.92307692307693%;*margin-left:76.81669394435352%}.row-fluid .offset8{margin-left:70.94017094017094%;*margin-left:70.83378796144753%}.row-fluid .offset8:first-child{margin-left:68.37606837606839%;*margin-left:68.26968539734497%}.row-fluid .offset7{margin-left:62.393162393162385%;*margin-left:62.28677941443899%}.row-fluid .offset7:first-child{margin-left:59.82905982905982%;*margin-left:59.72267685033642%}.row-fluid .offset6{margin-left:53.84615384615384%;*margin-left:53.739770867430444%}.row-fluid .offset6:first-child{margin-left:51.28205128205128%;*margin-left:51.175668303327875%}.row-fluid .offset5{margin-left:45.299145299145295%;*margin-left:45.1927623204219%}.row-fluid .offset5:first-child{margin-left:42.73504273504273%;*margin-left:42.62865975631933%}.row-fluid .offset4{margin-left:36.75213675213675%;*margin-left:36.645753773413354%}.row-fluid .offset4:first-child{margin-left:34.18803418803419%;*margin-left:34.081651209310785%}.row-fluid .offset3{margin-left:28.205128205128204%;*margin-left:28.0987452264048%}.row-fluid .offset3:first-child{margin-left:25.641025641025642%;*margin-left:25.53464266230224%}.row-fluid .offset2{margin-left:19.65811965811966%;*margin-left:19.551736679396257%}.row-fluid .offset2:first-child{margin-left:17.094017094017094%;*margin-left:16.98763411529369%}.row-fluid .offset1{margin-left:11.11111111111111%;*margin-left:11.004728132387708%}.row-fluid .offset1:first-child{margin-left:8.547008547008547%;*margin-left:8.440625568285142%}input,textarea,.uneditable-input{margin-left:0}.controls-row [class*=\"span\"]+[class*=\"span\"]{margin-left:30px}input.span12,textarea.span12,.uneditable-input.span12{width:1156px}input.span11,textarea.span11,.uneditable-input.span11{width:1056px}input.span10,textarea.span10,.uneditable-input.span10{width:956px}input.span9,textarea.span9,.uneditable-input.span9{width:856px}input.span8,textarea.span8,.uneditable-input.span8{width:756px}input.span7,textarea.span7,.uneditable-input.span7{width:656px}input.span6,textarea.span6,.uneditable-input.span6{width:556px}input.span5,textarea.span5,.uneditable-input.span5{width:456px}input.span4,textarea.span4,.uneditable-input.span4{width:356px}input.span3,textarea.span3,.uneditable-input.span3{width:256px}input.span2,textarea.span2,.uneditable-input.span2{width:156px}input.span1,textarea.span1,.uneditable-input.span1{width:56px}.thumbnails{margin-left:-30px}.thumbnails>li{margin-left:30px}.row-fluid .thumbnails{margin-left:0}}@media(min-width:768px) and (max-width:979px){.row{margin-left:-20px;*zoom:1}.row:before,.row:after{display:table;line-height:0;content:\"\"}.row:after{clear:both}[class*=\"span\"]{float:left;min-height:1px;margin-left:20px}.container,.navbar-static-top .container,.navbar-fixed-top .container,.navbar-fixed-bottom .container{width:724px}.span12{width:724px}.span11{width:662px}.span10{width:600px}.span9{width:538px}.span8{width:476px}.span7{width:414px}.span6{width:352px}.span5{width:290px}.span4{width:228px}.span3{width:166px}.span2{width:104px}.span1{width:42px}.offset12{margin-left:764px}.offset11{margin-left:702px}.offset10{margin-left:640px}.offset9{margin-left:578px}.offset8{margin-left:516px}.offset7{margin-left:454px}.offset6{margin-left:392px}.offset5{margin-left:330px}.offset4{margin-left:268px}.offset3{margin-left:206px}.offset2{margin-left:144px}.offset1{margin-left:82px}.row-fluid{width:100%;*zoom:1}.row-fluid:before,.row-fluid:after{display:table;line-height:0;content:\"\"}.row-fluid:after{clear:both}.row-fluid [class*=\"span\"]{display:block;float:left;width:100%;min-height:30px;margin-left:2.7624309392265194%;*margin-left:2.709239449864817%;box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.row-fluid [class*=\"span\"]:first-child{margin-left:0}.row-fluid .controls-row [class*=\"span\"]+[class*=\"span\"]{margin-left:2.7624309392265194%}.row-fluid .span12{width:100%;*width:99.94680851063829%}.row-fluid .span11{width:91.43646408839778%;*width:91.38327259903608%}.row-fluid .span10{width:82.87292817679558%;*width:82.81973668743387%}.row-fluid .span9{width:74.30939226519337%;*width:74.25620077583166%}.row-fluid .span8{width:65.74585635359117%;*width:65.69266486422946%}.row-fluid .span7{width:57.18232044198895%;*width:57.12912895262725%}.row-fluid .span6{width:48.61878453038674%;*width:48.56559304102504%}.row-fluid .span5{width:40.05524861878453%;*width:40.00205712942283%}.row-fluid .span4{width:31.491712707182323%;*width:31.43852121782062%}.row-fluid .span3{width:22.92817679558011%;*width:22.87498530621841%}.row-fluid .span2{width:14.3646408839779%;*width:14.311449394616199%}.row-fluid .span1{width:5.801104972375691%;*width:5.747913483013988%}.row-fluid .offset12{margin-left:105.52486187845304%;*margin-left:105.41847889972962%}.row-fluid .offset12:first-child{margin-left:102.76243093922652%;*margin-left:102.6560479605031%}.row-fluid .offset11{margin-left:96.96132596685082%;*margin-left:96.8549429881274%}.row-fluid .offset11:first-child{margin-left:94.1988950276243%;*margin-left:94.09251204890089%}.row-fluid .offset10{margin-left:88.39779005524862%;*margin-left:88.2914070765252%}.row-fluid .offset10:first-child{margin-left:85.6353591160221%;*margin-left:85.52897613729868%}.row-fluid .offset9{margin-left:79.8342541436464%;*margin-left:79.72787116492299%}.row-fluid .offset9:first-child{margin-left:77.07182320441989%;*margin-left:76.96544022569647%}.row-fluid .offset8{margin-left:71.2707182320442%;*margin-left:71.16433525332079%}.row-fluid .offset8:first-child{margin-left:68.50828729281768%;*margin-left:68.40190431409427%}.row-fluid .offset7{margin-left:62.70718232044199%;*margin-left:62.600799341718584%}.row-fluid .offset7:first-child{margin-left:59.94475138121547%;*margin-left:59.838368402492065%}.row-fluid .offset6{margin-left:54.14364640883978%;*margin-left:54.037263430116376%}.row-fluid .offset6:first-child{margin-left:51.38121546961326%;*margin-left:51.27483249088986%}.row-fluid .offset5{margin-left:45.58011049723757%;*margin-left:45.47372751851417%}.row-fluid .offset5:first-child{margin-left:42.81767955801105%;*margin-left:42.71129657928765%}.row-fluid .offset4{margin-left:37.01657458563536%;*margin-left:36.91019160691196%}.row-fluid .offset4:first-child{margin-left:34.25414364640884%;*margin-left:34.14776066768544%}.row-fluid .offset3{margin-left:28.45303867403315%;*margin-left:28.346655695309746%}.row-fluid .offset3:first-child{margin-left:25.69060773480663%;*margin-left:25.584224756083227%}.row-fluid .offset2{margin-left:19.88950276243094%;*margin-left:19.783119783707537%}.row-fluid .offset2:first-child{margin-left:17.12707182320442%;*margin-left:17.02068884448102%}.row-fluid .offset1{margin-left:11.32596685082873%;*margin-left:11.219583872105325%}.row-fluid .offset1:first-child{margin-left:8.56353591160221%;*margin-left:8.457152932878806%}input,textarea,.uneditable-input{margin-left:0}.controls-row [class*=\"span\"]+[class*=\"span\"]{margin-left:20px}input.span12,textarea.span12,.uneditable-input.span12{width:710px}input.span11,textarea.span11,.uneditable-input.span11{width:648px}input.span10,textarea.span10,.uneditable-input.span10{width:586px}input.span9,textarea.span9,.uneditable-input.span9{width:524px}input.span8,textarea.span8,.uneditable-input.span8{width:462px}input.span7,textarea.span7,.uneditable-input.span7{width:400px}input.span6,textarea.span6,.uneditable-input.span6{width:338px}input.span5,textarea.span5,.uneditable-input.span5{width:276px}input.span4,textarea.span4,.uneditable-input.span4{width:214px}input.span3,textarea.span3,.uneditable-input.span3{width:152px}input.span2,textarea.span2,.uneditable-input.span2{width:90px}input.span1,textarea.span1,.uneditable-input.span1{width:28px}}@media(max-width:767px){body{padding-right:20px;padding-left:20px}.navbar-fixed-top,.navbar-fixed-bottom,.navbar-static-top{margin-right:-20px;margin-left:-20px}.container-fluid{padding:0}.dl-horizontal dt{float:none;width:auto;clear:none;text-align:left}.dl-horizontal dd{margin-left:0}.container{width:auto}.row-fluid{width:100%}.row,.thumbnails{margin-left:0}.thumbnails>li{float:none;margin-left:0}[class*=\"span\"],.uneditable-input[class*=\"span\"],.row-fluid [class*=\"span\"]{display:block;float:none;width:100%;margin-left:0;box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.span12,.row-fluid .span12{width:100%;box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.row-fluid [class*=\"offset\"]:first-child{margin-left:0}.input-large,.input-xlarge,.input-xxlarge,input[class*=\"span\"],select[class*=\"span\"],textarea[class*=\"span\"],.uneditable-input{display:block;width:100%;min-height:30px;box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}.input-prepend input,.input-append input,.input-prepend input[class*=\"span\"],.input-append input[class*=\"span\"]{display:inline-block;width:auto}.controls-row [class*=\"span\"]+[class*=\"span\"]{margin-left:0}.modal{position:fixed;top:20px;right:20px;left:20px;width:auto;margin:0}.modal.fade{top:-100px}.modal.fade.in{top:20px}}@media(max-width:480px){.nav-collapse{-webkit-transform:translate3d(0,0,0)}.page-header h1 small{display:block;line-height:20px}input[type=\"checkbox\"],input[type=\"radio\"]{border:1px solid #ccc}.form-horizontal .control-label{float:none;width:auto;padding-top:0;text-align:left}.form-horizontal .controls{margin-left:0}.form-horizontal .control-list{padding-top:0}.form-horizontal .form-actions{padding-right:10px;padding-left:10px}.media .pull-left,.media .pull-right{display:block;float:none;margin-bottom:10px}.media-object{margin-right:0;margin-left:0}.modal{top:10px;right:10px;left:10px}.modal-header .close{padding:10px;margin:-10px}.carousel-caption{position:static}}@media(max-width:979px){body{padding-top:0}.navbar-fixed-top,.navbar-fixed-bottom{position:static}.navbar-fixed-top{margin-bottom:20px}.navbar-fixed-bottom{margin-top:20px}.navbar-fixed-top .navbar-inner,.navbar-fixed-bottom .navbar-inner{padding:5px}.navbar .container{width:auto;padding:0}.navbar .brand{padding-right:10px;padding-left:10px;margin:0 0 0 -5px}.nav-collapse{clear:both}.nav-collapse .nav{float:none;margin:0 0 10px}.nav-collapse .nav>li{float:none}.nav-collapse .nav>li>a{margin-bottom:2px}.nav-collapse .nav>.divider-vertical{display:none}.nav-collapse .nav .nav-header{color:#777;text-shadow:none}.nav-collapse .nav>li>a,.nav-collapse .dropdown-menu a{padding:9px 15px;font-weight:bold;color:#777;border-radius:3px;-moz-border-radius:3px;border-radius:3px}.nav-collapse .btn{padding:4px 10px 4px;font-weight:normal;border-radius:4px;-moz-border-radius:4px;border-radius:4px}.nav-collapse .dropdown-menu li+li a{margin-bottom:2px}.nav-collapse .nav>li>a:hover,.nav-collapse .dropdown-menu a:hover{background-color:#f2f2f2}.navbar-inverse .nav-collapse .nav>li>a,.navbar-inverse .nav-collapse .dropdown-menu a{color:#999}.navbar-inverse .nav-collapse .nav>li>a:hover,.navbar-inverse .nav-collapse .dropdown-menu a:hover{background-color:#111}.nav-collapse.in .btn-group{padding:0;margin-top:5px}.nav-collapse .dropdown-menu{position:static;top:auto;left:auto;display:none;float:none;max-width:none;padding:0;margin:0 15px;background-color:transparent;border:0;border-radius:0;-moz-border-radius:0;border-radius:0;box-shadow:none;-moz-box-shadow:none;box-shadow:none}.nav-collapse .open>.dropdown-menu{display:block}.nav-collapse .dropdown-menu:before,.nav-collapse .dropdown-menu:after{display:none}.nav-collapse .dropdown-menu .divider{display:none}.nav-collapse .nav>li>.dropdown-menu:before,.nav-collapse .nav>li>.dropdown-menu:after{display:none}.nav-collapse .navbar-form,.nav-collapse .navbar-search{float:none;padding:10px 15px;margin:10px 0;border-top:1px solid #f2f2f2;border-bottom:1px solid #f2f2f2;box-shadow:inset 0 1px 0 rgba(255,255,255,0.1),0 1px 0 rgba(255,255,255,0.1);-moz-box-shadow:inset 0 1px 0 rgba(255,255,255,0.1),0 1px 0 rgba(255,255,255,0.1);box-shadow:inset 0 1px 0 rgba(255,255,255,0.1),0 1px 0 rgba(255,255,255,0.1)}.navbar-inverse .nav-collapse .navbar-form,.navbar-inverse .nav-collapse .navbar-search{border-top-color:#111;border-bottom-color:#111}.navbar .nav-collapse .nav.pull-right{float:none;margin-left:0}.nav-collapse,.nav-collapse.collapse{height:0;overflow:hidden}.navbar .btn-navbar{display:block}.navbar-static .navbar-inner{padding-right:10px;padding-left:10px}}@media(min-width:980px){.nav-collapse.collapse{height:auto!important;overflow:visible!important}}","/*!\n * Bootstrap v2.2.2\n *\n * Copyright 2012 Twitter, Inc\n * Licensed under the Apache License v2.0\n * http://www.apache.org/licenses/LICENSE-2.0\n *\n * Designed and built with all the love in the world @twitter by @mdo and @fat.\n */\n.clearfix{*zoom:1;}.clearfix:before,.clearfix:after{display:table;content:\"\";line-height:0;}\n.clearfix:after{clear:both;}\n.hide-text{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0;}\n.input-block-level{display:block;width:100%;min-height:30px;box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;}\n[class^=\"icon-\"],[class*=\" icon-\"]{margin:5px;display:inline-block;width:14px;height:14px;*margin-right:.3em;line-height:14px;vertical-align:text-top;background-image:url(\"/images/bootstrap/glyphicons-halflings.png\");background-position:14px 14px;background-repeat:no-repeat;margin-top:1px;}\n.icon-white,.nav-pills>.active>a>[class^=\"icon-\"],.nav-pills>.active>a>[class*=\" icon-\"],.nav-list>.active>a>[class^=\"icon-\"],.nav-list>.active>a>[class*=\" icon-\"],.navbar-inverse .nav>.active>a>[class^=\"icon-\"],.navbar-inverse .nav>.active>a>[class*=\" icon-\"],.dropdown-menu>li>a:hover>[class^=\"icon-\"],.dropdown-menu>li>a:focus>[class^=\"icon-\"],.dropdown-menu>li>a:hover>[class*=\" icon-\"],.dropdown-menu>li>a:focus>[class*=\" icon-\"],.dropdown-menu>.active>a>[class^=\"icon-\"],.dropdown-menu>.active>a>[class*=\" icon-\"],.dropdown-submenu:hover>a>[class^=\"icon-\"],.dropdown-submenu:focus>a>[class^=\"icon-\"],.dropdown-submenu:hover>a>[class*=\" icon-\"],.dropdown-submenu:focus>a>[class*=\" icon-\"]{background-image:url(\"/images/bootstrap/glyphicons-halflings-white.png\");}\n.icon-glass{background-position:0 0;}\n.icon-music{background-position:-24px 0;}\n.icon-envelope{background-position:-72px 0;}\n.icon-heart{background-position:-96px 0;}\n.icon-star{background-position:-120px 0;}\n.icon-star-empty{background-position:-144px 0;}\n.icon-user{background-position:-168px 0;}\n.icon-film{background-position:-192px 0;}\n.icon-th-large{background-position:-216px 0;}\n.icon-th{background-position:-240px 0;}\n.icon-th-list{background-position:-264px 0;}\n.icon-ok{background-position:-288px 0;}\n.icon-remove{background-position:-312px 0;}\n.icon-zoom-in{background-position:-336px 0;}\n.icon-zoom-out{background-position:-360px 0;}\n.icon-off{background-position:-384px 0;}\n.icon-signal{background-position:-408px 0;}\n.icon-cog{background-position:-432px 0;}\n.icon-trash{background-position:-456px 0;}\n.icon-home{background-position:0 -24px;}\n.icon-file{background-position:-24px -24px;}\n.icon-time{background-position:-48px -24px;}\n.icon-road{background-position:-72px -24px;}\n.icon-download-alt{background-position:-96px -24px;}\n.icon-download{background-position:-120px -24px;}\n.icon-upload{background-position:-144px -24px;}\n.icon-inbox{background-position:-168px -24px;}\n.icon-play-circle{background-position:-192px -24px;}\n.icon-repeat{background-position:-216px -24px;}\n.icon-refresh{background-position:-240px -24px;}\n.icon-list-alt{background-position:-264px -24px;}\n.icon-lock{background-position:-287px -24px;}\n.icon-flag{background-position:-312px -24px;}\n.icon-headphones{background-position:-336px -24px;}\n.icon-volume-off{background-position:-360px -24px;}\n.icon-volume-down{background-position:-384px -24px;}\n.icon-volume-up{background-position:-408px -24px;}\n.icon-qrcode{background-position:-432px -24px;}\n.icon-barcode{background-position:-456px -24px;}\n.icon-tag{background-position:0 -48px;}\n.icon-tags{background-position:-25px -48px;}\n.icon-book{background-position:-48px -48px;}\n.icon-bookmark{background-position:-72px -48px;}\n.icon-print{background-position:-96px -48px;}\n.icon-camera{background-position:-120px -48px;}\n.icon-font{background-position:-144px -48px;}\n.icon-bold{background-position:-167px -48px;}\n.icon-italic{background-position:-192px -48px;}\n.icon-text-height{background-position:-216px -48px;}\n.icon-text-width{background-position:-240px -48px;}\n.icon-align-left{background-position:-264px -48px;}\n.icon-align-center{background-position:-288px -48px;}\n.icon-align-right{background-position:-312px -48px;}\n.icon-align-justify{background-position:-336px -48px;}\n.icon-list{background-position:-360px -48px;}\n.icon-indent-left{background-position:-384px -48px;}\n.icon-indent-right{background-position:-408px -48px;}\n.icon-facetime-video{background-position:-432px -48px;}\n.icon-picture{background-position:-456px -48px;}\n.icon-pencil{background-position:0 -72px;}\n.icon-map-marker{background-position:-24px -72px;}\n.icon-adjust{background-position:-48px -72px;}\n.icon-tint{background-position:-72px -72px;}\n.icon-edit{background-position:-96px -72px;}\n.icon-share{background-position:-120px -72px;}\n.icon-check{background-position:-144px -72px;}\n.icon-move{background-position:-168px -72px;}\n.icon-step-backward{background-position:-192px -72px;}\n.icon-fast-backward{background-position:-216px -72px;}\n.icon-backward{background-position:-240px -72px;}\n.icon-play{background-position:-264px -72px;}\n.icon-pause{background-position:-288px -72px;}\n.icon-stop{background-position:-312px -72px;}\n.icon-forward{background-position:-336px -72px;}\n.icon-fast-forward{background-position:-360px -72px;}\n.icon-step-forward{background-position:-384px -72px;}\n.icon-eject{background-position:-408px -72px;}\n.icon-chevron-left{background-position:-432px -72px;}\n.icon-chevron-right{background-position:-456px -72px;}\n.icon-plus-sign{background-position:0 -96px;}\n.icon-minus-sign{background-position:-24px -96px;}\n.icon-remove-sign{background-position:-48px -96px;}\n.icon-ok-sign{background-position:-72px -96px;}\n.icon-question-sign{background-position:-96px -96px;}\n.icon-info-sign{background-position:-120px -96px;}\n.icon-screenshot{background-position:-144px -96px;}\n.icon-remove-circle{background-position:-168px -96px;}\n.icon-ok-circle{background-position:-192px -96px;}\n.icon-ban-circle{background-position:-216px -96px;}\n.icon-arrow-left{background-position:-240px -96px;}\n.icon-arrow-right{background-position:-264px -96px;}\n.icon-arrow-up{background-position:-289px -96px;}\n.icon-arrow-down{background-position:-312px -96px;}\n.icon-share-alt{background-position:-336px -96px;}\n.icon-resize-full{background-position:-360px -96px;}\n.icon-resize-small{background-position:-384px -96px;}\n.icon-plus{background-position:-408px -96px;}\n.icon-minus{background-position:-433px -96px;}\n.icon-asterisk{background-position:-456px -96px;}\n.icon-exclamation-sign{background-position:0 -120px;}\n.icon-gift{background-position:-24px -120px;}\n.icon-leaf{background-position:-48px -120px;}\n.icon-fire{background-position:-72px -120px;}\n.icon-eye-open{background-position:-96px -120px;}\n.icon-eye-close{background-position:-120px -120px;}\n.icon-warning-sign{background-position:-144px -120px;}\n.icon-plane{background-position:-168px -120px;}\n.icon-calendar{background-position:-192px -120px;}\n.icon-random{background-position:-216px -120px;width:16px;}\n.icon-comment{background-position:-240px -120px;}\n.icon-magnet{background-position:-264px -120px;}\n.icon-chevron-up{background-position:-288px -120px;}\n.icon-chevron-down{background-position:-313px -119px;}\n.icon-retweet{background-position:-336px -120px;}\n.icon-shopping-cart{background-position:-360px -120px;}\n.icon-folder-close{background-position:-384px -120px;width:16px;}\n.icon-folder-open{background-position:-408px -120px;width:16px;}\n.icon-resize-vertical{background-position:-432px -119px;}\n.icon-resize-horizontal{background-position:-456px -118px;}\n.icon-hdd{background-position:0 -144px;}\n.icon-bullhorn{background-position:-24px -144px;}\n.icon-bell{background-position:-48px -144px;}\n.icon-certificate{background-position:-72px -144px;}\n.icon-thumbs-up{background-position:-96px -144px;}\n.icon-thumbs-down{background-position:-120px -144px;}\n.icon-hand-right{background-position:-144px -144px;}\n.icon-hand-left{background-position:-168px -144px;}\n.icon-hand-up{background-position:-192px -144px;}\n.icon-hand-down{background-position:-216px -144px;}\n.icon-circle-arrow-right{background-position:-240px -144px;}\n.icon-circle-arrow-left{background-position:-264px -144px;}\n.icon-circle-arrow-up{background-position:-288px -144px;}\n.icon-circle-arrow-down{background-position:-312px -144px;}\n.icon-globe{background-position:-336px -144px;}\n.icon-wrench{background-position:-360px -144px;}\n.icon-tasks{background-position:-384px -144px;}\n.icon-filter{background-position:-408px -144px;}\n.icon-briefcase{background-position:-432px -144px;}\n.icon-fullscreen{background-position:-456px -144px;}\narticle,aside,details,figcaption,figure,footer,header,hgroup,nav,section{display:block;}\naudio,canvas,video{display:inline-block;*display:inline;*zoom:1;}\naudio:not([controls]){display:none;}\nhtml{font-size:100%;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;}\na:focus{outline:thin dotted #333;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px;}\na:hover,a:active{outline:0;}\nsub,sup{position:relative;font-size:75%;line-height:0;vertical-align:baseline;}\nsup{top:-0.5em;}\nsub{bottom:-0.25em;}\nimg{max-width:100%;width:auto\\9;height:auto;vertical-align:middle;border:0;-ms-interpolation-mode:bicubic;}\n#map_canvas img,.google-maps img{max-width:none;}\nbutton,input,select,textarea{margin:0;font-size:100%;vertical-align:middle;}\nbutton,input{*overflow:visible;line-height:normal;}\nbutton::-moz-focus-inner,input::-moz-focus-inner{padding:0;border:0;}\nbutton,html input[type=\"button\"],input[type=\"reset\"],input[type=\"submit\"]{-webkit-appearance:button;cursor:pointer;}\nlabel,select,button,input[type=\"button\"],input[type=\"reset\"],input[type=\"submit\"],input[type=\"radio\"],input[type=\"checkbox\"]{cursor:pointer;}\ninput[type=\"search\"]{box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;-webkit-appearance:textfield;}\ninput[type=\"search\"]::-webkit-search-decoration,input[type=\"search\"]::-webkit-search-cancel-button{-webkit-appearance:none;}\ntextarea{overflow:auto;vertical-align:top;}\n@media print{*{text-shadow:none !important;color:#000 !important;background:transparent !important;box-shadow:none !important;} a,a:visited{text-decoration:underline;} a[href]:after{content:\" (\" attr(href) \")\";} abbr[title]:after{content:\" (\" attr(title) \")\";} .ir a:after,a[href^=\"javascript:\"]:after,a[href^=\"#\"]:after{content:\"\";} pre,blockquote{border:1px solid #999;page-break-inside:avoid;} thead{display:table-header-group;} tr,img{page-break-inside:avoid;} img{max-width:100% !important;} @page {margin:0.5cm;}p,h2,h3{orphans:3;widows:3;} h2,h3{page-break-after:avoid;}}body{margin:0;font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-size:14px;line-height:20px;color:#333333;background-color:#ffffff;}\na{color:#0088cc;text-decoration:none;}\na:hover{color:#005580;text-decoration:underline;}\n.img-rounded{border-radius:6px;-moz-border-radius:6px;border-radius:6px;}\n.img-polaroid{padding:4px;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0, 0, 0, 0.2);box-shadow:0 1px 3px rgba(0, 0, 0, 0.1);-moz-box-shadow:0 1px 3px rgba(0, 0, 0, 0.1);box-shadow:0 1px 3px rgba(0, 0, 0, 0.1);}\n.img-circle{border-radius:500px;-moz-border-radius:500px;border-radius:500px;}\n.row{margin-left:-20px;*zoom:1;}.row:before,.row:after{display:table;content:\"\";line-height:0;}\n.row:after{clear:both;}\n[class*=\"span\"]{float:left;min-height:1px;margin-left:20px;}\n.container,.navbar-static-top .container,.navbar-fixed-top .container,.navbar-fixed-bottom .container{width:940px;}\n.span12{width:940px;}\n.span11{width:860px;}\n.span10{width:780px;}\n.span9{width:700px;}\n.span8{width:620px;}\n.span7{width:540px;}\n.span6{width:460px;}\n.span5{width:380px;}\n.span4{width:300px;}\n.span3{width:220px;}\n.span2{width:140px;}\n.span1{width:60px;}\n.offset12{margin-left:980px;}\n.offset11{margin-left:900px;}\n.offset10{margin-left:820px;}\n.offset9{margin-left:740px;}\n.offset8{margin-left:660px;}\n.offset7{margin-left:580px;}\n.offset6{margin-left:500px;}\n.offset5{margin-left:420px;}\n.offset4{margin-left:340px;}\n.offset3{margin-left:260px;}\n.offset2{margin-left:180px;}\n.offset1{margin-left:100px;}\n.row-fluid{width:100%;*zoom:1;}.row-fluid:before,.row-fluid:after{display:table;content:\"\";line-height:0;}\n.row-fluid:after{clear:both;}\n.row-fluid [class*=\"span\"]{display:block;width:100%;min-height:30px;box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;float:left;margin-left:2.127659574468085%;*margin-left:2.074468085106383%;}\n.row-fluid [class*=\"span\"]:first-child{margin-left:0;}\n.row-fluid .controls-row [class*=\"span\"]+[class*=\"span\"]{margin-left:2.127659574468085%;}\n.row-fluid .span12{width:100%;*width:99.94680851063829%;}\n.row-fluid .span11{width:91.48936170212765%;*width:91.43617021276594%;}\n.row-fluid .span10{width:82.97872340425532%;*width:82.92553191489361%;}\n.row-fluid .span9{width:74.46808510638297%;*width:74.41489361702126%;}\n.row-fluid .span8{width:65.95744680851064%;*width:65.90425531914893%;}\n.row-fluid .span7{width:57.44680851063829%;*width:57.39361702127659%;}\n.row-fluid .span6{width:48.93617021276595%;*width:48.88297872340425%;}\n.row-fluid .span5{width:40.42553191489362%;*width:40.37234042553192%;}\n.row-fluid .span4{width:31.914893617021278%;*width:31.861702127659576%;}\n.row-fluid .span3{width:23.404255319148934%;*width:23.351063829787233%;}\n.row-fluid .span2{width:14.893617021276595%;*width:14.840425531914894%;}\n.row-fluid .span1{width:6.382978723404255%;*width:6.329787234042553%;}\n.row-fluid .offset12{margin-left:104.25531914893617%;*margin-left:104.14893617021275%;}\n.row-fluid .offset12:first-child{margin-left:102.12765957446808%;*margin-left:102.02127659574467%;}\n.row-fluid .offset11{margin-left:95.74468085106382%;*margin-left:95.6382978723404%;}\n.row-fluid .offset11:first-child{margin-left:93.61702127659574%;*margin-left:93.51063829787232%;}\n.row-fluid .offset10{margin-left:87.23404255319149%;*margin-left:87.12765957446807%;}\n.row-fluid .offset10:first-child{margin-left:85.1063829787234%;*margin-left:84.99999999999999%;}\n.row-fluid .offset9{margin-left:78.72340425531914%;*margin-left:78.61702127659572%;}\n.row-fluid .offset9:first-child{margin-left:76.59574468085106%;*margin-left:76.48936170212764%;}\n.row-fluid .offset8{margin-left:70.2127659574468%;*margin-left:70.10638297872339%;}\n.row-fluid .offset8:first-child{margin-left:68.08510638297872%;*margin-left:67.9787234042553%;}\n.row-fluid .offset7{margin-left:61.70212765957446%;*margin-left:61.59574468085106%;}\n.row-fluid .offset7:first-child{margin-left:59.574468085106375%;*margin-left:59.46808510638297%;}\n.row-fluid .offset6{margin-left:53.191489361702125%;*margin-left:53.085106382978715%;}\n.row-fluid .offset6:first-child{margin-left:51.063829787234035%;*margin-left:50.95744680851063%;}\n.row-fluid .offset5{margin-left:44.68085106382979%;*margin-left:44.57446808510638%;}\n.row-fluid .offset5:first-child{margin-left:42.5531914893617%;*margin-left:42.4468085106383%;}\n.row-fluid .offset4{margin-left:36.170212765957444%;*margin-left:36.06382978723405%;}\n.row-fluid .offset4:first-child{margin-left:34.04255319148936%;*margin-left:33.93617021276596%;}\n.row-fluid .offset3{margin-left:27.659574468085104%;*margin-left:27.5531914893617%;}\n.row-fluid .offset3:first-child{margin-left:25.53191489361702%;*margin-left:25.425531914893618%;}\n.row-fluid .offset2{margin-left:19.148936170212764%;*margin-left:19.04255319148936%;}\n.row-fluid .offset2:first-child{margin-left:17.02127659574468%;*margin-left:16.914893617021278%;}\n.row-fluid .offset1{margin-left:10.638297872340425%;*margin-left:10.53191489361702%;}\n.row-fluid .offset1:first-child{margin-left:8.51063829787234%;*margin-left:8.404255319148938%;}\n[class*=\"span\"].hide,.row-fluid [class*=\"span\"].hide{display:none;}\n[class*=\"span\"].pull-right,.row-fluid [class*=\"span\"].pull-right{float:right;}\n.container{margin-right:auto;margin-left:auto;*zoom:1;}.container:before,.container:after{display:table;content:\"\";line-height:0;}\n.container:after{clear:both;}\n.container-fluid{padding-right:20px;padding-left:20px;*zoom:1;}.container-fluid:before,.container-fluid:after{display:table;content:\"\";line-height:0;}\n.container-fluid:after{clear:both;}\n.btn-group{position:relative;display:inline-block;*display:inline;*zoom:1;font-size:0;vertical-align:middle;white-space:nowrap;*margin-left:.3em;}.btn-group:first-child{*margin-left:0;}\n.btn-group+.btn-group{margin-left:5px;}\n.btn-toolbar{font-size:0;margin-top:10px;margin-bottom:10px;}.btn-toolbar>.btn+.btn,.btn-toolbar>.btn-group+.btn,.btn-toolbar>.btn+.btn-group{margin-left:5px;}\n.btn-group>.btn{position:relative;border-radius:0;-moz-border-radius:0;border-radius:0;}\n.btn-group>.btn+.btn{margin-left:-1px;}\n.btn-group>.btn,.btn-group>.dropdown-menu,.btn-group>.popover{font-size:14px;}\n.btn-group>.btn-mini{font-size:10.5px;}\n.btn-group>.btn-small{font-size:11.9px;}\n.btn-group>.btn-large{font-size:17.5px;}\n.btn-group>.btn:first-child{margin-left:0;border-top-left-radius:4px;-moz-border-radius-topleft:4px;border-top-left-radius:4px;border-bottom-left-radius:4px;-moz-border-radius-bottomleft:4px;border-bottom-left-radius:4px;}\n.btn-group>.btn:last-child,.btn-group>.dropdown-toggle{border-top-right-radius:4px;-moz-border-radius-topright:4px;border-top-right-radius:4px;border-bottom-right-radius:4px;-moz-border-radius-bottomright:4px;border-bottom-right-radius:4px;}\n.btn-group>.btn.large:first-child{margin-left:0;border-top-left-radius:6px;-moz-border-radius-topleft:6px;border-top-left-radius:6px;border-bottom-left-radius:6px;-moz-border-radius-bottomleft:6px;border-bottom-left-radius:6px;}\n.btn-group>.btn.large:last-child,.btn-group>.large.dropdown-toggle{border-top-right-radius:6px;-moz-border-radius-topright:6px;border-top-right-radius:6px;border-bottom-right-radius:6px;-moz-border-radius-bottomright:6px;border-bottom-right-radius:6px;}\n.btn-group>.btn:hover,.btn-group>.btn:focus,.btn-group>.btn:active,.btn-group>.btn.active{z-index:2;}\n.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0;}\n.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px;box-shadow:inset 1px 0 0 rgba(255,255,255,.125), inset 0 1px 0 rgba(255,255,255,.2), 0 1px 2px rgba(0,0,0,.05);-moz-box-shadow:inset 1px 0 0 rgba(255,255,255,.125), inset 0 1px 0 rgba(255,255,255,.2), 0 1px 2px rgba(0,0,0,.05);box-shadow:inset 1px 0 0 rgba(255,255,255,.125), inset 0 1px 0 rgba(255,255,255,.2), 0 1px 2px rgba(0,0,0,.05);*padding-top:5px;*padding-bottom:5px;}\n.btn-group>.btn-mini+.dropdown-toggle{padding-left:5px;padding-right:5px;*padding-top:2px;*padding-bottom:2px;}\n.btn-group>.btn-small+.dropdown-toggle{*padding-top:5px;*padding-bottom:4px;}\n.btn-group>.btn-large+.dropdown-toggle{padding-left:12px;padding-right:12px;*padding-top:7px;*padding-bottom:7px;}\n.btn-group.open .dropdown-toggle{background-image:none;box-shadow:inset 0 2px 4px rgba(0,0,0,.15), 0 1px 2px rgba(0,0,0,.05);-moz-box-shadow:inset 0 2px 4px rgba(0,0,0,.15), 0 1px 2px rgba(0,0,0,.05);box-shadow:inset 0 2px 4px rgba(0,0,0,.15), 0 1px 2px rgba(0,0,0,.05);}\n.btn-group.open .btn.dropdown-toggle{background-color:#e6e6e6;}\n.btn-group.open .btn-primary.dropdown-toggle{background-color:#0044cc;}\n.btn-group.open .btn-warning.dropdown-toggle{background-color:#f89406;}\n.btn-group.open .btn-danger.dropdown-toggle{background-color:#bd362f;}\n.btn-group.open .btn-success.dropdown-toggle{background-color:#51a351;}\n.btn-group.open .btn-info.dropdown-toggle{background-color:#2f96b4;}\n.btn-group.open .btn-inverse.dropdown-toggle{background-color:#222222;}\n.btn .caret{margin-top:8px;margin-left:0;}\n.btn-mini .caret,.btn-small .caret,.btn-large .caret{margin-top:6px;}\n.btn-large .caret{border-left-width:5px;border-right-width:5px;border-top-width:5px;}\n.dropup .btn-large .caret{border-bottom-width:5px;}\n.btn-primary .caret,.btn-warning .caret,.btn-danger .caret,.btn-info .caret,.btn-success .caret,.btn-inverse .caret{border-top-color:#ffffff;border-bottom-color:#ffffff;}\n.btn-group-vertical{display:inline-block;*display:inline;*zoom:1;}\n.btn-group-vertical>.btn{display:block;float:none;max-width:100%;border-radius:0;-moz-border-radius:0;border-radius:0;}\n.btn-group-vertical>.btn+.btn{margin-left:0;margin-top:-1px;}\n.btn-group-vertical>.btn:first-child{border-radius:4px 4px 0 0;-moz-border-radius:4px 4px 0 0;border-radius:4px 4px 0 0;}\n.btn-group-vertical>.btn:last-child{border-radius:0 0 4px 4px;-moz-border-radius:0 0 4px 4px;border-radius:0 0 4px 4px;}\n.btn-group-vertical>.btn-large:first-child{border-radius:6px 6px 0 0;-moz-border-radius:6px 6px 0 0;border-radius:6px 6px 0 0;}\n.btn-group-vertical>.btn-large:last-child{border-radius:0 0 6px 6px;-moz-border-radius:0 0 6px 6px;border-radius:0 0 6px 6px;}\n.nav{margin-left:0;margin-bottom:20px;list-style:none;}\n.nav>li>a{display:block;}\n.nav>li>a:hover{text-decoration:none;background-color:#eeeeee;}\n.nav>li>a>img{max-width:none;}\n.nav>.pull-right{float:right;}\n.nav-header{display:block;padding:3px 15px;font-size:11px;font-weight:bold;line-height:20px;color:#999999;text-shadow:0 1px 0 rgba(255, 255, 255, 0.5);text-transform:uppercase;}\n.nav li+.nav-header{margin-top:9px;}\n.nav-list{padding-left:15px;padding-right:15px;margin-bottom:0;}\n.nav-list>li>a,.nav-list .nav-header{margin-left:-15px;margin-right:-15px;text-shadow:0 1px 0 rgba(255, 255, 255, 0.5);}\n.nav-list>li>a{padding:3px 15px;}\n.nav-list>.active>a,.nav-list>.active>a:hover{color:#ffffff;text-shadow:0 -1px 0 rgba(0, 0, 0, 0.2);background-color:#0088cc;}\n.nav-list [class^=\"icon-\"],.nav-list [class*=\" icon-\"]{margin-right:2px;}\n.nav-list .divider{*width:100%;height:1px;margin:9px 1px;*margin:-5px 0 5px;overflow:hidden;background-color:#e5e5e5;border-bottom:1px solid #ffffff;}\n.nav-tabs,.nav-pills{*zoom:1;}.nav-tabs:before,.nav-pills:before,.nav-tabs:after,.nav-pills:after{display:table;content:\"\";line-height:0;}\n.nav-tabs:after,.nav-pills:after{clear:both;}\n.nav-tabs>li,.nav-pills>li{float:left;}\n.nav-tabs>li>a,.nav-pills>li>a{padding-right:12px;padding-left:12px;margin-right:2px;line-height:14px;}\n.nav-tabs{border-bottom:1px solid #ddd;}\n.nav-tabs>li{margin-bottom:-1px;}\n.nav-tabs>li>a{padding-top:8px;padding-bottom:8px;line-height:20px;border:1px solid transparent;border-radius:4px 4px 0 0;-moz-border-radius:4px 4px 0 0;border-radius:4px 4px 0 0;}.nav-tabs>li>a:hover{border-color:#eeeeee #eeeeee #dddddd;}\n.nav-tabs>.active>a,.nav-tabs>.active>a:hover{color:#555555;background-color:#ffffff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default;}\n.nav-pills>li>a{padding-top:8px;padding-bottom:8px;margin-top:2px;margin-bottom:2px;border-radius:5px;-moz-border-radius:5px;border-radius:5px;}\n.nav-pills>.active>a,.nav-pills>.active>a:hover{color:#ffffff;background-color:#0088cc;}\n.nav-stacked>li{float:none;}\n.nav-stacked>li>a{margin-right:0;}\n.nav-tabs.nav-stacked{border-bottom:0;}\n.nav-tabs.nav-stacked>li>a{border:1px solid #ddd;border-radius:0;-moz-border-radius:0;border-radius:0;}\n.nav-tabs.nav-stacked>li:first-child>a{border-top-right-radius:4px;-moz-border-radius-topright:4px;border-top-right-radius:4px;border-top-left-radius:4px;-moz-border-radius-topleft:4px;border-top-left-radius:4px;}\n.nav-tabs.nav-stacked>li:last-child>a{border-bottom-right-radius:4px;-moz-border-radius-bottomright:4px;border-bottom-right-radius:4px;border-bottom-left-radius:4px;-moz-border-radius-bottomleft:4px;border-bottom-left-radius:4px;}\n.nav-tabs.nav-stacked>li>a:hover{border-color:#ddd;z-index:2;}\n.nav-pills.nav-stacked>li>a{margin-bottom:3px;}\n.nav-pills.nav-stacked>li:last-child>a{margin-bottom:1px;}\n.nav-tabs .dropdown-menu{border-radius:0 0 6px 6px;-moz-border-radius:0 0 6px 6px;border-radius:0 0 6px 6px;}\n.nav-pills .dropdown-menu{border-radius:6px;-moz-border-radius:6px;border-radius:6px;}\n.nav .dropdown-toggle .caret{border-top-color:#0088cc;border-bottom-color:#0088cc;margin-top:6px;}\n.nav .dropdown-toggle:hover .caret{border-top-color:#005580;border-bottom-color:#005580;}\n.nav-tabs .dropdown-toggle .caret{margin-top:8px;}\n.nav .active .dropdown-toggle .caret{border-top-color:#fff;border-bottom-color:#fff;}\n.nav-tabs .active .dropdown-toggle .caret{border-top-color:#555555;border-bottom-color:#555555;}\n.nav>.dropdown.active>a:hover{cursor:pointer;}\n.nav-tabs .open .dropdown-toggle,.nav-pills .open .dropdown-toggle,.nav>li.dropdown.open.active>a:hover{color:#ffffff;background-color:#999999;border-color:#999999;}\n.nav li.dropdown.open .caret,.nav li.dropdown.open.active .caret,.nav li.dropdown.open a:hover .caret{border-top-color:#ffffff;border-bottom-color:#ffffff;opacity:1;filter:alpha(opacity=100);}\n.tabs-stacked .open>a:hover{border-color:#999999;}\n.tabbable{*zoom:1;}.tabbable:before,.tabbable:after{display:table;content:\"\";line-height:0;}\n.tabbable:after{clear:both;}\n.tab-content{overflow:auto;}\n.tabs-below>.nav-tabs,.tabs-right>.nav-tabs,.tabs-left>.nav-tabs{border-bottom:0;}\n.tab-content>.tab-pane,.pill-content>.pill-pane{display:none;}\n.tab-content>.active,.pill-content>.active{display:block;}\n.tabs-below>.nav-tabs{border-top:1px solid #ddd;}\n.tabs-below>.nav-tabs>li{margin-top:-1px;margin-bottom:0;}\n.tabs-below>.nav-tabs>li>a{border-radius:0 0 4px 4px;-moz-border-radius:0 0 4px 4px;border-radius:0 0 4px 4px;}.tabs-below>.nav-tabs>li>a:hover{border-bottom-color:transparent;border-top-color:#ddd;}\n.tabs-below>.nav-tabs>.active>a,.tabs-below>.nav-tabs>.active>a:hover{border-color:transparent #ddd #ddd #ddd;}\n.tabs-left>.nav-tabs>li,.tabs-right>.nav-tabs>li{float:none;}\n.tabs-left>.nav-tabs>li>a,.tabs-right>.nav-tabs>li>a{min-width:74px;margin-right:0;margin-bottom:3px;}\n.tabs-left>.nav-tabs{float:left;margin-right:19px;border-right:1px solid #ddd;}\n.tabs-left>.nav-tabs>li>a{margin-right:-1px;border-radius:4px 0 0 4px;-moz-border-radius:4px 0 0 4px;border-radius:4px 0 0 4px;}\n.tabs-left>.nav-tabs>li>a:hover{border-color:#eeeeee #dddddd #eeeeee #eeeeee;}\n.tabs-left>.nav-tabs .active>a,.tabs-left>.nav-tabs .active>a:hover{border-color:#ddd transparent #ddd #ddd;*border-right-color:#ffffff;}\n.tabs-right>.nav-tabs{float:right;margin-left:19px;border-left:1px solid #ddd;}\n.tabs-right>.nav-tabs>li>a{margin-left:-1px;border-radius:0 4px 4px 0;-moz-border-radius:0 4px 4px 0;border-radius:0 4px 4px 0;}\n.tabs-right>.nav-tabs>li>a:hover{border-color:#eeeeee #eeeeee #eeeeee #dddddd;}\n.tabs-right>.nav-tabs .active>a,.tabs-right>.nav-tabs .active>a:hover{border-color:#ddd #ddd #ddd transparent;*border-left-color:#ffffff;}\n.nav>.disabled>a{color:#999999;}\n.nav>.disabled>a:hover{text-decoration:none;background-color:transparent;cursor:default;}\n.navbar{overflow:visible;*position:relative;*z-index:2;}\n.navbar-inner{min-height:40px;padding-left:20px;padding-right:20px;background-color:#fafafa;background-image:-moz-linear-gradient(to bottom, #ffffff, #f2f2f2);background-image:-webkit-gradient(linear, 0 0, 0 100%, from(#ffffff), to(#f2f2f2));background-image:-webkit-linear-gradient(to bottom, #ffffff, #f2f2f2);background-image:-o-linear-gradient(to bottom, #ffffff, #f2f2f2);background-image:linear-gradient(to bottom, #ffffff, #f2f2f2);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff', endColorstr='#fff2f2f2', GradientType=0);border:1px solid #d4d4d4;border-radius:4px;-moz-border-radius:4px;border-radius:4px;box-shadow:0 1px 4px rgba(0, 0, 0, 0.065);-moz-box-shadow:0 1px 4px rgba(0, 0, 0, 0.065);box-shadow:0 1px 4px rgba(0, 0, 0, 0.065);*zoom:1;}.navbar-inner:before,.navbar-inner:after{display:table;content:\"\";line-height:0;}\n.navbar-inner:after{clear:both;}\n.navbar .container{width:auto;}\n.nav-collapse.collapse{height:auto;overflow:visible;}\n.navbar .brand{float:left;display:block;padding:10px 20px 10px;margin-left:-20px;font-size:20px;font-weight:200;color:#777777;text-shadow:0 1px 0 #ffffff;}.navbar .brand:hover{text-decoration:none;}\n.navbar-text{margin-bottom:0;line-height:40px;color:#777777;}\n.navbar-link{color:#777777;}.navbar-link:hover{color:#333333;}\n.navbar .divider-vertical{height:40px;margin:0 9px;border-left:1px solid #f2f2f2;border-right:1px solid #ffffff;}\n.navbar .btn,.navbar .btn-group{margin-top:5px;}\n.navbar .btn-group .btn,.navbar .input-prepend .btn,.navbar .input-append .btn{margin-top:0;}\n.navbar-form{margin-bottom:0;*zoom:1;}.navbar-form:before,.navbar-form:after{display:table;content:\"\";line-height:0;}\n.navbar-form:after{clear:both;}\n.navbar-form input,.navbar-form select,.navbar-form .radio,.navbar-form .checkbox{margin-top:5px;}\n.navbar-form input,.navbar-form select,.navbar-form .btn{display:inline-block;margin-bottom:0;}\n.navbar-form input[type=\"image\"],.navbar-form input[type=\"checkbox\"],.navbar-form input[type=\"radio\"]{margin-top:3px;}\n.navbar-form .input-append,.navbar-form .input-prepend{margin-top:5px;white-space:nowrap;}.navbar-form .input-append input,.navbar-form .input-prepend input{margin-top:0;}\n.navbar-search{position:relative;float:left;margin-top:5px;margin-bottom:0;}.navbar-search .search-query{margin-bottom:0;padding:4px 14px;font-family:\"Helvetica Neue\",Helvetica,Arial,sans-serif;font-size:13px;font-weight:normal;line-height:1;border-radius:15px;-moz-border-radius:15px;border-radius:15px;}\n.navbar-static-top{position:static;margin-bottom:0;}.navbar-static-top .navbar-inner{border-radius:0;-moz-border-radius:0;border-radius:0;}\n.navbar-fixed-top,.navbar-fixed-bottom{position:fixed;right:0;left:0;z-index:1030;margin-bottom:0;}\n.navbar-fixed-top .navbar-inner,.navbar-static-top .navbar-inner{border-width:0 0 1px;}\n.navbar-fixed-bottom .navbar-inner{border-width:1px 0 0;}\n.navbar-fixed-top .navbar-inner,.navbar-fixed-bottom .navbar-inner{padding-left:0;padding-right:0;border-radius:0;-moz-border-radius:0;border-radius:0;}\n.navbar-static-top .container,.navbar-fixed-top .container,.navbar-fixed-bottom .container{width:940px;}\n.navbar-fixed-top{top:0;}\n.navbar-fixed-top .navbar-inner,.navbar-static-top .navbar-inner{box-shadow:0 1px 10px rgba(0,0,0,.1);-moz-box-shadow:0 1px 10px rgba(0,0,0,.1);box-shadow:0 1px 10px rgba(0,0,0,.1);}\n.navbar-fixed-bottom{bottom:0;}.navbar-fixed-bottom .navbar-inner{box-shadow:0 -1px 10px rgba(0,0,0,.1);-moz-box-shadow:0 -1px 10px rgba(0,0,0,.1);box-shadow:0 -1px 10px rgba(0,0,0,.1);}\n.navbar .nav{position:relative;left:0;display:block;float:left;margin:0 10px 0 0;}\n.navbar .nav.pull-right{float:right;margin-right:0;}\n.navbar .nav>li{float:left;}\n.navbar .nav>li>a{float:none;padding:10px 15px 10px;color:#777777;text-decoration:none;text-shadow:0 1px 0 #ffffff;}\n.navbar .nav .dropdown-toggle .caret{margin-top:8px;}\n.navbar .nav>li>a:focus,.navbar .nav>li>a:hover{background-color:transparent;color:#333333;text-decoration:none;}\n.navbar .nav>.active>a,.navbar .nav>.active>a:hover,.navbar .nav>.active>a:focus{color:#555555;text-decoration:none;background-color:#e5e5e5;box-shadow:inset 0 3px 8px rgba(0, 0, 0, 0.125);-moz-box-shadow:inset 0 3px 8px rgba(0, 0, 0, 0.125);box-shadow:inset 0 3px 8px rgba(0, 0, 0, 0.125);}\n.navbar .btn-navbar{display:none;float:right;padding:7px 10px;margin-left:5px;margin-right:5px;color:#ffffff;text-shadow:0 -1px 0 rgba(0, 0, 0, 0.25);background-color:#ededed;background-image:-moz-linear-gradient(to bottom, #f2f2f2, #e5e5e5);background-image:-webkit-gradient(linear, 0 0, 0 100%, from(#f2f2f2), to(#e5e5e5));background-image:-webkit-linear-gradient(to bottom, #f2f2f2, #e5e5e5);background-image:-o-linear-gradient(to bottom, #f2f2f2, #e5e5e5);background-image:linear-gradient(to bottom, #f2f2f2, #e5e5e5);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff2f2f2', endColorstr='#ffe5e5e5', GradientType=0);border-color:#e5e5e5 #e5e5e5 #bfbfbf;border-color:rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);*background-color:#e5e5e5;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);box-shadow:inset 0 1px 0 rgba(255,255,255,.1), 0 1px 0 rgba(255,255,255,.075);-moz-box-shadow:inset 0 1px 0 rgba(255,255,255,.1), 0 1px 0 rgba(255,255,255,.075);box-shadow:inset 0 1px 0 rgba(255,255,255,.1), 0 1px 0 rgba(255,255,255,.075);}.navbar .btn-navbar:hover,.navbar .btn-navbar:active,.navbar .btn-navbar.active,.navbar .btn-navbar.disabled,.navbar .btn-navbar[disabled]{color:#ffffff;background-color:#e5e5e5;*background-color:#d9d9d9;}\n.navbar .btn-navbar:active,.navbar .btn-navbar.active{background-color:#cccccc \\9;}\n.navbar .btn-navbar .icon-bar{display:block;width:18px;height:2px;background-color:#f5f5f5;border-radius:1px;-moz-border-radius:1px;border-radius:1px;box-shadow:0 1px 0 rgba(0, 0, 0, 0.25);-moz-box-shadow:0 1px 0 rgba(0, 0, 0, 0.25);box-shadow:0 1px 0 rgba(0, 0, 0, 0.25);}\n.btn-navbar .icon-bar+.icon-bar{margin-top:3px;}\n.navbar .nav>li>.dropdown-menu:before{content:'';display:inline-block;border-left:7px solid transparent;border-right:7px solid transparent;border-bottom:7px solid #ccc;border-bottom-color:rgba(0, 0, 0, 0.2);position:absolute;top:-7px;left:9px;}\n.navbar .nav>li>.dropdown-menu:after{content:'';display:inline-block;border-left:6px solid transparent;border-right:6px solid transparent;border-bottom:6px solid #ffffff;position:absolute;top:-6px;left:10px;}\n.navbar-fixed-bottom .nav>li>.dropdown-menu:before{border-top:7px solid #ccc;border-top-color:rgba(0, 0, 0, 0.2);border-bottom:0;bottom:-7px;top:auto;}\n.navbar-fixed-bottom .nav>li>.dropdown-menu:after{border-top:6px solid #ffffff;border-bottom:0;bottom:-6px;top:auto;}\n.navbar .nav li.dropdown>a:hover .caret{border-top-color:#555555;border-bottom-color:#555555;}\n.navbar .nav li.dropdown.open>.dropdown-toggle,.navbar .nav li.dropdown.active>.dropdown-toggle,.navbar .nav li.dropdown.open.active>.dropdown-toggle{background-color:#e5e5e5;color:#555555;}\n.navbar .nav li.dropdown>.dropdown-toggle .caret{border-top-color:#777777;border-bottom-color:#777777;}\n.navbar .nav li.dropdown.open>.dropdown-toggle .caret,.navbar .nav li.dropdown.active>.dropdown-toggle .caret,.navbar .nav li.dropdown.open.active>.dropdown-toggle .caret{border-top-color:#555555;border-bottom-color:#555555;}\n.navbar .pull-right>li>.dropdown-menu,.navbar .nav>li>.dropdown-menu.pull-right{left:auto;right:0;}.navbar .pull-right>li>.dropdown-menu:before,.navbar .nav>li>.dropdown-menu.pull-right:before{left:auto;right:12px;}\n.navbar .pull-right>li>.dropdown-menu:after,.navbar .nav>li>.dropdown-menu.pull-right:after{left:auto;right:13px;}\n.navbar .pull-right>li>.dropdown-menu .dropdown-menu,.navbar .nav>li>.dropdown-menu.pull-right .dropdown-menu{left:auto;right:100%;margin-left:0;margin-right:-1px;border-radius:6px 0 6px 6px;-moz-border-radius:6px 0 6px 6px;border-radius:6px 0 6px 6px;}\n.navbar-inverse .navbar-inner{background-color:#1b1b1b;background-image:-moz-linear-gradient(to bottom, #222222, #111111);background-image:-webkit-gradient(linear, 0 0, 0 100%, from(#222222), to(#111111));background-image:-webkit-linear-gradient(to bottom, #222222, #111111);background-image:-o-linear-gradient(to bottom, #222222, #111111);background-image:linear-gradient(to bottom, #222222, #111111);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff222222', endColorstr='#ff111111', GradientType=0);border-color:#252525;}\n.navbar-inverse .brand,.navbar-inverse .nav>li>a{color:#999999;text-shadow:0 -1px 0 rgba(0, 0, 0, 0.25);}.navbar-inverse .brand:hover,.navbar-inverse .nav>li>a:hover{color:#ffffff;}\n.navbar-inverse .brand{color:#999999;}\n.navbar-inverse .navbar-text{color:#999999;}\n.navbar-inverse .nav>li>a:focus,.navbar-inverse .nav>li>a:hover{background-color:transparent;color:#ffffff;}\n.navbar-inverse .nav .active>a,.navbar-inverse .nav .active>a:hover,.navbar-inverse .nav .active>a:focus{color:#ffffff;background-color:#111111;}\n.navbar-inverse .navbar-link{color:#999999;}.navbar-inverse .navbar-link:hover{color:#ffffff;}\n.navbar-inverse .divider-vertical{border-left-color:#111111;border-right-color:#222222;}\n.navbar-inverse .nav li.dropdown.open>.dropdown-toggle,.navbar-inverse .nav li.dropdown.active>.dropdown-toggle,.navbar-inverse .nav li.dropdown.open.active>.dropdown-toggle{background-color:#111111;color:#ffffff;}\n.navbar-inverse .nav li.dropdown>a:hover .caret{border-top-color:#ffffff;border-bottom-color:#ffffff;}\n.navbar-inverse .nav li.dropdown>.dropdown-toggle .caret{border-top-color:#999999;border-bottom-color:#999999;}\n.navbar-inverse .nav li.dropdown.open>.dropdown-toggle .caret,.navbar-inverse .nav li.dropdown.active>.dropdown-toggle .caret,.navbar-inverse .nav li.dropdown.open.active>.dropdown-toggle .caret{border-top-color:#ffffff;border-bottom-color:#ffffff;}\n.navbar-inverse .navbar-search .search-query{color:#ffffff;background-color:#515151;border-color:#111111;box-shadow:inset 0 1px 2px rgba(0,0,0,.1), 0 1px 0 rgba(255,255,255,.15);-moz-box-shadow:inset 0 1px 2px rgba(0,0,0,.1), 0 1px 0 rgba(255,255,255,.15);box-shadow:inset 0 1px 2px rgba(0,0,0,.1), 0 1px 0 rgba(255,255,255,.15);-webkit-transition:none;-moz-transition:none;-o-transition:none;transition:none;}.navbar-inverse .navbar-search .search-query:-moz-placeholder{color:#cccccc;}\n.navbar-inverse .navbar-search .search-query:-ms-input-placeholder{color:#cccccc;}\n.navbar-inverse .navbar-search .search-query::-webkit-input-placeholder{color:#cccccc;}\n.navbar-inverse .navbar-search .search-query:focus,.navbar-inverse .navbar-search .search-query.focused{padding:5px 15px;color:#333333;text-shadow:0 1px 0 #ffffff;background-color:#ffffff;border:0;box-shadow:0 0 3px rgba(0, 0, 0, 0.15);-moz-box-shadow:0 0 3px rgba(0, 0, 0, 0.15);box-shadow:0 0 3px rgba(0, 0, 0, 0.15);outline:0;}\n.navbar-inverse .btn-navbar{color:#ffffff;text-shadow:0 -1px 0 rgba(0, 0, 0, 0.25);background-color:#0e0e0e;background-image:-moz-linear-gradient(to bottom, #151515, #040404);background-image:-webkit-gradient(linear, 0 0, 0 100%, from(#151515), to(#040404));background-image:-webkit-linear-gradient(to bottom, #151515, #040404);background-image:-o-linear-gradient(to bottom, #151515, #040404);background-image:linear-gradient(to bottom, #151515, #040404);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff151515', endColorstr='#ff040404', GradientType=0);border-color:#040404 #040404 #000000;border-color:rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);*background-color:#040404;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);}.navbar-inverse .btn-navbar:hover,.navbar-inverse .btn-navbar:active,.navbar-inverse .btn-navbar.active,.navbar-inverse .btn-navbar.disabled,.navbar-inverse .btn-navbar[disabled]{color:#ffffff;background-color:#040404;*background-color:#000000;}\n.navbar-inverse .btn-navbar:active,.navbar-inverse .btn-navbar.active{background-color:#000000 \\9;}\n.breadcrumb{padding:8px 15px;margin:0 0 20px;list-style:none;background-color:#f5f5f5;border-radius:4px;-moz-border-radius:4px;border-radius:4px;}.breadcrumb>li{display:inline-block;*display:inline;*zoom:1;text-shadow:0 1px 0 #ffffff;}.breadcrumb>li>.divider{padding:0 5px;color:#ccc;}\n.breadcrumb>.active{color:#999999;}\n.pagination{margin:20px 0;}\n.pagination ul{display:inline-block;*display:inline;*zoom:1;margin-left:0;margin-bottom:0;border-radius:4px;-moz-border-radius:4px;border-radius:4px;box-shadow:0 1px 2px rgba(0, 0, 0, 0.05);-moz-box-shadow:0 1px 2px rgba(0, 0, 0, 0.05);box-shadow:0 1px 2px rgba(0, 0, 0, 0.05);}\n.pagination ul>li{display:inline;}\n.pagination ul>li>a,.pagination ul>li>span{float:left;padding:4px 12px;line-height:20px;text-decoration:none;background-color:#ffffff;border:1px solid #dddddd;border-left-width:0;}\n.pagination ul>li>a:hover,.pagination ul>.active>a,.pagination ul>.active>span{background-color:#f5f5f5;}\n.pagination ul>.active>a,.pagination ul>.active>span{color:#999999;cursor:default;}\n.pagination ul>.disabled>span,.pagination ul>.disabled>a,.pagination ul>.disabled>a:hover{color:#999999;background-color:transparent;cursor:default;}\n.pagination ul>li:first-child>a,.pagination ul>li:first-child>span{border-left-width:1px;border-top-left-radius:4px;-moz-border-radius-topleft:4px;border-top-left-radius:4px;border-bottom-left-radius:4px;-moz-border-radius-bottomleft:4px;border-bottom-left-radius:4px;}\n.pagination ul>li:last-child>a,.pagination ul>li:last-child>span{border-top-right-radius:4px;-moz-border-radius-topright:4px;border-top-right-radius:4px;border-bottom-right-radius:4px;-moz-border-radius-bottomright:4px;border-bottom-right-radius:4px;}\n.pagination-centered{text-align:center;}\n.pagination-right{text-align:right;}\n.pagination-large ul>li>a,.pagination-large ul>li>span{padding:11px 19px;font-size:17.5px;}\n.pagination-large ul>li:first-child>a,.pagination-large ul>li:first-child>span{border-top-left-radius:6px;-moz-border-radius-topleft:6px;border-top-left-radius:6px;border-bottom-left-radius:6px;-moz-border-radius-bottomleft:6px;border-bottom-left-radius:6px;}\n.pagination-large ul>li:last-child>a,.pagination-large ul>li:last-child>span{border-top-right-radius:6px;-moz-border-radius-topright:6px;border-top-right-radius:6px;border-bottom-right-radius:6px;-moz-border-radius-bottomright:6px;border-bottom-right-radius:6px;}\n.pagination-mini ul>li:first-child>a,.pagination-small ul>li:first-child>a,.pagination-mini ul>li:first-child>span,.pagination-small ul>li:first-child>span{border-top-left-radius:3px;-moz-border-radius-topleft:3px;border-top-left-radius:3px;border-bottom-left-radius:3px;-moz-border-radius-bottomleft:3px;border-bottom-left-radius:3px;}\n.pagination-mini ul>li:last-child>a,.pagination-small ul>li:last-child>a,.pagination-mini ul>li:last-child>span,.pagination-small ul>li:last-child>span{border-top-right-radius:3px;-moz-border-radius-topright:3px;border-top-right-radius:3px;border-bottom-right-radius:3px;-moz-border-radius-bottomright:3px;border-bottom-right-radius:3px;}\n.pagination-small ul>li>a,.pagination-small ul>li>span{padding:2px 10px;font-size:11.9px;}\n.pagination-mini ul>li>a,.pagination-mini ul>li>span{padding:0 6px;font-size:10.5px;}\n.pager{margin:20px 0;list-style:none;text-align:center;*zoom:1;}.pager:before,.pager:after{display:table;content:\"\";line-height:0;}\n.pager:after{clear:both;}\n.pager li{display:inline;}\n.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px;-moz-border-radius:15px;border-radius:15px;}\n.pager li>a:hover{text-decoration:none;background-color:#f5f5f5;}\n.pager .next>a,.pager .next>span{float:right;}\n.pager .previous>a,.pager .previous>span{float:left;}\n.pager .disabled>a,.pager .disabled>a:hover,.pager .disabled>span{color:#999999;background-color:#fff;cursor:default;}\n.thumbnails{margin-left:-20px;list-style:none;*zoom:1;}.thumbnails:before,.thumbnails:after{display:table;content:\"\";line-height:0;}\n.thumbnails:after{clear:both;}\n.row-fluid .thumbnails{margin-left:0;}\n.thumbnails>li{float:left;margin-bottom:20px;margin-left:20px;}\n.thumbnail{display:block;padding:4px;line-height:20px;border:1px solid #ddd;border-radius:4px;-moz-border-radius:4px;border-radius:4px;box-shadow:0 1px 3px rgba(0, 0, 0, 0.055);-moz-box-shadow:0 1px 3px rgba(0, 0, 0, 0.055);box-shadow:0 1px 3px rgba(0, 0, 0, 0.055);-webkit-transition:all 0.2s ease-in-out;-moz-transition:all 0.2s ease-in-out;-o-transition:all 0.2s ease-in-out;transition:all 0.2s ease-in-out;}\na.thumbnail:hover{border-color:#0088cc;box-shadow:0 1px 4px rgba(0, 105, 214, 0.25);-moz-box-shadow:0 1px 4px rgba(0, 105, 214, 0.25);box-shadow:0 1px 4px rgba(0, 105, 214, 0.25);}\n.thumbnail>img{display:block;max-width:100%;margin-left:auto;margin-right:auto;}\n.thumbnail .caption{padding:9px;color:#555555;}\n.alert{padding:8px 35px 8px 14px;margin-bottom:20px;text-shadow:0 1px 0 rgba(255, 255, 255, 0.5);background-color:#fcf8e3;border:1px solid #fbeed5;border-radius:4px;-moz-border-radius:4px;border-radius:4px;}\n.alert,.alert h4{color:#c09853;}\n.alert h4{margin:0;}\n.alert .close{position:relative;top:-2px;right:-21px;line-height:20px;}\n.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#468847;}\n.alert-success h4{color:#468847;}\n.alert-danger,.alert-error{background-color:#f2dede;border-color:#eed3d7;color:#b94a48;}\n.alert-danger h4,.alert-error h4{color:#b94a48;}\n.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#3a87ad;}\n.alert-info h4{color:#3a87ad;}\n.alert-block{padding-top:14px;padding-bottom:14px;}\n.alert-block>p,.alert-block>ul{margin-bottom:0;}\n.alert-block p+p{margin-top:5px;}\n@-webkit-keyframes progress-bar-stripes{from{background-position:40px 0;} to{background-position:0 0;}}@-moz-keyframes progress-bar-stripes{from{background-position:40px 0;} to{background-position:0 0;}}@-ms-keyframes progress-bar-stripes{from{background-position:40px 0;} to{background-position:0 0;}}@-o-keyframes progress-bar-stripes{from{background-position:0 0;} to{background-position:40px 0;}}@keyframes progress-bar-stripes{from{background-position:40px 0;} to{background-position:0 0;}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f7f7f7;background-image:-moz-linear-gradient(to bottom, #f5f5f5, #f9f9f9);background-image:-webkit-gradient(linear, 0 0, 0 100%, from(#f5f5f5), to(#f9f9f9));background-image:-webkit-linear-gradient(to bottom, #f5f5f5, #f9f9f9);background-image:-o-linear-gradient(to bottom, #f5f5f5, #f9f9f9);background-image:linear-gradient(to bottom, #f5f5f5, #f9f9f9);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff5f5f5', endColorstr='#fff9f9f9', GradientType=0);box-shadow:inset 0 1px 2px rgba(0, 0, 0, 0.1);-moz-box-shadow:inset 0 1px 2px rgba(0, 0, 0, 0.1);box-shadow:inset 0 1px 2px rgba(0, 0, 0, 0.1);border-radius:4px;-moz-border-radius:4px;border-radius:4px;}\n.progress .bar{width:0%;height:100%;color:#ffffff;float:left;font-size:12px;text-align:center;text-shadow:0 -1px 0 rgba(0, 0, 0, 0.25);background-color:#0e90d2;background-image:-moz-linear-gradient(to bottom, #149bdf, #0480be);background-image:-webkit-gradient(linear, 0 0, 0 100%, from(#149bdf), to(#0480be));background-image:-webkit-linear-gradient(to bottom, #149bdf, #0480be);background-image:-o-linear-gradient(to bottom, #149bdf, #0480be);background-image:linear-gradient(to bottom, #149bdf, #0480be);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff149bdf', endColorstr='#ff0480be', GradientType=0);box-shadow:inset 0 -1px 0 rgba(0, 0, 0, 0.15);-moz-box-shadow:inset 0 -1px 0 rgba(0, 0, 0, 0.15);box-shadow:inset 0 -1px 0 rgba(0, 0, 0, 0.15);box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;-webkit-transition:width 0.6s ease;-moz-transition:width 0.6s ease;-o-transition:width 0.6s ease;transition:width 0.6s ease;}\n.progress .bar+.bar{box-shadow:inset 1px 0 0 rgba(0,0,0,.15), inset 0 -1px 0 rgba(0,0,0,.15);-moz-box-shadow:inset 1px 0 0 rgba(0,0,0,.15), inset 0 -1px 0 rgba(0,0,0,.15);box-shadow:inset 1px 0 0 rgba(0,0,0,.15), inset 0 -1px 0 rgba(0,0,0,.15);}\n.progress-striped .bar{background-color:#149bdf;background-image:-webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));background-image:-webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:-moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);-webkit-background-size:40px 40px;-moz-background-size:40px 40px;-o-background-size:40px 40px;background-size:40px 40px;}\n.progress.active .bar{-webkit-animation:progress-bar-stripes 2s linear infinite;-moz-animation:progress-bar-stripes 2s linear infinite;-ms-animation:progress-bar-stripes 2s linear infinite;-o-animation:progress-bar-stripes 2s linear infinite;animation:progress-bar-stripes 2s linear infinite;}\n.progress-danger .bar,.progress .bar-danger{background-color:#dd514c;background-image:-moz-linear-gradient(to bottom, #ee5f5b, #c43c35);background-image:-webkit-gradient(linear, 0 0, 0 100%, from(#ee5f5b), to(#c43c35));background-image:-webkit-linear-gradient(to bottom, #ee5f5b, #c43c35);background-image:-o-linear-gradient(to bottom, #ee5f5b, #c43c35);background-image:linear-gradient(to bottom, #ee5f5b, #c43c35);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffee5f5b', endColorstr='#ffc43c35', GradientType=0);}\n.progress-danger.progress-striped .bar,.progress-striped .bar-danger{background-color:#ee5f5b;background-image:-webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));background-image:-webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:-moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);}\n.progress-success .bar,.progress .bar-success{background-color:#5eb95e;background-image:-moz-linear-gradient(to bottom, #62c462, #57a957);background-image:-webkit-gradient(linear, 0 0, 0 100%, from(#62c462), to(#57a957));background-image:-webkit-linear-gradient(to bottom, #62c462, #57a957);background-image:-o-linear-gradient(to bottom, #62c462, #57a957);background-image:linear-gradient(to bottom, #62c462, #57a957);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff62c462', endColorstr='#ff57a957', GradientType=0);}\n.progress-success.progress-striped .bar,.progress-striped .bar-success{background-color:#62c462;background-image:-webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));background-image:-webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:-moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);}\n.progress-info .bar,.progress .bar-info{background-color:#4bb1cf;background-image:-moz-linear-gradient(to bottom, #5bc0de, #339bb9);background-image:-webkit-gradient(linear, 0 0, 0 100%, from(#5bc0de), to(#339bb9));background-image:-webkit-linear-gradient(to bottom, #5bc0de, #339bb9);background-image:-o-linear-gradient(to bottom, #5bc0de, #339bb9);background-image:linear-gradient(to bottom, #5bc0de, #339bb9);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff5bc0de', endColorstr='#ff339bb9', GradientType=0);}\n.progress-info.progress-striped .bar,.progress-striped .bar-info{background-color:#5bc0de;background-image:-webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));background-image:-webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:-moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);}\n.progress-warning .bar,.progress .bar-warning{background-color:#faa732;background-image:-moz-linear-gradient(to bottom, #fbb450, #f89406);background-image:-webkit-gradient(linear, 0 0, 0 100%, from(#fbb450), to(#f89406));background-image:-webkit-linear-gradient(to bottom, #fbb450, #f89406);background-image:-o-linear-gradient(to bottom, #fbb450, #f89406);background-image:linear-gradient(to bottom, #fbb450, #f89406);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#fffbb450', endColorstr='#fff89406', GradientType=0);}\n.progress-warning.progress-striped .bar,.progress-striped .bar-warning{background-color:#fbb450;background-image:-webkit-gradient(linear, 0 100%, 100% 0, color-stop(0.25, rgba(255, 255, 255, 0.15)), color-stop(0.25, transparent), color-stop(0.5, transparent), color-stop(0.5, rgba(255, 255, 255, 0.15)), color-stop(0.75, rgba(255, 255, 255, 0.15)), color-stop(0.75, transparent), to(transparent));background-image:-webkit-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:-moz-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:-o-linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);background-image:linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);}\n.hero-unit{padding:60px;margin-bottom:30px;font-size:18px;font-weight:200;line-height:30px;color:inherit;background-color:#eeeeee;border-radius:6px;-moz-border-radius:6px;border-radius:6px;}.hero-unit h1{margin-bottom:0;font-size:60px;line-height:1;color:inherit;letter-spacing:-1px;}\n.hero-unit li{line-height:30px;}\n.media,.media-body{overflow:hidden;*overflow:visible;zoom:1;}\n.media,.media .media{margin-top:15px;}\n.media:first-child{margin-top:0;}\n.media-object{display:block;}\n.media-heading{margin:0 0 5px;}\n.media .pull-left{margin-right:10px;}\n.media .pull-right{margin-left:10px;}\n.media-list{margin-left:0;list-style:none;}\n.tooltip{position:absolute;z-index:1030;display:block;visibility:visible;padding:5px;font-size:11px;opacity:0;filter:alpha(opacity=0);}.tooltip.in{opacity:0.8;filter:alpha(opacity=80);}\n.tooltip.top{margin-top:-3px;}\n.tooltip.right{margin-left:3px;}\n.tooltip.bottom{margin-top:3px;}\n.tooltip.left{margin-left:-3px;}\n.tooltip-inner{max-width:200px;padding:3px 8px;color:#ffffff;text-align:center;text-decoration:none;background-color:#000000;border-radius:4px;-moz-border-radius:4px;border-radius:4px;}\n.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid;}\n.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000000;}\n.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000000;}\n.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000000;}\n.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000000;}\n.popover{position:absolute;top:0;left:0;z-index:1010;display:none;width:236px;padding:1px;text-align:left;background-color:#ffffff;-webkit-background-clip:padding-box;-moz-background-clip:padding;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0, 0, 0, 0.2);border-radius:6px;-moz-border-radius:6px;border-radius:6px;box-shadow:0 5px 10px rgba(0, 0, 0, 0.2);-moz-box-shadow:0 5px 10px rgba(0, 0, 0, 0.2);box-shadow:0 5px 10px rgba(0, 0, 0, 0.2);white-space:normal;}.popover.top{margin-top:-10px;}\n.popover.right{margin-left:10px;}\n.popover.bottom{margin-top:10px;}\n.popover.left{margin-left:-10px;}\n.popover-title{margin:0;padding:8px 14px;font-size:14px;font-weight:normal;line-height:18px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0;-moz-border-radius:5px 5px 0 0;border-radius:5px 5px 0 0;}\n.popover-content{padding:9px 14px;}\n.popover .arrow,.popover .arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid;}\n.popover .arrow{border-width:11px;}\n.popover .arrow:after{border-width:10px;content:\"\";}\n.popover.top .arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0, 0, 0, 0.25);bottom:-11px;}.popover.top .arrow:after{bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#ffffff;}\n.popover.right .arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0, 0, 0, 0.25);}.popover.right .arrow:after{left:1px;bottom:-10px;border-left-width:0;border-right-color:#ffffff;}\n.popover.bottom .arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0, 0, 0, 0.25);top:-11px;}.popover.bottom .arrow:after{top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#ffffff;}\n.popover.left .arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0, 0, 0, 0.25);}.popover.left .arrow:after{right:1px;border-right-width:0;border-left-color:#ffffff;bottom:-10px;}\n.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000000;}.modal-backdrop.fade{opacity:0;}\n.modal-backdrop,.modal-backdrop.fade.in{opacity:0.8;filter:alpha(opacity=80);}\n.modal{position:fixed;top:10%;left:50%;z-index:1050;width:560px;margin-left:-280px;background-color:#ffffff;border:1px solid #999;border:1px solid rgba(0, 0, 0, 0.3);*border:1px solid #999;border-radius:6px;-moz-border-radius:6px;border-radius:6px;box-shadow:0 3px 7px rgba(0, 0, 0, 0.3);-moz-box-shadow:0 3px 7px rgba(0, 0, 0, 0.3);box-shadow:0 3px 7px rgba(0, 0, 0, 0.3);-webkit-background-clip:padding-box;-moz-background-clip:padding-box;background-clip:padding-box;outline:none;}.modal.fade{-webkit-transition:opacity .3s linear, top .3s ease-out;-moz-transition:opacity .3s linear, top .3s ease-out;-o-transition:opacity .3s linear, top .3s ease-out;transition:opacity .3s linear, top .3s ease-out;top:-25%;}\n.modal.fade.in{top:10%;}\n.modal-header{padding:9px 15px;border-bottom:1px solid #eee;}.modal-header .close{margin-top:2px;}\n.modal-header h3{margin:0;line-height:30px;}\n.modal-body{position:relative;overflow-y:auto;max-height:400px;padding:15px;}\n.modal-form{margin-bottom:0;}\n.modal-footer{padding:14px 15px 15px;margin-bottom:0;text-align:right;background-color:#f5f5f5;border-top:1px solid #ddd;border-radius:0 0 6px 6px;-moz-border-radius:0 0 6px 6px;border-radius:0 0 6px 6px;box-shadow:inset 0 1px 0 #ffffff;-moz-box-shadow:inset 0 1px 0 #ffffff;box-shadow:inset 0 1px 0 #ffffff;*zoom:1;}.modal-footer:before,.modal-footer:after{display:table;content:\"\";line-height:0;}\n.modal-footer:after{clear:both;}\n.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0;}\n.modal-footer .btn-group .btn+.btn{margin-left:-1px;}\n.modal-footer .btn-block+.btn-block{margin-left:0;}\n.dropup,.dropdown{position:relative;}\n.dropdown-toggle{*margin-bottom:-3px;}\n.dropdown-toggle:active,.open .dropdown-toggle{outline:0;}\n.caret{display:inline-block;width:0;height:0;vertical-align:top;border-top:4px solid #000000;border-right:4px solid transparent;border-left:4px solid transparent;content:\"\";}\n.dropdown .caret{margin-top:8px;margin-left:2px;}\n.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;background-color:#ffffff;border:1px solid #ccc;border:1px solid rgba(0, 0, 0, 0.2);*border-right-width:2px;*border-bottom-width:2px;border-radius:6px;-moz-border-radius:6px;border-radius:6px;box-shadow:0 5px 10px rgba(0, 0, 0, 0.2);-moz-box-shadow:0 5px 10px rgba(0, 0, 0, 0.2);box-shadow:0 5px 10px rgba(0, 0, 0, 0.2);-webkit-background-clip:padding-box;-moz-background-clip:padding;background-clip:padding-box;}.dropdown-menu.pull-right{right:0;left:auto;}\n.dropdown-menu .divider{*width:100%;height:1px;margin:9px 1px;*margin:-5px 0 5px;overflow:hidden;background-color:#e5e5e5;border-bottom:1px solid #ffffff;}\n.dropdown-menu li>a{display:block;padding:3px 20px;clear:both;font-weight:normal;line-height:20px;color:#333333;white-space:nowrap;}\n.dropdown-menu li>a:hover,.dropdown-menu li>a:focus,.dropdown-submenu:hover>a{text-decoration:none;color:#ffffff;background-color:#0081c2;background-image:-moz-linear-gradient(to bottom, #0088cc, #0077b3);background-image:-webkit-gradient(linear, 0 0, 0 100%, from(#0088cc), to(#0077b3));background-image:-webkit-linear-gradient(to bottom, #0088cc, #0077b3);background-image:-o-linear-gradient(to bottom, #0088cc, #0077b3);background-image:linear-gradient(to bottom, #0088cc, #0077b3);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff0088cc', endColorstr='#ff0077b3', GradientType=0);}\n.dropdown-menu .active>a,.dropdown-menu .active>a:hover{color:#ffffff;text-decoration:none;outline:0;background-color:#0081c2;background-image:-moz-linear-gradient(to bottom, #0088cc, #0077b3);background-image:-webkit-gradient(linear, 0 0, 0 100%, from(#0088cc), to(#0077b3));background-image:-webkit-linear-gradient(to bottom, #0088cc, #0077b3);background-image:-o-linear-gradient(to bottom, #0088cc, #0077b3);background-image:linear-gradient(to bottom, #0088cc, #0077b3);background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff0088cc', endColorstr='#ff0077b3', GradientType=0);}\n.dropdown-menu .disabled>a,.dropdown-menu .disabled>a:hover{color:#999999;}\n.dropdown-menu .disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:default;}\n.open{*z-index:1000;}.open >.dropdown-menu{display:block;}\n.pull-right>.dropdown-menu{right:0;left:auto;}\n.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px solid #000000;content:\"\";}\n.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:1px;}\n.dropdown-submenu{position:relative;}\n.dropdown-submenu>.dropdown-menu{top:0;left:100%;margin-top:-6px;margin-left:-1px;border-radius:0 6px 6px 6px;-moz-border-radius:0 6px 6px 6px;border-radius:0 6px 6px 6px;}\n.dropdown-submenu:hover>.dropdown-menu{display:block;}\n.dropup .dropdown-submenu>.dropdown-menu{top:auto;bottom:0;margin-top:0;margin-bottom:-2px;border-radius:5px 5px 5px 0;-moz-border-radius:5px 5px 5px 0;border-radius:5px 5px 5px 0;}\n.dropdown-submenu>a:after{display:block;content:\" \";float:right;width:0;height:0;border-color:transparent;border-style:solid;border-width:5px 0 5px 5px;border-left-color:#cccccc;margin-top:5px;margin-right:-10px;}\n.dropdown-submenu:hover>a:after{border-left-color:#ffffff;}\n.dropdown-submenu.pull-left{float:none;}.dropdown-submenu.pull-left>.dropdown-menu{left:-100%;margin-left:10px;border-radius:6px 0 6px 6px;-moz-border-radius:6px 0 6px 6px;border-radius:6px 0 6px 6px;}\n.dropdown .dropdown-menu .nav-header{padding-left:20px;padding-right:20px;}\n.typeahead{z-index:1051;margin-top:2px;border-radius:4px;-moz-border-radius:4px;border-radius:4px;}\n.accordion{margin-bottom:20px;}\n/*.accordion-group{margin:10px;border:1px solid #e5e5e5;border-radius:4px;-moz-border-radius:4px;border-radius:4px;background-color: #F8F8F8}*/\n.accordion-group{margin:10px;border:1px solid #e5e5e5;background-color: #F8F8F8;border-radius: 4px;}\n.accordion-heading{border-bottom:0;}\n.accordion-heading .accordion-toggle{display:block;padding:8px 15px}\n.accordion-heading .accordion-toggle::first-letter{text-transform:capitalize;}\n.accordion-toggle{cursor:pointer;}\n/*.accordion-inner{padding:9px 15px;border-top:1px solid #e5e5e5;}*/\n.accordion-inner{padding:9px 15px;background-color: rgb(255, 255, 255);}\n.carousel{position:relative;margin-bottom:20px;line-height:1;}\n.carousel-inner{overflow:hidden;width:100%;position:relative;}\n.carousel-inner>.item{display:none;position:relative;-webkit-transition:0.6s ease-in-out left;-moz-transition:0.6s ease-in-out left;-o-transition:0.6s ease-in-out left;transition:0.6s ease-in-out left;}\n.carousel-inner>.item>img{display:block;line-height:1;}\n.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block;}\n.carousel-inner>.active{left:0;}\n.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%;}\n.carousel-inner>.next{left:100%;}\n.carousel-inner>.prev{left:-100%;}\n.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0;}\n.carousel-inner>.active.left{left:-100%;}\n.carousel-inner>.active.right{left:100%;}\n.carousel-control{position:absolute;top:40%;left:15px;width:40px;height:40px;margin-top:-20px;font-size:60px;font-weight:100;line-height:30px;color:#ffffff;text-align:center;background:#222222;border:3px solid #ffffff;border-radius:23px;-moz-border-radius:23px;border-radius:23px;opacity:0.5;filter:alpha(opacity=50);}.carousel-control.right{left:auto;right:15px;}\n.carousel-control:hover{color:#ffffff;text-decoration:none;opacity:0.9;filter:alpha(opacity=90);}\n.carousel-caption{position:absolute;left:0;right:0;bottom:0;padding:15px;background:#333333;background:rgba(0, 0, 0, 0.75);}\n.carousel-caption h4,.carousel-caption p{color:#ffffff;line-height:20px;}\n.carousel-caption h4{margin:0 0 5px;}\n.carousel-caption p{margin-bottom:0;}\n.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;-moz-border-radius:4px;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.05);-moz-box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.05);box-shadow:inset 0 1px 1px rgba(0, 0, 0, 0.05);}.well blockquote{border-color:#ddd;border-color:rgba(0, 0, 0, 0.15);}\n.well-large{padding:24px;border-radius:6px;-moz-border-radius:6px;border-radius:6px;}\n.well-small{padding:9px;border-radius:3px;-moz-border-radius:3px;border-radius:3px;}\n.close{float:right;font-size:20px;font-weight:bold;line-height:20px;color:#000000;text-shadow:0 1px 0 #ffffff;opacity:0.2;filter:alpha(opacity=20);}.close:hover{color:#000000;text-decoration:none;cursor:pointer;opacity:0.4;filter:alpha(opacity=40);}\nbutton.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none;}\n.pull-right{float:right;}\n.pull-left{float:left;}\n.hide{display:none;}\n.show{display:block;}\n.invisible{visibility:hidden;}\n.affix{position:fixed;}\n.fade{opacity:0;-webkit-transition:opacity 0.15s linear;-moz-transition:opacity 0.15s linear;-o-transition:opacity 0.15s linear;transition:opacity 0.15s linear;}.fade.in{opacity:1;}\n.collapse{position:relative;height:0;overflow:hidden;-webkit-transition:height 0.35s ease;-moz-transition:height 0.35s ease;-o-transition:height 0.35s ease;transition:height 0.35s ease;}.collapse.in{height:auto;}\n.hidden{display:none;visibility:hidden;}\n.visible-phone{display:none !important;}\n.visible-tablet{display:none !important;}\n.hidden-desktop{display:none !important;}\n.visible-desktop{display:inherit !important;}\n@media (min-width:768px) and (max-width:979px){.hidden-desktop{display:inherit !important;} .visible-desktop{display:none !important ;} .visible-tablet{display:inherit !important;} .hidden-tablet{display:none !important;}}@media (max-width:767px){.hidden-desktop{display:inherit !important;} .visible-desktop{display:none !important;} .visible-phone{display:inherit !important;} .hidden-phone{display:none !important;}}@media (max-width:767px){body{padding-left:20px;padding-right:20px;} .navbar-fixed-top,.navbar-fixed-bottom,.navbar-static-top{margin-left:-20px;margin-right:-20px;} .container-fluid{padding:0;} .dl-horizontal dt{float:none;clear:none;width:auto;text-align:left;} .dl-horizontal dd{margin-left:0;} .container{width:auto;} .row-fluid{width:100%;} .row,.thumbnails{margin-left:0;} .thumbnails>li{float:none;margin-left:0;} [class*=\"span\"],.uneditable-input[class*=\"span\"],.row-fluid [class*=\"span\"]{float:none;display:block;width:100%;margin-left:0;box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;} .span12,.row-fluid .span12{width:100%;box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;} .row-fluid [class*=\"offset\"]:first-child{margin-left:0;} .input-large,.input-xlarge,.input-xxlarge,input[class*=\"span\"],select[class*=\"span\"],textarea[class*=\"span\"],.uneditable-input{display:block;width:100%;min-height:30px;box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;} .input-prepend input,.input-append input,.input-prepend input[class*=\"span\"],.input-append input[class*=\"span\"]{display:inline-block;width:auto;} .controls-row [class*=\"span\"]+[class*=\"span\"]{margin-left:0;} .modal{position:fixed;top:20px;left:20px;right:20px;width:auto;margin:0;}.modal.fade{top:-100px;} .modal.fade.in{top:20px;}}@media (max-width:480px){.nav-collapse{-webkit-transform:translate3d(0, 0, 0);} .page-header h1 small{display:block;line-height:20px;} input[type=\"checkbox\"],input[type=\"radio\"]{border:1px solid #ccc;} .form-horizontal .control-label{float:none;width:auto;padding-top:0;text-align:left;} .form-horizontal .controls{margin-left:0;} .form-horizontal .control-list{padding-top:0;} .form-horizontal .form-actions{padding-left:10px;padding-right:10px;} .media .pull-left,.media .pull-right{float:none;display:block;margin-bottom:10px;} .media-object{margin-right:0;margin-left:0;} .modal{top:10px;left:10px;right:10px;} .modal-header .close{padding:10px;margin:-10px;} .carousel-caption{position:static;}}@media (min-width:768px) and (max-width:979px){.row{margin-left:-20px;*zoom:1;}.row:before,.row:after{display:table;content:\"\";line-height:0;} .row:after{clear:both;} [class*=\"span\"]{float:left;min-height:1px;margin-left:20px;} .container,.navbar-static-top .container,.navbar-fixed-top .container,.navbar-fixed-bottom .container{width:724px;} .span12{width:724px;} .span11{width:662px;} .span10{width:600px;} .span9{width:538px;} .span8{width:476px;} .span7{width:414px;} .span6{width:352px;} .span5{width:290px;} .span4{width:228px;} .span3{width:166px;} .span2{width:104px;} .span1{width:42px;} .offset12{margin-left:764px;} .offset11{margin-left:702px;} .offset10{margin-left:640px;} .offset9{margin-left:578px;} .offset8{margin-left:516px;} .offset7{margin-left:454px;} .offset6{margin-left:392px;} .offset5{margin-left:330px;} .offset4{margin-left:268px;} .offset3{margin-left:206px;} .offset2{margin-left:144px;} .offset1{margin-left:82px;} .row-fluid{width:100%;*zoom:1;}.row-fluid:before,.row-fluid:after{display:table;content:\"\";line-height:0;} .row-fluid:after{clear:both;} .row-fluid [class*=\"span\"]{display:block;width:100%;min-height:30px;box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;float:left;margin-left:2.7624309392265194%;*margin-left:2.709239449864817%;} .row-fluid [class*=\"span\"]:first-child{margin-left:0;} .row-fluid .controls-row [class*=\"span\"]+[class*=\"span\"]{margin-left:2.7624309392265194%;} .row-fluid .span12{width:100%;*width:99.94680851063829%;} .row-fluid .span11{width:91.43646408839778%;*width:91.38327259903608%;} .row-fluid .span10{width:82.87292817679558%;*width:82.81973668743387%;} .row-fluid .span9{width:74.30939226519337%;*width:74.25620077583166%;} .row-fluid .span8{width:65.74585635359117%;*width:65.69266486422946%;} .row-fluid .span7{width:57.18232044198895%;*width:57.12912895262725%;} .row-fluid .span6{width:48.61878453038674%;*width:48.56559304102504%;} .row-fluid .span5{width:40.05524861878453%;*width:40.00205712942283%;} .row-fluid .span4{width:31.491712707182323%;*width:31.43852121782062%;} .row-fluid .span3{width:22.92817679558011%;*width:22.87498530621841%;} .row-fluid .span2{width:14.3646408839779%;*width:14.311449394616199%;} .row-fluid .span1{width:5.801104972375691%;*width:5.747913483013988%;} .row-fluid .offset12{margin-left:105.52486187845304%;*margin-left:105.41847889972962%;} .row-fluid .offset12:first-child{margin-left:102.76243093922652%;*margin-left:102.6560479605031%;} .row-fluid .offset11{margin-left:96.96132596685082%;*margin-left:96.8549429881274%;} .row-fluid .offset11:first-child{margin-left:94.1988950276243%;*margin-left:94.09251204890089%;} .row-fluid .offset10{margin-left:88.39779005524862%;*margin-left:88.2914070765252%;} .row-fluid .offset10:first-child{margin-left:85.6353591160221%;*margin-left:85.52897613729868%;} .row-fluid .offset9{margin-left:79.8342541436464%;*margin-left:79.72787116492299%;} .row-fluid .offset9:first-child{margin-left:77.07182320441989%;*margin-left:76.96544022569647%;} .row-fluid .offset8{margin-left:71.2707182320442%;*margin-left:71.16433525332079%;} .row-fluid .offset8:first-child{margin-left:68.50828729281768%;*margin-left:68.40190431409427%;} .row-fluid .offset7{margin-left:62.70718232044199%;*margin-left:62.600799341718584%;} .row-fluid .offset7:first-child{margin-left:59.94475138121547%;*margin-left:59.838368402492065%;} .row-fluid .offset6{margin-left:54.14364640883978%;*margin-left:54.037263430116376%;} .row-fluid .offset6:first-child{margin-left:51.38121546961326%;*margin-left:51.27483249088986%;} .row-fluid .offset5{margin-left:45.58011049723757%;*margin-left:45.47372751851417%;} .row-fluid .offset5:first-child{margin-left:42.81767955801105%;*margin-left:42.71129657928765%;} .row-fluid .offset4{margin-left:37.01657458563536%;*margin-left:36.91019160691196%;} .row-fluid .offset4:first-child{margin-left:34.25414364640884%;*margin-left:34.14776066768544%;} .row-fluid .offset3{margin-left:28.45303867403315%;*margin-left:28.346655695309746%;} .row-fluid .offset3:first-child{margin-left:25.69060773480663%;*margin-left:25.584224756083227%;} .row-fluid .offset2{margin-left:19.88950276243094%;*margin-left:19.783119783707537%;} .row-fluid .offset2:first-child{margin-left:17.12707182320442%;*margin-left:17.02068884448102%;} .row-fluid .offset1{margin-left:11.32596685082873%;*margin-left:11.219583872105325%;} .row-fluid .offset1:first-child{margin-left:8.56353591160221%;*margin-left:8.457152932878806%;} input,textarea,.uneditable-input{margin-left:0;} .controls-row [class*=\"span\"]+[class*=\"span\"]{margin-left:20px;} input.span12, textarea.span12, .uneditable-input.span12{width:710px;} input.span11, textarea.span11, .uneditable-input.span11{width:648px;} input.span10, textarea.span10, .uneditable-input.span10{width:586px;} input.span9, textarea.span9, .uneditable-input.span9{width:524px;} input.span8, textarea.span8, .uneditable-input.span8{width:462px;} input.span7, textarea.span7, .uneditable-input.span7{width:400px;} input.span6, textarea.span6, .uneditable-input.span6{width:338px;} input.span5, textarea.span5, .uneditable-input.span5{width:276px;} input.span4, textarea.span4, .uneditable-input.span4{width:214px;} input.span3, textarea.span3, .uneditable-input.span3{width:152px;} input.span2, textarea.span2, .uneditable-input.span2{width:90px;} input.span1, textarea.span1, .uneditable-input.span1{width:28px;}}@media (min-width:1200px){.row{margin-left:-30px;*zoom:1;}.row:before,.row:after{display:table;content:\"\";line-height:0;} .row:after{clear:both;} [class*=\"span\"]{float:left;min-height:1px;margin-left:30px;} .container,.navbar-static-top .container,.navbar-fixed-top .container,.navbar-fixed-bottom .container{width:1170px;} .span12{width:1170px;} .span11{width:1070px;} .span10{width:970px;} .span9{width:870px;} .span8{width:770px;} .span7{width:670px;} .span6{width:570px;} .span5{width:470px;} .span4{width:370px;} .span3{width:270px;} .span2{width:170px;} .span1{width:70px;} .offset12{margin-left:1230px;} .offset11{margin-left:1130px;} .offset10{margin-left:1030px;} .offset9{margin-left:930px;} .offset8{margin-left:830px;} .offset7{margin-left:730px;} .offset6{margin-left:630px;} .offset5{margin-left:530px;} .offset4{margin-left:430px;} .offset3{margin-left:330px;} .offset2{margin-left:230px;} .offset1{margin-left:130px;} .row-fluid{width:100%;*zoom:1;}.row-fluid:before,.row-fluid:after{display:table;content:\"\";line-height:0;} .row-fluid:after{clear:both;} .row-fluid [class*=\"span\"]{display:block;width:100%;min-height:30px;box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;float:left;margin-left:2.564102564102564%;*margin-left:2.5109110747408616%;} .row-fluid [class*=\"span\"]:first-child{margin-left:0;} .row-fluid .controls-row [class*=\"span\"]+[class*=\"span\"]{margin-left:2.564102564102564%;} .row-fluid .span12{width:100%;*width:99.94680851063829%;} .row-fluid .span11{width:91.45299145299145%;*width:91.39979996362975%;} .row-fluid .span10{width:82.90598290598291%;*width:82.8527914166212%;} .row-fluid .span9{width:74.35897435897436%;*width:74.30578286961266%;} .row-fluid .span8{width:65.81196581196582%;*width:65.75877432260411%;} .row-fluid .span7{width:57.26495726495726%;*width:57.21176577559556%;} .row-fluid .span6{width:48.717948717948715%;*width:48.664757228587014%;} .row-fluid .span5{width:40.17094017094017%;*width:40.11774868157847%;} .row-fluid .span4{width:31.623931623931625%;*width:31.570740134569924%;} .row-fluid .span3{width:23.076923076923077%;*width:23.023731587561375%;} .row-fluid .span2{width:14.52991452991453%;*width:14.476723040552828%;} .row-fluid .span1{width:5.982905982905983%;*width:5.929714493544281%;} .row-fluid .offset12{margin-left:105.12820512820512%;*margin-left:105.02182214948171%;} .row-fluid .offset12:first-child{margin-left:102.56410256410257%;*margin-left:102.45771958537915%;} .row-fluid .offset11{margin-left:96.58119658119658%;*margin-left:96.47481360247316%;} .row-fluid .offset11:first-child{margin-left:94.01709401709402%;*margin-left:93.91071103837061%;} .row-fluid .offset10{margin-left:88.03418803418803%;*margin-left:87.92780505546462%;} .row-fluid .offset10:first-child{margin-left:85.47008547008548%;*margin-left:85.36370249136206%;} .row-fluid .offset9{margin-left:79.48717948717949%;*margin-left:79.38079650845607%;} .row-fluid .offset9:first-child{margin-left:76.92307692307693%;*margin-left:76.81669394435352%;} .row-fluid .offset8{margin-left:70.94017094017094%;*margin-left:70.83378796144753%;} .row-fluid .offset8:first-child{margin-left:68.37606837606839%;*margin-left:68.26968539734497%;} .row-fluid .offset7{margin-left:62.393162393162385%;*margin-left:62.28677941443899%;} .row-fluid .offset7:first-child{margin-left:59.82905982905982%;*margin-left:59.72267685033642%;} .row-fluid .offset6{margin-left:53.84615384615384%;*margin-left:53.739770867430444%;} .row-fluid .offset6:first-child{margin-left:51.28205128205128%;*margin-left:51.175668303327875%;} .row-fluid .offset5{margin-left:45.299145299145295%;*margin-left:45.1927623204219%;} .row-fluid .offset5:first-child{margin-left:42.73504273504273%;*margin-left:42.62865975631933%;} .row-fluid .offset4{margin-left:36.75213675213675%;*margin-left:36.645753773413354%;} .row-fluid .offset4:first-child{margin-left:34.18803418803419%;*margin-left:34.081651209310785%;} .row-fluid .offset3{margin-left:28.205128205128204%;*margin-left:28.0987452264048%;} .row-fluid .offset3:first-child{margin-left:25.641025641025642%;*margin-left:25.53464266230224%;} .row-fluid .offset2{margin-left:19.65811965811966%;*margin-left:19.551736679396257%;} .row-fluid .offset2:first-child{margin-left:17.094017094017094%;*margin-left:16.98763411529369%;} .row-fluid .offset1{margin-left:11.11111111111111%;*margin-left:11.004728132387708%;} .row-fluid .offset1:first-child{margin-left:8.547008547008547%;*margin-left:8.440625568285142%;} input,textarea,.uneditable-input{margin-left:0;} .controls-row [class*=\"span\"]+[class*=\"span\"]{margin-left:30px;} input.span12, textarea.span12, .uneditable-input.span12{width:1156px;} input.span11, textarea.span11, .uneditable-input.span11{width:1056px;} input.span10, textarea.span10, .uneditable-input.span10{width:956px;} input.span9, textarea.span9, .uneditable-input.span9{width:856px;} input.span8, textarea.span8, .uneditable-input.span8{width:756px;} input.span7, textarea.span7, .uneditable-input.span7{width:656px;} input.span6, textarea.span6, .uneditable-input.span6{width:556px;} input.span5, textarea.span5, .uneditable-input.span5{width:456px;} input.span4, textarea.span4, .uneditable-input.span4{width:356px;} input.span3, textarea.span3, .uneditable-input.span3{width:256px;} input.span2, textarea.span2, .uneditable-input.span2{width:156px;} input.span1, textarea.span1, .uneditable-input.span1{width:56px;} .thumbnails{margin-left:-30px;} .thumbnails>li{margin-left:30px;} .row-fluid .thumbnails{margin-left:0;}}@media (max-width:979px){body{padding-top:0;} .navbar-fixed-top,.navbar-fixed-bottom{position:static;} .navbar-fixed-top{margin-bottom:20px;} .navbar-fixed-bottom{margin-top:20px;} .navbar-fixed-top .navbar-inner,.navbar-fixed-bottom .navbar-inner{padding:5px;} .navbar .container{width:auto;padding:0;} .navbar .brand{padding-left:10px;padding-right:10px;margin:0 0 0 -5px;} .nav-collapse{clear:both;} .nav-collapse .nav{float:none;margin:0 0 10px;} .nav-collapse .nav>li{float:none;} .nav-collapse .nav>li>a{margin-bottom:2px;} .nav-collapse .nav>.divider-vertical{display:none;} .nav-collapse .nav .nav-header{color:#777777;text-shadow:none;} .nav-collapse .nav>li>a,.nav-collapse .dropdown-menu a{padding:9px 15px;font-weight:bold;color:#777777;border-radius:3px;-moz-border-radius:3px;border-radius:3px;} .nav-collapse .btn{padding:4px 10px 4px;font-weight:normal;border-radius:4px;-moz-border-radius:4px;border-radius:4px;} .nav-collapse .dropdown-menu li+li a{margin-bottom:2px;} .nav-collapse .nav>li>a:hover,.nav-collapse .dropdown-menu a:hover{background-color:#f2f2f2;} .navbar-inverse .nav-collapse .nav>li>a,.navbar-inverse .nav-collapse .dropdown-menu a{color:#999999;} .navbar-inverse .nav-collapse .nav>li>a:hover,.navbar-inverse .nav-collapse .dropdown-menu a:hover{background-color:#111111;} .nav-collapse.in .btn-group{margin-top:5px;padding:0;} .nav-collapse .dropdown-menu{position:static;top:auto;left:auto;float:none;display:none;max-width:none;margin:0 15px;padding:0;background-color:transparent;border:none;border-radius:0;-moz-border-radius:0;border-radius:0;box-shadow:none;-moz-box-shadow:none;box-shadow:none;} .nav-collapse .open>.dropdown-menu{display:block;} .nav-collapse .dropdown-menu:before,.nav-collapse .dropdown-menu:after{display:none;} .nav-collapse .dropdown-menu .divider{display:none;} .nav-collapse .nav>li>.dropdown-menu:before,.nav-collapse .nav>li>.dropdown-menu:after{display:none;} .nav-collapse .navbar-form,.nav-collapse .navbar-search{float:none;padding:10px 15px;margin:10px 0;border-top:1px solid #f2f2f2;border-bottom:1px solid #f2f2f2;box-shadow:inset 0 1px 0 rgba(255,255,255,.1), 0 1px 0 rgba(255,255,255,.1);-moz-box-shadow:inset 0 1px 0 rgba(255,255,255,.1), 0 1px 0 rgba(255,255,255,.1);box-shadow:inset 0 1px 0 rgba(255,255,255,.1), 0 1px 0 rgba(255,255,255,.1);} .navbar-inverse .nav-collapse .navbar-form,.navbar-inverse .nav-collapse .navbar-search{border-top-color:#111111;border-bottom-color:#111111;} .navbar .nav-collapse .nav.pull-right{float:none;margin-left:0;} .nav-collapse,.nav-collapse.collapse{overflow:hidden;height:0;} .navbar .btn-navbar{display:block;} .navbar-static .navbar-inner{padding-left:10px;padding-right:10px;}}@media (min-width:980px){.nav-collapse.collapse{height:auto !important;overflow:visible !important;}}\n","/*!\n * Bootstrap v2.2.1\n *\n * Copyright 2012 Twitter, Inc\n * Licensed under the Apache License v2.0\n * http://www.apache.org/licenses/LICENSE-2.0\n *\n * Designed and built with all the love in the world @twitter by @mdo and @fat.\n */\n.clearfix {\n    *zoom: 1;\n}\n\n.clearfix:before,\n.clearfix:after {\n    display: table;\n    content: \"\";\n    line-height: 0;\n}\n\n.clearfix:after {\n    clear: both;\n}\n\n.hide-text {\n    font: 0/0 a;\n    color: transparent;\n    text-shadow: none;\n    background-color: transparent;\n    border: 0;\n}\n\n.input-block-level {\n    display: block;\n    width: 100%;\n    min-height: 30px;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n}\n\n.navbar {\n    overflow: visible;\n    /*margin-bottom: 20px;*/\n    color: #777777;\n    *position: relative;\n    *z-index: 2;\n}\n\n.navbar-inner {\n    min-height: 40px;\n    padding: 0 10px;\n    background-color: #FAFAFA;\n    background-image: -moz-linear-gradient(to bottom, #FFFFFF, #F2F2F2);\n    background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#FFFFFF), to(#F2F2F2));\n    background-image: -webkit-linear-gradient(to bottom, #FFFFFF, #F2F2F2);\n    background-image: -o-linear-gradient(to bottom, #FFFFFF, #F2F2F2);\n    background-image: linear-gradient(to bottom, #FFFFFF, #F2F2F2);\n    background-repeat: repeat-x;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffffff', endColorstr='#fff2f2f2', GradientType=0);\n    border: 1px solid #D4D4D4;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.065);\n    -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, 0.065);\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.065);\n    *zoom: 1;\n}\n\n.navbar-inner:before,\n.navbar-inner:after {\n    display: table;\n    content: \"\";\n    line-height: 0;\n}\n\n.navbar-inner:after {\n    clear: both;\n}\n\n.navbar .container {\n    width: auto;\n}\n\n.nav-collapse.collapse {\n    height: auto;\n    overflow: visible;\n}\n\n.navbar .brand {\n    float: left;\n    display: block;\n    padding: 4px 20px;\n    margin-left: -20px;\n    font-size: 20px;\n    font-weight: 200;\n    color: #777777;\n    text-shadow: 0 1px 0 #FFFFFF;\n}\n\n.navbar .brand .svg_icon {\n    line-height: 30px;\n    margin-right: 20px;\n}\n\n.navbar .brand:hover {\n    text-decoration: none;\n}\n\n.navbar-text {\n    margin-bottom: 0;\n    line-height: 40px;\n}\n\n.navbar-link {\n    color: #777777;\n}\n\n.navbar-link:hover {\n    color: #333333;\n}\n\n.navbar .divider-vertical {\n    height: 40px;\n    margin: 0 9px;\n    border-left: 1px solid #F2F2F2;\n    border-right: 1px solid #FFFFFF;\n}\n\n.navbar .btn,\n.navbar .btn-group {\n    margin-top: 5px;\n}\n\n.navbar .btn-group .btn,\n.navbar .input-prepend .btn,\n.navbar .input-append .btn {\n    margin-top: 0;\n}\n\n.navbar-form {\n    margin-bottom: 0;\n    *zoom: 1;\n}\n\n.navbar-form:before,\n.navbar-form:after {\n    display: table;\n    content: \"\";\n    line-height: 0;\n}\n\n.navbar-form:after {\n    clear: both;\n}\n\n.navbar-form input,\n.navbar-form select,\n.navbar-form .radio,\n.navbar-form .checkbox {\n    margin-top: 5px;\n}\n\n.navbar-form input,\n.navbar-form select,\n.navbar-form .btn {\n    display: inline-block;\n    margin-bottom: 0;\n}\n\n.navbar-form input[type=\"image\"],\n.navbar-form input[type=\"checkbox\"],\n.navbar-form input[type=\"radio\"] {\n    margin-top: 3px;\n}\n\n.navbar-form .input-append,\n.navbar-form .input-prepend {\n    margin-top: 6px;\n    white-space: nowrap;\n}\n\n.navbar-form .input-append input,\n.navbar-form .input-prepend input {\n    margin-top: 0;\n}\n\n.navbar-search {\n    position: relative;\n    float: left;\n    margin-top: 5px;\n    margin-bottom: 0;\n}\n\n.navbar-search .search-query {\n    margin-bottom: 0;\n    padding: 4px 14px;\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 13px;\n    font-weight: normal;\n    line-height: 1;\n    border-radius: 15px;\n    -moz-border-radius: 15px;\n    border-radius: 15px;\n}\n\n.navbar-static-top {\n    position: static;\n    margin-bottom: 0;\n}\n\n.navbar-static-top .navbar-inner {\n    border-radius: 0;\n    -moz-border-radius: 0;\n    border-radius: 0;\n}\n\n.navbar-fixed-top,\n.navbar-fixed-bottom {\n    position: fixed;\n    right: 0;\n    left: 0;\n    z-index: 1030;\n    margin-bottom: 0;\n}\n\n.navbar-fixed-top .navbar-inner,\n.navbar-static-top .navbar-inner {\n    border-width: 0 0 1px;\n}\n\n.navbar-fixed-bottom .navbar-inner {\n    border-width: 1px 0 0;\n}\n\n.navbar-fixed-top .navbar-inner,\n.navbar-fixed-bottom .navbar-inner {\n    padding-left: 0;\n    padding-right: 0;\n    border-radius: 0;\n    -moz-border-radius: 0;\n    border-radius: 0;\n}\n\n.navbar-static-top .container,\n.navbar-fixed-top .container,\n.navbar-fixed-bottom .container {\n    width: 940px;\n}\n\n.navbar-fixed-top {\n    top: 0;\n}\n\n.navbar-fixed-top .navbar-inner,\n.navbar-static-top .navbar-inner {\n    box-shadow: 0 1px 10px rgba(0, 0, 0, .1);\n    -moz-box-shadow: 0 1px 10px rgba(0, 0, 0, .1);\n    box-shadow: 0 1px 10px rgba(0, 0, 0, .1);\n}\n\n.navbar-fixed-bottom {\n    bottom: 0;\n}\n\n.navbar-fixed-bottom .navbar-inner {\n    box-shadow: 0 -1px 10px rgba(0, 0, 0, .1);\n    -moz-box-shadow: 0 -1px 10px rgba(0, 0, 0, .1);\n    box-shadow: 0 -1px 10px rgba(0, 0, 0, .1);\n}\n\n.navbar .nav {\n    position: relative;\n    left: 0;\n    display: block;\n    float: left;\n    margin: 0 10px 0 0;\n}\n\n.navbar .nav.pull-right {\n    float: right;\n    margin-right: 0;\n}\n\n.navbar .nav > li {\n    float: left;\n\n    &::first-letter {\n        text-transform: capitalize;\n    }\n}\n\n.navbar .nav > li > a {\n    float: none;\n    padding: 10px 15px 10px;\n    color: #777777;\n    text-decoration: none;\n    text-shadow: 0 1px 0 #FFFFFF;\n}\n\n.navbar .nav .dropdown-toggle .caret {\n    margin-top: 8px;\n}\n\n.navbar .nav > li > a:focus,\n.navbar .nav > li > a:hover {\n    cursor: pointer;\n    background-color: transparent;\n    color: #333333;\n    text-decoration: none;\n}\n\n.navbar .nav > .active > a,\n.navbar .nav > .active > a:hover,\n.navbar .nav > .active > a:focus {\n    color: #555555;\n    text-decoration: none;\n    background-color: #E5E5E5;\n    box-shadow: inset 0 3px 8px rgba(0, 0, 0, 0.125);\n    -moz-box-shadow: inset 0 3px 8px rgba(0, 0, 0, 0.125);\n    box-shadow: inset 0 3px 8px rgba(0, 0, 0, 0.125);\n}\n\n.navbar .btn-navbar {\n    display: none;\n    float: right;\n    padding: 7px 10px;\n    margin-left: 5px;\n    margin-right: 5px;\n    color: #FFFFFF;\n    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n    background-color: #EDEDED;\n    background-image: -moz-linear-gradient(to bottom, #F2F2F2, #E5E5E5);\n    background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#F2F2F2), to(#E5E5E5));\n    background-image: -webkit-linear-gradient(to bottom, #F2F2F2, #E5E5E5);\n    background-image: -o-linear-gradient(to bottom, #F2F2F2, #E5E5E5);\n    background-image: linear-gradient(to bottom, #F2F2F2, #E5E5E5);\n    background-repeat: repeat-x;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fff2f2f2', endColorstr='#ffe5e5e5', GradientType=0);\n    border-color: #E5E5E5 #E5E5E5 #BFBFBF;\n    border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n    *background-color: #E5E5E5;\n    /* Darken IE7 buttons by default so they stand out more given they won't have borders */\n\n    filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .075);\n    -moz-box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .075);\n    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .1), 0 1px 0 rgba(255, 255, 255, .075);\n}\n\n.navbar .btn-navbar:hover,\n.navbar .btn-navbar:active,\n.navbar .btn-navbar.active,\n.navbar .btn-navbar.disabled,\n.navbar .btn-navbar[disabled] {\n    color: #FFFFFF;\n    background-color: #E5E5E5;\n    *background-color: #D9D9D9;\n}\n\n.navbar .btn-navbar:active,\n.navbar .btn-navbar.active {\n    background-color: #CCCCCC \\9;\n}\n\n.navbar .btn-navbar .icon-bar {\n    display: block;\n    width: 18px;\n    height: 2px;\n    background-color: #F5F5F5;\n    border-radius: 1px;\n    -moz-border-radius: 1px;\n    border-radius: 1px;\n    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);\n    -moz-box-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);\n    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);\n}\n\n.btn-navbar .icon-bar + .icon-bar {\n    margin-top: 3px;\n}\n\n.navbar .nav > li > .dropdown-menu:before {\n    content: '';\n    display: inline-block;\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-bottom: 7px solid #CCCCCC;\n    border-bottom-color: rgba(0, 0, 0, 0.2);\n    position: absolute;\n    top: -7px;\n    left: 9px;\n}\n\n.navbar .nav > li > .dropdown-menu:after {\n    content: '';\n    display: inline-block;\n    border-left: 6px solid transparent;\n    border-right: 6px solid transparent;\n    border-bottom: 6px solid #FFFFFF;\n    position: absolute;\n    top: -6px;\n    left: 10px;\n}\n\n.navbar-fixed-bottom .nav > li > .dropdown-menu:before {\n    border-top: 7px solid #CCCCCC;\n    border-top-color: rgba(0, 0, 0, 0.2);\n    border-bottom: 0;\n    bottom: -7px;\n    top: auto;\n}\n\n.navbar-fixed-bottom .nav > li > .dropdown-menu:after {\n    border-top: 6px solid #FFFFFF;\n    border-bottom: 0;\n    bottom: -6px;\n    top: auto;\n}\n\n.navbar .nav li.dropdown.open > .dropdown-toggle,\n.navbar .nav li.dropdown.active > .dropdown-toggle,\n.navbar .nav li.dropdown.open.active > .dropdown-toggle {\n    background-color: #E5E5E5;\n    color: #555555;\n}\n\n.navbar .nav li.dropdown > .dropdown-toggle .caret {\n    border-top-color: #777777;\n    border-bottom-color: #777777;\n}\n\n.navbar .nav li.dropdown.open > .dropdown-toggle .caret,\n.navbar .nav li.dropdown.active > .dropdown-toggle .caret,\n.navbar .nav li.dropdown.open.active > .dropdown-toggle .caret {\n    border-top-color: #555555;\n    border-bottom-color: #555555;\n}\n\n.navbar .pull-right > li > .dropdown-menu,\n.navbar .nav > li > .dropdown-menu.pull-right {\n    left: auto;\n    right: 0;\n}\n\n.navbar .pull-right > li > .dropdown-menu:before,\n.navbar .nav > li > .dropdown-menu.pull-right:before {\n    left: auto;\n    right: 12px;\n}\n\n.navbar .pull-right > li > .dropdown-menu:after,\n.navbar .nav > li > .dropdown-menu.pull-right:after {\n    left: auto;\n    right: 13px;\n}\n\n.navbar .pull-right > li > .dropdown-menu .dropdown-menu,\n.navbar .nav > li > .dropdown-menu.pull-right .dropdown-menu {\n    left: auto;\n    right: 100%;\n    margin-left: 0;\n    margin-right: -1px;\n    border-radius: 6px 0 6px 6px;\n    -moz-border-radius: 6px 0 6px 6px;\n    border-radius: 6px 0 6px 6px;\n}\n\n.navbar-inverse {\n    color: #999999;\n}\n\n.navbar-inverse .navbar-inner {\n    background-color: #1B1B1B;\n    background-image: -moz-linear-gradient(to bottom, #222222, #111111);\n    background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#222222), to(#111111));\n    background-image: -webkit-linear-gradient(to bottom, #222222, #111111);\n    background-image: -o-linear-gradient(to bottom, #222222, #111111);\n    background-image: linear-gradient(to bottom, #222222, #111111);\n    background-repeat: repeat-x;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff222222', endColorstr='#ff111111', GradientType=0);\n    border-color: #252525;\n}\n\n.navbar-inverse .brand,\n.navbar-inverse .nav > li > a {\n    color: #999999;\n    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n}\n\n.navbar-inverse .brand:hover,\n.navbar-inverse .nav > li > a:hover {\n    color: #FFFFFF;\n}\n\n.navbar-inverse .nav > li > a:focus,\n.navbar-inverse .nav > li > a:hover {\n    background-color: transparent;\n    color: #FFFFFF;\n}\n\n.navbar-inverse .nav .active > a,\n.navbar-inverse .nav .active > a:hover,\n.navbar-inverse .nav .active > a:focus {\n    color: #FFFFFF;\n    background-color: #111111;\n}\n\n.navbar-inverse .navbar-link {\n    color: #999999;\n}\n\n.navbar-inverse .navbar-link:hover {\n    color: #FFFFFF;\n}\n\n.navbar-inverse .divider-vertical {\n    border-left-color: #111111;\n    border-right-color: #222222;\n}\n\n.navbar-inverse .nav li.dropdown.open > .dropdown-toggle,\n.navbar-inverse .nav li.dropdown.active > .dropdown-toggle,\n.navbar-inverse .nav li.dropdown.open.active > .dropdown-toggle {\n    background-color: #111111;\n    color: #FFFFFF;\n}\n\n.navbar-inverse .nav li.dropdown > .dropdown-toggle .caret {\n    border-top-color: #999999;\n    border-bottom-color: #999999;\n}\n\n.navbar-inverse .nav li.dropdown.open > .dropdown-toggle .caret,\n.navbar-inverse .nav li.dropdown.active > .dropdown-toggle .caret,\n.navbar-inverse .nav li.dropdown.open.active > .dropdown-toggle .caret {\n    border-top-color: #FFFFFF;\n    border-bottom-color: #FFFFFF;\n}\n\n.navbar-inverse .navbar-search .search-query {\n    color: #FFFFFF;\n    background-color: #515151;\n    border-color: #111111;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1), 0 1px 0 rgba(255, 255, 255, .15);\n    -moz-box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1), 0 1px 0 rgba(255, 255, 255, .15);\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, .1), 0 1px 0 rgba(255, 255, 255, .15);\n    -webkit-transition: none;\n    -moz-transition: none;\n    -o-transition: none;\n    transition: none;\n}\n\n.navbar-inverse .navbar-search .search-query:-moz-placeholder {\n    color: #CCCCCC;\n}\n\n.navbar-inverse .navbar-search .search-query:-ms-input-placeholder {\n    color: #CCCCCC;\n}\n\n.navbar-inverse .navbar-search .search-query::-webkit-input-placeholder {\n    color: #CCCCCC;\n}\n\n.navbar-inverse .navbar-search .search-query:focus,\n.navbar-inverse .navbar-search .search-query.focused {\n    padding: 5px 15px;\n    color: #333333;\n    text-shadow: 0 1px 0 #FFFFFF;\n    background-color: #FFFFFF;\n    border: 0;\n    box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);\n    -moz-box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);\n    box-shadow: 0 0 3px rgba(0, 0, 0, 0.15);\n    outline: 0;\n}\n\n.navbar-inverse .btn-navbar {\n    color: #FFFFFF;\n    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25);\n    background-color: #0E0E0E;\n    background-image: -moz-linear-gradient(to bottom, #151515, #040404);\n    background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#151515), to(#040404));\n    background-image: -webkit-linear-gradient(to bottom, #151515, #040404);\n    background-image: -o-linear-gradient(to bottom, #151515, #040404);\n    background-image: linear-gradient(to bottom, #151515, #040404);\n    background-repeat: repeat-x;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ff151515', endColorstr='#ff040404', GradientType=0);\n    border-color: #040404 #040404 #000000;\n    border-color: rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.25);\n    *background-color: #040404;\n    /* Darken IE7 buttons by default so they stand out more given they won't have borders */\n\n    filter: progid:DXImageTransform.Microsoft.gradient(enabled=false);\n}\n\n.navbar-inverse .btn-navbar:hover,\n.navbar-inverse .btn-navbar:active,\n.navbar-inverse .btn-navbar.active,\n.navbar-inverse .btn-navbar.disabled,\n.navbar-inverse .btn-navbar[disabled] {\n    color: #FFFFFF;\n    background-color: #040404;\n    *background-color: #000000;\n}\n\n.navbar-inverse .btn-navbar:active,\n.navbar-inverse .btn-navbar.active {\n    background-color: #000000 \\9;\n}\n","/*!\n * Bootstrap v2.2.1\n *\n * Copyright 2012 Twitter, Inc\n * Licensed under the Apache License v2.0\n * http://www.apache.org/licenses/LICENSE-2.0\n *\n * Designed and built with all the love in the world @twitter by @mdo and @fat.\n */\n.clearfix {\n    *zoom: 1;\n}\n\n.clearfix:before,\n.clearfix:after {\n    display: table;\n    content: \"\";\n    line-height: 0;\n}\n\n.clearfix:after {\n    clear: both;\n}\n\n.hide-text {\n    font: 0/0 a;\n    color: transparent;\n    text-shadow: none;\n    background-color: transparent;\n    border: 0;\n}\n\n.input-block-level {\n    display: block;\n    width: 100%;\n    min-height: 30px;\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n}\n\n.nav {\n    margin-left: 0;\n    margin-bottom: 20px;\n    list-style: none;\n}\n\n.nav > li > a {\n    display: block;\n}\n\n.nav > li > a:hover {\n    text-decoration: none;\n    background-color: #EEEEEE;\n}\n\n.nav > .pull-right {\n    float: right;\n}\n\n.nav-header {\n    display: block;\n    padding: 3px 15px;\n    font-size: 11px;\n    font-weight: bold;\n    line-height: 20px;\n    color: #999999;\n    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);\n    text-transform: uppercase;\n}\n\n.nav li + .nav-header {\n    margin-top: 9px;\n}\n\n.nav-list {\n    padding-left: 15px;\n    padding-right: 15px;\n    margin-bottom: 0;\n}\n\n.nav-list > li > a,\n.nav-list .nav-header {\n    margin-left: -15px;\n    margin-right: -15px;\n    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);\n}\n\n.nav-list > li > a {\n    padding: 3px 15px;\n}\n\n.nav-list > .active > a,\n.nav-list > .active > a:hover {\n    color: #FFFFFF;\n    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.2);\n    background-color: #0088CC;\n}\n\n.nav-list [class^=\"icon-\"],\n.nav-list [class*=\" icon-\"] {\n    margin-right: 2px;\n}\n\n.nav-list .divider {\n    *width: 100%;\n    height: 1px;\n    margin: 9px 1px;\n    *margin: -5px 0 5px;\n    overflow: hidden;\n    background-color: #E5E5E5;\n    border-bottom: 1px solid #FFFFFF;\n}\n\n.nav-tabs,\n.nav-pills {\n    *zoom: 1;\n}\n\n.nav-tabs:before,\n.nav-pills:before,\n.nav-tabs:after,\n.nav-pills:after {\n    display: table;\n    content: \"\";\n    line-height: 0;\n}\n\n.nav-tabs:after,\n.nav-pills:after {\n    clear: both;\n}\n\n.nav-tabs > li,\n.nav-pills > li {\n    float: left;\n}\n\n.nav-tabs > li > a,\n.nav-pills > li > a {\n    padding-right: 12px;\n    padding-left: 12px;\n    /*margin-right: 2px;*/\n    line-height: 14px;\n}\n\n.nav-tabs {\n    border-bottom: 1px solid #DDDDDD;\n}\n\n.nav-tabs > li {\n    margin-bottom: -1px;\n}\n\n.nav-tabs > li > a {\n    padding-top: 8px;\n    padding-bottom: 8px;\n    line-height: 20px;\n    border: 1px solid transparent;\n    border-radius: 4px 4px 0 0;\n    -moz-border-radius: 4px 4px 0 0;\n    border-radius: 4px 4px 0 0;\n}\n\n.nav-tabs > li > a:hover {\n    border-color: #EEEEEE #EEEEEE #DDDDDD;\n}\n\n.nav-tabs > .active > a,\n.nav-tabs > .active > a:hover {\n    color: #555555;\n    background-color: #FFFFFF;\n    border: 1px solid #DDDDDD;\n    border-bottom-color: transparent;\n    cursor: default;\n}\n\n.nav-pills > li > a {\n    padding-top: 8px;\n    padding-bottom: 8px;\n    margin-top: 2px;\n    margin-bottom: 2px;\n    border-radius: 5px;\n    -moz-border-radius: 5px;\n    border-radius: 5px;\n}\n\n.nav-pills > .active > a,\n.nav-pills > .active > a:hover {\n    color: #FFFFFF;\n    background-color: #0088CC;\n}\n\n.nav-stacked > li {\n    float: none;\n}\n\n.nav-stacked > li > a {\n    margin-right: 0;\n}\n\n.nav-tabs.nav-stacked {\n    border-bottom: 0;\n}\n\n.nav-tabs.nav-stacked > li > a {\n    border: 1px solid #DDDDDD;\n    border-radius: 0;\n    -moz-border-radius: 0;\n    border-radius: 0;\n}\n\n.nav-tabs.nav-stacked > li:first-child > a {\n    border-top-right-radius: 4px;\n    -moz-border-radius-topright: 4px;\n    border-top-right-radius: 4px;\n    border-top-left-radius: 4px;\n    -moz-border-radius-topleft: 4px;\n    border-top-left-radius: 4px;\n}\n\n.nav-tabs.nav-stacked > li:last-child > a {\n    border-bottom-right-radius: 4px;\n    -moz-border-radius-bottomright: 4px;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px;\n    -moz-border-radius-bottomleft: 4px;\n    border-bottom-left-radius: 4px;\n}\n\n.nav-tabs.nav-stacked > li > a:hover {\n    border-color: #DDDDDD;\n    z-index: 2;\n}\n\n.nav-pills.nav-stacked > li > a {\n    margin-bottom: 3px;\n}\n\n.nav-pills.nav-stacked > li:last-child > a {\n    margin-bottom: 1px;\n}\n\n.nav-tabs .dropdown-menu {\n    border-radius: 0 0 6px 6px;\n    -moz-border-radius: 0 0 6px 6px;\n    border-radius: 0 0 6px 6px;\n}\n\n.nav-pills .dropdown-menu {\n    border-radius: 6px;\n    -moz-border-radius: 6px;\n    border-radius: 6px;\n}\n\n.nav .dropdown-toggle .caret {\n    border-top-color: #0088CC;\n    border-bottom-color: #0088CC;\n    margin-top: 6px;\n}\n\n.nav .dropdown-toggle:hover .caret {\n    border-top-color: #005580;\n    border-bottom-color: #005580;\n}\n\n/* move down carets for tabs */\n.nav-tabs .dropdown-toggle .caret {\n    margin-top: 8px;\n}\n\n.nav .active .dropdown-toggle .caret {\n    border-top-color: #FFFFFF;\n    border-bottom-color: #FFFFFF;\n}\n\n.nav-tabs .active .dropdown-toggle .caret {\n    border-top-color: #555555;\n    border-bottom-color: #555555;\n}\n\n.nav > .dropdown.active > a:hover {\n    cursor: pointer;\n}\n\n.nav-tabs .open .dropdown-toggle,\n.nav-pills .open .dropdown-toggle,\n.nav > li.dropdown.open.active > a:hover {\n    color: #FFFFFF;\n    background-color: #999999;\n    border-color: #999999;\n}\n\n.nav li.dropdown.open .caret,\n.nav li.dropdown.open.active .caret,\n.nav li.dropdown.open a:hover .caret {\n    border-top-color: #FFFFFF;\n    border-bottom-color: #FFFFFF;\n    opacity: 1;\n    filter: alpha(opacity=100);\n}\n\n.tabs-stacked .open > a:hover {\n    border-color: #999999;\n}\n\n.tabbable {\n    *zoom: 1;\n}\n\n.tabbable:before,\n.tabbable:after {\n    display: table;\n    content: \"\";\n    line-height: 0;\n}\n\n.tabbable:after {\n    clear: both;\n}\n\n.tab-content {\n    overflow: auto;\n}\n\n.tabs-below > .nav-tabs,\n.tabs-right > .nav-tabs,\n.tabs-left > .nav-tabs {\n    border-bottom: 0;\n}\n\n.tab-content > .tab-pane,\n.pill-content > .pill-pane {\n    display: none;\n}\n\n.tab-content > .active,\n.pill-content > .active {\n    display: block;\n}\n\n.tabs-below > .nav-tabs {\n    border-top: 1px solid #DDDDDD;\n}\n\n.tabs-below > .nav-tabs > li {\n    margin-top: -1px;\n    margin-bottom: 0;\n}\n\n.tabs-below > .nav-tabs > li > a {\n    border-radius: 0 0 4px 4px;\n    -moz-border-radius: 0 0 4px 4px;\n    border-radius: 0 0 4px 4px;\n}\n\n.tabs-below > .nav-tabs > li > a:hover {\n    border-bottom-color: transparent;\n    border-top-color: #DDDDDD;\n}\n\n.tabs-below > .nav-tabs > .active > a,\n.tabs-below > .nav-tabs > .active > a:hover {\n    border-color: transparent #DDDDDD #DDDDDD #DDDDDD;\n}\n\n.tabs-left > .nav-tabs > li,\n.tabs-right > .nav-tabs > li {\n    float: none;\n}\n\n.tabs-left > .nav-tabs > li > a,\n.tabs-right > .nav-tabs > li > a {\n    min-width: 74px;\n    margin-right: 0;\n    margin-bottom: 3px;\n}\n\n.tabs-left > .nav-tabs {\n    float: left;\n    margin-right: 19px;\n    border-right: 1px solid #DDDDDD;\n}\n\n.tabs-left > .nav-tabs > li > a {\n    margin-right: -1px;\n    border-radius: 4px 0 0 4px;\n    -moz-border-radius: 4px 0 0 4px;\n    border-radius: 4px 0 0 4px;\n}\n\n.tabs-left > .nav-tabs > li > a:hover {\n    border-color: #EEEEEE #DDDDDD #EEEEEE #EEEEEE;\n}\n\n.tabs-left > .nav-tabs .active > a,\n.tabs-left > .nav-tabs .active > a:hover {\n    border-color: #DDDDDD transparent #DDDDDD #DDDDDD;\n    *border-right-color: #FFFFFF;\n}\n\n.tabs-right > .nav-tabs {\n    float: right;\n    margin-left: 19px;\n    border-left: 1px solid #DDDDDD;\n}\n\n.tabs-right > .nav-tabs > li > a {\n    margin-left: -1px;\n    border-radius: 0 4px 4px 0;\n    -moz-border-radius: 0 4px 4px 0;\n    border-radius: 0 4px 4px 0;\n}\n\n.tabs-right > .nav-tabs > li > a:hover {\n    border-color: #EEEEEE #EEEEEE #EEEEEE #DDDDDD;\n}\n\n.tabs-right > .nav-tabs .active > a,\n.tabs-right > .nav-tabs .active > a:hover {\n    border-color: #DDDDDD #DDDDDD #DDDDDD transparent;\n    *border-left-color: #FFFFFF;\n}\n\n.nav > .disabled > a {\n    color: #999999;\n}\n\n.nav > .disabled > a:hover {\n    text-decoration: none;\n    background-color: transparent;\n    cursor: default;\n}\n","/*! jQuery UI - v1.10.1 - 2013-02-25\n* http://jqueryui.com\n* Includes: jquery.ui.core.css, jquery.ui.resizable.css, jquery.ui.selectable.css, jquery.ui.accordion.css, jquery.ui.autocomplete.css, jquery.ui.button.css, jquery.ui.datepicker.css, jquery.ui.dialog.css, jquery.ui.menu.css, jquery.ui.progressbar.css, jquery.ui.slider.css, jquery.ui.spinner.css, jquery.ui.tabs.css, jquery.ui.tooltip.css\n* To view and modify this theme, visit http://jqueryui.com/themeroller/?ffDefault=Verdana%2CArial%2Csans-serif&fwDefault=normal&fsDefault=1.1em&cornerRadius=4px&bgColorHeader=cccccc&bgTextureHeader=highlight_soft&bgImgOpacityHeader=75&borderColorHeader=aaaaaa&fcHeader=222222&iconColorHeader=222222&bgColorContent=ffffff&bgTextureContent=flat&bgImgOpacityContent=75&borderColorContent=aaaaaa&fcContent=222222&iconColorContent=222222&bgColorDefault=e6e6e6&bgTextureDefault=glass&bgImgOpacityDefault=75&borderColorDefault=d3d3d3&fcDefault=555555&iconColorDefault=888888&bgColorHover=dadada&bgTextureHover=glass&bgImgOpacityHover=75&borderColorHover=999999&fcHover=212121&iconColorHover=454545&bgColorActive=ffffff&bgTextureActive=glass&bgImgOpacityActive=65&borderColorActive=aaaaaa&fcActive=212121&iconColorActive=454545&bgColorHighlight=fbf9ee&bgTextureHighlight=glass&bgImgOpacityHighlight=55&borderColorHighlight=fcefa1&fcHighlight=363636&iconColorHighlight=2e83ff&bgColorError=fef1ec&bgTextureError=glass&bgImgOpacityError=95&borderColorError=cd0a0a&fcError=cd0a0a&iconColorError=cd0a0a&bgColorOverlay=aaaaaa&bgTextureOverlay=flat&bgImgOpacityOverlay=0&opacityOverlay=30&bgColorShadow=aaaaaa&bgTextureShadow=flat&bgImgOpacityShadow=0&opacityShadow=30&thicknessShadow=8px&offsetTopShadow=-8px&offsetLeftShadow=-8px&cornerRadiusShadow=8px\n* Copyright (c) 2013 jQuery Foundation and other contributors Licensed MIT */\n\n/* Layout helpers\n----------------------------------*/\n.ui-helper-hidden {\n    display: none;\n}\n\n.ui-helper-hidden-accessible {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n}\n\n.ui-helper-reset {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    outline: 0;\n    line-height: 1.3;\n    text-decoration: none;\n    font-size: 100%;\n    list-style: none;\n}\n\n.ui-helper-clearfix:before,\n.ui-helper-clearfix:after {\n    content: \"\";\n    display: table;\n    border-collapse: collapse;\n}\n\n.ui-helper-clearfix:after {\n    clear: both;\n}\n\n.ui-helper-clearfix {\n    min-height: 0; /* support: IE7 */\n}\n\n.ui-helper-zfix {\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    position: absolute;\n    opacity: 0;\n    filter: Alpha(Opacity=0);\n}\n\n.ui-front {\n    z-index: 100;\n}\n\n\n/* Interaction Cues\n----------------------------------*/\n.ui-state-disabled {\n    cursor: default !important;\n}\n\n\n/* Icons\n----------------------------------*/\n\n/* states and images */\n.ui-icon {\n    display: block;\n    text-indent: -99999px;\n    overflow: hidden;\n    background-repeat: no-repeat;\n}\n\n\n/* Misc visuals\n----------------------------------*/\n\n/* Overlays */\n.ui-widget-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n.ui-resizable {\n    position: relative;\n}\n\n.ui-resizable-handle {\n    position: absolute;\n    font-size: 0.1px;\n    display: block;\n}\n\n.ui-resizable-disabled .ui-resizable-handle,\n.ui-resizable-autohide .ui-resizable-handle {\n    display: none;\n}\n\n.ui-resizable-n {\n    cursor: n-resize;\n    height: 7px;\n    width: 100%;\n    top: -5px;\n    left: 0;\n}\n\n.ui-resizable-s {\n    cursor: s-resize;\n    height: 7px;\n    width: 100%;\n    bottom: -5px;\n    left: 0;\n}\n\n.ui-resizable-e {\n    cursor: e-resize;\n    width: 7px;\n    right: -5px;\n    top: 0;\n    height: 100%;\n}\n\n.ui-resizable-w {\n    cursor: w-resize;\n    width: 7px;\n    left: -5px;\n    top: 0;\n    height: 100%;\n}\n\n.ui-resizable-se {\n    cursor: se-resize;\n    width: 12px;\n    height: 12px;\n    right: 1px;\n    bottom: 1px;\n}\n\n.ui-resizable-sw {\n    cursor: sw-resize;\n    width: 9px;\n    height: 9px;\n    left: -5px;\n    bottom: -5px;\n}\n\n.ui-resizable-nw {\n    cursor: nw-resize;\n    width: 9px;\n    height: 9px;\n    left: -5px;\n    top: -5px;\n}\n\n.ui-resizable-ne {\n    cursor: ne-resize;\n    width: 9px;\n    height: 9px;\n    right: -5px;\n    top: -5px;\n}\n\n.ui-selectable-helper {\n    position: absolute;\n    z-index: 100;\n    border: 1px dotted black;\n}\n\n.ui-accordion .ui-accordion-header {\n    display: block;\n    cursor: pointer;\n    position: relative;\n    margin-top: 2px;\n    padding: .5em .5em .5em .7em;\n    min-height: 0; /* support: IE7 */\n}\n\n.ui-accordion .ui-accordion-icons {\n    padding-left: 2.2em;\n}\n\n.ui-accordion .ui-accordion-noicons {\n    padding-left: .7em;\n}\n\n.ui-accordion .ui-accordion-icons .ui-accordion-icons {\n    padding-left: 2.2em;\n}\n\n.ui-accordion .ui-accordion-header .ui-accordion-header-icon {\n    position: absolute;\n    left: .5em;\n    top: 50%;\n    margin-top: -8px;\n}\n\n.ui-accordion .ui-accordion-content {\n    padding: 1em 2.2em;\n    border-top: 0;\n    overflow: auto;\n}\n\n.ui-autocomplete {\n    position: absolute;\n    top: 0;\n    left: 0;\n    cursor: default;\n}\n\n.ui-button {\n    display: inline-block;\n    position: relative;\n    padding: 0;\n    line-height: normal;\n    margin-right: .1em;\n    cursor: pointer;\n    vertical-align: middle;\n    text-align: center;\n    overflow: visible; /* removes extra width in IE */\n}\n\n.ui-button,\n.ui-button:link,\n.ui-button:visited,\n.ui-button:hover,\n.ui-button:active {\n    text-decoration: none;\n}\n\n/* to make room for the icon, a width needs to be set here */\n.ui-button-icon-only {\n    width: 2.2em;\n}\n\n/* button elements seem to need a little more width */\nbutton.ui-button-icon-only {\n    width: 2.4em;\n}\n\n.ui-button-icons-only {\n    width: 3.4em;\n}\n\nbutton.ui-button-icons-only {\n    width: 3.7em;\n}\n\n/* button text element */\n.ui-button .ui-button-text {\n    display: block;\n    line-height: normal;\n}\n\n.ui-button-text-only .ui-button-text {\n    padding: .4em 1em;\n}\n\n.ui-button-icon-only .ui-button-text,\n.ui-button-icons-only .ui-button-text {\n    padding: .4em;\n    text-indent: -9999999px;\n}\n\n.ui-button-text-icon-primary .ui-button-text,\n.ui-button-text-icons .ui-button-text {\n    padding: .4em 1em .4em 2.1em;\n}\n\n.ui-button-text-icon-secondary .ui-button-text,\n.ui-button-text-icons .ui-button-text {\n    padding: .4em 2.1em .4em 1em;\n}\n\n.ui-button-text-icons .ui-button-text {\n    padding-left: 2.1em;\n    padding-right: 2.1em;\n}\n\n/* no icon support for input elements, provide padding by default */\ninput.ui-button {\n    padding: .4em 1em;\n}\n\n/* button icon element(s) */\n.ui-button-icon-only .ui-icon,\n.ui-button-text-icon-primary .ui-icon,\n.ui-button-text-icon-secondary .ui-icon,\n.ui-button-text-icons .ui-icon,\n.ui-button-icons-only .ui-icon {\n    position: absolute;\n    top: 50%;\n    margin-top: -8px;\n}\n\n.ui-button-icon-only .ui-icon {\n    left: 50%;\n    margin-left: -8px;\n}\n\n.ui-button-text-icon-primary .ui-button-icon-primary,\n.ui-button-text-icons .ui-button-icon-primary,\n.ui-button-icons-only .ui-button-icon-primary {\n    left: .5em;\n}\n\n.ui-button-text-icon-secondary .ui-button-icon-secondary,\n.ui-button-text-icons .ui-button-icon-secondary,\n.ui-button-icons-only .ui-button-icon-secondary {\n    right: .5em;\n}\n\n/* button sets */\n.ui-buttonset {\n    margin-right: 7px;\n}\n\n.ui-buttonset .ui-button {\n    margin-left: 0;\n    margin-right: -.3em;\n}\n\n/* workarounds */\n/* reset extra padding in Firefox, see h5bp.com/l */\ninput.ui-button::-moz-focus-inner,\nbutton.ui-button::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n}\n\n.ui-datepicker {\n    width: 17em;\n    padding: .2em .2em 0;\n    display: none;\n}\n\n.ui-datepicker .ui-datepicker-header {\n    position: relative;\n    padding: .2em 0;\n}\n\n.ui-datepicker .ui-datepicker-prev,\n.ui-datepicker .ui-datepicker-next {\n    position: absolute;\n    top: 2px;\n    width: 1.8em;\n    height: 1.8em;\n}\n\n.ui-datepicker .ui-datepicker-prev-hover,\n.ui-datepicker .ui-datepicker-next-hover {\n    top: 1px;\n}\n\n.ui-datepicker .ui-datepicker-prev {\n    left: 2px;\n}\n\n.ui-datepicker .ui-datepicker-next {\n    right: 2px;\n}\n\n.ui-datepicker .ui-datepicker-prev-hover {\n    left: 1px;\n}\n\n.ui-datepicker .ui-datepicker-next-hover {\n    right: 1px;\n}\n\n.ui-datepicker .ui-datepicker-prev span,\n.ui-datepicker .ui-datepicker-next span {\n    display: block;\n    position: absolute;\n    left: 50%;\n    margin-left: -8px;\n    top: 50%;\n    margin-top: -8px;\n}\n\n.ui-datepicker .ui-datepicker-title {\n    margin: 0 2.3em;\n    line-height: 1.8em;\n    text-align: center;\n}\n\n.ui-datepicker .ui-datepicker-title select {\n    font-size: 1em;\n    margin: 1px 0;\n}\n\n.ui-datepicker select.ui-datepicker-month-year {\n    width: 100%;\n}\n\n.ui-datepicker select.ui-datepicker-month,\n.ui-datepicker select.ui-datepicker-year {\n    width: 49%;\n}\n\n.ui-datepicker table {\n    width: 100%;\n    font-size: .9em;\n    border-collapse: collapse;\n    margin: 0 0 .4em;\n}\n\n.ui-datepicker th {\n    padding: .7em .3em;\n    text-align: center;\n    font-weight: bold;\n    border: 0;\n}\n\n.ui-datepicker td {\n    border: 0;\n    padding: 1px;\n}\n\n.ui-datepicker td span,\n.ui-datepicker td a {\n    display: block;\n    padding: .2em;\n    text-align: right;\n    text-decoration: none;\n}\n\n.ui-datepicker .ui-datepicker-buttonpane {\n    background-image: none;\n    margin: .7em 0 0 0;\n    padding: 0 .2em;\n    border-left: 0;\n    border-right: 0;\n    border-bottom: 0;\n}\n\n.ui-datepicker .ui-datepicker-buttonpane button {\n    float: right;\n    margin: .5em .2em .4em;\n    cursor: pointer;\n    padding: .2em .6em .3em .6em;\n    width: auto;\n    overflow: visible;\n}\n\n.ui-datepicker .ui-datepicker-buttonpane button.ui-datepicker-current {\n    float: left;\n}\n\n/* with multiple calendars */\n.ui-datepicker.ui-datepicker-multi {\n    width: auto;\n}\n\n.ui-datepicker-multi .ui-datepicker-group {\n    float: left;\n}\n\n.ui-datepicker-multi .ui-datepicker-group table {\n    width: 95%;\n    margin: 0 auto .4em;\n}\n\n.ui-datepicker-multi-2 .ui-datepicker-group {\n    width: 50%;\n}\n\n.ui-datepicker-multi-3 .ui-datepicker-group {\n    width: 33.3%;\n}\n\n.ui-datepicker-multi-4 .ui-datepicker-group {\n    width: 25%;\n}\n\n.ui-datepicker-multi .ui-datepicker-group-last .ui-datepicker-header,\n.ui-datepicker-multi .ui-datepicker-group-middle .ui-datepicker-header {\n    border-left-width: 0;\n}\n\n.ui-datepicker-multi .ui-datepicker-buttonpane {\n    clear: left;\n}\n\n.ui-datepicker-row-break {\n    clear: both;\n    width: 100%;\n    font-size: 0;\n}\n\n/* RTL support */\n.ui-datepicker-rtl {\n    direction: rtl;\n}\n\n.ui-datepicker-rtl .ui-datepicker-prev {\n    right: 2px;\n    left: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-next {\n    left: 2px;\n    right: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-prev:hover {\n    right: 1px;\n    left: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-next:hover {\n    left: 1px;\n    right: auto;\n}\n\n.ui-datepicker-rtl .ui-datepicker-buttonpane {\n    clear: right;\n}\n\n.ui-datepicker-rtl .ui-datepicker-buttonpane button {\n    float: left;\n}\n\n.ui-datepicker-rtl .ui-datepicker-buttonpane button.ui-datepicker-current,\n.ui-datepicker-rtl .ui-datepicker-group {\n    float: right;\n}\n\n.ui-datepicker-rtl .ui-datepicker-group-last .ui-datepicker-header,\n.ui-datepicker-rtl .ui-datepicker-group-middle .ui-datepicker-header {\n    border-right-width: 0;\n    border-left-width: 1px;\n}\n\n.ui-dialog {\n    position: absolute;\n    top: 0;\n    left: 0;\n    padding: .2em;\n    outline: 0;\n}\n\n.ui-dialog .ui-dialog-titlebar {\n    padding: .4em 1em;\n    position: relative;\n}\n\n.ui-dialog .ui-dialog-title {\n    float: left;\n    margin: .1em 0;\n    white-space: nowrap;\n    width: 90%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.ui-dialog .ui-dialog-titlebar-close {\n    position: absolute;\n    right: .3em;\n    top: 50%;\n    width: 21px;\n    margin: -10px 0 0 0;\n    padding: 1px;\n    height: 20px;\n}\n\n.ui-dialog .ui-dialog-content {\n    position: relative;\n    border: 0;\n    padding: .5em 1em;\n    background: none;\n    overflow: auto;\n}\n\n.ui-dialog .ui-dialog-buttonpane {\n    text-align: left;\n    border-width: 1px 0 0 0;\n    background-image: none;\n    margin-top: .5em;\n    padding: .3em 1em .5em .4em;\n}\n\n.ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset {\n    float: right;\n}\n\n.ui-dialog .ui-dialog-buttonpane button {\n    margin: .5em .4em .5em 0;\n    cursor: pointer;\n}\n\n.ui-dialog .ui-resizable-se {\n    width: 12px;\n    height: 12px;\n    right: -5px;\n    bottom: -5px;\n    background-position: 16px 16px;\n}\n\n.ui-draggable .ui-dialog-titlebar {\n    cursor: move;\n}\n\n.ui-menu {\n    list-style: none;\n    padding: 2px;\n    margin: 0;\n    display: block;\n    outline: none;\n}\n\n.ui-menu .ui-menu {\n    margin-top: -3px;\n    position: absolute;\n}\n\n.ui-menu .ui-menu-item {\n    margin: 0;\n    padding: 0;\n    width: 100%;\n}\n\n.ui-menu .ui-menu-divider {\n    margin: 5px -2px 5px -2px;\n    height: 0;\n    font-size: 0;\n    line-height: 0;\n    border-width: 1px 0 0 0;\n}\n\n.ui-menu .ui-menu-item a {\n    text-decoration: none;\n    display: block;\n    padding: 2px .4em;\n    line-height: 1.5;\n    min-height: 0; /* support: IE7 */\n    font-weight: normal;\n}\n\n.ui-menu .ui-menu-item a.ui-state-focus,\n.ui-menu .ui-menu-item a.ui-state-active {\n    font-weight: normal;\n    margin: -1px;\n}\n\n.ui-menu .ui-state-disabled {\n    font-weight: normal;\n    margin: .4em 0 .2em;\n    line-height: 1.5;\n}\n\n.ui-menu .ui-state-disabled a {\n    cursor: default;\n}\n\n/* icon support */\n.ui-menu-icons {\n    position: relative;\n}\n\n.ui-menu-icons .ui-menu-item a {\n    position: relative;\n    padding-left: 2em;\n}\n\n/* left-aligned */\n.ui-menu .ui-icon {\n    position: absolute;\n    top: .2em;\n    left: .2em;\n}\n\n/* right-aligned */\n.ui-menu .ui-menu-icon {\n    position: static;\n    float: right;\n}\n\n.ui-progressbar {\n    height: 2em;\n    text-align: left;\n    overflow: hidden;\n}\n\n.ui-progressbar .ui-progressbar-value {\n    margin: -1px;\n    height: 100%;\n}\n\n.ui-progressbar .ui-progressbar-overlay {\n    background: url(/images/jquery-ui/animated-overlay.gif);\n    height: 100%;\n    filter: alpha(opacity=25);\n    opacity: 0.25;\n}\n\n.ui-progressbar-indeterminate .ui-progressbar-value {\n    background-image: none;\n}\n\n.ui-slider {\n    position: relative;\n    text-align: left;\n}\n\n.ui-slider .ui-slider-handle {\n    position: absolute;\n    z-index: 2;\n    width: 1.2em;\n    height: 1.2em;\n    cursor: default;\n}\n\n.ui-slider .ui-slider-range {\n    position: absolute;\n    z-index: 1;\n    font-size: .7em;\n    display: block;\n    border: 0;\n    background-position: 0 0;\n}\n\n/* For IE8 - See #6727 */\n.ui-slider.ui-state-disabled .ui-slider-handle,\n.ui-slider.ui-state-disabled .ui-slider-range {\n    filter: inherit;\n}\n\n.ui-slider-horizontal {\n    height: .8em;\n}\n\n.ui-slider-horizontal .ui-slider-handle {\n    top: -.3em;\n    margin-left: -.6em;\n}\n\n.ui-slider-horizontal .ui-slider-range {\n    top: 0;\n    height: 100%;\n}\n\n.ui-slider-horizontal .ui-slider-range-min {\n    left: 0;\n}\n\n.ui-slider-horizontal .ui-slider-range-max {\n    right: 0;\n}\n\n.ui-slider-vertical {\n    width: .8em;\n    height: 100px;\n}\n\n.ui-slider-vertical .ui-slider-handle {\n    left: -.3em;\n    margin-left: 0;\n    margin-bottom: -.6em;\n}\n\n.ui-slider-vertical .ui-slider-range {\n    left: 0;\n    width: 100%;\n}\n\n.ui-slider-vertical .ui-slider-range-min {\n    bottom: 0;\n}\n\n.ui-slider-vertical .ui-slider-range-max {\n    top: 0;\n}\n\n.ui-spinner {\n    position: relative;\n    display: inline-block;\n    overflow: hidden;\n    padding: 0;\n    vertical-align: middle;\n}\n\n.ui-spinner-input {\n    border: none;\n    background: none;\n    color: inherit;\n    padding: 0;\n    margin: .2em 0;\n    vertical-align: middle;\n    margin-left: .4em;\n    margin-right: 22px;\n}\n\n.ui-spinner-button {\n    width: 16px;\n    height: 50%;\n    font-size: .5em;\n    padding: 0;\n    margin: 0;\n    text-align: center;\n    position: absolute;\n    cursor: default;\n    display: block;\n    overflow: hidden;\n    right: 0;\n}\n\n/* more specificity required here to overide default borders */\n.ui-spinner a.ui-spinner-button {\n    border-top: none;\n    border-bottom: none;\n    border-right: none;\n}\n\n/* vertical centre icon */\n.ui-spinner .ui-icon {\n    position: absolute;\n    margin-top: -8px;\n    top: 50%;\n    left: 0;\n}\n\n.ui-spinner-up {\n    top: 0;\n}\n\n.ui-spinner-down {\n    bottom: 0;\n}\n\n/* TR overrides */\n.ui-spinner .ui-icon-triangle-1-s {\n    /* need to fix icons sprite */\n    background-position: -65px -16px;\n}\n\n.ui-tabs {\n    position: relative; /* position: relative prevents IE scroll bug (element with position: relative inside container with overflow: auto appear as \"fixed\") */\n    padding: .2em;\n}\n\n.ui-tabs .ui-tabs-nav {\n    margin: 0;\n    padding: .2em .2em 0;\n}\n\n.ui-tabs .ui-tabs-nav li {\n    list-style: none;\n    float: left;\n    position: relative;\n    top: 0;\n    margin: 1px .2em 0 0;\n    border-bottom: 0;\n    padding: 0;\n    white-space: nowrap;\n}\n\n.ui-tabs .ui-tabs-nav li a {\n    float: left;\n    padding: .5em 1em;\n    text-decoration: none;\n}\n\n.ui-tabs .ui-tabs-nav li.ui-tabs-active {\n    margin-bottom: -1px;\n    padding-bottom: 1px;\n}\n\n.ui-tabs .ui-tabs-nav li.ui-tabs-active a,\n.ui-tabs .ui-tabs-nav li.ui-state-disabled a,\n.ui-tabs .ui-tabs-nav li.ui-tabs-loading a {\n    cursor: text;\n}\n\n.ui-tabs .ui-tabs-nav li a, /* first selector in group seems obsolete, but required to overcome bug in Opera applying cursor: text overall if defined elsewhere... */\n.ui-tabs-collapsible .ui-tabs-nav li.ui-tabs-active a {\n    cursor: pointer;\n}\n\n.ui-tabs .ui-tabs-panel {\n    display: block;\n    border-width: 0;\n    padding: 1em 1.4em;\n    background: none;\n}\n\n.ui-tooltip {\n    padding: 8px;\n    position: absolute;\n    z-index: 9999;\n    max-width: 300px;\n    -webkit-box-shadow: 0 0 5px #AAAAAA;\n    box-shadow: 0 0 5px #AAAAAA;\n}\n\nbody .ui-tooltip {\n    border-width: 2px;\n}\n\n/* Component containers\n----------------------------------*/\n.ui-widget {\n    font-family: Verdana, Arial, sans-serif;\n    font-size: 1.1em;\n}\n\n.ui-widget .ui-widget {\n    font-size: 1em;\n}\n\n.ui-widget input,\n.ui-widget select,\n.ui-widget textarea,\n.ui-widget button {\n    font-family: Verdana, Arial, sans-serif;\n    font-size: 1em;\n}\n\n.ui-widget-content {\n    border: 1px solid #AAAAAA;\n    background: #FFFFFF url(/images/jquery-ui/ui-bg_flat_75_ffffff_40x100.png) 50% 50% repeat-x;\n    color: #222222;\n}\n\n.ui-widget-content a {\n    color: #222222;\n}\n\n.ui-widget-header {\n    border: rgb(255, 255, 255);\n    color: #222222;\n    font-weight: bold;\n}\n\n.ui-widget-header a {\n    color: #222222;\n}\n\n/* Interaction states\n----------------------------------*/\n.ui-state-default,\n.ui-widget-content .ui-state-default,\n.ui-widget-header .ui-state-default {\n    /* border: 1px solid #FAFAFA; */\n    /* background: #FAFAFA; */\n    font-weight: normal;\n    color: #555555;\n}\n\n.ui-state-default a,\n.ui-state-default a:link,\n.ui-state-default a:visited {\n    color: #555555;\n    text-decoration: none;\n}\n\n.ui-state-hover,\n.ui-widget-content .ui-state-hover,\n.ui-widget-header .ui-state-hover,\n.ui-state-focus,\n.ui-widget-content .ui-state-focus,\n.ui-widget-header .ui-state-focus {\n    border: 1px solid #999999;\n    background: #DADADA url(/images/jquery-ui/ui-bg_glass_75_dadada_1x400.png) 50% 50% repeat-x;\n    font-weight: normal;\n    color: #212121;\n}\n\n.ui-state-hover a,\n.ui-state-hover a:hover,\n.ui-state-hover a:link,\n.ui-state-hover a:visited {\n    color: #212121;\n    text-decoration: none;\n}\n\n.ui-state-active,\n.ui-widget-content .ui-state-active,\n.ui-widget-header .ui-state-active {\n    border: 1px solid #AAAAAA;\n    background: #FFFFFF url(/images/jquery-ui/ui-bg_glass_65_ffffff_1x400.png) 50% 50% repeat-x;\n    font-weight: normal;\n    color: #212121;\n}\n\n.ui-state-active a,\n.ui-state-active a:link,\n.ui-state-active a:visited {\n    color: #212121;\n    text-decoration: none;\n}\n\n/* Interaction Cues\n----------------------------------*/\n.ui-state-highlight,\n.ui-widget-content .ui-state-highlight,\n.ui-widget-header .ui-state-highlight {\n    border: 1px solid #FCEFA1;\n    background: #FBF9EE url(/images/jquery-ui/ui-bg_glass_55_fbf9ee_1x400.png) 50% 50% repeat-x;\n    color: #363636;\n}\n\n.ui-state-highlight a,\n.ui-widget-content .ui-state-highlight a,\n.ui-widget-header .ui-state-highlight a {\n    color: #363636;\n}\n\n.ui-state-error,\n.ui-widget-content .ui-state-error,\n.ui-widget-header .ui-state-error {\n    border: 1px solid #CD0A0A;\n    background: #FEF1EC url(/images/jquery-ui/ui-bg_glass_95_fef1ec_1x400.png) 50% 50% repeat-x;\n    color: #CD0A0A;\n}\n\n.ui-state-error a,\n.ui-widget-content .ui-state-error a,\n.ui-widget-header .ui-state-error a {\n    color: #CD0A0A;\n}\n\n.ui-state-error-text,\n.ui-widget-content .ui-state-error-text,\n.ui-widget-header .ui-state-error-text {\n    color: #CD0A0A;\n}\n\n.ui-priority-primary,\n.ui-widget-content .ui-priority-primary,\n.ui-widget-header .ui-priority-primary {\n    font-weight: bold;\n}\n\n.ui-priority-secondary,\n.ui-widget-content .ui-priority-secondary,\n.ui-widget-header .ui-priority-secondary {\n    opacity: .7;\n    filter: Alpha(Opacity=70);\n    font-weight: normal;\n}\n\n.ui-state-disabled,\n.ui-widget-content .ui-state-disabled,\n.ui-widget-header .ui-state-disabled {\n    opacity: .35;\n    filter: Alpha(Opacity=35);\n    background-image: none;\n}\n\n.ui-state-disabled .ui-icon {\n    filter: Alpha(Opacity=35); /* For IE8 - See #6059 */\n}\n\n/* Icons\n----------------------------------*/\n\n/* states and images */\n.ui-icon {\n    width: 16px;\n    height: 16px;\n    background-position: 16px 16px;\n}\n\n.ui-icon,\n.ui-widget-content .ui-icon {\n    background-image: url(/images/jquery-ui/ui-icons_222222_256x240.png);\n}\n\n.ui-widget-header .ui-icon {\n    background-image: url(/images/jquery-ui/ui-icons_222222_256x240.png);\n}\n\n.ui-state-default .ui-icon {\n    background-image: url(/images/jquery-ui/ui-icons_888888_256x240.png);\n}\n\n.ui-state-hover .ui-icon,\n.ui-state-focus .ui-icon {\n    background-image: url(/images/jquery-ui/ui-icons_454545_256x240.png);\n}\n\n.ui-state-active .ui-icon {\n    background-image: url(/images/jquery-ui/ui-icons_454545_256x240.png);\n}\n\n.ui-state-highlight .ui-icon {\n    background-image: url(/images/jquery-ui/ui-icons_2e83ff_256x240.png);\n}\n\n.ui-state-error .ui-icon,\n.ui-state-error-text .ui-icon {\n    background-image: url(/images/jquery-ui/ui-icons_cd0a0a_256x240.png);\n}\n\n/* positioning */\n.ui-icon-carat-1-n {\n    background-position: 0 0;\n}\n\n.ui-icon-carat-1-ne {\n    background-position: -16px 0;\n}\n\n.ui-icon-carat-1-e {\n    background-position: -32px 0;\n}\n\n.ui-icon-carat-1-se {\n    background-position: -48px 0;\n}\n\n.ui-icon-carat-1-s {\n    background-position: -64px 0;\n}\n\n.ui-icon-carat-1-sw {\n    background-position: -80px 0;\n}\n\n.ui-icon-carat-1-w {\n    background-position: -96px 0;\n}\n\n.ui-icon-carat-1-nw {\n    background-position: -112px 0;\n}\n\n.ui-icon-carat-2-n-s {\n    background-position: -128px 0;\n}\n\n.ui-icon-carat-2-e-w {\n    background-position: -144px 0;\n}\n\n.ui-icon-triangle-1-n {\n    background-position: 0 -16px;\n}\n\n.ui-icon-triangle-1-ne {\n    background-position: -16px -16px;\n}\n\n.ui-icon-triangle-1-e {\n    background-position: -32px -16px;\n}\n\n.ui-icon-triangle-1-se {\n    background-position: -48px -16px;\n}\n\n.ui-icon-triangle-1-s {\n    background-position: -64px -16px;\n}\n\n.ui-icon-triangle-1-sw {\n    background-position: -80px -16px;\n}\n\n.ui-icon-triangle-1-w {\n    background-position: -96px -16px;\n}\n\n.ui-icon-triangle-1-nw {\n    background-position: -112px -16px;\n}\n\n.ui-icon-triangle-2-n-s {\n    background-position: -128px -16px;\n}\n\n.ui-icon-triangle-2-e-w {\n    background-position: -144px -16px;\n}\n\n.ui-icon-arrow-1-n {\n    background-position: 0 -32px;\n}\n\n.ui-icon-arrow-1-ne {\n    background-position: -16px -32px;\n}\n\n.ui-icon-arrow-1-e {\n    background-position: -32px -32px;\n}\n\n.ui-icon-arrow-1-se {\n    background-position: -48px -32px;\n}\n\n.ui-icon-arrow-1-s {\n    background-position: -64px -32px;\n}\n\n.ui-icon-arrow-1-sw {\n    background-position: -80px -32px;\n}\n\n.ui-icon-arrow-1-w {\n    background-position: -96px -32px;\n}\n\n.ui-icon-arrow-1-nw {\n    background-position: -112px -32px;\n}\n\n.ui-icon-arrow-2-n-s {\n    background-position: -128px -32px;\n}\n\n.ui-icon-arrow-2-ne-sw {\n    background-position: -144px -32px;\n}\n\n.ui-icon-arrow-2-e-w {\n    background-position: -160px -32px;\n}\n\n.ui-icon-arrow-2-se-nw {\n    background-position: -176px -32px;\n}\n\n.ui-icon-arrowstop-1-n {\n    background-position: -192px -32px;\n}\n\n.ui-icon-arrowstop-1-e {\n    background-position: -208px -32px;\n}\n\n.ui-icon-arrowstop-1-s {\n    background-position: -224px -32px;\n}\n\n.ui-icon-arrowstop-1-w {\n    background-position: -240px -32px;\n}\n\n.ui-icon-arrowthick-1-n {\n    background-position: 0 -48px;\n}\n\n.ui-icon-arrowthick-1-ne {\n    background-position: -16px -48px;\n}\n\n.ui-icon-arrowthick-1-e {\n    background-position: -32px -48px;\n}\n\n.ui-icon-arrowthick-1-se {\n    background-position: -48px -48px;\n}\n\n.ui-icon-arrowthick-1-s {\n    background-position: -64px -48px;\n}\n\n.ui-icon-arrowthick-1-sw {\n    background-position: -80px -48px;\n}\n\n.ui-icon-arrowthick-1-w {\n    background-position: -96px -48px;\n}\n\n.ui-icon-arrowthick-1-nw {\n    background-position: -112px -48px;\n}\n\n.ui-icon-arrowthick-2-n-s {\n    background-position: -128px -48px;\n}\n\n.ui-icon-arrowthick-2-ne-sw {\n    background-position: -144px -48px;\n}\n\n.ui-icon-arrowthick-2-e-w {\n    background-position: -160px -48px;\n}\n\n.ui-icon-arrowthick-2-se-nw {\n    background-position: -176px -48px;\n}\n\n.ui-icon-arrowthickstop-1-n {\n    background-position: -192px -48px;\n}\n\n.ui-icon-arrowthickstop-1-e {\n    background-position: -208px -48px;\n}\n\n.ui-icon-arrowthickstop-1-s {\n    background-position: -224px -48px;\n}\n\n.ui-icon-arrowthickstop-1-w {\n    background-position: -240px -48px;\n}\n\n.ui-icon-arrowreturnthick-1-w {\n    background-position: 0 -64px;\n}\n\n.ui-icon-arrowreturnthick-1-n {\n    background-position: -16px -64px;\n}\n\n.ui-icon-arrowreturnthick-1-e {\n    background-position: -32px -64px;\n}\n\n.ui-icon-arrowreturnthick-1-s {\n    background-position: -48px -64px;\n}\n\n.ui-icon-arrowreturn-1-w {\n    background-position: -64px -64px;\n}\n\n.ui-icon-arrowreturn-1-n {\n    background-position: -80px -64px;\n}\n\n.ui-icon-arrowreturn-1-e {\n    background-position: -96px -64px;\n}\n\n.ui-icon-arrowreturn-1-s {\n    background-position: -112px -64px;\n}\n\n.ui-icon-arrowrefresh-1-w {\n    background-position: -128px -64px;\n}\n\n.ui-icon-arrowrefresh-1-n {\n    background-position: -144px -64px;\n}\n\n.ui-icon-arrowrefresh-1-e {\n    background-position: -160px -64px;\n}\n\n.ui-icon-arrowrefresh-1-s {\n    background-position: -176px -64px;\n}\n\n.ui-icon-arrow-4 {\n    background-position: 0 -80px;\n}\n\n.ui-icon-arrow-4-diag {\n    background-position: -16px -80px;\n}\n\n.ui-icon-extlink {\n    background-position: -32px -80px;\n}\n\n.ui-icon-newwin {\n    background-position: -48px -80px;\n}\n\n.ui-icon-refresh {\n    background-position: -64px -80px;\n}\n\n.ui-icon-shuffle {\n    background-position: -80px -80px;\n}\n\n.ui-icon-transfer-e-w {\n    background-position: -96px -80px;\n}\n\n.ui-icon-transferthick-e-w {\n    background-position: -112px -80px;\n}\n\n.ui-icon-folder-collapsed {\n    background-position: 0 -96px;\n}\n\n.ui-icon-folder-open {\n    background-position: -16px -96px;\n}\n\n.ui-icon-document {\n    background-position: -32px -96px;\n}\n\n.ui-icon-document-b {\n    background-position: -48px -96px;\n}\n\n.ui-icon-note {\n    background-position: -64px -96px;\n}\n\n.ui-icon-mail-closed {\n    background-position: -80px -96px;\n}\n\n.ui-icon-mail-open {\n    background-position: -96px -96px;\n}\n\n.ui-icon-suitcase {\n    background-position: -112px -96px;\n}\n\n.ui-icon-comment {\n    background-position: -128px -96px;\n}\n\n.ui-icon-person {\n    background-position: -144px -96px;\n}\n\n.ui-icon-print {\n    background-position: -160px -96px;\n}\n\n.ui-icon-trash {\n    background-position: -176px -96px;\n}\n\n.ui-icon-locked {\n    background-position: -192px -96px;\n}\n\n.ui-icon-unlocked {\n    background-position: -208px -96px;\n}\n\n.ui-icon-bookmark {\n    background-position: -224px -96px;\n}\n\n.ui-icon-tag {\n    background-position: -240px -96px;\n}\n\n.ui-icon-home {\n    background-position: 0 -112px;\n}\n\n.ui-icon-flag {\n    background-position: -16px -112px;\n}\n\n.ui-icon-calendar {\n    background-position: -32px -112px;\n}\n\n.ui-icon-cart {\n    background-position: -48px -112px;\n}\n\n.ui-icon-pencil {\n    background-position: -64px -112px;\n}\n\n.ui-icon-clock {\n    background-position: -80px -112px;\n}\n\n.ui-icon-disk {\n    background-position: -96px -112px;\n}\n\n.ui-icon-calculator {\n    background-position: -112px -112px;\n}\n\n.ui-icon-zoomin {\n    background-position: -128px -112px;\n}\n\n.ui-icon-zoomout {\n    background-position: -144px -112px;\n}\n\n.ui-icon-search {\n    background-position: -160px -112px;\n}\n\n.ui-icon-wrench {\n    background-position: -176px -112px;\n}\n\n.ui-icon-gear {\n    background-position: -192px -112px;\n}\n\n.ui-icon-heart {\n    background-position: -208px -112px;\n}\n\n.ui-icon-star {\n    background-position: -224px -112px;\n}\n\n.ui-icon-link {\n    background-position: -240px -112px;\n}\n\n.ui-icon-cancel {\n    background-position: 0 -128px;\n}\n\n.ui-icon-plus {\n    background-position: -16px -128px;\n}\n\n.ui-icon-plusthick {\n    background-position: -32px -128px;\n}\n\n.ui-icon-minus {\n    background-position: -48px -128px;\n}\n\n.ui-icon-minusthick {\n    background-position: -64px -128px;\n}\n\n.ui-icon-close {\n    background-position: -80px -128px;\n}\n\n.ui-icon-closethick {\n    background-position: -96px -128px;\n}\n\n.ui-icon-key {\n    background-position: -112px -128px;\n}\n\n.ui-icon-lightbulb {\n    background-position: -128px -128px;\n}\n\n.ui-icon-scissors {\n    background-position: -144px -128px;\n}\n\n.ui-icon-clipboard {\n    background-position: -160px -128px;\n}\n\n.ui-icon-copy {\n    background-position: -176px -128px;\n}\n\n.ui-icon-contact {\n    background-position: -192px -128px;\n}\n\n.ui-icon-image {\n    background-position: -208px -128px;\n}\n\n.ui-icon-video {\n    background-position: -224px -128px;\n}\n\n.ui-icon-script {\n    background-position: -240px -128px;\n}\n\n.ui-icon-alert {\n    background-position: 0 -144px;\n}\n\n.ui-icon-info {\n    background-position: -16px -144px;\n}\n\n.ui-icon-notice {\n    background-position: -32px -144px;\n}\n\n.ui-icon-help {\n    background-position: -48px -144px;\n}\n\n.ui-icon-check {\n    background-position: -64px -144px;\n}\n\n.ui-icon-bullet {\n    background-position: -80px -144px;\n}\n\n.ui-icon-radio-on {\n    background-position: -96px -144px;\n}\n\n.ui-icon-radio-off {\n    background-position: -112px -144px;\n}\n\n.ui-icon-pin-w {\n    background-position: -128px -144px;\n}\n\n.ui-icon-pin-s {\n    background-position: -144px -144px;\n}\n\n.ui-icon-play {\n    background-position: 0 -160px;\n}\n\n.ui-icon-pause {\n    background-position: -16px -160px;\n}\n\n.ui-icon-seek-next {\n    background-position: -32px -160px;\n}\n\n.ui-icon-seek-prev {\n    background-position: -48px -160px;\n}\n\n.ui-icon-seek-end {\n    background-position: -64px -160px;\n}\n\n.ui-icon-seek-start {\n    background-position: -80px -160px;\n}\n\n/* ui-icon-seek-first is deprecated, use ui-icon-seek-start instead */\n.ui-icon-seek-first {\n    background-position: -80px -160px;\n}\n\n.ui-icon-stop {\n    background-position: -96px -160px;\n}\n\n.ui-icon-eject {\n    background-position: -112px -160px;\n}\n\n.ui-icon-volume-off {\n    background-position: -128px -160px;\n}\n\n.ui-icon-volume-on {\n    background-position: -144px -160px;\n}\n\n.ui-icon-power {\n    background-position: 0 -176px;\n}\n\n.ui-icon-signal-diag {\n    background-position: -16px -176px;\n}\n\n.ui-icon-signal {\n    background-position: -32px -176px;\n}\n\n.ui-icon-battery-0 {\n    background-position: -48px -176px;\n}\n\n.ui-icon-battery-1 {\n    background-position: -64px -176px;\n}\n\n.ui-icon-battery-2 {\n    background-position: -80px -176px;\n}\n\n.ui-icon-battery-3 {\n    background-position: -96px -176px;\n}\n\n.ui-icon-circle-plus {\n    background-position: 0 -192px;\n}\n\n.ui-icon-circle-minus {\n    background-position: -16px -192px;\n}\n\n.ui-icon-circle-close {\n    background-position: -32px -192px;\n}\n\n.ui-icon-circle-triangle-e {\n    background-position: -48px -192px;\n}\n\n.ui-icon-circle-triangle-s {\n    background-position: -64px -192px;\n}\n\n.ui-icon-circle-triangle-w {\n    background-position: -80px -192px;\n}\n\n.ui-icon-circle-triangle-n {\n    background-position: -96px -192px;\n}\n\n.ui-icon-circle-arrow-e {\n    background-position: -112px -192px;\n}\n\n.ui-icon-circle-arrow-s {\n    background-position: -128px -192px;\n}\n\n.ui-icon-circle-arrow-w {\n    background-position: -144px -192px;\n}\n\n.ui-icon-circle-arrow-n {\n    background-position: -160px -192px;\n}\n\n.ui-icon-circle-zoomin {\n    background-position: -176px -192px;\n}\n\n.ui-icon-circle-zoomout {\n    background-position: -192px -192px;\n}\n\n.ui-icon-circle-check {\n    background-position: -208px -192px;\n}\n\n.ui-icon-circlesmall-plus {\n    background-position: 0 -208px;\n}\n\n.ui-icon-circlesmall-minus {\n    background-position: -16px -208px;\n}\n\n.ui-icon-circlesmall-close {\n    background-position: -32px -208px;\n}\n\n.ui-icon-squaresmall-plus {\n    background-position: -48px -208px;\n}\n\n.ui-icon-squaresmall-minus {\n    background-position: -64px -208px;\n}\n\n.ui-icon-squaresmall-close {\n    background-position: -80px -208px;\n}\n\n.ui-icon-grip-dotted-vertical {\n    background-position: 0 -224px;\n}\n\n.ui-icon-grip-dotted-horizontal {\n    background-position: -16px -224px;\n}\n\n.ui-icon-grip-solid-vertical {\n    background-position: -32px -224px;\n}\n\n.ui-icon-grip-solid-horizontal {\n    background-position: -48px -224px;\n}\n\n.ui-icon-gripsmall-diagonal-se {\n    background-position: -64px -224px;\n}\n\n.ui-icon-grip-diagonal-se {\n    background-position: -80px -224px;\n}\n\n\n/* Misc visuals\n----------------------------------*/\n\n/* Corner radius */\n.ui-corner-all,\n.ui-corner-top,\n.ui-corner-left,\n.ui-corner-tl {\n    border-top-left-radius: 4px;\n}\n\n.ui-corner-all,\n.ui-corner-top,\n.ui-corner-right,\n.ui-corner-tr {\n    border-top-right-radius: 4px;\n}\n\n.ui-corner-all,\n.ui-corner-bottom,\n.ui-corner-left,\n.ui-corner-bl {\n    border-bottom-left-radius: 4px;\n}\n\n.ui-corner-all,\n.ui-corner-bottom,\n.ui-corner-right,\n.ui-corner-br {\n    border-bottom-right-radius: 4px;\n}\n\n/* Overlays */\n.ui-widget-overlay {\n    background: #AAAAAA url(/images/jquery-ui/ui-bg_flat_0_aaaaaa_40x100.png) 50% 50% repeat-x;\n    opacity: .3;\n    filter: Alpha(Opacity=30);\n}\n\n.ui-widget-shadow {\n    margin: -8px 0 0 -8px;\n    padding: 8px;\n    background: #AAAAAA url(/images/jquery-ui/ui-bg_flat_0_aaaaaa_40x100.png) 50% 50% repeat-x;\n    opacity: .3;\n    filter: Alpha(Opacity=30);\n    border-radius: 8px;\n}\n",".ui-timepicker-div .ui-widget-header {\n    margin-bottom: 8px;\n}\n\n.ui-timepicker-div dl {\n    text-align: left;\n}\n\n.ui-timepicker-div dl dt {\n    float: left;\n    clear: left;\n    padding: 0 0 0 5px;\n}\n\n.ui-timepicker-div dl dd {\n    margin: 0 10px 10px 40%;\n}\n\n.ui-timepicker-div td {\n    font-size: 90%;\n}\n\n.ui-tpicker-grid-label {\n    background: none;\n    border: none;\n    margin: 0;\n    padding: 0;\n}\n\n.ui-timepicker-div .ui_tpicker_unit_hide {\n    display: none;\n}\n\n.ui-timepicker-div .ui_tpicker_time .ui_tpicker_time_input {\n    background: none;\n    color: inherit;\n    border: none;\n    outline: none;\n    border-bottom: solid 1px #555555;\n    width: 95%;\n}\n\n.ui-timepicker-div .ui_tpicker_time .ui_tpicker_time_input:focus {\n    border-bottom-color: #AAAAAA;\n}\n\n.ui-timepicker-rtl {\n    direction: rtl;\n}\n\n.ui-timepicker-rtl dl {\n    text-align: right;\n    padding: 0 5px 0 0;\n}\n\n.ui-timepicker-rtl dl dt {\n    float: right;\n    clear: right;\n}\n\n.ui-timepicker-rtl dl dd {\n    margin: 0 40% 10px 10px;\n}\n\n/* Shortened version style */\n.ui-timepicker-div.ui-timepicker-oneLine {\n    padding-right: 2px;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_time,\n.ui-timepicker-div.ui-timepicker-oneLine dt {\n    display: none;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_time_label {\n    display: block;\n    padding-top: 2px;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine dl {\n    text-align: right;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine dl dd,\n.ui-timepicker-div.ui-timepicker-oneLine dl dd > div {\n    display: inline-block;\n    margin: 0;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_minute:before,\n.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_second:before {\n    content: ':';\n    display: inline-block;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_millisec:before,\n.ui-timepicker-div.ui-timepicker-oneLine dl dd.ui_tpicker_microsec:before {\n    content: '.';\n    display: inline-block;\n}\n\n.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_unit_hide,\n.ui-timepicker-div.ui-timepicker-oneLine .ui_tpicker_unit_hide:before {\n    display: none;\n}\n\n.ui-slider-handle {\n    background: #DADADA !important;\n}\n","/*\n * Table\n */\ntable.dataTable {\n    clear: both;\n    width: 100%;\n    border-collapse: collapse;\n    margin: 15px auto 0;\n}\n\ntable.dataTable thead th {\n    cursor: pointer;\n    *cursor: hand;\n}\n\n\ntable.dataTable th.align-right {\n    text-align: right;\n}\n\ntable.dataTable th.align-center {\n    text-align: center;\n}\n\ntable.dataTable tfoot th {\n    padding: 3px 10px;\n}\n\ntable.dataTable td {\n    padding: 10px;\n    border: 0;\n}\n\ntable.dataTable td.table-icon {\n    color: #8BC53F;\n    font-size: 12px;\n}\n\ntable.dataTable td.align-right {\n    text-align: right;\n}\n\ntable.dataTable td.align-center {\n    text-align: center;\n}\n\ntable.dataTable td.control.center {\n    width: 50px;\n}\n\ntable.dataTable td.center,\ntable.dataTable td.dataTables_empty {\n    text-align: -webkit-center;\n}\n\ntable.dataTable tr.odd:hover {\n    color: #5CBB35;\n}\n\ntable.dataTable tr.odd:hover td.table-icon {\n    color: #5CBB35;\n}\n\ntable.dataTable tr.even:hover {\n    color: #5CBB35;\n}\n\ntable.dataTable tr.even:hover td.table-icon {\n    color: #5CBB35;\n}\n\ntable.dataTable tr.odd {\n    background-color: #F2F2F2;\n    border-bottom: #E5E5E5 solid 1px;\n}\n\ntable.dataTable tr.odd.checked {\n    background-color: #8BC53F;\n    color: white;\n}\n\ntable.dataTable tr.odd.checked td a {\n    color: white;\n}\n\ntable.dataTable tr.odd.checked td.table-icon {\n    color: white;\n}\n\ntable.dataTable tr.odd.checked td div.circle {\n    background-color: white !important;\n}\n\ntable.dataTable tr.even {\n    background-color: white;\n    border-bottom: #E5E5E5 solid 1px;\n}\n\ntable.dataTable tr.even.checked td a {\n    color: white;\n}\n\ntable.dataTable tr.even.checked {\n    background-color: #8BC53F;\n    color: white;\n}\n\ntable.dataTable tr.even.checked td.table-icon {\n    color: white;\n}\n\ntable.dataTable tr.even.checked td div.circle {\n    background-color: white !important;\n}\n\ntable.dataTable tr.odd td.sorting_1 {\n    background-color: #F2F2F2;\n}\n\ntable.dataTable tr.odd.checked td.sorting_1 {\n    background-color: #8BC53F;\n}\n\ntable.dataTable tr.odd td.sorting_2 {\n    background-color: #EEF4FD;\n}\n\ntable.dataTable tr.odd.checked td.sorting_2 {\n    background-color: #8BC53F;\n}\n\ntable.dataTable tr.odd td.sorting_3 {\n    background-color: #EEF4FD;\n}\n\ntable.dataTable tr.odd.checked td.sorting_3 {\n    background-color: #8BC53F;\n}\n\ntable.dataTable tr.even td.sorting_1 {\n    background-color: white;\n}\n\ntable.dataTable tr.even.checked td.sorting_1 {\n    background-color: #8BC53F;\n}\n\ntable.dataTable tr.even td.sorting_2 {\n    background-color: white;\n}\n\ntable.dataTable tr.even.checked td.sorting_2 {\n    background-color: #8BC53F;\n}\n\ntable.dataTable tr.even td.sorting_3 {\n    background-color: white;\n}\n\ntable.dataTable tr.even.checked td.sorting_3 {\n    background-color: #8BC53F;\n}\n\n/*\n * Table wrapper\n */\n.dataTables_wrapper {\n    margin: 10px;\n    position: relative;\n    clear: both;\n    *zoom: 1;\n}\n\n.dataTables_wrapper .ui-widget-header {\n    font-weight: normal;\n}\n\n.dataTables_wrapper .ui-toolbar {\n    padding: 5px;\n}\n\n\n/*\n * Page length menu\n */\n.dataTables_length {\n    height: 32px;\n    margin-bottom: 15px;\n    float: right;\n    margin-left: 20px;\n    margin-right: 10px;\n}\n\n.dataTables_length select {\n    height: 24px;\n    border: solid 1px #BBBBBB;\n    border-radius: 4px;\n    margin: 0;\n}\n\n/*\n * Filter\n */\n.dataTables_filter {\n    height: 32px;\n    margin-bottom: 15px;\n    float: right;\n    text-align: right;\n}\n\n.dataTables_filter label input {\n    margin-left: 5px;\n    height: 20px;\n    border: solid 1px #BBBBBB;\n    border-radius: 4px;\n    padding-left: 4px;\n}\n\n.dataTables_filter label, .dataTables_length label {\n    font-size: 1em;\n}\n\n/*\n * Table information\n */\n.dataTables_info {\n    margin-top: 15px;\n    padding-top: 3px;\n    clear: both;\n    float: left;\n}\n\n/*\n * Table inner details # to complete\n */\ndiv.tableInnerDetails {\n    display: block;\n}\n\ntable.dataTable.details {\n    padding-left: 50px;\n    border-collapse: collapse;\n    border-spacing: 0;\n    font-size: 1.3em;\n}\n\ntable.dataTable.details td {\n    border: 0;\n}\n\n.dataTables_toolbar {\n    float: left;\n    padding: 2px 6px;\n    margin: 0;\n    cursor: pointer;\n    *cursor: hand;\n    color: #333333 !important;\n}\n\n.toolbar .ui-button {\n    padding: 2px 6px;\n    margin: 0;\n    cursor: pointer;\n    *cursor: hand;\n    color: #333333 !important;\n}\n\n/*\n * END CUSTOM\n */\n\n/*\n * Pagination\n */\n.dataTables_paginate {\n    margin-top: 15px;\n    float: right;\n    text-align: right;\n    color: #224C4F;\n}\n\n.dataTables_paginate .paginate_button {\n    margin-right: -0.1em !important;\n}\n\n.paging_two_button .ui-button {\n    float: left;\n    cursor: pointer;\n    *cursor: hand;\n}\n\n.paging_full_numbers .paginate_button {\n    padding: 2px 6px;\n    margin: 0;\n    cursor: pointer;\n    *cursor: hand;\n    color: #333333 !important;\n}\n\n/* Full number pagination */\n.paging_full_numbers a:active {\n    outline: none\n}\n\n.paging_full_numbers a:hover {\n    text-decoration: none;\n}\n\n.paging_full_numbers a.paginate_button,\n.paging_full_numbers a.paginate_active {\n    padding: 2px 5px;\n    margin: 0 3px;\n    cursor: pointer;\n    *cursor: hand;\n    color: #333333 !important;\n}\n\n.paging_full_numbers a.paginate_button:hover {\n    text-decoration: underline;\n}\n\n.paging_full_numbers a.paginate_button.disabled,\n.paging_full_numbers a.paginate_button.current {\n    color: #999999 !important;\n    text-decoration: none !important;\n    cursor: default !important;\n}\n\n/*\n * Processing indicator\n */\n.dataTables_processing {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 250px;\n    height: 30px;\n    margin-left: -125px;\n    margin-top: -15px;\n    padding: 14px 0 2px 0;\n    border: 1px solid #DDDDDD;\n    text-align: center;\n    color: #999999;\n    font-size: 14px;\n    background-color: white;\n}\n\n/*\n * Sorting\n */\ntable.dataTable thead th div.DataTables_sort_wrapper {\n    position: relative;\n    padding-top: 5px;\n    padding-right: 20px;\n    font-weight: bold;\n    color: #224C4F;\n    font-size: 11px;\n    text-transform: capitalize;\n    margin-bottom: 5px;\n}\n\ntable.dataTable thead th div.DataTables_sort_wrapper span {\n    position: absolute;\n    top: 66%;\n    margin-top: -8px;\n    right: 0;\n}\n\ntable.dataTable th:active {\n    outline: none;\n}\n\n/*\n * Scrolling\n */\n.dataTables_scroll {\n    clear: both;\n}\n\n.dataTables_scrollBody {\n    *margin-top: -1px;\n    -webkit-overflow-scrolling: touch;\n}\n\n/*\n * dataTables custom buttons\n */\n\nnav[role=\"navigation\"] li {\n    float: left;\n    margin: 0 0 10px 0;\n    font-size: 14px;\n}\n\nnav[role=\"navigation\"] li a {\n    position: relative;\n    float: left;\n    padding: 5px 8px;\n    cursor: pointer;\n    *cursor: hand;\n}\n\n.table-activate-button, .table-discard-button, .table-reset-button {\n    border: none;\n    border-radius: 4px;\n    color: white;\n    font-size: .9em;\n    height: 24px;\n    margin-right: 4px !important;\n    width: 48px;\n}\n\n.table-activate-button {\n    background-color: #2DC937;\n}\n\n.table-discard-button {\n    background-color: #CC3232;\n}\n\n.table-reset-button {\n    background-color: #6EB3E3;\n}\n","/*\n * File:        TableTools.css\n * Description: Styles for TableTools 2\n * Author:      Allan Jardine (www.sprymedia.co.uk)\n * Language:    Javascript\n * License:     GPL v2 / 3 point BSD\n * Project:     DataTables\n *\n * Copyright 2009-2012 Allan Jardine, all rights reserved.\n *\n * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *\n *\n * CSS name space:\n *   DTTT                  DataTables TableTools\n *\n * Style sheet provides:\n *   CONTAINER             TableTools container element and styles applying to all components\n *   BUTTON_STYLES         Action specific button styles\n *   SELECTING             Row selection styles\n *   COLLECTIONS           Drop down list (collection) styles\n *   PRINTING              Print display styles\n */\n\n\n/*\n * CONTAINER\n * TableTools container element and styles applying to all components\n */\ndiv.DTTT_container {\n    position: relative;\n    float: right;\n    margin-bottom: 1em;\n}\n\nbutton.DTTT_button,\ndiv.DTTT_button,\na.DTTT_button {\n    position: relative;\n    float: left;\n    margin-right: 3px;\n    padding: 5px 8px;\n    border: 1px solid #999999;\n    cursor: pointer;\n    *cursor: hand;\n    font-size: 0.88em;\n    color: black !important;\n\n    border-radius: 2px;\n    -moz-border-radius: 2px;\n    -ms-border-radius: 2px;\n    -o-border-radius: 2px;\n    border-radius: 2px;\n\n    box-shadow: 1px 1px 3px #CCCCCC;\n    -moz-box-shadow: 1px 1px 3px #CCCCCC;\n    -ms-box-shadow: 1px 1px 3px #CCCCCC;\n    -o-box-shadow: 1px 1px 3px #CCCCCC;\n    box-shadow: 1px 1px 3px #CCCCCC;\n\n    /* Generated by http://www.colorzilla.com/gradient-editor/ */\n    background: #FFFFFF; /* Old browsers */\n    background: -webkit-linear-gradient(to bottom, #FFFFFF 0%, #F3F3F3 89%, #F9F9F9 100%); /* Chrome10+,Safari5.1+ */\n    background: -moz-linear-gradient(to bottom, #FFFFFF 0%, #F3F3F3 89%, #F9F9F9 100%); /* FF3.6+ */\n    background: -ms-linear-gradient(to bottom, #FFFFFF 0%, #F3F3F3 89%, #F9F9F9 100%); /* IE10+ */\n    background: -o-linear-gradient(to bottom, #FFFFFF 0%, #F3F3F3 89%, #F9F9F9 100%); /* Opera 11.10+ */\n    background: linear-gradient(to bottom, #FFFFFF 0%, #F3F3F3 89%, #F9F9F9 100%); /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#f9f9f9', GradientType=0); /* IE6-9 */\n}\n\n\n/* Buttons are cunning border-box sizing - we can't just use that for A and DIV due to IE6/7 */\nbutton.DTTT_button {\n    height: 30px;\n    padding: 3px 8px;\n}\n\n.DTTT_button embed {\n    outline: none;\n}\n\nbutton.DTTT_button:hover,\ndiv.DTTT_button:hover,\na.DTTT_button:hover {\n    border: 1px solid #666666;\n    text-decoration: none !important;\n\n    box-shadow: 1px 1px 3px #999999;\n    -moz-box-shadow: 1px 1px 3px #999999;\n    -ms-box-shadow: 1px 1px 3px #999999;\n    -o-box-shadow: 1px 1px 3px #999999;\n    box-shadow: 1px 1px 3px #999999;\n\n    background: #F3F3F3; /* Old browsers */\n    background: -webkit-linear-gradient(to bottom, #F3F3F3 0%, #E2E2E2 89%, #F4F4F4 100%); /* Chrome10+,Safari5.1+ */\n    background: -moz-linear-gradient(to bottom, #F3F3F3 0%, #E2E2E2 89%, #F4F4F4 100%); /* FF3.6+ */\n    background: -ms-linear-gradient(to bottom, #F3F3F3 0%, #E2E2E2 89%, #F4F4F4 100%); /* IE10+ */\n    background: -o-linear-gradient(to bottom, #F3F3F3 0%, #E2E2E2 89%, #F4F4F4 100%); /* Opera 11.10+ */\n    background: linear-gradient(to bottom, #F3F3F3 0%, #E2E2E2 89%, #F4F4F4 100%); /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f3f3f3', endColorstr='#f4f4f4', GradientType=0); /* IE6-9 */\n}\n\nbutton.DTTT_disabled,\ndiv.DTTT_disabled,\na.DTTT_disabled {\n    color: #999999;\n    border: 1px solid #D0D0D0;\n\n    background: #FFFFFF; /* Old browsers */\n    background: -webkit-linear-gradient(to bottom, #FFFFFF 0%, #F9F9F9 89%, #FAFAFA 100%); /* Chrome10+,Safari5.1+ */\n    background: -moz-linear-gradient(to bottom, #FFFFFF 0%, #F9F9F9 89%, #FAFAFA 100%); /* FF3.6+ */\n    background: -ms-linear-gradient(to bottom, #FFFFFF 0%, #F9F9F9 89%, #FAFAFA 100%); /* IE10+ */\n    background: -o-linear-gradient(to bottom, #FFFFFF 0%, #F9F9F9 89%, #FAFAFA 100%); /* Opera 11.10+ */\n    background: linear-gradient(to bottom, #FFFFFF 0%, #F9F9F9 89%, #FAFAFA 100%); /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#fafafa', GradientType=0); /* IE6-9 */\n}\n\n\n/*\n * BUTTON_STYLES\n * Action specific button styles\n * If you want images - comment this back in\n\nbutton.DTTT_button_csv,\nbutton.DTTT_button_xls,\nbutton.DTTT_button_copy,\nbutton.DTTT_button_pdf,\nbutton.DTTT_button_print {\n\tpadding-right: 0;\n}\n\nbutton.DTTT_button_csv span,\nbutton.DTTT_button_xls span,\nbutton.DTTT_button_copy span,\nbutton.DTTT_button_pdf span,\nbutton.DTTT_button_print span {\n\tdisplay: inline-block;\n\theight: 24px;\n\tline-height: 24px;\n\tpadding-right: 30px;\n}\n\n\nbutton.DTTT_button_csv span { background: url(../images/csv.png) no-repeat bottom right; }\nbutton.DTTT_button_csv:hover span { background: url(../images/csv_hover.png) no-repeat center right; }\n\nbutton.DTTT_button_xls span { background: url(../images/xls.png) no-repeat center right; }\nbutton.DTTT_button_xls:hover span { background: #f0f0f0 url(../images/xls_hover.png) no-repeat center right; }\n\nbutton.DTTT_button_copy span { background: url(../images/copy.png) no-repeat center right; }\nbutton.DTTT_button_copy:hover span { background: #f0f0f0 url(../images/copy_hover.png) no-repeat center right; }\n\nbutton.DTTT_button_pdf span { background: url(../images/pdf.png) no-repeat center right; }\nbutton.DTTT_button_pdf:hover span { background: #f0f0f0 url(../images/pdf_hover.png) no-repeat center right; }\n\nbutton.DTTT_button_print span { background: url(../images/print.png) no-repeat center right; }\nbutton.DTTT_button_print:hover span { background: #f0f0f0 url(../images/print_hover.png) no-repeat center right; }\n\n */\n\nbutton.DTTT_button_collection span {\n    padding-right: 17px;\n    /*background: url(../images/collection.png) no-repeat center right;*/\n}\n\nbutton.DTTT_button_collection:hover span {\n    padding-right: 17px;\n    /*background: #f0f0f0 url(../images/collection_hover.png) no-repeat center right;*/\n}\n\n\n/*\n* SELECTING\n* Row selection styles\n*/\ntable.DTTT_selectable tbody tr {\n    cursor: pointer;\n    *cursor: hand;\n}\n\ntable.dataTable tr.DTTT_selected.odd {\n    background-color: #9FAFD1;\n}\n\ntable.dataTable tr.DTTT_selected.odd td.sorting_1 {\n    background-color: #9FAFD1;\n}\n\ntable.dataTable tr.DTTT_selected.odd td.sorting_2 {\n    background-color: #9FAFD1;\n}\n\ntable.dataTable tr.DTTT_selected.odd td.sorting_3 {\n    background-color: #9FAFD1;\n}\n\n\ntable.dataTable tr.DTTT_selected.even {\n    background-color: #B0BED9;\n}\n\ntable.dataTable tr.DTTT_selected.even td.sorting_1 {\n    background-color: #B0BED9;\n}\n\ntable.dataTable tr.DTTT_selected.even td.sorting_2 {\n    background-color: #B0BED9;\n}\n\ntable.dataTable tr.DTTT_selected.even td.sorting_3 {\n    background-color: #B0BED9;\n}\n\n\n/*\n * COLLECTIONS\n * Drop down list (collection) styles\n */\n\ndiv.DTTT_collection {\n    width: 150px;\n    padding: 8px 8px 4px 8px;\n    border: 1px solid #CCCCCC;\n    border: 1px solid rgba(0, 0, 0, 0.4);\n    background-color: #F3F3F3;\n    background-color: rgba(255, 255, 255, 0.3);\n    overflow: hidden;\n    z-index: 2002;\n\n    border-radius: 5px;\n    -moz-border-radius: 5px;\n    -ms-border-radius: 5px;\n    -o-border-radius: 5px;\n    border-radius: 5px;\n\n    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);\n    -moz-box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);\n    -ms-box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);\n    -o-box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);\n    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.3);\n}\n\ndiv.DTTT_collection_background {\n    /*background: transparent url(../images/background.png) repeat top left;*/\n    z-index: 2001;\n}\n\ndiv.DTTT_collection button.DTTT_button,\ndiv.DTTT_collection div.DTTT_button,\ndiv.DTTT_collection a.DTTT_button {\n    position: relative;\n    left: 0;\n    right: 0;\n\n    display: block;\n    float: none;\n    margin-bottom: 4px;\n\n    box-shadow: 1px 1px 3px #999999;\n    -moz-box-shadow: 1px 1px 3px #999999;\n    -ms-box-shadow: 1px 1px 3px #999999;\n    -o-box-shadow: 1px 1px 3px #999999;\n    box-shadow: 1px 1px 3px #999999;\n}\n\n\n/*\n* PRINTING\n* Print display styles\n*/\n\n.DTTT_print_info {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    width: 400px;\n    height: 150px;\n    margin-left: -200px;\n    margin-top: -75px;\n    text-align: center;\n    color: #333333;\n    padding: 10px 30px;\n\n    background: #FFFFFF; /* Old browsers */\n    background: -webkit-linear-gradient(to bottom, #FFFFFF 0%, #F3F3F3 89%, #F9F9F9 100%); /* Chrome10+,Safari5.1+ */\n    background: -moz-linear-gradient(to bottom, #FFFFFF 0%, #F3F3F3 89%, #F9F9F9 100%); /* FF3.6+ */\n    background: -ms-linear-gradient(to bottom, #FFFFFF 0%, #F3F3F3 89%, #F9F9F9 100%); /* IE10+ */\n    background: -o-linear-gradient(to bottom, #FFFFFF 0%, #F3F3F3 89%, #F9F9F9 100%); /* Opera 11.10+ */\n    background: linear-gradient(to bottom, #FFFFFF 0%, #F3F3F3 89%, #F9F9F9 100%); /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#f9f9f9', GradientType=0); /* IE6-9 */\n\n    opacity: 0.95;\n\n    border: 1px solid black;\n    border: 1px solid rgba(0, 0, 0, 0.5);\n\n    border-radius: 6px;\n    -moz-border-radius: 6px;\n    -ms-border-radius: 6px;\n    -o-border-radius: 6px;\n    border-radius: 6px;\n\n    box-shadow: 0 3px 7px rgba(0, 0, 0, 0.5);\n    -moz-box-shadow: 0 3px 7px rgba(0, 0, 0, 0.5);\n    -ms-box-shadow: 0 3px 7px rgba(0, 0, 0, 0.5);\n    -o-box-shadow: 0 3px 7px rgba(0, 0, 0, 0.5);\n    box-shadow: 0 3px 7px rgba(0, 0, 0, 0.5);\n}\n\n.DTTT_print_info h6 {\n    font-weight: normal;\n    font-size: 28px;\n    line-height: 28px;\n    margin: 1em;\n}\n\n.DTTT_print_info p {\n    font-size: 14px;\n    line-height: 20px;\n}\n\n","/*\n * File:        TableTools.css\n * Description: Styles for TableTools 2 with JUI theming\n * Author:      Allan Jardine (www.sprymedia.co.uk)\n * Language:    Javascript\n * License:     LGPL / 3 point BSD\n * Project:     DataTables\n *\n * Copyright 2010 Allan Jardine, all rights reserved.\n *\n * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *\n *\n * Notes:\n *   Generally speaking, please refer to the TableTools.css file - this file contains basic\n *   modifications to that 'master' stylesheet for ThemeRoller.\n *\n * CSS name space:\n *   DTTT                  DataTables TableTools\n *\n * Colour dictionary:\n *   Button border         #d0d0d0\n *   Button border hover   #999999\n *   Hover background      #f0f0f0\n *   Action blue           #4b66d9\n *\n * Style sheet provides:\n *   CONTAINER             TableTools container element and styles applying to all components\n *   SELECTING             Row selection styles\n *   COLLECTIONS           Drop down list (collection) styles\n *   PRINTING              Print display styles\n *   MISC                  Minor misc styles\n */\n\n/*\n * CONTAINER\n * TableTools container element and styles applying to all components\n */\ndiv.DTTT_container {\n    position: relative;\n    float: left;\n}\n\n.DTTT_button {\n    position: relative;\n    float: left;\n    margin-right: 3px;\n    padding: 3px 10px;\n    border: 1px solid #D0D0D0;\n    background-color: #FFFFFF;\n    color: #333333 !important;\n    cursor: pointer;\n    *cursor: hand;\n}\n\n.DTTT_button::-moz-focus-inner {\n    border: none !important;\n    padding: 0;\n}\n\n/*\n * SELECTING\n * Row selection styles\n */\ntable.DTTT_selectable tbody tr {\n    cursor: pointer;\n    *cursor: hand;\n}\n\ntable.dataTable tr.DTTT_selected.odd {\n    background-color: #9FAFD1;\n}\n\ntable.dataTable tr.DTTT_selected.odd td.sorting_1 {\n    background-color: #9FAFD1;\n}\n\ntable.dataTable tr.DTTT_selected.odd td.sorting_2 {\n    background-color: #9FAFD1;\n}\n\ntable.dataTable tr.DTTT_selected.odd td.sorting_3 {\n    background-color: #9FAFD1;\n}\n\ntable.dataTable tr.DTTT_selected.even {\n    background-color: #B0BED9;\n}\n\ntable.dataTable tr.DTTT_selected.even td.sorting_1 {\n    background-color: #B0BED9;\n}\n\ntable.dataTable tr.DTTT_selected.even td.sorting_2 {\n    background-color: #B0BED9;\n}\n\ntable.dataTable tr.DTTT_selected.even td.sorting_3 {\n    background-color: #B0BED9;\n}\n\n/*\n * COLLECTIONS\n * Drop down list (collection) styles\n */\n\ndiv.DTTT_collection {\n    width: 150px;\n    background-color: #F3F3F3;\n    overflow: hidden;\n    z-index: 2002;\n\n    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);\n    -moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);\n    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);\n}\n\ndiv.DTTT_collection_background {\n    /*background: url(../images/background.png) repeat top left;*/\n    z-index: 2001;\n}\n\ndiv.DTTT_collection button.DTTT_button,\ndiv.DTTT_collection div.DTTT_button,\ndiv.DTTT_collection a.DTTT_button {\n    float: none;\n    width: 100%;\n    margin-bottom: -0.1em;\n}\n\n/*\n* PRINTING\n* Print display styles\n*/\n\n.DTTT_print_info {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 400px;\n    height: 150px;\n    margin-left: -200px;\n    margin-top: -75px;\n    text-align: center;\n    background-color: #3F3F3F;\n    color: white;\n    padding: 10px 30px;\n\n    opacity: 0.9;\n\n    border-radius: 5px;\n    -moz-border-radius: 5px;\n    border-radius: 5px;\n\n    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);\n    -moz-box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);\n    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);\n}\n\n.DTTT_print_info h6 {\n    font-weight: normal;\n    font-size: 28px;\n    line-height: 28px;\n    margin: 1em;\n}\n\n.DTTT_print_info p {\n    font-size: 14px;\n    line-height: 20px;\n}\n\n/*\n * MISC\n * Minor misc styles\n */\n\n.DTTT_disabled {\n    color: #999999;\n}\n","/* Assets in alarms */\n\n.alarm-integration-assets {\n    margin-top: 10px;\n    width: 100%;\n    background: none;\n    width: calc(100% - 25px);\n}\n\n.alarm-integration-assets .content {\n    width: 100%;\n    background-color: #E8E8E8;\n    border-radius: 0 0 3px 3px;\n    padding: 0px 10px 10px 10px;\n}\n\n.alarm-integration-assets .content #integration-assets {\n    padding-top: 5px;\n}\n\n.alarm-integration-assets .content li {\n    margin: 5px 0;\n    float: left;\n}\n\n.alarm-integration-assets .content ul {\n    list-style: none;\n}\n\n.alarm-integration-assets .title {\n    width: 100%;\n    font-size: 12px;\n    border-radius: 3px 3px 0 0;\n    background: #224C4F;\n    text-align: left;\n    color: white;\n    font-weight: bold;\n    padding: 10px;\n}\n\n.partner-title {\n    font-weight: bold;\n    padding-top: 5px;\n}\n\n.question-mark {\n    display: inline-block;\n    vertical-align: top;\n}\n\n.question-mark .tooltiptext {\n    visibility: hidden;\n    width: 120px;\n    background-color: #224C4F;\n    color: #FFFFFF;\n    text-align: center;\n    border-radius: 3px;\n    padding: 5px 2px;\n    position: absolute;\n    z-index: 15;\n}\n\n.question-mark:hover .tooltiptext {\n    visibility: visible;\n}\n\n.truncated-text {\n    max-width: 150px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    display: inline-block;\n}\n\n/* Asset show */\n\n.asset-settings .slider {\n    left: auto;\n}\n\n.asset-settings .switch {\n    position: initial;\n}\n\n","._select_view {\n    width: 200px;\n}\n",".wise-layout a {\n    color: #8BC53F;\n    text-decoration: none;\n}\n\n.wise-layout a:hover {\n    color: #8BC53F;\n    text-decoration: underline;\n}\n\n.wise-layout .breadcrumb {\n    padding: 7px 14px;\n    margin: 0 0 18px;\n    height: 18px;\n    background-color: #FBFBFB;\n    background-image: -moz-linear-gradient(to bottom, #FFFFFF, #F5F5F5);\n    background-image: -ms-linear-gradient(to bottom, #FFFFFF, #F5F5F5);\n    background-image: -webkit-gradient(linear, 0 0, 0 100%, from(#FFFFFF), to(#F5F5F5));\n    background-image: -webkit-linear-gradient(to bottom, #FFFFFF, #F5F5F5);\n    background-image: -o-linear-gradient(to bottom, #FFFFFF, #F5F5F5);\n    background-image: linear-gradient(to bottom, #FFFFFF, #F5F5F5);\n    background-repeat: repeat-x;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ffffff', endColorstr='#f5f5f5', GradientType=0);\n    border: 1px solid #DDDDDD;\n    border-radius: 3px;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    box-shadow: inset 0 1px 0 #FFFFFF;\n    -moz-box-shadow: inset 0 1px 0 #FFFFFF;\n    box-shadow: inset 0 1px 0 #FFFFFF;\n}\n\n.wise-layout .breadcrumb li {\n    display: inline-block;\n    text-shadow: 0 1px 0 #FFFFFF;\n}\n\n.wise-layout .breadcrumb .divider {\n    padding: 0 5px;\n    color: #999999;\n}\n\n.wise-layout .breadcrumb .active a {\n    color: #333333;\n}\n\n.wise-layout #content-banner {\n    margin: 20px;\n    padding: 20px 20px;\n    border-radius: 3px;\n    background-color: #8BC53F;\n    color: #224C4F;\n    font-size: 14px;\n}\n","/* Cal-HeatMap CSS */\n\n.cal-heatmap-container {\n    display: block;\n}\n\n.graph {\n    font-family: \"Lucida Grande\", Lucida, Verdana, sans-serif;\n}\n\n.graph-label {\n    fill: #999999;\n    font-size: 10px\n}\n\n.graph, .graph-legend rect {\n    shape-rendering: crispedges\n}\n\n.graph-rect {\n    fill: #EDEDED\n}\n\n.graph-subdomain-group rect:hover {\n    stroke: #000000;\n    stroke-width: 1px\n}\n\n.subdomain-text {\n    font-size: 8px;\n    fill: #999999;\n    pointer-events: none\n}\n\n.hover_cursor:hover {\n    cursor: pointer\n}\n\n.qi {\n    background-color: #999999;\n    fill: #999999\n}\n\n/*\nRemove comment to apply this style to date with value equal to 0\n.q0\n{\n\tbackground-color: #fff;\n\tfill: #fff;\n\tstroke: #ededed\n}\n*/\n\n.q1 {\n    background-color: #DAE289;\n    fill: #DAE289\n}\n\n.q2 {\n    background-color: #CEDB9C;\n    fill: #9CC069\n}\n\n.q3 {\n    background-color: #B5CF6B;\n    fill: #669D45\n}\n\n.q4 {\n    background-color: #637939;\n    fill: #637939\n}\n\n.q5 {\n    background-color: #3B6427;\n    fill: #3B6427\n}\n\nrect.highlight {\n    stroke: #444444;\n    stroke-width: 1\n}\n\ntext.highlight {\n    fill: #444444\n}\n\nrect.now {\n    stroke: red\n}\n\ntext.now {\n    fill: red;\n    font-weight: 800\n}\n\n.domain-background {\n    fill: none;\n    shape-rendering: crispedges\n}\n\n.ch-tooltip {\n    padding: 10px;\n    background: #222222;\n    color: #BBBBBB;\n    font-size: 12px;\n    line-height: 1.4;\n    width: 140px;\n    position: absolute;\n    z-index: 99999 !important;\n    text-align: center;\n    border-radius: 2px;\n    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2);\n    display: none;\n    box-sizing: border-box;\n}\n\n.ch-tooltip::after {\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-color: transparent;\n    border-style: solid;\n    content: \"\";\n    padding: 0;\n    display: \"block\";\n    bottom: -6px;\n    left: 50%;\n    margin-left: -6px;\n    border-width: 6px 6px 0;\n    border-top-color: #222222;\n}\n",".subdomain-text {\n    font-size: 7px;\n    fill: black;\n}\n\n.q0 {\n    background-color: #EDEDED;\n    fill: #EDEDED;\n}\n\n.q1 {\n    background-color: #AAAAAA;\n    fill: #AAAAAA;\n}\n\n.q2 {\n    background-color: #4D7D9E;\n    fill: #4D7D9E;\n}\n\n.q3 {\n    background-color: #6EB3E3;\n    fill: #6EB3E3;\n}\n\n.q4 {\n    background-color: #A8D1EE;\n    fill: #A8D1EE;\n}\n\n.q5 {\n    background-color: #EF7C7E;\n    fill: #EF7C7E;\n}\n\n.q6 {\n    background-color: #E94547;\n    fill: #E94547;\n}\n","/*\n * This product includes color specifications and designs developed by Cynthia\n * Brewer (http://colorbrewer.org/).\n */\n.YlGn .q0-3 {\n    fill: rgb(247, 252, 185)\n}\n\n.YlGn .q1-3 {\n    fill: rgb(173, 221, 142)\n}\n\n.YlGn .q2-3 {\n    fill: rgb(49, 163, 84)\n}\n\n.YlGn .q0-4 {\n    fill: rgb(255, 255, 204)\n}\n\n.YlGn .q1-4 {\n    fill: rgb(194, 230, 153)\n}\n\n.YlGn .q2-4 {\n    fill: rgb(120, 198, 121)\n}\n\n.YlGn .q3-4 {\n    fill: rgb(35, 132, 67)\n}\n\n.YlGn .q0-5 {\n    fill: rgb(255, 255, 204)\n}\n\n.YlGn .q1-5 {\n    fill: rgb(194, 230, 153)\n}\n\n.YlGn .q2-5 {\n    fill: rgb(120, 198, 121)\n}\n\n.YlGn .q3-5 {\n    fill: rgb(49, 163, 84)\n}\n\n.YlGn .q4-5 {\n    fill: rgb(0, 104, 55)\n}\n\n.YlGn .q0-6 {\n    fill: rgb(255, 255, 204)\n}\n\n.YlGn .q1-6 {\n    fill: rgb(217, 240, 163)\n}\n\n.YlGn .q2-6 {\n    fill: rgb(173, 221, 142)\n}\n\n.YlGn .q3-6 {\n    fill: rgb(120, 198, 121)\n}\n\n.YlGn .q4-6 {\n    fill: rgb(49, 163, 84)\n}\n\n.YlGn .q5-6 {\n    fill: rgb(0, 104, 55)\n}\n\n.YlGn .q0-7 {\n    fill: rgb(255, 255, 204)\n}\n\n.YlGn .q1-7 {\n    fill: rgb(217, 240, 163)\n}\n\n.YlGn .q2-7 {\n    fill: rgb(173, 221, 142)\n}\n\n.YlGn .q3-7 {\n    fill: rgb(120, 198, 121)\n}\n\n.YlGn .q4-7 {\n    fill: rgb(65, 171, 93)\n}\n\n.YlGn .q5-7 {\n    fill: rgb(35, 132, 67)\n}\n\n.YlGn .q6-7 {\n    fill: rgb(0, 90, 50)\n}\n\n.YlGn .q0-8 {\n    fill: rgb(255, 255, 229)\n}\n\n.YlGn .q1-8 {\n    fill: rgb(247, 252, 185)\n}\n\n.YlGn .q2-8 {\n    fill: rgb(217, 240, 163)\n}\n\n.YlGn .q3-8 {\n    fill: rgb(173, 221, 142)\n}\n\n.YlGn .q4-8 {\n    fill: rgb(120, 198, 121)\n}\n\n.YlGn .q5-8 {\n    fill: rgb(65, 171, 93)\n}\n\n.YlGn .q6-8 {\n    fill: rgb(35, 132, 67)\n}\n\n.YlGn .q7-8 {\n    fill: rgb(0, 90, 50)\n}\n\n.YlGn .q0-9 {\n    fill: rgb(255, 255, 229)\n}\n\n.YlGn .q1-9 {\n    fill: rgb(247, 252, 185)\n}\n\n.YlGn .q2-9 {\n    fill: rgb(217, 240, 163)\n}\n\n.YlGn .q3-9 {\n    fill: rgb(173, 221, 142)\n}\n\n.YlGn .q4-9 {\n    fill: rgb(120, 198, 121)\n}\n\n.YlGn .q5-9 {\n    fill: rgb(65, 171, 93)\n}\n\n.YlGn .q6-9 {\n    fill: rgb(35, 132, 67)\n}\n\n.YlGn .q7-9 {\n    fill: rgb(0, 104, 55)\n}\n\n.YlGn .q8-9 {\n    fill: rgb(0, 69, 41)\n}\n\n.YlGnBu .q0-3 {\n    fill: rgb(237, 248, 177)\n}\n\n.YlGnBu .q1-3 {\n    fill: rgb(127, 205, 187)\n}\n\n.YlGnBu .q2-3 {\n    fill: rgb(44, 127, 184)\n}\n\n.YlGnBu .q0-4 {\n    fill: rgb(255, 255, 204)\n}\n\n.YlGnBu .q1-4 {\n    fill: rgb(161, 218, 180)\n}\n\n.YlGnBu .q2-4 {\n    fill: rgb(65, 182, 196)\n}\n\n.YlGnBu .q3-4 {\n    fill: rgb(34, 94, 168)\n}\n\n.YlGnBu .q0-5 {\n    fill: rgb(255, 255, 204)\n}\n\n.YlGnBu .q1-5 {\n    fill: rgb(161, 218, 180)\n}\n\n.YlGnBu .q2-5 {\n    fill: rgb(65, 182, 196)\n}\n\n.YlGnBu .q3-5 {\n    fill: rgb(44, 127, 184)\n}\n\n.YlGnBu .q4-5 {\n    fill: rgb(37, 52, 148)\n}\n\n.YlGnBu .q0-6 {\n    fill: rgb(255, 255, 204)\n}\n\n.YlGnBu .q1-6 {\n    fill: rgb(199, 233, 180)\n}\n\n.YlGnBu .q2-6 {\n    fill: rgb(127, 205, 187)\n}\n\n.YlGnBu .q3-6 {\n    fill: rgb(65, 182, 196)\n}\n\n.YlGnBu .q4-6 {\n    fill: rgb(44, 127, 184)\n}\n\n.YlGnBu .q5-6 {\n    fill: rgb(37, 52, 148)\n}\n\n.YlGnBu .q0-7 {\n    fill: rgb(255, 255, 204)\n}\n\n.YlGnBu .q1-7 {\n    fill: rgb(199, 233, 180)\n}\n\n.YlGnBu .q2-7 {\n    fill: rgb(127, 205, 187)\n}\n\n.YlGnBu .q3-7 {\n    fill: rgb(65, 182, 196)\n}\n\n.YlGnBu .q4-7 {\n    fill: rgb(29, 145, 192)\n}\n\n.YlGnBu .q5-7 {\n    fill: rgb(34, 94, 168)\n}\n\n.YlGnBu .q6-7 {\n    fill: rgb(12, 44, 132)\n}\n\n.YlGnBu .q0-8 {\n    fill: rgb(255, 255, 217)\n}\n\n.YlGnBu .q1-8 {\n    fill: rgb(237, 248, 177)\n}\n\n.YlGnBu .q2-8 {\n    fill: rgb(199, 233, 180)\n}\n\n.YlGnBu .q3-8 {\n    fill: rgb(127, 205, 187)\n}\n\n.YlGnBu .q4-8 {\n    fill: rgb(65, 182, 196)\n}\n\n.YlGnBu .q5-8 {\n    fill: rgb(29, 145, 192)\n}\n\n.YlGnBu .q6-8 {\n    fill: rgb(34, 94, 168)\n}\n\n.YlGnBu .q7-8 {\n    fill: rgb(12, 44, 132)\n}\n\n.YlGnBu .q0-9 {\n    fill: rgb(255, 255, 217)\n}\n\n.YlGnBu .q1-9 {\n    fill: rgb(237, 248, 177)\n}\n\n.YlGnBu .q2-9 {\n    fill: rgb(199, 233, 180)\n}\n\n.YlGnBu .q3-9 {\n    fill: rgb(127, 205, 187)\n}\n\n.YlGnBu .q4-9 {\n    fill: rgb(65, 182, 196)\n}\n\n.YlGnBu .q5-9 {\n    fill: rgb(29, 145, 192)\n}\n\n.YlGnBu .q6-9 {\n    fill: rgb(34, 94, 168)\n}\n\n.YlGnBu .q7-9 {\n    fill: rgb(37, 52, 148)\n}\n\n.YlGnBu .q8-9 {\n    fill: rgb(8, 29, 88)\n}\n\n.GnBu .q0-3 {\n    fill: rgb(224, 243, 219)\n}\n\n.GnBu .q1-3 {\n    fill: rgb(168, 221, 181)\n}\n\n.GnBu .q2-3 {\n    fill: rgb(67, 162, 202)\n}\n\n.GnBu .q0-4 {\n    fill: rgb(240, 249, 232)\n}\n\n.GnBu .q1-4 {\n    fill: rgb(186, 228, 188)\n}\n\n.GnBu .q2-4 {\n    fill: rgb(123, 204, 196)\n}\n\n.GnBu .q3-4 {\n    fill: rgb(43, 140, 190)\n}\n\n.GnBu .q0-5 {\n    fill: rgb(240, 249, 232)\n}\n\n.GnBu .q1-5 {\n    fill: rgb(186, 228, 188)\n}\n\n.GnBu .q2-5 {\n    fill: rgb(123, 204, 196)\n}\n\n.GnBu .q3-5 {\n    fill: rgb(67, 162, 202)\n}\n\n.GnBu .q4-5 {\n    fill: rgb(8, 104, 172)\n}\n\n.GnBu .q0-6 {\n    fill: rgb(240, 249, 232)\n}\n\n.GnBu .q1-6 {\n    fill: rgb(204, 235, 197)\n}\n\n.GnBu .q2-6 {\n    fill: rgb(168, 221, 181)\n}\n\n.GnBu .q3-6 {\n    fill: rgb(123, 204, 196)\n}\n\n.GnBu .q4-6 {\n    fill: rgb(67, 162, 202)\n}\n\n.GnBu .q5-6 {\n    fill: rgb(8, 104, 172)\n}\n\n.GnBu .q0-7 {\n    fill: rgb(240, 249, 232)\n}\n\n.GnBu .q1-7 {\n    fill: rgb(204, 235, 197)\n}\n\n.GnBu .q2-7 {\n    fill: rgb(168, 221, 181)\n}\n\n.GnBu .q3-7 {\n    fill: rgb(123, 204, 196)\n}\n\n.GnBu .q4-7 {\n    fill: rgb(78, 179, 211)\n}\n\n.GnBu .q5-7 {\n    fill: rgb(43, 140, 190)\n}\n\n.GnBu .q6-7 {\n    fill: rgb(8, 88, 158)\n}\n\n.GnBu .q0-8 {\n    fill: rgb(247, 252, 240)\n}\n\n.GnBu .q1-8 {\n    fill: rgb(224, 243, 219)\n}\n\n.GnBu .q2-8 {\n    fill: rgb(204, 235, 197)\n}\n\n.GnBu .q3-8 {\n    fill: rgb(168, 221, 181)\n}\n\n.GnBu .q4-8 {\n    fill: rgb(123, 204, 196)\n}\n\n.GnBu .q5-8 {\n    fill: rgb(78, 179, 211)\n}\n\n.GnBu .q6-8 {\n    fill: rgb(43, 140, 190)\n}\n\n.GnBu .q7-8 {\n    fill: rgb(8, 88, 158)\n}\n\n.GnBu .q0-9 {\n    fill: rgb(247, 252, 240)\n}\n\n.GnBu .q1-9 {\n    fill: rgb(224, 243, 219)\n}\n\n.GnBu .q2-9 {\n    fill: rgb(204, 235, 197)\n}\n\n.GnBu .q3-9 {\n    fill: rgb(168, 221, 181)\n}\n\n.GnBu .q4-9 {\n    fill: rgb(123, 204, 196)\n}\n\n.GnBu .q5-9 {\n    fill: rgb(78, 179, 211)\n}\n\n.GnBu .q6-9 {\n    fill: rgb(43, 140, 190)\n}\n\n.GnBu .q7-9 {\n    fill: rgb(8, 104, 172)\n}\n\n.GnBu .q8-9 {\n    fill: rgb(8, 64, 129)\n}\n\n.BuGn .q0-3 {\n    fill: rgb(229, 245, 249)\n}\n\n.BuGn .q1-3 {\n    fill: rgb(153, 216, 201)\n}\n\n.BuGn .q2-3 {\n    fill: rgb(44, 162, 95)\n}\n\n.BuGn .q0-4 {\n    fill: rgb(237, 248, 251)\n}\n\n.BuGn .q1-4 {\n    fill: rgb(178, 226, 226)\n}\n\n.BuGn .q2-4 {\n    fill: rgb(102, 194, 164)\n}\n\n.BuGn .q3-4 {\n    fill: rgb(35, 139, 69)\n}\n\n.BuGn .q0-5 {\n    fill: rgb(237, 248, 251)\n}\n\n.BuGn .q1-5 {\n    fill: rgb(178, 226, 226)\n}\n\n.BuGn .q2-5 {\n    fill: rgb(102, 194, 164)\n}\n\n.BuGn .q3-5 {\n    fill: rgb(44, 162, 95)\n}\n\n.BuGn .q4-5 {\n    fill: rgb(0, 109, 44)\n}\n\n.BuGn .q0-6 {\n    fill: rgb(237, 248, 251)\n}\n\n.BuGn .q1-6 {\n    fill: rgb(204, 236, 230)\n}\n\n.BuGn .q2-6 {\n    fill: rgb(153, 216, 201)\n}\n\n.BuGn .q3-6 {\n    fill: rgb(102, 194, 164)\n}\n\n.BuGn .q4-6 {\n    fill: rgb(44, 162, 95)\n}\n\n.BuGn .q5-6 {\n    fill: rgb(0, 109, 44)\n}\n\n.BuGn .q0-7 {\n    fill: rgb(237, 248, 251)\n}\n\n.BuGn .q1-7 {\n    fill: rgb(204, 236, 230)\n}\n\n.BuGn .q2-7 {\n    fill: rgb(153, 216, 201)\n}\n\n.BuGn .q3-7 {\n    fill: rgb(102, 194, 164)\n}\n\n.BuGn .q4-7 {\n    fill: rgb(65, 174, 118)\n}\n\n.BuGn .q5-7 {\n    fill: rgb(35, 139, 69)\n}\n\n.BuGn .q6-7 {\n    fill: rgb(0, 88, 36)\n}\n\n.BuGn .q0-8 {\n    fill: rgb(247, 252, 253)\n}\n\n.BuGn .q1-8 {\n    fill: rgb(229, 245, 249)\n}\n\n.BuGn .q2-8 {\n    fill: rgb(204, 236, 230)\n}\n\n.BuGn .q3-8 {\n    fill: rgb(153, 216, 201)\n}\n\n.BuGn .q4-8 {\n    fill: rgb(102, 194, 164)\n}\n\n.BuGn .q5-8 {\n    fill: rgb(65, 174, 118)\n}\n\n.BuGn .q6-8 {\n    fill: rgb(35, 139, 69)\n}\n\n.BuGn .q7-8 {\n    fill: rgb(0, 88, 36)\n}\n\n.BuGn .q0-9 {\n    fill: rgb(247, 252, 253)\n}\n\n.BuGn .q1-9 {\n    fill: rgb(229, 245, 249)\n}\n\n.BuGn .q2-9 {\n    fill: rgb(204, 236, 230)\n}\n\n.BuGn .q3-9 {\n    fill: rgb(153, 216, 201)\n}\n\n.BuGn .q4-9 {\n    fill: rgb(102, 194, 164)\n}\n\n.BuGn .q5-9 {\n    fill: rgb(65, 174, 118)\n}\n\n.BuGn .q6-9 {\n    fill: rgb(35, 139, 69)\n}\n\n.BuGn .q7-9 {\n    fill: rgb(0, 109, 44)\n}\n\n.BuGn .q8-9 {\n    fill: rgb(0, 68, 27)\n}\n\n.PuBuGn .q0-3 {\n    fill: rgb(236, 226, 240)\n}\n\n.PuBuGn .q1-3 {\n    fill: rgb(166, 189, 219)\n}\n\n.PuBuGn .q2-3 {\n    fill: rgb(28, 144, 153)\n}\n\n.PuBuGn .q0-4 {\n    fill: rgb(246, 239, 247)\n}\n\n.PuBuGn .q1-4 {\n    fill: rgb(189, 201, 225)\n}\n\n.PuBuGn .q2-4 {\n    fill: rgb(103, 169, 207)\n}\n\n.PuBuGn .q3-4 {\n    fill: rgb(2, 129, 138)\n}\n\n.PuBuGn .q0-5 {\n    fill: rgb(246, 239, 247)\n}\n\n.PuBuGn .q1-5 {\n    fill: rgb(189, 201, 225)\n}\n\n.PuBuGn .q2-5 {\n    fill: rgb(103, 169, 207)\n}\n\n.PuBuGn .q3-5 {\n    fill: rgb(28, 144, 153)\n}\n\n.PuBuGn .q4-5 {\n    fill: rgb(1, 108, 89)\n}\n\n.PuBuGn .q0-6 {\n    fill: rgb(246, 239, 247)\n}\n\n.PuBuGn .q1-6 {\n    fill: rgb(208, 209, 230)\n}\n\n.PuBuGn .q2-6 {\n    fill: rgb(166, 189, 219)\n}\n\n.PuBuGn .q3-6 {\n    fill: rgb(103, 169, 207)\n}\n\n.PuBuGn .q4-6 {\n    fill: rgb(28, 144, 153)\n}\n\n.PuBuGn .q5-6 {\n    fill: rgb(1, 108, 89)\n}\n\n.PuBuGn .q0-7 {\n    fill: rgb(246, 239, 247)\n}\n\n.PuBuGn .q1-7 {\n    fill: rgb(208, 209, 230)\n}\n\n.PuBuGn .q2-7 {\n    fill: rgb(166, 189, 219)\n}\n\n.PuBuGn .q3-7 {\n    fill: rgb(103, 169, 207)\n}\n\n.PuBuGn .q4-7 {\n    fill: rgb(54, 144, 192)\n}\n\n.PuBuGn .q5-7 {\n    fill: rgb(2, 129, 138)\n}\n\n.PuBuGn .q6-7 {\n    fill: rgb(1, 100, 80)\n}\n\n.PuBuGn .q0-8 {\n    fill: rgb(255, 247, 251)\n}\n\n.PuBuGn .q1-8 {\n    fill: rgb(236, 226, 240)\n}\n\n.PuBuGn .q2-8 {\n    fill: rgb(208, 209, 230)\n}\n\n.PuBuGn .q3-8 {\n    fill: rgb(166, 189, 219)\n}\n\n.PuBuGn .q4-8 {\n    fill: rgb(103, 169, 207)\n}\n\n.PuBuGn .q5-8 {\n    fill: rgb(54, 144, 192)\n}\n\n.PuBuGn .q6-8 {\n    fill: rgb(2, 129, 138)\n}\n\n.PuBuGn .q7-8 {\n    fill: rgb(1, 100, 80)\n}\n\n.PuBuGn .q0-9 {\n    fill: rgb(255, 247, 251)\n}\n\n.PuBuGn .q1-9 {\n    fill: rgb(236, 226, 240)\n}\n\n.PuBuGn .q2-9 {\n    fill: rgb(208, 209, 230)\n}\n\n.PuBuGn .q3-9 {\n    fill: rgb(166, 189, 219)\n}\n\n.PuBuGn .q4-9 {\n    fill: rgb(103, 169, 207)\n}\n\n.PuBuGn .q5-9 {\n    fill: rgb(54, 144, 192)\n}\n\n.PuBuGn .q6-9 {\n    fill: rgb(2, 129, 138)\n}\n\n.PuBuGn .q7-9 {\n    fill: rgb(1, 108, 89)\n}\n\n.PuBuGn .q8-9 {\n    fill: rgb(1, 70, 54)\n}\n\n.PuBu .q0-3 {\n    fill: rgb(236, 231, 242)\n}\n\n.PuBu .q1-3 {\n    fill: rgb(166, 189, 219)\n}\n\n.PuBu .q2-3 {\n    fill: rgb(43, 140, 190)\n}\n\n.PuBu .q0-4 {\n    fill: rgb(241, 238, 246)\n}\n\n.PuBu .q1-4 {\n    fill: rgb(189, 201, 225)\n}\n\n.PuBu .q2-4 {\n    fill: rgb(116, 169, 207)\n}\n\n.PuBu .q3-4 {\n    fill: rgb(5, 112, 176)\n}\n\n.PuBu .q0-5 {\n    fill: rgb(241, 238, 246)\n}\n\n.PuBu .q1-5 {\n    fill: rgb(189, 201, 225)\n}\n\n.PuBu .q2-5 {\n    fill: rgb(116, 169, 207)\n}\n\n.PuBu .q3-5 {\n    fill: rgb(43, 140, 190)\n}\n\n.PuBu .q4-5 {\n    fill: rgb(4, 90, 141)\n}\n\n.PuBu .q0-6 {\n    fill: rgb(241, 238, 246)\n}\n\n.PuBu .q1-6 {\n    fill: rgb(208, 209, 230)\n}\n\n.PuBu .q2-6 {\n    fill: rgb(166, 189, 219)\n}\n\n.PuBu .q3-6 {\n    fill: rgb(116, 169, 207)\n}\n\n.PuBu .q4-6 {\n    fill: rgb(43, 140, 190)\n}\n\n.PuBu .q5-6 {\n    fill: rgb(4, 90, 141)\n}\n\n.PuBu .q0-7 {\n    fill: rgb(241, 238, 246)\n}\n\n.PuBu .q1-7 {\n    fill: rgb(208, 209, 230)\n}\n\n.PuBu .q2-7 {\n    fill: rgb(166, 189, 219)\n}\n\n.PuBu .q3-7 {\n    fill: rgb(116, 169, 207)\n}\n\n.PuBu .q4-7 {\n    fill: rgb(54, 144, 192)\n}\n\n.PuBu .q5-7 {\n    fill: rgb(5, 112, 176)\n}\n\n.PuBu .q6-7 {\n    fill: rgb(3, 78, 123)\n}\n\n.PuBu .q0-8 {\n    fill: rgb(255, 247, 251)\n}\n\n.PuBu .q1-8 {\n    fill: rgb(236, 231, 242)\n}\n\n.PuBu .q2-8 {\n    fill: rgb(208, 209, 230)\n}\n\n.PuBu .q3-8 {\n    fill: rgb(166, 189, 219)\n}\n\n.PuBu .q4-8 {\n    fill: rgb(116, 169, 207)\n}\n\n.PuBu .q5-8 {\n    fill: rgb(54, 144, 192)\n}\n\n.PuBu .q6-8 {\n    fill: rgb(5, 112, 176)\n}\n\n.PuBu .q7-8 {\n    fill: rgb(3, 78, 123)\n}\n\n.PuBu .q0-9 {\n    fill: rgb(255, 247, 251)\n}\n\n.PuBu .q1-9 {\n    fill: rgb(236, 231, 242)\n}\n\n.PuBu .q2-9 {\n    fill: rgb(208, 209, 230)\n}\n\n.PuBu .q3-9 {\n    fill: rgb(166, 189, 219)\n}\n\n.PuBu .q4-9 {\n    fill: rgb(116, 169, 207)\n}\n\n.PuBu .q5-9 {\n    fill: rgb(54, 144, 192)\n}\n\n.PuBu .q6-9 {\n    fill: rgb(5, 112, 176)\n}\n\n.PuBu .q7-9 {\n    fill: rgb(4, 90, 141)\n}\n\n.PuBu .q8-9 {\n    fill: rgb(2, 56, 88)\n}\n\n.BuPu .q0-3 {\n    fill: rgb(224, 236, 244)\n}\n\n.BuPu .q1-3 {\n    fill: rgb(158, 188, 218)\n}\n\n.BuPu .q2-3 {\n    fill: rgb(136, 86, 167)\n}\n\n.BuPu .q0-4 {\n    fill: rgb(237, 248, 251)\n}\n\n.BuPu .q1-4 {\n    fill: rgb(179, 205, 227)\n}\n\n.BuPu .q2-4 {\n    fill: rgb(140, 150, 198)\n}\n\n.BuPu .q3-4 {\n    fill: rgb(136, 65, 157)\n}\n\n.BuPu .q0-5 {\n    fill: rgb(237, 248, 251)\n}\n\n.BuPu .q1-5 {\n    fill: rgb(179, 205, 227)\n}\n\n.BuPu .q2-5 {\n    fill: rgb(140, 150, 198)\n}\n\n.BuPu .q3-5 {\n    fill: rgb(136, 86, 167)\n}\n\n.BuPu .q4-5 {\n    fill: rgb(129, 15, 124)\n}\n\n.BuPu .q0-6 {\n    fill: rgb(237, 248, 251)\n}\n\n.BuPu .q1-6 {\n    fill: rgb(191, 211, 230)\n}\n\n.BuPu .q2-6 {\n    fill: rgb(158, 188, 218)\n}\n\n.BuPu .q3-6 {\n    fill: rgb(140, 150, 198)\n}\n\n.BuPu .q4-6 {\n    fill: rgb(136, 86, 167)\n}\n\n.BuPu .q5-6 {\n    fill: rgb(129, 15, 124)\n}\n\n.BuPu .q0-7 {\n    fill: rgb(237, 248, 251)\n}\n\n.BuPu .q1-7 {\n    fill: rgb(191, 211, 230)\n}\n\n.BuPu .q2-7 {\n    fill: rgb(158, 188, 218)\n}\n\n.BuPu .q3-7 {\n    fill: rgb(140, 150, 198)\n}\n\n.BuPu .q4-7 {\n    fill: rgb(140, 107, 177)\n}\n\n.BuPu .q5-7 {\n    fill: rgb(136, 65, 157)\n}\n\n.BuPu .q6-7 {\n    fill: rgb(110, 1, 107)\n}\n\n.BuPu .q0-8 {\n    fill: rgb(247, 252, 253)\n}\n\n.BuPu .q1-8 {\n    fill: rgb(224, 236, 244)\n}\n\n.BuPu .q2-8 {\n    fill: rgb(191, 211, 230)\n}\n\n.BuPu .q3-8 {\n    fill: rgb(158, 188, 218)\n}\n\n.BuPu .q4-8 {\n    fill: rgb(140, 150, 198)\n}\n\n.BuPu .q5-8 {\n    fill: rgb(140, 107, 177)\n}\n\n.BuPu .q6-8 {\n    fill: rgb(136, 65, 157)\n}\n\n.BuPu .q7-8 {\n    fill: rgb(110, 1, 107)\n}\n\n.BuPu .q0-9 {\n    fill: rgb(247, 252, 253)\n}\n\n.BuPu .q1-9 {\n    fill: rgb(224, 236, 244)\n}\n\n.BuPu .q2-9 {\n    fill: rgb(191, 211, 230)\n}\n\n.BuPu .q3-9 {\n    fill: rgb(158, 188, 218)\n}\n\n.BuPu .q4-9 {\n    fill: rgb(140, 150, 198)\n}\n\n.BuPu .q5-9 {\n    fill: rgb(140, 107, 177)\n}\n\n.BuPu .q6-9 {\n    fill: rgb(136, 65, 157)\n}\n\n.BuPu .q7-9 {\n    fill: rgb(129, 15, 124)\n}\n\n.BuPu .q8-9 {\n    fill: rgb(77, 0, 75)\n}\n\n.RdPu .q0-3 {\n    fill: rgb(253, 224, 221)\n}\n\n.RdPu .q1-3 {\n    fill: rgb(250, 159, 181)\n}\n\n.RdPu .q2-3 {\n    fill: rgb(197, 27, 138)\n}\n\n.RdPu .q0-4 {\n    fill: rgb(254, 235, 226)\n}\n\n.RdPu .q1-4 {\n    fill: rgb(251, 180, 185)\n}\n\n.RdPu .q2-4 {\n    fill: rgb(247, 104, 161)\n}\n\n.RdPu .q3-4 {\n    fill: rgb(174, 1, 126)\n}\n\n.RdPu .q0-5 {\n    fill: rgb(254, 235, 226)\n}\n\n.RdPu .q1-5 {\n    fill: rgb(251, 180, 185)\n}\n\n.RdPu .q2-5 {\n    fill: rgb(247, 104, 161)\n}\n\n.RdPu .q3-5 {\n    fill: rgb(197, 27, 138)\n}\n\n.RdPu .q4-5 {\n    fill: rgb(122, 1, 119)\n}\n\n.RdPu .q0-6 {\n    fill: rgb(254, 235, 226)\n}\n\n.RdPu .q1-6 {\n    fill: rgb(252, 197, 192)\n}\n\n.RdPu .q2-6 {\n    fill: rgb(250, 159, 181)\n}\n\n.RdPu .q3-6 {\n    fill: rgb(247, 104, 161)\n}\n\n.RdPu .q4-6 {\n    fill: rgb(197, 27, 138)\n}\n\n.RdPu .q5-6 {\n    fill: rgb(122, 1, 119)\n}\n\n.RdPu .q0-7 {\n    fill: rgb(254, 235, 226)\n}\n\n.RdPu .q1-7 {\n    fill: rgb(252, 197, 192)\n}\n\n.RdPu .q2-7 {\n    fill: rgb(250, 159, 181)\n}\n\n.RdPu .q3-7 {\n    fill: rgb(247, 104, 161)\n}\n\n.RdPu .q4-7 {\n    fill: rgb(221, 52, 151)\n}\n\n.RdPu .q5-7 {\n    fill: rgb(174, 1, 126)\n}\n\n.RdPu .q6-7 {\n    fill: rgb(122, 1, 119)\n}\n\n.RdPu .q0-8 {\n    fill: rgb(255, 247, 243)\n}\n\n.RdPu .q1-8 {\n    fill: rgb(253, 224, 221)\n}\n\n.RdPu .q2-8 {\n    fill: rgb(252, 197, 192)\n}\n\n.RdPu .q3-8 {\n    fill: rgb(250, 159, 181)\n}\n\n.RdPu .q4-8 {\n    fill: rgb(247, 104, 161)\n}\n\n.RdPu .q5-8 {\n    fill: rgb(221, 52, 151)\n}\n\n.RdPu .q6-8 {\n    fill: rgb(174, 1, 126)\n}\n\n.RdPu .q7-8 {\n    fill: rgb(122, 1, 119)\n}\n\n.RdPu .q0-9 {\n    fill: rgb(255, 247, 243)\n}\n\n.RdPu .q1-9 {\n    fill: rgb(253, 224, 221)\n}\n\n.RdPu .q2-9 {\n    fill: rgb(252, 197, 192)\n}\n\n.RdPu .q3-9 {\n    fill: rgb(250, 159, 181)\n}\n\n.RdPu .q4-9 {\n    fill: rgb(247, 104, 161)\n}\n\n.RdPu .q5-9 {\n    fill: rgb(221, 52, 151)\n}\n\n.RdPu .q6-9 {\n    fill: rgb(174, 1, 126)\n}\n\n.RdPu .q7-9 {\n    fill: rgb(122, 1, 119)\n}\n\n.RdPu .q8-9 {\n    fill: rgb(73, 0, 106)\n}\n\n.PuRd .q0-3 {\n    fill: rgb(231, 225, 239)\n}\n\n.PuRd .q1-3 {\n    fill: rgb(201, 148, 199)\n}\n\n.PuRd .q2-3 {\n    fill: rgb(221, 28, 119)\n}\n\n.PuRd .q0-4 {\n    fill: rgb(241, 238, 246)\n}\n\n.PuRd .q1-4 {\n    fill: rgb(215, 181, 216)\n}\n\n.PuRd .q2-4 {\n    fill: rgb(223, 101, 176)\n}\n\n.PuRd .q3-4 {\n    fill: rgb(206, 18, 86)\n}\n\n.PuRd .q0-5 {\n    fill: rgb(241, 238, 246)\n}\n\n.PuRd .q1-5 {\n    fill: rgb(215, 181, 216)\n}\n\n.PuRd .q2-5 {\n    fill: rgb(223, 101, 176)\n}\n\n.PuRd .q3-5 {\n    fill: rgb(221, 28, 119)\n}\n\n.PuRd .q4-5 {\n    fill: rgb(152, 0, 67)\n}\n\n.PuRd .q0-6 {\n    fill: rgb(241, 238, 246)\n}\n\n.PuRd .q1-6 {\n    fill: rgb(212, 185, 218)\n}\n\n.PuRd .q2-6 {\n    fill: rgb(201, 148, 199)\n}\n\n.PuRd .q3-6 {\n    fill: rgb(223, 101, 176)\n}\n\n.PuRd .q4-6 {\n    fill: rgb(221, 28, 119)\n}\n\n.PuRd .q5-6 {\n    fill: rgb(152, 0, 67)\n}\n\n.PuRd .q0-7 {\n    fill: rgb(241, 238, 246)\n}\n\n.PuRd .q1-7 {\n    fill: rgb(212, 185, 218)\n}\n\n.PuRd .q2-7 {\n    fill: rgb(201, 148, 199)\n}\n\n.PuRd .q3-7 {\n    fill: rgb(223, 101, 176)\n}\n\n.PuRd .q4-7 {\n    fill: rgb(231, 41, 138)\n}\n\n.PuRd .q5-7 {\n    fill: rgb(206, 18, 86)\n}\n\n.PuRd .q6-7 {\n    fill: rgb(145, 0, 63)\n}\n\n.PuRd .q0-8 {\n    fill: rgb(247, 244, 249)\n}\n\n.PuRd .q1-8 {\n    fill: rgb(231, 225, 239)\n}\n\n.PuRd .q2-8 {\n    fill: rgb(212, 185, 218)\n}\n\n.PuRd .q3-8 {\n    fill: rgb(201, 148, 199)\n}\n\n.PuRd .q4-8 {\n    fill: rgb(223, 101, 176)\n}\n\n.PuRd .q5-8 {\n    fill: rgb(231, 41, 138)\n}\n\n.PuRd .q6-8 {\n    fill: rgb(206, 18, 86)\n}\n\n.PuRd .q7-8 {\n    fill: rgb(145, 0, 63)\n}\n\n.PuRd .q0-9 {\n    fill: rgb(247, 244, 249)\n}\n\n.PuRd .q1-9 {\n    fill: rgb(231, 225, 239)\n}\n\n.PuRd .q2-9 {\n    fill: rgb(212, 185, 218)\n}\n\n.PuRd .q3-9 {\n    fill: rgb(201, 148, 199)\n}\n\n.PuRd .q4-9 {\n    fill: rgb(223, 101, 176)\n}\n\n.PuRd .q5-9 {\n    fill: rgb(231, 41, 138)\n}\n\n.PuRd .q6-9 {\n    fill: rgb(206, 18, 86)\n}\n\n.PuRd .q7-9 {\n    fill: rgb(152, 0, 67)\n}\n\n.PuRd .q8-9 {\n    fill: rgb(103, 0, 31)\n}\n\n.OrRd .q0-3 {\n    fill: rgb(254, 232, 200)\n}\n\n.OrRd .q1-3 {\n    fill: rgb(253, 187, 132)\n}\n\n.OrRd .q2-3 {\n    fill: rgb(227, 74, 51)\n}\n\n.OrRd .q0-4 {\n    fill: rgb(254, 240, 217)\n}\n\n.OrRd .q1-4 {\n    fill: rgb(253, 204, 138)\n}\n\n.OrRd .q2-4 {\n    fill: rgb(252, 141, 89)\n}\n\n.OrRd .q3-4 {\n    fill: rgb(215, 48, 31)\n}\n\n.OrRd .q0-5 {\n    fill: rgb(254, 240, 217)\n}\n\n.OrRd .q1-5 {\n    fill: rgb(253, 204, 138)\n}\n\n.OrRd .q2-5 {\n    fill: rgb(252, 141, 89)\n}\n\n.OrRd .q3-5 {\n    fill: rgb(227, 74, 51)\n}\n\n.OrRd .q4-5 {\n    fill: rgb(179, 0, 0)\n}\n\n.OrRd .q0-6 {\n    fill: rgb(254, 240, 217)\n}\n\n.OrRd .q1-6 {\n    fill: rgb(253, 212, 158)\n}\n\n.OrRd .q2-6 {\n    fill: rgb(253, 187, 132)\n}\n\n.OrRd .q3-6 {\n    fill: rgb(252, 141, 89)\n}\n\n.OrRd .q4-6 {\n    fill: rgb(227, 74, 51)\n}\n\n.OrRd .q5-6 {\n    fill: rgb(179, 0, 0)\n}\n\n.OrRd .q0-7 {\n    fill: rgb(254, 240, 217)\n}\n\n.OrRd .q1-7 {\n    fill: rgb(253, 212, 158)\n}\n\n.OrRd .q2-7 {\n    fill: rgb(253, 187, 132)\n}\n\n.OrRd .q3-7 {\n    fill: rgb(252, 141, 89)\n}\n\n.OrRd .q4-7 {\n    fill: rgb(239, 101, 72)\n}\n\n.OrRd .q5-7 {\n    fill: rgb(215, 48, 31)\n}\n\n.OrRd .q6-7 {\n    fill: rgb(153, 0, 0)\n}\n\n.OrRd .q0-8 {\n    fill: rgb(255, 247, 236)\n}\n\n.OrRd .q1-8 {\n    fill: rgb(254, 232, 200)\n}\n\n.OrRd .q2-8 {\n    fill: rgb(253, 212, 158)\n}\n\n.OrRd .q3-8 {\n    fill: rgb(253, 187, 132)\n}\n\n.OrRd .q4-8 {\n    fill: rgb(252, 141, 89)\n}\n\n.OrRd .q5-8 {\n    fill: rgb(239, 101, 72)\n}\n\n.OrRd .q6-8 {\n    fill: rgb(215, 48, 31)\n}\n\n.OrRd .q7-8 {\n    fill: rgb(153, 0, 0)\n}\n\n.OrRd .q0-9 {\n    fill: rgb(255, 247, 236)\n}\n\n.OrRd .q1-9 {\n    fill: rgb(254, 232, 200)\n}\n\n.OrRd .q2-9 {\n    fill: rgb(253, 212, 158)\n}\n\n.OrRd .q3-9 {\n    fill: rgb(253, 187, 132)\n}\n\n.OrRd .q4-9 {\n    fill: rgb(252, 141, 89)\n}\n\n.OrRd .q5-9 {\n    fill: rgb(239, 101, 72)\n}\n\n.OrRd .q6-9 {\n    fill: rgb(215, 48, 31)\n}\n\n.OrRd .q7-9 {\n    fill: rgb(179, 0, 0)\n}\n\n.OrRd .q8-9 {\n    fill: rgb(127, 0, 0)\n}\n\n.YlOrRd .q0-3 {\n    fill: rgb(255, 237, 160)\n}\n\n.YlOrRd .q1-3 {\n    fill: rgb(254, 178, 76)\n}\n\n.YlOrRd .q2-3 {\n    fill: rgb(240, 59, 32)\n}\n\n.YlOrRd .q0-4 {\n    fill: rgb(255, 255, 178)\n}\n\n.YlOrRd .q1-4 {\n    fill: rgb(254, 204, 92)\n}\n\n.YlOrRd .q2-4 {\n    fill: rgb(253, 141, 60)\n}\n\n.YlOrRd .q3-4 {\n    fill: rgb(227, 26, 28)\n}\n\n.YlOrRd .q0-5 {\n    fill: rgb(255, 255, 178)\n}\n\n.YlOrRd .q1-5 {\n    fill: rgb(254, 204, 92)\n}\n\n.YlOrRd .q2-5 {\n    fill: rgb(253, 141, 60)\n}\n\n.YlOrRd .q3-5 {\n    fill: rgb(240, 59, 32)\n}\n\n.YlOrRd .q4-5 {\n    fill: rgb(189, 0, 38)\n}\n\n.YlOrRd .q0-6 {\n    fill: rgb(255, 255, 178)\n}\n\n.YlOrRd .q1-6 {\n    fill: rgb(254, 217, 118)\n}\n\n.YlOrRd .q2-6 {\n    fill: rgb(254, 178, 76)\n}\n\n.YlOrRd .q3-6 {\n    fill: rgb(253, 141, 60)\n}\n\n.YlOrRd .q4-6 {\n    fill: rgb(240, 59, 32)\n}\n\n.YlOrRd .q5-6 {\n    fill: rgb(189, 0, 38)\n}\n\n.YlOrRd .q0-7 {\n    fill: rgb(255, 255, 178)\n}\n\n.YlOrRd .q1-7 {\n    fill: rgb(254, 217, 118)\n}\n\n.YlOrRd .q2-7 {\n    fill: rgb(254, 178, 76)\n}\n\n.YlOrRd .q3-7 {\n    fill: rgb(253, 141, 60)\n}\n\n.YlOrRd .q4-7 {\n    fill: rgb(252, 78, 42)\n}\n\n.YlOrRd .q5-7 {\n    fill: rgb(227, 26, 28)\n}\n\n.YlOrRd .q6-7 {\n    fill: rgb(177, 0, 38)\n}\n\n.YlOrRd .q0-8 {\n    fill: rgb(255, 255, 204)\n}\n\n.YlOrRd .q1-8 {\n    fill: rgb(255, 237, 160)\n}\n\n.YlOrRd .q2-8 {\n    fill: rgb(254, 217, 118)\n}\n\n.YlOrRd .q3-8 {\n    fill: rgb(254, 178, 76)\n}\n\n.YlOrRd .q4-8 {\n    fill: rgb(253, 141, 60)\n}\n\n.YlOrRd .q5-8 {\n    fill: rgb(252, 78, 42)\n}\n\n.YlOrRd .q6-8 {\n    fill: rgb(227, 26, 28)\n}\n\n.YlOrRd .q7-8 {\n    fill: rgb(177, 0, 38)\n}\n\n.YlOrRd .q0-9 {\n    fill: rgb(255, 255, 204)\n}\n\n.YlOrRd .q1-9 {\n    fill: rgb(255, 237, 160)\n}\n\n.YlOrRd .q2-9 {\n    fill: rgb(254, 217, 118)\n}\n\n.YlOrRd .q3-9 {\n    fill: rgb(254, 178, 76)\n}\n\n.YlOrRd .q4-9 {\n    fill: rgb(253, 141, 60)\n}\n\n.YlOrRd .q5-9 {\n    fill: rgb(252, 78, 42)\n}\n\n.YlOrRd .q6-9 {\n    fill: rgb(227, 26, 28)\n}\n\n.YlOrRd .q7-9 {\n    fill: rgb(189, 0, 38)\n}\n\n.YlOrRd .q8-9 {\n    fill: rgb(128, 0, 38)\n}\n\n.YlOrBr .q0-3 {\n    fill: rgb(255, 247, 188)\n}\n\n.YlOrBr .q1-3 {\n    fill: rgb(254, 196, 79)\n}\n\n.YlOrBr .q2-3 {\n    fill: rgb(217, 95, 14)\n}\n\n.YlOrBr .q0-4 {\n    fill: rgb(255, 255, 212)\n}\n\n.YlOrBr .q1-4 {\n    fill: rgb(254, 217, 142)\n}\n\n.YlOrBr .q2-4 {\n    fill: rgb(254, 153, 41)\n}\n\n.YlOrBr .q3-4 {\n    fill: rgb(204, 76, 2)\n}\n\n.YlOrBr .q0-5 {\n    fill: rgb(255, 255, 212)\n}\n\n.YlOrBr .q1-5 {\n    fill: rgb(254, 217, 142)\n}\n\n.YlOrBr .q2-5 {\n    fill: rgb(254, 153, 41)\n}\n\n.YlOrBr .q3-5 {\n    fill: rgb(217, 95, 14)\n}\n\n.YlOrBr .q4-5 {\n    fill: rgb(153, 52, 4)\n}\n\n.YlOrBr .q0-6 {\n    fill: rgb(255, 255, 212)\n}\n\n.YlOrBr .q1-6 {\n    fill: rgb(254, 227, 145)\n}\n\n.YlOrBr .q2-6 {\n    fill: rgb(254, 196, 79)\n}\n\n.YlOrBr .q3-6 {\n    fill: rgb(254, 153, 41)\n}\n\n.YlOrBr .q4-6 {\n    fill: rgb(217, 95, 14)\n}\n\n.YlOrBr .q5-6 {\n    fill: rgb(153, 52, 4)\n}\n\n.YlOrBr .q0-7 {\n    fill: rgb(255, 255, 212)\n}\n\n.YlOrBr .q1-7 {\n    fill: rgb(254, 227, 145)\n}\n\n.YlOrBr .q2-7 {\n    fill: rgb(254, 196, 79)\n}\n\n.YlOrBr .q3-7 {\n    fill: rgb(254, 153, 41)\n}\n\n.YlOrBr .q4-7 {\n    fill: rgb(236, 112, 20)\n}\n\n.YlOrBr .q5-7 {\n    fill: rgb(204, 76, 2)\n}\n\n.YlOrBr .q6-7 {\n    fill: rgb(140, 45, 4)\n}\n\n.YlOrBr .q0-8 {\n    fill: rgb(255, 255, 229)\n}\n\n.YlOrBr .q1-8 {\n    fill: rgb(255, 247, 188)\n}\n\n.YlOrBr .q2-8 {\n    fill: rgb(254, 227, 145)\n}\n\n.YlOrBr .q3-8 {\n    fill: rgb(254, 196, 79)\n}\n\n.YlOrBr .q4-8 {\n    fill: rgb(254, 153, 41)\n}\n\n.YlOrBr .q5-8 {\n    fill: rgb(236, 112, 20)\n}\n\n.YlOrBr .q6-8 {\n    fill: rgb(204, 76, 2)\n}\n\n.YlOrBr .q7-8 {\n    fill: rgb(140, 45, 4)\n}\n\n.YlOrBr .q0-9 {\n    fill: rgb(255, 255, 229)\n}\n\n.YlOrBr .q1-9 {\n    fill: rgb(255, 247, 188)\n}\n\n.YlOrBr .q2-9 {\n    fill: rgb(254, 227, 145)\n}\n\n.YlOrBr .q3-9 {\n    fill: rgb(254, 196, 79)\n}\n\n.YlOrBr .q4-9 {\n    fill: rgb(254, 153, 41)\n}\n\n.YlOrBr .q5-9 {\n    fill: rgb(236, 112, 20)\n}\n\n.YlOrBr .q6-9 {\n    fill: rgb(204, 76, 2)\n}\n\n.YlOrBr .q7-9 {\n    fill: rgb(153, 52, 4)\n}\n\n.YlOrBr .q8-9 {\n    fill: rgb(102, 37, 6)\n}\n\n.Purples .q0-3 {\n    fill: rgb(239, 237, 245)\n}\n\n.Purples .q1-3 {\n    fill: rgb(188, 189, 220)\n}\n\n.Purples .q2-3 {\n    fill: rgb(117, 107, 177)\n}\n\n.Purples .q0-4 {\n    fill: rgb(242, 240, 247)\n}\n\n.Purples .q1-4 {\n    fill: rgb(203, 201, 226)\n}\n\n.Purples .q2-4 {\n    fill: rgb(158, 154, 200)\n}\n\n.Purples .q3-4 {\n    fill: rgb(106, 81, 163)\n}\n\n.Purples .q0-5 {\n    fill: rgb(242, 240, 247)\n}\n\n.Purples .q1-5 {\n    fill: rgb(203, 201, 226)\n}\n\n.Purples .q2-5 {\n    fill: rgb(158, 154, 200)\n}\n\n.Purples .q3-5 {\n    fill: rgb(117, 107, 177)\n}\n\n.Purples .q4-5 {\n    fill: rgb(84, 39, 143)\n}\n\n.Purples .q0-6 {\n    fill: rgb(242, 240, 247)\n}\n\n.Purples .q1-6 {\n    fill: rgb(218, 218, 235)\n}\n\n.Purples .q2-6 {\n    fill: rgb(188, 189, 220)\n}\n\n.Purples .q3-6 {\n    fill: rgb(158, 154, 200)\n}\n\n.Purples .q4-6 {\n    fill: rgb(117, 107, 177)\n}\n\n.Purples .q5-6 {\n    fill: rgb(84, 39, 143)\n}\n\n.Purples .q0-7 {\n    fill: rgb(242, 240, 247)\n}\n\n.Purples .q1-7 {\n    fill: rgb(218, 218, 235)\n}\n\n.Purples .q2-7 {\n    fill: rgb(188, 189, 220)\n}\n\n.Purples .q3-7 {\n    fill: rgb(158, 154, 200)\n}\n\n.Purples .q4-7 {\n    fill: rgb(128, 125, 186)\n}\n\n.Purples .q5-7 {\n    fill: rgb(106, 81, 163)\n}\n\n.Purples .q6-7 {\n    fill: rgb(74, 20, 134)\n}\n\n.Purples .q0-8 {\n    fill: rgb(252, 251, 253)\n}\n\n.Purples .q1-8 {\n    fill: rgb(239, 237, 245)\n}\n\n.Purples .q2-8 {\n    fill: rgb(218, 218, 235)\n}\n\n.Purples .q3-8 {\n    fill: rgb(188, 189, 220)\n}\n\n.Purples .q4-8 {\n    fill: rgb(158, 154, 200)\n}\n\n.Purples .q5-8 {\n    fill: rgb(128, 125, 186)\n}\n\n.Purples .q6-8 {\n    fill: rgb(106, 81, 163)\n}\n\n.Purples .q7-8 {\n    fill: rgb(74, 20, 134)\n}\n\n.Purples .q0-9 {\n    fill: rgb(252, 251, 253)\n}\n\n.Purples .q1-9 {\n    fill: rgb(239, 237, 245)\n}\n\n.Purples .q2-9 {\n    fill: rgb(218, 218, 235)\n}\n\n.Purples .q3-9 {\n    fill: rgb(188, 189, 220)\n}\n\n.Purples .q4-9 {\n    fill: rgb(158, 154, 200)\n}\n\n.Purples .q5-9 {\n    fill: rgb(128, 125, 186)\n}\n\n.Purples .q6-9 {\n    fill: rgb(106, 81, 163)\n}\n\n.Purples .q7-9 {\n    fill: rgb(84, 39, 143)\n}\n\n.Purples .q8-9 {\n    fill: rgb(63, 0, 125)\n}\n\n.Blues .q0-3 {\n    fill: rgb(222, 235, 247)\n}\n\n.Blues .q1-3 {\n    fill: rgb(158, 202, 225)\n}\n\n.Blues .q2-3 {\n    fill: rgb(49, 130, 189)\n}\n\n.Blues .q0-4 {\n    fill: rgb(239, 243, 255)\n}\n\n.Blues .q1-4 {\n    fill: rgb(189, 215, 231)\n}\n\n.Blues .q2-4 {\n    fill: rgb(107, 174, 214)\n}\n\n.Blues .q3-4 {\n    fill: rgb(33, 113, 181)\n}\n\n.Blues .q0-5 {\n    fill: rgb(239, 243, 255)\n}\n\n.Blues .q1-5 {\n    fill: rgb(189, 215, 231)\n}\n\n.Blues .q2-5 {\n    fill: rgb(107, 174, 214)\n}\n\n.Blues .q3-5 {\n    fill: rgb(49, 130, 189)\n}\n\n.Blues .q4-5 {\n    fill: rgb(8, 81, 156)\n}\n\n.Blues .q0-6 {\n    fill: rgb(239, 243, 255)\n}\n\n.Blues .q1-6 {\n    fill: rgb(198, 219, 239)\n}\n\n.Blues .q2-6 {\n    fill: rgb(158, 202, 225)\n}\n\n.Blues .q3-6 {\n    fill: rgb(107, 174, 214)\n}\n\n.Blues .q4-6 {\n    fill: rgb(49, 130, 189)\n}\n\n.Blues .q5-6 {\n    fill: rgb(8, 81, 156)\n}\n\n.Blues .q0-7 {\n    fill: rgb(239, 243, 255)\n}\n\n.Blues .q1-7 {\n    fill: rgb(198, 219, 239)\n}\n\n.Blues .q2-7 {\n    fill: rgb(158, 202, 225)\n}\n\n.Blues .q3-7 {\n    fill: rgb(107, 174, 214)\n}\n\n.Blues .q4-7 {\n    fill: rgb(66, 146, 198)\n}\n\n.Blues .q5-7 {\n    fill: rgb(33, 113, 181)\n}\n\n.Blues .q6-7 {\n    fill: rgb(8, 69, 148)\n}\n\n.Blues .q0-8 {\n    fill: rgb(247, 251, 255)\n}\n\n.Blues .q1-8 {\n    fill: rgb(222, 235, 247)\n}\n\n.Blues .q2-8 {\n    fill: rgb(198, 219, 239)\n}\n\n.Blues .q3-8 {\n    fill: rgb(158, 202, 225)\n}\n\n.Blues .q4-8 {\n    fill: rgb(107, 174, 214)\n}\n\n.Blues .q5-8 {\n    fill: rgb(66, 146, 198)\n}\n\n.Blues .q6-8 {\n    fill: rgb(33, 113, 181)\n}\n\n.Blues .q7-8 {\n    fill: rgb(8, 69, 148)\n}\n\n.Blues .q0-9 {\n    fill: rgb(247, 251, 255)\n}\n\n.Blues .q1-9 {\n    fill: rgb(222, 235, 247)\n}\n\n.Blues .q2-9 {\n    fill: rgb(198, 219, 239)\n}\n\n.Blues .q3-9 {\n    fill: rgb(158, 202, 225)\n}\n\n.Blues .q4-9 {\n    fill: rgb(107, 174, 214)\n}\n\n.Blues .q5-9 {\n    fill: rgb(66, 146, 198)\n}\n\n.Blues .q6-9 {\n    fill: rgb(33, 113, 181)\n}\n\n.Blues .q7-9 {\n    fill: rgb(8, 81, 156)\n}\n\n.Blues .q8-9 {\n    fill: rgb(8, 48, 107)\n}\n\n.Greens .q0-3 {\n    fill: rgb(229, 245, 224)\n}\n\n.Greens .q1-3 {\n    fill: rgb(161, 217, 155)\n}\n\n.Greens .q2-3 {\n    fill: rgb(49, 163, 84)\n}\n\n.Greens .q0-4 {\n    fill: rgb(237, 248, 233)\n}\n\n.Greens .q1-4 {\n    fill: rgb(186, 228, 179)\n}\n\n.Greens .q2-4 {\n    fill: rgb(116, 196, 118)\n}\n\n.Greens .q3-4 {\n    fill: rgb(35, 139, 69)\n}\n\n.Greens .q0-5 {\n    fill: rgb(237, 248, 233)\n}\n\n.Greens .q1-5 {\n    fill: rgb(186, 228, 179)\n}\n\n.Greens .q2-5 {\n    fill: rgb(116, 196, 118)\n}\n\n.Greens .q3-5 {\n    fill: rgb(49, 163, 84)\n}\n\n.Greens .q4-5 {\n    fill: rgb(0, 109, 44)\n}\n\n.Greens .q0-6 {\n    fill: rgb(237, 248, 233)\n}\n\n.Greens .q1-6 {\n    fill: rgb(199, 233, 192)\n}\n\n.Greens .q2-6 {\n    fill: rgb(161, 217, 155)\n}\n\n.Greens .q3-6 {\n    fill: rgb(116, 196, 118)\n}\n\n.Greens .q4-6 {\n    fill: rgb(49, 163, 84)\n}\n\n.Greens .q5-6 {\n    fill: rgb(0, 109, 44)\n}\n\n.Greens .q0-7 {\n    fill: rgb(237, 248, 233)\n}\n\n.Greens .q1-7 {\n    fill: rgb(199, 233, 192)\n}\n\n.Greens .q2-7 {\n    fill: rgb(161, 217, 155)\n}\n\n.Greens .q3-7 {\n    fill: rgb(116, 196, 118)\n}\n\n.Greens .q4-7 {\n    fill: rgb(65, 171, 93)\n}\n\n.Greens .q5-7 {\n    fill: rgb(35, 139, 69)\n}\n\n.Greens .q6-7 {\n    fill: rgb(0, 90, 50)\n}\n\n.Greens .q0-8 {\n    fill: rgb(247, 252, 245)\n}\n\n.Greens .q1-8 {\n    fill: rgb(229, 245, 224)\n}\n\n.Greens .q2-8 {\n    fill: rgb(199, 233, 192)\n}\n\n.Greens .q3-8 {\n    fill: rgb(161, 217, 155)\n}\n\n.Greens .q4-8 {\n    fill: rgb(116, 196, 118)\n}\n\n.Greens .q5-8 {\n    fill: rgb(65, 171, 93)\n}\n\n.Greens .q6-8 {\n    fill: rgb(35, 139, 69)\n}\n\n.Greens .q7-8 {\n    fill: rgb(0, 90, 50)\n}\n\n.Greens .q0-9 {\n    fill: rgb(247, 252, 245)\n}\n\n.Greens .q1-9 {\n    fill: rgb(229, 245, 224)\n}\n\n.Greens .q2-9 {\n    fill: rgb(199, 233, 192)\n}\n\n.Greens .q3-9 {\n    fill: rgb(161, 217, 155)\n}\n\n.Greens .q4-9 {\n    fill: rgb(116, 196, 118)\n}\n\n.Greens .q5-9 {\n    fill: rgb(65, 171, 93)\n}\n\n.Greens .q6-9 {\n    fill: rgb(35, 139, 69)\n}\n\n.Greens .q7-9 {\n    fill: rgb(0, 109, 44)\n}\n\n.Greens .q8-9 {\n    fill: rgb(0, 68, 27)\n}\n\n.Oranges .q0-3 {\n    fill: rgb(254, 230, 206)\n}\n\n.Oranges .q1-3 {\n    fill: rgb(253, 174, 107)\n}\n\n.Oranges .q2-3 {\n    fill: rgb(230, 85, 13)\n}\n\n.Oranges .q0-4 {\n    fill: rgb(254, 237, 222)\n}\n\n.Oranges .q1-4 {\n    fill: rgb(253, 190, 133)\n}\n\n.Oranges .q2-4 {\n    fill: rgb(253, 141, 60)\n}\n\n.Oranges .q3-4 {\n    fill: rgb(217, 71, 1)\n}\n\n.Oranges .q0-5 {\n    fill: rgb(254, 237, 222)\n}\n\n.Oranges .q1-5 {\n    fill: rgb(253, 190, 133)\n}\n\n.Oranges .q2-5 {\n    fill: rgb(253, 141, 60)\n}\n\n.Oranges .q3-5 {\n    fill: rgb(230, 85, 13)\n}\n\n.Oranges .q4-5 {\n    fill: rgb(166, 54, 3)\n}\n\n.Oranges .q0-6 {\n    fill: rgb(254, 237, 222)\n}\n\n.Oranges .q1-6 {\n    fill: rgb(253, 208, 162)\n}\n\n.Oranges .q2-6 {\n    fill: rgb(253, 174, 107)\n}\n\n.Oranges .q3-6 {\n    fill: rgb(253, 141, 60)\n}\n\n.Oranges .q4-6 {\n    fill: rgb(230, 85, 13)\n}\n\n.Oranges .q5-6 {\n    fill: rgb(166, 54, 3)\n}\n\n.Oranges .q0-7 {\n    fill: rgb(254, 237, 222)\n}\n\n.Oranges .q1-7 {\n    fill: rgb(253, 208, 162)\n}\n\n.Oranges .q2-7 {\n    fill: rgb(253, 174, 107)\n}\n\n.Oranges .q3-7 {\n    fill: rgb(253, 141, 60)\n}\n\n.Oranges .q4-7 {\n    fill: rgb(241, 105, 19)\n}\n\n.Oranges .q5-7 {\n    fill: rgb(217, 72, 1)\n}\n\n.Oranges .q6-7 {\n    fill: rgb(140, 45, 4)\n}\n\n.Oranges .q0-8 {\n    fill: rgb(255, 245, 235)\n}\n\n.Oranges .q1-8 {\n    fill: rgb(254, 230, 206)\n}\n\n.Oranges .q2-8 {\n    fill: rgb(253, 208, 162)\n}\n\n.Oranges .q3-8 {\n    fill: rgb(253, 174, 107)\n}\n\n.Oranges .q4-8 {\n    fill: rgb(253, 141, 60)\n}\n\n.Oranges .q5-8 {\n    fill: rgb(241, 105, 19)\n}\n\n.Oranges .q6-8 {\n    fill: rgb(217, 72, 1)\n}\n\n.Oranges .q7-8 {\n    fill: rgb(140, 45, 4)\n}\n\n.Oranges .q0-9 {\n    fill: rgb(255, 245, 235)\n}\n\n.Oranges .q1-9 {\n    fill: rgb(254, 230, 206)\n}\n\n.Oranges .q2-9 {\n    fill: rgb(253, 208, 162)\n}\n\n.Oranges .q3-9 {\n    fill: rgb(253, 174, 107)\n}\n\n.Oranges .q4-9 {\n    fill: rgb(253, 141, 60)\n}\n\n.Oranges .q5-9 {\n    fill: rgb(241, 105, 19)\n}\n\n.Oranges .q6-9 {\n    fill: rgb(217, 72, 1)\n}\n\n.Oranges .q7-9 {\n    fill: rgb(166, 54, 3)\n}\n\n.Oranges .q8-9 {\n    fill: rgb(127, 39, 4)\n}\n\n.Reds .q0-3 {\n    fill: rgb(254, 224, 210)\n}\n\n.Reds .q1-3 {\n    fill: rgb(252, 146, 114)\n}\n\n.Reds .q2-3 {\n    fill: rgb(222, 45, 38)\n}\n\n.Reds .q0-4 {\n    fill: rgb(254, 229, 217)\n}\n\n.Reds .q1-4 {\n    fill: rgb(252, 174, 145)\n}\n\n.Reds .q2-4 {\n    fill: rgb(251, 106, 74)\n}\n\n.Reds .q3-4 {\n    fill: rgb(203, 24, 29)\n}\n\n.Reds .q0-5 {\n    fill: rgb(254, 229, 217)\n}\n\n.Reds .q1-5 {\n    fill: rgb(252, 174, 145)\n}\n\n.Reds .q2-5 {\n    fill: rgb(251, 106, 74)\n}\n\n.Reds .q3-5 {\n    fill: rgb(222, 45, 38)\n}\n\n.Reds .q4-5 {\n    fill: rgb(165, 15, 21)\n}\n\n.Reds .q0-6 {\n    fill: rgb(254, 229, 217)\n}\n\n.Reds .q1-6 {\n    fill: rgb(252, 187, 161)\n}\n\n.Reds .q2-6 {\n    fill: rgb(252, 146, 114)\n}\n\n.Reds .q3-6 {\n    fill: rgb(251, 106, 74)\n}\n\n.Reds .q4-6 {\n    fill: rgb(222, 45, 38)\n}\n\n.Reds .q5-6 {\n    fill: rgb(165, 15, 21)\n}\n\n.Reds .q0-7 {\n    fill: rgb(254, 229, 217)\n}\n\n.Reds .q1-7 {\n    fill: rgb(252, 187, 161)\n}\n\n.Reds .q2-7 {\n    fill: rgb(252, 146, 114)\n}\n\n.Reds .q3-7 {\n    fill: rgb(251, 106, 74)\n}\n\n.Reds .q4-7 {\n    fill: rgb(239, 59, 44)\n}\n\n.Reds .q5-7 {\n    fill: rgb(203, 24, 29)\n}\n\n.Reds .q6-7 {\n    fill: rgb(153, 0, 13)\n}\n\n.Reds .q0-8 {\n    fill: rgb(255, 245, 240)\n}\n\n.Reds .q1-8 {\n    fill: rgb(254, 224, 210)\n}\n\n.Reds .q2-8 {\n    fill: rgb(252, 187, 161)\n}\n\n.Reds .q3-8 {\n    fill: rgb(252, 146, 114)\n}\n\n.Reds .q4-8 {\n    fill: rgb(251, 106, 74)\n}\n\n.Reds .q5-8 {\n    fill: rgb(239, 59, 44)\n}\n\n.Reds .q6-8 {\n    fill: rgb(203, 24, 29)\n}\n\n.Reds .q7-8 {\n    fill: rgb(153, 0, 13)\n}\n\n.Reds .q0-9 {\n    fill: rgb(255, 245, 240)\n}\n\n.Reds .q1-9 {\n    fill: rgb(254, 224, 210)\n}\n\n.Reds .q2-9 {\n    fill: rgb(252, 187, 161)\n}\n\n.Reds .q3-9 {\n    fill: rgb(252, 146, 114)\n}\n\n.Reds .q4-9 {\n    fill: rgb(251, 106, 74)\n}\n\n.Reds .q5-9 {\n    fill: rgb(239, 59, 44)\n}\n\n.Reds .q6-9 {\n    fill: rgb(203, 24, 29)\n}\n\n.Reds .q7-9 {\n    fill: rgb(165, 15, 21)\n}\n\n.Reds .q8-9 {\n    fill: rgb(103, 0, 13)\n}\n\n.Greys .q0-3 {\n    fill: rgb(240, 240, 240)\n}\n\n.Greys .q1-3 {\n    fill: rgb(189, 189, 189)\n}\n\n.Greys .q2-3 {\n    fill: rgb(99, 99, 99)\n}\n\n.Greys .q0-4 {\n    fill: rgb(247, 247, 247)\n}\n\n.Greys .q1-4 {\n    fill: rgb(204, 204, 204)\n}\n\n.Greys .q2-4 {\n    fill: rgb(150, 150, 150)\n}\n\n.Greys .q3-4 {\n    fill: rgb(82, 82, 82)\n}\n\n.Greys .q0-5 {\n    fill: rgb(247, 247, 247)\n}\n\n.Greys .q1-5 {\n    fill: rgb(204, 204, 204)\n}\n\n.Greys .q2-5 {\n    fill: rgb(150, 150, 150)\n}\n\n.Greys .q3-5 {\n    fill: rgb(99, 99, 99)\n}\n\n.Greys .q4-5 {\n    fill: rgb(37, 37, 37)\n}\n\n.Greys .q0-6 {\n    fill: rgb(247, 247, 247)\n}\n\n.Greys .q1-6 {\n    fill: rgb(217, 217, 217)\n}\n\n.Greys .q2-6 {\n    fill: rgb(189, 189, 189)\n}\n\n.Greys .q3-6 {\n    fill: rgb(150, 150, 150)\n}\n\n.Greys .q4-6 {\n    fill: rgb(99, 99, 99)\n}\n\n.Greys .q5-6 {\n    fill: rgb(37, 37, 37)\n}\n\n.Greys .q0-7 {\n    fill: rgb(247, 247, 247)\n}\n\n.Greys .q1-7 {\n    fill: rgb(217, 217, 217)\n}\n\n.Greys .q2-7 {\n    fill: rgb(189, 189, 189)\n}\n\n.Greys .q3-7 {\n    fill: rgb(150, 150, 150)\n}\n\n.Greys .q4-7 {\n    fill: rgb(115, 115, 115)\n}\n\n.Greys .q5-7 {\n    fill: rgb(82, 82, 82)\n}\n\n.Greys .q6-7 {\n    fill: rgb(37, 37, 37)\n}\n\n.Greys .q0-8 {\n    fill: rgb(255, 255, 255)\n}\n\n.Greys .q1-8 {\n    fill: rgb(240, 240, 240)\n}\n\n.Greys .q2-8 {\n    fill: rgb(217, 217, 217)\n}\n\n.Greys .q3-8 {\n    fill: rgb(189, 189, 189)\n}\n\n.Greys .q4-8 {\n    fill: rgb(150, 150, 150)\n}\n\n.Greys .q5-8 {\n    fill: rgb(115, 115, 115)\n}\n\n.Greys .q6-8 {\n    fill: rgb(82, 82, 82)\n}\n\n.Greys .q7-8 {\n    fill: rgb(37, 37, 37)\n}\n\n.Greys .q0-9 {\n    fill: rgb(255, 255, 255)\n}\n\n.Greys .q1-9 {\n    fill: rgb(240, 240, 240)\n}\n\n.Greys .q2-9 {\n    fill: rgb(217, 217, 217)\n}\n\n.Greys .q3-9 {\n    fill: rgb(189, 189, 189)\n}\n\n.Greys .q4-9 {\n    fill: rgb(150, 150, 150)\n}\n\n.Greys .q5-9 {\n    fill: rgb(115, 115, 115)\n}\n\n.Greys .q6-9 {\n    fill: rgb(82, 82, 82)\n}\n\n.Greys .q7-9 {\n    fill: rgb(37, 37, 37)\n}\n\n.Greys .q8-9 {\n    fill: rgb(0, 0, 0)\n}\n\n.PuOr .q0-3 {\n    fill: rgb(241, 163, 64)\n}\n\n.PuOr .q1-3 {\n    fill: rgb(247, 247, 247)\n}\n\n.PuOr .q2-3 {\n    fill: rgb(153, 142, 195)\n}\n\n.PuOr .q0-4 {\n    fill: rgb(230, 97, 1)\n}\n\n.PuOr .q1-4 {\n    fill: rgb(253, 184, 99)\n}\n\n.PuOr .q2-4 {\n    fill: rgb(178, 171, 210)\n}\n\n.PuOr .q3-4 {\n    fill: rgb(94, 60, 153)\n}\n\n.PuOr .q0-5 {\n    fill: rgb(230, 97, 1)\n}\n\n.PuOr .q1-5 {\n    fill: rgb(253, 184, 99)\n}\n\n.PuOr .q2-5 {\n    fill: rgb(247, 247, 247)\n}\n\n.PuOr .q3-5 {\n    fill: rgb(178, 171, 210)\n}\n\n.PuOr .q4-5 {\n    fill: rgb(94, 60, 153)\n}\n\n.PuOr .q0-6 {\n    fill: rgb(179, 88, 6)\n}\n\n.PuOr .q1-6 {\n    fill: rgb(241, 163, 64)\n}\n\n.PuOr .q2-6 {\n    fill: rgb(254, 224, 182)\n}\n\n.PuOr .q3-6 {\n    fill: rgb(216, 218, 235)\n}\n\n.PuOr .q4-6 {\n    fill: rgb(153, 142, 195)\n}\n\n.PuOr .q5-6 {\n    fill: rgb(84, 39, 136)\n}\n\n.PuOr .q0-7 {\n    fill: rgb(179, 88, 6)\n}\n\n.PuOr .q1-7 {\n    fill: rgb(241, 163, 64)\n}\n\n.PuOr .q2-7 {\n    fill: rgb(254, 224, 182)\n}\n\n.PuOr .q3-7 {\n    fill: rgb(247, 247, 247)\n}\n\n.PuOr .q4-7 {\n    fill: rgb(216, 218, 235)\n}\n\n.PuOr .q5-7 {\n    fill: rgb(153, 142, 195)\n}\n\n.PuOr .q6-7 {\n    fill: rgb(84, 39, 136)\n}\n\n.PuOr .q0-8 {\n    fill: rgb(179, 88, 6)\n}\n\n.PuOr .q1-8 {\n    fill: rgb(224, 130, 20)\n}\n\n.PuOr .q2-8 {\n    fill: rgb(253, 184, 99)\n}\n\n.PuOr .q3-8 {\n    fill: rgb(254, 224, 182)\n}\n\n.PuOr .q4-8 {\n    fill: rgb(216, 218, 235)\n}\n\n.PuOr .q5-8 {\n    fill: rgb(178, 171, 210)\n}\n\n.PuOr .q6-8 {\n    fill: rgb(128, 115, 172)\n}\n\n.PuOr .q7-8 {\n    fill: rgb(84, 39, 136)\n}\n\n.PuOr .q0-9 {\n    fill: rgb(179, 88, 6)\n}\n\n.PuOr .q1-9 {\n    fill: rgb(224, 130, 20)\n}\n\n.PuOr .q2-9 {\n    fill: rgb(253, 184, 99)\n}\n\n.PuOr .q3-9 {\n    fill: rgb(254, 224, 182)\n}\n\n.PuOr .q4-9 {\n    fill: rgb(247, 247, 247)\n}\n\n.PuOr .q5-9 {\n    fill: rgb(216, 218, 235)\n}\n\n.PuOr .q6-9 {\n    fill: rgb(178, 171, 210)\n}\n\n.PuOr .q7-9 {\n    fill: rgb(128, 115, 172)\n}\n\n.PuOr .q8-9 {\n    fill: rgb(84, 39, 136)\n}\n\n.PuOr .q0-10 {\n    fill: rgb(127, 59, 8)\n}\n\n.PuOr .q1-10 {\n    fill: rgb(179, 88, 6)\n}\n\n.PuOr .q2-10 {\n    fill: rgb(224, 130, 20)\n}\n\n.PuOr .q3-10 {\n    fill: rgb(253, 184, 99)\n}\n\n.PuOr .q4-10 {\n    fill: rgb(254, 224, 182)\n}\n\n.PuOr .q5-10 {\n    fill: rgb(216, 218, 235)\n}\n\n.PuOr .q6-10 {\n    fill: rgb(178, 171, 210)\n}\n\n.PuOr .q7-10 {\n    fill: rgb(128, 115, 172)\n}\n\n.PuOr .q8-10 {\n    fill: rgb(84, 39, 136)\n}\n\n.PuOr .q9-10 {\n    fill: rgb(45, 0, 75)\n}\n\n.PuOr .q0-11 {\n    fill: rgb(127, 59, 8)\n}\n\n.PuOr .q1-11 {\n    fill: rgb(179, 88, 6)\n}\n\n.PuOr .q2-11 {\n    fill: rgb(224, 130, 20)\n}\n\n.PuOr .q3-11 {\n    fill: rgb(253, 184, 99)\n}\n\n.PuOr .q4-11 {\n    fill: rgb(254, 224, 182)\n}\n\n.PuOr .q5-11 {\n    fill: rgb(247, 247, 247)\n}\n\n.PuOr .q6-11 {\n    fill: rgb(216, 218, 235)\n}\n\n.PuOr .q7-11 {\n    fill: rgb(178, 171, 210)\n}\n\n.PuOr .q8-11 {\n    fill: rgb(128, 115, 172)\n}\n\n.PuOr .q9-11 {\n    fill: rgb(84, 39, 136)\n}\n\n.PuOr .q10-11 {\n    fill: rgb(45, 0, 75)\n}\n\n.BrBG .q0-3 {\n    fill: rgb(216, 179, 101)\n}\n\n.BrBG .q1-3 {\n    fill: rgb(245, 245, 245)\n}\n\n.BrBG .q2-3 {\n    fill: rgb(90, 180, 172)\n}\n\n.BrBG .q0-4 {\n    fill: rgb(166, 97, 26)\n}\n\n.BrBG .q1-4 {\n    fill: rgb(223, 194, 125)\n}\n\n.BrBG .q2-4 {\n    fill: rgb(128, 205, 193)\n}\n\n.BrBG .q3-4 {\n    fill: rgb(1, 133, 113)\n}\n\n.BrBG .q0-5 {\n    fill: rgb(166, 97, 26)\n}\n\n.BrBG .q1-5 {\n    fill: rgb(223, 194, 125)\n}\n\n.BrBG .q2-5 {\n    fill: rgb(245, 245, 245)\n}\n\n.BrBG .q3-5 {\n    fill: rgb(128, 205, 193)\n}\n\n.BrBG .q4-5 {\n    fill: rgb(1, 133, 113)\n}\n\n.BrBG .q0-6 {\n    fill: rgb(140, 81, 10)\n}\n\n.BrBG .q1-6 {\n    fill: rgb(216, 179, 101)\n}\n\n.BrBG .q2-6 {\n    fill: rgb(246, 232, 195)\n}\n\n.BrBG .q3-6 {\n    fill: rgb(199, 234, 229)\n}\n\n.BrBG .q4-6 {\n    fill: rgb(90, 180, 172)\n}\n\n.BrBG .q5-6 {\n    fill: rgb(1, 102, 94)\n}\n\n.BrBG .q0-7 {\n    fill: rgb(140, 81, 10)\n}\n\n.BrBG .q1-7 {\n    fill: rgb(216, 179, 101)\n}\n\n.BrBG .q2-7 {\n    fill: rgb(246, 232, 195)\n}\n\n.BrBG .q3-7 {\n    fill: rgb(245, 245, 245)\n}\n\n.BrBG .q4-7 {\n    fill: rgb(199, 234, 229)\n}\n\n.BrBG .q5-7 {\n    fill: rgb(90, 180, 172)\n}\n\n.BrBG .q6-7 {\n    fill: rgb(1, 102, 94)\n}\n\n.BrBG .q0-8 {\n    fill: rgb(140, 81, 10)\n}\n\n.BrBG .q1-8 {\n    fill: rgb(191, 129, 45)\n}\n\n.BrBG .q2-8 {\n    fill: rgb(223, 194, 125)\n}\n\n.BrBG .q3-8 {\n    fill: rgb(246, 232, 195)\n}\n\n.BrBG .q4-8 {\n    fill: rgb(199, 234, 229)\n}\n\n.BrBG .q5-8 {\n    fill: rgb(128, 205, 193)\n}\n\n.BrBG .q6-8 {\n    fill: rgb(53, 151, 143)\n}\n\n.BrBG .q7-8 {\n    fill: rgb(1, 102, 94)\n}\n\n.BrBG .q0-9 {\n    fill: rgb(140, 81, 10)\n}\n\n.BrBG .q1-9 {\n    fill: rgb(191, 129, 45)\n}\n\n.BrBG .q2-9 {\n    fill: rgb(223, 194, 125)\n}\n\n.BrBG .q3-9 {\n    fill: rgb(246, 232, 195)\n}\n\n.BrBG .q4-9 {\n    fill: rgb(245, 245, 245)\n}\n\n.BrBG .q5-9 {\n    fill: rgb(199, 234, 229)\n}\n\n.BrBG .q6-9 {\n    fill: rgb(128, 205, 193)\n}\n\n.BrBG .q7-9 {\n    fill: rgb(53, 151, 143)\n}\n\n.BrBG .q8-9 {\n    fill: rgb(1, 102, 94)\n}\n\n.BrBG .q0-10 {\n    fill: rgb(84, 48, 5)\n}\n\n.BrBG .q1-10 {\n    fill: rgb(140, 81, 10)\n}\n\n.BrBG .q2-10 {\n    fill: rgb(191, 129, 45)\n}\n\n.BrBG .q3-10 {\n    fill: rgb(223, 194, 125)\n}\n\n.BrBG .q4-10 {\n    fill: rgb(246, 232, 195)\n}\n\n.BrBG .q5-10 {\n    fill: rgb(199, 234, 229)\n}\n\n.BrBG .q6-10 {\n    fill: rgb(128, 205, 193)\n}\n\n.BrBG .q7-10 {\n    fill: rgb(53, 151, 143)\n}\n\n.BrBG .q8-10 {\n    fill: rgb(1, 102, 94)\n}\n\n.BrBG .q9-10 {\n    fill: rgb(0, 60, 48)\n}\n\n.BrBG .q0-11 {\n    fill: rgb(84, 48, 5)\n}\n\n.BrBG .q1-11 {\n    fill: rgb(140, 81, 10)\n}\n\n.BrBG .q2-11 {\n    fill: rgb(191, 129, 45)\n}\n\n.BrBG .q3-11 {\n    fill: rgb(223, 194, 125)\n}\n\n.BrBG .q4-11 {\n    fill: rgb(246, 232, 195)\n}\n\n.BrBG .q5-11 {\n    fill: rgb(245, 245, 245)\n}\n\n.BrBG .q6-11 {\n    fill: rgb(199, 234, 229)\n}\n\n.BrBG .q7-11 {\n    fill: rgb(128, 205, 193)\n}\n\n.BrBG .q8-11 {\n    fill: rgb(53, 151, 143)\n}\n\n.BrBG .q9-11 {\n    fill: rgb(1, 102, 94)\n}\n\n.BrBG .q10-11 {\n    fill: rgb(0, 60, 48)\n}\n\n.PRGn .q0-3 {\n    fill: rgb(175, 141, 195)\n}\n\n.PRGn .q1-3 {\n    fill: rgb(247, 247, 247)\n}\n\n.PRGn .q2-3 {\n    fill: rgb(127, 191, 123)\n}\n\n.PRGn .q0-4 {\n    fill: rgb(123, 50, 148)\n}\n\n.PRGn .q1-4 {\n    fill: rgb(194, 165, 207)\n}\n\n.PRGn .q2-4 {\n    fill: rgb(166, 219, 160)\n}\n\n.PRGn .q3-4 {\n    fill: rgb(0, 136, 55)\n}\n\n.PRGn .q0-5 {\n    fill: rgb(123, 50, 148)\n}\n\n.PRGn .q1-5 {\n    fill: rgb(194, 165, 207)\n}\n\n.PRGn .q2-5 {\n    fill: rgb(247, 247, 247)\n}\n\n.PRGn .q3-5 {\n    fill: rgb(166, 219, 160)\n}\n\n.PRGn .q4-5 {\n    fill: rgb(0, 136, 55)\n}\n\n.PRGn .q0-6 {\n    fill: rgb(118, 42, 131)\n}\n\n.PRGn .q1-6 {\n    fill: rgb(175, 141, 195)\n}\n\n.PRGn .q2-6 {\n    fill: rgb(231, 212, 232)\n}\n\n.PRGn .q3-6 {\n    fill: rgb(217, 240, 211)\n}\n\n.PRGn .q4-6 {\n    fill: rgb(127, 191, 123)\n}\n\n.PRGn .q5-6 {\n    fill: rgb(27, 120, 55)\n}\n\n.PRGn .q0-7 {\n    fill: rgb(118, 42, 131)\n}\n\n.PRGn .q1-7 {\n    fill: rgb(175, 141, 195)\n}\n\n.PRGn .q2-7 {\n    fill: rgb(231, 212, 232)\n}\n\n.PRGn .q3-7 {\n    fill: rgb(247, 247, 247)\n}\n\n.PRGn .q4-7 {\n    fill: rgb(217, 240, 211)\n}\n\n.PRGn .q5-7 {\n    fill: rgb(127, 191, 123)\n}\n\n.PRGn .q6-7 {\n    fill: rgb(27, 120, 55)\n}\n\n.PRGn .q0-8 {\n    fill: rgb(118, 42, 131)\n}\n\n.PRGn .q1-8 {\n    fill: rgb(153, 112, 171)\n}\n\n.PRGn .q2-8 {\n    fill: rgb(194, 165, 207)\n}\n\n.PRGn .q3-8 {\n    fill: rgb(231, 212, 232)\n}\n\n.PRGn .q4-8 {\n    fill: rgb(217, 240, 211)\n}\n\n.PRGn .q5-8 {\n    fill: rgb(166, 219, 160)\n}\n\n.PRGn .q6-8 {\n    fill: rgb(90, 174, 97)\n}\n\n.PRGn .q7-8 {\n    fill: rgb(27, 120, 55)\n}\n\n.PRGn .q0-9 {\n    fill: rgb(118, 42, 131)\n}\n\n.PRGn .q1-9 {\n    fill: rgb(153, 112, 171)\n}\n\n.PRGn .q2-9 {\n    fill: rgb(194, 165, 207)\n}\n\n.PRGn .q3-9 {\n    fill: rgb(231, 212, 232)\n}\n\n.PRGn .q4-9 {\n    fill: rgb(247, 247, 247)\n}\n\n.PRGn .q5-9 {\n    fill: rgb(217, 240, 211)\n}\n\n.PRGn .q6-9 {\n    fill: rgb(166, 219, 160)\n}\n\n.PRGn .q7-9 {\n    fill: rgb(90, 174, 97)\n}\n\n.PRGn .q8-9 {\n    fill: rgb(27, 120, 55)\n}\n\n.PRGn .q0-10 {\n    fill: rgb(64, 0, 75)\n}\n\n.PRGn .q1-10 {\n    fill: rgb(118, 42, 131)\n}\n\n.PRGn .q2-10 {\n    fill: rgb(153, 112, 171)\n}\n\n.PRGn .q3-10 {\n    fill: rgb(194, 165, 207)\n}\n\n.PRGn .q4-10 {\n    fill: rgb(231, 212, 232)\n}\n\n.PRGn .q5-10 {\n    fill: rgb(217, 240, 211)\n}\n\n.PRGn .q6-10 {\n    fill: rgb(166, 219, 160)\n}\n\n.PRGn .q7-10 {\n    fill: rgb(90, 174, 97)\n}\n\n.PRGn .q8-10 {\n    fill: rgb(27, 120, 55)\n}\n\n.PRGn .q9-10 {\n    fill: rgb(0, 68, 27)\n}\n\n.PRGn .q0-11 {\n    fill: rgb(64, 0, 75)\n}\n\n.PRGn .q1-11 {\n    fill: rgb(118, 42, 131)\n}\n\n.PRGn .q2-11 {\n    fill: rgb(153, 112, 171)\n}\n\n.PRGn .q3-11 {\n    fill: rgb(194, 165, 207)\n}\n\n.PRGn .q4-11 {\n    fill: rgb(231, 212, 232)\n}\n\n.PRGn .q5-11 {\n    fill: rgb(247, 247, 247)\n}\n\n.PRGn .q6-11 {\n    fill: rgb(217, 240, 211)\n}\n\n.PRGn .q7-11 {\n    fill: rgb(166, 219, 160)\n}\n\n.PRGn .q8-11 {\n    fill: rgb(90, 174, 97)\n}\n\n.PRGn .q9-11 {\n    fill: rgb(27, 120, 55)\n}\n\n.PRGn .q10-11 {\n    fill: rgb(0, 68, 27)\n}\n\n.PiYG .q0-3 {\n    fill: rgb(233, 163, 201)\n}\n\n.PiYG .q1-3 {\n    fill: rgb(247, 247, 247)\n}\n\n.PiYG .q2-3 {\n    fill: rgb(161, 215, 106)\n}\n\n.PiYG .q0-4 {\n    fill: rgb(208, 28, 139)\n}\n\n.PiYG .q1-4 {\n    fill: rgb(241, 182, 218)\n}\n\n.PiYG .q2-4 {\n    fill: rgb(184, 225, 134)\n}\n\n.PiYG .q3-4 {\n    fill: rgb(77, 172, 38)\n}\n\n.PiYG .q0-5 {\n    fill: rgb(208, 28, 139)\n}\n\n.PiYG .q1-5 {\n    fill: rgb(241, 182, 218)\n}\n\n.PiYG .q2-5 {\n    fill: rgb(247, 247, 247)\n}\n\n.PiYG .q3-5 {\n    fill: rgb(184, 225, 134)\n}\n\n.PiYG .q4-5 {\n    fill: rgb(77, 172, 38)\n}\n\n.PiYG .q0-6 {\n    fill: rgb(197, 27, 125)\n}\n\n.PiYG .q1-6 {\n    fill: rgb(233, 163, 201)\n}\n\n.PiYG .q2-6 {\n    fill: rgb(253, 224, 239)\n}\n\n.PiYG .q3-6 {\n    fill: rgb(230, 245, 208)\n}\n\n.PiYG .q4-6 {\n    fill: rgb(161, 215, 106)\n}\n\n.PiYG .q5-6 {\n    fill: rgb(77, 146, 33)\n}\n\n.PiYG .q0-7 {\n    fill: rgb(197, 27, 125)\n}\n\n.PiYG .q1-7 {\n    fill: rgb(233, 163, 201)\n}\n\n.PiYG .q2-7 {\n    fill: rgb(253, 224, 239)\n}\n\n.PiYG .q3-7 {\n    fill: rgb(247, 247, 247)\n}\n\n.PiYG .q4-7 {\n    fill: rgb(230, 245, 208)\n}\n\n.PiYG .q5-7 {\n    fill: rgb(161, 215, 106)\n}\n\n.PiYG .q6-7 {\n    fill: rgb(77, 146, 33)\n}\n\n.PiYG .q0-8 {\n    fill: rgb(197, 27, 125)\n}\n\n.PiYG .q1-8 {\n    fill: rgb(222, 119, 174)\n}\n\n.PiYG .q2-8 {\n    fill: rgb(241, 182, 218)\n}\n\n.PiYG .q3-8 {\n    fill: rgb(253, 224, 239)\n}\n\n.PiYG .q4-8 {\n    fill: rgb(230, 245, 208)\n}\n\n.PiYG .q5-8 {\n    fill: rgb(184, 225, 134)\n}\n\n.PiYG .q6-8 {\n    fill: rgb(127, 188, 65)\n}\n\n.PiYG .q7-8 {\n    fill: rgb(77, 146, 33)\n}\n\n.PiYG .q0-9 {\n    fill: rgb(197, 27, 125)\n}\n\n.PiYG .q1-9 {\n    fill: rgb(222, 119, 174)\n}\n\n.PiYG .q2-9 {\n    fill: rgb(241, 182, 218)\n}\n\n.PiYG .q3-9 {\n    fill: rgb(253, 224, 239)\n}\n\n.PiYG .q4-9 {\n    fill: rgb(247, 247, 247)\n}\n\n.PiYG .q5-9 {\n    fill: rgb(230, 245, 208)\n}\n\n.PiYG .q6-9 {\n    fill: rgb(184, 225, 134)\n}\n\n.PiYG .q7-9 {\n    fill: rgb(127, 188, 65)\n}\n\n.PiYG .q8-9 {\n    fill: rgb(77, 146, 33)\n}\n\n.PiYG .q0-10 {\n    fill: rgb(142, 1, 82)\n}\n\n.PiYG .q1-10 {\n    fill: rgb(197, 27, 125)\n}\n\n.PiYG .q2-10 {\n    fill: rgb(222, 119, 174)\n}\n\n.PiYG .q3-10 {\n    fill: rgb(241, 182, 218)\n}\n\n.PiYG .q4-10 {\n    fill: rgb(253, 224, 239)\n}\n\n.PiYG .q5-10 {\n    fill: rgb(230, 245, 208)\n}\n\n.PiYG .q6-10 {\n    fill: rgb(184, 225, 134)\n}\n\n.PiYG .q7-10 {\n    fill: rgb(127, 188, 65)\n}\n\n.PiYG .q8-10 {\n    fill: rgb(77, 146, 33)\n}\n\n.PiYG .q9-10 {\n    fill: rgb(39, 100, 25)\n}\n\n.PiYG .q0-11 {\n    fill: rgb(142, 1, 82)\n}\n\n.PiYG .q1-11 {\n    fill: rgb(197, 27, 125)\n}\n\n.PiYG .q2-11 {\n    fill: rgb(222, 119, 174)\n}\n\n.PiYG .q3-11 {\n    fill: rgb(241, 182, 218)\n}\n\n.PiYG .q4-11 {\n    fill: rgb(253, 224, 239)\n}\n\n.PiYG .q5-11 {\n    fill: rgb(247, 247, 247)\n}\n\n.PiYG .q6-11 {\n    fill: rgb(230, 245, 208)\n}\n\n.PiYG .q7-11 {\n    fill: rgb(184, 225, 134)\n}\n\n.PiYG .q8-11 {\n    fill: rgb(127, 188, 65)\n}\n\n.PiYG .q9-11 {\n    fill: rgb(77, 146, 33)\n}\n\n.PiYG .q10-11 {\n    fill: rgb(39, 100, 25)\n}\n\n.RdBu .q0-3 {\n    fill: rgb(239, 138, 98)\n}\n\n.RdBu .q1-3 {\n    fill: rgb(247, 247, 247)\n}\n\n.RdBu .q2-3 {\n    fill: rgb(103, 169, 207)\n}\n\n.RdBu .q0-4 {\n    fill: rgb(202, 0, 32)\n}\n\n.RdBu .q1-4 {\n    fill: rgb(244, 165, 130)\n}\n\n.RdBu .q2-4 {\n    fill: rgb(146, 197, 222)\n}\n\n.RdBu .q3-4 {\n    fill: rgb(5, 113, 176)\n}\n\n.RdBu .q0-5 {\n    fill: rgb(202, 0, 32)\n}\n\n.RdBu .q1-5 {\n    fill: rgb(244, 165, 130)\n}\n\n.RdBu .q2-5 {\n    fill: rgb(247, 247, 247)\n}\n\n.RdBu .q3-5 {\n    fill: rgb(146, 197, 222)\n}\n\n.RdBu .q4-5 {\n    fill: rgb(5, 113, 176)\n}\n\n.RdBu .q0-6 {\n    fill: rgb(178, 24, 43)\n}\n\n.RdBu .q1-6 {\n    fill: rgb(239, 138, 98)\n}\n\n.RdBu .q2-6 {\n    fill: rgb(253, 219, 199)\n}\n\n.RdBu .q3-6 {\n    fill: rgb(209, 229, 240)\n}\n\n.RdBu .q4-6 {\n    fill: rgb(103, 169, 207)\n}\n\n.RdBu .q5-6 {\n    fill: rgb(33, 102, 172)\n}\n\n.RdBu .q0-7 {\n    fill: rgb(178, 24, 43)\n}\n\n.RdBu .q1-7 {\n    fill: rgb(239, 138, 98)\n}\n\n.RdBu .q2-7 {\n    fill: rgb(253, 219, 199)\n}\n\n.RdBu .q3-7 {\n    fill: rgb(247, 247, 247)\n}\n\n.RdBu .q4-7 {\n    fill: rgb(209, 229, 240)\n}\n\n.RdBu .q5-7 {\n    fill: rgb(103, 169, 207)\n}\n\n.RdBu .q6-7 {\n    fill: rgb(33, 102, 172)\n}\n\n.RdBu .q0-8 {\n    fill: rgb(178, 24, 43)\n}\n\n.RdBu .q1-8 {\n    fill: rgb(214, 96, 77)\n}\n\n.RdBu .q2-8 {\n    fill: rgb(244, 165, 130)\n}\n\n.RdBu .q3-8 {\n    fill: rgb(253, 219, 199)\n}\n\n.RdBu .q4-8 {\n    fill: rgb(209, 229, 240)\n}\n\n.RdBu .q5-8 {\n    fill: rgb(146, 197, 222)\n}\n\n.RdBu .q6-8 {\n    fill: rgb(67, 147, 195)\n}\n\n.RdBu .q7-8 {\n    fill: rgb(33, 102, 172)\n}\n\n.RdBu .q0-9 {\n    fill: rgb(178, 24, 43)\n}\n\n.RdBu .q1-9 {\n    fill: rgb(214, 96, 77)\n}\n\n.RdBu .q2-9 {\n    fill: rgb(244, 165, 130)\n}\n\n.RdBu .q3-9 {\n    fill: rgb(253, 219, 199)\n}\n\n.RdBu .q4-9 {\n    fill: rgb(247, 247, 247)\n}\n\n.RdBu .q5-9 {\n    fill: rgb(209, 229, 240)\n}\n\n.RdBu .q6-9 {\n    fill: rgb(146, 197, 222)\n}\n\n.RdBu .q7-9 {\n    fill: rgb(67, 147, 195)\n}\n\n.RdBu .q8-9 {\n    fill: rgb(33, 102, 172)\n}\n\n.RdBu .q0-10 {\n    fill: rgb(103, 0, 31)\n}\n\n.RdBu .q1-10 {\n    fill: rgb(178, 24, 43)\n}\n\n.RdBu .q2-10 {\n    fill: rgb(214, 96, 77)\n}\n\n.RdBu .q3-10 {\n    fill: rgb(244, 165, 130)\n}\n\n.RdBu .q4-10 {\n    fill: rgb(253, 219, 199)\n}\n\n.RdBu .q5-10 {\n    fill: rgb(209, 229, 240)\n}\n\n.RdBu .q6-10 {\n    fill: rgb(146, 197, 222)\n}\n\n.RdBu .q7-10 {\n    fill: rgb(67, 147, 195)\n}\n\n.RdBu .q8-10 {\n    fill: rgb(33, 102, 172)\n}\n\n.RdBu .q9-10 {\n    fill: rgb(5, 48, 97)\n}\n\n.RdBu .q0-11 {\n    fill: rgb(103, 0, 31)\n}\n\n.RdBu .q1-11 {\n    fill: rgb(178, 24, 43)\n}\n\n.RdBu .q2-11 {\n    fill: rgb(214, 96, 77)\n}\n\n.RdBu .q3-11 {\n    fill: rgb(244, 165, 130)\n}\n\n.RdBu .q4-11 {\n    fill: rgb(253, 219, 199)\n}\n\n.RdBu .q5-11 {\n    fill: rgb(247, 247, 247)\n}\n\n.RdBu .q6-11 {\n    fill: rgb(209, 229, 240)\n}\n\n.RdBu .q7-11 {\n    fill: rgb(146, 197, 222)\n}\n\n.RdBu .q8-11 {\n    fill: rgb(67, 147, 195)\n}\n\n.RdBu .q9-11 {\n    fill: rgb(33, 102, 172)\n}\n\n.RdBu .q10-11 {\n    fill: rgb(5, 48, 97)\n}\n\n.RdGy .q0-3 {\n    fill: rgb(239, 138, 98)\n}\n\n.RdGy .q1-3 {\n    fill: rgb(255, 255, 255)\n}\n\n.RdGy .q2-3 {\n    fill: rgb(153, 153, 153)\n}\n\n.RdGy .q0-4 {\n    fill: rgb(202, 0, 32)\n}\n\n.RdGy .q1-4 {\n    fill: rgb(244, 165, 130)\n}\n\n.RdGy .q2-4 {\n    fill: rgb(186, 186, 186)\n}\n\n.RdGy .q3-4 {\n    fill: rgb(64, 64, 64)\n}\n\n.RdGy .q0-5 {\n    fill: rgb(202, 0, 32)\n}\n\n.RdGy .q1-5 {\n    fill: rgb(244, 165, 130)\n}\n\n.RdGy .q2-5 {\n    fill: rgb(255, 255, 255)\n}\n\n.RdGy .q3-5 {\n    fill: rgb(186, 186, 186)\n}\n\n.RdGy .q4-5 {\n    fill: rgb(64, 64, 64)\n}\n\n.RdGy .q0-6 {\n    fill: rgb(178, 24, 43)\n}\n\n.RdGy .q1-6 {\n    fill: rgb(239, 138, 98)\n}\n\n.RdGy .q2-6 {\n    fill: rgb(253, 219, 199)\n}\n\n.RdGy .q3-6 {\n    fill: rgb(224, 224, 224)\n}\n\n.RdGy .q4-6 {\n    fill: rgb(153, 153, 153)\n}\n\n.RdGy .q5-6 {\n    fill: rgb(77, 77, 77)\n}\n\n.RdGy .q0-7 {\n    fill: rgb(178, 24, 43)\n}\n\n.RdGy .q1-7 {\n    fill: rgb(239, 138, 98)\n}\n\n.RdGy .q2-7 {\n    fill: rgb(253, 219, 199)\n}\n\n.RdGy .q3-7 {\n    fill: rgb(255, 255, 255)\n}\n\n.RdGy .q4-7 {\n    fill: rgb(224, 224, 224)\n}\n\n.RdGy .q5-7 {\n    fill: rgb(153, 153, 153)\n}\n\n.RdGy .q6-7 {\n    fill: rgb(77, 77, 77)\n}\n\n.RdGy .q0-8 {\n    fill: rgb(178, 24, 43)\n}\n\n.RdGy .q1-8 {\n    fill: rgb(214, 96, 77)\n}\n\n.RdGy .q2-8 {\n    fill: rgb(244, 165, 130)\n}\n\n.RdGy .q3-8 {\n    fill: rgb(253, 219, 199)\n}\n\n.RdGy .q4-8 {\n    fill: rgb(224, 224, 224)\n}\n\n.RdGy .q5-8 {\n    fill: rgb(186, 186, 186)\n}\n\n.RdGy .q6-8 {\n    fill: rgb(135, 135, 135)\n}\n\n.RdGy .q7-8 {\n    fill: rgb(77, 77, 77)\n}\n\n.RdGy .q0-9 {\n    fill: rgb(178, 24, 43)\n}\n\n.RdGy .q1-9 {\n    fill: rgb(214, 96, 77)\n}\n\n.RdGy .q2-9 {\n    fill: rgb(244, 165, 130)\n}\n\n.RdGy .q3-9 {\n    fill: rgb(253, 219, 199)\n}\n\n.RdGy .q4-9 {\n    fill: rgb(255, 255, 255)\n}\n\n.RdGy .q5-9 {\n    fill: rgb(224, 224, 224)\n}\n\n.RdGy .q6-9 {\n    fill: rgb(186, 186, 186)\n}\n\n.RdGy .q7-9 {\n    fill: rgb(135, 135, 135)\n}\n\n.RdGy .q8-9 {\n    fill: rgb(77, 77, 77)\n}\n\n.RdGy .q0-10 {\n    fill: rgb(103, 0, 31)\n}\n\n.RdGy .q1-10 {\n    fill: rgb(178, 24, 43)\n}\n\n.RdGy .q2-10 {\n    fill: rgb(214, 96, 77)\n}\n\n.RdGy .q3-10 {\n    fill: rgb(244, 165, 130)\n}\n\n.RdGy .q4-10 {\n    fill: rgb(253, 219, 199)\n}\n\n.RdGy .q5-10 {\n    fill: rgb(224, 224, 224)\n}\n\n.RdGy .q6-10 {\n    fill: rgb(186, 186, 186)\n}\n\n.RdGy .q7-10 {\n    fill: rgb(135, 135, 135)\n}\n\n.RdGy .q8-10 {\n    fill: rgb(77, 77, 77)\n}\n\n.RdGy .q9-10 {\n    fill: rgb(26, 26, 26)\n}\n\n.RdGy .q0-11 {\n    fill: rgb(103, 0, 31)\n}\n\n.RdGy .q1-11 {\n    fill: rgb(178, 24, 43)\n}\n\n.RdGy .q2-11 {\n    fill: rgb(214, 96, 77)\n}\n\n.RdGy .q3-11 {\n    fill: rgb(244, 165, 130)\n}\n\n.RdGy .q4-11 {\n    fill: rgb(253, 219, 199)\n}\n\n.RdGy .q5-11 {\n    fill: rgb(255, 255, 255)\n}\n\n.RdGy .q6-11 {\n    fill: rgb(224, 224, 224)\n}\n\n.RdGy .q7-11 {\n    fill: rgb(186, 186, 186)\n}\n\n.RdGy .q8-11 {\n    fill: rgb(135, 135, 135)\n}\n\n.RdGy .q9-11 {\n    fill: rgb(77, 77, 77)\n}\n\n.RdGy .q10-11 {\n    fill: rgb(26, 26, 26)\n}\n\n.RdYlBu .q0-3 {\n    fill: rgb(252, 141, 89)\n}\n\n.RdYlBu .q1-3 {\n    fill: rgb(255, 255, 191)\n}\n\n.RdYlBu .q2-3 {\n    fill: rgb(145, 191, 219)\n}\n\n.RdYlBu .q0-4 {\n    fill: rgb(215, 25, 28)\n}\n\n.RdYlBu .q1-4 {\n    fill: rgb(253, 174, 97)\n}\n\n.RdYlBu .q2-4 {\n    fill: rgb(171, 217, 233)\n}\n\n.RdYlBu .q3-4 {\n    fill: rgb(44, 123, 182)\n}\n\n.RdYlBu .q0-5 {\n    fill: rgb(215, 25, 28)\n}\n\n.RdYlBu .q1-5 {\n    fill: rgb(253, 174, 97)\n}\n\n.RdYlBu .q2-5 {\n    fill: rgb(255, 255, 191)\n}\n\n.RdYlBu .q3-5 {\n    fill: rgb(171, 217, 233)\n}\n\n.RdYlBu .q4-5 {\n    fill: rgb(44, 123, 182)\n}\n\n.RdYlBu .q0-6 {\n    fill: rgb(215, 48, 39)\n}\n\n.RdYlBu .q1-6 {\n    fill: rgb(252, 141, 89)\n}\n\n.RdYlBu .q2-6 {\n    fill: rgb(254, 224, 144)\n}\n\n.RdYlBu .q3-6 {\n    fill: rgb(224, 243, 248)\n}\n\n.RdYlBu .q4-6 {\n    fill: rgb(145, 191, 219)\n}\n\n.RdYlBu .q5-6 {\n    fill: rgb(69, 117, 180)\n}\n\n.RdYlBu .q0-7 {\n    fill: rgb(215, 48, 39)\n}\n\n.RdYlBu .q1-7 {\n    fill: rgb(252, 141, 89)\n}\n\n.RdYlBu .q2-7 {\n    fill: rgb(254, 224, 144)\n}\n\n.RdYlBu .q3-7 {\n    fill: rgb(255, 255, 191)\n}\n\n.RdYlBu .q4-7 {\n    fill: rgb(224, 243, 248)\n}\n\n.RdYlBu .q5-7 {\n    fill: rgb(145, 191, 219)\n}\n\n.RdYlBu .q6-7 {\n    fill: rgb(69, 117, 180)\n}\n\n.RdYlBu .q0-8 {\n    fill: rgb(215, 48, 39)\n}\n\n.RdYlBu .q1-8 {\n    fill: rgb(244, 109, 67)\n}\n\n.RdYlBu .q2-8 {\n    fill: rgb(253, 174, 97)\n}\n\n.RdYlBu .q3-8 {\n    fill: rgb(254, 224, 144)\n}\n\n.RdYlBu .q4-8 {\n    fill: rgb(224, 243, 248)\n}\n\n.RdYlBu .q5-8 {\n    fill: rgb(171, 217, 233)\n}\n\n.RdYlBu .q6-8 {\n    fill: rgb(116, 173, 209)\n}\n\n.RdYlBu .q7-8 {\n    fill: rgb(69, 117, 180)\n}\n\n.RdYlBu .q0-9 {\n    fill: rgb(215, 48, 39)\n}\n\n.RdYlBu .q1-9 {\n    fill: rgb(244, 109, 67)\n}\n\n.RdYlBu .q2-9 {\n    fill: rgb(253, 174, 97)\n}\n\n.RdYlBu .q3-9 {\n    fill: rgb(254, 224, 144)\n}\n\n.RdYlBu .q4-9 {\n    fill: rgb(255, 255, 191)\n}\n\n.RdYlBu .q5-9 {\n    fill: rgb(224, 243, 248)\n}\n\n.RdYlBu .q6-9 {\n    fill: rgb(171, 217, 233)\n}\n\n.RdYlBu .q7-9 {\n    fill: rgb(116, 173, 209)\n}\n\n.RdYlBu .q8-9 {\n    fill: rgb(69, 117, 180)\n}\n\n.RdYlBu .q0-10 {\n    fill: rgb(165, 0, 38)\n}\n\n.RdYlBu .q1-10 {\n    fill: rgb(215, 48, 39)\n}\n\n.RdYlBu .q2-10 {\n    fill: rgb(244, 109, 67)\n}\n\n.RdYlBu .q3-10 {\n    fill: rgb(253, 174, 97)\n}\n\n.RdYlBu .q4-10 {\n    fill: rgb(254, 224, 144)\n}\n\n.RdYlBu .q5-10 {\n    fill: rgb(224, 243, 248)\n}\n\n.RdYlBu .q6-10 {\n    fill: rgb(171, 217, 233)\n}\n\n.RdYlBu .q7-10 {\n    fill: rgb(116, 173, 209)\n}\n\n.RdYlBu .q8-10 {\n    fill: rgb(69, 117, 180)\n}\n\n.RdYlBu .q9-10 {\n    fill: rgb(49, 54, 149)\n}\n\n.RdYlBu .q0-11 {\n    fill: rgb(165, 0, 38)\n}\n\n.RdYlBu .q1-11 {\n    fill: rgb(215, 48, 39)\n}\n\n.RdYlBu .q2-11 {\n    fill: rgb(244, 109, 67)\n}\n\n.RdYlBu .q3-11 {\n    fill: rgb(253, 174, 97)\n}\n\n.RdYlBu .q4-11 {\n    fill: rgb(254, 224, 144)\n}\n\n.RdYlBu .q5-11 {\n    fill: rgb(255, 255, 191)\n}\n\n.RdYlBu .q6-11 {\n    fill: rgb(224, 243, 248)\n}\n\n.RdYlBu .q7-11 {\n    fill: rgb(171, 217, 233)\n}\n\n.RdYlBu .q8-11 {\n    fill: rgb(116, 173, 209)\n}\n\n.RdYlBu .q9-11 {\n    fill: rgb(69, 117, 180)\n}\n\n.RdYlBu .q10-11 {\n    fill: rgb(49, 54, 149)\n}\n\n.Spectral .q0-3 {\n    fill: rgb(252, 141, 89)\n}\n\n.Spectral .q1-3 {\n    fill: rgb(255, 255, 191)\n}\n\n.Spectral .q2-3 {\n    fill: rgb(153, 213, 148)\n}\n\n.Spectral .q0-4 {\n    fill: rgb(215, 25, 28)\n}\n\n.Spectral .q1-4 {\n    fill: rgb(253, 174, 97)\n}\n\n.Spectral .q2-4 {\n    fill: rgb(171, 221, 164)\n}\n\n.Spectral .q3-4 {\n    fill: rgb(43, 131, 186)\n}\n\n.Spectral .q0-5 {\n    fill: rgb(215, 25, 28)\n}\n\n.Spectral .q1-5 {\n    fill: rgb(253, 174, 97)\n}\n\n.Spectral .q2-5 {\n    fill: rgb(255, 255, 191)\n}\n\n.Spectral .q3-5 {\n    fill: rgb(171, 221, 164)\n}\n\n.Spectral .q4-5 {\n    fill: rgb(43, 131, 186)\n}\n\n.Spectral .q0-6 {\n    fill: rgb(213, 62, 79)\n}\n\n.Spectral .q1-6 {\n    fill: rgb(252, 141, 89)\n}\n\n.Spectral .q2-6 {\n    fill: rgb(254, 224, 139)\n}\n\n.Spectral .q3-6 {\n    fill: rgb(230, 245, 152)\n}\n\n.Spectral .q4-6 {\n    fill: rgb(153, 213, 148)\n}\n\n.Spectral .q5-6 {\n    fill: rgb(50, 136, 189)\n}\n\n.Spectral .q0-7 {\n    fill: rgb(213, 62, 79)\n}\n\n.Spectral .q1-7 {\n    fill: rgb(252, 141, 89)\n}\n\n.Spectral .q2-7 {\n    fill: rgb(254, 224, 139)\n}\n\n.Spectral .q3-7 {\n    fill: rgb(255, 255, 191)\n}\n\n.Spectral .q4-7 {\n    fill: rgb(230, 245, 152)\n}\n\n.Spectral .q5-7 {\n    fill: rgb(153, 213, 148)\n}\n\n.Spectral .q6-7 {\n    fill: rgb(50, 136, 189)\n}\n\n.Spectral .q0-8 {\n    fill: rgb(213, 62, 79)\n}\n\n.Spectral .q1-8 {\n    fill: rgb(244, 109, 67)\n}\n\n.Spectral .q2-8 {\n    fill: rgb(253, 174, 97)\n}\n\n.Spectral .q3-8 {\n    fill: rgb(254, 224, 139)\n}\n\n.Spectral .q4-8 {\n    fill: rgb(230, 245, 152)\n}\n\n.Spectral .q5-8 {\n    fill: rgb(171, 221, 164)\n}\n\n.Spectral .q6-8 {\n    fill: rgb(102, 194, 165)\n}\n\n.Spectral .q7-8 {\n    fill: rgb(50, 136, 189)\n}\n\n.Spectral .q0-9 {\n    fill: rgb(213, 62, 79)\n}\n\n.Spectral .q1-9 {\n    fill: rgb(244, 109, 67)\n}\n\n.Spectral .q2-9 {\n    fill: rgb(253, 174, 97)\n}\n\n.Spectral .q3-9 {\n    fill: rgb(254, 224, 139)\n}\n\n.Spectral .q4-9 {\n    fill: rgb(255, 255, 191)\n}\n\n.Spectral .q5-9 {\n    fill: rgb(230, 245, 152)\n}\n\n.Spectral .q6-9 {\n    fill: rgb(171, 221, 164)\n}\n\n.Spectral .q7-9 {\n    fill: rgb(102, 194, 165)\n}\n\n.Spectral .q8-9 {\n    fill: rgb(50, 136, 189)\n}\n\n.Spectral .q0-10 {\n    fill: rgb(158, 1, 66)\n}\n\n.Spectral .q1-10 {\n    fill: rgb(213, 62, 79)\n}\n\n.Spectral .q2-10 {\n    fill: rgb(244, 109, 67)\n}\n\n.Spectral .q3-10 {\n    fill: rgb(253, 174, 97)\n}\n\n.Spectral .q4-10 {\n    fill: rgb(254, 224, 139)\n}\n\n.Spectral .q5-10 {\n    fill: rgb(230, 245, 152)\n}\n\n.Spectral .q6-10 {\n    fill: rgb(171, 221, 164)\n}\n\n.Spectral .q7-10 {\n    fill: rgb(102, 194, 165)\n}\n\n.Spectral .q8-10 {\n    fill: rgb(50, 136, 189)\n}\n\n.Spectral .q9-10 {\n    fill: rgb(94, 79, 162)\n}\n\n.Spectral .q0-11 {\n    fill: rgb(158, 1, 66)\n}\n\n.Spectral .q1-11 {\n    fill: rgb(213, 62, 79)\n}\n\n.Spectral .q2-11 {\n    fill: rgb(244, 109, 67)\n}\n\n.Spectral .q3-11 {\n    fill: rgb(253, 174, 97)\n}\n\n.Spectral .q4-11 {\n    fill: rgb(254, 224, 139)\n}\n\n.Spectral .q5-11 {\n    fill: rgb(255, 255, 191)\n}\n\n.Spectral .q6-11 {\n    fill: rgb(230, 245, 152)\n}\n\n.Spectral .q7-11 {\n    fill: rgb(171, 221, 164)\n}\n\n.Spectral .q8-11 {\n    fill: rgb(102, 194, 165)\n}\n\n.Spectral .q9-11 {\n    fill: rgb(50, 136, 189)\n}\n\n.Spectral .q10-11 {\n    fill: rgb(94, 79, 162)\n}\n\n.RdYlGn .q0-3 {\n    fill: rgb(252, 141, 89)\n}\n\n.RdYlGn .q1-3 {\n    fill: rgb(255, 255, 191)\n}\n\n.RdYlGn .q2-3 {\n    fill: rgb(145, 207, 96)\n}\n\n.RdYlGn .q0-4 {\n    fill: rgb(215, 25, 28)\n}\n\n.RdYlGn .q1-4 {\n    fill: rgb(253, 174, 97)\n}\n\n.RdYlGn .q2-4 {\n    fill: rgb(166, 217, 106)\n}\n\n.RdYlGn .q3-4 {\n    fill: rgb(26, 150, 65)\n}\n\n.RdYlGn .q0-5 {\n    fill: rgb(215, 25, 28)\n}\n\n.RdYlGn .q1-5 {\n    fill: rgb(253, 174, 97)\n}\n\n.RdYlGn .q2-5 {\n    fill: rgb(255, 255, 191)\n}\n\n.RdYlGn .q3-5 {\n    fill: rgb(166, 217, 106)\n}\n\n.RdYlGn .q4-5 {\n    fill: rgb(26, 150, 65)\n}\n\n.RdYlGn .q0-6 {\n    fill: rgb(215, 48, 39)\n}\n\n.RdYlGn .q1-6 {\n    fill: rgb(252, 141, 89)\n}\n\n.RdYlGn .q2-6 {\n    fill: rgb(254, 224, 139)\n}\n\n.RdYlGn .q3-6 {\n    fill: rgb(217, 239, 139)\n}\n\n.RdYlGn .q4-6 {\n    fill: rgb(145, 207, 96)\n}\n\n.RdYlGn .q5-6 {\n    fill: rgb(26, 152, 80)\n}\n\n.RdYlGn .q0-7 {\n    fill: rgb(215, 48, 39)\n}\n\n.RdYlGn .q1-7 {\n    fill: rgb(252, 141, 89)\n}\n\n.RdYlGn .q2-7 {\n    fill: rgb(254, 224, 139)\n}\n\n.RdYlGn .q3-7 {\n    fill: rgb(255, 255, 191)\n}\n\n.RdYlGn .q4-7 {\n    fill: rgb(217, 239, 139)\n}\n\n.RdYlGn .q5-7 {\n    fill: rgb(145, 207, 96)\n}\n\n.RdYlGn .q6-7 {\n    fill: rgb(26, 152, 80)\n}\n\n.RdYlGn .q0-8 {\n    fill: rgb(215, 48, 39)\n}\n\n.RdYlGn .q1-8 {\n    fill: rgb(244, 109, 67)\n}\n\n.RdYlGn .q2-8 {\n    fill: rgb(253, 174, 97)\n}\n\n.RdYlGn .q3-8 {\n    fill: rgb(254, 224, 139)\n}\n\n.RdYlGn .q4-8 {\n    fill: rgb(217, 239, 139)\n}\n\n.RdYlGn .q5-8 {\n    fill: rgb(166, 217, 106)\n}\n\n.RdYlGn .q6-8 {\n    fill: rgb(102, 189, 99)\n}\n\n.RdYlGn .q7-8 {\n    fill: rgb(26, 152, 80)\n}\n\n.RdYlGn .q0-9 {\n    fill: rgb(215, 48, 39)\n}\n\n.RdYlGn .q1-9 {\n    fill: rgb(244, 109, 67)\n}\n\n.RdYlGn .q2-9 {\n    fill: rgb(253, 174, 97)\n}\n\n.RdYlGn .q3-9 {\n    fill: rgb(254, 224, 139)\n}\n\n.RdYlGn .q4-9 {\n    fill: rgb(255, 255, 191)\n}\n\n.RdYlGn .q5-9 {\n    fill: rgb(217, 239, 139)\n}\n\n.RdYlGn .q6-9 {\n    fill: rgb(166, 217, 106)\n}\n\n.RdYlGn .q7-9 {\n    fill: rgb(102, 189, 99)\n}\n\n.RdYlGn .q8-9 {\n    fill: rgb(26, 152, 80)\n}\n\n.RdYlGn .q0-10 {\n    fill: rgb(165, 0, 38)\n}\n\n.RdYlGn .q1-10 {\n    fill: rgb(215, 48, 39)\n}\n\n.RdYlGn .q2-10 {\n    fill: rgb(244, 109, 67)\n}\n\n.RdYlGn .q3-10 {\n    fill: rgb(253, 174, 97)\n}\n\n.RdYlGn .q4-10 {\n    fill: rgb(254, 224, 139)\n}\n\n.RdYlGn .q5-10 {\n    fill: rgb(217, 239, 139)\n}\n\n.RdYlGn .q6-10 {\n    fill: rgb(166, 217, 106)\n}\n\n.RdYlGn .q7-10 {\n    fill: rgb(102, 189, 99)\n}\n\n.RdYlGn .q8-10 {\n    fill: rgb(26, 152, 80)\n}\n\n.RdYlGn .q9-10 {\n    fill: rgb(0, 104, 55)\n}\n\n.RdYlGn .q0-11 {\n    fill: rgb(165, 0, 38)\n}\n\n.RdYlGn .q1-11 {\n    fill: rgb(215, 48, 39)\n}\n\n.RdYlGn .q2-11 {\n    fill: rgb(244, 109, 67)\n}\n\n.RdYlGn .q3-11 {\n    fill: rgb(253, 174, 97)\n}\n\n.RdYlGn .q4-11 {\n    fill: rgb(254, 224, 139)\n}\n\n.RdYlGn .q5-11 {\n    fill: rgb(255, 255, 191)\n}\n\n.RdYlGn .q6-11 {\n    fill: rgb(217, 239, 139)\n}\n\n.RdYlGn .q7-11 {\n    fill: rgb(166, 217, 106)\n}\n\n.RdYlGn .q8-11 {\n    fill: rgb(102, 189, 99)\n}\n\n.RdYlGn .q9-11 {\n    fill: rgb(26, 152, 80)\n}\n\n.RdYlGn .q10-11 {\n    fill: rgb(0, 104, 55)\n}\n",".full-height {\n    float: left;\n    height: 100%;\n    width: 100%;\n}\n\n.dashboard * {\n    box-sizing: border-box;\n    -moz-box-sizing: border-box;\n}\n\n.dashboard .wmui-header {\n    margin: 0;\n    padding: 10px;\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    height: 74px;\n}\n\n.dashboard .wmui-toolbox {\n    position: absolute;\n    top: 15px;\n    right: 0;\n}\n\n.dashboard .wmui-header h2, .dashboard .wmui-header h5 {\n    margin: 0;\n}\n\n.dashboard .content {\n    position: absolute;\n    border: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    /* min-width: 1000px; */\n    min-height: 783px;\n}\n\n#widgets-wrapper.edit-mode {\n    border: dashed 1px #8A8A8A;\n    box-shadow: none;\n    border-radius: 2px;\n    padding: 1% 0 0 1%;\n    margin: 1%;\n}\n\n.dashboard .content .automation {\n    position: relative;\n    padding: 0;\n    float: left;\n    width: 100%;\n    min-width: 1000px;\n    height: 40%;\n    min-height: 400px;\n}\n\n.dashboard .content .info {\n    position: relative;\n    padding: 0;\n    float: left;\n    width: 12%;\n    min-width: 120px;\n    height: 32%;\n    min-height: 250px;\n}\n\n.dashboard .content .info .section {\n    padding: 20px 0 0 0;\n    margin: 0;\n}\n\n.dashboard .content .info .section .head .title {\n    font-size: 11px;\n    padding-left: 10px;\n    text-transform: none;\n}\n\n.dashboard .content .info .section .body li {\n    padding-left: 10px;\n}\n\n.dashboard .content .half {\n    position: relative;\n    float: left;\n    width: 50%;\n    min-width: 500px;\n    height: 25%;\n    min-height: 250px;\n}\n\n.dashboard .content .third {\n    position: relative;\n    float: left;\n    width: 33%;\n    min-width: 333px;\n    height: 33%;\n    min-height: 250px;\n}\n\n.dashboard table#automation {\n    margin: 0 0 25px 25px;\n    width: auto;\n    border-collapse: separate;\n}\n\n.dashboard table#automation th, .dashboard table#automation td {\n    width: auto;\n    padding: 0 10px;\n    font-weight: bold;\n}\n\n.dashboard table#automation td {\n    border: 1px solid #FFFFFF;\n    border-left-width: 0;\n    border-right-width: 0;\n}\n\n.dashboard table#automation td.values {\n    font-weight: normal;\n    text-align: center;\n}\n\n.objectives, .trends, .costs {\n    background: none repeat scroll 0 0 #F9F9F9;\n    background: -moz-linear-gradient(to bottom, #EEEEEE, #DDDDDD);\n    background: -webkit-gradient(linear, left top, left bottom, from(#EEEEEE), to(#DDDDDD));\n    filter: progid:DXImageTransform.Microsoft.Gradient(StartColorStr='#EEEEEE', EndColorStr='#DDDDDD', GradientType=0);\n    border: 1px solid #DDDDDD;\n    border-radius: 3px 3px 3px 3px;\n    box-shadow: 3px 3px 5px #F8F8F8;\n    margin: 10px;\n    width: 500px !important;\n    min-width: 500px !important;\n}\n\n.costs, .trends {\n    width: 400px !important;\n    min-width: 400px !important;\n}\n\n.rebuild-button, .sort-button {\n    float: right !important;\n    width: 30px !important;\n    line-height: 40px !important;\n    margin-right: 0 !important;\n    cursor: pointer;\n}\n\n/* New dashboard */\n\n.dashboard-inner {\n    padding-left: 20px;\n    height: 55px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.global-dashboard-title {\n    display: flex;\n    font-size: 20px;\n    text-align: left;\n    line-height: 20px;\n    vertical-align: middle;\n    color: #777777;\n    text-shadow: 0 1px 0 #FFFFFF;\n    margin-right: auto;\n}\n\n.global-dashboard-title svg {\n    margin-right: 10px;\n}\n\n.dashboard-inner-edit {\n    margin-top: 10px;\n    padding-left: 20px;\n    height: 30px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.dashboard-inner-edit.hidden-transition {\n    margin-top: 0px;\n}\n\n.global-dashboard-edit-title {\n    display: flex;\n    font-size: 12px;\n    text-align: left;\n    line-height: 12px;\n    vertical-align: middle;\n    color: #777777;\n    text-shadow: 0 1px 0 #FFFFFF;\n    margin-right: auto;\n}\n\n.global-dashboard-edit-title svg {\n    margin-right: 10px;\n}\n\n.navbar .nav.dashboard-options {\n    display: flex;\n    margin-left: auto;\n}\n\n.navbar.dashboard-navbar {\n    margin: 1% 1% 0 1%;\n}\n\n.dashboard.edit-mode .dashboard-inner {\n    display: none;\n}\n",".per-box dl {\n    margin: 1em;\n    font-size: 1em;\n    line-height: 1.5em;\n    overflow: hidden;\n}\n\n.per-box dl dt {\n    font-weight: bold;\n    float: left;\n    width: auto;\n    text-align: left;\n    padding-right: 5px;\n    font-size: 0.9167em;\n    line-height: 1.6364em;\n    clear: both;\n}\n\n.per-box dl dt::first-letter {\n    text-transform: capitalize;\n}\n\n.per-box dl dt.wise-box-name {\n    width: auto;\n}\n\n.per-box dd {\n    font-size: 1em;\n    line-height: 1.5em;\n    float: left;\n    width: auto;\n}\n\n.per-box dd select {\n    margin: .5em 0;\n}\n\ndd.link {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.intervals.no-border table.interval {\n    border: none;\n}\n\nspan.wise-box-schedule {\n    text-decoration: underline;\n    cursor: pointer;\n}\n","#toolbar {\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n    height: 50px;\n    border: 0;\n    display: -webkit-box;\n    background-color: #224C4F;\n}\n\n#toolbar .main-logo {\n    left: 10px;\n    max-width: 180px;\n    position: absolute;\n    top: 10px;\n}\n\n#toolbar .menu {\n    font-size: 11px;\n    color: white;\n    height: 35px;\n    position: absolute;\n    left: 215px;\n    right: 0;\n    top: 8px;\n    z-index: 100;\n    line-height: 35px;\n}\n\n#toolbar .menu .item {\n    float: left;\n    margin-right: 15px;\n}\n\n#toolbar .menu .item.organization {\n    float: right;\n    margin-top: 7px;\n}\n\n#toolbar .menu .item.username {\n    float: right;\n}\n\n#toolbar .menu .item.notifications,\n#toolbar .menu .item.wise-store {\n    cursor: pointer;\n    float: right;\n    margin-right: 20px;\n    height: inherit;\n    margin-top: 5px;;\n}\n\n#toolbar .menu .item.notifications,\n#toolbar .menu .item.wise-store {\n    &:hover {\n        color: #8BC53F;\n\n        .dropdown-main-icon {\n            color: #8BC53F;\n        }\n    }\n}\n\n#toolbar .menu .item .dropdown .dropdown-main:not(.current_user) {\n    &:hover {\n        color: #8BC53F;\n\n        .dropdown-main-icon {\n            color: #8BC53F;\n        }\n    }\n}\n\n#toolbar .menu .item.notifications .badge {\n    background-color: #E94547;\n    border-radius: 10px;\n    color: white;\n    cursor: pointer;\n    font-size: 9px;\n    font-weight: bold;\n    height: 10px;\n    line-height: 9px;\n    padding: 2px 4px 2px 3px;\n    position: relative;\n    right: -10px;\n    text-align: center;\n    top: -40px;\n    white-space: nowrap;\n    width: auto;\n}\n\n#toolbar .menu .item.change-organization {\n    cursor: pointer;\n    float: right;\n    margin-right: 15px;\n    height: inherit;\n}\n\n#toolbar .menu .item.change-organization #organizations {\n    background-color: transparent;\n    padding-right: 2px;\n    border: none;\n    color: #8BC53F;\n    font-weight: bold;\n    font-size: 12px;\n    height: 32px;\n    text-align: right;\n    margin-top: -4px;\n}\n\n#toolbar .menu .logo * {\n    height: 20px;\n    margin: 8px 0 0 0;\n}\n\n.dropdown {\n    cursor: pointer;\n}\n\n.dropdown a {\n    color: white;\n}\n\n.dropdown a:hover {\n    text-decoration: none;\n}\n\n.dropdown-main::first-letter {\n    text-transform: capitalize;\n}\n\n.dropdown-main.current_user {\n    border-radius: 50%;\n    background-color: #8BC53F;\n    font-weight: bold;\n    font-size: 11px;\n    color: #224C4F;\n    height: 34px;\n    text-align: center;\n    width: 34px;\n}\n\n.dropdown-main.content {\n    border-radius: 50%;\n    font-weight: bold;\n    font-size: 14px;\n    color: #333333;\n    height: 34px;\n    text-align: center;\n    width: 34px;\n    display: flex;\n    flex-flow: column;\n    justify-content: space-around;\n\n    &:hover {\n        background-color: #EEEEEE;\n        color: #224C4F !important;\n        font-weight: bold;\n        font-size: 16px;\n    }\n}\n\n.dropdown:hover .dropdown-main:not(.content) {\n    color: white;\n}\n\n.dropdown:hover .dropdown-main.content {\n    background-color: #EEEEEE;\n    color: #224C4F !important;\n    font-weight: bold;\n    font-size: 16px;\n}\n\n.dropdown-main img {\n    margin-top: 7px;\n}\n\n.dropdown-section:hover::after {\n    border-bottom-color: #7A9395;\n}\n\n.dropdown-section::after {\n    border: 5px solid rgba(48, 48, 48, 0);\n    border-bottom-color: #224C4F;\n    bottom: 100%;\n    content: \" \";\n    height: 0;\n    left: 50%;\n    margin-left: -5px;\n    pointer-events: none;\n    position: absolute;\n    right: auto;\n    text-align: center;\n    transform: translate(-50%, 0);\n}\n\n.dropdown-section {\n    background-clip: padding-box;\n    background-color: #224C4F;\n    border-radius: 0;\n    border-top: 15px solid transparent;\n    display: none;\n    left: 50%;\n    position: absolute;\n    /* https://stackoverflow.com/a/28078054/1787187 */\n    right: auto;\n    text-align: center;\n    transform: translate(-50%, 0);\n    width: 200px;\n}\n\n.dropdown-section::first-letter {\n    text-transform: capitalize;\n}\n\n.dropdown-section.menu-right::after {\n    border: 5px solid rgba(48, 48, 48, 0);\n    border-bottom-color: #224C4F;\n    bottom: 100%;\n    content: \" \";\n    height: 0;\n    left: 95%;\n    pointer-events: none;\n    position: absolute;\n    right: auto;\n    text-align: center;\n    transform: translate(-50%, 0);\n}\n\n.dropdown-section.menu-right {\n    background-clip: padding-box;\n    background-color: #224C4F;\n    border-radius: 0;\n    border-top: 17px solid transparent;\n    display: none;\n    left: -230%;\n    position: absolute;\n    /* https://stackoverflow.com/a/28078054/1787187 */\n    right: auto;\n    text-align: center;\n    transform: translate(-50%, 0);\n    width: 220px;\n}\n\n.dropdown-section.content::after {\n    border: 5px solid rgba(48, 48, 48, 0);\n    border-bottom-color: #224C4F;\n    bottom: 100%;\n    content: \" \";\n    height: 0;\n    pointer-events: none;\n    position: absolute;\n    right: auto;\n    text-align: center;\n    transform: translate(-50%, 0);\n    left: 95%;\n}\n\n.dropdown-section.content {\n    z-index: 1000;\n    left: -230%;\n    position: absolute;\n    /* https://stackoverflow.com/a/28078054/1787187 */\n    right: auto;\n    transform: translate(-50%, 0);\n    width: 220px;\n}\n\n.dropdown-section.content > a > .dropdown-section-item {\n    padding: 10px;\n}\n\n.dropdown-toggle::after {\n    float: right;\n}\n\n.dropdown-section-icon, .dropdown-main-icon {\n    color: white;\n    float: left;\n    font-size: 14px;\n    margin: 0 14px;\n    min-width: 22px;\n    text-align: center;\n}\n\n.dropdown-main-icon {\n    margin: 0 5px 0 0;\n}\n\n.dropdown-section-item {\n    border-bottom: 1px solid #7A9395;\n    text-align: left;\n\n    &::first-letter {\n        text-transform: capitalize;\n    }\n}\n\n.dropdown-section-item:hover {\n    background-color: #8BC53F;\n    color: white;\n}\n\n.dropdown-section-item:hover .dropdown-section-icon {\n    color: white;\n}\n\n.dropdown-section-item .dropdown-item {\n    display: flex;\n    justify-content: space-between;\n\n    :first-letter {\n        text-transform: capitalize;\n    }\n}\n\n.dropdown-section-item .dropdown-item .lock {\n    padding-right: 15px;\n    color: #7A9395;\n}\n\n",".panels_container.regular:has(> .drop-zone-overlay.active) #content-menu {\n    position: relative;\n    z-index: 201;\n}\n\n.drop-zone-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    display: none;\n    align-items: center;\n    justify-content: center;\n    z-index: 300;\n    pointer-events: none;\n}\n\n.drop-zone-overlay.active {\n    display: flex;\n    pointer-events: auto;\n    background-color: rgba(34, 76, 79, 0.48);\n}\n\n.drop-zone-overlay.success {\n    background-color: rgba(34, 76, 79, 0.36);\n}\n\n.drop-zone-overlay span {\n    display: inline-flex;\n    align-items: center;\n    gap: 14px;\n    font-size: 18px;\n    color: white;\n    font-weight: bold;\n    padding: 20px 40px;\n    background-color: #224C4F;\n    border-radius: 8px;\n    opacity: 1;\n    transition: opacity 160ms ease, transform 180ms ease, background-color 180ms ease;\n}\n\n.drop-zone-overlay span.changing {\n    opacity: 0;\n    transform: translateY(6px) scale(0.98);\n}\n\n.drop-zone-overlay span.entering {\n    opacity: 0;\n    transform: translateY(-6px) scale(1.01);\n}\n\n.drop-zone-overlay.success span {\n    transform: scale(1.03);\n    background-color: #2F7D5C;\n}\n\n.drop-zone-overlay.success span.changing {\n    transform: translateY(6px) scale(0.98);\n}\n\n.drop-zone-overlay.success span.entering {\n    transform: translateY(-6px) scale(1.01);\n}\n\n.drop-zone-icon {\n    font-size: 22px;\n}\n\n.drop-zone-field {\n    margin: 10px;\n    padding: 28px 20px;\n    border: 2px dashed #c7d3d4;\n    border-radius: 8px;\n    background-color: #f7fafa;\n    color: #224C4F;\n    cursor: pointer;\n    text-align: center;\n    transition: border-color 160ms ease, background-color 160ms ease;\n}\n\n.drop-zone-field:hover,\n.drop-zone-field.active {\n    border-color: #224C4F;\n    background-color: #eef4f4;\n}\n\n.drop-zone-field-icon {\n    display: block;\n    margin-bottom: 10px;\n    font-size: 26px;\n}\n\n.drop-zone-field-hint {\n    display: block;\n    margin-top: 6px;\n    color: #6b7f80;\n    font-size: 12px;\n}\n\n.drop-zone-file-list {\n    margin: 0 10px 10px;\n    padding: 0;\n    max-height: 180px;\n    overflow-y: auto;\n    list-style: none;\n}\n\n.drop-zone-file-list li {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 4px;\n    border-bottom: 1px solid #eceff0;\n    font-size: 13px;\n}\n\n.drop-zone-file-name {\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.drop-zone-file-size {\n    color: #6b7f80;\n    font-size: 12px;\n}\n\n.drop-zone-file-remove {\n    color: #e94547;\n    cursor: pointer;\n}\n\n.drop-zone-overlay.success .drop-zone-icon {\n    animation: drop-zone-check 240ms ease-out;\n}\n\n@keyframes drop-zone-check {\n    0% {\n        transform: scale(0.4);\n        opacity: 0;\n    }\n\n    70% {\n        transform: scale(1.18);\n        opacity: 1;\n    }\n\n    100% {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n","#modal-backdrop {\n    display: none;\n    position: fixed;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.15);\n    z-index: 1000;\n}\n\n#modal-errors.active {\n    background-color: rgba(200, 0, 0, 0.25);\n    border: 2px solid #CC0000;\n    color: #CC0000;\n    margin: 10px 10px 0;\n    padding: 10px;\n}\n\n.modal_blocker {\n    z-index: 1001;\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    opacity: 0.7;\n    background: none no-repeat scroll center center white;\n    text-align: center;\n}\n\n.modal_blocker_container {\n    position: relative;\n    top: 50%;\n}\n\n.modal_loading {\n    color: #666666;\n    border: 1px solid #CCCCCC;\n    font-size: 16px;\n    margin: 10px;\n    padding: 20px;\n    text-align: center;\n}\n\n.modal-description-warning {\n    color: #CC0000;\n}\n\n.modal-description-container {\n    padding: 10px;\n    margin: 10px 0;\n    border-radius: 4px;\n    background-color: #F2F2F2;\n}\n\n.modal-description-title {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.modal-description-title p {\n    margin: 0;\n}\n\n#etl_extra_description {\n    margin-bottom: 0px;\n}\n",".card.plan.selected {\n    border: #8BC53F solid 2px;\n    position: relative;\n}\n\n.plan {\n    border: 2px solid #224C4F;\n    border-radius: 4px;\n    padding: 20px 20px;\n}\n\n.plan > .plan-title {\n    text-transform: capitalize;\n    text-align: center;\n    font-weight: bold;\n    font-size: 15px;\n    color: #224C4F;\n}\n\n.plan > .plan-description {\n    text-align: left;\n    color: #224C4F;\n    margin: 40px 0 40px 0;\n    min-height: 270px;\n}\n\n.plan > .plan-description > .item {\n    display: flex;\n\n    div:first-child {\n        margin-right: 10px;\n    }\n}\n\n.plan > .plan-changer > .plan-changer-button {\n    width: 100%;\n    padding: 10px;\n    background: #224C4F;\n    color: #FFFFFF;\n    border: none;\n    border-radius: 3px;\n    cursor: pointer;\n    text-align: center;\n\n    &:hover {\n        background-color: #8BC53F;\n    }\n\n    &:disabled {\n        background-color: #F8F8F8;\n        color: #224C4F;\n        cursor: not-allowed;\n    }\n}\n\n.features {\n    font-weight: bold;\n    text-transform: capitalize;\n}\n\n.plans-accordion {\n    background-color: #F8F8F8;\n}\n\n.btn-group-organization {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n    padding: 2% 0%;\n    width: 100%;\n}\n\n.btn-group-organization > .btn {\n    border-color: #224C4F;\n    font-weight: bold;\n    height: auto;\n    margin: 0;\n    padding: 10px;\n    position: relative;\n    text-transform: capitalize;\n    width: auto;\n}\n\n.btn-group-organization > .btn:hover {\n    background-color: #8BC53F;\n    color: white;\n    text-shadow: none;\n}\n\n.btn-group-organization > .btn-essentials {\n    background-color: white;\n    color: #224C4F;\n}\n\n.btn-group-organization > .btn-standard {\n    background-color: #E6E7E8;\n    color: #224C4F;\n}\n\n.btn-group-organization > .btn-advanced {\n    background-color: #BBBDBF;\n    color: #224C4F;\n}\n\n.btn-group-organization > .btn-premium {\n    background-color: #224C4F;\n    color: #8BC53F;\n}\n\n.btn-group-organization > .selected {\n    background-color: #8BC53F;\n    color: white;\n    text-shadow: none;\n}\n\n.organization-details, .site-details {\n    display: flex;\n    justify-content: space-between;\n}\n\n.organization-details > .per-box > dl > dd > img {\n    max-height: 90px;\n}\n\n.site-details > .per-box > img {\n    max-height: 180px;\n}\n","body {\n    height: 100%;\n}\n\n.wmui-btn-n {\n    display: inline-block;\n    padding: 0 4px !important;\n    margin: 0 2px 0 0 !important;\n    border: 1px solid transparent;\n    font-size: 8px !important;\n    border: 1px solid #E3E3E3;\n    background: #F3F3F3;\n    color: gray;\n    cursor: pointer;\n    border-radius: 9px !important;\n    -moz-border-radius: 9px !important;\n}\n\n.wmui-btn-n.edt:hover {\n    background-color: #8BC53F;\n    color: white !important;\n    border-color: #8BC53F !important;\n}\n\n.wmui-btn-n.dlt:hover {\n    background-color: red;\n    color: white !important;\n    border-color: red !important;\n}\n\n.wmui-btn-n:hover {\n    background: #C3C3C3;\n    border: 1px solid gray;\n    color: black !important;\n}\n\n.pad {\n    color: black;\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    left: 0;\n}\n\nul li.label {\n    cursor: normal;\n    font-size: 10px;\n    margin: 0 !important;\n    padding: 2px 3px 0 0 !important;\n    font-weight: bold;\n    color: black;\n}\n\nul li.label::first-letter {\n    text-transform: capitalize;\n}\n\nul li.label.comparison {\n    margin-top: 3px !important;\n    padding-top: 3px !important;\n}\n\nul.grp_btn {\n    border: 1px solid #E3E3E3;\n    border-radius: 3px !important;\n    -moz-border-radius: 3px !important;\n    overflow: auto;\n}\n\nul.grp_btn li {\n    padding: 1px 3px !important;\n    font-size: 10px;\n    cursor: pointer;\n    margin: 0 2px 0 0 !important;\n    border-right: 1px solid #E3E3E3;\n    width: 16px;\n    text-align: center;\n}\n\nul.grp_btn li.on {\n    background: #E3E3E3;\n    color: white;\n}\n\nul.grp_btn li.last {\n    border: none;\n}\n\nul.btns li.btn, ul.ctrl li.btn {\n    border: 1px solid gray !important;\n    background-color: #E3E3E3 !important;\n    border-radius: 3px !important;\n    -moz-border-radius: 3px !important;\n    border-radius: 3px !important;\n    cursor: pointer;\n    font-size: 10px !important;\n    margin: 5px 2px 0 0 !important;\n    color: #8BC53F !important;\n    padding: 1px 3px !important;\n    width: auto;\n}\n\nul.btns li.btn:hover, ul.ctrl li.btn:hover {\n    color: white !important;\n    background-color: gray !important;\n}\n\ndiv.wmui-split_view {\n    /*position: absolute;*/\n    overflow: auto;\n    right: 0;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    background-color: white;\n}\n\ndiv.wmui-split_view.collapsed_inspector_panel .ph_left {\n    margin-right: 0 !important;\n}\n\ndiv.wmui-split_view.collapsed_inspector_panel .ph_right {\n    display: none;\n}\n\ndiv.wmui-split_view .ph_left {\n    background-color: white;\n}\n\ndiv.wmui-split_view .ph_left .wmui-view {\n    /* padding: 15px; */\n}\n\ndiv.wmui-split_view .ph_left.grayed {\n    background-color: #F3F3F3;\n}\n\ndiv.wmui-split_view .ph_left .ph_handler {\n    left: 0 !important;\n    height: 100%;\n    overflow: hidden;\n    float: right;\n    cursor: col-resize;\n    border-right: 1px solid #E8E8E8;\n    border-left: 1px solid #E8E8E8;\n    width: 4px;\n    background-color: white;\n    background-image: url(\"/images/ui/dot.png\");\n    background-repeat: no-repeat;\n    background-position: 0 0;\n    background-position: 50% 50% !important;\n}\n\ndiv.wmui-split_view .ph_right {\n    position: absolute;\n    right: 0;\n    padding-top: 0;\n    overflow: hidden;\n    padding-top: 0;\n}\n\ndiv.wmui-split_view .ph_right.grayed {\n    background-color: #F3F3F3;\n}\n\ndiv.wmui-split_view .ph_right div.body, div.wmui-split_view .ph_right div.wmui-detail-list {\n    background-color: #F3F3F3;\n    border-bottom: 1px dotted #E3E3E3;\n}\n\ndiv.wmui-split_view .ph_right .section {\n    margin-top: 0;\n}\n\n.clr {\n    clear: both;\n    height: 1px;\n    width: 100%;\n    overflow: hidden;\n}\n\n.wmui-help-box {\n    border: 1px solid #E7E7E7;\n    background-color: #F7F7F7;\n    padding: 10px !important;\n    margin: 5px !important;\n    font-size: 10px;\n    font-style: italic;\n    padding: 10px;\n    color: gray;\n}\n\n.wmui-msg-box {\n    font-size: 10px !important;\n    text-align: center !important;\n    text-shadow: white 1px 1px 0;\n    color: rgba(0, 0, 0, 0.6);\n    border: 1px solid #E7E7E7;\n    background-color: #F7F7F7;\n    padding: 10px !important;\n    margin: 5px 5px 10px !important;\n    padding: 5px;\n}\n\n.wmui-section {\n    margin: 0;\n    padding: 0;\n}\n\n.wmui-section .head {\n    border-bottom: 1px solid white;\n    font-size: 9px !important;\n    background-color: #333333;\n}\n\n.wmui-section .head:hover {\n    background-color: black;\n}\n\n.wmui-section .head .title {\n    color: white;\n    padding: 5px;\n    font-size: 9px;\n}\n\n.wmui-section .head .toolbar {\n    margin: 0 !important;\n    color: white;\n}\n\n.wmui-section .head .wmui-toolbar {\n    margin: 10px 10px !important;\n}\n\n.wmui-section .body ul.items {\n    margin-right: 0 !important;\n}\n\n.wmui-section .body > div {\n    margin-bottom: 18px;\n}\n\n.wmui-section .body dl {\n    /* margin: 0 15px 0 5px; */\n}\n\n.wmui-section .body hr {\n    background-color: #E4E4E4;\n    border: 0;\n    height: 1px;\n    display: inline-block;\n    margin: 0;\n    padding: 0;\n}\n\n.wmui-section .body dt {\n    clear: both;\n}\n\n.wmui-section .body dd {\n    cursor: text;\n}\n\n.wmui-section .body dd span {\n    padding: 0;\n}\n\n.wmui-section .body hr {\n    margin: 0 0 10px !important;\n    display: inline-block;\n}\n\n.wmui-hc {\n    overflow: hidden;\n}\n\n.wmui-chart {\n    position: relative;\n    background-color: white !important;\n    border-bottom: 0 solid #E3E3E3;\n    border-left: 0 solid #E3E3E3;\n    border-right: 0 solid #E3E3E3;\n    height: auto;\n}\n\ndiv.grp_ctrl {\n    border-top: 0 solid #F3F3F3;\n    border-bottom: 0 solid #F3F3F3;\n    padding: 0;\n}\n\ndiv.grp_ctrl.wmui-chart-toolbar {\n    width: 100%;\n    overflow: hidden;\n    background: white;\n    min-height: 36px;\n}\n\ndiv.grp_ctrl div {\n    display: inline-block;\n    padding: 5px;\n    float: left;\n}\n\ndiv.grp_ctrl div.title {\n    font-size: 120%;\n    color: rgb(119, 119, 119);\n    line-height: 28px;\n    padding-right: 10px;\n}\n\ndiv.grp_ctrl div.wmui-chart-control-resolution {\n    background: white;\n}\n\ndiv.grp_ctrl div.wmui-chart-control-operation {\n    background: white;\n    border: none !important;\n}\n\ndiv.grp_ctrl div.wmui-chart-control-activity {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    top: 300px;\n    left: 50%;\n    z-index: 900000;\n    margin-left: -110px;\n    width: 200px;\n    height: 80px;\n    padding: 4px 8px;\n    background: rgba(233, 233, 233, 0.2);\n    border: 1px solid #E3E3E3;\n    border-radius: 3px !important;\n    -moz-border-radius: 3px !important;\n    border-radius: 3px !important;\n    box-shadow: rgba(0, 0, 0, 0.08) 0 5px 5px;\n}\n\ndiv.grp_ctrl div.wmui-chart-control-activity.loading {\n    border: none;\n    background: none;\n    box-shadow: none;\n}\n\ndiv.grp_ctrl div.wmui-chart-control-activity img {\n    float: left;\n    margin-right: 5px;\n    display: none;\n}\n\ndiv.grp_ctrl div.wmui-chart-control-activity h4 {\n    width: 100%;\n    display: inline-block;\n    padding-top: 22px;\n    color: rgba(0, 0, 0, 0.5);\n    text-align: center;\n    font-size: 24px !important;\n    font-weight: bold;\n}\n\nul.ctrl {\n    overflow: auto;\n    padding: 5px;\n}\n\nul.ctrl li {\n    display: block-inline;\n    height: auto;\n    color: #224C4F !important;\n}\n\nul.ctrl li.mode {\n    border-radius: 3px !important;\n    -moz-border-radius: 3px !important;\n    border: 1px solid transparent !important;\n    padding: 1px 3px !important;\n    font-size: 10px;\n    cursor: pointer;\n    margin: 0 2px 0 0 !important;\n    text-align: center;\n}\n\nul.ctrl li.not-selectable {\n    border-radius: 3px !important;\n    -moz-border-radius: 3px !important;\n    border: 1px solid transparent !important;\n    padding: 1px 3px !important;\n    font-size: 10px;\n    margin: 0 5px 0 0 !important;\n    color: #888888;\n    text-align: center;\n}\n\nul.ctrl li.mode:hover:not(.locked) {\n    background: rgb(34, 76, 79);\n    color: #FFFFFF !important;\n}\n\nul.ctrl li.mode.disabled:hover {\n    text-decoration: none;\n    cursor: default;\n}\n\nul.ctrl li.mode.current {\n    border: 1px solid #8BC53F !important;\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#8E93D5', endColorstr='#2731AE', GradientType=0);\n    color: white !important;\n    background-color: #8BC53F !important;\n}\n\nul.ctrl li.locked {\n    color: #E3E3E3 !important;\n    cursor: default !important;\n}\n\nul.ctrl li.locked:hover {\n    text-decoration: none !important;\n}\n\n.wmui-chart-control-operation {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n}\n\n.wmui-chart-control-operation ul.ctrl {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n}\n\n.wmui-chart-control-date_time, .wmui-chart-control-text {\n    padding: 4px !important;\n}\n\n.wmui-chart-control-text {\n    float: none !important;\n    background-color: white;\n    z-index: 999999;\n    left: 20px;\n    margin-top: 0;\n    border: none !important;\n    padding: 0 !important;\n    height: 20px;\n}\n\n.wmui-hc-analyze {\n    margin-top: 18px;\n}\n\n.wmui-chart-control-period ul li label {\n    margin-right: 5px;\n}\n\n.wmui-chart-control-date_time, .wmui-chart-control-text, .wmui-chart-compare {\n    padding: 0;\n}\n\n.wmui-chart-control-date_time ul.ctrl, .wmui-chart-control-text ul.ctrl, .wmui-chart-compare ul.ctrl {\n    border: none !important;\n}\n\n.wmui-chart-control-date_time ul.ctrl li, .wmui-chart-control-text ul.ctrl li, .wmui-chart-compare ul.ctrl li {\n    float: left;\n    margin: 0 0;\n}\n\n.wmui-chart-control-date_time ul.ctrl li.invalid input, .wmui-chart-control-text ul.ctrl li.invalid input, .wmui-chart-compare ul.ctrl li.invalid input {\n    color: red !important;\n}\n\n.wmui-chart-control-date_time ul.ctrl li.field:hover, .wmui-chart-control-text ul.ctrl li.field:hover, .wmui-chart-compare ul.ctrl li.field:hover {\n    border: 1px solid #8BC53F !important;\n    background-color: #EDF5FF !important;\n}\n\n.wmui-chart-control-date_time ul.ctrl li.field:focus, .wmui-chart-control-text ul.ctrl li.field:focus, .wmui-chart-compare ul.ctrl li.field:focus {\n    border: 1px solid #8BC53F !important;\n    background-color: #EDF5FF !important;\n}\n\n.wmui-chart-control-date_time ul.ctrl li input, .wmui-chart-control-text ul.ctrl li input, .wmui-chart-compare ul.ctrl li input {\n    display: inline-block;\n    float: left;\n    color: #224C4F !important;\n    font-size: 10px;\n    padding: 3px 5px !important;\n    margin-right: 0 !important;\n    border: none;\n    width: 52px;\n    background: transparent !important;\n}\n\n.wmui-chart-control-date_time ul.ctrl li.legend, .wmui-chart-control-text ul.ctrl li.legend, .wmui-chart-compare ul.ctrl li.legend {\n    font-size: 10px;\n}\n\n.wmui-chart-control-date_time ul.ctrl li.legend span, .wmui-chart-control-text ul.ctrl li.legend span, .wmui-chart-compare ul.ctrl li.legend span {\n    font-weight: bold;\n}\n\n.wmui-chart-control-date_time ul.ctrl li.label, .wmui-chart-control-text ul.ctrl li.label, .wmui-chart-compare ul.ctrl li.label {\n    margin: 0 5px !important;\n}\n\n.wmui-chart-compare ul.ctrl li.label {\n    color: white !important;\n}\n\n.wmui-chart-compare ul.ctrl li.label.comparison {\n    margin-top: 3px !important;\n}\n\n.wmui-chart-control-date_time ul.ctrl li.border, .wmui-chart-control-text ul.ctrl li.border, .wmui-chart-compare ul.ctrl li.border {\n    border: 1px solid #E3E3E3;\n}\n\n.wmui-chart-control-date_time ul.ctrl li.box, .wmui-chart-control-text ul.ctrl li.box, .wmui-chart-compare ul.ctrl li.box {\n    border-left-width: none !important;\n    height: 18px !important;\n    padding: 0 3px;\n    margin: 0 10px 0 0 !important;\n    cursor: pointer;\n    color: black !important;\n}\n\n.wmui-chart-control-date_time ul.ctrl li.box:hover, .wmui-chart-control-text ul.ctrl li.box:hover, .wmui-chart-compare ul.ctrl li.box:hover {\n    color: #A1A1A1 !important;\n    background-color: #E2E6EB !important;\n    border: 1px solid #E3E3E3 !important;\n    border-left-width: 0 !important;\n}\n\n.wmui-chart-control-date_time ul.ctrl li.ui_date_picker, .wmui-chart-control-text ul.ctrl li.ui_date_picker, .wmui-chart-compare ul.ctrl li.ui_date_picker {\n    color: #E3E3E3 !important;\n    border-left-width: 0;\n}\n\n.wmui-chart-compare {\n    width: 100%;\n    height: auto;\n    background-color: #8BC53F;\n    color: white;\n    position: relative;\n}\n\n.wmui-chart-compare ul li.black {\n    color: black !important;\n}\n\n.wmui-chart-compare ul li.btn {\n    margin: 2px 10px 0 1px !important;\n}\n\n.wmui-chart-compare ul li {\n    margin: 0 3px 0 0 !important;\n}\n\n.wmui-chart-compare ul li .wmui-icon {\n    margin: 4px 0 0 2px;\n}\n\n.wmui-chart-compare ul li.regular {\n    background-color: white;\n    margin: 0px !important;\n}\n\n.wmui-chart-compare ul li.regular input {\n    width: 250px !important;\n    padding: 10px;\n    font-weight: bold;\n}\n\n.wmui-chart-compare ul li.regular input::placeholder {\n    color: #797979;\n    font-weight: normal;\n}\n\n.wmui-chart-compare ul li.regular:hover {\n    border: 1px solid #8BC53F !important;\n    background-color: white !important;\n}\n\n.wmui-chart-compare ul li ul.items {\n    overflow: hidden;\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\n.wmui-chart-compare ul li ul.items li {\n    float: left;\n    padding: 0 8px;\n    margin: 2px !important;\n    background: #224C4F;\n    border-radius: 3px !important;\n    -moz-border-radius: 3px !important;\n}\n\n\n.wmui-chart-compare ul li ul.items li a, .wmui-chart-compare ul li ul.items li label {\n    cursor: pointer;\n    color: white !important;\n}\n\n.wmui-chart-compare ul li ul.items li .rm {\n    cursor: pointer;\n    float: left;\n    color: white;\n}\n\n.wmui-chart-compare ul li ul.items li .rm:hover {\n    color: red !important;\n}\n\n.wmui-chart-compare ul li ul.items li label {\n    font-size: 10px;\n    color: black;\n    float: left;\n    padding: 6px 3px;\n}\n\n.wmui-chart-compare ul li ul.items li label:hover {\n    color: #8BC53F !important;\n}\n\n.wmui-chart-compare ul li ul.items li input[type=checkbox] {\n    margin: 7px 3px 0 0 !important;\n    width: auto !important;\n    float: left;\n}\n\n.wmui-search-result-list {\n    box-shadow: rgba(0, 0, 0, 0.08) 0 5px 5px;\n    position: absolute;\n    z-index: 900001;\n    height: auto;\n    width: 415px;\n    top: 38px;\n    left: 80px;\n    border-top: none;\n    border-right: 1px solid #E3E3E3;\n    border-left: 1px solid #E3E3E3;\n    border-bottom: 1px solid #E3E3E3;\n    background: white;\n    max-height: 450px;\n    overflow: auto;\n}\n\n.wmui-search-result-list ul.wmui-search-items {\n    padding: 5px 5px !important;\n    margin: 0 !important;\n    background-color: #224C4F;\n    border: none;\n    overflow: hidden;\n}\n\n.wmui-search-result-list ul.wmui-search-items li {\n    color: white;\n    margin: 0 !important;\n    padding: 2px 5px !important;\n    width: 385px;\n    font-size: 10px;\n    clear: both;\n    font-weight: bold;\n    border-bottom: 1px solid #F3F3F3;\n}\n\n.wmui-search-result-list ul.wmui-search-items li div.item-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center\n}\n\n.wmui-search-result-list ul.wmui-search-items li div.item-info div.wmui-btn {\n    height: fit-content;\n}\n\n.wmui-search-result-list ul.wmui-search-items li.inactive {\n    background-color: rgba(0, 0, 0, 0.02) !important;\n}\n\n.wmui-search-result-list ul.wmui-search-items li.inactive label {\n    color: #E3E3E3 !important;\n}\n\n.wmui-search-result-list ul.wmui-search-items li.inactive:hover {\n    background-color: rgba(0, 0, 0, 0.02) !important;\n}\n\n.wmui-search-result-list ul.wmui-search-items li.inactive .icon {\n    opacity: 0.3;\n}\n\n.wmui-search-result-list ul.wmui-search-items li.bottom_bar {\n    padding: 5px 5px 2px 0 !important;\n}\n\n.wmui-search-result-list ul.wmui-search-items li.bottom_bar:hover {\n    background-color: transparent !important;\n}\n\n.wmui-search-result-list ul.wmui-search-items li.bottom_bar:hover label {\n    color: black !important;\n    font-size: 9px !important;\n}\n\n.wmui-search-result-list ul.wmui-search-items li.bottom_bar label {\n    color: white;\n}\n\n.wmui-search-result-list ul.wmui-search-items li:last-child {\n    border: none;\n}\n\n.wmui-search-result-list ul.wmui-search-items li div.wmui-icon {\n    float: left;\n}\n\n.wmui-search-result-list ul.wmui-search-items li.last {\n    border-bottom: none !important;\n}\n\n.wmui-search-result-list ul.wmui-search-items li label {\n    font-size: 9px !important;\n    cursor: pointer !important;\n    color: white !important;\n}\n\n.wmui-search-result-list ul.wmui-search-items li:hover {\n    background-color: #404040 !important;\n    color: white !important;\n}\n\n.wmui-search-result-list ul.wmui-search-items li:hover .wmui-btn {\n    background-color: #8BC53F !important;\n    color: white !important;\n}\n\n.wmui-search-result-list ul.wmui-search-items li ul.toolbar {\n    padding: 0 !important;\n    margin: 0 !important;\n    width: auto;\n}\n\n.wmui-search-result-list ul.wmui-search-items li ul.toolbar .rgt {\n    float: right;\n}\n\n.wmui-search-result-list ul.wmui-search-items li ul.toolbar li {\n    margin: 0;\n    padding: 0;\n}\n\n.wmui-search-result-list ul.wmui-search-items li ul.toolbar li .wmui-btn {\n    display: inline-block;\n    float: right;\n    width: auto;\n    margin: 0;\n    padding: 0;\n}\n\ndiv.wmui-icn {\n    width: 16px;\n    height: 16px;\n    float: left;\n    margin-right: 8px;\n}\n\ndiv.wmui-btn,\ndiv.pagination a,\nul.toolbar.form li.wmui-btn a,\nul.toolbar.regular li.wmui-btn a {\n    text-decoration: none;\n    border-radius: 3px !important;\n    -moz-border-radius: 3px !important;\n    text-shadow: none;\n    display: inline-block;\n    padding: 2px 6px 2px 6px !important;\n    margin: 0;\n    font-size: 9px;\n    cursor: pointer;\n    text-align: center;\n    text-transform: capitalize;\n    background-color: #D3D3D3;\n    border: 1px solid #C3C3C3;\n    color: #444444;\n}\n\ndiv.wmui-btn:hover,\ndiv.pagination a:hover,\nul.toolbar.regular li.wmui-btn a:hover,\nul.toolbar.form li.wmui-btn a:hover {\n    border-color: #D8D8D8;\n    background-color: #797979;\n    color: white !important;\n}\n\ndiv.wmui-btn.disabled {\n    cursor: default;\n    color: #777777 !important;\n}\n\ndiv.wmui-btn.disabled:hover {\n    background-color: #D3D3D3;\n    border: 1px solid #C3C3C3;\n    color: #777777 !important;\n}\n\ndiv.wmui-btn.deactivate {\n    margin-left: 5px;\n    background-color: #8BC53F !important;\n    border: solid 1px #8BC53F;\n    color: white;\n}\n\ndiv.wmui-btn.deactivate:hover {\n    background-color: #224C4F !important;\n    border-color: #224C4F !important;\n}\n\ndiv.wmui-btn.activate {\n    margin-left: 5px;\n    background-color: #E94547 !important;\n    border: solid 1px #E94547;\n    color: white;\n}\n\ndiv.wmui-btn.red:hover, div.wmui-btn.activate:hover {\n    background-color: #C0392B !important;\n    border-color: #C0392B !important;\n}\n\ndiv.wmui-btn.active, div.pagination span.current, div.pagination span.disabled, div.pagination span.gap {\n    -moz-border-radius: 3px !important;\n    border-radius: 3px !important;\n    padding: 2px 6px 2px 6px !important;\n    background-color: gray;\n    color: white;\n    text-shadow: #646464 1px 1px 0;\n    border: 1px solid rgba(0, 0, 0, 0.5);\n}\n\ndiv.pagination span.current, div.pagination span.disabled, div.pagination span.gap {\n    opacity: 0.5;\n    cursor: default;\n    background-color: white;\n    color: gray;\n    text-shadow: none;\n    font-weight: bold;\n}\n\ndiv.wmui-btn.active.edit {\n    background-color: #8BC53F !important;\n}\n\ndiv.wmui-symbol {\n    -moz-border-radius: 9px !important;\n    border-radius: 9px !important;\n    display: inline-block;\n    margin: 0 2px !important;\n    height: fit-content;\n}\n\ndiv.wmui-symbol.strong {\n    font-weight: bold !important;\n    height: fit-content;\n}\n\nspan.num {\n    background: gray;\n    color: white;\n    font-weight: bold !important;\n    font-size: 10px;\n    -moz-border-radius: 9px !important;\n    border-radius: 9px !important;\n    padding: 2px 5px !important;\n    margin-right: 8px;\n}\n\n.bottom-offset {\n    margin-bottom: 10px;\n}\n\n.top-offset {\n    margin-top: 5px;\n}\n\ndl.stepped {\n    display: inline-block !important;\n    padding: 0 !important;\n    margin: 10px !important;\n}\n\nul.date_time-selector button {\n    color: #444444;\n    text-decoration: none;\n    border-radius: 3px !important;\n    display: inline-block;\n    padding: 3px 6px 3px 6px !important;\n    margin: 0 5px 0;\n    font-size: 9px;\n    cursor: pointer;\n    background-color: #D3D3D3;\n    border: 1px solid #C3C3C3;\n    text-transform: uppercase;\n    text-align: center;\n}\n\nul.date_time-selector li.separator {\n    margin: 0 3px;\n}\n\nul.toolbar {\n    overflow: hidden;\n}\n\nul.toolbar.rgt {\n    float: right;\n    padding: 5px;\n}\n\nul.toolbar.regular {\n    float: none !important;\n    clear: right;\n    background-color: #E6E6E6;\n    padding: 10px;\n    border-bottom: 1px solid #E3E3E3;\n    margin: 0;\n}\n\nul.toolbar.regular li {\n    border: none !important;\n}\n\nul.toolbar.regular li.wmui-label {\n    margin: 0;\n}\n\n/* ul.toolbar.form li.wmui-btn a,\nul.toolbar.regular li.wmui-btn a {\n    border-radius: 3px !important;\n    -moz-border-radius: 3px !important;\n    border-radius: 3px !important;\n    display: inline-block;\n    padding: 2px 6px 2px 6px !important;\n    margin: 0;\n    font-size: 9px;\n    cursor: pointer;\n    text-align: center;\n    background-color: #D3D3D3;\n    border: 1px solid #C3C3C3;\n    color: #444444;\n    text-transform: uppercase;\n    text-align: center;\n} */\n\n/* ul.toolbar.regular li.wmui-btn a:hover,\nul.toolbar.form li.wmui-btn a:hover {\n    text-decoration: none;\n    text-shadow: #444444 1px 1px 0;\n    border-color: #444444;\n    background-color: #A3A3A3;\n    color: white !important;\n} */\n\nul.toolbar.regular li.wmui-btn a.red:hover,\nul.toolbar.form li.wmui-btn a.red:hover {\n    background-color: red !important;\n    border-color: red;\n    color: white !important;\n    text-shadow: #646464 1px 1px 0;\n}\n\nul.toolbar.regular li.wmui-btn a.active,\nul.toolbar.form li.wmui-btn a.active {\n    background-color: gray;\n    color: white;\n    text-shadow: #646464 1px 1px 0;\n    border: 1px solid rgba(0, 0, 0, 0.5);\n}\n\nul.toolbar.regular li.wmui-btn a.active.edit,\nul.toolbar.form li.wmui-btn a.active.edit {\n    background-color: #8BC53F !important;\n}\n\nul.toolbar.regular li.wmui-btn a.active:hover,\nul.toolbar.form li.wmui-btn a.active:hover {\n    color: white !important;\n}\n\nul.toolbar.regular li.rgt {\n    float: right;\n}\n\nul.toolbar.form {\n    width: 234px;\n    padding: 5px 10px 10px 10px !important;\n    margin: 0;\n}\n\n/* ul.toolbar.form li.wmui-btn a {\n    border-radius: 3px !important;\n    -moz-border-radius: 3px !important;\n    border-radius: 3px !important;\n    text-shadow: white 1px 1px 0;\n    display: inline-block;\n    padding: 2px 6px 2px 6px !important;\n    margin: 0;\n    font-size: 9px;\n    cursor: pointer;\n    text-align: center;\n    background-color: #D3D3D3;\n    border: 1px solid #C3C3C3;\n    color: #444444;\n    background-color: #E7E7E7;\n    text-transform: uppercase;\n    margin: 2px 2px !important;\n} */\n/*\nul.toolbar.form li.wmui-btn a:hover {\n    text-shadow: #444444 1px 1px 0;\n    border-color: #444444;\n    background-color: #A3A3A3;\n    color: white !important;\n} */\n\n/* ul.toolbar.form li.wmui-btn a.red:hover {\n    background-color: red !important;\n    border-color: red;\n    color: white !important;\n    text-shadow: #646464 1px 1px 0;\n} */\n\n/* ul.toolbar.form li.wmui-btn a.active {\n    background-color: gray;\n    color: white;\n    text-shadow: #646464 1px 1px 0;\n    border: 1px solid rgba(0, 0, 0, 0.5);\n} */\n\n/* ul.toolbar.form li.wmui-btn a.active.edit {\n    background-color: #8bc53f !important;\n} */\n/*\nul.toolbar.form li.wmui-btn a.active:hover {\n    color: white !important;\n} */\n\nul.toolbar.form li.rgt {\n    float: right !important;\n}\n\nli.wmui-chart-analyze {\n    margin-right: 0 !important;\n}\n\nli.wmui-chart-analyze ul.toolbar li.wmui-select-box select {\n    width: 140px;\n}\n\nselect.analyze-opt {\n    width: 100px;\n    margin-right: 10px;\n}\n\n.wmui-chart-control-resume {\n    border-top: 2px solid #F7F7F7;\n    position: relative;\n    padding: 0 !important;\n    margin: 0 !important;\n    width: 100%;\n}\n\n.wmui-chart-control-resume .btn-ctrl {\n    cursor: pointer;\n    margin-right: 5px;\n    width: 40px;\n    text-align: center;\n    background-color: #E7E7E7;\n    position: relative;\n    float: right;\n    border: 1px solid #F2F2F2;\n    border-radius: 0 0 8px 8px/0 0 8px 8px;\n    -moz-border-bottom-radius: 8px 8px;\n    border-bottom-radius: 8px 8px;\n    text-shadow: white 1px 1px 0;\n    padding: 1px 6px !important;\n    font-size: 8px;\n    corner-radius: 4px;\n}\n\n.wmui-chart-control-resume .btn-ctrl:hover {\n    background-color: #E3E3E3;\n}\n\n.wmui-chart-control-resume .wmui-resume-box {\n    border-bottom: 1px solid #F2F2F2;\n}\n\n.wmui-chart-control-resume .wmui-resume-box:hover .wmui-btn-hdl {\n    display: block;\n}\n\n.wmui-chart-control-resume .wmui-resume-box .wmui-btn-hdl {\n    border: none !important;\n    display: none;\n    cursor: pointer;\n    position: absolute;\n    top: 8px;\n}\n\n.wmui-chart-control-resume .wmui-resume-box .wmui-btn-hdl:hover svg path {\n    fill: #444444;\n}\n\n.wmui-chart-control-resume .wmui-resume-box .wmui-btn-hdl.in_ctrl {\n    top: 10px;\n    right: px;\n}\n\n.wmui-chart-control-resume .wmui-resume-box .wmui-btn-hdl.in_arrow_west {\n    left: 10px;\n}\n\n.wmui-chart-control-resume .wmui-resume-box .wmui-btn-hdl.in_arrow_east {\n    right: 10px;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board {\n    overflow: hidden;\n    width: 5000px;\n    padding: 0 0 !important;\n    height: 40px;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board > li {\n    padding: 5px !important;\n    margin-right: 5px !important;\n    padding: 5px !important;\n    border-right: 1px dotted #E3E3E3;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board > li.wmui-board-active {\n    background-color: #F7F7F7;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board > li.wmui-control-handler {\n    margin: 0 !important;\n    padding: 0 !important;\n    width: 10px;\n    height: 10px;\n    border: none !important;\n    cursor: pointer;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board > li.wmui-control-handler.wmui-button {\n    border: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board > li:last-child {\n    border-right: none;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board > li .value {\n    font-size: 12px;\n    float: right !important;\n    margin: 0 5px 0 0 !important;\n    padding: 0 0 0 0 !important;\n    font-weight: bold;\n    border: none !important;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board > li .value span.unit {\n    font-size: 8px;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board > li ul {\n    margin: 0;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board > li ul li {\n    padding: 0 !important;\n    text-align: left;\n    clear: both;\n    margin-left: 5px;\n    font-size: px;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board > li ul li:first-child span:last-child {\n    font-size: 14px !important;\n    padding-left: 3px;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board > li ul li span:first-child {\n    width: 40px;\n    display: inline-block;\n    padding: 0 2px 0 0;\n    font-size: 9px;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board > li ul li span:first-child.max {\n    font-size: 8px;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board > li ul li span:first-child.min {\n    font-size: 8px;\n}\n\n.wmui-chart-control-resume .wmui-resume-box ul.board > li ul li span:first-child.avg {\n    font-size: 8px;\n}\n\ndiv.wmui-list {\n    padding: 10px 15px !important;\n}\n\ndiv.wmui-list dl dt span {\n    display: inline-block;\n    padding-bottom: 2px !important;\n    font-weight: 700;\n}\n\ndiv.wmui-list dl dd {\n    clear: both;\n}\n\ndiv.wmui-list dl dd.active {\n    background-color: #F7F7F7 !important;\n    padding: 0 5px;\n    font-weight: bold !important;\n}\n\ndiv.wmui-list dl dd div.wmui-icon {\n    float: left;\n    cursor: pointer;\n    margin-right: 3px;\n}\n\ndiv.wmui-list dl dd div.wmui-icon + span {\n    margin-top: 2px;\n    display: inline-block;\n}\n\ndiv.wmui-list div.wmui-list-title {\n    padding: 0;\n    margin: 10px 0 0;\n}\n\ndiv.wmui-list div.wmui-list-title h3 {\n    margin: 0;\n    padding: 0 0 9px;\n    color: black;\n    text-shadow: white 1px 1px 0;\n}\n\ndiv.wmui-form {\n    padding: 10px !important;\n}\n\ndl.stepped {\n    overflow: hidden;\n    width: 100%;\n    margin: 10px 0 !important;\n    padding: 0 !important;\n\n    dt:not(:first-child) {\n        margin-top: 10px;\n    }\n}\n\ndl.stepped .two-column {\n    display: flex;\n    justify-content: space-between;\n}\n\ndl.stepped .right-side .check {\n    display: table-cell;\n    vertical-align: middle;\n    text-align: center;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px\n}\n\ndl.stepped .right-side .check.green {\n    background-color: #8BC53F\n}\n\ndl.stepped .right-side .check.red {\n    background-color: #E94547\n}\n\ndl.stepped .right-side .check.orange {\n    background-color: #F59D24\n}\n\ndl.stepped .right-side .check.blue {\n    background-color: #6EB3E3;\n}\n\ndl.stepped .right-side .check.lightGrey {\n    background-color: #C5C5C5;\n}\n\ndl.stepped .right-side .check span {\n    color: white;\n    font-size: 14px;\n}\n\ndl.stepped .right-side .status {\n    margin-top: 10px;\n}\n\n\ndl.stepped dd {\n    position: relative;\n}\n\ndl.stepped dd.inherited {\n    color: #A1A1A1;\n}\n\ndl.stepped dt {\n    position: relative;\n}\n\ndl.stepped dt:not(:first-child) {\n    margin-top: 10px;\n}\n\ndl.stepped div dt:first-child {\n    margin-top: 10px;\n}\n\ndl.stepped dt::first-letter {\n    text-transform: capitalize;\n}\n\ndl.stepped dt.inherited {\n    color: #A1A1A1;\n}\n\ndl.stepped dt._error_ label, dl.stepped dt._error_ span {\n    color: red !important;\n}\n\n.wmui-form dd {\n    display: block;\n}\n\n.wmui-form dd input, .wmui-form dd textarea {\n    padding: 5px 5px !important;\n    border: 1px solid #E3E3E3;\n    background: white;\n}\n\n.wmui-form dd input.wmui-field-number, .wmui-form dd input.wmui-field-float {\n    width: 100px !important;\n}\n\n.wmui-form dd input.wmui-field-text {\n    -webkit-appearance: textarea;\n    width: 100% !important;\n}\n\n.wmui-form dd textarea.wmui-field-textarea {\n    width: 100% !important;\n    height: 72px !important;\n}\n\n.wmui-form dd select.wmui-field-enumerator {\n    width: 100px !important;\n}\n\n.icon {\n    cursor: pointer;\n}\n\n.wmui-header {\n    width: 100%;\n}\n\n.wmui-header .icn {\n    height: 20px;\n    width: auto;\n    float: left;\n    background: url(/images/ui/dummy_icon.png) no-repeat;\n    margin-right: 10px;\n}\n\n.wmui-header h1, .wmui-header h2, .wmui-header h3, .wmui-header p {\n    color: #232323 !important;\n}\n\n.wmui-toolbox-abs {\n    border-top: 1px solid #E3E3E3;\n    margin: 0 10px !important;\n    padding: 5px !important;\n    float: left !important;\n}\n\n.wmui-toolbox-abs ul {\n    width: 270px !important;\n}\n\n.wmui-toolbox {\n    float: right;\n}\n\n.wmui-toolbox ul.wmui-toolbox-menu li.wmui-toolbox-btn {\n    overflow: auto;\n    margin: 5px;\n}\n\n.wmui-toolbox ul.wmui-toolbox-menu li.wmui-toolbox-btn .wmui-icon {\n    float: left;\n}\n\n.wmui-toolbox ul.wmui-toolbox-menu li.wmui-toolbox-btn label {\n    color: #A1A1A1;\n    margin: 2px 5px 0 5px !important;\n    font-size: 10px !important;\n}\n\n.wmui-toolbox ul.wmui-toolbox-menu li.wmui-toolbox-btn .wmui-icon:hover {\n    cursor: pointer !important;\n}\n\n.wmui-toolbox ul.wmui-toolbox-menu li.wmui-toolbox-btn .wmui-icon:hover path {\n    fill: black !important;\n    stroke: black !important;\n}\n\n.wmui-board-grid div.wtb-gt {\n    overflow: hidden;\n    margin-top: 10px;\n}\n\n.wmui-board-grid div.wtb-gt:first-child {\n    border-top: 1px solid #D3D3D3;\n}\n\n.wmui-board-grid div.wtb-gt div.wtb-u {\n    display: inline-block;\n    border-left: 1px solid #E3E3E3 !important;\n    float: left;\n    margin: 0 0 0 0%;\n    height: 100%;\n}\n\n.wmui-board-grid div.wtb-gt div.wtb-u:first-child {\n    border-left: none !important;\n}\n\n.wmui-board-grid div.wtb-gt div.wtb-u div.id {\n    color: #A1A1A1;\n    padding: 10px;\n}\n\n.wmui-board-grid div.wtb-gt div.first {\n    margin-left: 0;\n}\n\n.wmui-wgt-head h4 {\n    padding: 5px 5px !important;\n    color: #ABABAB;\n    margin: 0;\n}\n\n.wmui-wgt {\n    overflow: hidden;\n    padding: 10px;\n    border: none;\n}\n\n.wmui-wgt.active {\n    background-color: red;\n}\n\n.wmui-wgt .handle {\n    cursor: move;\n}\n\n.wmui-wgt-msg {\n    padding: 50px 20px;\n    margin: 0 !important;\n}\n\n.wmui-wgt-msg h3 {\n    color: #E3E3E3;\n    text-align: center;\n    line-height: 36px !important;\n}\n\n.wmui-chart-res {\n    background: #F9F9F9;\n    padding: 15px;\n    border-radius: 3px;\n    border: 1px solid #DDDDDD;\n    box-shadow: 3px 3px 5px #F8F8F8;\n    margin: 5px 5px 0 0 !important;\n    position: relative;\n}\n\n.wmui-chart-res h5 {\n    margin: 0 !important;\n    font-weight: normal;\n}\n\n.wmui-chart-res .head h4, .wmui-chart-res .head h5, .wmui-chart-res .head h6 {\n    text-transform: uppercase;\n    margin: 0;\n    padding: 5px;\n}\n\n.wmui-chart-res .head h4 a, .wmui-chart-res .head h5 a, .wmui-chart-res .head h6 a {\n    color: #333333;\n    text-shadow: white 1px 1px 0;\n    text-decoration: none;\n}\n\n.wmui-chart-res .head h4 a:hover, .wmui-chart-res .head h5 a:hover, .wmui-chart-res .head h6 a:hover {\n    color: #8BC53F;\n}\n\n.wmui-chart-res .body {\n    overflow: hidden;\n}\n\n.wmui-chart-res .body .wmui-res-diff {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    color: white;\n    width: auto;\n    float: right;\n}\n\n.wmui-chart-res .body .wmui-res-diff .wmui-icon {\n    float: left;\n    margin: 0;\n}\n\n.wmui-chart-res .body .wmui-res-diff h5 {\n    font-size: 12px;\n    float: right;\n    font-weight: bold;\n    margin: 0 0;\n}\n\n.wmui-chart-res .msg {\n    position: absolute;\n    top: 40%;\n    left: 0;\n    right: 0;\n}\n\n.wmui-chart-res .msg p {\n    text-align: center;\n    text-transform: uppercase;\n    color: #E3E3E3;\n    font-size: 10px;\n    font-weight: bold;\n    padding: 5px;\n    margin: 0;\n}\n\n.wmui-chart-res .footer {\n    text-align: center;\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\n.wmui-chart-res .footer .wmui-chart-ctrl {\n    vertical-align: top;\n    display: inline-block;\n    padding: 0 5px !important;\n    margin: 0 !important;\n}\n\n.wmui-chart-res .footer .wmui-chart-ctrl.wmui-chart-ctrl-btn {\n    margin-top: 3px !important;\n    padding-top: 5px;\n    color: gray;\n    cursor: pointer;\n}\n\n.wmui-chart-res .footer .wmui-chart-ctrl.wmui-chart-ctrl-btn:hover path {\n    fill: #8BC53F;\n}\n\n.wmui-chart-res .footer label {\n    color: black;\n    text-transform: capitalize;\n    font-weight: bold;\n    display: inline-block;\n    padding: 0 !important;\n    margin: 0 !important;\n}\n\n.wmui-wgt-slider {\n    position: relative;\n    padding: 10px;\n    border: 1px solid #E3E3E3;\n    margin: 10px;\n}\n\n.wmui-wgt-slider .frame {\n    width: 100%;\n}\n\n.wmui-wgt-slider .frame .scroller {\n    margin: 5px 35px;\n    overflow: hidden;\n}\n\n.wmui-wgt-slider .frame .scroller .container {\n    padding: 0;\n    width: 3500px;\n    background: transparent;\n}\n\n.wmui-wgt-slider .frame .scroller .container .section {\n    border-right: 1px solid #E3E3E3;\n    float: left;\n    margin: 0 0 0 0;\n}\n\n.wmui-wgt-slider .frame .scroller .container .section:last-child {\n    border-right: none;\n}\n\n.wmui-wgt-slider .frame .scroller .container .section > div {\n    margin: 0 1px 0 0;\n}\n\n.wmui-wgt-slider .frame .wmui-wgt-slider-btn {\n    top: 0;\n    bottom: 0;\n    width: 30px;\n    position: absolute;\n    z-index: 5;\n    padding-top: 140px;\n}\n\n.wmui-wgt-slider .frame .wmui-wgt-slider-btn.wmui-wgt-slider-btn-nxt {\n    border-left: 1px solid transparent;\n    right: 0;\n}\n\n.wmui-wgt-slider .frame .wmui-wgt-slider-btn.wmui-wgt-slider-btn-prv {\n    border-right: 1px solid transparent;\n    left: 0;\n}\n\n.wmui-wgt-slider .frame .wmui-wgt-slider-btn div {\n    cursor: pointer;\n    margin-left: 10px !important;\n}\n\n.wmui-view > div.wmui-table-view {\n    margin: 10px;\n}\n\n.wmui-view > div.wmui-detail-list {\n    margin: 0;\n}\n\n.wmui-msg h4 {\n    text-shadow: white 1px 1px 0;\n    color: #A1A1A1;\n    text-align: center;\n    margin: 20px auto;\n}\n\n.wmui-chart-analyze dl {\n    margin: 0 !important;\n}\n\n.wmui-chart-analyze select {\n    color: black;\n    text-transform: capitalize;\n    font-weight: normal;\n}\n\n.wmui-chart-analyze select option {\n    text-transform: capitalize;\n    font-weight: normal;\n}\n\n.wmui-chart-analyze select:disabled {\n    background: transparent;\n    color: gray;\n}\n\n.wmui-chart-analyze .analyze-mode {\n    margin-right: 5px;\n}\n\n.wmui-chart-ph {\n    position: relative;\n    overflow: auto;\n}\n\n.wmui-chart-control-handler {\n    position: relative;\n    color: white;\n    height: 100px;\n}\n\n.wmui-costs ul {\n    padding: 5px;\n}\n\n.wmui-costs ul li {\n    clear: both;\n    padding: 0 5px;\n    border-bottom: 1px solid #E3E3E3;\n    margin: 0px;\n}\n\n.wmui-costs ul li.active {\n    background-color: #F7F7F7;\n}\n\n.wmui-costs ul li:last-child {\n    border: none;\n}\n\n.wmui-costs ul li div.wmui-icon {\n    float: left;\n}\n\n.wmui-costs ul li label {\n    padding: 0 0 !important;\n    display: inline-block;\n    vertical-align: top;\n    margin: 3px 0 6px 6px;\n    color: gray;\n}\n\n.wmui-costs ul li.current label {\n    color: black;\n}\n\ntable.jCalendar {\n    border: 1px solid transparent;\n    background: transparent;\n    border-collapse: separate;\n    border-spacing: 1px;\n}\n\ntable.jCalendar thead {\n    background-color: #E6F0FD;\n}\n\ntable.jCalendar thead th {\n    background: transparent;\n    color: #8BC53F;\n    font-weight: bold;\n    padding: 3px 0;\n    text-align: center;\n    border: none !important;\n}\n\ntable.jCalendar td {\n    background: #F3F3F3;\n    color: black;\n    border: 1px solid transparent;\n    padding: 3px 5px;\n    text-align: center;\n}\n\ntable.jCalendar td.other-month {\n    background: #DDDDDD;\n    color: #AAAAAA;\n}\n\ntable.jCalendar td.today {\n    background: #666666;\n    color: white;\n}\n\ntable.jCalendar td.selected {\n    background: #FF6666;\n    color: white;\n}\n\ntable.jCalendar td.selected.dp-hover {\n    background: #FF3333;\n    color: white;\n}\n\ntable.jCalendar td.dp-hover {\n    background: white;\n    color: black;\n    border: 1px solid #E3E3E3;\n}\n\ntable.jCalendar tr.activeWeekHover td {\n    background: white;\n    color: black;\n}\n\ntable.jCalendar tr.selectedWeek td {\n    background: #FF6666;\n    color: white;\n}\n\ntable.jCalendar td.disabled {\n    background: #BBBBBB;\n    color: #888888;\n}\n\ntable.jCalendar td.disabled.dp-hover {\n    background: #BBBBBB;\n    color: #888888;\n}\n\ntable.jCalendar td.unselectable {\n    background: #BBBBBB;\n    color: #888888;\n}\n\ntable.jCalendar td.unselectable:hover, table.jCalendar td.unselectable.dp-hover {\n    background: #BBBBBB;\n    color: #888888;\n}\n\n/* For the popup */\n/* NOTE - you will probably want to style a.dp-choose-date - see how I did it in demo.css */\ndiv.dp-popup {\n    box-shadow: rgba(0, 0, 0, 0.08) 0 5px 5px;\n    border: 1px solid #E3E3E3;\n    position: relative;\n    background: #F8FAFE;\n    font-size: 10px;\n    padding: 4px;\n    width: 171px;\n    line-height: 1.2em;\n}\n\ndiv#dp-popup {\n    position: absolute;\n    z-index: 199;\n}\n\ndiv.dp-popup h2 {\n    font-size: 11px;\n    text-shadow: white 1px 1px 0;\n    text-align: center;\n    margin: 2px 0;\n    padding: 0;\n    color: #8BC53F;\n    font-weight: bold;\n}\n\na#dp-close {\n    font-size: 11px;\n    padding: 4px 0;\n    text-align: center;\n    display: block;\n}\n\na#dp-close:hover {\n    text-decoration: underline;\n}\n\ndiv.dp-popup a {\n    color: #8BC53F;\n    text-decoration: none;\n    padding: 3px 2px 0;\n}\n\ndiv.dp-popup div.dp-nav-prev {\n    position: absolute;\n    top: 2px;\n    left: 4px;\n    width: 100px;\n}\n\ndiv.dp-popup div.dp-nav-prev a {\n    font-size: 9px;\n    font-weight: bold;\n    float: left;\n    cursor: pointer;\n}\n\ndiv.dp-popup div.dp-nav-next a {\n    cursor: pointer;\n}\n\ndiv.dp-popup div.dp-nav-prev a.disabled {\n    cursor: default;\n}\n\ndiv.dp-popup div.dp-nav-next {\n    position: absolute;\n    top: 2px;\n    right: 4px;\n    width: 100px;\n}\n\ndiv.dp-popup div.dp-nav-next a {\n    font-size: 9px;\n    font-weight: bold;\n    float: right;\n}\n\ndiv.dp-popup div.dp-nav-next a.disabled {\n    cursor: default;\n}\n\ndiv.dp-popup a.disabled {\n    cursor: default;\n    color: #AAAAAA;\n}\n\ndiv.dp-popup td {\n    cursor: pointer;\n}\n\ndiv.dp-popup td.disabled {\n    cursor: default;\n}\n\n.dp li {\n    width: 100%;\n    margin-right: 0;\n}\n\n.wmui-table-mono {\n    padding: 9px 10px;\n    background: none !important;\n    margin-right: 20px !important;\n}\n\n.wmui-table-mono table {\n    background: none !important;\n}\n\n.wmui-table-mono table thead tr {\n    background: none !important;\n}\n\n.wmui-table-mono table thead tr th {\n    border: none !important;\n}\n\n.wmui-table-mono table tbody {\n    background-color: none !important;\n}\n\n.wmui-table-mono table tbody tr {\n    background-color: none !important;\n    cursor: pointer;\n}\n\n.wmui-table-mono table tbody tr:nth-child(odd) {\n    background: none !important;\n}\n\n.wmui-table-mono table tbody tr:hover td {\n    background-color: rgba(255, 255, 255, 0.7);\n    color: black !important;\n    text-shadow: none !important;\n    border-top: 1px solid #D1D1D1;\n}\n\n.wmui-table-mono table tbody tr:hover td a {\n    color: black !important;\n}\n\n.wmui-table-mono table tbody tr:hover td a.wmui-btn {\n    color: black !important;\n}\n\n.wmui-table-mono table tbody tr:hover td.unit {\n    color: white !important;\n}\n\n.wmui-table-mono table tbody tr td {\n    border-right: none !important;\n    border-top: 1px solid #D1D1D1;\n    overflow: hidden;\n    text-overflow: ellipsis !important;\n    white-space: nowrap !important;\n    color: black !important;\n    font-size: 10px !important;\n    padding: 2px 5px;\n}\n\n.wmui-table-mono table tbody tr td:last-child {\n    border-right: none;\n}\n\n.wmui-table-mono table tbody tr td a {\n    color: black;\n    text-decoration: underscore;\n}\n\n.wmui-table-mono table tbody tr td a.wmui-btn {\n    border-radius: 3px !important;\n    -moz-border-radius: 3px !important;\n    border-radius: 3px !important;\n    text-shadow: white 1px 1px 0;\n    display: inline-block;\n    padding: 2px 6px 2px 6px !important;\n    margin: 0;\n    font-size: 9px;\n    cursor: pointer;\n    text-align: center;\n    background-color: #D3D3D3;\n    border: 1px solid #C3C3C3;\n    color: #444444;\n    text-transform: uppercase;\n    font-size: 7px;\n    line-height: 14px;\n    padding: 0 6px !important;\n}\n\n.wmui-table-mono table tbody tr td a.wmui-btn:hover {\n    text-shadow: #444444 1px 1px 0;\n    border-color: #444444;\n    background-color: #A3A3A3;\n    color: white !important;\n}\n\n.wmui-table-mono table tbody tr td a.wmui-btn.red:hover {\n    background-color: red !important;\n    border-color: red;\n    color: white !important;\n    text-shadow: #646464 1px 1px 0;\n}\n\n.wmui-table-mono table tbody tr td a.wmui-btn.active {\n    background-color: gray;\n    color: white;\n    text-shadow: #646464 1px 1px 0;\n    border: 1px solid rgba(0, 0, 0, 0.5);\n}\n\n.wmui-table-mono table tbody tr td a.wmui-btn.active.edit {\n    background-color: #8BC53F !important;\n}\n\n.wmui-table-mono table tbody tr td a.wmui-btn.active:hover {\n    color: white !important;\n}\n\n.wmui-table-mono table tbody tr td a.wmui-btn:hover {\n    border: 1px solid gray;\n    color: blue !important;\n}\n\n.wmui-table-mono table tbody tr td.unit {\n    color: white;\n    text-shadow: black 1px 1px 0;\n    text-align: right !important;\n    font-size: 7px !important;\n    font-weight: bold;\n    background-image: url(\"/images/ui/_tags_18.png\");\n    background-repeat: no-repeat;\n    background-position: 0 0;\n    text-shadow: \"black\" 1px 1px 0;\n    background-position: 0 2px;\n}\n\n.exported {\n    text-shadow: \"black\" 1px 1px 0;\n    width: 100%;\n}\n\n.exported .icon {\n    text-align: center;\n    cursor: pointer;\n    width: 100px;\n    height: 131px;\n    margin: 20px auto 0;\n    float: none;\n    clear: both;\n}\n\n.exported .icon.error {\n    cursor: auto;\n    background-image: url(\"/images/ui/export_error.png\");\n    background-repeat: no-repeat;\n    background-position: 0 0;\n}\n\n.exported .icon.csv {\n    background-image: url(\"/images/ui/export_csv.png\");\n    background-repeat: no-repeat;\n    background-position: 0 0;\n}\n\n.exported .icon.pdf {\n    background-image: url(\"/images/ui/export_pdf.png\");\n    background-repeat: no-repeat;\n    background-position: 0 0;\n}\n\n.exported .icon.html {\n    background-image: url(\"/images/ui/export_html.png\");\n    background-repeat: no-repeat;\n    background-position: 0 0;\n}\n\n.exported .icon.xlsx {\n    background-image: url(\"/images/ui/export_xlsx.png\");\n    background-repeat: no-repeat;\n    background-position: 0 0;\n}\n\n.exported .wmui-btn-download {\n    cursor: pointer;\n    text-align: center;\n}\n\n.exported .wmui-btn-download .wmui-btn {\n    font-size: 12px;\n    margin: 6px auto;\n}\n\n.exported p {\n    text-align: center;\n    font-size: 10px;\n}\n\n.exported p.error {\n    background: none !important;\n    color: red;\n    padding: 10px 20px;\n}\n\ndiv.form_content {\n    padding: 0 10px;\n}\n\ndiv.ldr_il {\n    margin: 20px;\n}\n\n.wmui-chart-components,\n.wmui-chart-legend,\n.wmui-export,\n.wmui-chart-triggers,\n.wmui-costs {\n    margin: 0;\n}\n\n.wmui-chart-triggers div {\n    padding: 10px;\n}\n\n.wmui-chart-legend {\n    width: 100%;\n}\n\n.wmui-chart-legend ul {\n    padding: 5px;\n}\n\n.wmui-chart-legend ul li {\n    border-top: 1px solid #E3E3E3;\n    padding: 0 5px !important;\n    clear: both;\n}\n\n.wmui-chart-legend ul li.active {\n    background-color: #2372D5;\n}\n\n\n.wmui-chart-legend ul li.item.component {\n    display: flex;\n    margin: 0;\n}\n\n.wmui-chart-legend ul li.item.current.component {\n    background-color: transparent !important;\n}\n\n.wmui-chart-legend ul li.item .wmui-icon {\n    float: left;\n    margin: 3px 6px !important;\n}\n\n.wmui-chart-legend ul li.item .wmui-icon:hover path {\n    stroke: #A1A1A1;\n    fill: white;\n}\n\n.wmui-chart-legend ul li div.color-box {\n    display: block;\n    float: left;\n    width: 10px;\n    height: 10px;\n    margin: 6px 0;\n}\n\n.wmui-chart-legend ul li label {\n    float: none;\n}\n\n.wmui-chart-legend ul li .label {\n    float: none;\n    font-size: 9px;\n    width: 150px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\nth.d-head {\n    background-image: none !important;\n    background-color: white;\n    border: none !important;\n    width: 12px;\n    padding: 2px 0 !important;\n}\n\ntd.d-handler {\n    border-right: 1px solid #F7F7F7;\n    margin: 0;\n    padding: 0 !important;\n    cursor: move;\n}\n\ntd.d-handler div {\n    color: black;\n    border-radius: 3px !important;\n    -moz-border-radius: 3px !important;\n    border-radius: 3px !important;\n    width: 10px !important;\n    height: 20px;\n    font-weight: bold;\n    padding: 0 0 0 5px;\n    font-size: 12px;\n}\n\ntr.tDnD_whileDrag {\n    background-color: #FAF9B6 !important;\n}\n\ntr.tDnD_whileDrag td.d-handler {\n    background-color: #FAF9B6;\n}\n\ntr.tDnD_whileDrag td {\n    border-top: 1px solid #E3E3E3 !important;\n    border-bottom: 1px solid #E3E3E3 !important;\n}\n\ntr.tDnD_whileDrag td {\n    font-weight: bold;\n    color: black;\n}\n\n.wmui-tipper {\n    z-index: 99999;\n    top: 0;\n    opacity: 0;\n    position: absolute;\n    background-color: \"none\";\n}\n\n.wmui-tipper .wmui-tipper-arrow {\n    width: 0;\n    height: 0;\n    position: absolute;\n    z-index: 10;\n}\n\n.wmui-tipper .wmui-tipper-arrow.n, .wmui-tipper .wmui-tipper-arrow.ne, .wmui-tipper .wmui-tipper-arrow.nw {\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-bottom: 10px solid #333333;\n}\n\n.wmui-tipper .wmui-tipper-arrow.s, .wmui-tipper .wmui-tipper-arrow.se, .wmui-tipper .wmui-tipper-arrow.sw {\n    border-left: 10px solid transparent;\n    border-right: 10px solid transparent;\n    border-top: 10px solid #333333;\n}\n\n.wmui-tipper .wmui-tipper-body {\n    z-index: 11;\n    margin-top: 10px;\n    -moz-box-shadow: 0 0 5px #BCBCBC;\n    box-shadow: 0 0 5px #BCBCBC;\n    text-align: center;\n    background: #333333;\n    padding: 0 5px;\n    border-radius: 3px !important;\n    -moz-border-radius: 3px !important;\n    border-radius: 3px !important;\n    padding: 10px 10px;\n    text-align: center;\n    color: #F3F3F3;\n}\n\n.wmui-tipper .wmui-tipper-body .wmui-tipper-msg {\n    font-size: 9px;\n    border: 1px solid #333333;\n    width: 100%;\n    text-transform: uppercase;\n    text-align: left;\n}\n\n.wmui-tipper .wmui-tipper-body label {\n    display: block;\n    width: 100%;\n    margin-bottom: 9px;\n    padding-left: 2px;\n    text-align: left !important;\n    font-size: 9px !important;\n    text-transform: uppercase;\n    color: #E3E3E3;\n}\n\n.wmui-tipper .wmui-tipper-body input {\n    clear: left;\n    border: 1px solid #444444;\n    padding: 6px !important;\n    margin-bottom: 9px;\n    font-size: 12px;\n    background: #F3F3F3;\n    min-width: 200px;\n    color: #444444 !important;\n    font-weight: 700;\n}\n\n.wmui-tipper .wmui-tipper-body p {\n    padding: 0 !important;\n    font-size: 12px;\n    margin: 0 0 9px;\n}\n\n.wmui-tipper .wmui-tipper-body.wmui-tipper-publish div.tiper-form {\n    text-align: left;\n    margin: 4px 0 9px !important;\n    overflow: hidden;\n}\n\n.wmui-tipper .wmui-tipper-body.wmui-tipper-publish div.tiper-form select {\n    min-width: 100px;\n}\n\n.wmui-tipper .wmui-tipper-body.wmui-tipper-signal {\n    padding: 4px 6px 3px !important;\n    background-color: #F8E891;\n}\n\n.wmui-tipper .wmui-tipper-body.wmui-tipper-signal p {\n    margin: 0 !important;\n    padding: 0 9px !important;\n    color: #444444;\n    font-weight: 700;\n    font-size: 10px;\n}\n\n.wmui-tipper .wmui-tipper-body.wmui-tipper-signal p.imperative {\n    text-transform: uppercase;\n}\n\n.wmui-tipper .wmui-tipper-body.wmui-tipper-signal p.declarative {\n    text-transform: normal;\n}\n\n.wmui-tipper .wmui-tipper-body .wmui-tipper-btns .wmui-btn {\n    margin-right: 5px !important;\n    text-transform: uppercase;\n}\n\n.wmui-tipper.an-n, .wmui-tipper.an-ne, .wmui-tipper.an-nw {\n    margin-top: 10px;\n    opacity: 1;\n}\n\n.wmui-tipper.an-s, .wmui-tipper.an-se, .wmui-tipper.an-sw {\n    margin-top: -15px;\n    opacity: 1;\n}\n\n.an {\n    -moz-transition: all 0.3s;\n    -webkit-transition: all 0.3s;\n    -o-transition: all 0.3s;\n    transition: all 0.3s;\n}\n\n.wmui-visualizations ul {\n    padding: 10px 10px 10px 10px;\n}\n\n.wmui-visualizations ul li {\n    clear: both;\n    margin: 1px 0 0;\n    padding: 2px 5px;\n    border-bottom: 1px solid #E3E3E3;\n}\n\n.wmui-visualizations ul li.active {\n    background-color: #F7F7F7;\n}\n\n.wmui-visualizations ul li:last-child {\n    border: none;\n}\n\n.wmui-visualizations ul li div.wmui-icon {\n    float: left;\n}\n\n.wmui-visualizations ul li label {\n    padding: 0 0 !important;\n    display: inline-block;\n    vertical-align: top;\n    margin: 3px 0 6px 6px;\n    color: gray;\n}\n\n.wmui-visualizations ul li.current label {\n    color: black;\n}\n\n.left-18 {\n    margin-left: 18px;\n}\n\n.wmui-btn-right {\n    min-width: 60px;\n    display: inline-block;\n    padding: 4px 6px;\n    margin-left: auto;\n    border: none;\n    background-color: #8BC53F;\n    font-size: 10px !important;\n    color: white;\n    cursor: pointer;\n    border-radius: 3px !important;\n    -moz-border-radius: 3px !important;\n}\n\n.wmui-btn-right:hover {\n    background-color: #224C4F;\n}\n\n.wmui-btn-right:disabled {\n    background-color: #D3D3D3;\n    color: #333333;\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.wmui-btn-right:disabled:hover {\n    background-color: #D3D3D3;\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n",".ribbon {\n    width: 30px;\n    height: 40px;\n    background-color: #8BC53F;\n    position: absolute;\n    right: 5%;\n    top: -350px;\n    animation: drop forwards 1s 0.1s cubic-bezier(0.165, 0.84, 0.44, 1);\n\n    &:before {\n        content: '';\n        position: absolute;\n        z-index: 2;\n        left: 0;\n        bottom: -14px;\n        border-left: 15px solid #8BC53F;\n        border-right: 15px solid #8BC53F;\n        border-bottom: 15px solid transparent;\n    }\n}\n\n@keyframes drop {\n    0% { top: -350px; }\n    100% { top: 0; }\n}\n",".progress {\n    margin: 5px 0;\n    display: -ms-flexbox;\n    display: flex;\n    height: 1rem;\n    overflow: hidden;\n    font-size: 0.75rem;\n    background-color: #E9ECEF;\n    border-radius: 0.25rem;\n}\n\n.progress-bar {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -ms-flex-pack: center;\n    justify-content: center;\n    overflow: hidden;\n    color: #FFFFFF;\n    text-align: center;\n    white-space: nowrap;\n    background-color: #8BC53F;\n    transition: width 0.6s ease;\n}\n\n.progress-bar.yellow {\n    background-color: #F5D124;\n}\n\n.missing-configurations {\n    margin: 20px 0;\n\n    :first-child {\n        font-weight: bold;\n    }\n}\n",".ui-schedule {\n    overflow: auto;\n    clear: left;\n    float: left;\n    padding-right: 10px;\n}\n\ntable.ui-schedule-table {\n    border: 1px solid #222222 !important;\n    border-collapse: collapse;\n    margin-top: 0;\n}\n\ntable.ui-schedule-table th {\n    border: 1px solid #222222;\n    padding: 0;\n    text-align: center;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\ntable.ui-schedule-table tbody tr td:first-child {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n}\n\ntable.ui-schedule-table th.day {\n    width: 40px;\n}\n\ntable.ui-schedule-table td {\n    border: 0;\n    border-right: 1px solid #888888;\n    border-bottom: 1px solid #888888;\n    height: 15px;\n    padding: 0;\n    text-align: center;\n    width: 15px;\n}\n\ntable.ui-schedule-table td.day {\n    width: 40px;\n}\n\n.pointer-show {\n    cursor: default;\n}\n\ntable.ui-schedule-table td.day-change {\n    border-right: 1px solid #222222;\n}\n\n.schedule-legend {\n    float: left;\n}\n\n.schedule-legend .schedule-legend-label {\n    font-weight: bold;\n    margin: 0;\n    max-width: 215px;\n    text-transform: capitalize;\n}\n\n.schedule-legend .on-off {\n    clear: both;\n    padding-top: 10px;\n}\n\n.schedule-legend .color-legend {\n    border: 1px solid transparent;\n    border-radius: 3px;\n    height: 16px;\n    margin-bottom: 0;\n    padding: 3px;\n}\n\n.schedule-legend .color-legend:hover {\n    border-color: #DDDDDD !important;\n    cursor: pointer;\n    background-color: #FAFAFA;\n}\n\n.schedule-legend .period-values {\n    float: left;\n    margin-right: 2px;\n    width: 50px;\n}\n\n.schedule-legend span.color-box {\n    margin-right: 5px;\n    width: 14px;\n    height: 14px;\n    float: left;\n    border: 1px solid transparent;\n    border-radius: 2px;\n}\n\n.schedule-legend .color-box:hover {\n    border-color: #DDDDDD !important;\n    cursor: pointer;\n    background-color: #FAFAFA;\n}\n\n.schedule-legend span.color-text {\n    float: left;\n    font-size: 12px;\n    font-weight: normal;\n    height: 16px;\n    line-height: 16px;\n}\n\n.schedule-legend #current_position {\n    background: #F8F8F8;\n    border: 1px solid #CCCCCC;\n    border-radius: 2px;\n    display: none;\n    margin-top: 10px;\n    padding: 5px;\n}\n\n.schedule-left {\n    float: left;\n    max-width: 200px;\n    min-width: 200px;\n    padding-right: 15px;\n}\n\n.schedule-left select {\n    max-width: 200px;\n}\n\n.schedule-left input.circuit-search {\n    width: 190px;\n    padding: 3px;\n}\n\n.schedule-left .circuit-search-results {\n    margin-top: 10px;\n    max-height: 385px;\n    overflow: scroll;\n}\n\n.schedule-right {\n    border-left: 1px solid #CCCCCC;\n    float: left;\n    padding-left: 15px;\n}\n","#tipper {\n    position: fixed;\n    top: 8px;\n    left: 200px;\n    right: 200px;\n    z-index: 1000;\n    text-align: center;\n}\n\n#tipper .tipper {\n    -moz-border-radius: 4px;\n    border: 2px solid transparent;\n    border-radius: 3px;\n    font-weight: bold;\n    left: 50%;\n    margin: 4px auto;\n    padding: 2px 12px 2px 2px;\n    position: absolute;\n    transform: translate(-50%, 0);\n    top: 0;\n}\n\n#tipper .alert, #tipper .alert path {\n    background-color: #F59D24;\n    color: white;\n    text-shadow: none;\n}\n\n#tipper .success, #tipper .success path {\n    background-color: #8BC53F;\n    color: white;\n}\n\n#tipper .error, #tipper .error path {\n    background-color: #E94547;\n    color: white;\n}\n\n#tipper .info, #tipper .info path {\n    background-color: #6EB3E3;\n    color: white;\n}\n\n#tipper .tipper-icon {\n    float: left;\n    margin: 0 10px 0 5px;\n}\n",".capitalize::first-letter {\n    text-transform: capitalize;\n}\n\n.decapitalize {\n    text-transform: none !important;\n}\n\n.pointer:hover {\n    cursor: pointer;\n}\n\ndiv.svg_icon.disabled_icon {\n    cursor: default;\n    opacity: 0.2;\n}\n\ndiv.svg_icon.red > svg > path {\n    fill: red\n}\n\ndiv#wmwmui-datepicker-div {\n    z-index: 100;\n}\n\n#wmui-timepicker-div dl {\n    text-align: left;\n}\n\n#wmui-timepicker-div dl dt {\n    height: 25px;\n}\n\n#wmui-timepicker-div dl dd {\n    margin: -25px 0 10px 65px;\n}\n\nbody {\n    height: 100%;\n    margin: 0;\n    overflow: hidden;\n    width: 100%;\n}\n\nbody {\n    -webkit-text-size-adjust: none;\n    -webkit-user-select: text;\n    -moz-user-select: text;\n}\n\n\n/*  this still allows the indicator to appear when focused by keyboard, but hides when mouse activated. It’s the best of both worlds… */\n\na:active {\n    outline: none;\n}\n\n.data_period {\n    position: absolute;\n    top: 37px;\n    right: 36px;\n    z-index: 999;\n}\n\n.data_period input {\n    border: none;\n    font-family: \"Lucida Grande\", \"Lucida Sans Unicode\", Helvetica, Arial, Verdana, sans-serif;\n    text-align: center;\n    font-size: 11px;\n    display: inline;\n    color: #333333;\n    text-decoration: underline;\n    cursor: pointer;\n    cursor: hand;\n    padding: 0 5px;\n    top: 3px;\n}\n\n.data_period input.to {\n    padding: 0 0 0 5px;\n}\n\n.data_period .select a.current {\n    padding-right: 3px;\n    color: #000000;\n    padding-bottom: 2px;\n}\n\n.data_period .select .dropdown {\n    z-index: 2;\n    background-color: #FFFFFF;\n    display: inline;\n    border: 1px solid transparent;\n    border-top-left-radius: 5px;\n    -moz-border-radius-topleft: 5px;\n    border-top-right-radius: 5px;\n    -moz-border-radius-topright: 5px;\n    padding-bottom: 2px;\n}\n\n.data_period .select .dropdown img {\n    position: relative;\n    top: 3px;\n    cursor: pointer;\n    cursor: hand;\n}\n\n.data_period .select .dropdown .options {\n    z-index: -1;\n    position: absolute;\n    right: 0;\n    margin-top: 2px;\n    padding: 5px 10px;\n    text-align: right;\n    background-color: #FFFFFF;\n    border-top-left-radius: 5px;\n    -moz-border-radius-topleft: 5px;\n    border-bottom-left-radius: 5px;\n    -moz-border-radius-bottomleft: 5px;\n    border-bottom-right-radius: 5px;\n    -moz-border-radius-bottomright: 5px;\n    border: 1px solid #C2C2C2;\n}\n\n.data_period .select a,\n.data_period .select .dropdown .options a {\n    color: #999999;\n}\n\n.data_period .select a:hover,\n.data_period .select .dropdown .options a:hover {\n    color: #000000;\n}\n\n\n/*login*/\n\n.login #main {\n    background-color: #224C4F;\n    border-width: 0 !important;\n    overflow-y: auto;\n    top: 0;\n}\n\n.login .central {\n    position: absolute;\n    left: 50%;\n    top: 30%;\n    margin-left: -267px;\n}\n\n.login .log {\n    float: left;\n    width: 200px;\n    padding: 6em 4em 0 0;\n}\n\n.login .form_log {\n    float: left;\n    width: 310px;\n}\n\n.login .form_log p .title.corn {\n    width: -webkit-fill-available;\n    margin-top: 0.5em;\n}\n\n.login .form_log form div {\n    margin: 0.5em 0;\n    border: none !important;\n}\n\n.login .form_log .footer {\n    display: flex;\n    justify-content: space-between;\n}\n\n.login .msg {\n    padding: .5em .5em 0.25em;\n    color: white;\n}\n\n.login .msg .icon {\n    margin-right: 8px;\n}\n\n.login .msg .svg_icon {\n    margin-right: 8px;\n}\n\n.login .msg_text {\n    font-size: .8em;\n    line-height: 2em;\n}\n\n.login .central label {\n    color: white;\n    font-size: .8em;\n    line-height: 1.5em;\n    display: block;\n    margin-top: .5em;\n}\n\n.login .central form {\n    margin-top: .5em;\n    border-top: 1px solid white;\n    border-bottom: 1px solid white;\n    padding: 1em 0.5em;\n    overflow: auto;\n}\n\n.login .loader {\n    background-image: url(/images/ui/search_loader.gif) !important;\n    width: 16px;\n    height: 16px;\n    float: left;\n    margin-right: 10px;\n    border: 0 solid gray !important;\n}\n\n.login .msg_text {\n    text-transform: uppercase;\n}\n\n.login .active {\n    background-color: #3B73BA;\n}\n\n.login input[type=submit] {\n    height: 24px;\n    width: 100px;\n    border: 1px;\n    font-weight: bold;\n    cursor: pointer;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n}\n\n.login input[type=submit] {\n    background-color: #FDFDFD;\n    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#DCDCDC), to(#FDFDFD));\n}\n\n.login input[type=submit]:hover {\n    background-color: #DCDCDC;\n    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#FDFDFD), to(#DCDCDC));\n}\n\n.login a.small {\n    font-size: .9em;\n    text-decoration: none;\n    color: white;\n}\n\n.login a.small:hover {\n    font-size: .9em;\n    text-decoration: none;\n    color: rgba(255, 255, 255, 1);\n}\n\n\n/*inline buttons*/\n\na.lnk {\n    font-size: 8px;\n    background: #E3E3E3;\n    color: #2E3D1B;\n    text-transform: uppercase;\n    padding: .3em 1em;\n    text-decoration: none;\n    -moz-border-radius: 3px;\n    border-radius: 3px;\n    margin-right: 3px;\n}\n\na.lnk.operation {\n    font-size: 10px;\n    line-height: 2;\n}\n\na.lnk:hover {\n    background: #63764B;\n    color: white\n}\n\n\n/*colors*/\n\na.lnk_right {\n    float: right !important;\n}\n\na.lnk_red {\n    background: #FFD3D3;\n    color: #C41E12;\n}\n\na.lnk_red:hover {\n    background: red;\n    color: white;\n}\n\na.lnk_blue {\n    background: #1C9EE8;\n    color: white;\n}\n\na.lnk_blue:hover {\n    background: #007AC0;\n    color: white;\n}\n\na.lnk_petro {\n    background: #E3E3E3;\n    color: #2E3D1B;\n}\n\na.lnk_petro:hover {\n    background: #0366B7;\n    color: white;\n}\n\na.lnk_green {\n    background: #DAFFEA;\n    color: #147307;\n}\n\na.lnk_green:hover {\n    background: #3FA76B;\n    color: white;\n}\n\na.lnk_yellow {\n    background: #FFFADB;\n    color: black;\n}\n\na.lnk_yellow:hover {\n    background: #FFEA5F;\n    color: black;\n}\n\na.lnk_gray {\n    background: #94979A;\n    color: white;\n}\n\na.lnk_gray:hover {\n    background: #3579EB;\n    color: white;\n}\n\n.lnk_tlb {\n    margin: 1em .5em;\n    border-bottom: 1px solid #E3E3E3;\n    height: 26px;\n}\n\na.lnk_big {\n    color: black;\n    padding: .5em 1em;\n    font-size: 1.1em;\n    background: #F1F1F1;\n    border: 1px solid gray;\n    font-weight: bold;\n    text-decoration: none;\n    float: left;\n}\n\na.lnk_big:hover {\n    background: gray;\n    color: white;\n}\n\n\n.bar {\n    height: 4px;\n    width: 100%;\n    position: absolute;\n    background-color: #F3F3F3;\n}\n\n.bar {\n    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#DCDCDC), to(#FDFDFD));\n}\n\n.bar {\n    background: -moz-linear-gradient(to bottom, #DCDCDC, #FDFDFD);\n}\n\n#search {\n    margin: 0 5px 0 0;\n    padding: 3px 5px;\n    height: 36px;\n}\n\n#search .btn {\n    margin-top: 8px;\n}\n\n#search input {\n    padding: 2px;\n    margin: 7px 10px 5px 3px;\n    width: 212px;\n    -moz-border-radius: 2px;\n    float: left;\n}\n\n#main {\n    background-color: white;\n    bottom: 0;\n    left: 0;\n    overflow: hidden;\n    position: absolute;\n    right: 0;\n    top: 41px;\n    z-index: 1;\n}\n\n#main_panels {\n    bottom: 4px;\n    left: 0;\n    overflow: hidden;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n#main_status_bar {\n    bottom: 0;\n    left: 0;\n    position: absolute;\n    right: 0;\n}\n\n#navbar-inner {\n    margin-right: 0;\n    min-height: 38px;\n    height: 38px;\n    border-radius: 0;\n    border-width: 1px 0;\n    display: flex;\n    justify-content: space-between;\n\n    ul {\n        width: 100%;\n        overflow-y: scroll;\n    }\n\n    button {\n        border: none;\n        background: none;\n    }\n}\n\n#wrapper {\n    display: flex;\n    flex-direction: row;\n    position: fixed !important;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    margin: 50px 0 0;\n    overflow: hidden;\n    width: 100%;\n}\n\n#elm_content {\n    flex: 1;\n    display: block;\n    padding: 0;\n    position: relative !important;\n    overflow: auto;\n}\n\n#elm_sidebar {\n    background-color: #FAFAFA;\n    cursor: default;\n    overflow: hidden;\n    position: relative !important;\n    width: 225px;\n    min-width: 225px;\n    max-width: 50%;\n    border-right: #E5E5E5 solid 1px;\n}\n\n#elm_sidebar > .ui-resizable-handle.ui-resizable-e {\n    right: 0;\n    top: 0;\n    width: 8px;\n    height: 100%;\n    background-position: -26px center;\n    cursor: col-resize;\n    background-color: #FAFAFA;\n    position: absolute;\n    background-image: url(/images/ui/resizable.png);\n    background-repeat: no-repeat;\n    margin-top: 0;\n}\n\n#elm_sidebar > .panels_container {\n    right: 7px;\n}\n\n#elm_sidebar .tab_sections {\n    padding-right: 10px;\n}\n\n#content-body .wmui-split_view .ph_left {\n    min-height: calc(100vh - 75px);\n}\n\n.elm_resize_vertical_handler {\n    bottom: 0;\n    cursor: col-resize;\n    position: absolute;\n    top: 35px;\n    width: 5px;\n    z-index: 500;\n    left: 220px;\n    border-right: 1px solid #797979;\n}\n\n.panels_container {\n    overflow: auto;\n}\n\n.status_bar {\n    height: 4px;\n    overflow: hidden;\n    white-space: nowrap;\n    z-index: 12;\n    border-top: 1px solid #A2A2A2;\n    background-color: #F3F3F3;\n}\n\n.status_bar {\n    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#DCDCDC), to(#FDFDFD));\n}\n\ndiv.panels_container {\n    position: absolute;\n    background-color: transparent;\n    right: 0;\n    left: 0;\n    top: 0;\n    bottom: 0;\n}\n\n#elm_sidebar div.panels_container {\n    padding: 0 !important;\n    background-color: #FAFAFA;\n}\n\n.default_background,\n.default_loader {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    text-align: center;\n    background: url(/images/ui/logo_inverted.png) no-repeat center center;\n    background-position-x: 50%;\n    background-position-y: 50%;\n    background-color: #F3F3F3 !important;\n    display: block;\n}\n\n.default_loader {\n    background: url(/images/ui/loader.svg) no-repeat center center;\n}\n\nol.silver > li.tab.current {\n    background: -webkit-gradient(linear, 0% 0%, 0% 50%, from(#FFFFFF), to(#FAFAFA));\n}\n\nol.silver > li.tab.current {\n    background: -moz-linear-gradient(to bottom, #FFFFFF, #FAFAFA);\n}\n\nol.silver > li.tab.current {\n    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#FEFEFE', endColorstr='#FAFAFA', GradientType=0);\n}\n\nul {\n    list-style: none;\n}\n\nul li {\n    float: left;\n    margin-right: 5px;\n}\n\nul li a {\n    text-decoration: none;\n}\n\n.icon {\n    float: left;\n    margin-right: 2px;\n    margin-top: 0;\n    width: 16px;\n    height: 16px;\n}\n\n.svg_icon {\n    float: left;\n    margin-right: 5px;\n    margin-top: 0;\n    width: 16px;\n    height: 16px;\n}\n\n.accordion-toggle .svg_icon {\n    line-height: 18px;\n    margin-right: 10px;\n}\n\n.accordion-toggle .wmui-btn {\n    float: right;\n    margin-top: -1px;\n    width: 60px;\n}\n\n.svg_icon > svg > path {\n    fill: #606060\n}\n\nli.current > .svg_icon > svg > path {\n    fill: #E0E0E0\n}\n\n.wmui-icon > svg > path {\n    fill: #AAAAAA\n}\n\n.wmui-icon > svg:hover > path {\n    fill: #DDDDDD\n}\n\n.btn {\n    float: left;\n    margin-right: 3px;\n    margin-top: 0;\n    width: 16px;\n    height: 16px;\n    cursor: pointer !important;\n}\n\n.first {\n    margin-left: 10px;\n}\n\n.last {\n    margin-right: 10px;\n}\n\n.section {\n    background: transparent;\n    overflow: auto;\n    margin-top: 5px;\n}\n\n.section .head {\n    cursor: pointer;\n    padding: 5px 0;\n}\n\n.section .title {\n    color: #39508A;\n    text-transform: uppercase;\n    font-size: 10px;\n    font-weight: bold;\n    padding-left: 10px;\n}\n\n.section ul.toolbar li {\n    position: relative;\n    float: left;\n    margin-left: 5px;\n    padding: 0 !important\n}\n\n.section ul.toolbar li.top {\n    top: -3px;\n}\n\n.section ul li {\n    cursor: pointer;\n    float: none;\n}\n\n.section li.search {\n    display: none;\n}\n\n.section .toolbar {\n    float: right;\n    margin-right: 5px;\n}\n\n.section .body {\n    width: 100%;\n    overflow: hidden;\n}\n\nul.items {\n    margin-right: -5px;\n    padding: 0;\n}\n\nli.item {\n    height: 24px;\n    line-height: 24px;\n    margin-top: 1px;\n    padding-left: 8px;\n    white-space: nowrap;\n}\n\nli.item.activate, li.item.deactivated {\n    height: 40px;\n}\n\n\nli.item div.title {\n    text-transform: none;\n    padding-left: 0;\n    padding-right: 10px;\n    font-size: .9em;\n    font-weight: normal;\n    color: #000000;\n    margin-left: 1em;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\nli.item div.title .tree {\n    display: flex;\n    justify-content: space-between;\n    padding-right: 10px;\n}\n\nli.item div.title .tree .lock {\n    color: #BCC9CA;\n}\n\nli.item div.title .tree {\n    display: flex;\n    justify-content: space-between;\n    padding-right: 10px;\n}\n\nli.item div.title.activate {\n    color: #E94547;\n}\n\nli.item div.title.deactivated {\n    color: grey;\n}\n\nli.item div.svg_icon {\n    text-align: center;\n}\n\nli.item div.accessor {\n    float: right;\n    margin-right: 7px;\n}\n\nli.item.current {\n    background-color: #224C4F;\n    background-position-x: 100%;\n    background-position-y: 50%;\n    background-repeat: no-repeat;\n}\n\nli.item.current.activate {\n    background-color: #E94547;\n}\n\n.subtitle {\n    font-size: 8px;\n    line-height: 0;\n}\n\nli.item.current.deactivated {\n    background-color: grey;\n}\n\nli.item.current .title,\nli.item.current .title.activate,\nli.item.current .title.deactivated {\n    color: white;\n}\n\nli.item.high .icon {\n    margin-right: 5px;\n    margin-top: 4px;\n    width: 32px !important;\n    height: 32px !important;\n}\n\nli.item.high .svg_icon {\n    float: left;\n    margin-right: 5px;\n    margin-top: 4px;\n    width: 32px !important;\n    height: 32px !important;\n}\n\nli.item.high .title {\n    height: 40px;\n}\n\nli.item.high {\n    height: 40px;\n    line-height: 40px;\n    margin-top: 1px;\n    white-space: nowrap;\n    padding-left: 20px;\n}\n\n.spacer {\n    float: left;\n    margin-right: 2px;\n    margin-top: 0;\n    width: 16px;\n    height: 16px;\n}\n\n.hidden {\n    display: none;\n}\n\n.hidden-transition {\n    opacity: 0;\n    max-height: 0;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.visible-transition {\n    opacity: 1;\n    max-height: 1000px; /* Arbitrary large value */\n    transition: opacity 1s ease, max-height 1s ease;\n}\n\n.search_panel {\n    position: absolute;\n    z-index: 1001;\n    left: 111px;\n    top: 0;\n    height: auto;\n    max-height: 90%;\n    overflow-y: auto;\n    overflow-x: hidden;\n    background-color: white;\n    border-right: 1px solid #A1A1A1;\n    border-bottom: 1px solid #A1A1A1;\n    width: 254px;\n    box-shadow: rgba(0, 0, 0, 0.2) 0 5px 25px;\n}\n\n.search_panel {\n    background: #FFFFFF;\n}\n\n.search_panel ul {\n    background-image: url(/images/ui/lst_bck_src.png);\n}\n\n.search_panel ul {\n    list-style: none;\n    border-bottom: 1px solid #E3E3E3;\n}\n\n.search_panel ul li {\n    white-space: nowrap;\n    float: none;\n    cursor: pointer;\n    padding: 0;\n    margin: 0;\n    height: 48px;\n    line-height: 1.5em;\n}\n\n.search_panel ul li:hover {\n    color: white;\n    background-color: #758193;\n}\n\n.search_panel ul li .icon {\n    margin-top: .5em;\n    margin-right: 5px;\n}\n\n.search_panel ul li .svg_icon {\n    margin-top: .5em;\n    margin-right: 5px;\n}\n\n.search_panel ul li .title {\n    padding-top: .5em;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    margin-right: 0;\n    font-size: 1em;\n    font-weight: bold;\n}\n\n.search_loader {\n    background-image: url(/images/ui/search_loader.gif) !important;\n}\n\n.search_panel ul li.no_result {\n    background-color: #F3F3F3;\n    padding: 10px 10px 0;\n    border-bottom: 4px solid white;\n}\n\n.search_panel ul li.no_result p {\n    color: gray;\n    text-align: center;\n    margin-bottom: 3px;\n}\n\n.search_panel ul li.no_result p.small {\n    font-style: italic;\n    font-size: 9px;\n    text-transform: normal;\n    text-align: center;\n    margin-bottom: 3px;\n}\n\n.center {\n    text-align: center;\n}\n\n.active {\n    background-color: #386BC0;\n}\n\n.error {\n    background-color: #EB4F35;\n}\n\n.success {\n    background-color: #50C029;\n}\n\n.box {\n    padding: 1em 2em;\n}\n\n.box .toolbar {\n    padding: 0;\n    margin: 0;\n    overflow: hidden;\n    border: 1px solid #C2C2C2;\n    height: 24px;\n}\n\n.box .toolbar {\n    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#FCFCFC), to(#E9E9E9));\n    background: -moz-linear-gradient(to bottom, #FCFCFC, #E9E9E9);\n    background-color: #BBBBBB;\n}\n\n.toolbar_button {\n    background-color: transparent;\n    border: 0 none transparent;\n    display: block;\n    float: left;\n    padding: 0;\n    vertical-align: top;\n    padding: 0;\n    height: 24px;\n    font-size: .9em;\n    cursor: pointer;\n    border-right: 1px solid #C2C2C2;\n    text-shadow: white 0 1px 1px;\n}\n\n.toolbar_button:hover,\n.toolbar > div > div.dropdown > .toolbar_button:hover {\n    background-color: rgba(255, 255, 255, .8)\n}\n\n.toolbar_button.active {\n    background-color: #C4C4C4;\n    color: white;\n    border: 1px solid #E3E3E3;\n}\n\n.toolbar_button.disabled {\n    background-color: rgba(255, 255, 255, .8);\n    color: #CBCBCB;\n}\n\n.toolbar_button_item {\n    width: 24px;\n    height: 24px;\n}\n\n.right {\n    border: 0 none transparent !important;\n    border-left: 1px solid #C2C2C2 !important;\n}\n\n.item_24 {\n    width: 24px !important;\n}\n\n.item_48 {\n    width: 48px !important;\n}\n\n.item_72 {\n    width: 72px !important;\n}\n\n.item_96 {\n    width: 96px !important;\n}\n\n.item_120 {\n    width: 120px !important;\n}\n\n.item_144 {\n    width: 144px !important;\n}\n\n.item_168 {\n    width: 168px !important;\n}\n\n.item_192 {\n    width: 192px !important;\n}\n\n.item_216 {\n    width: 216px !important;\n}\n\n.item_float {\n    padding: 0 1em;\n}\n\nselect.toolbar_select {\n    border: 1px solid #C2C2C2 !important;\n    width: 200px;\n    margin: 2px;\n}\n\n.toolbar label {\n    padding: 0 0 0 1em;\n    font-size: 10px !important;\n    font-weight: normal;\n}\n\n.toolbar_icon.item_float {\n    padding-left: 2.5em !important;\n}\n\n.toolbar > div > div.dropdown {\n    border-top: 1px solid #C2C2C2;\n}\n\n.toolbar > div > div.dropdown > .toolbar_button {\n    background-color: transparent;\n    display: block;\n    margin: 0;\n    padding: 0;\n    vertical-align: top;\n    padding: 0;\n    height: 24px;\n    font-size: .9em;\n    cursor: pointer;\n    text-shadow: white 0 1px 1px;\n    float: none;\n    border-width: 1px 1px 1px 1px;\n    border-color: #C2C2C2;\n    width: 25px;\n    border-style: none solid solid solid;\n}\n\n.toolbar > div > div.dropdown > .toolbar_button + .last {\n    border-style: solid;\n}\n\n.toolbar .from,\n.toolbar .to {\n    position: relative;\n    height: 24px;\n}\n\n.toolbar .from {\n    width: 140px;\n}\n\n.toolbar .to {\n    width: 130px;\n}\n\n.toolbar .from > label,\n.toolbar .to > label {\n    float: left;\n    top: 8px;\n    position: relative;\n    width: 0;\n    z-index: 1;\n}\n\n.toolbar .from > input,\n.toolbar .to > input {\n    width: 115px;\n    vertical-align: top;\n    height: 24px;\n    text-shadow: 0 1px 1px white;\n    display: block;\n    cursor: pointer;\n    background-color: transparent;\n    border-color: transparent;\n    border-style: none;\n    font-size: 10px;\n    margin: 0;\n    padding: 1px 10px 0 5px;\n    position: absolute;\n    text-align: right;\n    z-index: 2;\n}\n\n.toolbar .from > input {\n    width: 125px;\n}\n\n.toolbar .to > input {\n    width: 115px;\n}\n\ndl.stepped {\n    -webkit-user-select: text;\n    font-size: 10px;\n}\n\ndl.stepped dt {\n    font-size: 11px;\n    color: #000000;\n    font-weight: bold;\n    overflow: hidden;\n}\n\ndl.stepped dd {\n    font-size: 11px;\n    color: #535353;\n    margin-bottom: 5px;\n    text-align: justify;\n}\n\ndl.stepped.colored {\n    background-color: #F3F3F3;\n    padding: 1em 2em !important\n}\n\n.colored {\n    background-color: #F3F3F3;\n}\n\n.uppercase {\n    text-transform: uppercase;\n}\n\ntable {\n    width: 100%;\n    -webkit-user-select: text;\n    margin-top: 1em;\n}\n\ntable thead {\n    line-height: 2em;\n    font-size: 0.75em;\n    text-transform: uppercase;\n    font-weight: bold;\n    text-shadow: none;\n}\n\ntable thead th {\n    border-bottom: 1px solid #CBCBCD !important;\n    padding-left: 1em;\n}\n\ntable tbody tr {\n    line-height: 1.8em;\n    font-size: 0.8333em;\n    cursor: pointer;\n}\n\ntable.hv tbody tr:hover {\n    background-color: #336FD4 !important;\n    color: white;\n}\n\ntable.hv tbody tr:hover td > a {\n    color: white;\n}\n\ntable.hv tbody tr:hover td {\n    border-right: 1px solid transparent;\n}\n\ntable tbody td.sym {\n    width: 25px;\n    text-align: center;\n    padding-left: 0;\n}\n\ntable tbody td {\n    padding-left: 1em;\n    border-right: 1px solid #F3F3F3;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\ntable tbody td a {\n    text-decoration: none;\n    color: black;\n}\n\ntable tbody td.last {\n    border-width: 0 !important;\n}\n\ntable tbody td.red {\n    color: #E94547;\n}\n\ntable tbody td.blue {\n    color: #6EB3E3;\n}\n\ntable tbody td.green {\n    color: white;\n}\n\ntable tbody td.yellow {\n    color: #F5D124;\n}\n\ntable tbody td.gray {\n    color: #94979A;\n}\n\ntable.interval {\n    width: 452px;\n    border-style: solid;\n    border-width: 1px 0 0 0;\n    border-color: #444444;\n    padding-bottom: 5px;\n    color: black\n}\n\ntable.interval tr.spacer {\n    height: 5px;\n}\n\ntable.interval tr.spacer.shaded {\n    height: 5px;\n    background-color: #F0F0F0;\n    width: 100%\n}\n\ntable.interval th {\n    background-color: #F0F0F0;\n    border: 0;\n    font-size: 11px;\n    line-height: 17px;\n    padding: 0;\n    text-align: center;\n    width: 125px;\n}\n\ntable.interval th.head {\n    font-weight: bold;\n    background-color: #FAFAFA;\n}\n\ntable.interval th.top {\n    vertical-align: top;\n}\n\ntable.interval td {\n    text-align: left;\n    font-weight: bold;\n    border: 0;\n    padding: 0;\n    font-size: 11px;\n    line-height: 17px;\n}\n\ntable.interval td.unit {\n    text-align: left;\n    font-weight: normal;\n    border: 0;\n    padding: 0;\n}\n\ntable.interval input {\n    text-align: center;\n    width: 221px;\n    padding: 0;\n    margin: 0;\n}\n\ntable.interval input[type=radio] {\n    width: initial;\n    margin: 0 5px;\n}\n\ntable.interval input[type=radio]:focus {\n    margin: 0 5px\n}\n\ntable tbody tr.built_in,\ntable tbody tr.built_in a,\n.built_in {\n    color: gray;\n}\n\ntable.expanded {\n    border-top: 1px solid #E3E3E3;\n    border-bottom: 1px solid #E3E3E3;\n}\n\ntable.underline tbody tr:hover td {\n    background-color: #2372D5;\n    color: white;\n    border-right: 1px solid #A3B9D7;\n}\n\ntable.underline tbody td a {\n    color: white;\n}\n\ntable.base tbody tr td a {\n    color: blue;\n    text-decoration: underline;\n}\n\ntable.base tbody tr:hover td a {\n    color: white;\n    text-decoration: underline;\n}\n\ntable.ind {\n    margin: .5em 0 1em;\n    overflow: auto;\n    border-bottom: 1px solid #E3E3E3;\n}\n\ntable.ind tbody tr td {\n    border-top: 2px solid #FFFFFF;\n    border-bottom: 2px solid #FFFFFF;\n}\n\ntable.ind td p.title {\n    font-weight: bold;\n    font-size: 1.2em;\n    padding-top: .5em;\n}\n\ntable.ind td.sym {\n    padding: .5em;\n}\n\ntable.ind td p.lead {\n    font-weight: normal;\n    font-size: 1em;\n    padding-top: .5em;\n}\n\ntable.ind td {\n    background: -webkit-gradient(linear, 0% 20%, 0% 100%, from(#F1FFF6), to(#F1FFF6));\n}\n\ntable.ind td p.max {\n    font-weight: bold;\n    color: red;\n    padding: 0 .5em;\n}\n\ntable.ind td p.min {\n    font-weight: bold;\n    color: green;\n    padding: 0 .5em;\n}\n\ntable.ind td p.value {\n    font-size: 1.5em;\n    font-weight: bold;\n    color: blue;\n}\n\ntable td.top {\n    vertical-align: top;\n}\n\ntable td.center {\n    text-align: center;\n}\n\n\n/* table properties for showing metadata history in inspector panel */\n\ntable.metadata_history {\n    font-size: 12px;\n}\n\ntable.metadata_history tbody tr {\n    width: auto;\n}\n\ntable.metadata_history tbody tr td {\n    width: auto;\n}\n\n.strong {\n    font-weight: bold;\n}\n\n.explain {\n    padding: .5em;\n    border-bottom: 1px solid #E3E3E3;\n}\n\n.explain .error {\n    text-align: left;\n    font-size: .9em;\n    margin-bottom: 5px;\n}\n\n.explain > div {\n    padding: .5em 1em;\n}\n\n.explainError {\n    color: #CC0000;\n    font-size: 1em;\n    padding: 0;\n    border: none;\n}\n\n.explain .error.adhoc {\n    background-image: url(/images/ui/accessor_down.png);\n    background-position-x: 100%;\n    background-position-y: 50%;\n    background-repeat: no-repeat;\n}\n\n.explain .info {\n    border: 1px solid #F3F3F3;\n    background: #F7F7F7;\n    color: black;\n    font-size: .8em;\n    margin-bottom: 5px;\n    line-height: 1.8333;\n}\n\n.explain .notice {\n    background-color: #D8E0E1 !important;\n}\n\n.err {\n    color: #CC0000;\n}\n\n.err_dot {\n    color: #AE0000;\n    margin-left: 1em;\n    float: left;\n    font-size: 1em;\n    line-height: 1.5em;\n    cursor: pointer;\n}\n\n.err-help {\n    margin-left: 3px;\n    font-size: 1.2em;\n}\n\n.help {\n\n}\n\n/* .help:ho */\n\n/*tooltip*/\n\ndiv.stt {\n    padding: .3em .8em;\n    border-width: 2px !important;\n    position: absolute;\n    border: 2px solid #CC0000;\n    background: rgba(204, 0, 0, .75);\n    color: white;\n    font-size: .9em;\n    z-index: 10000;\n}\n\ndiv.stt {\n    box-shadow: rgba(0, 0, 0, 0.5) 0 5px 5px\n}\n\ndiv.stt_err {\n    border: 2px solid red;\n    background: rgba(179, 0, 3, .9);\n    color: white;\n    font-size: .9em;\n}\n\ndiv.stt_arr_down,\ndiv.stt_arr_down_inner {\n    position: absolute;\n    width: 0;\n    height: 0;\n    border-bottom-width: 0;\n    background: none;\n}\n\ndiv.stt_arr_down {\n    border-left: 7px solid transparent;\n    border-right: 7px solid transparent;\n    border-top-width: 14px;\n    bottom: -7px;\n    right: auto;\n    left: 50%;\n    margin-left: -7px;\n}\n\ndiv.stt_arr_down_inner {\n    border-right: 7px solid transparent;\n    border-left: 7px solid transparent;\n    border-top: 7px solid #CC0000;\n    bottom: auto;\n    top: -7px;\n    left: -7px;\n}\n\ndiv.stt_err div.stt_arr_down_inner {\n    border-top: 7px solid red;\n}\n\ndiv.sep {\n    color: gray;\n    overflow: auto;\n    padding: 3px 5px 0 5px !important;\n    margin-top: 1em;\n}\n\ndiv.sep h6 {\n    font-weight: bold;\n}\n\ndiv.sep_brd {\n    border-bottom: 1px solid rgb(227, 227, 227) !important;\n}\n\n.resource_error {\n    background-color: #DEDEDE;\n    color: white;\n}\n\nul.dashed {\n    padding: .5em;\n}\n\nul.dashed > li {\n    width: 100%;\n    min-width: 500px;\n    border: 2px solid transparent;\n}\n\nul.dashed > li.selected .spark_ind {\n    background: -webkit-gradient(linear, 0% 50%, 0% 100%, from(#F3F3F3), to(#F3F3F3));\n}\n\n.spark_ind {\n    text-shadow: rgba(255, 255, 255, 0.496094) 0 1px 1px;\n    border: 1px solid #E3E3E3;\n    background: -webkit-gradient(linear, 0% 50%, 0% 100%, from(#FBFBFB), to(#F9F9F9));\n    float: left;\n    margin: 0 5px 5px 0;\n}\n\n.spark_ind .title {\n    font-size: .9em;\n    font-weight: bold;\n    padding: .5em .5em;\n    margin-left: 5px;\n}\n\n.spark_ind .right {\n    border: none;\n}\n\n.spark_ind .pod {\n    width: 480px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 5px;\n}\n\n.spark_ind .folder {\n    width: 480px;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 5px;\n}\n\n.spark_ind .value {\n    width: 80px;\n    text-align: center;\n    padding: .5em;\n    float: left;\n    margin-right: 10px;\n    color: #144A77;\n}\n\n.spark_ind .value .number {\n    font-size: 1.8em;\n    font-weight: normal;\n    padding: 0;\n    margin: 0;\n    color: #144A77;\n}\n\n.spark_ind .value .unit {\n    font-size: 1em;\n    padding: 0;\n    margin: 0;\n}\n\n.spark_ind .canvas {\n    width: 300px;\n    height: 60px;\n    float: left;\n    margin: 0 5px;\n    border: 0 solid #E3E3E3;\n    border-bottom: 1px;\n}\n\n.spark_ind .time_elapse {\n    font-size: .8em;\n    padding: .5em 0;\n    margin: 0;\n    font-weight: bold;\n    text-align: center;\n    clear: both;\n    color: #949494;\n    padding-right: 10px;\n}\n\n.spark_ind .extras {\n    float: left;\n}\n\n.spark_ind .extras ul {\n    padding: 1em 0;\n    width: 60px;\n    overflow: auto;\n}\n\n.spark_ind .extras ul li {\n    text-align: center;\n    clear: both;\n    width: 100%;\n}\n\n.spark_ind .handler {\n    cursor: pointer;\n}\n\n.spark_ind .max {\n    font-size: .8em;\n    color: red;\n}\n\n.spark_ind .min {\n    font-size: .8em;\n    color: green;\n}\n\n._handler_ {\n    width: 16px;\n    height: 16px;\n    float: left;\n    margin-right: 2px;\n    cursor: pointer;\n    border: none !important\n}\n\n._handler_target_ {\n    padding: 0 1em;\n}\n\n._dash_handler_ {\n    width: 16px;\n    height: 16px;\n    float: left;\n    margin: -1px 3px;\n    cursor: pointer;\n    border: none !important;\n}\n\n.settings {\n    border: 1px solid transparent !important;\n}\n\ntd div.settings {\n    margin-top: 4px;\n}\n\n.on.settings {\n    z-index: 3;\n    border: 1px solid #949494 !important;\n    border-bottom: 3px solid #FAFAFA !important;\n    background-color: #FAFAFA;\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n    -moz-border-radius-top-left: 3px;\n    -moz-border-radius-top-right: 3px;\n}\n\n.context_menu {\n    position: absolute;\n    z-index: 20;\n    font-size: .9em;\n    margin-top: 3px;\n}\n\n.context_menu .btn {\n    position: absolute;\n    z-index: 4;\n    right: 0;\n    margin: 0 0 !important;\n    border-bottom: 0 solid #FAFAFA !important;\n    height: 17px;\n}\n\n.context_menu ul {\n    position: absolute;\n    z-index: 3;\n    left: 0;\n    top: 17px;\n    right: 0;\n    box-shadow: rgba(0, 0, 0, 0.1) 0 5px 5px;\n    -moz-box-shadow: rgba(0, 0, 0, 0.1) 0 5px 5px\n}\n\n.context_menu ul {\n    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#FAFAFA), to(#FFFFFF));\n    background: -moz-linear-gradient(to bottom, #FAFAFA, #FFFFFF);\n    background-color: #FFFFFF;\n}\n\n.context_menu ul {\n    border: 1px solid #BFBFBF;\n    padding: .5em;\n}\n\n.context_menu ul li {\n    list-style: none;\n    line-height: 1.8em;\n    border-bottom: 1px solid #E3E3E3;\n    margin: 0;\n    padding: 0 .5em;\n    clear: both;\n}\n\n.context_menu ul li:last-child {\n    border: none;\n}\n\n.context_menu ul li:hover {\n    background: #949494;\n    color: white;\n}\n\n.context_menu ul li:hover,\n.context_menu ul li:hover a {\n    color: white;\n    text-shadow: none;\n}\n\n.context_menu ul li a {\n    color: black;\n    text-shadow: rgb(255, 255, 255) 0 1px 1px;\n    width: 100%;\n}\n\n.btn.settings {\n    cursor: pointer;\n}\n\na.ctl {\n    text-decoration: none;\n    color: #C8C8C8;\n    text-transform: uppercase;\n    font-size: .78em;\n    margin-top: 2px;\n}\n\na.ctl:hover {\n    text-decoration: none;\n    color: #393939\n}\n\ndiv.chart_container {\n    border-top: 1px solid #E3E3E3;\n    padding: 0.5em 0;\n    margin-bottom: 2em;\n    overflow: hidden;\n}\n\ndiv.chart_container div.chart {\n    padding: .5em;\n    margin-bottom: .5em;\n    position: relative;\n    border: 1px solid #F3F3F3;\n}\n\ndiv.chart_container div.chart input {\n    float: left;\n    margin: .2em .5em 0 .25em;\n}\n\ndiv.chart_container div.chart div.canvas {\n    margin-left: 25px;\n    margin-top: .5em;\n}\n\ndiv.chart_container div.chart a.title {\n    cursor: pointer;\n}\n\ndiv.chart_container div.chart div.handler {\n    cursor: pointer;\n}\n\ndiv.chart_container div.chart div.context_menu {\n    position: absolute;\n    right: 4px;\n    top: 5px;\n    z-index: 20;\n}\n\ndiv.chart_container div.chart div.context_menu ul {\n    top: 17px;\n    margin-left: -120px;\n}\n\ndiv#cf-placeholder {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 999999;\n    overflow: hidden;\n}\n\niframe.chromeFrameInstallDefaultStyle {\n    z-index: 9999;\n}\n\ninput.number {\n    width: 60px !important;\n    float: left;\n    padding: .2em\n}\n\nselect.in {\n    width: 120px;\n    display: block;\n    float: left;\n    margin: .5em 1.5em .5em 0;\n}\n\ndiv.value_cont {\n    margin: 0 0;\n}\n\ndiv.placeholder div.chart {\n    clear: both;\n}\n\ndiv.placeholder div.legend {\n    float: left;\n    margin-left: 80px;\n    z-index: 10;\n}\n\ndiv.placeholder div.legend > ul > li {\n    width: 160px;\n    float: left;\n}\n\ndiv.placeholder div.legend > ul > li > div {\n    display: inline-block;\n    width: 15px;\n    height: 9px;\n    border-bottom: 2px solid;\n    margin-right: 5px;\n}\n\ndiv.placeholder div.legend > ul > li > a.legend_item {\n    text-decoration: none;\n    outline: none;\n    color: #333333;\n}\n\ndiv.placeholder div.legend > ul > li > a.unselected {\n    color: #CCCCCC !important;\n}\n\ndiv.pagination {\n    font-size: 10px !important;\n    line-height: 13px !important;\n    padding: 10px 0 0 2px;\n}\n\n\n/* calendar view (3d.js) */\n\n.ui_hc_calendar .day {\n    fill: #FFFFFF;\n    stroke: #CCCCCC;\n    shape-rendering: crispEdges;\n}\n\n.ui_hc_calendar .month {\n    fill: none;\n    stroke: #000000;\n    stroke-width: 2px;\n    shape-rendering: crispEdges;\n}\n\nimg.wise-loader {\n    display: block !important;\n    margin-left: auto;\n    margin-right: auto;\n}\n\nspan.red {\n    color: red;\n}\n\n.no-margin {\n    margin: 0 !important;\n}\n\n.no-padding {\n    padding: 0 !important;\n}\n\n.no-border {\n    border: none !important;\n}\n\ntable.buckets {\n    border-collapse: collapse;\n}\n\ntable.buckets tr:last-child {\n    border-bottom: 1px solid #3F3F3F;\n}\n\ntable.buckets td,\ntable.buckets th {\n    cursor: pointer !important;\n    font-size: 1.1em;\n    padding: 0 5px 0 0;\n    border: none;\n}\n\n#elm_sidebar .search {\n    border: 1px solid #CCCCCC;\n    box-sizing: border-box;\n    margin-left: 8px;\n    padding: 5px;\n    width: calc(100% - 18px)\n}\n",".wmui-card-view {\n    display: grid;\n    grid-template-columns: [first] 24.25% [line2] 24.25% [line3] 24.25% [line4] 24.25% [end];\n    margin: 20px;\n    grid-gap: 1%;\n    justify-content: flex-start;\n}\n\n.card {\n    background-color: #FFFFFF;\n    border-radius: 4px;\n    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1);\n    border: 1px solid #E4E4E7;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n}\n\n.card-cta {\n    background-color: #224C4F;\n    border: none;\n    border-radius: 2px;\n    color: white;\n    text-align: center;\n    width: -webkit-fill-available;\n\n    &.discard {\n        background-color: #CC3232;\n    }\n\n    &.activate {\n        background-color: #8BC53F;\n\n        &:hover {\n            background-color: #688715;\n        }\n    }\n\n    &:hover {\n        background-color: #8BC53F;\n    }\n\n    &:disabled {\n        background-color: #F8F8F8;\n        color: #224C4F;\n        cursor: not-allowed;\n    }\n\n    &::first-letter {\n        text-transform: capitalize;\n    }\n}\n\n.card-coming-soon {\n    color: #224C4F;\n    font-size: 12px;\n}\n\n.card-content {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    height: 100%;\n}\n\n.card-description {\n    padding: 10px;\n    text-align: justify;\n}\n\n.card-description p {\n    margin: 0;\n}\n\n.card-emphasis {\n    color: #333333;\n    font-weight: bold;\n    font-size: 1.5rem;\n    padding: 10px;\n}\n\n.card-header {\n    text-align: center;\n}\n\n.card-footer {\n    min-height: 60px;\n\n    div, button {\n        font-size: 12px;\n        font-weight: bold;\n        margin: 10px;\n        display: inline-block;\n    }\n\n    button {\n        padding: 10px 20px;\n    }\n\n    div {\n        padding: 10px 0px;\n    }\n}\n\n.card-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.card-links {\n    display: flex;\n    padding: 0px;\n}\n\n.card-list {\n    padding: 10px;\n    text-align: justify;\n    height: 250px;\n}\n\n.card-title-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n}\n\n.card-title {\n    height: 30px;\n    font-size: 14px;\n    margin: 0;\n    font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    width: 100%;\n    padding-top: 5px;\n    color: rgba(0, 0, 0, 0.6);\n    font-weight: 400;\n    line-height: 1.5;\n}\n\n.card-website, .card-linkedin {\n    font-size: medium;\n    text-align: right;\n    margin-right: 5px;\n}\n\n@media screen and (min-width: 600px) {\n    .card-grid {\n        grid-template-columns: repeat(auto-fit, minmax(0, 16%));\n    }\n}\n\n.wmui-small-card-view {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));\n    grid-gap: 10px;\n    margin: 10px;\n}\n\n.small-card {\n    background-color: #FFFFFF;\n    border-radius: 4px;\n    border: solid 1px #E0E0E0;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    padding: 10px 20px;\n}\n\n.small-card.green {\n    background: #8BC53F;\n}\n\n.small-card > .label {\n    font-weight: bold;\n\n    &::first-letter {\n        text-transform: capitalize;\n    }\n}\n\n.small-card > .label.green {\n    color: #8BC53F;\n}\n\n.small-card > .sub-label {\n    margin-bottom: 5px;\n    min-height: 18px;\n\n    &::first-letter {\n        text-transform: capitalize;\n    }\n}\n\n.small-card > .sub-label.green {\n    color: #8BC53F;\n}\n\n.small-card > .value {\n    font-weight: bold;\n    font-size: 20px;\n\n    &::first-letter {\n        text-transform: capitalize;\n    }\n}\n\n.small-card > .value.green {\n    color: #8BC53F;\n}\n\n.small-card > .bottom-label {\n    color: #999999;\n\n    &::first-letter {\n        text-transform: capitalize;\n    }\n}\n\n.small-card > .bottom-label.green {\n    color: #8BC53F;\n}\n\n/* Add these styles to ensure all cards have the same height */\n",".impact-analysis-box {\n    height: 80px;\n}\n\n.impact-analysis-box .results {\n    display: flex;\n    justify-content: space-between;\n}\n\n.workflow {\n    display: flex;\n    justify-content: space-between;\n    margin: 5px 0 15px 0 !important;\n}\n\n.workflow-caret {\n    margin: 0 5px;\n}\n\n.workflow-buttons {\n    background-color: #D3D3D3;\n    border: 1px solid #C3C3C3;\n    border-radius: 2px;\n    color: #444444;\n    cursor: pointer;\n    display: inline-block;\n    font-size: 12px;\n    height: 25px;\n    margin: 0;\n    padding: 2px 6px 2px 6px !important;\n    text-align: center;\n    text-transform: capitalize;\n    width: 75px;\n}\n\n.workflow-buttons:disabled {\n    opacity: 0.7;\n}\n\n.workflow-buttons:enabled:hover {\n    border-color: #8BC53F !important;\n    background-color: #8BC53F !important;\n    color: #224C4F !important;\n}\n\n.workflow-buttons:disabled:hover {\n    cursor: not-allowed;\n}\n\n.workflow-buttons#pending {\n    background-color: #6EB3E3;\n    border: solid 1px #6EB3E3;\n    color: white;\n}\n\n.workflow-buttons#ongoing {\n    background-color: #DB7B2B;\n    border: solid 1px #DB7B2B;\n    color: white;\n}\n\n.workflow-buttons#active, .workflow-buttons#completed {\n    background-color: #2DC937;\n    border: solid 1px #2DC937;\n    color: white;\n}\n\n.workflow-buttons#discarded {\n    background-color: #CC3232;\n    border: solid 1px #CC3232;\n    color: white;\n}\n\n.indicator-container {\n    padding: 5px 10px;\n    border: 1px solid #BBBBBB;\n    margin: 15px 0;\n}\n\n/* Side by side costs tables */\n\n.tables-wrapper {\n    display: flex;\n    justify-content: space-between;\n    margin-left: 10px;\n}\n\n.half-size-table {\n    padding: 15px;\n    flex: 1;\n    margin: 10px 10px 10px 0;\n    border-radius: 3px;\n}\n\n.half-size-table.cost {\n    background-color: #E8EDED;\n}\n\n.half-size-table.simulate {\n    background-color: #D2DBDB;\n}\n\n.half-size-table table {\n    width: 100%;\n    table-layout: fixed;\n}\n\ntr.half-totals {\n    background-color: #8BC53F;\n    color: white;\n    font-weight: bold;\n    font-size: 12px;\n}\n\ntr.half-variance {\n    border-top: 5px solid #D2DBDB;\n    background-color: #99C9EB;\n    color: white;\n    font-weight: bold;\n    font-size: 12px;\n}\n\n.half-table-title {\n    color: #224C4F;\n    font-size: 18px;\n}\n\n.half-table-legend {\n    font-size: 14px;\n}\n\n.half-table-title-wrapper {\n    min-height: 40px;\n}\n","/* reset.css */\nhtml, body, div, span, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, code, del, dfn, em, img, q, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    font-weight: inherit;\n    font-style: inherit;\n    font-size: 100%;\n    font-family: inherit;\n    vertical-align: baseline;\n}\n\nbody {\n    line-height: 1.5;\n}\n\ntable {\n    border-collapse: separate;\n    border-spacing: 0;\n}\n\ncaption, th, td {\n    text-align: left;\n    font-weight: normal;\n}\n\ntable, td, th {\n    vertical-align: middle;\n}\n\nblockquote:before, blockquote:after, q:before, q:after {\n    content: \"\";\n}\n\nblockquote, q {\n    quotes: \"\" \"\";\n}\n\na img {\n    border: none;\n}\n\n/*some bpp defaults*/\nbody {\n    cursor: default;\n    font-size: 75%;\n    color: #333333;\n    font-family: \"Lucida Grande\", \"Lucida Sans Unicode\", Helvetica, Arial, Verdana, sans-serif;\n    display: block;\n}\n\nh1, h2, h3, h4, h5, h6 {\n    font-weight: normal;\n    color: #000000;\n}\n\nul, ol {\n    margin: 0\n}\n\nul {\n    list-style-type: none;\n}\n\n.container {\n}\n\n.lft {\n    float: left;\n}\n\n.rgt {\n    float: right;\n}\n\ndiv.border {\n    padding-right: 4px;\n    margin-right: 5px;\n    border-right: 1px solid #EEEEEE;\n}\n\nhr {\n    background: #FFFFFF;\n    color: #000000;\n    clear: both;\n    float: none;\n    width: 100%;\n    height: .1em;\n    margin: 0 0 1.45em;\n    border: none;\n}\n\nhr.space {\n    background: #FFFFFF;\n    color: #FFFFFF;\n}\n\n.clearfix:after, .container:after {\n    content: \".\";\n    display: block;\n    height: 0;\n    clear: both;\n    visibility: hidden;\n}\n\n.clearfix, .container {\n    display: block;\n}\n\n.clear {\n    clear: both;\n}\n\n.state-label {\n    color: white;\n    padding: 5px;\n    border-radius: 3px;\n}\n","#wm-crud {\n    border: solid 1px #CCCCCC;\n    border-radius: 4px;\n    margin: 10px;\n    padding: 10px;\n}\n\n#wm-crud > #crud-header > #crud-title {\n    color: #8BC53F;\n    font-size: 20px;\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n\n#wm-crud > #crud-container > #crud-body {\n    max-height: none !important;\n}\n\n#wm-crud > #crud-container > #crud-body > .crud-info > form > dl > dd > .btn-group-organization {\n    padding: 0;\n}\n\n#wm-crud > #crud-container > #crud-body > .crud-info > form > dl > dt {\n    margin-top: 20px;\n}\n\n#wm-crud > #crud-container > #crud-body > .crud-info > form > dl > dt > label,\n#wm-crud > #crud-container > #crud-body > .crud-info > form > dl > div > dt > label {\n    font-size: 12px;\n    color: #224C4F;\n\n    .err-help {\n        color: red\n    }\n}\n\n#wm-crud > #crud-container > #crud-body > .crud-info > form > dl > dd > select {\n    font-size: 12px;\n    height: 28px;\n    width: -webkit-fill-available;\n    border-radius: 4px;\n}\n\n#wm-crud > #crud-container > #crud-body > .crud-info > form > dl > dd > input {\n    border-width: 1px;\n    font-size: 12px;\n    height: 14px;\n    width: -webkit-fill-available;\n    border-radius: 4px;\n\n    &.input-file {\n        height: 19px;\n    }\n\n    &:focus {\n        border-color: #8BC53F;\n        padding: 5px;\n    }\n}\n\n#wm-crud > #crud-container > #crud-footer {\n    margin-top: 20px;\n}\n\n#wm-crud > #crud-container > #crud-footer > .crud-btns {\n    display: flex;\n    justify-content: space-between;\n}\n\n#wm-crud > #crud-container > #crud-footer > .crud-btns > div > input {\n    background-color: #224C4F;\n    border: none;\n    border-radius: 4px;\n    color: #FFFFFF;\n    padding: 10px;\n    min-width: 80px;\n}\n\n","#lmit_mbx {\n    border: 1px solid #AAAAAA;\n    background: #FFFFFF;\n    border-radius: 6px;\n}\n\n.mbx_mask {\n    z-index: 5000;\n    position: absolute;\n    top: 0;\n    left: 0;\n    -moz-opacity: 0.5;\n    opacity: .50;\n    filter: alpha(opacity=50);\n    background-color: black;\n    width: 100%;\n    height: 100%;\n}\n\n.mbx {\n    padding: 0;\n    text-align: left;\n    font-size: 1em;\n    -moz-border-radius: 0;\n    box-shadow: rgba(0, 0, 0, 0.2) 0 5px 25px;\n    -moz-box-shadow: rgba(0, 0, 0, 0.2) 0 5px 25px\n}\n\n.mbx .mbx_head {\n    border-top-right-radius: 6px;\n    border-top-left-radius: 6px;\n    padding: 10px;\n    color: black !important;\n    text-decoration: none;\n    text-shadow: rgb(238, 238, 238) 1px 1px 0;\n    cursor: move;\n    background: -moz-linear-gradient(to bottom, #FCFCFC, #E9E9E9);\n    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#FCFCFC), to(#E9E9E9));\n    text-align: center;\n    font-size: 12px;\n    background-color: #BBBBBB;\n    border-bottom: 1px solid #AAAAAA;\n}\n\n.mbx .mbx_body {\n    background: white;\n    border-bottom-right-radius: 6px;\n    border-bottom-left-radius: 6px;\n    margin: 0;\n    padding: 0;\n}\n\n.mbx .mbx_cont {\n    overflow: auto;\n    padding: 5px;\n}\n\n.mbx .mbx_cont ul li {\n    float: none;\n}\n\n.mbx .mbx_body .mbx_msg {\n    font-size: 1.5em;\n    line-height: 1.5em;\n    text-align: center;\n    margin: 1em;\n}\n\n.mbx .mbx_body .mbx_msg h4 {\n    text-align: center;\n}\n\n.mbx_btns_pod {\n    padding: 5px;\n    margin: .8em;\n}\n\n.mbx .mbx_body .mbx_btns_pod {\n    background: -moz-linear-gradient(to bottom, #FFFFFF, #E8E8E8);\n    height: 24px;\n}\n\n.mbx .mbx_body .mbx_btns {\n    overflow: hidden;\n    background-color: #FAFAFA;\n    border-top: 1px solid #C2C2C2;\n    border-bottom-right-radius: 6px;\n    border-bottom-left-radius: 6px;\n}\n\n.mbx .mbx_body .mbx_btns_pod input {\n    margin-top: 0;\n    font-weight: bold !important;\n}\n\n.mbx .mbx_body .mbx_btns input {\n    border: 1px solid #BBBBBB;\n    border-radius: 4px;\n    font-size: .9em;\n    height: 24px;\n    margin-right: 4px !important;\n}\n\n.mbx_btns {\n    display: flex;\n    justify-content: space-between;\n    min-height: 36px;\n}\n\na.mbx_btn_close {\n    float: right;\n    margin: 2px;\n    background: url(/images/ui/spt.png) no-repeat;\n    background-position: -1px -1px;\n    width: 14px;\n    height: 14px;\n    display: block;\n}\n\na.mbx_btn_close:hover {\n    background-position: -18px -1px;\n}\n\n.mbx label {\n    font-size: 10px;\n    line-height: 14px;\n\n    &::first-letter {\n        text-transform: capitalize;\n    }\n}\n\n.mbx input.title {\n    font-size: 1.5em;\n    width: 260px;\n}\n\n.mbx .mbx_body input:focus, .mbx input.title:focus, .mbx textarea:focus, .mbx select:focus {\n    border: 2px solid #8BC53F;\n    margin: 0;\n}\n\n.mbx textarea:focus {\n    margin: 1px;\n}\n\n.mbx input.mbx_text, input.title {\n    width: 280px;\n    padding: 5px\n}\n\n.mbx select {\n    padding: 2px;\n}\n\n.mbx textarea.mbx_text {\n    width: 280px;\n    height: 120px;\n    padding: 5px;\n}\n\n.mbx legend {\n    font-weight: normal;\n    font-size: .9em;\n    font-style: italic;\n}\n\n.mbx .mbx_wait {\n    background: url(/images/ui/mbx/wait_icn.gif) no-repeat 0 0;\n}\n\n.mbx .btn:hover {\n    text-shadow: gray 1px 1px 1px\n}\n\n.mbx-info, .mbx_calendar {\n    padding: 10px;\n    text-align: center;\n}\n\n.mbx-info.green {\n    background-color: #8BC53F;\n    color: white;\n    padding: 15px;\n}\n\n.text-left {\n    text-align: left;\n}\n\n.mbx_calendar {\n    text-align: justify;\n}\n\n.mbx input.text, .mbx textarea.text, .mbx select.text, .mbx div.text {\n    font-size: 12px;\n    padding: 5px;\n    margin: 0;\n    border: 1px solid #BBBBBB;\n    box-sizing: border-box;\n    width: 100% !important;\n    border-radius: 4px;\n}\n\n.mbx select.text {\n    text-transform: capitalize;\n}\n\n.mbx textarea.text, .mbx div.text {\n    height: 50px;\n}\n\n.mbx div.text {\n    overflow: auto;\n}\n\n.mbx textarea.text.big, .mbx div.text.big {\n    height: 100px;\n}\n\n.mbx select.text {\n    width: 414px;\n    padding: 5px;\n    height: 27px;\n\n    &::first-letter {\n        text-transform: capitalize;\n    }\n}\n\n.mbx select.text[multiple] {\n    height: auto;\n}\n\n.mbx input.text:focus, .mbx textarea.text:focus, .mbx select.text:focus, .mbx div.text:focus {\n    border: 1px solid #372086;\n    margin: 0;\n    padding: 5px;\n}\n\n.mbx select.text:focus {\n    padding: 5px;\n}\n\n.stepped.zero {\n    margin: 0 !important;\n}\n\ninput.vertical-middle {\n    position: relative;\n    top: -1px;\n}\n\n.mbx dd.last {\n    margin-bottom: 0;\n}\n\n.mbx-input-group {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n.mbx-input-group-text {\n    flex: 1;\n}\n\n.mbx-input-group-button {\n    background-color: transparent;\n    border: 1px solid #BBBBBB;\n    border-radius: 4px;\n    cursor: pointer;\n    flex: 0 0 100px;\n    font-size: 1em;\n    font-weight: bold !important;\n    height: 26px;\n    margin: 0px 0px 5px 5px;\n    max-width: 30%;\n    padding: 0 10px;\n}\n\n.mbx .mbx_body .mbx-input-group-button:focus {\n    margin: 0px 0px 5px 5px;\n}\n",".no-access {\n    margin: 20px 10px;\n    padding: 10px;\n    background-color: #F8F8F8;\n    border-left: solid 4px #F5D124;\n}\n",".spt, .icon {\n    /* background: url(/images/ui/spt.png) no-repeat; */\n}\n\n.underline {\n    background: url(/images/ui/tbl_bck.png);\n}\n\n.underline30 {\n    background: url(/images/ui/lst_bck_src.png);\n}\n\n\n#search .close {\n    background-position: -102px -1px\n}\n\n#search .close:hover {\n    background-position: -120px -1px\n}\n\n.arrow {\n    background-position: -86px -51px\n}\n\nli:hover .arrow {\n    background-position: -102px -51px\n}\n\n\n#search .display {\n    background-position: -102px -17px\n}\n\n#search .display:hover {\n    background-position: -120px -17px\n}\n\n/*system icons*/\n.close {\n    background-position: -34px -1px\n}\n\nli.active > .close {\n    background-position: -1px -1px\n}\n\n.close:hover {\n    background-position: -17px -1px\n}\n\nli.active > .close:hover {\n    background-position: -17px -1px\n}\n\n._dash_handler_, .handler {\n    background-position: -51px -1px;\n}\n\n.expanded .handler {\n    background-position: -68px -1px\n}\n\n.settings {\n    background-position: 0 -52px;\n}\n\n.on_settings {\n    background-position: 0 -52px;\n}\n\nli .tree_handler {\n    background-position: -35px -53px;\n    padding-right: 5px;\n    color: grey;\n    width: auto;\n}\n\nli.expanded .tree_handler {\n    background-position: -18px -53px;\n}\n\nli.current .tree_handler {\n    background-position: -18px -53px;\n    color: white !important;\n}\n\n/*extended icons*/\n.explorer {\n    background-position: -18px -18px\n}\n\nli.current > .explorer {\n    background-position: -1px -18px\n}\n\n.management {\n    background-position: -52px -18px\n}\n\nli.current > .management {\n    background-position: -35px -18px\n}\n\n/* .wise_logo {background-position: -86px -18px} */\n.dashboard {\n    background-position: -86px -18px\n}\n\n.dashboard:hover {\n    background-position: -69px -18px\n}\n\n.current.dashboard {\n    background-position: -69px -18px\n}\n\n.mark {\n    background-position: 0 -315px;\n    width: 107px !important;\n    height: 28px !important;\n    margin-top: 3px;\n    margin-left: 4px;\n}\n\n/*theme*/\n.notification {\n    background-position: -1px -35px\n}\n\n.exit {\n    background-position: -18px -35px\n}\n\n.help {\n    background-position: -35px -35px\n}\n\n.exclamation {\n    background-position: -51px -35px\n}\n\n.success {\n    background-position: -69px -35px\n}\n\n/*section icons*/\n.site {\n    background-position: -1px -86px\n}\n\n.zone {\n    background-position: -136px -1px\n}\n\n.circuit {\n    background-position: -34px -121px\n}\n\n.equipment {\n    background-position: -19px -121px\n}\n\n.folder {\n    background-position: -35px -87px\n}\n\n.plot {\n    background-position: -69px -120px\n}\n\n.device {\n    background-position: -18px -120px\n}\n\n.indicator, .raw {\n    background-position: -69px -120px\n}\n\n.complex {\n    background-position: -52px -120px\n}\n\n.cost {\n    background-position: -68px -103px\n}\n\n.reading {\n    background-position: -86px -103px\n}\n\n.time_1 {\n    background-position: -19px -102px\n}\n\n.current .time_1 {\n    background-position: -19px -102px\n}\n\n/*defaults*/\n.default_16 {\n    background-position: -103px -86px\n}\n\n.tools {\n    background-position: -103px -103px\n}\n\n.profile {\n    background-position: -137px -103px\n}\n\n.operations {\n    background-position: -137px -70px\n}\n\n.tariffs {\n    background-position: -137px -41px\n}\n\n.tags {\n    background-position: -137px -15px\n}\n\n.member {\n    background-position: -103px -135px\n}\n\n.groups {\n    background-position: -137px -162px\n}\n\n.gears {\n    background-position: -103px -162px\n}\n\n.params {\n    background-position: -72px -160px\n}\n\n/*toolbar*/\n.inline_icon, .toolbar_icon {\n    background: url(/images/ui/tbr2.png) no-repeat;\n    width: 24px;\n}\n\n\n.curve {\n    background-position: -1px -1px\n}\n\n.chart {\n    background-position: -1px -252px\n}\n\n.implode {\n    background-position: -1px -200px\n}\n\n.table {\n    background-position: -1px -276px\n}\n\n.print {\n    background-position: -1px -175px\n}\n\n.share {\n    background-position: -1px -1px\n}\n\n.edit {\n    background-position: -1px -25px\n}\n\n.plus {\n    background-position: -1px -51px\n}\n\n.minus {\n    background-position: -1px -76px\n}\n\n.remove {\n    background-position: -1px -351px\n}\n\n.pw {\n    background-position: -1px -377px\n}\n\n.new_zone, .new_folder, .new_pod {\n    background-position: -1px -403px\n}\n\n.xls {\n    background-position: -1px -477px\n}\n\n.pdf {\n    background-position: -1px -427px\n}\n\n.csv {\n    background-position: -1px -452px\n}\n\n.join {\n    background-position: -1px -503px\n}\n\n.new_filtered_chart {\n    background-position: -1px -528px\n}\n\n.sum {\n    background-position: -1px -553px\n}\n\n.event {\n    background-position: -1px -577px\n}\n\n.trigger {\n    background-position: -1px -603px\n}\n\n.explode {\n    background-position: -1px -628px\n}\n\n.select_all {\n    background-position: -52px -69px\n}\n\n.select_none {\n    background-position: -35px -69px\n}\n\n.more {\n    background-position: -52px -51px\n}\n\n.less {\n    background-position: -68px -51px\n}\n\na.sel_all span {\n    background-position: -52px -69px;\n}\n\na.ctl {\n    display: inline-block;\n}\n\na.icn, a.ctl span {\n    display: block;\n    width: 16px;\n    height: 16px;\n    float: left;\n    margin-right: 3px;\n}\n\na.icn {\n    margin-right: .5em;\n}\n\na.icn.off {\n    opacity: .2;\n}\n\na.unsel_all span {\n    background-position: -35px -69px;\n}\n\na.exp_all span {\n    background-position: -86px -69px;\n}\n\na.clp_all span {\n    background-position: -103px -69px;\n}\n\na.watch {\n    background-position: -69px -68px;\n}\n\na.overlay {\n    background-position: -120px -68px;\n}\n\na.spacer {\n    background-position: -152px -134px;\n}\n\n\n/*inspector*/\n.info {\n    background-position: -47px -137px\n}\n\nli.current > .info {\n    background-position: -47px -137px\n}\n\n.list {\n    background-position: -1px -136px\n}\n\nli.list > .list {\n    background-position: -1px -136px\n}\n\n.preview-logo {\n    border: none;\n}\n\n.preview-image {\n    max-height: 200px;\n}\n","/*typo*/\nbody {\n    font-size: 75%;\n    color: #333333;\n    font-family: \"Lucida Grande\", \"Lucida Sans Unicode\", Helvetica, Arial, Verdana, sans-serif\n}\n\nh1, h2, h3, h4, h5, h6 {\n    font-weight: normal;\n    color: #111111;\n}\n\nh1 {\n    font-size: 3em;\n    line-height: 1;\n    margin-bottom: 0.5em;\n}\n\nh2 {\n    font-size: 2em;\n    margin-bottom: 0.75em;\n}\n\nh3 {\n    font-size: 1.5em;\n    line-height: 1;\n    margin-bottom: 1em;\n}\n\nh4 {\n    font-size: 1.2em;\n    line-height: 1.25;\n    margin-bottom: 1.25em;\n}\n\nh5 {\n    font-size: 1em;\n    font-weight: bold;\n    margin-bottom: 1.5em;\n}\n\nh6 {\n    font-size: .8em;\n    font-weight: normal;\n    line-height: 2em;\n}\n\np {\n    margin: 0 0 1.5em;\n}\n\nimg {\n    border-width: 0 !important;\n}\n\n.bottom {\n    margin-bottom: 0 !important;\n}\n\np img.left {\n    float: left;\n    margin: 1.5em 1.5em 1.5em 0;\n    padding: 0;\n}\n\np img.right {\n    float: right;\n    margin: 1.5em 0 1.5em 1.5em;\n}\n\nstrong {\n    font-weight: bold;\n}\n\n.strong {\n    font-weight: bold;\n}\n\nem, dfn {\n    font-style: italic;\n}\n\ndfn {\n    font-weight: bold;\n}\n\nsup, sub {\n    line-height: 0;\n}\n\n.small {\n    font-size: .8em;\n}\n\nabbr, acronym {\n    border-bottom: 1px dotted #666666;\n}\n\naddress {\n    margin: 0 0 1.5em;\n    font-style: italic;\n}\n\ndel {\n    color: #666666;\n}\n\npre {\n    margin: 1.5em 0;\n    white-space: pre;\n    text-align: left;\n}\n\npre, code, tt {\n    font: 1em 'andale mono', 'lucida console', monospace;\n    line-height: 1.5;\n}\n\nhr {\n    background: #DDDDDD;\n    color: #DDDDDD;\n    clear: both;\n    float: none;\n    width: 100%;\n    height: .1em;\n    margin: 0 0 1.45em;\n    border: none;\n}\n\nhr.space {\n    background: #FFFFFF;\n    color: #FFFFFF;\n}\n\n.clearfix, .container {\n    display: block;\n}\n\n.clear {\n    clear: both;\n}\n\n.right {\n    float: right;\n}\n\n.left {\n    float: left;\n}\n\n/* forms.css */\nlabel {\n    font-size: .8em;\n    line-height: 1.2em;\n}\n\nfieldset {\n    padding: 1.4em;\n    margin: 0 0 1.5em 0;\n    border: 1px solid #CCCCCC;\n}\n\nlegend {\n    font-weight: bold;\n    font-size: 1.2em;\n}\n\ninput.text, input.title, textarea, select {\n    border: 1px solid #BBBBBB;\n    margin: 1px;\n}\n\ninput[type=file] {\n    border: 2px solid #BBBBBB;\n}\n\ninput.text:focus, input.title:focus, textarea:focus {\n    border: 2px solid #68B0EE;\n    padding: 4px;\n}\n\ninput.text, input.title {\n    padding: 5px;\n}\n\ninput.title {\n    font-size: 1.3em;\n}\n\n.crn_all {\n    border-radius: 3px;\n}\n\ntextarea {\n    font-family: \"Lucida Grande\";\n    height: 60px;\n    padding: 5px;\n}\n\n/*colors*/\n.white {\n    color: white;\n}\n\n.green {\n    color: green;\n}\n\n.underlined-text {\n    text-decoration: underline;\n}\n","#widgets {\n    display: flex;\n    flex-flow: row wrap;\n    justify-content: space-around;\n}\n\n#widgets.list {\n    flex-flow: column wrap !important;\n    align-items: center;\n}\n\n#widgets.below-table {\n    display: flex;\n    flex-flow: row wrap;\n    justify-content: space-around;\n}\n\n.widget {\n    flex: 1;\n    padding: 0 5px;\n    margin: 5px 0;\n    min-width: 50%;\n    max-width: 100%;\n    width: 100%;\n    border: 0;\n    background: none;\n    height: 310px;\n    font-size: 10px;\n    line-height: 18px;\n    vertical-align: middle;\n}\n\n.widget.tall {\n    height: 425px;\n}\n\n.widget.full {\n    min-width: 100%;\n}\n\n.widget .title {\n    width: 100%;\n    position: relative;\n    float: left;\n    height: 30px;\n    margin: 0;\n    padding-top: 5px;\n    font-size: 12px;\n    border-radius: 3px 3px 0 0;\n    background: #224C4F;\n    text-align: center;\n    color: white;\n    font-weight: bold;\n}\n\n.widget .content {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 280px;\n    min-height: 280px;\n    max-height: 280px;\n    background-color: #E8E8E8;\n    float: left;\n    border-radius: 0 0 3px 3px;\n}\n\n.widget.tall .content {\n    height: 400px;\n    min-height: 400px;\n    max-height: 400px;\n}\n\n.widget .chart {\n    position: relative;\n    height: 280px;\n    width: 0;\n    flex: 1;\n    display: inline-block;\n}\n\n.widget.tall .chart {\n    height: 380px;\n}\n\n.widget .legend {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    flex: 0;\n    position: relative;\n    text-align: center;\n    width: 100px;\n    padding: 0 5px;\n}\n\n.widget .middle {\n    top: 80px;\n}\n\n.widget .legend .title {\n    position: relative;\n    float: left;\n    background: none;\n    width: 90px;\n    height: 20px;\n    min-height: 20px;\n    max-height: 20px;\n    line-height: 20px;\n    color: white;\n    font-weight: bold;\n    text-overflow: ellipsis;\n    text-transform: capitalize;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.widget .legend .tall {\n    height: 32px;\n    min-height: 32px;\n    max-height: 32px;\n    line-height: 16px;\n}\n\n.widget .legend .value {\n    position: relative;\n    float: left;\n    width: 90px;\n    height: 20px;\n    min-height: 20px;\n    max-height: 20px;\n    background-color: white;\n    /* border-radius: 0 0 5px 5px; */\n    margin-bottom: 10px;\n    font-weight: bold;\n}\n\n.widget .legend .last {\n    margin-bottom: 0;\n}\n\n.widget .legend .comparison {\n    /* border-radius: 0; */\n    margin-bottom: 0;\n}\n\n.widget .legend .positive {\n    color: white;\n    background-color: green;\n    margin-bottom: 0;\n}\n\n.widget .legend .negative {\n    color: white;\n    background-color: #E94547;\n    margin-bottom: 0;\n}\n\n.widget .loader {\n    line-height: 280px;\n    text-align: center;\n    color: #CCCCCC;\n    font-weight: bold;\n    font-size: 24px;\n}\n\n.widget .highcharts-data-labels.highcharts-pie-series {\n    z-index: -1;\n}\n\n.widget .highcharts-legend-item span {\n    z-index: -1;\n    height: 240px;\n}\n\n.widget .value-displayer {\n    flex-direction: column;\n    justify-content: center;\n}\n\n.widget .value-displayer .value svg {\n    color: #224C4F;\n    transform: rotate(-45deg);\n    font-size: 0.8em;\n}\n\n.widget .value-displayer .value {\n    font-size: 40px;\n    font-weight: bold;\n    height: 60px;\n    color: #8BC53F;\n}\n\n.widget .value-displayer .name {\n    font-size: 15px;\n    color: #224C4F;\n}\n\n.nav.widget-options select {\n    display: inline-block;\n    padding: 4px 6px;\n    margin-top: 4px;\n    margin-left: -5px;\n    font-size: 14px;\n    color: #555555;\n    vertical-align: middle;\n    /* -webkit-border-radius: 4px; */\n    /* -moz-border-radius: 4px; */\n    /* border-radius: 4px; */\n    height: 30px;\n    line-height: 30px;\n    background-color: #FFFFFF;\n    border: 1px solid #CCCCCC;\n}\n\n.sortable {\n    height: calc(39 * 34px);\n}\n\n.sortable .member {\n    background: #EEEEEE;\n    border: 1px solid #CCCCCC;\n    cursor: move;\n    margin: 4px;\n    padding: 5px 10px;\n    width: calc(100% - 30px);\n}\n\n.sortable .member input[type=checkbox] {\n    float: right;\n    height: 18px;\n    vertical-align: middle;\n}\n\n.legend {\n    position: relative;\n    font-size: 10px;\n    text-align: center;\n    height: 100%;\n}\n\n.legend .title {\n    padding-top: 0;\n    font-size: 10px;\n    color: white;\n    border-radius: 3px 3px 0 0;\n    line-height: 21px;\n    height: 20px;\n    min-height: 20px;\n    max-height: 20px;\n}\n\n.legend .value {\n    line-height: 21px;\n}\n\n.legend .past-value.value,\n.legend .currentGoal.value,\n.legend .no-comparison.value {\n    margin-bottom: 10px;\n    border-radius: 0 0 3px 3px;\n}\n\n.legend .percentage.value {\n    color: white;\n    margin-bottom: 10px;\n    border-radius: 0 0 3px 3px;\n}\n\n/* New dashboard Widgets */\n\n.basic-widget {\n    background-color: #FFFFFF;\n    overflow: hidden;\n    min-height: 382px;\n    position: relative;\n    font-size: 10px;\n    line-height: 18px;\n    vertical-align: middle;\n    border: 1px solid #DDDDDD;\n    border-radius: 4px;\n    margin-right: 1%;\n    margin-bottom: 1%;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, .3);\n}\n\n.basic-widget.hidden-true {\n    display: none;\n}\n\n.dashboard.edit-mode .basic-widget.hidden-true {\n    display: block;\n}\n\n.dashboard.edit-mode .basic-widget {\n    border: dashed 1px #8A8A8A;\n    box-shadow: none;\n    border-radius: 0px;\n    cursor: grab;\n}\n\n.basic-widget .chart {\n    width: 100%;\n}\n\n.basic-widget .content-map {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    float: left;\n    max-height: inherit;\n    height: 100%;\n}\n\n.basic-widget .empty-content {\n    padding: 15px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 279px;\n    float: left;\n    font-size: 15px;\n    font-weight: 300;\n    line-height: 20px;\n    text-shadow: 0 1px 0 #FFFFFF;\n    color: #CC3232;\n}\n\n.basic-widget .highcharts-data-labels.highcharts-pie-series {\n    z-index: -1;\n}\n\n.basic-widget .highcharts-legend-item span {\n    z-index: -1;\n    height: 240px;\n}\n\n.basic-widget .loader {\n    line-height: 280px;\n    text-align: center;\n    color: #CCCCCC;\n    font-weight: bold;\n    font-size: 24px;\n}\n\n.basic-widget .title {\n    width: 98%;\n    position: relative;\n    float: left;\n    height: 50px;\n    font-size: 1.5em;\n    text-align: left;\n    padding: 0 2% 0 2%;\n    align-items: center;\n    display: flex;\n}\n\n.basic-widget .widget-content {\n    position: relative;\n    padding: 15px;\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    float: left;\n}\n\n.basic-widget .widget-content .highlight-value {\n    opacity: 0.9;\n    height: 60px;\n    width: 100px;\n    font-size: 1.5em;\n    align-content: center;\n    position: absolute;\n    top: 0px;\n    right: 15px;\n    border-radius: 4px;\n    z-index: 1;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, .3);\n}\n\n.basic-widget-normalization {\n    position: absolute;\n    right: 0;\n    z-index: 100;\n    font-size: 10px;\n    font-weight: thin;\n    align-items: center;\n}\n\n.basic-widget-normalization span {\n    cursor: pointer;\n    border-radius: 3px;\n    border: 1px solid transparent;\n    padding: 3px 5px;\n    margin: 0 2px 0 0;\n    text-align: center;\n}\n\n.basic-widget-normalization span:hover {\n    cursor: pointer;\n    color: white;\n    background-color: #224C4F;\n}\n\n.dashboard.edit-mode .basic-widget .basic-widget-normalization {\n    display: none;\n}\n\n.basic-widget-underline {\n    color: #333333;\n    text-decoration: underline;\n}\n\n.basic-widget-options {\n    display: none;\n}\n\n.edit-mode .basic-widget-options {\n    display: block;\n    position: absolute;\n    right: 0;\n    z-index: 100;\n    color: #333333;\n    font-size: 15px;\n    font-weight: bold;\n    cursor: pointer;\n    align-items: center;\n}\n\n.empty-notification {\n    color: #777777;\n    font-weight: 300;\n}\n\n.empty-symbol {\n    flex: 0 0 25%;\n    display: flex;\n    height: 50%;\n}\n\n.empty-symbol svg {\n    opacity: 0.8;\n    width: 100%;\n    height: auto;\n    max-width: 100%;\n    padding-bottom: 20px;\n    color: #777777;\n}\n\n.grid-half {\n    min-width: 49%;\n    max-width: 49%;\n    width: 49%;\n}\n\n#widgets-wrapper {\n    padding: 1% 0 0 1%;\n    display: flex;\n    flex-flow: row wrap;\n    justify-content: space-between;\n}\n\n#widgets-wrapper.below-table {\n    display: flex;\n    flex-flow: row wrap;\n    justify-content: space-around;\n}\n\n#widgets-wrapper.list {\n    flex-flow: column wrap !important;\n    align-items: center;\n}\n\n.widget-options-wrapper {\n    padding: 5px;\n    position: absolute;\n    z-index: 999;\n    top: 0;\n    right: -50%;\n    transition: 1s;\n    background-color: white;\n    box-shadow: 0 0 3px rgba(0, 0, 0, .5);\n    opacity: 0;\n    width: 50%;\n    height: 100%;\n}\n\n.widget-options-wrapper.active {\n    right: 0;\n    opacity: 0.96;\n    transition: 1s;\n}\n\n.widget-options-buttons {\n    padding: 3px;\n    text-align: left;\n    width: 100%;\n    border-top: 1px solid #D4D4D4;\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    background-color: #FAFAFA;\n    background-image: linear-gradient(to bottom, #FFFFFF, #F2F2F2);\n}\n\n.widget-options-button {\n    border-radius: 3px !important;\n    -moz-border-radius: 3px !important;\n    background: none;\n    border: 1px solid transparent !important;\n    padding: 1px 3px !important;\n    font-size: 10px;\n    font-weight: bold;\n    cursor: pointer;\n    margin: 0 2px 0 0 !important;\n    text-align: center;\n    line-height: 25px;\n    color: #224C4F;\n}\n\n.widget-options-button:hover {\n    background-color: #224C4F;\n    color: white;\n}\n\n.widget-hidden {\n    position: absolute;\n    z-index: 99;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: white;\n    opacity: 0.8;\n}\n\n.widget-hidden-icon {\n    font-size: 5em;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n/* Carousel Widget */\n\n.basic-widget .grid-carousel .title .title-text {\n    margin: auto;\n}\n\n.basic-widget .grid-carousel .widget-content {\n    max-height: calc(100% - 100px);\n}\n\n.basic-widget .grid-carousel .title {\n    width: 98%;\n    height: 25px;\n    font-size: 1.25em;\n    text-align: center;\n    padding: 0 2% 0 2%;\n    align-items: center;\n    display: flex;\n}\n\n.carousel-button {\n    position: absolute;\n    top: 0;\n    font-size: 30px;\n    cursor: pointer;\n    color: #E8E8E8;\n    width: 40px;\n    height: 100%;\n    border: none;\n    background: none;\n    z-index: 10000;\n}\n\n.carousel-container {\n    width: 100%;\n    height: 100%;\n    margin: auto;\n    overflow: hidden;\n    position: relative;\n}\n\n.carousel-item {\n    width: 100%;\n    min-width: 100%;\n    height: calc(100% - 50px);\n    box-sizing: border-box;\n}\n\n.carousel-item .content div {\n    min-width: 50%;\n    box-sizing: border-box;\n}\n\n.carousel-item .sub-title {\n    font-size: 1.25em;\n    margin: 10px;\n}\n\n.carousel-item .widget-content .chart {\n    width: 100%;\n}\n\n\n.carousel-wrapper {\n    display: flex;\n    transition: transform 0.5s ease-in-out;\n    height: 100%;\n}\n\n.carousel-wrapper.basic-widget {\n    display: flex;\n    transition: transform 0.5s ease-in-out;\n    height: 100%;\n    font-size: 10px;\n    line-height: 14px;\n    vertical-align: left;\n    border: none;\n    margin: 0;\n    box-shadow: none;\n}\n\n.grid-carousel {\n    min-width: 100%;\n    max-width: 100%;\n    width: 100%;\n    font-size: 10px;\n    line-height: 14px;\n    vertical-align: middle;\n    border: none;\n    margin: 0;\n    box-shadow: none;\n}\n\n.next {\n    right: 0px;\n    transition: border-left 1s, color 1s, background-color 0.5s;\n}\n\n.next:hover {\n    border-left: 1px solid #DDDDDD;\n    color: #333333;\n    background-color: white;\n}\n\n.prev {\n    left: 0px;\n    transition: border-right 1s, color 1s, background-color 0.5s;\n}\n\n.prev:hover {\n    border-right: 1px solid #DDDDDD;\n    color: #333333;\n    background-color: white;\n}\n\n/* Totalizers */\n\n.percentage-wrapper {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n.totalizer-progress-bar {\n    flex: 1;\n    height: 10px;\n    background-color: #D7DEDF;\n    border-radius: 5px;\n    overflow: hidden;\n}\n\n.totalizer-progress-fill {\n    height: 100%;\n    border-radius: 5px;\n    background-color: #224C4F;\n}\n\n.progress-info {\n    display: flex;\n    flex-direction: column;\n    margin-left: 10px;\n}\n\n.text-wrapper {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n}\n\n#total-displayers {\n    display: flex;\n    flex-flow: row wrap;\n    margin: 1% 0 -1% 1%;\n}\n\n.total-displayer {\n    border-radius: 3px;\n    padding: 1vw 1vw;\n    width: 15.66%;\n    margin-bottom: 1%;\n    margin-right: 1%;\n}\n\n.total-displayer-header {\n    display: flex;\n    text-align: left;\n    justify-content: space-between;\n    height: 50px;\n    margin-bottom: -15px;\n}\n\n.total-displayer-icon {\n    display: flex;\n    flex: 0 0 auto;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    height: 3vw;\n    width: 3vw;\n    min-width: 50px;\n    min-height: 50px;\n    border-radius: 50%;\n    margin-right: 10px;\n}\n\n.total-displayer-icon svg {\n    width: 50%;\n    height: auto;\n}\n\n.total-displayer-main-wrapper {\n    margin-top: 15px;\n    text-align: right;\n}\n\n.total-displayer-small-icon svg {\n    height: 1.25em;\n    padding-top: 5px;\n}\n\n.total-displayer-title {\n    max-width: 95%;\n}\n\n.total-displayer-title p {\n    font-size: 0.7vw;\n    margin-bottom: 0px;\n    overflow: hidden;\n    max-width: 100%;\n    text-overflow: ellipsis;\n}\n\n.total-displayer-title .title-text {\n    font-size: 1.25em;\n}\n\n.total-displayer-title .title-text {\n    font-size: 1.25em;\n}\n\n.total-value {\n    font-size: 1.3vw;\n    font-weight: 500;\n}\n\n.total-subtitle {\n    font-size: 0.65vw;\n    margin-top: -5px;\n}\n\n/* Widget Table */\n\n.basic-widget.table-widget .widget-table-displayer {\n    position: relative;\n    padding: 15px;\n    border-radius: 4px;\n    height: 100%;\n}\n\n.no-data {\n    text-align: center;\n    color: #777777;\n}\n\n.table-main {\n    font-size: 1.25em;\n    margin: 0;\n    font-weight: 500;\n    margin-bottom: 5px;\n    color: #224C4F;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.table-sub {\n    font-size: 1em;\n    margin: 0;\n    color: #8BC53F;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.widget-table {\n    max-height: 332px;\n    display: flex;\n    flex-direction: column;\n    min-width: 100%;\n    max-width: 100%;\n    justify-content: space-between;\n    overflow-x: hidden;\n}\n\n.widget-table-cell {\n    white-space: nowrap;\n    padding: 8px;\n    margin: auto;\n    margin-right: 5px;\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.widget-table-icon {\n    display: flex;\n    flex: 0 0 auto;\n    justify-content: center;\n    align-items: center;\n    min-width: 36px;\n    min-height: 36px;\n    max-width: 55px;\n    max-height: 55px;\n    height: 2.5vw;\n    width: 2.5vw;\n    border-radius: 50%;\n    margin-right: 0px;\n}\n\n.widget-table-icon svg {\n    width: 45%;\n    height: auto;\n}\n\n.widget-table-row {\n    min-height: 60px;\n    display: flex;\n    flex-direction: row;\n}\n\n@media (max-width: 600px) {\n    .total-displayer-icon {\n        min-width: 150px;\n        min-height: 150px;\n    }\n}\n\n@media (max-width: 900px) {\n    .grid-half {\n        min-width: 99%;\n        max-width: 99%;\n        width: 99%;\n    }\n\n    .total-displayer {\n        min-width: 32.33%;\n        max-width: 32.33%;\n        width: 32.33%;\n    }\n\n    .total-displayer-icon {\n        min-width: 75px;\n        min-height: 75px;\n    }\n}\n","table.dataTable td.col50, table.dataTable th.col50 {\n    width: 50%;\n}\n\ntable.dataTable td.col25, table.dataTable th.col25 {\n    width: 25%;\n}\n\n.dataTables_toolbar {\n    cursor: default;\n    line-height: 16px;\n    margin-bottom: 10px;\n    height: 32px;\n}\n\n.dataTables_toolbar * {\n    box-sizing: border-box;\n}\n\n.dataTables_toolbar .svg_icon {\n    cursor: pointer;\n    padding: 8px;\n    background-color: #8BC53F;\n    border-radius: 4px;\n}\n\n.dataTables_toolbar .svg_icon {\n    width: 32px;\n    height: 32px;\n}\n\n.dataTables_toolbar .svg_icon svg {\n    width: 16px;\n    height: 16px;\n}\n\n.dataTables_toolbar .svg_icon svg path {\n    fill: white;\n}\n\nul.highcharts-menu li.highcharts-menu-item {\n    float: none;\n}\n\nul.highcharts-menu hr {\n    margin: 2px 0;\n}\n\ninput#select_all_checkbox {\n    margin-bottom: 2px;\n}\n\ndiv.accordion-body-fix {\n    background: white;\n    padding-bottom: 25px;\n}\n","#sites-map {\n    height: 100%;\n    position: absolute;\n    overflow: hidden;\n    width: 100%;\n}\n\n#sites-map #map-placeholder {\n    height: 100%;\n}\n\n#sites-map #map-search {\n    left: 10px;\n    position: absolute;\n    right: 10px;\n    top: 10px;\n}\n\n#sites-map #map-search input[type=search] {\n    border: none;\n    border-bottom: 1px solid #EEEEEE;\n    box-sizing: border-box;\n    height: 40px;\n    padding: 5px 15px;\n    width: 100%;\n}\n\n#sites-map #map-search .sites-table {\n    margin-right: 0;\n    padding-top: 5px;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n#sites-map #map-search input[type=search]:focus {\n    outline: 0;\n}\n\n#sites-map .search-box {\n    box-shadow: 0 2px 6px rgba(0, 0, 0, .3);\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n}\n\n.search-box .icon-searching {\n    color: #888888;\n    display: none;\n    font-size: 20px;\n    line-height: 40px;\n    position: absolute;\n    right: 10px;\n    top: 0;\n}\n\n.search-box .search-summary {\n    color: #888888;\n    font-size: 11px;\n    line-height: 40px;\n    position: absolute;\n    right: 10px;\n    top: 0;\n}\n\n#sites-map #map-search input[type=search]:focus + .results {\n    display: block;\n}\n\n#sites-map .search-box:hover .results {\n    display: block;\n}\n\n#sites-map .result {\n    background: white;\n    border: none;\n    border-bottom: 1px solid #EEEEEE;\n    box-sizing: border-box;\n    cursor: pointer;\n    padding: 7px 15px;\n}\n\n#sites-map .results {\n    display: none;\n    max-height: 170px;\n    overflow: scroll;\n    width: 100%;\n}\n\n#sites-map .result:hover {\n    background-color: #EEEEEE;\n}\n\n#sites-map .result .site-name {\n    font-weight: bold;\n}\n\n#sites-map .result .site-address {\n    color: #888888;\n    font-size: 11px;\n}\n\n#sites-map .result .site-tags {\n    color: #666666;\n    font-size: 11px;\n}\n\n.site-info-window {\n    cursor: pointer;\n    max-width: 100%;\n    width: 480px;\n}\n\n.site-info-window .image {\n    max-width: 40%;\n    padding-right: 10px;\n}\n\n.site-info-window .image img {\n    max-width: 100%;\n}\n\n.site-info-window .content-container {\n    display: flex;\n    width: 100%;\n}\n\n.site-info-window .popup-content {\n    flex: 1;\n    max-width: 100%;\n    min-height: auto;\n    overflow-y: scroll;\n    padding-right: 10px;\n    position: relative;\n}\n\n.site-info-window .popup-content::-webkit-scrollbar {\n    -webkit-appearance: none;\n    width: 7px;\n}\n\n.site-info-window .popup-content::-webkit-scrollbar-thumb {\n    border-radius: 4px;\n    background-color: #8BC53F;\n    box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n}\n\n.site-info-window .popup-title {\n    font-weight: bold;\n    margin-bottom: 10px;\n    text-align: left;\n    width: 100%;\n}\n\n.site-info-window .popup-title .street {\n    color: gray;\n    font-size: 9px;\n    max-height: 12px;\n    font-weight: normal;\n}\n\n.site-info-window .popup-content .summary {\n    font-size: 11px;\n}\n\n.site-info-window .popup-content .summary .line {\n    border-bottom: 2px solid #EEEEEE;\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 4px;\n    padding-bottom: 4px;\n    width: auto;\n}\n\n.site-info-window .popup-content .summary .last-year {\n    margin-bottom: 15px;\n}\n\n.site-info-window .no-content {\n    color: #CCCCCC;\n    font-size: 18px;\n    margin: 50px 0;\n    text-align: center;\n}\n\ndiv.map-control-button {\n    background-color: white;\n    border-radius: 2px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, .3);\n    cursor: pointer;\n    margin-right: 10px;\n    font-size: 20px;\n    height: 40px;\n    padding: 8px;\n    width: 40px;\n    box-sizing: border-box;\n    text-align: -webkit-center;\n    vertical-align: middle;\n    color: #666666;\n    margin-top: 10px;\n}\n\ndiv.map-control-button:hover {\n    color: black;\n}\n\nimg.edit-panorama:hover {\n    cursor: pointer;\n    opacity: 0.75;\n}\n\n/* dashboard map */\n\n#dashboard-placeholder {\n    background-color: #EEEEEE;\n    border-radius: 2px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, .3);\n    height: inherit;\n    width: 100%;\n}\n","#notifications-container *, *:before, *:after {\n    box-sizing: border-box;\n}\n\n#notifications-container {\n    background: #EEEEEE;\n    bottom: 0;\n    font-size: 12px;\n    left: 0;\n    line-height: 150%;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n#notifications-container .truncate {\n    display: inline-block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    width: 100%;\n}\n\n#notifications-container .disclaimer {\n    margin: 0 auto 50px;\n    text-align: center;\n    width: 400px;\n}\n\n#notifications-container .btn {\n    border: none;\n    cursor: pointer;\n    display: block;\n    font-size: 16px;\n    outline: none;\n    padding: 15px;\n    transition: all .1s linear;\n}\n\n#notifications-container #sidebar {\n    background: #34393D;\n    bottom: 0;\n    left: 0;\n    position: absolute;\n    top: 0;\n    width: 250px;\n}\n\n#notifications-container #sidebar .sidebar-inboxes li {\n    margin-right: 0;\n    width: 100%;\n}\n\n#notifications-container #sidebar .sidebar-inboxes .item-count {\n    background: #34393D;\n    border-radius: 5px;\n    float: right;\n    padding: 2px 8px;\n    margin: -2px -8px;\n}\n\n#notifications-container #sidebar .sidebar-inboxes li a {\n    color: #FFFFFF;\n    cursor: pointer;\n    display: block;\n    padding: 15px 15px 15px 0;\n    text-decoration: none;\n    transition: background .1s linear;\n    width: 100%;\n}\n\n#notifications-container #sidebar .item-icon {\n    width: 40px;\n}\n\n#notifications-container #sidebar .sidebar-inboxes li a.active {\n    background: #404549;\n}\n\n#notifications-container #sidebar .sidebar-inboxes li a:hover {\n    background: #54595D;\n}\n\n#notifications-container #sidebar .sidebar-inboxes .fa {\n    margin-right: 10px;\n}\n\n#notifications-container #sidebar .btn.compose {\n    background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4gPHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJncmFkIiBncmFkaWVudFVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCIgeDE9IjEuMCIgeTE9IjEuMCIgeDI9IjAuMCIgeTI9IjAuMCI+PHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iIzAwOWZjNCIvPjxzdG9wIG9mZnNldD0iMTAwJSIgc3RvcC1jb2xvcj0iIzBjN2VhZCIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxyZWN0IHg9IjAiIHk9IjAiIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JhZCkiIC8+PC9zdmc+IA==');\n    background-image: -webkit-gradient(linear, 100% 100%, 0% 0%, color-stop(0%, #009FC4), color-stop(100%, #0C7EAD));\n    background-image: -moz-linear-gradient(bottom right, #009FC4, #0C7EAD);\n    background-image: -webkit-linear-gradient(bottom right, #009FC4, #0C7EAD);\n    background-image: linear-gradient(to top left, #009FC4, #0C7EAD);\n    background-size: 100%;\n    color: #FFFFFF;\n    padding: 30px 15px;\n    text-align: center;\n    text-decoration: none;\n    transition: all .1s linear;\n    width: 100%;\n}\n\n#notifications-container #sidebar .btn.compose:hover {\n    background-size: 150%;\n}\n\n#notifications-container #sidebar .btn.compose:hover .fa {\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n}\n\n#notifications-container #sidebar .btn.compose .fa {\n    margin-left: 10px;\n    transition: all .1s linear;\n}\n\n#notifications-container .notification-list {\n    background: #F5F5F5;\n    bottom: 0;\n    left: 0;\n    overflow-y: auto;\n    position: absolute;\n    top: 0;\n    width: 350px;\n}\n\n#notifications-container .notification-list.empty {\n    color: #AAAAAA;\n    padding-top: calc(50vh - 50px);\n    text-align: center;\n}\n\n#notifications-container .notification-list .notification-item {\n    background: #FFFFFF;\n    border-bottom: 1px solid #EEEEEE;\n    cursor: pointer;\n    padding: 10px 15px;\n    position: relative;\n}\n\n#notifications-container .notification-list .notification-item.selected {\n    color: #009FC4;\n}\n\n#notifications-container .notification-list .notification-item.deleted.selected {\n    color: #B94A48;\n}\n\n#notifications-container .notification-list .notification-item__subject {\n    margin-bottom: 8px;\n}\n\n#notifications-container .notification-list .notification-item__details {\n    font-size: 10px;\n    opacity: 0.9;\n}\n\n#notifications-container .notification-list .notification-item-dot {\n    height: 100%;\n    position: absolute;\n    right: 10px;\n    top: 10px;\n}\n\n#notifications-container .notification-list .notification-item-dot[data-status=\"unread\"]:before, .notification-item-dot[data-status=\"deleted\"]:before {\n    background: #009FC4;\n    border-radius: 50%;\n    content: '';\n    display: block;\n    height: 6px;\n    width: 6px;\n}\n\n#notifications-container .notification-list .notification-item-dot[data-status=\"deleted\"]:before {\n    background: #B94A48;\n}\n\n#notifications-container .notification-list .notification-item__time {\n    text-align: right;\n}\n\n#notifications-container .notification-list .notification-item:hover:not(.selected) {\n    background: #FAFAFA;\n}\n\n#notifications-container .notification-wrapper {\n    background: #F5F5F5;\n    border-left: 1px solid #DDDDDD;\n    bottom: 0;\n    left: 350px;\n    overflow: hidden;\n    position: absolute;\n    right: 0;\n    top: 0;\n}\n\n#notifications-container .notification-content {\n    max-width: 1024px;\n    width: 80%;\n    margin: 5% auto 0 auto;\n    background-color: white;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    box-sizing: border-box;\n    position: relative;\n}\n\n#notifications-container .notification-content.empty {\n    color: #AAAAAA;\n    padding-top: calc(50vh - 50px);\n    text-align: center;\n    box-shadow: none;\n}\n\n#notifications-container .notification-banner {\n    background-color: #8BC53F;\n    text-align: center;\n}\n\n#notifications-container .notification-banner img {\n    width: 50%;\n    padding: 5% 10%;\n    height: auto;\n}\n\n#notifications-container .notification-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 2% 2% 0px 2%;\n}\n\n#notifications-container .notification-title {\n    font-size: 18px;\n    color: #224C4F;\n    margin: 10px 0;\n}\n\n#notifications-container .notification-header .notification-delete-btn {\n    cursor: pointer;\n    color: #797979;\n    transition: color .1s linear;\n}\n\n#notifications-container .notification-header .notification-delete-btn:hover {\n    color: #CC3232;\n}\n\n#notifications-container .notification-area {\n    padding: 2%;\n    margin: 10px 0px 10px 0px;\n    font-size: 14px;\n    min-height: 200px;\n}\n\n#notifications-container .notification-date {\n    width: 96%;\n    margin: 0px 2%;\n    text-align: right;\n    color: #797979;\n    font-style: italic;\n    font-size: 10px;\n    border-bottom: 1px solid #EEEEEE;\n}\n\n#notifications-container .notification-footer {\n    border-top: 1px solid #EEEEEE;\n    width: 96%;\n    margin: 0px 2%;\n    text-align: center;\n    padding: 10px 0;\n}\n\n#notifications-container .notification-footer p {\n    margin: 0px;\n}\n","/* The switch - the box around the slider */\n.switch {\n    position: relative;\n    display: inline-block;\n    width: 60px;\n    height: 34px;\n}\n\n/* Hide default HTML checkbox */\n.switch input {\n    opacity: 0;\n    width: 0;\n    height: 0;\n}\n\n/* The slider */\n.slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #CCCCCC;\n    -webkit-transition: .4s;\n    transition: .4s;\n}\n\n.slider:before {\n    position: absolute;\n    content: \"\";\n    height: 26px;\n    width: 26px;\n    left: 4px;\n    bottom: 4px;\n    background-color: white;\n    -webkit-transition: .4s;\n    transition: .4s;\n}\n\ninput:checked + .slider {\n    background-color: #8BC53F;\n}\n\ninput:disabled + .slider {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\ninput:focus + .slider {\n    box-shadow: 0 0 1px #8BC53F;\n}\n\ninput:checked + .slider:before {\n    -webkit-transform: translateX(26px);\n    -ms-transform: translateX(26px);\n    transform: translateX(26px);\n    left: -5px;\n}\n\ninput:checked + .slider:after {\n    content: '';\n    color: white;\n    display: block;\n    position: absolute;\n    transform: translate(-50%, -50%);\n    top: 50%;\n    left: 33%;\n    font-size: 9px;\n    font-family: Verdana, sans-serif;\n}\n\n/* Rounded sliders */\n.slider.round {\n    width: 35px;\n    height: 16px;\n    border-radius: 34px;\n}\n\n.slider.round:before {\n    height: 9px;\n    width: 9px;\n    border-radius: 50%;\n\n}\n","@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n    :root {\n        --background: 0 0% 100%;\n        --backgroundGrey: 108 2% 95%;\n        --foreground: 222.2 47.4% 11.2%;\n\n        --muted: 210 40% 96.1%;\n        --muted-foreground: 215.4 16.3% 46.9%;\n\n        --popover: 0 0% 100%;\n        --popover-foreground: 222.2 47.4% 11.2%;\n\n        --border: 214.3 31.8% 91.4%;\n        --input: 214.3 31.8% 91.4%;\n\n        --card: 0 0% 100%;\n        --card-foreground: 222.2 47.4% 11.2%;\n\n        --primary: 139 197 63;\n        --primary-foreground: 210 40% 98%;\n\n        --secondary: 34 76 79;\n        --secondary-foreground: 210 40% 98%;\n\n        --accent: 108 2% 95%;\n        --accent-foreground: 222.2 47.4% 11.2%;\n\n        --destructive: 359.27 78.85 59.22;\n        --destructive-foreground: 0 0% 100%;\n\n        --info: 200.41 98.01 39.41;\n        --info-foreground: 200.95 90 27.45;\n\n        --ring: 215 20.2% 65.1%;\n\n        --radius: 0.5rem;\n\n        --grey: 0 0 47%;\n        --grey-light: 0 0 85%;\n        --grey-dark: 0 0 20%;\n        --grey-bg: 0 0 95%;\n    }\n\n    .dark {\n        --background: 224 71% 4%;\n        --foreground: 213 31% 91%;\n\n        --muted: 223 47% 11%;\n        --muted-foreground: 215.4 16.3% 56.9%;\n\n        --accent: 216 34% 17%;\n        --accent-foreground: 210 40% 98%;\n\n        --popover: 224 71% 4%;\n        --popover-foreground: 215 20.2% 65.1%;\n\n        --border: 216 34% 17%;\n        --input: 216 34% 17%;\n\n        --card: 224 71% 4%;\n        --card-foreground: 213 31% 91%;\n\n        --primary: 210 40% 98%;\n        --primary-foreground: 222.2 47.4% 1.2%;\n\n        --secondary: 222.2 47.4% 11.2%;\n        --secondary-foreground: 210 40% 98%;\n\n        --destructive: 0 63% 31%;\n        --destructive-foreground: 210 40% 98%;\n\n        --ring: 216 34% 17%;\n\n        --radius: 0.5rem;\n\n        --grey: 0 0 47%;\n        --grey-light: 0 0 85%;\n        --grey-dark: 0 0 20%;\n        --grey-bg: 0 0 95%;\n    }\n}\n\n@layer base {\n    * {\n        @apply tw-border-border;\n    }\n\n    body {\n        @apply tw-bg-background tw-text-foreground;\n    }\n\n    .tailwind-container {\n        h1 {\n            @apply tw-text-2xl tw-font-bold tw-mt-4 tw-mb-2;\n            /* 1.5rem */\n        }\n\n        h2 {\n            @apply tw-text-xl tw-font-bold tw-mt-3 tw-mb-2;\n            /* 1.25rem */\n        }\n\n        h3 {\n            @apply tw-text-lg tw-font-bold tw-mt-3 tw-mb-2;\n            /* 1.125rem */\n        }\n\n        h4 {\n            @apply tw-text-base tw-font-bold tw-mt-3 tw-mb-2;\n            /* 1rem */\n        }\n\n        h5 {\n            @apply tw-text-sm tw-font-bold tw-mt-2 tw-mb-1;\n            /* 0.875rem */\n        }\n\n        h6 {\n            @apply tw-text-xs tw-font-bold tw-mt-2 tw-mb-1;\n            /* 0.75rem */\n        }\n    }\n}\n\n@layer base {\n    .tw-clear-float-list li {\n      float: none !important;\n      display: list-item !important;\n    }\n}\n","@import 'bootstrap/bootstrap-responsive.min.css';\n@import 'bootstrap/bootstrap.min.css';\n@import 'bootstrap/navbar.css';\n@import 'bootstrap/tabs.css';\n@import 'jquery-ui/1.10.1-darkness.css';\n@import 'jquery-ui/time-picker-addon.css';\n@import 'vendor/datatables/jquery.dataTables_themeroller.css';\n@import 'vendor/datatables/TableTools.css';\n@import 'vendor/datatables/TableTools_JUI.css';\n@import 'integrations.css';\n@import 'benchmark.css';\n@import 'breadcrumb.css';\n@import 'cal-heatmap.css';\n@import 'cal-heatmap-wisemetering.css';\n@import 'colorbrewer.css';\n@import 'dashboard.css';\n@import 'details.css';\n@import 'dropdown.css';\n@import 'drop_zone.css';\n@import 'modal.css';\n@import 'organization.css';\n@import 'reviewed.css';\n@import 'ribbon.css';\n@import 'progressbar.css';\n@import 'schedules.css';\n@import 'tipper.css';\n@import 'ui_app.css';\n@import 'ui_card.css';\n@import 'ui_custom.css';\n@import 'ui_defaults.css';\n@import 'ui_crud.css';\n@import 'ui_mbx.css';\n@import 'ui_no_access.css';\n@import 'ui_sprite.css';\n@import 'ui_text.css';\n@import 'widget.css';\n@import 'overrides.css';\n@import 'map.css';\n@import 'notifications.css';\n@import 'switch-toggle.css';\n@import 'shadcn.css';\n\n.disable-pointer {\n    pointer-events: none;\n    opacity: 0.7;\n}\n\n:focus {\n    outline: none;\n}\n\na, a.link {\n    color: #8BC53F;\n}\n\na.link {\n    text-decoration: underline;\n}\n\na:hover, a.link:hover {\n    color: #688715;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
